import vi from "openseadragon";
var ds = Object.prototype.hasOwnProperty;
function nr(r, t) {
  var e, n;
  if (r === t)
    return !0;
  if (r && t && (e = r.constructor) === t.constructor) {
    if (e === Date)
      return r.getTime() === t.getTime();
    if (e === RegExp)
      return r.toString() === t.toString();
    if (e === Array) {
      if ((n = r.length) === t.length)
        for (; n-- && nr(r[n], t[n]); )
          ;
      return n === -1;
    }
    if (!e || typeof r == "object") {
      n = 0;
      for (e in r)
        if (ds.call(r, e) && ++n && !ds.call(t, e) || !(e in t) || !nr(r[e], t[e]))
          return !1;
      return Object.keys(t).length === n;
    }
  }
  return r !== r && t !== t;
}
function Kt() {
}
function nf(r, t) {
  for (const e in t)
    r[e] = t[e];
  return r;
}
function Eu(r) {
  return r();
}
function ps() {
  return /* @__PURE__ */ Object.create(null);
}
function ke(r) {
  r.forEach(Eu);
}
function Gt(r) {
  return typeof r == "function";
}
function te(r, t) {
  return r != r ? t == t : r !== t || r && typeof r == "object" || typeof r == "function";
}
function of(r) {
  return Object.keys(r).length === 0;
}
function af(r, ...t) {
  if (r == null)
    return Kt;
  const e = r.subscribe(...t);
  return e.unsubscribe ? () => e.unsubscribe() : e;
}
function wu(r, t, e) {
  r.$$.on_destroy.push(af(t, e));
}
function Su(r, t, e, n) {
  if (r) {
    const i = Au(r, t, e, n);
    return r[0](i);
  }
}
function Au(r, t, e, n) {
  return r[1] && n ? nf(e.ctx.slice(), r[1](n(t))) : e.ctx;
}
function Pu(r, t, e, n) {
  if (r[2] && n) {
    const i = r[2](n(e));
    if (t.dirty === void 0)
      return i;
    if (typeof i == "object") {
      const o = [], a = Math.max(t.dirty.length, i.length);
      for (let s = 0; s < a; s += 1)
        o[s] = t.dirty[s] | i[s];
      return o;
    }
    return t.dirty | i;
  }
  return t.dirty;
}
function Ou(r, t, e, n, i, o) {
  if (i) {
    const a = Au(t, e, n, o);
    r.p(a, i);
  }
}
function Ru(r) {
  if (r.ctx.length > 32) {
    const t = [], e = r.ctx.length / 32;
    for (let n = 0; n < e; n++)
      t[n] = -1;
    return t;
  }
  return -1;
}
const Iu = typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : global;
function ir(r, t) {
  r.appendChild(t);
}
function Z(r, t, e) {
  r.insertBefore(t, e || null);
}
function K(r) {
  r.parentNode && r.parentNode.removeChild(r);
}
function Ba(r, t) {
  for (let e = 0; e < r.length; e += 1)
    r[e] && r[e].d(t);
}
function ft(r) {
  return document.createElementNS("http://www.w3.org/2000/svg", r);
}
function Na(r) {
  return document.createTextNode(r);
}
function ae() {
  return Na(" ");
}
function He() {
  return Na("");
}
function Yt(r, t, e, n) {
  return r.addEventListener(t, e, n), () => r.removeEventListener(t, e, n);
}
function S(r, t, e) {
  e == null ? r.removeAttribute(t) : r.getAttribute(t) !== e && r.setAttribute(t, e);
}
function sf(r) {
  return Array.from(r.childNodes);
}
function hf(r, t) {
  t = "" + t, r.data !== t && (r.data = t);
}
function vs(r, t, e) {
  r.classList[e ? "add" : "remove"](t);
}
function uf(r, t, { bubbles: e = !1, cancelable: n = !1 } = {}) {
  const i = document.createEvent("CustomEvent");
  return i.initCustomEvent(r, e, n, t), i;
}
function _i(r, t) {
  return new r(t);
}
let cn;
function an(r) {
  cn = r;
}
function La() {
  if (!cn)
    throw new Error("Function called outside component initialization");
  return cn;
}
function Fi(r) {
  La().$$.on_mount.push(r);
}
function lf(r) {
  La().$$.on_destroy.push(r);
}
function Bi() {
  const r = La();
  return (t, e, { cancelable: n = !1 } = {}) => {
    const i = r.$$.callbacks[t];
    if (i) {
      const o = uf(t, e, { cancelable: n });
      return i.slice().forEach((a) => {
        a.call(r, o);
      }), !o.defaultPrevented;
    }
    return !0;
  };
}
function Mr(r, t) {
  const e = r.$$.callbacks[t.type];
  e && e.slice().forEach((n) => n.call(this, t));
}
const wr = [], dn = [];
let Dr = [];
const _s = [], ff = /* @__PURE__ */ Promise.resolve();
let Uo = !1;
function cf() {
  Uo || (Uo = !0, ff.then(Cu));
}
function Go(r) {
  Dr.push(r);
}
const Xi = /* @__PURE__ */ new Set();
let _r = 0;
function Cu() {
  if (_r !== 0)
    return;
  const r = cn;
  do {
    try {
      for (; _r < wr.length; ) {
        const t = wr[_r];
        _r++, an(t), df(t.$$);
      }
    } catch (t) {
      throw wr.length = 0, _r = 0, t;
    }
    for (an(null), wr.length = 0, _r = 0; dn.length; )
      dn.pop()();
    for (let t = 0; t < Dr.length; t += 1) {
      const e = Dr[t];
      Xi.has(e) || (Xi.add(e), e());
    }
    Dr.length = 0;
  } while (wr.length);
  for (; _s.length; )
    _s.pop()();
  Uo = !1, Xi.clear(), an(r);
}
function df(r) {
  if (r.fragment !== null) {
    r.update(), ke(r.before_update);
    const t = r.dirty;
    r.dirty = [-1], r.fragment && r.fragment.p(r.ctx, t), r.after_update.forEach(Go);
  }
}
function pf(r) {
  const t = [], e = [];
  Dr.forEach((n) => r.indexOf(n) === -1 ? t.push(n) : e.push(n)), e.forEach((n) => n()), Dr = t;
}
const li = /* @__PURE__ */ new Set();
let rr;
function Xe() {
  rr = {
    r: 0,
    c: [],
    p: rr
    // parent group
  };
}
function je() {
  rr.r || ke(rr.c), rr = rr.p;
}
function ct(r, t) {
  r && r.i && (li.delete(r), r.i(t));
}
function bt(r, t, e, n) {
  if (r && r.o) {
    if (li.has(r))
      return;
    li.add(r), rr.c.push(() => {
      li.delete(r), n && (e && r.d(1), n());
    }), r.o(t);
  } else
    n && n();
}
function ee(r) {
  r && r.c();
}
function Zt(r, t, e, n) {
  const { fragment: i, after_update: o } = r.$$;
  i && i.m(t, e), n || Go(() => {
    const a = r.$$.on_mount.map(Eu).filter(Gt);
    r.$$.on_destroy ? r.$$.on_destroy.push(...a) : ke(a), r.$$.on_mount = [];
  }), o.forEach(Go);
}
function Jt(r, t) {
  const e = r.$$;
  e.fragment !== null && (pf(e.after_update), ke(e.on_destroy), e.fragment && e.fragment.d(t), e.on_destroy = e.fragment = null, e.ctx = []);
}
function vf(r, t) {
  r.$$.dirty[0] === -1 && (wr.push(r), cf(), r.$$.dirty.fill(0)), r.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function re(r, t, e, n, i, o, a, s = [-1]) {
  const h = cn;
  an(r);
  const u = r.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: o,
    update: Kt,
    not_equal: i,
    bound: ps(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(t.context || (h ? h.$$.context : [])),
    // everything else
    callbacks: ps(),
    dirty: s,
    skip_bound: !1,
    root: t.target || h.$$.root
  };
  a && a(u.root);
  let l = !1;
  if (u.ctx = e ? e(r, t.props || {}, (f, c, ...d) => {
    const p = d.length ? d[0] : c;
    return u.ctx && i(u.ctx[f], u.ctx[f] = p) && (!u.skip_bound && u.bound[f] && u.bound[f](p), l && vf(r, f)), c;
  }) : [], u.update(), l = !0, ke(u.before_update), u.fragment = n ? n(u.ctx) : !1, t.target) {
    if (t.hydrate) {
      const f = sf(t.target);
      u.fragment && u.fragment.l(f), f.forEach(K);
    } else
      u.fragment && u.fragment.c();
    t.intro && ct(r.$$.fragment), Zt(r, t.target, t.anchor, t.customElement), Cu();
  }
  an(h);
}
class ne {
  $destroy() {
    Jt(this, 1), this.$destroy = Kt;
  }
  $on(t, e) {
    if (!Gt(e))
      return Kt;
    const n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
    return n.push(e), () => {
      const i = n.indexOf(e);
      i !== -1 && n.splice(i, 1);
    };
  }
  $set(t) {
    this.$$set && !of(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
  }
}
const mr = [];
function Ua(r, t = Kt) {
  let e;
  const n = /* @__PURE__ */ new Set();
  function i(s) {
    if (te(r, s) && (r = s, e)) {
      const h = !mr.length;
      for (const u of n)
        u[1](), mr.push(u, r);
      if (h) {
        for (let u = 0; u < mr.length; u += 2)
          mr[u][0](mr[u + 1]);
        mr.length = 0;
      }
    }
  }
  function o(s) {
    i(s(r));
  }
  function a(s, h = Kt) {
    const u = [s, h];
    return n.add(u), n.size === 1 && (e = t(i) || Kt), s(r), () => {
      n.delete(u), n.size === 0 && e && (e(), e = null);
    };
  }
  return { set: i, update: o, subscribe: a };
}
const _f = (r) => {
  const { subscribe: t, set: e } = Ua(null);
  let n = null;
  return t((i) => n = i), r.observe(({ changes: i }) => {
    if (n) {
      i.deleted.some((s) => s.id === n) && e(null);
      const a = i.updated.find(({ oldValue: s }) => s.id === n);
      a && e(a.newValue.id);
    }
  }), {
    get current() {
      return n;
    },
    subscribe: t,
    set: e
  };
};
var Ga = /* @__PURE__ */ ((r) => (r.EDIT = "EDIT", r.HIGHLIGHT = "HIGHLIGHT", r.NONE = "NONE", r))(Ga || {});
const ji = { selected: [] }, mf = (r, t = "EDIT") => {
  const { subscribe: e, set: n } = Ua(ji);
  let i = ji;
  e((f) => i = f);
  const o = () => n(ji), a = () => {
    var f;
    return ((f = i.selected) == null ? void 0 : f.length) === 0;
  }, s = (f) => {
    if (i.selected.length === 0)
      return !1;
    const c = typeof f == "string" ? f : f.id;
    return i.selected.some((d) => d.id === c);
  }, h = (f, c) => {
    const d = r.getAnnotation(f);
    if (d) {
      const p = yf(d, t);
      n(p === "EDIT" ? { selected: [{ id: f, editable: !0 }], pointerEvent: c } : p === "HIGHLIGHT" ? { selected: [{ id: f }], pointerEvent: c } : { selected: [], pointerEvent: c });
    } else
      console.warn("Invalid selection: " + f);
  }, u = (f, c = !0) => {
    const d = Array.isArray(f) ? f : [f], p = d.map((v) => r.getAnnotation(v)).filter((v) => v);
    n({ selected: p.map(({ id: v }) => ({ id: v, editable: c })) }), p.length !== d.length && console.warn("Invalid selection", f);
  }, l = (f) => {
    if (i.selected.length === 0)
      return !1;
    const { selected: c } = i;
    c.filter(({ id: p }) => f.includes(p)).length > 0 && n({ selected: c.filter(({ id: p }) => !f.includes(p)) });
  };
  return r.observe(({ changes: f }) => l(f.deleted.map((c) => c.id))), {
    clear: o,
    clickSelect: h,
    get selected() {
      return i ? [...i.selected] : null;
    },
    get pointerEvent() {
      return i ? i.pointerEvent : null;
    },
    isEmpty: a,
    isSelected: s,
    setSelected: u,
    subscribe: e
  };
}, yf = (r, t) => typeof t == "function" ? t(r) || "EDIT" : t || "EDIT";
let Mn;
const gf = new Uint8Array(16);
function bf() {
  if (!Mn && (Mn = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Mn))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Mn(gf);
}
const Lt = [];
for (let r = 0; r < 256; ++r)
  Lt.push((r + 256).toString(16).slice(1));
function xf(r, t = 0) {
  return Lt[r[t + 0]] + Lt[r[t + 1]] + Lt[r[t + 2]] + Lt[r[t + 3]] + "-" + Lt[r[t + 4]] + Lt[r[t + 5]] + "-" + Lt[r[t + 6]] + Lt[r[t + 7]] + "-" + Lt[r[t + 8]] + Lt[r[t + 9]] + "-" + Lt[r[t + 10]] + Lt[r[t + 11]] + Lt[r[t + 12]] + Lt[r[t + 13]] + Lt[r[t + 14]] + Lt[r[t + 15]];
}
const Tf = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ms = {
  randomUUID: Tf
};
function Mu(r, t, e) {
  if (ms.randomUUID && !t && !r)
    return ms.randomUUID();
  r = r || {};
  const n = r.random || (r.rng || bf)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, t) {
    e = e || 0;
    for (let i = 0; i < 16; ++i)
      t[e + i] = n[i];
    return t;
  }
  return xf(n);
}
const Ef = (r, t, e, n) => ({
  id: Mu(),
  annotation: r.id,
  created: e || /* @__PURE__ */ new Date(),
  creator: n,
  ...t
}), wf = (r, t) => {
  const e = new Set(r.bodies.map((n) => n.id));
  return t.bodies.filter((n) => !e.has(n.id));
}, Sf = (r, t) => {
  const e = new Set(t.bodies.map((n) => n.id));
  return r.bodies.filter((n) => !e.has(n.id));
}, Af = (r, t) => t.bodies.map((e) => {
  const n = r.bodies.find((i) => i.id === e.id);
  return { newBody: e, oldBody: n && !nr(n, e) ? n : void 0 };
}).filter(({ oldBody: e }) => e), Pf = (r, t) => !nr(r.target, t.target), Of = (r, t) => ({
  oldValue: r,
  newValue: t,
  bodiesCreated: wf(r, t),
  bodiesDeleted: Sf(r, t),
  bodiesUpdated: Af(r, t),
  targetUpdated: Pf(r, t) ? { oldTarget: r.target, newTarget: t.target } : void 0
});
var Ct = /* @__PURE__ */ ((r) => (r.LOCAL = "LOCAL", r.REMOTE = "REMOTE", r))(Ct || {});
const Rf = (r, t) => {
  var o, a;
  const { changes: e, origin: n } = t;
  if (!(!r.options.origin || r.options.origin === n))
    return !1;
  if (r.options.ignore) {
    const { ignore: s } = r.options, h = (l) => (l == null ? void 0 : l.length) > 0;
    if (!(h(e.created) || h(e.deleted))) {
      const l = (o = e.updated) == null ? void 0 : o.some((c) => h(c.bodiesCreated) || h(c.bodiesDeleted) || h(c.bodiesUpdated)), f = (a = e.updated) == null ? void 0 : a.some((c) => c.targetUpdated);
      if (s === "BODY_ONLY" && l && !f || s === "TARGET_ONLY" && f && !l)
        return !1;
    }
  }
  if (r.options.annotations) {
    const s = /* @__PURE__ */ new Set([
      ...e.created.map((u) => u.id),
      ...e.deleted.map((u) => u.id),
      ...e.updated.map(({ oldValue: u }) => u.id)
    ]);
    return !!(Array.isArray(r.options.annotations) ? r.options.annotations : [r.options.annotations]).find((u) => s.has(u));
  } else
    return !0;
}, If = (r) => r.id !== void 0, Cf = () => {
  const r = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), e = [], n = (b, w = {}) => e.push({ onChange: b, options: w }), i = (b) => {
    const w = e.findIndex((A) => A.onChange == b);
    w > -1 && e.splice(w, 1);
  }, o = (b, w) => {
    const A = {
      origin: b,
      changes: {
        created: w.created || [],
        updated: w.updated || [],
        deleted: w.deleted || []
      },
      state: [...r.values()]
    };
    e.forEach((R) => {
      Rf(R, A) && R.onChange(A);
    });
  }, a = (b, w = Ct.LOCAL) => {
    if (r.get(b.id))
      throw Error(`Cannot add annotation ${b.id} - exists already`);
    r.set(b.id, b), b.bodies.forEach((R) => t.set(R.id, b.id)), o(w, { created: [b] });
  }, s = (b, w = Ct.LOCAL, A = Ct.LOCAL) => {
    const R = If(w) ? A : w, C = typeof b == "string" ? w : b, M = typeof b == "string" ? b : b.id, H = r.get(M);
    if (H) {
      const U = Of(H, C);
      M === C.id ? r.set(M, C) : (r.delete(M), r.set(C.id, C)), H.bodies.forEach((B) => t.delete(B.id)), C.bodies.forEach((B) => t.set(B.id, C.id)), o(R, { updated: [U] });
    } else
      throw Error(`Cannot update annotation ${M} - does not exist`);
  }, h = (b, w = Ct.LOCAL) => {
    const A = r.get(b.annotation);
    if (A) {
      const R = {
        ...A,
        bodies: [...A.bodies, b]
      };
      r.set(A.id, R), t.set(b.id, R.id), o(w, { updated: [{
        oldValue: A,
        newValue: R,
        bodiesCreated: [b]
      }] });
    } else
      console.warn(`Attempt to add body to missing annotation: ${b.annotation}`);
  }, u = () => [...r.values()], l = (b = Ct.LOCAL) => {
    const w = [...r.values()];
    r.clear(), t.clear(), o(b, { deleted: w });
  }, f = (b, w = !0, A = Ct.LOCAL) => {
    if (w) {
      const R = [...r.values()];
      r.clear(), t.clear(), b.forEach((C) => {
        r.set(C.id, C), C.bodies.forEach((M) => t.set(M.id, C.id));
      }), o(A, { created: b, deleted: R });
    } else {
      const R = b.reduce((C, M) => {
        const H = r.get(M.id);
        return H ? [...C, H] : C;
      }, []);
      if (R.length > 0)
        throw Error(`Bulk insert would overwrite the following annotations: ${R.map((C) => C.id).join(", ")}`);
      b.forEach((C) => {
        r.set(C.id, C), C.bodies.forEach((M) => t.set(M.id, C.id));
      }), o(A, { created: b });
    }
  }, c = (b) => {
    const w = typeof b == "string" ? b : b.id, A = r.get(w);
    if (A)
      return r.delete(w), A.bodies.forEach((R) => t.delete(R.id)), A;
    console.warn(`Attempt to delete missing annotation: ${w}`);
  }, d = (b, w = Ct.LOCAL) => {
    const A = c(b);
    A && o(w, { deleted: [A] });
  }, p = (b, w = Ct.LOCAL) => {
    const A = b.reduce((R, C) => {
      const M = c(C);
      return M ? [...R, M] : R;
    }, []);
    A.length > 0 && o(w, { deleted: A });
  }, v = (b, w = Ct.LOCAL) => {
    const A = r.get(b.annotation);
    if (A) {
      const R = A.bodies.find((C) => C.id === b.id);
      if (R) {
        t.delete(R.id);
        const C = {
          ...A,
          bodies: A.bodies.filter((H) => H.id !== b.id)
        };
        r.set(A.id, C), o(w, { updated: [{
          oldValue: A,
          newValue: C,
          bodiesDeleted: [R]
        }] });
      } else
        console.warn(`Attempt to delete missing body ${b.id} from annotation ${b.annotation}`);
    } else
      console.warn(`Attempt to delete body from missing annotation ${b.annotation}`);
  }, _ = (b) => {
    const w = r.get(b);
    return w ? { ...w } : void 0;
  }, m = (b) => {
    const w = t.get(b);
    if (w) {
      const R = _(w).bodies.find((C) => C.id === b);
      if (R)
        return R;
      console.error(`Store integrity error: body ${b} in index, but not in annotation`);
    } else
      console.warn(`Attempt to retrieve missing body: ${b}`);
  }, y = (b, w) => {
    if (b.annotation !== w.annotation)
      throw "Annotation integrity violation: annotation ID must be the same when updating bodies";
    const A = r.get(b.annotation);
    if (A) {
      const R = A.bodies.find((M) => M.id === b.id), C = {
        ...A,
        bodies: A.bodies.map((M) => M.id === R.id ? w : M)
      };
      return r.set(A.id, C), R.id !== w.id && (t.delete(R.id), t.set(w.id, C.id)), {
        oldValue: A,
        newValue: C,
        bodiesUpdated: [{ oldBody: R, newBody: w }]
      };
    } else
      console.warn(`Attempt to add body to missing annotation ${b.annotation}`);
  }, g = (b, w, A = Ct.LOCAL) => {
    const R = y(b, w);
    o(A, { updated: [R] });
  }, x = (b, w = Ct.LOCAL) => {
    const A = b.map((R) => y({ id: R.id, annotation: R.annotation }, R));
    o(w, { updated: A });
  }, T = (b) => {
    const w = r.get(b.annotation);
    if (w) {
      const A = {
        ...w,
        target: {
          ...w.target,
          ...b
        }
      };
      return r.set(w.id, A), {
        oldValue: w,
        newValue: A,
        targetUpdated: {
          oldTarget: w.target,
          newTarget: b
        }
      };
    } else
      console.warn(`Attempt to update target on missing annotation: ${b.annotation}`);
  };
  return {
    addAnnotation: a,
    addBody: h,
    all: u,
    bulkAddAnnotation: f,
    bulkDeleteAnnotation: p,
    bulkUpdateBodies: x,
    bulkUpdateTargets: (b, w = Ct.LOCAL) => {
      const A = b.map(T).filter((R) => R);
      A.length > 0 && o(w, { updated: A });
    },
    clear: l,
    deleteAnnotation: d,
    deleteBody: v,
    getAnnotation: _,
    getBody: m,
    observe: n,
    unobserve: i,
    updateAnnotation: s,
    updateBody: g,
    updateTarget: (b, w = Ct.LOCAL) => {
      const A = T(b);
      A && o(w, { updated: [A] });
    }
  };
}, Mf = () => {
  const { subscribe: r, set: t } = Ua([]);
  return {
    subscribe: r,
    set: t
  };
}, Df = (r, t, e, n, i, o) => {
  const a = /* @__PURE__ */ new Map();
  let s = [], h, u;
  const l = (p, v) => {
    a.has(p) ? a.get(p).push(v) : a.set(p, [v]);
  }, f = (p, v) => {
    const _ = a.get(p);
    _ && _.indexOf(v) > 0 && _.splice(_.indexOf(v), 1);
  }, c = (p, v, _) => {
    a.has(p) && setTimeout(() => {
      a.get(p).forEach((m) => {
        if (i) {
          const y = Array.isArray(v) ? v.map((x) => i.serialize(x)) : i.serialize(v), g = _ ? _ instanceof PointerEvent ? _ : i.serialize(_) : void 0;
          m(y, g);
        } else
          m(v, _);
      });
    }, 1);
  }, d = () => {
    const { selected: p } = t, v = p.map(({ id: _ }) => r.getAnnotation(_));
    v.forEach((_) => {
      const m = s.find((y) => y.id === _.id);
      (!m || !nr(m, _)) && c("updateAnnotation", _, m);
    }), s = s.map((_) => {
      const m = v.find(({ id: y }) => y === _.id);
      return m || _;
    });
  };
  return t.subscribe(({ selected: p }) => {
    if (!(s.length === 0 && p.length === 0)) {
      if (s.length === 0 && p.length > 0)
        s = p.map(({ id: v }) => r.getAnnotation(v));
      else if (s.length > 0 && p.length === 0)
        s.forEach((v) => {
          const _ = r.getAnnotation(v.id);
          _ && !nr(_, v) && c("updateAnnotation", _, v);
        }), s = [];
      else {
        const v = new Set(s.map((y) => y.id)), _ = new Set(p.map(({ id: y }) => y));
        s.filter((y) => !_.has(y.id)).forEach((y) => {
          const g = r.getAnnotation(y.id);
          g && !nr(g, y) && c("updateAnnotation", g, y);
        }), s = [
          // Remove annotations that were deselected
          ...s.filter((y) => _.has(y.id)),
          // Add editable annotations that were selected
          ...p.filter(({ id: y }) => !v.has(y)).map(({ id: y }) => r.getAnnotation(y))
        ];
      }
      c("selectionChanged", s);
    }
  }), e.subscribe((p) => {
    !h && p ? c("mouseEnterAnnotation", r.getAnnotation(p)) : h && !p ? c("mouseLeaveAnnotation", r.getAnnotation(h)) : h && p && (c("mouseLeaveAnnotation", r.getAnnotation(h)), c("mouseEnterAnnotation", r.getAnnotation(p))), h = p;
  }), n == null || n.subscribe((p) => c("viewportIntersect", p.map(r.getAnnotation))), r.observe((p) => {
    o && (u && clearTimeout(u), u = setTimeout(d, 1e3));
    const { created: v, deleted: _ } = p.changes;
    v.forEach((y) => c("createAnnotation", y)), _.forEach((y) => c("deleteAnnotation", y)), p.changes.updated.filter((y) => [
      ...y.bodiesCreated || [],
      ...y.bodiesDeleted || [],
      ...y.bodiesUpdated || []
    ].length > 0).forEach(({ oldValue: y, newValue: g }) => {
      const x = s.find((T) => T.id === y.id) || y;
      s = s.map((T) => T.id === y.id ? g : T), c("updateAnnotation", g, x);
    });
  }, { origin: Ct.LOCAL }), r.observe((p) => {
    if (s) {
      const v = new Set(s.map((m) => m.id)), _ = p.changes.updated.filter(({ newValue: m }) => v.has(m.id)).map(({ newValue: m }) => m);
      _.length > 0 && (s = s.map((m) => {
        const y = _.find((g) => g.id === m.id);
        return y || m;
      }));
    }
  }, { origin: Ct.REMOTE }), { on: l, off: f, emit: c };
}, Ff = (r) => (t) => t.reduce((e, n) => {
  const { parsed: i, error: o } = r.parse(n);
  return o ? {
    parsed: e.parsed,
    failed: [...e.failed, n]
  } : {
    parsed: [...e.parsed, i],
    failed: e.failed
  };
}, { parsed: [], failed: [] }), Bf = (r, t) => {
  const e = (l) => {
    if (t) {
      const { parsed: f, error: c } = t.parse(l);
      f ? r.addAnnotation(f, Ct.REMOTE) : console.error(c);
    } else
      r.addAnnotation(l, Ct.REMOTE);
  }, n = () => r.clear(), i = (l) => {
    const f = r.getAnnotation(l);
    return t && f ? t.serialize(f) : f;
  }, o = () => t ? r.all().map(t.serialize) : r.all(), a = (l) => fetch(l).then((f) => f.json()).then((f) => (h(f), f)), s = (l) => {
    if (typeof l == "string") {
      const f = r.getAnnotation(l);
      return r.deleteAnnotation(l), t ? t.serialize(f) : f;
    } else {
      const f = t ? t.parse(l).parsed : l;
      return r.deleteAnnotation(f), l;
    }
  }, h = (l) => {
    if (t) {
      const { parsed: f, failed: c } = Ff(t)(l);
      c.length > 0 && console.warn(`Discarded ${c.length} invalid annotations`, c), r.bulkAddAnnotation(f, !0, Ct.REMOTE);
    } else
      r.bulkAddAnnotation(l, !0, Ct.REMOTE);
  };
  return {
    addAnnotation: e,
    clearAnnotations: n,
    getAnnotationById: i,
    getAnnotations: o,
    loadAnnotations: a,
    removeAnnotation: s,
    setAnnotations: h,
    updateAnnotation: (l) => {
      if (t) {
        const f = t.parse(l).parsed, c = t.serialize(r.getAnnotation(f.id));
        return r.updateAnnotation(f), c;
      } else {
        const f = r.getAnnotation(l.id);
        return r.updateAnnotation(l), f;
      }
    }
  };
};
let Nf = (r) => crypto.getRandomValues(new Uint8Array(r)), Lf = (r, t, e) => {
  let n = (2 << Math.log(r.length - 1) / Math.LN2) - 1, i = -~(1.6 * n * t / r.length);
  return (o = t) => {
    let a = "";
    for (; ; ) {
      let s = e(i), h = i;
      for (; h--; )
        if (a += r[s[h] & n] || "", a.length === o)
          return a;
    }
  };
}, Uf = (r, t = 21) => Lf(r, t, Nf), Gf = (r = 21) => crypto.getRandomValues(new Uint8Array(r)).reduce((t, e) => (e &= 63, e < 36 ? t += e.toString(36) : e < 62 ? t += (e - 26).toString(36).toUpperCase() : e > 62 ? t += "-" : t += "_", t), "");
const kf = () => ({ isGuest: !0, id: Uf("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_", 20)() }), Hf = [
  "#ff7c00",
  // orange
  "#1ac938",
  // green
  "#e8000b",
  // red
  "#8b2be2",
  // purple
  "#9f4800",
  // brown
  "#f14cc1",
  // pink
  "#ffc400",
  // khaki
  "#00d7ff",
  // cyan
  "#023eff"
  // blue
], Xf = () => {
  const r = [...Hf];
  return { assignRandomColor: () => {
    const n = Math.floor(Math.random() * r.length), i = r[n];
    return r.splice(n, 1), i;
  }, releaseColor: (n) => r.push(n) };
};
Gf();
var $t = /* @__PURE__ */ ((r) => (r.ELLIPSE = "ELLIPSE", r.POLYGON = "POLYGON", r.RECTANGLE = "RECTANGLE", r))($t || {});
const ka = {}, Ha = (r, t) => ka[r] = t, ys = (r) => ka[r.type].area(r), jf = (r, t, e) => ka[r.type].intersects(r, t, e), ko = (r) => {
  let t = 1 / 0, e = 1 / 0, n = -1 / 0, i = -1 / 0;
  return r.forEach(([o, a]) => {
    t = Math.min(t, o), e = Math.min(e, a), n = Math.max(n, o), i = Math.max(i, a);
  }), { minX: t, minY: e, maxX: n, maxY: i };
}, Yf = {
  area: (r) => Math.PI * r.geometry.rx * r.geometry.ry,
  intersects: (r, t, e) => {
    const { cx: n, cy: i, rx: o, ry: a } = r.geometry, s = 0, h = Math.cos(s), u = Math.sin(s), l = t - n, f = e - i, c = h * l + u * f, d = u * l - h * f;
    return c * c / (o * o) + d * d / (a * a) <= 1;
  }
};
Ha($t.ELLIPSE, Yf);
const Vf = {
  area: (r) => {
    const { points: t } = r.geometry;
    let e = 0, n = t.length - 1;
    for (let i = 0; i < t.length; i++)
      e += (t[n][0] + t[i][0]) * (t[n][1] - t[i][1]), n = i;
    return Math.abs(0.5 * e);
  },
  intersects: (r, t, e) => {
    const { points: n } = r.geometry;
    let i = !1;
    for (let o = 0, a = n.length - 1; o < n.length; a = o++) {
      const s = n[o][0], h = n[o][1], u = n[a][0], l = n[a][1];
      h > e != l > e && t < (u - s) * (e - h) / (l - h) + s && (i = !i);
    }
    return i;
  }
};
Ha($t.POLYGON, Vf);
const zf = {
  area: (r) => r.geometry.w * r.geometry.h,
  intersects: (r, t, e) => t >= r.geometry.x && t <= r.geometry.x + r.geometry.w && e >= r.geometry.y && e <= r.geometry.y + r.geometry.h
};
Ha($t.RECTANGLE, zf);
function gs(r, t, e) {
  const n = r.slice();
  return n[11] = t[e], n[13] = e, n;
}
function bs(r) {
  let t, e, n, i, o;
  return {
    c() {
      t = ft("rect"), S(t, "class", "a9s-corner-handle"), S(t, "x", e = /*point*/
      r[11][0] - /*handleSize*/
      r[3] / 2), S(t, "y", n = /*point*/
      r[11][1] - /*handleSize*/
      r[3] / 2), S(
        t,
        "height",
        /*handleSize*/
        r[3]
      ), S(
        t,
        "width",
        /*handleSize*/
        r[3]
      );
    },
    m(a, s) {
      Z(a, t, s), i || (o = Yt(t, "pointerdown", function() {
        Gt(
          /*grab*/
          r[10](V(
            /*idx*/
            r[13]
          ))
        ) && r[10](V(
          /*idx*/
          r[13]
        )).apply(this, arguments);
      }), i = !0);
    },
    p(a, s) {
      r = a, s & /*geom, handleSize*/
      24 && e !== (e = /*point*/
      r[11][0] - /*handleSize*/
      r[3] / 2) && S(t, "x", e), s & /*geom, handleSize*/
      24 && n !== (n = /*point*/
      r[11][1] - /*handleSize*/
      r[3] / 2) && S(t, "y", n), s & /*handleSize*/
      8 && S(
        t,
        "height",
        /*handleSize*/
        r[3]
      ), s & /*handleSize*/
      8 && S(
        t,
        "width",
        /*handleSize*/
        r[3]
      );
    },
    d(a) {
      a && K(t), i = !1, o();
    }
  };
}
function Wf(r) {
  let t, e, n, i, o, a, s, h, u, l, f = (
    /*geom*/
    r[4].points
  ), c = [];
  for (let d = 0; d < f.length; d += 1)
    c[d] = bs(gs(r, f, d));
  return {
    c() {
      t = ft("polygon"), i = ae(), o = ft("polygon"), s = ae();
      for (let d = 0; d < c.length; d += 1)
        c[d].c();
      h = He(), S(t, "class", "a9s-outer"), S(t, "style", e = /*computedStyle*/
      r[1] ? "display:none;" : void 0), S(t, "points", n = /*geom*/
      r[4].points.map(xs).join(" ")), S(o, "class", "a9s-inner a9s-shape-handle"), S(
        o,
        "style",
        /*computedStyle*/
        r[1]
      ), S(o, "points", a = /*geom*/
      r[4].points.map(Ts).join(" "));
    },
    m(d, p) {
      Z(d, t, p), Z(d, i, p), Z(d, o, p), Z(d, s, p);
      for (let v = 0; v < c.length; v += 1)
        c[v] && c[v].m(d, p);
      Z(d, h, p), u || (l = [
        Yt(t, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.SHAPE)
          ) && r[10](V.SHAPE).apply(this, arguments);
        }),
        Yt(o, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.SHAPE)
          ) && r[10](V.SHAPE).apply(this, arguments);
        })
      ], u = !0);
    },
    p(d, p) {
      if (r = d, p & /*computedStyle*/
      2 && e !== (e = /*computedStyle*/
      r[1] ? "display:none;" : void 0) && S(t, "style", e), p & /*geom*/
      16 && n !== (n = /*geom*/
      r[4].points.map(xs).join(" ")) && S(t, "points", n), p & /*computedStyle*/
      2 && S(
        o,
        "style",
        /*computedStyle*/
        r[1]
      ), p & /*geom*/
      16 && a !== (a = /*geom*/
      r[4].points.map(Ts).join(" ")) && S(o, "points", a), p & /*geom, handleSize, grab, Handle*/
      1048) {
        f = /*geom*/
        r[4].points;
        let v;
        for (v = 0; v < f.length; v += 1) {
          const _ = gs(r, f, v);
          c[v] ? c[v].p(_, p) : (c[v] = bs(_), c[v].c(), c[v].m(h.parentNode, h));
        }
        for (; v < c.length; v += 1)
          c[v].d(1);
        c.length = f.length;
      }
    },
    d(d) {
      d && K(t), d && K(i), d && K(o), d && K(s), Ba(c, d), d && K(h), u = !1, ke(l);
    }
  };
}
function $f(r) {
  let t, e;
  return t = new Du({
    props: {
      shape: (
        /*shape*/
        r[0]
      ),
      transform: (
        /*transform*/
        r[2]
      ),
      editor: (
        /*editor*/
        r[5]
      ),
      $$slots: {
        default: [
          Wf,
          ({ grab: n }) => ({ 10: n }),
          ({ grab: n }) => n ? 1024 : 0
        ]
      },
      $$scope: { ctx: r }
    }
  }), t.$on(
    "change",
    /*change_handler*/
    r[7]
  ), t.$on(
    "grab",
    /*grab_handler*/
    r[8]
  ), t.$on(
    "release",
    /*release_handler*/
    r[9]
  ), {
    c() {
      ee(t.$$.fragment);
    },
    m(n, i) {
      Zt(t, n, i), e = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*shape*/
      1 && (o.shape = /*shape*/
      n[0]), i & /*transform*/
      4 && (o.transform = /*transform*/
      n[2]), i & /*$$scope, geom, handleSize, grab, computedStyle*/
      17434 && (o.$$scope = { dirty: i, ctx: n }), t.$set(o);
    },
    i(n) {
      e || (ct(t.$$.fragment, n), e = !0);
    },
    o(n) {
      bt(t.$$.fragment, n), e = !1;
    },
    d(n) {
      Jt(t, n);
    }
  };
}
const xs = (r) => r.join(","), Ts = (r) => r.join(",");
function qf(r, t, e) {
  let n, i, { shape: o } = t, { computedStyle: a = void 0 } = t, { transform: s } = t, { viewportScale: h = 1 } = t;
  const u = (d, p, v) => {
    let _;
    p === V.SHAPE ? _ = d.geometry.points.map(([y, g]) => [y + v[0], g + v[1]]) : _ = d.geometry.points.map(([y, g], x) => p === V(x) ? [y + v[0], g + v[1]] : [y, g]);
    const m = ko(_);
    return { ...d, geometry: { points: _, bounds: m } };
  };
  function l(d) {
    Mr.call(this, r, d);
  }
  function f(d) {
    Mr.call(this, r, d);
  }
  function c(d) {
    Mr.call(this, r, d);
  }
  return r.$$set = (d) => {
    "shape" in d && e(0, o = d.shape), "computedStyle" in d && e(1, a = d.computedStyle), "transform" in d && e(2, s = d.transform), "viewportScale" in d && e(6, h = d.viewportScale);
  }, r.$$.update = () => {
    r.$$.dirty & /*shape*/
    1 && e(4, n = o.geometry), r.$$.dirty & /*viewportScale*/
    64 && e(3, i = 10 / h);
  }, [
    o,
    a,
    s,
    i,
    n,
    u,
    h,
    l,
    f,
    c
  ];
}
class Kf extends ne {
  constructor(t) {
    super(), re(this, t, qf, $f, te, {
      shape: 0,
      computedStyle: 1,
      transform: 2,
      viewportScale: 6
    });
  }
}
function Zf(r) {
  let t, e, n, i, o, a, s, h, u, l, f, c, d, p, v, _, m, y, g, x, T, E, P, b, w, A, R, C, M, H, U, B, $, q, Q, N, F, k, tt, et, pt, j, st, _t, Tt, W, it, at, lt, nt;
  return {
    c() {
      t = ft("rect"), s = ae(), h = ft("rect"), d = ae(), p = ft("rect"), y = ae(), g = ft("rect"), P = ae(), b = ft("rect"), C = ae(), M = ft("rect"), $ = ae(), q = ft("rect"), F = ae(), k = ft("rect"), pt = ae(), j = ft("rect"), Tt = ae(), W = ft("rect"), S(t, "class", "a9s-outer"), S(t, "style", e = /*computedStyle*/
      r[1] ? "display:none;" : void 0), S(t, "x", n = /*geom*/
      r[4].x), S(t, "y", i = /*geom*/
      r[4].y), S(t, "width", o = /*geom*/
      r[4].w), S(t, "height", a = /*geom*/
      r[4].h), S(h, "class", "a9s-inner a9s-shape-handle"), S(
        h,
        "style",
        /*computedStyle*/
        r[1]
      ), S(h, "x", u = /*geom*/
      r[4].x), S(h, "y", l = /*geom*/
      r[4].y), S(h, "width", f = /*geom*/
      r[4].w), S(h, "height", c = /*geom*/
      r[4].h), S(p, "class", "a9s-edge-handle a9s-edge-handle-top"), S(p, "x", v = /*geom*/
      r[4].x), S(p, "y", _ = /*geom*/
      r[4].y), S(p, "height", 1), S(p, "width", m = /*geom*/
      r[4].w), S(g, "class", "a9s-edge-handle a9s-edge-handle-right"), S(g, "x", x = /*geom*/
      r[4].x + /*geom*/
      r[4].w), S(g, "y", T = /*geom*/
      r[4].y), S(g, "height", E = /*geom*/
      r[4].h), S(g, "width", 1), S(b, "class", "a9s-edge-handle a9s-edge-handle-bottom"), S(b, "x", w = /*geom*/
      r[4].x), S(b, "y", A = /*geom*/
      r[4].y + /*geom*/
      r[4].h), S(b, "height", 1), S(b, "width", R = /*geom*/
      r[4].w), S(M, "class", "a9s-edge-handle a9s-edge-handle-left"), S(M, "x", H = /*geom*/
      r[4].x), S(M, "y", U = /*geom*/
      r[4].y), S(M, "height", B = /*geom*/
      r[4].h), S(M, "width", 1), S(q, "class", "a9s-corner-handle a9s-corner-handle-topleft"), S(q, "x", Q = /*geom*/
      r[4].x - /*handleSize*/
      r[3] / 2), S(q, "y", N = /*geom*/
      r[4].y - /*handleSize*/
      r[3] / 2), S(
        q,
        "height",
        /*handleSize*/
        r[3]
      ), S(
        q,
        "width",
        /*handleSize*/
        r[3]
      ), S(k, "class", "a9s-corner-handle a9s-corner-handle-topright"), S(k, "x", tt = /*geom*/
      r[4].x + /*geom*/
      r[4].w - /*handleSize*/
      r[3] / 2), S(k, "y", et = /*geom*/
      r[4].y - /*handleSize*/
      r[3] / 2), S(
        k,
        "height",
        /*handleSize*/
        r[3]
      ), S(
        k,
        "width",
        /*handleSize*/
        r[3]
      ), S(j, "class", "a9s-corner-handle a9s-corner-handle-bottomright"), S(j, "x", st = /*geom*/
      r[4].x + /*geom*/
      r[4].w - /*handleSize*/
      r[3] / 2), S(j, "y", _t = /*geom*/
      r[4].y + /*geom*/
      r[4].h - /*handleSize*/
      r[3] / 2), S(
        j,
        "height",
        /*handleSize*/
        r[3]
      ), S(
        j,
        "width",
        /*handleSize*/
        r[3]
      ), S(W, "class", "a9s-corner-handle a9s-corner-handle-bottomleft"), S(W, "x", it = /*geom*/
      r[4].x - /*handleSize*/
      r[3] / 2), S(W, "y", at = /*geom*/
      r[4].y + /*geom*/
      r[4].h - /*handleSize*/
      r[3] / 2), S(
        W,
        "height",
        /*handleSize*/
        r[3]
      ), S(
        W,
        "width",
        /*handleSize*/
        r[3]
      );
    },
    m(D, O) {
      Z(D, t, O), Z(D, s, O), Z(D, h, O), Z(D, d, O), Z(D, p, O), Z(D, y, O), Z(D, g, O), Z(D, P, O), Z(D, b, O), Z(D, C, O), Z(D, M, O), Z(D, $, O), Z(D, q, O), Z(D, F, O), Z(D, k, O), Z(D, pt, O), Z(D, j, O), Z(D, Tt, O), Z(D, W, O), lt || (nt = [
        Yt(t, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.SHAPE)
          ) && r[10](V.SHAPE).apply(this, arguments);
        }),
        Yt(h, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.SHAPE)
          ) && r[10](V.SHAPE).apply(this, arguments);
        }),
        Yt(p, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.TOP)
          ) && r[10](V.TOP).apply(this, arguments);
        }),
        Yt(g, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.RIGHT)
          ) && r[10](V.RIGHT).apply(this, arguments);
        }),
        Yt(b, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.BOTTOM)
          ) && r[10](V.BOTTOM).apply(this, arguments);
        }),
        Yt(M, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.LEFT)
          ) && r[10](V.LEFT).apply(this, arguments);
        }),
        Yt(q, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.TOP_LEFT)
          ) && r[10](V.TOP_LEFT).apply(this, arguments);
        }),
        Yt(k, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.TOP_RIGHT)
          ) && r[10](V.TOP_RIGHT).apply(this, arguments);
        }),
        Yt(j, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.BOTTOM_RIGHT)
          ) && r[10](V.BOTTOM_RIGHT).apply(this, arguments);
        }),
        Yt(W, "pointerdown", function() {
          Gt(
            /*grab*/
            r[10](V.BOTTOM_LEFT)
          ) && r[10](V.BOTTOM_LEFT).apply(this, arguments);
        })
      ], lt = !0);
    },
    p(D, O) {
      r = D, O & /*computedStyle*/
      2 && e !== (e = /*computedStyle*/
      r[1] ? "display:none;" : void 0) && S(t, "style", e), O & /*geom*/
      16 && n !== (n = /*geom*/
      r[4].x) && S(t, "x", n), O & /*geom*/
      16 && i !== (i = /*geom*/
      r[4].y) && S(t, "y", i), O & /*geom*/
      16 && o !== (o = /*geom*/
      r[4].w) && S(t, "width", o), O & /*geom*/
      16 && a !== (a = /*geom*/
      r[4].h) && S(t, "height", a), O & /*computedStyle*/
      2 && S(
        h,
        "style",
        /*computedStyle*/
        r[1]
      ), O & /*geom*/
      16 && u !== (u = /*geom*/
      r[4].x) && S(h, "x", u), O & /*geom*/
      16 && l !== (l = /*geom*/
      r[4].y) && S(h, "y", l), O & /*geom*/
      16 && f !== (f = /*geom*/
      r[4].w) && S(h, "width", f), O & /*geom*/
      16 && c !== (c = /*geom*/
      r[4].h) && S(h, "height", c), O & /*geom*/
      16 && v !== (v = /*geom*/
      r[4].x) && S(p, "x", v), O & /*geom*/
      16 && _ !== (_ = /*geom*/
      r[4].y) && S(p, "y", _), O & /*geom*/
      16 && m !== (m = /*geom*/
      r[4].w) && S(p, "width", m), O & /*geom*/
      16 && x !== (x = /*geom*/
      r[4].x + /*geom*/
      r[4].w) && S(g, "x", x), O & /*geom*/
      16 && T !== (T = /*geom*/
      r[4].y) && S(g, "y", T), O & /*geom*/
      16 && E !== (E = /*geom*/
      r[4].h) && S(g, "height", E), O & /*geom*/
      16 && w !== (w = /*geom*/
      r[4].x) && S(b, "x", w), O & /*geom*/
      16 && A !== (A = /*geom*/
      r[4].y + /*geom*/
      r[4].h) && S(b, "y", A), O & /*geom*/
      16 && R !== (R = /*geom*/
      r[4].w) && S(b, "width", R), O & /*geom*/
      16 && H !== (H = /*geom*/
      r[4].x) && S(M, "x", H), O & /*geom*/
      16 && U !== (U = /*geom*/
      r[4].y) && S(M, "y", U), O & /*geom*/
      16 && B !== (B = /*geom*/
      r[4].h) && S(M, "height", B), O & /*geom, handleSize*/
      24 && Q !== (Q = /*geom*/
      r[4].x - /*handleSize*/
      r[3] / 2) && S(q, "x", Q), O & /*geom, handleSize*/
      24 && N !== (N = /*geom*/
      r[4].y - /*handleSize*/
      r[3] / 2) && S(q, "y", N), O & /*handleSize*/
      8 && S(
        q,
        "height",
        /*handleSize*/
        r[3]
      ), O & /*handleSize*/
      8 && S(
        q,
        "width",
        /*handleSize*/
        r[3]
      ), O & /*geom, handleSize*/
      24 && tt !== (tt = /*geom*/
      r[4].x + /*geom*/
      r[4].w - /*handleSize*/
      r[3] / 2) && S(k, "x", tt), O & /*geom, handleSize*/
      24 && et !== (et = /*geom*/
      r[4].y - /*handleSize*/
      r[3] / 2) && S(k, "y", et), O & /*handleSize*/
      8 && S(
        k,
        "height",
        /*handleSize*/
        r[3]
      ), O & /*handleSize*/
      8 && S(
        k,
        "width",
        /*handleSize*/
        r[3]
      ), O & /*geom, handleSize*/
      24 && st !== (st = /*geom*/
      r[4].x + /*geom*/
      r[4].w - /*handleSize*/
      r[3] / 2) && S(j, "x", st), O & /*geom, handleSize*/
      24 && _t !== (_t = /*geom*/
      r[4].y + /*geom*/
      r[4].h - /*handleSize*/
      r[3] / 2) && S(j, "y", _t), O & /*handleSize*/
      8 && S(
        j,
        "height",
        /*handleSize*/
        r[3]
      ), O & /*handleSize*/
      8 && S(
        j,
        "width",
        /*handleSize*/
        r[3]
      ), O & /*geom, handleSize*/
      24 && it !== (it = /*geom*/
      r[4].x - /*handleSize*/
      r[3] / 2) && S(W, "x", it), O & /*geom, handleSize*/
      24 && at !== (at = /*geom*/
      r[4].y + /*geom*/
      r[4].h - /*handleSize*/
      r[3] / 2) && S(W, "y", at), O & /*handleSize*/
      8 && S(
        W,
        "height",
        /*handleSize*/
        r[3]
      ), O & /*handleSize*/
      8 && S(
        W,
        "width",
        /*handleSize*/
        r[3]
      );
    },
    d(D) {
      D && K(t), D && K(s), D && K(h), D && K(d), D && K(p), D && K(y), D && K(g), D && K(P), D && K(b), D && K(C), D && K(M), D && K($), D && K(q), D && K(F), D && K(k), D && K(pt), D && K(j), D && K(Tt), D && K(W), lt = !1, ke(nt);
    }
  };
}
function Jf(r) {
  let t, e;
  return t = new Du({
    props: {
      shape: (
        /*shape*/
        r[0]
      ),
      transform: (
        /*transform*/
        r[2]
      ),
      editor: (
        /*editor*/
        r[5]
      ),
      $$slots: {
        default: [
          Zf,
          ({ grab: n }) => ({ 10: n }),
          ({ grab: n }) => n ? 1024 : 0
        ]
      },
      $$scope: { ctx: r }
    }
  }), t.$on(
    "grab",
    /*grab_handler*/
    r[7]
  ), t.$on(
    "change",
    /*change_handler*/
    r[8]
  ), t.$on(
    "release",
    /*release_handler*/
    r[9]
  ), {
    c() {
      ee(t.$$.fragment);
    },
    m(n, i) {
      Zt(t, n, i), e = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*shape*/
      1 && (o.shape = /*shape*/
      n[0]), i & /*transform*/
      4 && (o.transform = /*transform*/
      n[2]), i & /*$$scope, geom, handleSize, grab, computedStyle*/
      3098 && (o.$$scope = { dirty: i, ctx: n }), t.$set(o);
    },
    i(n) {
      e || (ct(t.$$.fragment, n), e = !0);
    },
    o(n) {
      bt(t.$$.fragment, n), e = !1;
    },
    d(n) {
      Jt(t, n);
    }
  };
}
function Qf(r, t, e) {
  let n, i, { shape: o } = t, { computedStyle: a = void 0 } = t, { transform: s } = t, { viewportScale: h = 1 } = t;
  const u = (d, p, v) => {
    const _ = d.geometry.bounds;
    let [m, y] = [_.minX, _.minY], [g, x] = [_.maxX, _.maxY];
    const [T, E] = v;
    if (p === V.SHAPE)
      m += T, g += T, y += E, x += E;
    else {
      switch (p) {
        case V.TOP:
        case V.TOP_LEFT:
        case V.TOP_RIGHT: {
          y += E;
          break;
        }
        case V.BOTTOM:
        case V.BOTTOM_LEFT:
        case V.BOTTOM_RIGHT: {
          x += E;
          break;
        }
      }
      switch (p) {
        case V.LEFT:
        case V.TOP_LEFT:
        case V.BOTTOM_LEFT: {
          m += T;
          break;
        }
        case V.RIGHT:
        case V.TOP_RIGHT:
        case V.BOTTOM_RIGHT: {
          g += T;
          break;
        }
      }
    }
    const P = Math.min(m, g), b = Math.min(y, x), w = Math.abs(g - m), A = Math.abs(x - y);
    return {
      ...d,
      geometry: {
        x: P,
        y: b,
        w,
        h: A,
        bounds: {
          minX: P,
          minY: b,
          maxX: P + w,
          maxY: b + A
        }
      }
    };
  };
  function l(d) {
    Mr.call(this, r, d);
  }
  function f(d) {
    Mr.call(this, r, d);
  }
  function c(d) {
    Mr.call(this, r, d);
  }
  return r.$$set = (d) => {
    "shape" in d && e(0, o = d.shape), "computedStyle" in d && e(1, a = d.computedStyle), "transform" in d && e(2, s = d.transform), "viewportScale" in d && e(6, h = d.viewportScale);
  }, r.$$.update = () => {
    r.$$.dirty & /*shape*/
    1 && e(4, n = o.geometry), r.$$.dirty & /*viewportScale*/
    64 && e(3, i = 10 / h);
  }, [
    o,
    a,
    s,
    i,
    n,
    u,
    h,
    l,
    f,
    c
  ];
}
class tc extends ne {
  constructor(t) {
    super(), re(this, t, Qf, Jf, te, {
      shape: 0,
      computedStyle: 1,
      transform: 2,
      viewportScale: 6
    });
  }
}
const ec = /* @__PURE__ */ new Map([
  [$t.RECTANGLE, tc],
  [$t.POLYGON, Kf]
]), Es = (r) => ec.get(r.type), V = (r) => `HANDLE-${r}`;
V.SHAPE = "SHAPE";
V.TOP = "TOP";
V.RIGHT = "RIGHT";
V.BOTTOM = "BOTTOM";
V.LEFT = "LEFT";
V.TOP_LEFT = "TOP_LEFT";
V.TOP_RIGHT = "TOP_RIGHT";
V.BOTTOM_RIGHT = "BOTTOM_RIGHT";
V.BOTTOM_LEFT = "BOTTOM_LEFT";
const rc = (r) => ({}), ws = (r) => ({ grab: (
  /*onGrab*/
  r[0]
) });
function nc(r) {
  let t, e, n, i;
  const o = (
    /*#slots*/
    r[7].default
  ), a = Su(
    o,
    r,
    /*$$scope*/
    r[6],
    ws
  );
  return {
    c() {
      t = ft("g"), a && a.c(), S(t, "class", "a9s-annotation selected");
    },
    m(s, h) {
      Z(s, t, h), a && a.m(t, null), e = !0, n || (i = [
        Yt(
          t,
          "pointerup",
          /*onRelease*/
          r[2]
        ),
        Yt(
          t,
          "pointermove",
          /*onPointerMove*/
          r[1]
        )
      ], n = !0);
    },
    p(s, [h]) {
      a && a.p && (!e || h & /*$$scope*/
      64) && Ou(
        a,
        o,
        s,
        /*$$scope*/
        s[6],
        e ? Pu(
          o,
          /*$$scope*/
          s[6],
          h,
          rc
        ) : Ru(
          /*$$scope*/
          s[6]
        ),
        ws
      );
    },
    i(s) {
      e || (ct(a, s), e = !0);
    },
    o(s) {
      bt(a, s), e = !1;
    },
    d(s) {
      s && K(t), a && a.d(s), n = !1, ke(i);
    }
  };
}
function ic(r, t, e) {
  let { $$slots: n = {}, $$scope: i } = t;
  const o = Bi();
  let { shape: a } = t, { editor: s } = t, { transform: h } = t, u = null, l, f = null;
  const c = (v) => (_) => {
    u = v, l = h.elementToImage(_.offsetX, _.offsetY), f = a, _.target.setPointerCapture(_.pointerId), o("grab");
  }, d = (v) => {
    if (u) {
      const [_, m] = h.elementToImage(v.offsetX, v.offsetY), y = [_ - l[0], m - l[1]];
      e(3, a = s(f, u, y)), o("change", a);
    }
  }, p = (v) => {
    v.target.releasePointerCapture(v.pointerId), u = null, f = a, o("release");
  };
  return r.$$set = (v) => {
    "shape" in v && e(3, a = v.shape), "editor" in v && e(4, s = v.editor), "transform" in v && e(5, h = v.transform), "$$scope" in v && e(6, i = v.$$scope);
  }, [c, d, p, a, s, h, i, n];
}
class Du extends ne {
  constructor(t) {
    super(), re(this, t, ic, nc, te, { shape: 3, editor: 4, transform: 5 });
  }
}
function Ss(r) {
  let t, e;
  return {
    c() {
      t = ft("rect"), e = ft("rect"), S(t, "class", "a9s-outer"), S(
        t,
        "x",
        /*x*/
        r[2]
      ), S(
        t,
        "y",
        /*y*/
        r[3]
      ), S(
        t,
        "width",
        /*w*/
        r[4]
      ), S(
        t,
        "height",
        /*h*/
        r[5]
      ), S(e, "class", "a9s-inner"), S(
        e,
        "x",
        /*x*/
        r[2]
      ), S(
        e,
        "y",
        /*y*/
        r[3]
      ), S(
        e,
        "width",
        /*w*/
        r[4]
      ), S(
        e,
        "height",
        /*h*/
        r[5]
      );
    },
    m(n, i) {
      Z(n, t, i), Z(n, e, i);
    },
    p(n, i) {
      i & /*x*/
      4 && S(
        t,
        "x",
        /*x*/
        n[2]
      ), i & /*y*/
      8 && S(
        t,
        "y",
        /*y*/
        n[3]
      ), i & /*w*/
      16 && S(
        t,
        "width",
        /*w*/
        n[4]
      ), i & /*h*/
      32 && S(
        t,
        "height",
        /*h*/
        n[5]
      ), i & /*x*/
      4 && S(
        e,
        "x",
        /*x*/
        n[2]
      ), i & /*y*/
      8 && S(
        e,
        "y",
        /*y*/
        n[3]
      ), i & /*w*/
      16 && S(
        e,
        "width",
        /*w*/
        n[4]
      ), i & /*h*/
      32 && S(
        e,
        "height",
        /*h*/
        n[5]
      );
    },
    d(n) {
      n && K(t), n && K(e);
    }
  };
}
function oc(r) {
  let t, e = (
    /*origin*/
    r[1] && Ss(r)
  );
  return {
    c() {
      t = ft("g"), e && e.c(), S(t, "class", "a9s-annotation a9s-rubberband");
    },
    m(n, i) {
      Z(n, t, i), e && e.m(t, null), r[7](t);
    },
    p(n, [i]) {
      /*origin*/
      n[1] ? e ? e.p(n, i) : (e = Ss(n), e.c(), e.m(t, null)) : e && (e.d(1), e = null);
    },
    i: Kt,
    o: Kt,
    d(n) {
      n && K(t), e && e.d(), r[7](null);
    }
  };
}
function ac(r, t, e) {
  const n = Bi();
  let { transform: i } = t, o, a, s, h, u, l, f;
  const c = (_) => {
    e(1, a = i.elementToImage(_.offsetX, _.offsetY)), s = a, e(2, h = a[0]), e(3, u = a[1]), e(4, l = 1), e(5, f = 1);
  }, d = (_) => {
    a && (s = i.elementToImage(_.offsetX, _.offsetY), e(2, h = Math.min(s[0], a[0])), e(3, u = Math.min(s[1], a[1])), e(4, l = Math.abs(s[0] - a[0])), e(5, f = Math.abs(s[1] - a[1])));
  }, p = () => {
    if (l * f > 15) {
      const _ = {
        type: $t.RECTANGLE,
        geometry: {
          bounds: {
            minX: h,
            minY: u,
            maxX: h + l,
            maxY: u + f
          },
          x: h,
          y: u,
          w: l,
          h: f
        }
      };
      n("create", _);
    }
    e(1, a = null), s = null;
  };
  Fi(() => {
    const _ = o.closest("svg");
    return _.addEventListener("pointerdown", c), _.addEventListener("pointermove", d), _.addEventListener("pointerup", p), () => {
      _.removeEventListener("pointerdown", c), _.removeEventListener("pointermove", d), _.removeEventListener("pointerup", p);
    };
  });
  function v(_) {
    dn[_ ? "unshift" : "push"](() => {
      o = _, e(0, o);
    });
  }
  return r.$$set = (_) => {
    "transform" in _ && e(6, i = _.transform);
  }, [o, a, h, u, l, f, i, v];
}
class sc extends ne {
  constructor(t) {
    super(), re(this, t, ac, oc, te, { transform: 6 });
  }
}
const As = (r, t) => {
  const e = Math.abs(t[0] - r[0]), n = Math.abs(t[1] - r[1]);
  return Math.sqrt(Math.pow(e, 2) + Math.pow(n, 2));
};
function Yi(r) {
  const t = r.slice(), e = (
    /*isClosable*/
    (t[3] ? (
      /*points*/
      t[1]
    ) : [
      .../*points*/
      t[1],
      /*cursor*/
      t[2]
    ]).map((n) => n.join(",")).join(" ")
  );
  return t[13] = e, t;
}
function Ps(r) {
  let t, e, n, i, o, a = (
    /*isClosable*/
    r[3] && Os(r)
  );
  return {
    c() {
      t = ft("polygon"), n = ft("polygon"), a && a.c(), o = He(), S(t, "class", "a9s-outer"), S(t, "points", e = /*coords*/
      r[13]), S(n, "class", "a9s-inner"), S(n, "points", i = /*coords*/
      r[13]);
    },
    m(s, h) {
      Z(s, t, h), Z(s, n, h), a && a.m(s, h), Z(s, o, h);
    },
    p(s, h) {
      h & /*isClosable, points, cursor*/
      14 && e !== (e = /*coords*/
      s[13]) && S(t, "points", e), h & /*isClosable, points, cursor*/
      14 && i !== (i = /*coords*/
      s[13]) && S(n, "points", i), /*isClosable*/
      s[3] ? a ? a.p(s, h) : (a = Os(s), a.c(), a.m(o.parentNode, o)) : a && (a.d(1), a = null);
    },
    d(s) {
      s && K(t), s && K(n), a && a.d(s), s && K(o);
    }
  };
}
function Os(r) {
  let t, e, n;
  return {
    c() {
      t = ft("rect"), S(t, "class", "a9s-corner-handle"), S(t, "x", e = /*points*/
      r[1][0][0] - /*handleSize*/
      r[4] / 2), S(t, "y", n = /*points*/
      r[1][0][1] - /*handleSize*/
      r[4] / 2), S(
        t,
        "height",
        /*handleSize*/
        r[4]
      ), S(
        t,
        "width",
        /*handleSize*/
        r[4]
      );
    },
    m(i, o) {
      Z(i, t, o);
    },
    p(i, o) {
      o & /*points, handleSize*/
      18 && e !== (e = /*points*/
      i[1][0][0] - /*handleSize*/
      i[4] / 2) && S(t, "x", e), o & /*points, handleSize*/
      18 && n !== (n = /*points*/
      i[1][0][1] - /*handleSize*/
      i[4] / 2) && S(t, "y", n), o & /*handleSize*/
      16 && S(
        t,
        "height",
        /*handleSize*/
        i[4]
      ), o & /*handleSize*/
      16 && S(
        t,
        "width",
        /*handleSize*/
        i[4]
      );
    },
    d(i) {
      i && K(t);
    }
  };
}
function hc(r) {
  let t, e = (
    /*cursor*/
    r[2] && Ps(Yi(r))
  );
  return {
    c() {
      t = ft("g"), e && e.c(), S(t, "class", "a9s-annotation a9s-rubberband");
    },
    m(n, i) {
      Z(n, t, i), e && e.m(t, null), r[7](t);
    },
    p(n, [i]) {
      /*cursor*/
      n[2] ? e ? e.p(Yi(n), i) : (e = Ps(Yi(n)), e.c(), e.m(t, null)) : e && (e.d(1), e = null);
    },
    i: Kt,
    o: Kt,
    d(n) {
      n && K(t), e && e.d(), r[7](null);
    }
  };
}
const uc = 20;
function lc(r, t, e) {
  let n;
  const i = Bi();
  let { transform: o } = t, { viewportScale: a = 1 } = t, s, h = [], u = null, l = !1;
  const f = (_) => {
    const m = o.elementToImage(_.offsetX, _.offsetY);
    h.length === 0 && h.push(m), e(2, u = m);
  }, c = (_) => {
    if (h.length > 0 && (e(2, u = o.elementToImage(_.offsetX, _.offsetY)), h.length > 2)) {
      const m = As(u, h[0]) * a;
      e(3, l = m < uc);
    }
  }, d = (_) => {
    if (h.length === 1 && As(h[0], u) <= 4) {
      e(1, h = []), e(2, u = null);
      return;
    }
    if (_.stopImmediatePropagation(), l) {
      const m = {
        type: $t.POLYGON,
        geometry: {
          bounds: ko(h),
          points: [...h]
        }
      };
      e(1, h = []), e(2, u = null), i("create", m);
    } else
      h.push(u);
  }, p = () => {
    const _ = [...h, u], m = {
      type: $t.POLYGON,
      geometry: { bounds: ko(_), points: _ }
    };
    e(1, h = []), e(2, u = null), i("create", m);
  };
  Fi(() => {
    const _ = s.closest("svg");
    return _.addEventListener("pointerdown", f, !0), _.addEventListener("pointermove", c), _.addEventListener("pointerup", d, !0), _.addEventListener("dblclick", p, !0), () => {
      _.removeEventListener("pointerdown", f, !0), _.removeEventListener("pointermove", c, !0), _.removeEventListener("pointerup", d, !0), _.removeEventListener("dblclick", p, !0);
    };
  });
  function v(_) {
    dn[_ ? "unshift" : "push"](() => {
      s = _, e(0, s);
    });
  }
  return r.$$set = (_) => {
    "transform" in _ && e(5, o = _.transform), "viewportScale" in _ && e(6, a = _.viewportScale);
  }, r.$$.update = () => {
    r.$$.dirty & /*viewportScale*/
    64 && e(4, n = 10 / a);
  }, [
    s,
    h,
    u,
    l,
    n,
    o,
    a,
    v
  ];
}
class fc extends ne {
  constructor(t) {
    super(), re(this, t, lc, hc, te, { transform: 5, viewportScale: 6 });
  }
}
const Fu = /* @__PURE__ */ new Map([
  ["rectangle", sc],
  ["polygon", fc]
]), cc = () => [...Fu.keys()], dc = (r) => Fu.get(r);
function pc(r, t, e, n, i) {
  Bu(r, t, e || 0, n || r.length - 1, i || vc);
}
function Bu(r, t, e, n, i) {
  for (; n > e; ) {
    if (n - e > 600) {
      var o = n - e + 1, a = t - e + 1, s = Math.log(o), h = 0.5 * Math.exp(2 * s / 3), u = 0.5 * Math.sqrt(s * h * (o - h) / o) * (a - o / 2 < 0 ? -1 : 1), l = Math.max(e, Math.floor(t - a * h / o + u)), f = Math.min(n, Math.floor(t + (o - a) * h / o + u));
      Bu(r, t, l, f, i);
    }
    var c = r[t], d = e, p = n;
    for ($r(r, e, t), i(r[n], c) > 0 && $r(r, e, n); d < p; ) {
      for ($r(r, d, p), d++, p--; i(r[d], c) < 0; )
        d++;
      for (; i(r[p], c) > 0; )
        p--;
    }
    i(r[e], c) === 0 ? $r(r, e, p) : (p++, $r(r, p, n)), p <= t && (e = p + 1), t <= p && (n = p - 1);
  }
}
function $r(r, t, e) {
  var n = r[t];
  r[t] = r[e], r[e] = n;
}
function vc(r, t) {
  return r < t ? -1 : r > t ? 1 : 0;
}
class _c {
  constructor(t = 9) {
    this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4)), this.clear();
  }
  all() {
    return this._all(this.data, []);
  }
  search(t) {
    let e = this.data;
    const n = [];
    if (!Fn(t, e))
      return n;
    const i = this.toBBox, o = [];
    for (; e; ) {
      for (let a = 0; a < e.children.length; a++) {
        const s = e.children[a], h = e.leaf ? i(s) : s;
        Fn(t, h) && (e.leaf ? n.push(s) : zi(t, h) ? this._all(s, n) : o.push(s));
      }
      e = o.pop();
    }
    return n;
  }
  collides(t) {
    let e = this.data;
    if (!Fn(t, e))
      return !1;
    const n = [];
    for (; e; ) {
      for (let i = 0; i < e.children.length; i++) {
        const o = e.children[i], a = e.leaf ? this.toBBox(o) : o;
        if (Fn(t, a)) {
          if (e.leaf || zi(t, a))
            return !0;
          n.push(o);
        }
      }
      e = n.pop();
    }
    return !1;
  }
  load(t) {
    if (!(t && t.length))
      return this;
    if (t.length < this._minEntries) {
      for (let n = 0; n < t.length; n++)
        this.insert(t[n]);
      return this;
    }
    let e = this._build(t.slice(), 0, t.length - 1, 0);
    if (!this.data.children.length)
      this.data = e;
    else if (this.data.height === e.height)
      this._splitRoot(this.data, e);
    else {
      if (this.data.height < e.height) {
        const n = this.data;
        this.data = e, e = n;
      }
      this._insert(e, this.data.height - e.height - 1, !0);
    }
    return this;
  }
  insert(t) {
    return t && this._insert(t, this.data.height - 1), this;
  }
  clear() {
    return this.data = Sr([]), this;
  }
  remove(t, e) {
    if (!t)
      return this;
    let n = this.data;
    const i = this.toBBox(t), o = [], a = [];
    let s, h, u;
    for (; n || o.length; ) {
      if (n || (n = o.pop(), h = o[o.length - 1], s = a.pop(), u = !0), n.leaf) {
        const l = mc(t, n.children, e);
        if (l !== -1)
          return n.children.splice(l, 1), o.push(n), this._condense(o), this;
      }
      !u && !n.leaf && zi(n, i) ? (o.push(n), a.push(s), s = 0, h = n, n = n.children[0]) : h ? (s++, n = h.children[s], u = !1) : n = null;
    }
    return this;
  }
  toBBox(t) {
    return t;
  }
  compareMinX(t, e) {
    return t.minX - e.minX;
  }
  compareMinY(t, e) {
    return t.minY - e.minY;
  }
  toJSON() {
    return this.data;
  }
  fromJSON(t) {
    return this.data = t, this;
  }
  _all(t, e) {
    const n = [];
    for (; t; )
      t.leaf ? e.push(...t.children) : n.push(...t.children), t = n.pop();
    return e;
  }
  _build(t, e, n, i) {
    const o = n - e + 1;
    let a = this._maxEntries, s;
    if (o <= a)
      return s = Sr(t.slice(e, n + 1)), yr(s, this.toBBox), s;
    i || (i = Math.ceil(Math.log(o) / Math.log(a)), a = Math.ceil(o / Math.pow(a, i - 1))), s = Sr([]), s.leaf = !1, s.height = i;
    const h = Math.ceil(o / a), u = h * Math.ceil(Math.sqrt(a));
    Rs(t, e, n, u, this.compareMinX);
    for (let l = e; l <= n; l += u) {
      const f = Math.min(l + u - 1, n);
      Rs(t, l, f, h, this.compareMinY);
      for (let c = l; c <= f; c += h) {
        const d = Math.min(c + h - 1, f);
        s.children.push(this._build(t, c, d, i - 1));
      }
    }
    return yr(s, this.toBBox), s;
  }
  _chooseSubtree(t, e, n, i) {
    for (; i.push(e), !(e.leaf || i.length - 1 === n); ) {
      let o = 1 / 0, a = 1 / 0, s;
      for (let h = 0; h < e.children.length; h++) {
        const u = e.children[h], l = Vi(u), f = bc(t, u) - l;
        f < a ? (a = f, o = l < o ? l : o, s = u) : f === a && l < o && (o = l, s = u);
      }
      e = s || e.children[0];
    }
    return e;
  }
  _insert(t, e, n) {
    const i = n ? t : this.toBBox(t), o = [], a = this._chooseSubtree(i, this.data, e, o);
    for (a.children.push(t), on(a, i); e >= 0 && o[e].children.length > this._maxEntries; )
      this._split(o, e), e--;
    this._adjustParentBBoxes(i, o, e);
  }
  // split overflowed node into two
  _split(t, e) {
    const n = t[e], i = n.children.length, o = this._minEntries;
    this._chooseSplitAxis(n, o, i);
    const a = this._chooseSplitIndex(n, o, i), s = Sr(n.children.splice(a, n.children.length - a));
    s.height = n.height, s.leaf = n.leaf, yr(n, this.toBBox), yr(s, this.toBBox), e ? t[e - 1].children.push(s) : this._splitRoot(n, s);
  }
  _splitRoot(t, e) {
    this.data = Sr([t, e]), this.data.height = t.height + 1, this.data.leaf = !1, yr(this.data, this.toBBox);
  }
  _chooseSplitIndex(t, e, n) {
    let i, o = 1 / 0, a = 1 / 0;
    for (let s = e; s <= n - e; s++) {
      const h = nn(t, 0, s, this.toBBox), u = nn(t, s, n, this.toBBox), l = xc(h, u), f = Vi(h) + Vi(u);
      l < o ? (o = l, i = s, a = f < a ? f : a) : l === o && f < a && (a = f, i = s);
    }
    return i || n - e;
  }
  // sorts node children by the best axis for split
  _chooseSplitAxis(t, e, n) {
    const i = t.leaf ? this.compareMinX : yc, o = t.leaf ? this.compareMinY : gc, a = this._allDistMargin(t, e, n, i), s = this._allDistMargin(t, e, n, o);
    a < s && t.children.sort(i);
  }
  // total margin of all possible split distributions where each node is at least m full
  _allDistMargin(t, e, n, i) {
    t.children.sort(i);
    const o = this.toBBox, a = nn(t, 0, e, o), s = nn(t, n - e, n, o);
    let h = Dn(a) + Dn(s);
    for (let u = e; u < n - e; u++) {
      const l = t.children[u];
      on(a, t.leaf ? o(l) : l), h += Dn(a);
    }
    for (let u = n - e - 1; u >= e; u--) {
      const l = t.children[u];
      on(s, t.leaf ? o(l) : l), h += Dn(s);
    }
    return h;
  }
  _adjustParentBBoxes(t, e, n) {
    for (let i = n; i >= 0; i--)
      on(e[i], t);
  }
  _condense(t) {
    for (let e = t.length - 1, n; e >= 0; e--)
      t[e].children.length === 0 ? e > 0 ? (n = t[e - 1].children, n.splice(n.indexOf(t[e]), 1)) : this.clear() : yr(t[e], this.toBBox);
  }
}
function mc(r, t, e) {
  if (!e)
    return t.indexOf(r);
  for (let n = 0; n < t.length; n++)
    if (e(r, t[n]))
      return n;
  return -1;
}
function yr(r, t) {
  nn(r, 0, r.children.length, t, r);
}
function nn(r, t, e, n, i) {
  i || (i = Sr(null)), i.minX = 1 / 0, i.minY = 1 / 0, i.maxX = -1 / 0, i.maxY = -1 / 0;
  for (let o = t; o < e; o++) {
    const a = r.children[o];
    on(i, r.leaf ? n(a) : a);
  }
  return i;
}
function on(r, t) {
  return r.minX = Math.min(r.minX, t.minX), r.minY = Math.min(r.minY, t.minY), r.maxX = Math.max(r.maxX, t.maxX), r.maxY = Math.max(r.maxY, t.maxY), r;
}
function yc(r, t) {
  return r.minX - t.minX;
}
function gc(r, t) {
  return r.minY - t.minY;
}
function Vi(r) {
  return (r.maxX - r.minX) * (r.maxY - r.minY);
}
function Dn(r) {
  return r.maxX - r.minX + (r.maxY - r.minY);
}
function bc(r, t) {
  return (Math.max(t.maxX, r.maxX) - Math.min(t.minX, r.minX)) * (Math.max(t.maxY, r.maxY) - Math.min(t.minY, r.minY));
}
function xc(r, t) {
  const e = Math.max(r.minX, t.minX), n = Math.max(r.minY, t.minY), i = Math.min(r.maxX, t.maxX), o = Math.min(r.maxY, t.maxY);
  return Math.max(0, i - e) * Math.max(0, o - n);
}
function zi(r, t) {
  return r.minX <= t.minX && r.minY <= t.minY && t.maxX <= r.maxX && t.maxY <= r.maxY;
}
function Fn(r, t) {
  return t.minX <= r.maxX && t.minY <= r.maxY && t.maxX >= r.minX && t.maxY >= r.minY;
}
function Sr(r) {
  return {
    children: r,
    height: 1,
    leaf: !0,
    minX: 1 / 0,
    minY: 1 / 0,
    maxX: -1 / 0,
    maxY: -1 / 0
  };
}
function Rs(r, t, e, n, i) {
  const o = [t, e];
  for (; o.length; ) {
    if (e = o.pop(), t = o.pop(), e - t <= n)
      continue;
    const a = t + Math.ceil((e - t) / n / 2) * n;
    pc(r, a, t, e, i), o.push(t, a, a, e);
  }
}
const Tc = () => {
  const r = new _c(), t = /* @__PURE__ */ new Map(), e = () => [...t.values()], n = () => {
    r.clear(), t.clear();
  }, i = (f) => {
    const { minX: c, minY: d, maxX: p, maxY: v } = f.selector.geometry.bounds, _ = { minX: c, minY: d, maxX: p, maxY: v, target: f };
    r.insert(_), t.set(f.annotation, _);
  }, o = (f) => {
    const c = t.get(f.annotation);
    r.remove(c), t.delete(f.annotation);
  };
  return {
    all: e,
    clear: n,
    getAt: (f, c) => {
      const p = r.search({
        minX: f,
        minY: c,
        maxX: f,
        maxY: c
      }).map((v) => v.target).filter((v) => v.selector.type === $t.RECTANGLE || jf(v.selector, f, c));
      if (p.length > 0)
        return p.sort((v, _) => ys(v.selector) - ys(_.selector)), p[0];
    },
    getIntersecting: (f, c, d, p) => r.search({
      minX: f,
      minY: c,
      maxX: f + d,
      maxY: c + p
    }).map((v) => v.target),
    insert: i,
    remove: o,
    set: (f, c = !0) => {
      c && n();
      const d = f.map((p) => {
        const { minX: v, minY: _, maxX: m, maxY: y } = p.selector.geometry.bounds;
        return { minX: v, minY: _, maxX: m, maxY: y, target: p };
      });
      d.forEach((p) => t.set(p.target.annotation, p)), r.load(d);
    },
    size: () => r.all().length,
    update: (f, c) => {
      o(f), i(c);
    }
  };
}, Ec = (r) => {
  const t = Cf(), e = Tc(), n = mf(t, r.pointerSelectAction), i = _f(t), o = Mf();
  return t.observe(({ changes: h }) => {
    e.set(h.created.map((u) => u.target), !1), h.deleted.forEach((u) => e.remove(u.target)), h.updated.forEach(({ oldValue: u, newValue: l }) => e.update(u.target, l.target));
  }), {
    store: {
      ...t,
      getAt: (h, u) => {
        const l = e.getAt(h, u);
        return l ? t.getAnnotation(l.annotation) : void 0;
      },
      getIntersecting: (h, u, l, f) => e.getIntersecting(h, u, l, f).map((c) => t.getAnnotation(c.annotation))
    },
    selection: n,
    hover: i,
    viewport: o
  };
}, wc = (r) => {
  let t, e;
  if (r.nodeName === "CANVAS")
    t = r, e = t.getContext("2d", { willReadFrequently: !0 });
  else {
    const i = r;
    t = document.createElement("canvas"), t.width = i.width, t.height = i.height, e = t.getContext("2d", { willReadFrequently: !0 }), e.drawImage(i, 0, 0, i.width, i.height);
  }
  let n = 0;
  for (let i = 1; i < 10; i++)
    for (let o = 1; o < 10; o++) {
      const a = Math.round(o * t.width / 10), s = Math.round(i * t.height / 10), h = e.getImageData(a, s, 1, 1).data, u = (0.299 * h[0] + 0.587 * h[1] + 0.114 * h[2]) / 255;
      n += u;
    }
  return n / 81;
}, Sc = (r, t) => {
  const e = wc(r), n = e > 0.6 ? "dark" : "light";
  console.log(`[Annotorious] Image brightness: ${e.toFixed(1)}. Setting ${n} theme.`), t.setAttribute("data-theme", n);
}, Ac = (r) => ({
  ...r,
  pointerSelectAction: r.pointerSelectAction || Ga.EDIT
});
function Pc(r) {
  var t = this.constructor;
  return this.then(
    function(e) {
      return t.resolve(r()).then(function() {
        return e;
      });
    },
    function(e) {
      return t.resolve(r()).then(function() {
        return t.reject(e);
      });
    }
  );
}
function Oc(r) {
  var t = this;
  return new t(function(e, n) {
    if (!(r && typeof r.length < "u"))
      return n(
        new TypeError(
          typeof r + " " + r + " is not iterable(cannot read property Symbol(Symbol.iterator))"
        )
      );
    var i = Array.prototype.slice.call(r);
    if (i.length === 0)
      return e([]);
    var o = i.length;
    function a(h, u) {
      if (u && (typeof u == "object" || typeof u == "function")) {
        var l = u.then;
        if (typeof l == "function") {
          l.call(
            u,
            function(f) {
              a(h, f);
            },
            function(f) {
              i[h] = { status: "rejected", reason: f }, --o === 0 && e(i);
            }
          );
          return;
        }
      }
      i[h] = { status: "fulfilled", value: u }, --o === 0 && e(i);
    }
    for (var s = 0; s < i.length; s++)
      a(s, i[s]);
  });
}
function Nu(r, t) {
  this.name = "AggregateError", this.errors = r, this.message = t || "";
}
Nu.prototype = Error.prototype;
function Rc(r) {
  var t = this;
  return new t(function(e, n) {
    if (!(r && typeof r.length < "u"))
      return n(new TypeError("Promise.any accepts an array"));
    var i = Array.prototype.slice.call(r);
    if (i.length === 0)
      return n();
    for (var o = [], a = 0; a < i.length; a++)
      try {
        t.resolve(i[a]).then(e).catch(function(s) {
          o.push(s), o.length === i.length && n(
            new Nu(
              o,
              "All promises were rejected"
            )
          );
        });
      } catch (s) {
        n(s);
      }
  });
}
var Ic = setTimeout;
function Lu(r) {
  return !!(r && typeof r.length < "u");
}
function Cc() {
}
function Mc(r, t) {
  return function() {
    r.apply(t, arguments);
  };
}
function Pt(r) {
  if (!(this instanceof Pt))
    throw new TypeError("Promises must be constructed via new");
  if (typeof r != "function")
    throw new TypeError("not a function");
  this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], Gu(r, this);
}
function Uu(r, t) {
  for (; r._state === 3; )
    r = r._value;
  if (r._state === 0) {
    r._deferreds.push(t);
    return;
  }
  r._handled = !0, Pt._immediateFn(function() {
    var e = r._state === 1 ? t.onFulfilled : t.onRejected;
    if (e === null) {
      (r._state === 1 ? Ho : pn)(t.promise, r._value);
      return;
    }
    var n;
    try {
      n = e(r._value);
    } catch (i) {
      pn(t.promise, i);
      return;
    }
    Ho(t.promise, n);
  });
}
function Ho(r, t) {
  try {
    if (t === r)
      throw new TypeError("A promise cannot be resolved with itself.");
    if (t && (typeof t == "object" || typeof t == "function")) {
      var e = t.then;
      if (t instanceof Pt) {
        r._state = 3, r._value = t, Xo(r);
        return;
      } else if (typeof e == "function") {
        Gu(Mc(e, t), r);
        return;
      }
    }
    r._state = 1, r._value = t, Xo(r);
  } catch (n) {
    pn(r, n);
  }
}
function pn(r, t) {
  r._state = 2, r._value = t, Xo(r);
}
function Xo(r) {
  r._state === 2 && r._deferreds.length === 0 && Pt._immediateFn(function() {
    r._handled || Pt._unhandledRejectionFn(r._value);
  });
  for (var t = 0, e = r._deferreds.length; t < e; t++)
    Uu(r, r._deferreds[t]);
  r._deferreds = null;
}
function Dc(r, t, e) {
  this.onFulfilled = typeof r == "function" ? r : null, this.onRejected = typeof t == "function" ? t : null, this.promise = e;
}
function Gu(r, t) {
  var e = !1;
  try {
    r(
      function(n) {
        e || (e = !0, Ho(t, n));
      },
      function(n) {
        e || (e = !0, pn(t, n));
      }
    );
  } catch (n) {
    if (e)
      return;
    e = !0, pn(t, n);
  }
}
Pt.prototype.catch = function(r) {
  return this.then(null, r);
};
Pt.prototype.then = function(r, t) {
  var e = new this.constructor(Cc);
  return Uu(this, new Dc(r, t, e)), e;
};
Pt.prototype.finally = Pc;
Pt.all = function(r) {
  return new Pt(function(t, e) {
    if (!Lu(r))
      return e(new TypeError("Promise.all accepts an array"));
    var n = Array.prototype.slice.call(r);
    if (n.length === 0)
      return t([]);
    var i = n.length;
    function o(s, h) {
      try {
        if (h && (typeof h == "object" || typeof h == "function")) {
          var u = h.then;
          if (typeof u == "function") {
            u.call(
              h,
              function(l) {
                o(s, l);
              },
              e
            );
            return;
          }
        }
        n[s] = h, --i === 0 && t(n);
      } catch (l) {
        e(l);
      }
    }
    for (var a = 0; a < n.length; a++)
      o(a, n[a]);
  });
};
Pt.any = Rc;
Pt.allSettled = Oc;
Pt.resolve = function(r) {
  return r && typeof r == "object" && r.constructor === Pt ? r : new Pt(function(t) {
    t(r);
  });
};
Pt.reject = function(r) {
  return new Pt(function(t, e) {
    e(r);
  });
};
Pt.race = function(r) {
  return new Pt(function(t, e) {
    if (!Lu(r))
      return e(new TypeError("Promise.race accepts an array"));
    for (var n = 0, i = r.length; n < i; n++)
      Pt.resolve(r[n]).then(t, e);
  });
};
Pt._immediateFn = // @ts-ignore
typeof setImmediate == "function" && function(r) {
  setImmediate(r);
} || function(r) {
  Ic(r, 0);
};
Pt._unhandledRejectionFn = function(t) {
  typeof console < "u" && console && console.warn("Possible Unhandled Promise Rejection:", t);
};
var Wi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xa(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function Fc(r) {
  if (r.__esModule)
    return r;
  var t = r.default;
  if (typeof t == "function") {
    var e = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    e.prototype = t.prototype;
  } else
    e = {};
  return Object.defineProperty(e, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(e, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), e;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Is = Object.getOwnPropertySymbols, Bc = Object.prototype.hasOwnProperty, Nc = Object.prototype.propertyIsEnumerable;
function Lc(r) {
  if (r == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(r);
}
function Uc() {
  try {
    if (!Object.assign)
      return !1;
    var r = new String("abc");
    if (r[5] = "de", Object.getOwnPropertyNames(r)[0] === "5")
      return !1;
    for (var t = {}, e = 0; e < 10; e++)
      t["_" + String.fromCharCode(e)] = e;
    var n = Object.getOwnPropertyNames(t).map(function(o) {
      return t[o];
    });
    if (n.join("") !== "0123456789")
      return !1;
    var i = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(o) {
      i[o] = o;
    }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
var Gc = Uc() ? Object.assign : function(r, t) {
  for (var e, n = Lc(r), i, o = 1; o < arguments.length; o++) {
    e = Object(arguments[o]);
    for (var a in e)
      Bc.call(e, a) && (n[a] = e[a]);
    if (Is) {
      i = Is(e);
      for (var s = 0; s < i.length; s++)
        Nc.call(e, i[s]) && (n[i[s]] = e[i[s]]);
    }
  }
  return n;
};
const kc = /* @__PURE__ */ Xa(Gc);
/*!
 * @pixi/polyfill - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/polyfill is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
typeof globalThis > "u" && (typeof self < "u" ? self.globalThis = self : typeof global < "u" && (global.globalThis = global));
globalThis.Promise || (globalThis.Promise = Pt);
Object.assign || (Object.assign = kc);
var Hc = 16;
Date.now && Date.prototype.getTime || (Date.now = function() {
  return (/* @__PURE__ */ new Date()).getTime();
});
if (!(globalThis.performance && globalThis.performance.now)) {
  var Xc = Date.now();
  globalThis.performance || (globalThis.performance = {}), globalThis.performance.now = function() {
    return Date.now() - Xc;
  };
}
var $i = Date.now(), Cs = ["ms", "moz", "webkit", "o"];
for (var qi = 0; qi < Cs.length && !globalThis.requestAnimationFrame; ++qi) {
  var Ki = Cs[qi];
  globalThis.requestAnimationFrame = globalThis[Ki + "RequestAnimationFrame"], globalThis.cancelAnimationFrame = globalThis[Ki + "CancelAnimationFrame"] || globalThis[Ki + "CancelRequestAnimationFrame"];
}
globalThis.requestAnimationFrame || (globalThis.requestAnimationFrame = function(r) {
  if (typeof r != "function")
    throw new TypeError(r + "is not a function");
  var t = Date.now(), e = Hc + $i - t;
  return e < 0 && (e = 0), $i = t, globalThis.self.setTimeout(function() {
    $i = Date.now(), r(performance.now());
  }, e);
});
globalThis.cancelAnimationFrame || (globalThis.cancelAnimationFrame = function(r) {
  return clearTimeout(r);
});
Math.sign || (Math.sign = function(t) {
  return t = Number(t), t === 0 || isNaN(t) ? t : t > 0 ? 1 : -1;
});
Number.isInteger || (Number.isInteger = function(t) {
  return typeof t == "number" && isFinite(t) && Math.floor(t) === t;
});
globalThis.ArrayBuffer || (globalThis.ArrayBuffer = Array);
globalThis.Float32Array || (globalThis.Float32Array = Array);
globalThis.Uint32Array || (globalThis.Uint32Array = Array);
globalThis.Uint16Array || (globalThis.Uint16Array = Array);
globalThis.Uint8Array || (globalThis.Uint8Array = Array);
globalThis.Int32Array || (globalThis.Int32Array = Array);
/*!
 * @pixi/constants - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/constants is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var Ie;
(function(r) {
  r[r.WEBGL_LEGACY = 0] = "WEBGL_LEGACY", r[r.WEBGL = 1] = "WEBGL", r[r.WEBGL2 = 2] = "WEBGL2";
})(Ie || (Ie = {}));
var vn;
(function(r) {
  r[r.UNKNOWN = 0] = "UNKNOWN", r[r.WEBGL = 1] = "WEBGL", r[r.CANVAS = 2] = "CANVAS";
})(vn || (vn = {}));
var mi;
(function(r) {
  r[r.COLOR = 16384] = "COLOR", r[r.DEPTH = 256] = "DEPTH", r[r.STENCIL = 1024] = "STENCIL";
})(mi || (mi = {}));
var Y;
(function(r) {
  r[r.NORMAL = 0] = "NORMAL", r[r.ADD = 1] = "ADD", r[r.MULTIPLY = 2] = "MULTIPLY", r[r.SCREEN = 3] = "SCREEN", r[r.OVERLAY = 4] = "OVERLAY", r[r.DARKEN = 5] = "DARKEN", r[r.LIGHTEN = 6] = "LIGHTEN", r[r.COLOR_DODGE = 7] = "COLOR_DODGE", r[r.COLOR_BURN = 8] = "COLOR_BURN", r[r.HARD_LIGHT = 9] = "HARD_LIGHT", r[r.SOFT_LIGHT = 10] = "SOFT_LIGHT", r[r.DIFFERENCE = 11] = "DIFFERENCE", r[r.EXCLUSION = 12] = "EXCLUSION", r[r.HUE = 13] = "HUE", r[r.SATURATION = 14] = "SATURATION", r[r.COLOR = 15] = "COLOR", r[r.LUMINOSITY = 16] = "LUMINOSITY", r[r.NORMAL_NPM = 17] = "NORMAL_NPM", r[r.ADD_NPM = 18] = "ADD_NPM", r[r.SCREEN_NPM = 19] = "SCREEN_NPM", r[r.NONE = 20] = "NONE", r[r.SRC_OVER = 0] = "SRC_OVER", r[r.SRC_IN = 21] = "SRC_IN", r[r.SRC_OUT = 22] = "SRC_OUT", r[r.SRC_ATOP = 23] = "SRC_ATOP", r[r.DST_OVER = 24] = "DST_OVER", r[r.DST_IN = 25] = "DST_IN", r[r.DST_OUT = 26] = "DST_OUT", r[r.DST_ATOP = 27] = "DST_ATOP", r[r.ERASE = 26] = "ERASE", r[r.SUBTRACT = 28] = "SUBTRACT", r[r.XOR = 29] = "XOR";
})(Y || (Y = {}));
var le;
(function(r) {
  r[r.POINTS = 0] = "POINTS", r[r.LINES = 1] = "LINES", r[r.LINE_LOOP = 2] = "LINE_LOOP", r[r.LINE_STRIP = 3] = "LINE_STRIP", r[r.TRIANGLES = 4] = "TRIANGLES", r[r.TRIANGLE_STRIP = 5] = "TRIANGLE_STRIP", r[r.TRIANGLE_FAN = 6] = "TRIANGLE_FAN";
})(le || (le = {}));
var L;
(function(r) {
  r[r.RGBA = 6408] = "RGBA", r[r.RGB = 6407] = "RGB", r[r.RG = 33319] = "RG", r[r.RED = 6403] = "RED", r[r.RGBA_INTEGER = 36249] = "RGBA_INTEGER", r[r.RGB_INTEGER = 36248] = "RGB_INTEGER", r[r.RG_INTEGER = 33320] = "RG_INTEGER", r[r.RED_INTEGER = 36244] = "RED_INTEGER", r[r.ALPHA = 6406] = "ALPHA", r[r.LUMINANCE = 6409] = "LUMINANCE", r[r.LUMINANCE_ALPHA = 6410] = "LUMINANCE_ALPHA", r[r.DEPTH_COMPONENT = 6402] = "DEPTH_COMPONENT", r[r.DEPTH_STENCIL = 34041] = "DEPTH_STENCIL";
})(L || (L = {}));
var or;
(function(r) {
  r[r.TEXTURE_2D = 3553] = "TEXTURE_2D", r[r.TEXTURE_CUBE_MAP = 34067] = "TEXTURE_CUBE_MAP", r[r.TEXTURE_2D_ARRAY = 35866] = "TEXTURE_2D_ARRAY", r[r.TEXTURE_CUBE_MAP_POSITIVE_X = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X", r[r.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X", r[r.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y", r[r.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y", r[r.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z", r[r.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
})(or || (or = {}));
var X;
(function(r) {
  r[r.UNSIGNED_BYTE = 5121] = "UNSIGNED_BYTE", r[r.UNSIGNED_SHORT = 5123] = "UNSIGNED_SHORT", r[r.UNSIGNED_SHORT_5_6_5 = 33635] = "UNSIGNED_SHORT_5_6_5", r[r.UNSIGNED_SHORT_4_4_4_4 = 32819] = "UNSIGNED_SHORT_4_4_4_4", r[r.UNSIGNED_SHORT_5_5_5_1 = 32820] = "UNSIGNED_SHORT_5_5_5_1", r[r.UNSIGNED_INT = 5125] = "UNSIGNED_INT", r[r.UNSIGNED_INT_10F_11F_11F_REV = 35899] = "UNSIGNED_INT_10F_11F_11F_REV", r[r.UNSIGNED_INT_2_10_10_10_REV = 33640] = "UNSIGNED_INT_2_10_10_10_REV", r[r.UNSIGNED_INT_24_8 = 34042] = "UNSIGNED_INT_24_8", r[r.UNSIGNED_INT_5_9_9_9_REV = 35902] = "UNSIGNED_INT_5_9_9_9_REV", r[r.BYTE = 5120] = "BYTE", r[r.SHORT = 5122] = "SHORT", r[r.INT = 5124] = "INT", r[r.FLOAT = 5126] = "FLOAT", r[r.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV", r[r.HALF_FLOAT = 36193] = "HALF_FLOAT";
})(X || (X = {}));
var yi;
(function(r) {
  r[r.FLOAT = 0] = "FLOAT", r[r.INT = 1] = "INT", r[r.UINT = 2] = "UINT";
})(yi || (yi = {}));
var ye;
(function(r) {
  r[r.NEAREST = 0] = "NEAREST", r[r.LINEAR = 1] = "LINEAR";
})(ye || (ye = {}));
var be;
(function(r) {
  r[r.CLAMP = 33071] = "CLAMP", r[r.REPEAT = 10497] = "REPEAT", r[r.MIRRORED_REPEAT = 33648] = "MIRRORED_REPEAT";
})(be || (be = {}));
var de;
(function(r) {
  r[r.OFF = 0] = "OFF", r[r.POW2 = 1] = "POW2", r[r.ON = 2] = "ON", r[r.ON_MANUAL = 3] = "ON_MANUAL";
})(de || (de = {}));
var pe;
(function(r) {
  r[r.NPM = 0] = "NPM", r[r.UNPACK = 1] = "UNPACK", r[r.PMA = 2] = "PMA", r[r.NO_PREMULTIPLIED_ALPHA = 0] = "NO_PREMULTIPLIED_ALPHA", r[r.PREMULTIPLY_ON_UPLOAD = 1] = "PREMULTIPLY_ON_UPLOAD", r[r.PREMULTIPLY_ALPHA = 2] = "PREMULTIPLY_ALPHA", r[r.PREMULTIPLIED_ALPHA = 2] = "PREMULTIPLIED_ALPHA";
})(pe || (pe = {}));
var ue;
(function(r) {
  r[r.NO = 0] = "NO", r[r.YES = 1] = "YES", r[r.AUTO = 2] = "AUTO", r[r.BLEND = 0] = "BLEND", r[r.CLEAR = 1] = "CLEAR", r[r.BLIT = 2] = "BLIT";
})(ue || (ue = {}));
var gi;
(function(r) {
  r[r.AUTO = 0] = "AUTO", r[r.MANUAL = 1] = "MANUAL";
})(gi || (gi = {}));
var qt;
(function(r) {
  r.LOW = "lowp", r.MEDIUM = "mediump", r.HIGH = "highp";
})(qt || (qt = {}));
var It;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.SCISSOR = 1] = "SCISSOR", r[r.STENCIL = 2] = "STENCIL", r[r.SPRITE = 3] = "SPRITE", r[r.COLOR = 4] = "COLOR";
})(It || (It = {}));
var Ms;
(function(r) {
  r[r.RED = 1] = "RED", r[r.GREEN = 2] = "GREEN", r[r.BLUE = 4] = "BLUE", r[r.ALPHA = 8] = "ALPHA";
})(Ms || (Ms = {}));
var wt;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.LOW = 2] = "LOW", r[r.MEDIUM = 4] = "MEDIUM", r[r.HIGH = 8] = "HIGH";
})(wt || (wt = {}));
var xe;
(function(r) {
  r[r.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER", r[r.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", r[r.UNIFORM_BUFFER = 35345] = "UNIFORM_BUFFER";
})(xe || (xe = {}));
/*!
 * @pixi/settings - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/settings is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var jc = {
  /**
   * Creates a canvas element of the given size.
   * This canvas is created using the browser's native canvas element.
   * @param width - width of the canvas
   * @param height - height of the canvas
   */
  createCanvas: function(r, t) {
    var e = document.createElement("canvas");
    return e.width = r, e.height = t, e;
  },
  getWebGLRenderingContext: function() {
    return WebGLRenderingContext;
  },
  getNavigator: function() {
    return navigator;
  },
  getBaseUrl: function() {
    var r;
    return (r = document.baseURI) !== null && r !== void 0 ? r : window.location.href;
  },
  fetch: function(r, t) {
    return fetch(r, t);
  }
}, Zi = /iPhone/i, Ds = /iPod/i, Fs = /iPad/i, Bs = /\biOS-universal(?:.+)Mac\b/i, Ji = /\bAndroid(?:.+)Mobile\b/i, Ns = /Android/i, gr = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i, Bn = /Silk/i, we = /Windows Phone/i, Ls = /\bWindows(?:.+)ARM\b/i, Us = /BlackBerry/i, Gs = /BB10/i, ks = /Opera Mini/i, Hs = /\b(CriOS|Chrome)(?:.+)Mobile/i, Xs = /Mobile(?:.+)Firefox\b/i, js = function(r) {
  return typeof r < "u" && r.platform === "MacIntel" && typeof r.maxTouchPoints == "number" && r.maxTouchPoints > 1 && typeof MSStream > "u";
};
function Yc(r) {
  return function(t) {
    return t.test(r);
  };
}
function Vc(r) {
  var t = {
    userAgent: "",
    platform: "",
    maxTouchPoints: 0
  };
  !r && typeof navigator < "u" ? t = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints || 0
  } : typeof r == "string" ? t.userAgent = r : r && r.userAgent && (t = {
    userAgent: r.userAgent,
    platform: r.platform,
    maxTouchPoints: r.maxTouchPoints || 0
  });
  var e = t.userAgent, n = e.split("[FBAN");
  typeof n[1] < "u" && (e = n[0]), n = e.split("Twitter"), typeof n[1] < "u" && (e = n[0]);
  var i = Yc(e), o = {
    apple: {
      phone: i(Zi) && !i(we),
      ipod: i(Ds),
      tablet: !i(Zi) && (i(Fs) || js(t)) && !i(we),
      universal: i(Bs),
      device: (i(Zi) || i(Ds) || i(Fs) || i(Bs) || js(t)) && !i(we)
    },
    amazon: {
      phone: i(gr),
      tablet: !i(gr) && i(Bn),
      device: i(gr) || i(Bn)
    },
    android: {
      phone: !i(we) && i(gr) || !i(we) && i(Ji),
      tablet: !i(we) && !i(gr) && !i(Ji) && (i(Bn) || i(Ns)),
      device: !i(we) && (i(gr) || i(Bn) || i(Ji) || i(Ns)) || i(/\bokhttp\b/i)
    },
    windows: {
      phone: i(we),
      tablet: i(Ls),
      device: i(we) || i(Ls)
    },
    other: {
      blackberry: i(Us),
      blackberry10: i(Gs),
      opera: i(ks),
      firefox: i(Xs),
      chrome: i(Hs),
      device: i(Us) || i(Gs) || i(ks) || i(Xs) || i(Hs)
    },
    any: !1,
    phone: !1,
    tablet: !1
  };
  return o.any = o.apple.device || o.android.device || o.windows.device || o.other.device, o.phone = o.apple.phone || o.android.phone || o.windows.phone, o.tablet = o.apple.tablet || o.android.tablet || o.windows.tablet, o;
}
var ge = Vc(globalThis.navigator);
function zc() {
  return !ge.apple.device;
}
function Wc(r) {
  var t = !0;
  if (ge.tablet || ge.phone) {
    if (ge.apple.device) {
      var e = navigator.userAgent.match(/OS (\d+)_(\d+)?/);
      if (e) {
        var n = parseInt(e[1], 10);
        n < 11 && (t = !1);
      }
    }
    if (ge.android.device) {
      var e = navigator.userAgent.match(/Android\s([0-9.]*)/);
      if (e) {
        var n = parseInt(e[1], 10);
        n < 7 && (t = !1);
      }
    }
  }
  return t ? r : 4;
}
var G = {
  /**
   * This adapter is used to call methods that are platform dependent.
   * For example `document.createElement` only runs on the web but fails in node environments.
   * This allows us to support more platforms by abstracting away specific implementations per platform.
   *
   * By default the adapter is set to work in the browser. However you can create your own
   * by implementing the `IAdapter` interface. See `IAdapter` for more information.
   * @name ADAPTER
   * @memberof PIXI.settings
   * @type {PIXI.IAdapter}
   * @default PIXI.BrowserAdapter
   */
  ADAPTER: jc,
  /**
   * If set to true WebGL will attempt make textures mimpaped by default.
   * Mipmapping will only succeed if the base texture uploaded has power of two dimensions.
   * @static
   * @name MIPMAP_TEXTURES
   * @memberof PIXI.settings
   * @type {PIXI.MIPMAP_MODES}
   * @default PIXI.MIPMAP_MODES.POW2
   */
  MIPMAP_TEXTURES: de.POW2,
  /**
   * Default anisotropic filtering level of textures.
   * Usually from 0 to 16
   * @static
   * @name ANISOTROPIC_LEVEL
   * @memberof PIXI.settings
   * @type {number}
   * @default 0
   */
  ANISOTROPIC_LEVEL: 0,
  /**
   * Default resolution / device pixel ratio of the renderer.
   * @static
   * @name RESOLUTION
   * @memberof PIXI.settings
   * @type {number}
   * @default 1
   */
  RESOLUTION: 1,
  /**
   * Default filter resolution.
   * @static
   * @name FILTER_RESOLUTION
   * @memberof PIXI.settings
   * @type {number}
   * @default 1
   */
  FILTER_RESOLUTION: 1,
  /**
   * Default filter samples.
   * @static
   * @name FILTER_MULTISAMPLE
   * @memberof PIXI.settings
   * @type {PIXI.MSAA_QUALITY}
   * @default PIXI.MSAA_QUALITY.NONE
   */
  FILTER_MULTISAMPLE: wt.NONE,
  /**
   * The maximum textures that this device supports.
   * @static
   * @name SPRITE_MAX_TEXTURES
   * @memberof PIXI.settings
   * @type {number}
   * @default 32
   */
  SPRITE_MAX_TEXTURES: Wc(32),
  // TODO: maybe change to SPRITE.BATCH_SIZE: 2000
  // TODO: maybe add PARTICLE.BATCH_SIZE: 15000
  /**
   * The default sprite batch size.
   *
   * The default aims to balance desktop and mobile devices.
   * @static
   * @name SPRITE_BATCH_SIZE
   * @memberof PIXI.settings
   * @type {number}
   * @default 4096
   */
  SPRITE_BATCH_SIZE: 4096,
  /**
   * The default render options if none are supplied to {@link PIXI.Renderer}
   * or {@link PIXI.CanvasRenderer}.
   * @static
   * @name RENDER_OPTIONS
   * @memberof PIXI.settings
   * @type {object}
   * @property {boolean} [antialias=false] - {@link PIXI.IRendererOptions.antialias}
   * @property {boolean} [autoDensity=false] - {@link PIXI.IRendererOptions.autoDensity}
   * @property {number} [backgroundAlpha=1] - {@link PIXI.IRendererOptions.backgroundAlpha}
   * @property {number} [backgroundColor=0x000000] - {@link PIXI.IRendererOptions.backgroundColor}
   * @property {boolean} [clearBeforeRender=true] - {@link PIXI.IRendererOptions.clearBeforeRender}
   * @property {number} [height=600] - {@link PIXI.IRendererOptions.height}
   * @property {boolean} [preserveDrawingBuffer=false] - {@link PIXI.IRendererOptions.preserveDrawingBuffer}
   * @property {boolean|'notMultiplied'} [useContextAlpha=true] - {@link PIXI.IRendererOptions.useContextAlpha}
   * @property {HTMLCanvasElement} [view=null] - {@link PIXI.IRendererOptions.view}
   * @property {number} [width=800] - {@link PIXI.IRendererOptions.width}
   */
  RENDER_OPTIONS: {
    view: null,
    width: 800,
    height: 600,
    autoDensity: !1,
    backgroundColor: 0,
    backgroundAlpha: 1,
    useContextAlpha: !0,
    clearBeforeRender: !0,
    antialias: !1,
    preserveDrawingBuffer: !1
  },
  /**
   * Default Garbage Collection mode.
   * @static
   * @name GC_MODE
   * @memberof PIXI.settings
   * @type {PIXI.GC_MODES}
   * @default PIXI.GC_MODES.AUTO
   */
  GC_MODE: gi.AUTO,
  /**
   * Default Garbage Collection max idle.
   * @static
   * @name GC_MAX_IDLE
   * @memberof PIXI.settings
   * @type {number}
   * @default 3600
   */
  GC_MAX_IDLE: 60 * 60,
  /**
   * Default Garbage Collection maximum check count.
   * @static
   * @name GC_MAX_CHECK_COUNT
   * @memberof PIXI.settings
   * @type {number}
   * @default 600
   */
  GC_MAX_CHECK_COUNT: 60 * 10,
  /**
   * Default wrap modes that are supported by pixi.
   * @static
   * @name WRAP_MODE
   * @memberof PIXI.settings
   * @type {PIXI.WRAP_MODES}
   * @default PIXI.WRAP_MODES.CLAMP
   */
  WRAP_MODE: be.CLAMP,
  /**
   * Default scale mode for textures.
   * @static
   * @name SCALE_MODE
   * @memberof PIXI.settings
   * @type {PIXI.SCALE_MODES}
   * @default PIXI.SCALE_MODES.LINEAR
   */
  SCALE_MODE: ye.LINEAR,
  /**
   * Default specify float precision in vertex shader.
   * @static
   * @name PRECISION_VERTEX
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @default PIXI.PRECISION.HIGH
   */
  PRECISION_VERTEX: qt.HIGH,
  /**
   * Default specify float precision in fragment shader.
   * iOS is best set at highp due to https://github.com/pixijs/pixi.js/issues/3742
   * @static
   * @name PRECISION_FRAGMENT
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @default PIXI.PRECISION.MEDIUM
   */
  PRECISION_FRAGMENT: ge.apple.device ? qt.HIGH : qt.MEDIUM,
  /**
   * Can we upload the same buffer in a single frame?
   * @static
   * @name CAN_UPLOAD_SAME_BUFFER
   * @memberof PIXI.settings
   * @type {boolean}
   */
  CAN_UPLOAD_SAME_BUFFER: zc(),
  /**
   * Enables bitmap creation before image load. This feature is experimental.
   * @static
   * @name CREATE_IMAGE_BITMAP
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */
  CREATE_IMAGE_BITMAP: !1,
  /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * @static
   * @constant
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */
  ROUND_PIXELS: !1
}, ku = { exports: {} };
(function(r) {
  var t = Object.prototype.hasOwnProperty, e = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (e = !1));
  function i(h, u, l) {
    this.fn = h, this.context = u, this.once = l || !1;
  }
  function o(h, u, l, f, c) {
    if (typeof l != "function")
      throw new TypeError("The listener must be a function");
    var d = new i(l, f || h, c), p = e ? e + u : u;
    return h._events[p] ? h._events[p].fn ? h._events[p] = [h._events[p], d] : h._events[p].push(d) : (h._events[p] = d, h._eventsCount++), h;
  }
  function a(h, u) {
    --h._eventsCount === 0 ? h._events = new n() : delete h._events[u];
  }
  function s() {
    this._events = new n(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var u = [], l, f;
    if (this._eventsCount === 0)
      return u;
    for (f in l = this._events)
      t.call(l, f) && u.push(e ? f.slice(1) : f);
    return Object.getOwnPropertySymbols ? u.concat(Object.getOwnPropertySymbols(l)) : u;
  }, s.prototype.listeners = function(u) {
    var l = e ? e + u : u, f = this._events[l];
    if (!f)
      return [];
    if (f.fn)
      return [f.fn];
    for (var c = 0, d = f.length, p = new Array(d); c < d; c++)
      p[c] = f[c].fn;
    return p;
  }, s.prototype.listenerCount = function(u) {
    var l = e ? e + u : u, f = this._events[l];
    return f ? f.fn ? 1 : f.length : 0;
  }, s.prototype.emit = function(u, l, f, c, d, p) {
    var v = e ? e + u : u;
    if (!this._events[v])
      return !1;
    var _ = this._events[v], m = arguments.length, y, g;
    if (_.fn) {
      switch (_.once && this.removeListener(u, _.fn, void 0, !0), m) {
        case 1:
          return _.fn.call(_.context), !0;
        case 2:
          return _.fn.call(_.context, l), !0;
        case 3:
          return _.fn.call(_.context, l, f), !0;
        case 4:
          return _.fn.call(_.context, l, f, c), !0;
        case 5:
          return _.fn.call(_.context, l, f, c, d), !0;
        case 6:
          return _.fn.call(_.context, l, f, c, d, p), !0;
      }
      for (g = 1, y = new Array(m - 1); g < m; g++)
        y[g - 1] = arguments[g];
      _.fn.apply(_.context, y);
    } else {
      var x = _.length, T;
      for (g = 0; g < x; g++)
        switch (_[g].once && this.removeListener(u, _[g].fn, void 0, !0), m) {
          case 1:
            _[g].fn.call(_[g].context);
            break;
          case 2:
            _[g].fn.call(_[g].context, l);
            break;
          case 3:
            _[g].fn.call(_[g].context, l, f);
            break;
          case 4:
            _[g].fn.call(_[g].context, l, f, c);
            break;
          default:
            if (!y)
              for (T = 1, y = new Array(m - 1); T < m; T++)
                y[T - 1] = arguments[T];
            _[g].fn.apply(_[g].context, y);
        }
    }
    return !0;
  }, s.prototype.on = function(u, l, f) {
    return o(this, u, l, f, !1);
  }, s.prototype.once = function(u, l, f) {
    return o(this, u, l, f, !0);
  }, s.prototype.removeListener = function(u, l, f, c) {
    var d = e ? e + u : u;
    if (!this._events[d])
      return this;
    if (!l)
      return a(this, d), this;
    var p = this._events[d];
    if (p.fn)
      p.fn === l && (!c || p.once) && (!f || p.context === f) && a(this, d);
    else {
      for (var v = 0, _ = [], m = p.length; v < m; v++)
        (p[v].fn !== l || c && !p[v].once || f && p[v].context !== f) && _.push(p[v]);
      _.length ? this._events[d] = _.length === 1 ? _[0] : _ : a(this, d);
    }
    return this;
  }, s.prototype.removeAllListeners = function(u) {
    var l;
    return u ? (l = e ? e + u : u, this._events[l] && a(this, l)) : (this._events = new n(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = e, s.EventEmitter = s, r.exports = s;
})(ku);
var $c = ku.exports;
const Sn = /* @__PURE__ */ Xa($c);
var ja = { exports: {} };
ja.exports = Ni;
ja.exports.default = Ni;
function Ni(r, t, e) {
  e = e || 2;
  var n = t && t.length, i = n ? t[0] * e : r.length, o = Hu(r, 0, i, e, !0), a = [];
  if (!o || o.next === o.prev)
    return a;
  var s, h, u, l, f, c, d;
  if (n && (o = Qc(r, t, o, e)), r.length > 80 * e) {
    s = u = r[0], h = l = r[1];
    for (var p = e; p < i; p += e)
      f = r[p], c = r[p + 1], f < s && (s = f), c < h && (h = c), f > u && (u = f), c > l && (l = c);
    d = Math.max(u - s, l - h), d = d !== 0 ? 32767 / d : 0;
  }
  return _n(o, a, e, s, h, d, 0), a;
}
function Hu(r, t, e, n, i) {
  var o, a;
  if (i === Vo(r, t, e, n) > 0)
    for (o = t; o < e; o += n)
      a = Ys(o, r[o], r[o + 1], a);
  else
    for (o = e - n; o >= t; o -= n)
      a = Ys(o, r[o], r[o + 1], a);
  return a && Li(a, a.next) && (yn(a), a = a.next), a;
}
function ur(r, t) {
  if (!r)
    return r;
  t || (t = r);
  var e = r, n;
  do
    if (n = !1, !e.steiner && (Li(e, e.next) || At(e.prev, e, e.next) === 0)) {
      if (yn(e), e = t = e.prev, e === e.next)
        break;
      n = !0;
    } else
      e = e.next;
  while (n || e !== t);
  return t;
}
function _n(r, t, e, n, i, o, a) {
  if (r) {
    !a && o && id(r, n, i, o);
    for (var s = r, h, u; r.prev !== r.next; ) {
      if (h = r.prev, u = r.next, o ? Kc(r, n, i, o) : qc(r)) {
        t.push(h.i / e | 0), t.push(r.i / e | 0), t.push(u.i / e | 0), yn(r), r = u.next, s = u.next;
        continue;
      }
      if (r = u, r === s) {
        a ? a === 1 ? (r = Zc(ur(r), t, e), _n(r, t, e, n, i, o, 2)) : a === 2 && Jc(r, t, e, n, i, o) : _n(ur(r), t, e, n, i, o, 1);
        break;
      }
    }
  }
}
function qc(r) {
  var t = r.prev, e = r, n = r.next;
  if (At(t, e, n) >= 0)
    return !1;
  for (var i = t.x, o = e.x, a = n.x, s = t.y, h = e.y, u = n.y, l = i < o ? i < a ? i : a : o < a ? o : a, f = s < h ? s < u ? s : u : h < u ? h : u, c = i > o ? i > a ? i : a : o > a ? o : a, d = s > h ? s > u ? s : u : h > u ? h : u, p = n.next; p !== t; ) {
    if (p.x >= l && p.x <= c && p.y >= f && p.y <= d && Or(i, s, o, h, a, u, p.x, p.y) && At(p.prev, p, p.next) >= 0)
      return !1;
    p = p.next;
  }
  return !0;
}
function Kc(r, t, e, n) {
  var i = r.prev, o = r, a = r.next;
  if (At(i, o, a) >= 0)
    return !1;
  for (var s = i.x, h = o.x, u = a.x, l = i.y, f = o.y, c = a.y, d = s < h ? s < u ? s : u : h < u ? h : u, p = l < f ? l < c ? l : c : f < c ? f : c, v = s > h ? s > u ? s : u : h > u ? h : u, _ = l > f ? l > c ? l : c : f > c ? f : c, m = jo(d, p, t, e, n), y = jo(v, _, t, e, n), g = r.prevZ, x = r.nextZ; g && g.z >= m && x && x.z <= y; ) {
    if (g.x >= d && g.x <= v && g.y >= p && g.y <= _ && g !== i && g !== a && Or(s, l, h, f, u, c, g.x, g.y) && At(g.prev, g, g.next) >= 0 || (g = g.prevZ, x.x >= d && x.x <= v && x.y >= p && x.y <= _ && x !== i && x !== a && Or(s, l, h, f, u, c, x.x, x.y) && At(x.prev, x, x.next) >= 0))
      return !1;
    x = x.nextZ;
  }
  for (; g && g.z >= m; ) {
    if (g.x >= d && g.x <= v && g.y >= p && g.y <= _ && g !== i && g !== a && Or(s, l, h, f, u, c, g.x, g.y) && At(g.prev, g, g.next) >= 0)
      return !1;
    g = g.prevZ;
  }
  for (; x && x.z <= y; ) {
    if (x.x >= d && x.x <= v && x.y >= p && x.y <= _ && x !== i && x !== a && Or(s, l, h, f, u, c, x.x, x.y) && At(x.prev, x, x.next) >= 0)
      return !1;
    x = x.nextZ;
  }
  return !0;
}
function Zc(r, t, e) {
  var n = r;
  do {
    var i = n.prev, o = n.next.next;
    !Li(i, o) && Xu(i, n, n.next, o) && mn(i, o) && mn(o, i) && (t.push(i.i / e | 0), t.push(n.i / e | 0), t.push(o.i / e | 0), yn(n), yn(n.next), n = r = o), n = n.next;
  } while (n !== r);
  return ur(n);
}
function Jc(r, t, e, n, i, o) {
  var a = r;
  do {
    for (var s = a.next.next; s !== a.prev; ) {
      if (a.i !== s.i && sd(a, s)) {
        var h = ju(a, s);
        a = ur(a, a.next), h = ur(h, h.next), _n(a, t, e, n, i, o, 0), _n(h, t, e, n, i, o, 0);
        return;
      }
      s = s.next;
    }
    a = a.next;
  } while (a !== r);
}
function Qc(r, t, e, n) {
  var i = [], o, a, s, h, u;
  for (o = 0, a = t.length; o < a; o++)
    s = t[o] * n, h = o < a - 1 ? t[o + 1] * n : r.length, u = Hu(r, s, h, n, !1), u === u.next && (u.steiner = !0), i.push(ad(u));
  for (i.sort(td), o = 0; o < i.length; o++)
    e = ed(i[o], e);
  return e;
}
function td(r, t) {
  return r.x - t.x;
}
function ed(r, t) {
  var e = rd(r, t);
  if (!e)
    return t;
  var n = ju(e, r);
  return ur(n, n.next), ur(e, e.next);
}
function rd(r, t) {
  var e = t, n = r.x, i = r.y, o = -1 / 0, a;
  do {
    if (i <= e.y && i >= e.next.y && e.next.y !== e.y) {
      var s = e.x + (i - e.y) * (e.next.x - e.x) / (e.next.y - e.y);
      if (s <= n && s > o && (o = s, a = e.x < e.next.x ? e : e.next, s === n))
        return a;
    }
    e = e.next;
  } while (e !== t);
  if (!a)
    return null;
  var h = a, u = a.x, l = a.y, f = 1 / 0, c;
  e = a;
  do
    n >= e.x && e.x >= u && n !== e.x && Or(i < l ? n : o, i, u, l, i < l ? o : n, i, e.x, e.y) && (c = Math.abs(i - e.y) / (n - e.x), mn(e, r) && (c < f || c === f && (e.x > a.x || e.x === a.x && nd(a, e))) && (a = e, f = c)), e = e.next;
  while (e !== h);
  return a;
}
function nd(r, t) {
  return At(r.prev, r, t.prev) < 0 && At(t.next, r, r.next) < 0;
}
function id(r, t, e, n) {
  var i = r;
  do
    i.z === 0 && (i.z = jo(i.x, i.y, t, e, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
  while (i !== r);
  i.prevZ.nextZ = null, i.prevZ = null, od(i);
}
function od(r) {
  var t, e, n, i, o, a, s, h, u = 1;
  do {
    for (e = r, r = null, o = null, a = 0; e; ) {
      for (a++, n = e, s = 0, t = 0; t < u && (s++, n = n.nextZ, !!n); t++)
        ;
      for (h = u; s > 0 || h > 0 && n; )
        s !== 0 && (h === 0 || !n || e.z <= n.z) ? (i = e, e = e.nextZ, s--) : (i = n, n = n.nextZ, h--), o ? o.nextZ = i : r = i, i.prevZ = o, o = i;
      e = n;
    }
    o.nextZ = null, u *= 2;
  } while (a > 1);
  return r;
}
function jo(r, t, e, n, i) {
  return r = (r - e) * i | 0, t = (t - n) * i | 0, r = (r | r << 8) & 16711935, r = (r | r << 4) & 252645135, r = (r | r << 2) & 858993459, r = (r | r << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, r | t << 1;
}
function ad(r) {
  var t = r, e = r;
  do
    (t.x < e.x || t.x === e.x && t.y < e.y) && (e = t), t = t.next;
  while (t !== r);
  return e;
}
function Or(r, t, e, n, i, o, a, s) {
  return (i - a) * (t - s) >= (r - a) * (o - s) && (r - a) * (n - s) >= (e - a) * (t - s) && (e - a) * (o - s) >= (i - a) * (n - s);
}
function sd(r, t) {
  return r.next.i !== t.i && r.prev.i !== t.i && !hd(r, t) && // dones't intersect other edges
  (mn(r, t) && mn(t, r) && ud(r, t) && // locally visible
  (At(r.prev, r, t.prev) || At(r, t.prev, t)) || // does not create opposite-facing sectors
  Li(r, t) && At(r.prev, r, r.next) > 0 && At(t.prev, t, t.next) > 0);
}
function At(r, t, e) {
  return (t.y - r.y) * (e.x - t.x) - (t.x - r.x) * (e.y - t.y);
}
function Li(r, t) {
  return r.x === t.x && r.y === t.y;
}
function Xu(r, t, e, n) {
  var i = Ln(At(r, t, e)), o = Ln(At(r, t, n)), a = Ln(At(e, n, r)), s = Ln(At(e, n, t));
  return !!(i !== o && a !== s || i === 0 && Nn(r, e, t) || o === 0 && Nn(r, n, t) || a === 0 && Nn(e, r, n) || s === 0 && Nn(e, t, n));
}
function Nn(r, t, e) {
  return t.x <= Math.max(r.x, e.x) && t.x >= Math.min(r.x, e.x) && t.y <= Math.max(r.y, e.y) && t.y >= Math.min(r.y, e.y);
}
function Ln(r) {
  return r > 0 ? 1 : r < 0 ? -1 : 0;
}
function hd(r, t) {
  var e = r;
  do {
    if (e.i !== r.i && e.next.i !== r.i && e.i !== t.i && e.next.i !== t.i && Xu(e, e.next, r, t))
      return !0;
    e = e.next;
  } while (e !== r);
  return !1;
}
function mn(r, t) {
  return At(r.prev, r, r.next) < 0 ? At(r, t, r.next) >= 0 && At(r, r.prev, t) >= 0 : At(r, t, r.prev) < 0 || At(r, r.next, t) < 0;
}
function ud(r, t) {
  var e = r, n = !1, i = (r.x + t.x) / 2, o = (r.y + t.y) / 2;
  do
    e.y > o != e.next.y > o && e.next.y !== e.y && i < (e.next.x - e.x) * (o - e.y) / (e.next.y - e.y) + e.x && (n = !n), e = e.next;
  while (e !== r);
  return n;
}
function ju(r, t) {
  var e = new Yo(r.i, r.x, r.y), n = new Yo(t.i, t.x, t.y), i = r.next, o = t.prev;
  return r.next = t, t.prev = r, e.next = i, i.prev = e, n.next = e, e.prev = n, o.next = n, n.prev = o, n;
}
function Ys(r, t, e, n) {
  var i = new Yo(r, t, e);
  return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
}
function yn(r) {
  r.next.prev = r.prev, r.prev.next = r.next, r.prevZ && (r.prevZ.nextZ = r.nextZ), r.nextZ && (r.nextZ.prevZ = r.prevZ);
}
function Yo(r, t, e) {
  this.i = r, this.x = t, this.y = e, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
Ni.deviation = function(r, t, e, n) {
  var i = t && t.length, o = i ? t[0] * e : r.length, a = Math.abs(Vo(r, 0, o, e));
  if (i)
    for (var s = 0, h = t.length; s < h; s++) {
      var u = t[s] * e, l = s < h - 1 ? t[s + 1] * e : r.length;
      a -= Math.abs(Vo(r, u, l, e));
    }
  var f = 0;
  for (s = 0; s < n.length; s += 3) {
    var c = n[s] * e, d = n[s + 1] * e, p = n[s + 2] * e;
    f += Math.abs(
      (r[c] - r[p]) * (r[d + 1] - r[c + 1]) - (r[c] - r[d]) * (r[p + 1] - r[c + 1])
    );
  }
  return a === 0 && f === 0 ? 0 : Math.abs((f - a) / a);
};
function Vo(r, t, e, n) {
  for (var i = 0, o = t, a = e - n; o < e; o += n)
    i += (r[a] - r[o]) * (r[o + 1] + r[a + 1]), a = o;
  return i;
}
Ni.flatten = function(r) {
  for (var t = r[0][0].length, e = { vertices: [], holes: [], dimensions: t }, n = 0, i = 0; i < r.length; i++) {
    for (var o = 0; o < r[i].length; o++)
      for (var a = 0; a < t; a++)
        e.vertices.push(r[i][o][a]);
    i > 0 && (n += r[i - 1].length, e.holes.push(n));
  }
  return e;
};
var ld = ja.exports;
const Yu = /* @__PURE__ */ Xa(ld);
var bi = { exports: {} };
/*! https://mths.be/punycode v1.4.1 by @mathias */
bi.exports;
(function(r, t) {
  (function(e) {
    var n = t && !t.nodeType && t, i = r && !r.nodeType && r, o = typeof Wi == "object" && Wi;
    (o.global === o || o.window === o || o.self === o) && (e = o);
    var a, s = 2147483647, h = 36, u = 1, l = 26, f = 38, c = 700, d = 72, p = 128, v = "-", _ = /^xn--/, m = /[^\x20-\x7E]/, y = /[\x2E\u3002\uFF0E\uFF61]/g, g = {
      overflow: "Overflow: input needs wider integers to process",
      "not-basic": "Illegal input >= 0x80 (not a basic code point)",
      "invalid-input": "Invalid input"
    }, x = h - u, T = Math.floor, E = String.fromCharCode, P;
    function b(N) {
      throw new RangeError(g[N]);
    }
    function w(N, F) {
      for (var k = N.length, tt = []; k--; )
        tt[k] = F(N[k]);
      return tt;
    }
    function A(N, F) {
      var k = N.split("@"), tt = "";
      k.length > 1 && (tt = k[0] + "@", N = k[1]), N = N.replace(y, ".");
      var et = N.split("."), pt = w(et, F).join(".");
      return tt + pt;
    }
    function R(N) {
      for (var F = [], k = 0, tt = N.length, et, pt; k < tt; )
        et = N.charCodeAt(k++), et >= 55296 && et <= 56319 && k < tt ? (pt = N.charCodeAt(k++), (pt & 64512) == 56320 ? F.push(((et & 1023) << 10) + (pt & 1023) + 65536) : (F.push(et), k--)) : F.push(et);
      return F;
    }
    function C(N) {
      return w(N, function(F) {
        var k = "";
        return F > 65535 && (F -= 65536, k += E(F >>> 10 & 1023 | 55296), F = 56320 | F & 1023), k += E(F), k;
      }).join("");
    }
    function M(N) {
      return N - 48 < 10 ? N - 22 : N - 65 < 26 ? N - 65 : N - 97 < 26 ? N - 97 : h;
    }
    function H(N, F) {
      return N + 22 + 75 * (N < 26) - ((F != 0) << 5);
    }
    function U(N, F, k) {
      var tt = 0;
      for (N = k ? T(N / c) : N >> 1, N += T(N / F); N > x * l >> 1; tt += h)
        N = T(N / x);
      return T(tt + (x + 1) * N / (N + f));
    }
    function B(N) {
      var F = [], k = N.length, tt, et = 0, pt = p, j = d, st, _t, Tt, W, it, at, lt, nt, D;
      for (st = N.lastIndexOf(v), st < 0 && (st = 0), _t = 0; _t < st; ++_t)
        N.charCodeAt(_t) >= 128 && b("not-basic"), F.push(N.charCodeAt(_t));
      for (Tt = st > 0 ? st + 1 : 0; Tt < k; ) {
        for (W = et, it = 1, at = h; Tt >= k && b("invalid-input"), lt = M(N.charCodeAt(Tt++)), (lt >= h || lt > T((s - et) / it)) && b("overflow"), et += lt * it, nt = at <= j ? u : at >= j + l ? l : at - j, !(lt < nt); at += h)
          D = h - nt, it > T(s / D) && b("overflow"), it *= D;
        tt = F.length + 1, j = U(et - W, tt, W == 0), T(et / tt) > s - pt && b("overflow"), pt += T(et / tt), et %= tt, F.splice(et++, 0, pt);
      }
      return C(F);
    }
    function $(N) {
      var F, k, tt, et, pt, j, st, _t, Tt, W, it, at = [], lt, nt, D, O;
      for (N = R(N), lt = N.length, F = p, k = 0, pt = d, j = 0; j < lt; ++j)
        it = N[j], it < 128 && at.push(E(it));
      for (tt = et = at.length, et && at.push(v); tt < lt; ) {
        for (st = s, j = 0; j < lt; ++j)
          it = N[j], it >= F && it < st && (st = it);
        for (nt = tt + 1, st - F > T((s - k) / nt) && b("overflow"), k += (st - F) * nt, F = st, j = 0; j < lt; ++j)
          if (it = N[j], it < F && ++k > s && b("overflow"), it == F) {
            for (_t = k, Tt = h; W = Tt <= pt ? u : Tt >= pt + l ? l : Tt - pt, !(_t < W); Tt += h)
              O = _t - W, D = h - W, at.push(
                E(H(W + O % D, 0))
              ), _t = T(O / D);
            at.push(E(H(_t, 0))), pt = U(k, nt, tt == et), k = 0, ++tt;
          }
        ++k, ++F;
      }
      return at.join("");
    }
    function q(N) {
      return A(N, function(F) {
        return _.test(F) ? B(F.slice(4).toLowerCase()) : F;
      });
    }
    function Q(N) {
      return A(N, function(F) {
        return m.test(F) ? "xn--" + $(F) : F;
      });
    }
    if (a = {
      /**
       * A string representing the current Punycode.js version number.
       * @memberOf punycode
       * @type String
       */
      version: "1.4.1",
      /**
       * An object of methods to convert from JavaScript's internal character
       * representation (UCS-2) to Unicode code points, and back.
       * @see <https://mathiasbynens.be/notes/javascript-encoding>
       * @memberOf punycode
       * @type Object
       */
      ucs2: {
        decode: R,
        encode: C
      },
      decode: B,
      encode: $,
      toASCII: Q,
      toUnicode: q
    }, n && i)
      if (r.exports == n)
        i.exports = a;
      else
        for (P in a)
          a.hasOwnProperty(P) && (n[P] = a[P]);
    else
      e.punycode = a;
  })(Wi);
})(bi, bi.exports);
var fd = bi.exports, cd = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var t = {}, e = Symbol("test"), n = Object(e);
  if (typeof e == "string" || Object.prototype.toString.call(e) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var i = 42;
  t[e] = i;
  for (e in t)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
    return !1;
  var o = Object.getOwnPropertySymbols(t);
  if (o.length !== 1 || o[0] !== e || !Object.prototype.propertyIsEnumerable.call(t, e))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var a = Object.getOwnPropertyDescriptor(t, e);
    if (a.value !== i || a.enumerable !== !0)
      return !1;
  }
  return !0;
}, Vs = typeof Symbol < "u" && Symbol, dd = cd, pd = function() {
  return typeof Vs != "function" || typeof Symbol != "function" || typeof Vs("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : dd();
}, zs = {
  foo: {}
}, vd = Object, _d = function() {
  return { __proto__: zs }.foo === zs.foo && !({ __proto__: null } instanceof vd);
}, md = "Function.prototype.bind called on incompatible ", Qi = Array.prototype.slice, yd = Object.prototype.toString, gd = "[object Function]", bd = function(t) {
  var e = this;
  if (typeof e != "function" || yd.call(e) !== gd)
    throw new TypeError(md + e);
  for (var n = Qi.call(arguments, 1), i, o = function() {
    if (this instanceof i) {
      var l = e.apply(
        this,
        n.concat(Qi.call(arguments))
      );
      return Object(l) === l ? l : this;
    } else
      return e.apply(
        t,
        n.concat(Qi.call(arguments))
      );
  }, a = Math.max(0, e.length - n.length), s = [], h = 0; h < a; h++)
    s.push("$" + h);
  if (i = Function("binder", "return function (" + s.join(",") + "){ return binder.apply(this,arguments); }")(o), e.prototype) {
    var u = function() {
    };
    u.prototype = e.prototype, i.prototype = new u(), u.prototype = null;
  }
  return i;
}, xd = bd, Vu = Function.prototype.bind || xd, Ws = {}.hasOwnProperty, to = Function.prototype.call, Td = to.bind ? to.bind(Ws) : function(r, t) {
  return to.call(Ws, r, t);
}, ot, kr = SyntaxError, zu = Function, Fr = TypeError, eo = function(r) {
  try {
    return zu('"use strict"; return (' + r + ").constructor;")();
  } catch {
  }
}, ar = Object.getOwnPropertyDescriptor;
if (ar)
  try {
    ar({}, "");
  } catch {
    ar = null;
  }
var ro = function() {
  throw new Fr();
}, Ed = ar ? function() {
  try {
    return arguments.callee, ro;
  } catch {
    try {
      return ar(arguments, "callee").get;
    } catch {
      return ro;
    }
  }
}() : ro, br = pd(), wd = _d(), Bt = Object.getPrototypeOf || (wd ? function(r) {
  return r.__proto__;
} : null), Ar = {}, Sd = typeof Uint8Array > "u" || !Bt ? ot : Bt(Uint8Array), sr = {
  "%AggregateError%": typeof AggregateError > "u" ? ot : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? ot : ArrayBuffer,
  "%ArrayIteratorPrototype%": br && Bt ? Bt([][Symbol.iterator]()) : ot,
  "%AsyncFromSyncIteratorPrototype%": ot,
  "%AsyncFunction%": Ar,
  "%AsyncGenerator%": Ar,
  "%AsyncGeneratorFunction%": Ar,
  "%AsyncIteratorPrototype%": Ar,
  "%Atomics%": typeof Atomics > "u" ? ot : Atomics,
  "%BigInt%": typeof BigInt > "u" ? ot : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? ot : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? ot : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? ot : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? ot : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? ot : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? ot : FinalizationRegistry,
  "%Function%": zu,
  "%GeneratorFunction%": Ar,
  "%Int8Array%": typeof Int8Array > "u" ? ot : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? ot : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? ot : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": br && Bt ? Bt(Bt([][Symbol.iterator]())) : ot,
  "%JSON%": typeof JSON == "object" ? JSON : ot,
  "%Map%": typeof Map > "u" ? ot : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !br || !Bt ? ot : Bt((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? ot : Promise,
  "%Proxy%": typeof Proxy > "u" ? ot : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? ot : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? ot : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !br || !Bt ? ot : Bt((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? ot : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": br && Bt ? Bt(""[Symbol.iterator]()) : ot,
  "%Symbol%": br ? Symbol : ot,
  "%SyntaxError%": kr,
  "%ThrowTypeError%": Ed,
  "%TypedArray%": Sd,
  "%TypeError%": Fr,
  "%Uint8Array%": typeof Uint8Array > "u" ? ot : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? ot : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? ot : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? ot : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? ot : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? ot : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? ot : WeakSet
};
if (Bt)
  try {
    null.error;
  } catch (r) {
    var Ad = Bt(Bt(r));
    sr["%Error.prototype%"] = Ad;
  }
var Pd = function r(t) {
  var e;
  if (t === "%AsyncFunction%")
    e = eo("async function () {}");
  else if (t === "%GeneratorFunction%")
    e = eo("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    e = eo("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var n = r("%AsyncGeneratorFunction%");
    n && (e = n.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var i = r("%AsyncGenerator%");
    i && Bt && (e = Bt(i.prototype));
  }
  return sr[t] = e, e;
}, $s = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, An = Vu, xi = Td, Od = An.call(Function.call, Array.prototype.concat), Rd = An.call(Function.apply, Array.prototype.splice), qs = An.call(Function.call, String.prototype.replace), Ti = An.call(Function.call, String.prototype.slice), Id = An.call(Function.call, RegExp.prototype.exec), Cd = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Md = /\\(\\)?/g, Dd = function(t) {
  var e = Ti(t, 0, 1), n = Ti(t, -1);
  if (e === "%" && n !== "%")
    throw new kr("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && e !== "%")
    throw new kr("invalid intrinsic syntax, expected opening `%`");
  var i = [];
  return qs(t, Cd, function(o, a, s, h) {
    i[i.length] = s ? qs(h, Md, "$1") : a || o;
  }), i;
}, Fd = function(t, e) {
  var n = t, i;
  if (xi($s, n) && (i = $s[n], n = "%" + i[0] + "%"), xi(sr, n)) {
    var o = sr[n];
    if (o === Ar && (o = Pd(n)), typeof o > "u" && !e)
      throw new Fr("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: i,
      name: n,
      value: o
    };
  }
  throw new kr("intrinsic " + t + " does not exist!");
}, Ya = function(t, e) {
  if (typeof t != "string" || t.length === 0)
    throw new Fr("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof e != "boolean")
    throw new Fr('"allowMissing" argument must be a boolean');
  if (Id(/^%?[^%]*%?$/, t) === null)
    throw new kr("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = Dd(t), i = n.length > 0 ? n[0] : "", o = Fd("%" + i + "%", e), a = o.name, s = o.value, h = !1, u = o.alias;
  u && (i = u[0], Rd(n, Od([0, 1], u)));
  for (var l = 1, f = !0; l < n.length; l += 1) {
    var c = n[l], d = Ti(c, 0, 1), p = Ti(c, -1);
    if ((d === '"' || d === "'" || d === "`" || p === '"' || p === "'" || p === "`") && d !== p)
      throw new kr("property names with quotes must have matching quotes");
    if ((c === "constructor" || !f) && (h = !0), i += "." + c, a = "%" + i + "%", xi(sr, a))
      s = sr[a];
    else if (s != null) {
      if (!(c in s)) {
        if (!e)
          throw new Fr("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if (ar && l + 1 >= n.length) {
        var v = ar(s, c);
        f = !!v, f && "get" in v && !("originalValue" in v.get) ? s = v.get : s = s[c];
      } else
        f = xi(s, c), s = s[c];
      f && !h && (sr[a] = s);
    }
  }
  return s;
}, Wu = { exports: {} };
(function(r) {
  var t = Vu, e = Ya, n = e("%Function.prototype.apply%"), i = e("%Function.prototype.call%"), o = e("%Reflect.apply%", !0) || t.call(i, n), a = e("%Object.getOwnPropertyDescriptor%", !0), s = e("%Object.defineProperty%", !0), h = e("%Math.max%");
  if (s)
    try {
      s({}, "a", { value: 1 });
    } catch {
      s = null;
    }
  r.exports = function(f) {
    var c = o(t, i, arguments);
    if (a && s) {
      var d = a(c, "length");
      d.configurable && s(
        c,
        "length",
        { value: 1 + h(0, f.length - (arguments.length - 1)) }
      );
    }
    return c;
  };
  var u = function() {
    return o(t, n, arguments);
  };
  s ? s(r.exports, "apply", { value: u }) : r.exports.apply = u;
})(Wu);
var Bd = Wu.exports, $u = Ya, qu = Bd, Nd = qu($u("String.prototype.indexOf")), Ld = function(t, e) {
  var n = $u(t, !!e);
  return typeof n == "function" && Nd(t, ".prototype.") > -1 ? qu(n) : n;
};
const Ud = {}, Gd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ud
}, Symbol.toStringTag, { value: "Module" })), kd = /* @__PURE__ */ Fc(Gd);
var Va = typeof Map == "function" && Map.prototype, no = Object.getOwnPropertyDescriptor && Va ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, Ei = Va && no && typeof no.get == "function" ? no.get : null, Ks = Va && Map.prototype.forEach, za = typeof Set == "function" && Set.prototype, io = Object.getOwnPropertyDescriptor && za ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, wi = za && io && typeof io.get == "function" ? io.get : null, Zs = za && Set.prototype.forEach, Hd = typeof WeakMap == "function" && WeakMap.prototype, sn = Hd ? WeakMap.prototype.has : null, Xd = typeof WeakSet == "function" && WeakSet.prototype, hn = Xd ? WeakSet.prototype.has : null, jd = typeof WeakRef == "function" && WeakRef.prototype, Js = jd ? WeakRef.prototype.deref : null, Yd = Boolean.prototype.valueOf, Vd = Object.prototype.toString, zd = Function.prototype.toString, Wd = String.prototype.match, Wa = String.prototype.slice, Ne = String.prototype.replace, $d = String.prototype.toUpperCase, Qs = String.prototype.toLowerCase, Ku = RegExp.prototype.test, th = Array.prototype.concat, me = Array.prototype.join, qd = Array.prototype.slice, eh = Math.floor, zo = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, oo = Object.getOwnPropertySymbols, Wo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Hr = typeof Symbol == "function" && typeof Symbol.iterator == "object", jt = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Hr || "symbol") ? Symbol.toStringTag : null, Zu = Object.prototype.propertyIsEnumerable, rh = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(r) {
  return r.__proto__;
} : null);
function nh(r, t) {
  if (r === 1 / 0 || r === -1 / 0 || r !== r || r && r > -1e3 && r < 1e3 || Ku.call(/e/, t))
    return t;
  var e = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof r == "number") {
    var n = r < 0 ? -eh(-r) : eh(r);
    if (n !== r) {
      var i = String(n), o = Wa.call(t, i.length + 1);
      return Ne.call(i, e, "$&_") + "." + Ne.call(Ne.call(o, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return Ne.call(t, e, "$&_");
}
var $o = kd, ih = $o.custom, oh = Qu(ih) ? ih : null, Kd = function r(t, e, n, i) {
  var o = e || {};
  if (Be(o, "quoteStyle") && o.quoteStyle !== "single" && o.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (Be(o, "maxStringLength") && (typeof o.maxStringLength == "number" ? o.maxStringLength < 0 && o.maxStringLength !== 1 / 0 : o.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var a = Be(o, "customInspect") ? o.customInspect : !0;
  if (typeof a != "boolean" && a !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (Be(o, "indent") && o.indent !== null && o.indent !== "	" && !(parseInt(o.indent, 10) === o.indent && o.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (Be(o, "numericSeparator") && typeof o.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var s = o.numericSeparator;
  if (typeof t > "u")
    return "undefined";
  if (t === null)
    return "null";
  if (typeof t == "boolean")
    return t ? "true" : "false";
  if (typeof t == "string")
    return el(t, o);
  if (typeof t == "number") {
    if (t === 0)
      return 1 / 0 / t > 0 ? "0" : "-0";
    var h = String(t);
    return s ? nh(t, h) : h;
  }
  if (typeof t == "bigint") {
    var u = String(t) + "n";
    return s ? nh(t, u) : u;
  }
  var l = typeof o.depth > "u" ? 5 : o.depth;
  if (typeof n > "u" && (n = 0), n >= l && l > 0 && typeof t == "object")
    return qo(t) ? "[Array]" : "[Object]";
  var f = pp(o, n);
  if (typeof i > "u")
    i = [];
  else if (tl(i, t) >= 0)
    return "[Circular]";
  function c(M, H, U) {
    if (H && (i = qd.call(i), i.push(H)), U) {
      var B = {
        depth: o.depth
      };
      return Be(o, "quoteStyle") && (B.quoteStyle = o.quoteStyle), r(M, B, n + 1, i);
    }
    return r(M, o, n + 1, i);
  }
  if (typeof t == "function" && !ah(t)) {
    var d = op(t), p = Un(t, c);
    return "[Function" + (d ? ": " + d : " (anonymous)") + "]" + (p.length > 0 ? " { " + me.call(p, ", ") + " }" : "");
  }
  if (Qu(t)) {
    var v = Hr ? Ne.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : Wo.call(t);
    return typeof t == "object" && !Hr ? qr(v) : v;
  }
  if (fp(t)) {
    for (var _ = "<" + Qs.call(String(t.nodeName)), m = t.attributes || [], y = 0; y < m.length; y++)
      _ += " " + m[y].name + "=" + Ju(Zd(m[y].value), "double", o);
    return _ += ">", t.childNodes && t.childNodes.length && (_ += "..."), _ += "</" + Qs.call(String(t.nodeName)) + ">", _;
  }
  if (qo(t)) {
    if (t.length === 0)
      return "[]";
    var g = Un(t, c);
    return f && !dp(g) ? "[" + Ko(g, f) + "]" : "[ " + me.call(g, ", ") + " ]";
  }
  if (Qd(t)) {
    var x = Un(t, c);
    return !("cause" in Error.prototype) && "cause" in t && !Zu.call(t, "cause") ? "{ [" + String(t) + "] " + me.call(th.call("[cause]: " + c(t.cause), x), ", ") + " }" : x.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + me.call(x, ", ") + " }";
  }
  if (typeof t == "object" && a) {
    if (oh && typeof t[oh] == "function" && $o)
      return $o(t, { depth: l - n });
    if (a !== "symbol" && typeof t.inspect == "function")
      return t.inspect();
  }
  if (ap(t)) {
    var T = [];
    return Ks && Ks.call(t, function(M, H) {
      T.push(c(H, t, !0) + " => " + c(M, t));
    }), sh("Map", Ei.call(t), T, f);
  }
  if (up(t)) {
    var E = [];
    return Zs && Zs.call(t, function(M) {
      E.push(c(M, t));
    }), sh("Set", wi.call(t), E, f);
  }
  if (sp(t))
    return ao("WeakMap");
  if (lp(t))
    return ao("WeakSet");
  if (hp(t))
    return ao("WeakRef");
  if (ep(t))
    return qr(c(Number(t)));
  if (np(t))
    return qr(c(zo.call(t)));
  if (rp(t))
    return qr(Yd.call(t));
  if (tp(t))
    return qr(c(String(t)));
  if (!Jd(t) && !ah(t)) {
    var P = Un(t, c), b = rh ? rh(t) === Object.prototype : t instanceof Object || t.constructor === Object, w = t instanceof Object ? "" : "null prototype", A = !b && jt && Object(t) === t && jt in t ? Wa.call(Ye(t), 8, -1) : w ? "Object" : "", R = b || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "", C = R + (A || w ? "[" + me.call(th.call([], A || [], w || []), ": ") + "] " : "");
    return P.length === 0 ? C + "{}" : f ? C + "{" + Ko(P, f) + "}" : C + "{ " + me.call(P, ", ") + " }";
  }
  return String(t);
};
function Ju(r, t, e) {
  var n = (e.quoteStyle || t) === "double" ? '"' : "'";
  return n + r + n;
}
function Zd(r) {
  return Ne.call(String(r), /"/g, "&quot;");
}
function qo(r) {
  return Ye(r) === "[object Array]" && (!jt || !(typeof r == "object" && jt in r));
}
function Jd(r) {
  return Ye(r) === "[object Date]" && (!jt || !(typeof r == "object" && jt in r));
}
function ah(r) {
  return Ye(r) === "[object RegExp]" && (!jt || !(typeof r == "object" && jt in r));
}
function Qd(r) {
  return Ye(r) === "[object Error]" && (!jt || !(typeof r == "object" && jt in r));
}
function tp(r) {
  return Ye(r) === "[object String]" && (!jt || !(typeof r == "object" && jt in r));
}
function ep(r) {
  return Ye(r) === "[object Number]" && (!jt || !(typeof r == "object" && jt in r));
}
function rp(r) {
  return Ye(r) === "[object Boolean]" && (!jt || !(typeof r == "object" && jt in r));
}
function Qu(r) {
  if (Hr)
    return r && typeof r == "object" && r instanceof Symbol;
  if (typeof r == "symbol")
    return !0;
  if (!r || typeof r != "object" || !Wo)
    return !1;
  try {
    return Wo.call(r), !0;
  } catch {
  }
  return !1;
}
function np(r) {
  if (!r || typeof r != "object" || !zo)
    return !1;
  try {
    return zo.call(r), !0;
  } catch {
  }
  return !1;
}
var ip = Object.prototype.hasOwnProperty || function(r) {
  return r in this;
};
function Be(r, t) {
  return ip.call(r, t);
}
function Ye(r) {
  return Vd.call(r);
}
function op(r) {
  if (r.name)
    return r.name;
  var t = Wd.call(zd.call(r), /^function\s*([\w$]+)/);
  return t ? t[1] : null;
}
function tl(r, t) {
  if (r.indexOf)
    return r.indexOf(t);
  for (var e = 0, n = r.length; e < n; e++)
    if (r[e] === t)
      return e;
  return -1;
}
function ap(r) {
  if (!Ei || !r || typeof r != "object")
    return !1;
  try {
    Ei.call(r);
    try {
      wi.call(r);
    } catch {
      return !0;
    }
    return r instanceof Map;
  } catch {
  }
  return !1;
}
function sp(r) {
  if (!sn || !r || typeof r != "object")
    return !1;
  try {
    sn.call(r, sn);
    try {
      hn.call(r, hn);
    } catch {
      return !0;
    }
    return r instanceof WeakMap;
  } catch {
  }
  return !1;
}
function hp(r) {
  if (!Js || !r || typeof r != "object")
    return !1;
  try {
    return Js.call(r), !0;
  } catch {
  }
  return !1;
}
function up(r) {
  if (!wi || !r || typeof r != "object")
    return !1;
  try {
    wi.call(r);
    try {
      Ei.call(r);
    } catch {
      return !0;
    }
    return r instanceof Set;
  } catch {
  }
  return !1;
}
function lp(r) {
  if (!hn || !r || typeof r != "object")
    return !1;
  try {
    hn.call(r, hn);
    try {
      sn.call(r, sn);
    } catch {
      return !0;
    }
    return r instanceof WeakSet;
  } catch {
  }
  return !1;
}
function fp(r) {
  return !r || typeof r != "object" ? !1 : typeof HTMLElement < "u" && r instanceof HTMLElement ? !0 : typeof r.nodeName == "string" && typeof r.getAttribute == "function";
}
function el(r, t) {
  if (r.length > t.maxStringLength) {
    var e = r.length - t.maxStringLength, n = "... " + e + " more character" + (e > 1 ? "s" : "");
    return el(Wa.call(r, 0, t.maxStringLength), t) + n;
  }
  var i = Ne.call(Ne.call(r, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, cp);
  return Ju(i, "single", t);
}
function cp(r) {
  var t = r.charCodeAt(0), e = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[t];
  return e ? "\\" + e : "\\x" + (t < 16 ? "0" : "") + $d.call(t.toString(16));
}
function qr(r) {
  return "Object(" + r + ")";
}
function ao(r) {
  return r + " { ? }";
}
function sh(r, t, e, n) {
  var i = n ? Ko(e, n) : me.call(e, ", ");
  return r + " (" + t + ") {" + i + "}";
}
function dp(r) {
  for (var t = 0; t < r.length; t++)
    if (tl(r[t], `
`) >= 0)
      return !1;
  return !0;
}
function pp(r, t) {
  var e;
  if (r.indent === "	")
    e = "	";
  else if (typeof r.indent == "number" && r.indent > 0)
    e = me.call(Array(r.indent + 1), " ");
  else
    return null;
  return {
    base: e,
    prev: me.call(Array(t + 1), e)
  };
}
function Ko(r, t) {
  if (r.length === 0)
    return "";
  var e = `
` + t.prev + t.base;
  return e + me.call(r, "," + e) + `
` + t.prev;
}
function Un(r, t) {
  var e = qo(r), n = [];
  if (e) {
    n.length = r.length;
    for (var i = 0; i < r.length; i++)
      n[i] = Be(r, i) ? t(r[i], r) : "";
  }
  var o = typeof oo == "function" ? oo(r) : [], a;
  if (Hr) {
    a = {};
    for (var s = 0; s < o.length; s++)
      a["$" + o[s]] = o[s];
  }
  for (var h in r)
    Be(r, h) && (e && String(Number(h)) === h && h < r.length || Hr && a["$" + h] instanceof Symbol || (Ku.call(/[^\w$]/, h) ? n.push(t(h, r) + ": " + t(r[h], r)) : n.push(h + ": " + t(r[h], r))));
  if (typeof oo == "function")
    for (var u = 0; u < o.length; u++)
      Zu.call(r, o[u]) && n.push("[" + t(o[u]) + "]: " + t(r[o[u]], r));
  return n;
}
var $a = Ya, zr = Ld, vp = Kd, _p = $a("%TypeError%"), Gn = $a("%WeakMap%", !0), kn = $a("%Map%", !0), mp = zr("WeakMap.prototype.get", !0), yp = zr("WeakMap.prototype.set", !0), gp = zr("WeakMap.prototype.has", !0), bp = zr("Map.prototype.get", !0), xp = zr("Map.prototype.set", !0), Tp = zr("Map.prototype.has", !0), qa = function(r, t) {
  for (var e = r, n; (n = e.next) !== null; e = n)
    if (n.key === t)
      return e.next = n.next, n.next = r.next, r.next = n, n;
}, Ep = function(r, t) {
  var e = qa(r, t);
  return e && e.value;
}, wp = function(r, t, e) {
  var n = qa(r, t);
  n ? n.value = e : r.next = {
    // eslint-disable-line no-param-reassign
    key: t,
    next: r.next,
    value: e
  };
}, Sp = function(r, t) {
  return !!qa(r, t);
}, Ap = function() {
  var t, e, n, i = {
    assert: function(o) {
      if (!i.has(o))
        throw new _p("Side channel does not contain " + vp(o));
    },
    get: function(o) {
      if (Gn && o && (typeof o == "object" || typeof o == "function")) {
        if (t)
          return mp(t, o);
      } else if (kn) {
        if (e)
          return bp(e, o);
      } else if (n)
        return Ep(n, o);
    },
    has: function(o) {
      if (Gn && o && (typeof o == "object" || typeof o == "function")) {
        if (t)
          return gp(t, o);
      } else if (kn) {
        if (e)
          return Tp(e, o);
      } else if (n)
        return Sp(n, o);
      return !1;
    },
    set: function(o, a) {
      Gn && o && (typeof o == "object" || typeof o == "function") ? (t || (t = new Gn()), yp(t, o, a)) : kn ? (e || (e = new kn()), xp(e, o, a)) : (n || (n = { key: {}, next: null }), wp(n, o, a));
    }
  };
  return i;
}, Pp = String.prototype.replace, Op = /%20/g, so = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, Ka = {
  default: so.RFC3986,
  formatters: {
    RFC1738: function(r) {
      return Pp.call(r, Op, "+");
    },
    RFC3986: function(r) {
      return String(r);
    }
  },
  RFC1738: so.RFC1738,
  RFC3986: so.RFC3986
}, Rp = Ka, ho = Object.prototype.hasOwnProperty, er = Array.isArray, _e = function() {
  for (var r = [], t = 0; t < 256; ++t)
    r.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return r;
}(), Ip = function(t) {
  for (; t.length > 1; ) {
    var e = t.pop(), n = e.obj[e.prop];
    if (er(n)) {
      for (var i = [], o = 0; o < n.length; ++o)
        typeof n[o] < "u" && i.push(n[o]);
      e.obj[e.prop] = i;
    }
  }
}, rl = function(t, e) {
  for (var n = e && e.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = 0; i < t.length; ++i)
    typeof t[i] < "u" && (n[i] = t[i]);
  return n;
}, Cp = function r(t, e, n) {
  if (!e)
    return t;
  if (typeof e != "object") {
    if (er(t))
      t.push(e);
    else if (t && typeof t == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !ho.call(Object.prototype, e)) && (t[e] = !0);
    else
      return [t, e];
    return t;
  }
  if (!t || typeof t != "object")
    return [t].concat(e);
  var i = t;
  return er(t) && !er(e) && (i = rl(t, n)), er(t) && er(e) ? (e.forEach(function(o, a) {
    if (ho.call(t, a)) {
      var s = t[a];
      s && typeof s == "object" && o && typeof o == "object" ? t[a] = r(s, o, n) : t.push(o);
    } else
      t[a] = o;
  }), t) : Object.keys(e).reduce(function(o, a) {
    var s = e[a];
    return ho.call(o, a) ? o[a] = r(o[a], s, n) : o[a] = s, o;
  }, i);
}, Mp = function(t, e) {
  return Object.keys(e).reduce(function(n, i) {
    return n[i] = e[i], n;
  }, t);
}, Dp = function(r, t, e) {
  var n = r.replace(/\+/g, " ");
  if (e === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, Fp = function(t, e, n, i, o) {
  if (t.length === 0)
    return t;
  var a = t;
  if (typeof t == "symbol" ? a = Symbol.prototype.toString.call(t) : typeof t != "string" && (a = String(t)), n === "iso-8859-1")
    return escape(a).replace(/%u[0-9a-f]{4}/gi, function(l) {
      return "%26%23" + parseInt(l.slice(2), 16) + "%3B";
    });
  for (var s = "", h = 0; h < a.length; ++h) {
    var u = a.charCodeAt(h);
    if (u === 45 || u === 46 || u === 95 || u === 126 || u >= 48 && u <= 57 || u >= 65 && u <= 90 || u >= 97 && u <= 122 || o === Rp.RFC1738 && (u === 40 || u === 41)) {
      s += a.charAt(h);
      continue;
    }
    if (u < 128) {
      s = s + _e[u];
      continue;
    }
    if (u < 2048) {
      s = s + (_e[192 | u >> 6] + _e[128 | u & 63]);
      continue;
    }
    if (u < 55296 || u >= 57344) {
      s = s + (_e[224 | u >> 12] + _e[128 | u >> 6 & 63] + _e[128 | u & 63]);
      continue;
    }
    h += 1, u = 65536 + ((u & 1023) << 10 | a.charCodeAt(h) & 1023), s += _e[240 | u >> 18] + _e[128 | u >> 12 & 63] + _e[128 | u >> 6 & 63] + _e[128 | u & 63];
  }
  return s;
}, Bp = function(t) {
  for (var e = [{ obj: { o: t }, prop: "o" }], n = [], i = 0; i < e.length; ++i)
    for (var o = e[i], a = o.obj[o.prop], s = Object.keys(a), h = 0; h < s.length; ++h) {
      var u = s[h], l = a[u];
      typeof l == "object" && l !== null && n.indexOf(l) === -1 && (e.push({ obj: a, prop: u }), n.push(l));
    }
  return Ip(e), t;
}, Np = function(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}, Lp = function(t) {
  return !t || typeof t != "object" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
}, Up = function(t, e) {
  return [].concat(t, e);
}, Gp = function(t, e) {
  if (er(t)) {
    for (var n = [], i = 0; i < t.length; i += 1)
      n.push(e(t[i]));
    return n;
  }
  return e(t);
}, nl = {
  arrayToObject: rl,
  assign: Mp,
  combine: Up,
  compact: Bp,
  decode: Dp,
  encode: Fp,
  isBuffer: Lp,
  isRegExp: Np,
  maybeMap: Gp,
  merge: Cp
}, il = Ap, fi = nl, un = Ka, kp = Object.prototype.hasOwnProperty, hh = {
  brackets: function(t) {
    return t + "[]";
  },
  comma: "comma",
  indices: function(t, e) {
    return t + "[" + e + "]";
  },
  repeat: function(t) {
    return t;
  }
}, Pe = Array.isArray, Hp = Array.prototype.push, ol = function(r, t) {
  Hp.apply(r, Pe(t) ? t : [t]);
}, Xp = Date.prototype.toISOString, uh = un.default, Xt = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: fi.encode,
  encodeValuesOnly: !1,
  format: uh,
  formatter: un.formatters[uh],
  // deprecated
  indices: !1,
  serializeDate: function(t) {
    return Xp.call(t);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, jp = function(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "symbol" || typeof t == "bigint";
}, uo = {}, Yp = function r(t, e, n, i, o, a, s, h, u, l, f, c, d, p, v, _) {
  for (var m = t, y = _, g = 0, x = !1; (y = y.get(uo)) !== void 0 && !x; ) {
    var T = y.get(t);
    if (g += 1, typeof T < "u") {
      if (T === g)
        throw new RangeError("Cyclic object value");
      x = !0;
    }
    typeof y.get(uo) > "u" && (g = 0);
  }
  if (typeof h == "function" ? m = h(e, m) : m instanceof Date ? m = f(m) : n === "comma" && Pe(m) && (m = fi.maybeMap(m, function(B) {
    return B instanceof Date ? f(B) : B;
  })), m === null) {
    if (o)
      return s && !p ? s(e, Xt.encoder, v, "key", c) : e;
    m = "";
  }
  if (jp(m) || fi.isBuffer(m)) {
    if (s) {
      var E = p ? e : s(e, Xt.encoder, v, "key", c);
      return [d(E) + "=" + d(s(m, Xt.encoder, v, "value", c))];
    }
    return [d(e) + "=" + d(String(m))];
  }
  var P = [];
  if (typeof m > "u")
    return P;
  var b;
  if (n === "comma" && Pe(m))
    p && s && (m = fi.maybeMap(m, s)), b = [{ value: m.length > 0 ? m.join(",") || null : void 0 }];
  else if (Pe(h))
    b = h;
  else {
    var w = Object.keys(m);
    b = u ? w.sort(u) : w;
  }
  for (var A = i && Pe(m) && m.length === 1 ? e + "[]" : e, R = 0; R < b.length; ++R) {
    var C = b[R], M = typeof C == "object" && typeof C.value < "u" ? C.value : m[C];
    if (!(a && M === null)) {
      var H = Pe(m) ? typeof n == "function" ? n(A, C) : A : A + (l ? "." + C : "[" + C + "]");
      _.set(t, g);
      var U = il();
      U.set(uo, _), ol(P, r(
        M,
        H,
        n,
        i,
        o,
        a,
        n === "comma" && p && Pe(m) ? null : s,
        h,
        u,
        l,
        f,
        c,
        d,
        p,
        v,
        U
      ));
    }
  }
  return P;
}, Vp = function(t) {
  if (!t)
    return Xt;
  if (t.encoder !== null && typeof t.encoder < "u" && typeof t.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var e = t.charset || Xt.charset;
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = un.default;
  if (typeof t.format < "u") {
    if (!kp.call(un.formatters, t.format))
      throw new TypeError("Unknown format option provided.");
    n = t.format;
  }
  var i = un.formatters[n], o = Xt.filter;
  return (typeof t.filter == "function" || Pe(t.filter)) && (o = t.filter), {
    addQueryPrefix: typeof t.addQueryPrefix == "boolean" ? t.addQueryPrefix : Xt.addQueryPrefix,
    allowDots: typeof t.allowDots > "u" ? Xt.allowDots : !!t.allowDots,
    charset: e,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : Xt.charsetSentinel,
    delimiter: typeof t.delimiter > "u" ? Xt.delimiter : t.delimiter,
    encode: typeof t.encode == "boolean" ? t.encode : Xt.encode,
    encoder: typeof t.encoder == "function" ? t.encoder : Xt.encoder,
    encodeValuesOnly: typeof t.encodeValuesOnly == "boolean" ? t.encodeValuesOnly : Xt.encodeValuesOnly,
    filter: o,
    format: n,
    formatter: i,
    serializeDate: typeof t.serializeDate == "function" ? t.serializeDate : Xt.serializeDate,
    skipNulls: typeof t.skipNulls == "boolean" ? t.skipNulls : Xt.skipNulls,
    sort: typeof t.sort == "function" ? t.sort : null,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : Xt.strictNullHandling
  };
}, zp = function(r, t) {
  var e = r, n = Vp(t), i, o;
  typeof n.filter == "function" ? (o = n.filter, e = o("", e)) : Pe(n.filter) && (o = n.filter, i = o);
  var a = [];
  if (typeof e != "object" || e === null)
    return "";
  var s;
  t && t.arrayFormat in hh ? s = t.arrayFormat : t && "indices" in t ? s = t.indices ? "indices" : "repeat" : s = "indices";
  var h = hh[s];
  if (t && "commaRoundTrip" in t && typeof t.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var u = h === "comma" && t && t.commaRoundTrip;
  i || (i = Object.keys(e)), n.sort && i.sort(n.sort);
  for (var l = il(), f = 0; f < i.length; ++f) {
    var c = i[f];
    n.skipNulls && e[c] === null || ol(a, Yp(
      e[c],
      c,
      h,
      u,
      n.strictNullHandling,
      n.skipNulls,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset,
      l
    ));
  }
  var d = a.join(n.delimiter), p = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? p += "utf8=%26%2310003%3B&" : p += "utf8=%E2%9C%93&"), d.length > 0 ? p + d : "";
}, Xr = nl, Zo = Object.prototype.hasOwnProperty, Wp = Array.isArray, Ft = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: Xr.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, $p = function(r) {
  return r.replace(/&#(\d+);/g, function(t, e) {
    return String.fromCharCode(parseInt(e, 10));
  });
}, al = function(r, t) {
  return r && typeof r == "string" && t.comma && r.indexOf(",") > -1 ? r.split(",") : r;
}, qp = "utf8=%26%2310003%3B", Kp = "utf8=%E2%9C%93", Zp = function(t, e) {
  var n = { __proto__: null }, i = e.ignoreQueryPrefix ? t.replace(/^\?/, "") : t, o = e.parameterLimit === 1 / 0 ? void 0 : e.parameterLimit, a = i.split(e.delimiter, o), s = -1, h, u = e.charset;
  if (e.charsetSentinel)
    for (h = 0; h < a.length; ++h)
      a[h].indexOf("utf8=") === 0 && (a[h] === Kp ? u = "utf-8" : a[h] === qp && (u = "iso-8859-1"), s = h, h = a.length);
  for (h = 0; h < a.length; ++h)
    if (h !== s) {
      var l = a[h], f = l.indexOf("]="), c = f === -1 ? l.indexOf("=") : f + 1, d, p;
      c === -1 ? (d = e.decoder(l, Ft.decoder, u, "key"), p = e.strictNullHandling ? null : "") : (d = e.decoder(l.slice(0, c), Ft.decoder, u, "key"), p = Xr.maybeMap(
        al(l.slice(c + 1), e),
        function(v) {
          return e.decoder(v, Ft.decoder, u, "value");
        }
      )), p && e.interpretNumericEntities && u === "iso-8859-1" && (p = $p(p)), l.indexOf("[]=") > -1 && (p = Wp(p) ? [p] : p), Zo.call(n, d) ? n[d] = Xr.combine(n[d], p) : n[d] = p;
    }
  return n;
}, Jp = function(r, t, e, n) {
  for (var i = n ? t : al(t, e), o = r.length - 1; o >= 0; --o) {
    var a, s = r[o];
    if (s === "[]" && e.parseArrays)
      a = [].concat(i);
    else {
      a = e.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var h = s.charAt(0) === "[" && s.charAt(s.length - 1) === "]" ? s.slice(1, -1) : s, u = parseInt(h, 10);
      !e.parseArrays && h === "" ? a = { 0: i } : !isNaN(u) && s !== h && String(u) === h && u >= 0 && e.parseArrays && u <= e.arrayLimit ? (a = [], a[u] = i) : h !== "__proto__" && (a[h] = i);
    }
    i = a;
  }
  return i;
}, Qp = function(t, e, n, i) {
  if (t) {
    var o = n.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, a = /(\[[^[\]]*])/, s = /(\[[^[\]]*])/g, h = n.depth > 0 && a.exec(o), u = h ? o.slice(0, h.index) : o, l = [];
    if (u) {
      if (!n.plainObjects && Zo.call(Object.prototype, u) && !n.allowPrototypes)
        return;
      l.push(u);
    }
    for (var f = 0; n.depth > 0 && (h = s.exec(o)) !== null && f < n.depth; ) {
      if (f += 1, !n.plainObjects && Zo.call(Object.prototype, h[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      l.push(h[1]);
    }
    return h && l.push("[" + o.slice(h.index) + "]"), Jp(l, e, n, i);
  }
}, tv = function(t) {
  if (!t)
    return Ft;
  if (t.decoder !== null && t.decoder !== void 0 && typeof t.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var e = typeof t.charset > "u" ? Ft.charset : t.charset;
  return {
    allowDots: typeof t.allowDots > "u" ? Ft.allowDots : !!t.allowDots,
    allowPrototypes: typeof t.allowPrototypes == "boolean" ? t.allowPrototypes : Ft.allowPrototypes,
    allowSparse: typeof t.allowSparse == "boolean" ? t.allowSparse : Ft.allowSparse,
    arrayLimit: typeof t.arrayLimit == "number" ? t.arrayLimit : Ft.arrayLimit,
    charset: e,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : Ft.charsetSentinel,
    comma: typeof t.comma == "boolean" ? t.comma : Ft.comma,
    decoder: typeof t.decoder == "function" ? t.decoder : Ft.decoder,
    delimiter: typeof t.delimiter == "string" || Xr.isRegExp(t.delimiter) ? t.delimiter : Ft.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof t.depth == "number" || t.depth === !1 ? +t.depth : Ft.depth,
    ignoreQueryPrefix: t.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof t.interpretNumericEntities == "boolean" ? t.interpretNumericEntities : Ft.interpretNumericEntities,
    parameterLimit: typeof t.parameterLimit == "number" ? t.parameterLimit : Ft.parameterLimit,
    parseArrays: t.parseArrays !== !1,
    plainObjects: typeof t.plainObjects == "boolean" ? t.plainObjects : Ft.plainObjects,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : Ft.strictNullHandling
  };
}, ev = function(r, t) {
  var e = tv(t);
  if (r === "" || r === null || typeof r > "u")
    return e.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof r == "string" ? Zp(r, e) : r, i = e.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, o = Object.keys(n), a = 0; a < o.length; ++a) {
    var s = o[a], h = Qp(s, n[s], e, typeof r == "string");
    i = Xr.merge(i, h, e);
  }
  return e.allowSparse === !0 ? i : Xr.compact(i);
}, rv = zp, nv = ev, iv = Ka, ov = {
  formats: iv,
  parse: nv,
  stringify: rv
}, av = fd;
function fe() {
  this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
}
var sv = /^([a-z0-9.+-]+:)/i, hv = /:[0-9]*$/, uv = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, lv = [
  "<",
  ">",
  '"',
  "`",
  " ",
  "\r",
  `
`,
  "	"
], fv = [
  "{",
  "}",
  "|",
  "\\",
  "^",
  "`"
].concat(lv), Jo = ["'"].concat(fv), lh = [
  "%",
  "/",
  "?",
  ";",
  "#"
].concat(Jo), fh = [
  "/",
  "?",
  "#"
], cv = 255, ch = /^[+a-z0-9A-Z_-]{0,63}$/, dv = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, pv = {
  javascript: !0,
  "javascript:": !0
}, Qo = {
  javascript: !0,
  "javascript:": !0
}, Br = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
}, ta = ov;
function Ui(r, t, e) {
  if (r && typeof r == "object" && r instanceof fe)
    return r;
  var n = new fe();
  return n.parse(r, t, e), n;
}
fe.prototype.parse = function(r, t, e) {
  if (typeof r != "string")
    throw new TypeError("Parameter 'url' must be a string, not " + typeof r);
  var n = r.indexOf("?"), i = n !== -1 && n < r.indexOf("#") ? "?" : "#", o = r.split(i), a = /\\/g;
  o[0] = o[0].replace(a, "/"), r = o.join(i);
  var s = r;
  if (s = s.trim(), !e && r.split("#").length === 1) {
    var h = uv.exec(s);
    if (h)
      return this.path = s, this.href = s, this.pathname = h[1], h[2] ? (this.search = h[2], t ? this.query = ta.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : t && (this.search = "", this.query = {}), this;
  }
  var u = sv.exec(s);
  if (u) {
    u = u[0];
    var l = u.toLowerCase();
    this.protocol = l, s = s.substr(u.length);
  }
  if (e || u || s.match(/^\/\/[^@/]+@[^@/]+/)) {
    var f = s.substr(0, 2) === "//";
    f && !(u && Qo[u]) && (s = s.substr(2), this.slashes = !0);
  }
  if (!Qo[u] && (f || u && !Br[u])) {
    for (var c = -1, d = 0; d < fh.length; d++) {
      var p = s.indexOf(fh[d]);
      p !== -1 && (c === -1 || p < c) && (c = p);
    }
    var v, _;
    c === -1 ? _ = s.lastIndexOf("@") : _ = s.lastIndexOf("@", c), _ !== -1 && (v = s.slice(0, _), s = s.slice(_ + 1), this.auth = decodeURIComponent(v)), c = -1;
    for (var d = 0; d < lh.length; d++) {
      var p = s.indexOf(lh[d]);
      p !== -1 && (c === -1 || p < c) && (c = p);
    }
    c === -1 && (c = s.length), this.host = s.slice(0, c), s = s.slice(c), this.parseHost(), this.hostname = this.hostname || "";
    var m = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!m)
      for (var y = this.hostname.split(/\./), d = 0, g = y.length; d < g; d++) {
        var x = y[d];
        if (x && !x.match(ch)) {
          for (var T = "", E = 0, P = x.length; E < P; E++)
            x.charCodeAt(E) > 127 ? T += "x" : T += x[E];
          if (!T.match(ch)) {
            var b = y.slice(0, d), w = y.slice(d + 1), A = x.match(dv);
            A && (b.push(A[1]), w.unshift(A[2])), w.length && (s = "/" + w.join(".") + s), this.hostname = b.join(".");
            break;
          }
        }
      }
    this.hostname.length > cv ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), m || (this.hostname = av.toASCII(this.hostname));
    var R = this.port ? ":" + this.port : "", C = this.hostname || "";
    this.host = C + R, this.href += this.host, m && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), s[0] !== "/" && (s = "/" + s));
  }
  if (!pv[l])
    for (var d = 0, g = Jo.length; d < g; d++) {
      var M = Jo[d];
      if (s.indexOf(M) !== -1) {
        var H = encodeURIComponent(M);
        H === M && (H = escape(M)), s = s.split(M).join(H);
      }
    }
  var U = s.indexOf("#");
  U !== -1 && (this.hash = s.substr(U), s = s.slice(0, U));
  var B = s.indexOf("?");
  if (B !== -1 ? (this.search = s.substr(B), this.query = s.substr(B + 1), t && (this.query = ta.parse(this.query)), s = s.slice(0, B)) : t && (this.search = "", this.query = {}), s && (this.pathname = s), Br[l] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
    var R = this.pathname || "", $ = this.search || "";
    this.path = R + $;
  }
  return this.href = this.format(), this;
};
function vv(r) {
  return typeof r == "string" && (r = Ui(r)), r instanceof fe ? r.format() : fe.prototype.format.call(r);
}
fe.prototype.format = function() {
  var r = this.auth || "";
  r && (r = encodeURIComponent(r), r = r.replace(/%3A/i, ":"), r += "@");
  var t = this.protocol || "", e = this.pathname || "", n = this.hash || "", i = !1, o = "";
  this.host ? i = r + this.host : this.hostname && (i = r + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (i += ":" + this.port)), this.query && typeof this.query == "object" && Object.keys(this.query).length && (o = ta.stringify(this.query, {
    arrayFormat: "repeat",
    addQueryPrefix: !1
  }));
  var a = this.search || o && "?" + o || "";
  return t && t.substr(-1) !== ":" && (t += ":"), this.slashes || (!t || Br[t]) && i !== !1 ? (i = "//" + (i || ""), e && e.charAt(0) !== "/" && (e = "/" + e)) : i || (i = ""), n && n.charAt(0) !== "#" && (n = "#" + n), a && a.charAt(0) !== "?" && (a = "?" + a), e = e.replace(/[?#]/g, function(s) {
    return encodeURIComponent(s);
  }), a = a.replace("#", "%23"), t + i + e + a + n;
};
function _v(r, t) {
  return Ui(r, !1, !0).resolve(t);
}
fe.prototype.resolve = function(r) {
  return this.resolveObject(Ui(r, !1, !0)).format();
};
fe.prototype.resolveObject = function(r) {
  if (typeof r == "string") {
    var t = new fe();
    t.parse(r, !1, !0), r = t;
  }
  for (var e = new fe(), n = Object.keys(this), i = 0; i < n.length; i++) {
    var o = n[i];
    e[o] = this[o];
  }
  if (e.hash = r.hash, r.href === "")
    return e.href = e.format(), e;
  if (r.slashes && !r.protocol) {
    for (var a = Object.keys(r), s = 0; s < a.length; s++) {
      var h = a[s];
      h !== "protocol" && (e[h] = r[h]);
    }
    return Br[e.protocol] && e.hostname && !e.pathname && (e.pathname = "/", e.path = e.pathname), e.href = e.format(), e;
  }
  if (r.protocol && r.protocol !== e.protocol) {
    if (!Br[r.protocol]) {
      for (var u = Object.keys(r), l = 0; l < u.length; l++) {
        var f = u[l];
        e[f] = r[f];
      }
      return e.href = e.format(), e;
    }
    if (e.protocol = r.protocol, !r.host && !Qo[r.protocol]) {
      for (var g = (r.pathname || "").split("/"); g.length && !(r.host = g.shift()); )
        ;
      r.host || (r.host = ""), r.hostname || (r.hostname = ""), g[0] !== "" && g.unshift(""), g.length < 2 && g.unshift(""), e.pathname = g.join("/");
    } else
      e.pathname = r.pathname;
    if (e.search = r.search, e.query = r.query, e.host = r.host || "", e.auth = r.auth, e.hostname = r.hostname || r.host, e.port = r.port, e.pathname || e.search) {
      var c = e.pathname || "", d = e.search || "";
      e.path = c + d;
    }
    return e.slashes = e.slashes || r.slashes, e.href = e.format(), e;
  }
  var p = e.pathname && e.pathname.charAt(0) === "/", v = r.host || r.pathname && r.pathname.charAt(0) === "/", _ = v || p || e.host && r.pathname, m = _, y = e.pathname && e.pathname.split("/") || [], g = r.pathname && r.pathname.split("/") || [], x = e.protocol && !Br[e.protocol];
  if (x && (e.hostname = "", e.port = null, e.host && (y[0] === "" ? y[0] = e.host : y.unshift(e.host)), e.host = "", r.protocol && (r.hostname = null, r.port = null, r.host && (g[0] === "" ? g[0] = r.host : g.unshift(r.host)), r.host = null), _ = _ && (g[0] === "" || y[0] === "")), v)
    e.host = r.host || r.host === "" ? r.host : e.host, e.hostname = r.hostname || r.hostname === "" ? r.hostname : e.hostname, e.search = r.search, e.query = r.query, y = g;
  else if (g.length)
    y || (y = []), y.pop(), y = y.concat(g), e.search = r.search, e.query = r.query;
  else if (r.search != null) {
    if (x) {
      e.host = y.shift(), e.hostname = e.host;
      var T = e.host && e.host.indexOf("@") > 0 ? e.host.split("@") : !1;
      T && (e.auth = T.shift(), e.hostname = T.shift(), e.host = e.hostname);
    }
    return e.search = r.search, e.query = r.query, (e.pathname !== null || e.search !== null) && (e.path = (e.pathname ? e.pathname : "") + (e.search ? e.search : "")), e.href = e.format(), e;
  }
  if (!y.length)
    return e.pathname = null, e.search ? e.path = "/" + e.search : e.path = null, e.href = e.format(), e;
  for (var E = y.slice(-1)[0], P = (e.host || r.host || y.length > 1) && (E === "." || E === "..") || E === "", b = 0, w = y.length; w >= 0; w--)
    E = y[w], E === "." ? y.splice(w, 1) : E === ".." ? (y.splice(w, 1), b++) : b && (y.splice(w, 1), b--);
  if (!_ && !m)
    for (; b--; b)
      y.unshift("..");
  _ && y[0] !== "" && (!y[0] || y[0].charAt(0) !== "/") && y.unshift(""), P && y.join("/").substr(-1) !== "/" && y.push("");
  var A = y[0] === "" || y[0] && y[0].charAt(0) === "/";
  if (x) {
    e.hostname = A ? "" : y.length ? y.shift() : "", e.host = e.hostname;
    var T = e.host && e.host.indexOf("@") > 0 ? e.host.split("@") : !1;
    T && (e.auth = T.shift(), e.hostname = T.shift(), e.host = e.hostname);
  }
  return _ = _ || e.host && y.length, _ && !A && y.unshift(""), y.length > 0 ? e.pathname = y.join("/") : (e.pathname = null, e.path = null), (e.pathname !== null || e.search !== null) && (e.path = (e.pathname ? e.pathname : "") + (e.search ? e.search : "")), e.auth = r.auth || e.auth, e.slashes = e.slashes || r.slashes, e.href = e.format(), e;
};
fe.prototype.parseHost = function() {
  var r = this.host, t = hv.exec(r);
  t && (t = t[0], t !== ":" && (this.port = t.substr(1)), r = r.substr(0, r.length - t.length)), r && (this.hostname = r);
};
var mv = Ui, yv = _v, gv = vv;
/*!
 * @pixi/utils - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/utils is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var Rr = {
  parse: mv,
  format: gv,
  resolve: yv
};
G.RETINA_PREFIX = /@([0-9\.]+)x/;
G.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = !1;
var dh = !1, ph = "6.5.10";
function bv(r) {
  var t;
  if (!dh) {
    if (G.ADAPTER.getNavigator().userAgent.toLowerCase().indexOf("chrome") > -1) {
      var e = [
        `
 %c %c %c PixiJS ` + ph + " - ✰ " + r + ` ✰  %c  %c  http://www.pixijs.com/  %c %c ♥%c♥%c♥ 

`,
        "background: #ff66a5; padding:5px 0;",
        "background: #ff66a5; padding:5px 0;",
        "color: #ff66a5; background: #030307; padding:5px 0;",
        "background: #ff66a5; padding:5px 0;",
        "background: #ffc3dc; padding:5px 0;",
        "background: #ff66a5; padding:5px 0;",
        "color: #ff2424; background: #fff; padding:5px 0;",
        "color: #ff2424; background: #fff; padding:5px 0;",
        "color: #ff2424; background: #fff; padding:5px 0;"
      ];
      (t = globalThis.console).log.apply(t, e);
    } else
      globalThis.console && globalThis.console.log("PixiJS " + ph + " - " + r + " - http://www.pixijs.com/");
    dh = !0;
  }
}
var lo;
function xv() {
  return typeof lo > "u" && (lo = function() {
    var t = {
      stencil: !0,
      failIfMajorPerformanceCaveat: G.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
    };
    try {
      if (!G.ADAPTER.getWebGLRenderingContext())
        return !1;
      var e = G.ADAPTER.createCanvas(), n = e.getContext("webgl", t) || e.getContext("experimental-webgl", t), i = !!(n && n.getContextAttributes().stencil);
      if (n) {
        var o = n.getExtension("WEBGL_lose_context");
        o && o.loseContext();
      }
      return n = null, i;
    } catch {
      return !1;
    }
  }()), lo;
}
var Tv = "#f0f8ff", Ev = "#faebd7", wv = "#00ffff", Sv = "#7fffd4", Av = "#f0ffff", Pv = "#f5f5dc", Ov = "#ffe4c4", Rv = "#000000", Iv = "#ffebcd", Cv = "#0000ff", Mv = "#8a2be2", Dv = "#a52a2a", Fv = "#deb887", Bv = "#5f9ea0", Nv = "#7fff00", Lv = "#d2691e", Uv = "#ff7f50", Gv = "#6495ed", kv = "#fff8dc", Hv = "#dc143c", Xv = "#00ffff", jv = "#00008b", Yv = "#008b8b", Vv = "#b8860b", zv = "#a9a9a9", Wv = "#006400", $v = "#a9a9a9", qv = "#bdb76b", Kv = "#8b008b", Zv = "#556b2f", Jv = "#ff8c00", Qv = "#9932cc", t_ = "#8b0000", e_ = "#e9967a", r_ = "#8fbc8f", n_ = "#483d8b", i_ = "#2f4f4f", o_ = "#2f4f4f", a_ = "#00ced1", s_ = "#9400d3", h_ = "#ff1493", u_ = "#00bfff", l_ = "#696969", f_ = "#696969", c_ = "#1e90ff", d_ = "#b22222", p_ = "#fffaf0", v_ = "#228b22", __ = "#ff00ff", m_ = "#dcdcdc", y_ = "#f8f8ff", g_ = "#daa520", b_ = "#ffd700", x_ = "#808080", T_ = "#008000", E_ = "#adff2f", w_ = "#808080", S_ = "#f0fff0", A_ = "#ff69b4", P_ = "#cd5c5c", O_ = "#4b0082", R_ = "#fffff0", I_ = "#f0e68c", C_ = "#fff0f5", M_ = "#e6e6fa", D_ = "#7cfc00", F_ = "#fffacd", B_ = "#add8e6", N_ = "#f08080", L_ = "#e0ffff", U_ = "#fafad2", G_ = "#d3d3d3", k_ = "#90ee90", H_ = "#d3d3d3", X_ = "#ffb6c1", j_ = "#ffa07a", Y_ = "#20b2aa", V_ = "#87cefa", z_ = "#778899", W_ = "#778899", $_ = "#b0c4de", q_ = "#ffffe0", K_ = "#00ff00", Z_ = "#32cd32", J_ = "#faf0e6", Q_ = "#ff00ff", tm = "#800000", em = "#66cdaa", rm = "#0000cd", nm = "#ba55d3", im = "#9370db", om = "#3cb371", am = "#7b68ee", sm = "#00fa9a", hm = "#48d1cc", um = "#c71585", lm = "#191970", fm = "#f5fffa", cm = "#ffe4e1", dm = "#ffe4b5", pm = "#ffdead", vm = "#000080", _m = "#fdf5e6", mm = "#808000", ym = "#6b8e23", gm = "#ffa500", bm = "#ff4500", xm = "#da70d6", Tm = "#eee8aa", Em = "#98fb98", wm = "#afeeee", Sm = "#db7093", Am = "#ffefd5", Pm = "#ffdab9", Om = "#cd853f", Rm = "#ffc0cb", Im = "#dda0dd", Cm = "#b0e0e6", Mm = "#800080", Dm = "#663399", Fm = "#ff0000", Bm = "#bc8f8f", Nm = "#4169e1", Lm = "#8b4513", Um = "#fa8072", Gm = "#f4a460", km = "#2e8b57", Hm = "#fff5ee", Xm = "#a0522d", jm = "#c0c0c0", Ym = "#87ceeb", Vm = "#6a5acd", zm = "#708090", Wm = "#708090", $m = "#fffafa", qm = "#00ff7f", Km = "#4682b4", Zm = "#d2b48c", Jm = "#008080", Qm = "#d8bfd8", ty = "#ff6347", ey = "#40e0d0", ry = "#ee82ee", ny = "#f5deb3", iy = "#ffffff", oy = "#f5f5f5", ay = "#ffff00", sy = "#9acd32", hy = {
  aliceblue: Tv,
  antiquewhite: Ev,
  aqua: wv,
  aquamarine: Sv,
  azure: Av,
  beige: Pv,
  bisque: Ov,
  black: Rv,
  blanchedalmond: Iv,
  blue: Cv,
  blueviolet: Mv,
  brown: Dv,
  burlywood: Fv,
  cadetblue: Bv,
  chartreuse: Nv,
  chocolate: Lv,
  coral: Uv,
  cornflowerblue: Gv,
  cornsilk: kv,
  crimson: Hv,
  cyan: Xv,
  darkblue: jv,
  darkcyan: Yv,
  darkgoldenrod: Vv,
  darkgray: zv,
  darkgreen: Wv,
  darkgrey: $v,
  darkkhaki: qv,
  darkmagenta: Kv,
  darkolivegreen: Zv,
  darkorange: Jv,
  darkorchid: Qv,
  darkred: t_,
  darksalmon: e_,
  darkseagreen: r_,
  darkslateblue: n_,
  darkslategray: i_,
  darkslategrey: o_,
  darkturquoise: a_,
  darkviolet: s_,
  deeppink: h_,
  deepskyblue: u_,
  dimgray: l_,
  dimgrey: f_,
  dodgerblue: c_,
  firebrick: d_,
  floralwhite: p_,
  forestgreen: v_,
  fuchsia: __,
  gainsboro: m_,
  ghostwhite: y_,
  goldenrod: g_,
  gold: b_,
  gray: x_,
  green: T_,
  greenyellow: E_,
  grey: w_,
  honeydew: S_,
  hotpink: A_,
  indianred: P_,
  indigo: O_,
  ivory: R_,
  khaki: I_,
  lavenderblush: C_,
  lavender: M_,
  lawngreen: D_,
  lemonchiffon: F_,
  lightblue: B_,
  lightcoral: N_,
  lightcyan: L_,
  lightgoldenrodyellow: U_,
  lightgray: G_,
  lightgreen: k_,
  lightgrey: H_,
  lightpink: X_,
  lightsalmon: j_,
  lightseagreen: Y_,
  lightskyblue: V_,
  lightslategray: z_,
  lightslategrey: W_,
  lightsteelblue: $_,
  lightyellow: q_,
  lime: K_,
  limegreen: Z_,
  linen: J_,
  magenta: Q_,
  maroon: tm,
  mediumaquamarine: em,
  mediumblue: rm,
  mediumorchid: nm,
  mediumpurple: im,
  mediumseagreen: om,
  mediumslateblue: am,
  mediumspringgreen: sm,
  mediumturquoise: hm,
  mediumvioletred: um,
  midnightblue: lm,
  mintcream: fm,
  mistyrose: cm,
  moccasin: dm,
  navajowhite: pm,
  navy: vm,
  oldlace: _m,
  olive: mm,
  olivedrab: ym,
  orange: gm,
  orangered: bm,
  orchid: xm,
  palegoldenrod: Tm,
  palegreen: Em,
  paleturquoise: wm,
  palevioletred: Sm,
  papayawhip: Am,
  peachpuff: Pm,
  peru: Om,
  pink: Rm,
  plum: Im,
  powderblue: Cm,
  purple: Mm,
  rebeccapurple: Dm,
  red: Fm,
  rosybrown: Bm,
  royalblue: Nm,
  saddlebrown: Lm,
  salmon: Um,
  sandybrown: Gm,
  seagreen: km,
  seashell: Hm,
  sienna: Xm,
  silver: jm,
  skyblue: Ym,
  slateblue: Vm,
  slategray: zm,
  slategrey: Wm,
  snow: $m,
  springgreen: qm,
  steelblue: Km,
  tan: Zm,
  teal: Jm,
  thistle: Qm,
  tomato: ty,
  turquoise: ey,
  violet: ry,
  wheat: ny,
  white: iy,
  whitesmoke: oy,
  yellow: ay,
  yellowgreen: sy
};
function jr(r, t) {
  return t === void 0 && (t = []), t[0] = (r >> 16 & 255) / 255, t[1] = (r >> 8 & 255) / 255, t[2] = (r & 255) / 255, t;
}
function sl(r) {
  var t = r.toString(16);
  return t = "000000".substring(0, 6 - t.length) + t, "#" + t;
}
function Yr(r) {
  return typeof r == "string" && (r = hy[r.toLowerCase()] || r, r[0] === "#" && (r = r.slice(1))), parseInt(r, 16);
}
function uy() {
  for (var r = [], t = [], e = 0; e < 32; e++)
    r[e] = e, t[e] = e;
  r[Y.NORMAL_NPM] = Y.NORMAL, r[Y.ADD_NPM] = Y.ADD, r[Y.SCREEN_NPM] = Y.SCREEN, t[Y.NORMAL] = Y.NORMAL_NPM, t[Y.ADD] = Y.ADD_NPM, t[Y.SCREEN] = Y.SCREEN_NPM;
  var n = [];
  return n.push(t), n.push(r), n;
}
var hl = uy();
function ul(r, t) {
  return hl[t ? 1 : 0][r];
}
function ly(r, t, e, n) {
  return e = e || new Float32Array(4), n || n === void 0 ? (e[0] = r[0] * t, e[1] = r[1] * t, e[2] = r[2] * t) : (e[0] = r[0], e[1] = r[1], e[2] = r[2]), e[3] = t, e;
}
function Za(r, t) {
  if (t === 1)
    return (t * 255 << 24) + r;
  if (t === 0)
    return 0;
  var e = r >> 16 & 255, n = r >> 8 & 255, i = r & 255;
  return e = e * t + 0.5 | 0, n = n * t + 0.5 | 0, i = i * t + 0.5 | 0, (t * 255 << 24) + (e << 16) + (n << 8) + i;
}
function ll(r, t, e, n) {
  return e = e || new Float32Array(4), e[0] = (r >> 16 & 255) / 255, e[1] = (r >> 8 & 255) / 255, e[2] = (r & 255) / 255, (n || n === void 0) && (e[0] *= t, e[1] *= t, e[2] *= t), e[3] = t, e;
}
function fy(r, t) {
  t === void 0 && (t = null);
  var e = r * 6;
  if (t = t || new Uint16Array(e), t.length !== e)
    throw new Error("Out buffer length is incorrect, got " + t.length + " and expected " + e);
  for (var n = 0, i = 0; n < e; n += 6, i += 4)
    t[n + 0] = i + 0, t[n + 1] = i + 1, t[n + 2] = i + 2, t[n + 3] = i + 0, t[n + 4] = i + 2, t[n + 5] = i + 3;
  return t;
}
function fl(r) {
  if (r.BYTES_PER_ELEMENT === 4)
    return r instanceof Float32Array ? "Float32Array" : r instanceof Uint32Array ? "Uint32Array" : "Int32Array";
  if (r.BYTES_PER_ELEMENT === 2) {
    if (r instanceof Uint16Array)
      return "Uint16Array";
  } else if (r.BYTES_PER_ELEMENT === 1 && r instanceof Uint8Array)
    return "Uint8Array";
  return null;
}
function Si(r) {
  return r += r === 0 ? 1 : 0, --r, r |= r >>> 1, r |= r >>> 2, r |= r >>> 4, r |= r >>> 8, r |= r >>> 16, r + 1;
}
function vh(r) {
  return !(r & r - 1) && !!r;
}
function _h(r) {
  var t = (r > 65535 ? 1 : 0) << 4;
  r >>>= t;
  var e = (r > 255 ? 1 : 0) << 3;
  return r >>>= e, t |= e, e = (r > 15 ? 1 : 0) << 2, r >>>= e, t |= e, e = (r > 3 ? 1 : 0) << 1, r >>>= e, t |= e, t | r >> 1;
}
function Nr(r, t, e) {
  var n = r.length, i;
  if (!(t >= n || e === 0)) {
    e = t + e > n ? n - t : e;
    var o = n - e;
    for (i = t; i < o; ++i)
      r[i] = r[i + e];
    r.length = o;
  }
}
function Ir(r) {
  return r === 0 ? 0 : r < 0 ? -1 : 1;
}
var cy = 0;
function lr() {
  return ++cy;
}
var mh = {};
function ce(r, t, e) {
  if (e === void 0 && (e = 3), !mh[t]) {
    var n = new Error().stack;
    typeof n > "u" ? console.warn("PixiJS Deprecation Warning: ", t + `
Deprecated since v` + r) : (n = n.split(`
`).splice(e).join(`
`), console.groupCollapsed ? (console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", t + `
Deprecated since v` + r), console.warn(n), console.groupEnd()) : (console.warn("PixiJS Deprecation Warning: ", t + `
Deprecated since v` + r), console.warn(n))), mh[t] = !0;
  }
}
var yh = {}, Ae = /* @__PURE__ */ Object.create(null), ze = /* @__PURE__ */ Object.create(null), gh = (
  /** @class */
  function() {
    function r(t, e, n) {
      this.canvas = G.ADAPTER.createCanvas(), this.context = this.canvas.getContext("2d"), this.resolution = n || G.RESOLUTION, this.resize(t, e);
    }
    return r.prototype.clear = function() {
      this.context.setTransform(1, 0, 0, 1, 0, 0), this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }, r.prototype.resize = function(t, e) {
      this.canvas.width = Math.round(t * this.resolution), this.canvas.height = Math.round(e * this.resolution);
    }, r.prototype.destroy = function() {
      this.context = null, this.canvas = null;
    }, Object.defineProperty(r.prototype, "width", {
      /**
       * The width of the canvas buffer in pixels.
       * @member {number}
       */
      get: function() {
        return this.canvas.width;
      },
      set: function(t) {
        this.canvas.width = Math.round(t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "height", {
      /**
       * The height of the canvas buffer in pixels.
       * @member {number}
       */
      get: function() {
        return this.canvas.height;
      },
      set: function(t) {
        this.canvas.height = Math.round(t);
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }()
);
function dy(r) {
  var t = r.width, e = r.height, n = r.getContext("2d", {
    willReadFrequently: !0
  }), i = n.getImageData(0, 0, t, e), o = i.data, a = o.length, s = {
    top: null,
    left: null,
    right: null,
    bottom: null
  }, h = null, u, l, f;
  for (u = 0; u < a; u += 4)
    o[u + 3] !== 0 && (l = u / 4 % t, f = ~~(u / 4 / t), s.top === null && (s.top = f), (s.left === null || l < s.left) && (s.left = l), (s.right === null || s.right < l) && (s.right = l + 1), (s.bottom === null || s.bottom < f) && (s.bottom = f));
  return s.top !== null && (t = s.right - s.left, e = s.bottom - s.top + 1, h = n.getImageData(s.left, s.top, t, e)), {
    height: e,
    width: t,
    data: h
  };
}
var Hn;
function py(r, t) {
  if (t === void 0 && (t = globalThis.location), r.indexOf("data:") === 0)
    return "";
  t = t || globalThis.location, Hn || (Hn = document.createElement("a")), Hn.href = r;
  var e = Rr.parse(Hn.href), n = !e.port && t.port === "" || e.port === t.port;
  return e.hostname !== t.hostname || !n || e.protocol !== t.protocol ? "anonymous" : "";
}
function Ai(r, t) {
  var e = G.RETINA_PREFIX.exec(r);
  return e ? parseFloat(e[1]) : t !== void 0 ? t : 1;
}
/*!
 * @pixi/math - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/math is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var Pi = Math.PI * 2, vy = 180 / Math.PI, _y = Math.PI / 180, Nt;
(function(r) {
  r[r.POLY = 0] = "POLY", r[r.RECT = 1] = "RECT", r[r.CIRC = 2] = "CIRC", r[r.ELIP = 3] = "ELIP", r[r.RREC = 4] = "RREC";
})(Nt || (Nt = {}));
var Et = (
  /** @class */
  function() {
    function r(t, e) {
      t === void 0 && (t = 0), e === void 0 && (e = 0), this.x = 0, this.y = 0, this.x = t, this.y = e;
    }
    return r.prototype.clone = function() {
      return new r(this.x, this.y);
    }, r.prototype.copyFrom = function(t) {
      return this.set(t.x, t.y), this;
    }, r.prototype.copyTo = function(t) {
      return t.set(this.x, this.y), t;
    }, r.prototype.equals = function(t) {
      return t.x === this.x && t.y === this.y;
    }, r.prototype.set = function(t, e) {
      return t === void 0 && (t = 0), e === void 0 && (e = t), this.x = t, this.y = e, this;
    }, r.prototype.toString = function() {
      return "[@pixi/math:Point x=" + this.x + " y=" + this.y + "]";
    }, r;
  }()
), Xn = [new Et(), new Et(), new Et(), new Et()], ut = (
  /** @class */
  function() {
    function r(t, e, n, i) {
      t === void 0 && (t = 0), e === void 0 && (e = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.x = Number(t), this.y = Number(e), this.width = Number(n), this.height = Number(i), this.type = Nt.RECT;
    }
    return Object.defineProperty(r.prototype, "left", {
      /** Returns the left edge of the rectangle. */
      get: function() {
        return this.x;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "right", {
      /** Returns the right edge of the rectangle. */
      get: function() {
        return this.x + this.width;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "top", {
      /** Returns the top edge of the rectangle. */
      get: function() {
        return this.y;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "bottom", {
      /** Returns the bottom edge of the rectangle. */
      get: function() {
        return this.y + this.height;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r, "EMPTY", {
      /** A constant empty rectangle. */
      get: function() {
        return new r(0, 0, 0, 0);
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.clone = function() {
      return new r(this.x, this.y, this.width, this.height);
    }, r.prototype.copyFrom = function(t) {
      return this.x = t.x, this.y = t.y, this.width = t.width, this.height = t.height, this;
    }, r.prototype.copyTo = function(t) {
      return t.x = this.x, t.y = this.y, t.width = this.width, t.height = this.height, t;
    }, r.prototype.contains = function(t, e) {
      return this.width <= 0 || this.height <= 0 ? !1 : t >= this.x && t < this.x + this.width && e >= this.y && e < this.y + this.height;
    }, r.prototype.intersects = function(t, e) {
      if (!e) {
        var n = this.x < t.x ? t.x : this.x, i = this.right > t.right ? t.right : this.right;
        if (i <= n)
          return !1;
        var o = this.y < t.y ? t.y : this.y, a = this.bottom > t.bottom ? t.bottom : this.bottom;
        return a > o;
      }
      var s = this.left, h = this.right, u = this.top, l = this.bottom;
      if (h <= s || l <= u)
        return !1;
      var f = Xn[0].set(t.left, t.top), c = Xn[1].set(t.left, t.bottom), d = Xn[2].set(t.right, t.top), p = Xn[3].set(t.right, t.bottom);
      if (d.x <= f.x || c.y <= f.y)
        return !1;
      var v = Math.sign(e.a * e.d - e.b * e.c);
      if (v === 0 || (e.apply(f, f), e.apply(c, c), e.apply(d, d), e.apply(p, p), Math.max(f.x, c.x, d.x, p.x) <= s || Math.min(f.x, c.x, d.x, p.x) >= h || Math.max(f.y, c.y, d.y, p.y) <= u || Math.min(f.y, c.y, d.y, p.y) >= l))
        return !1;
      var _ = v * (c.y - f.y), m = v * (f.x - c.x), y = _ * s + m * u, g = _ * h + m * u, x = _ * s + m * l, T = _ * h + m * l;
      if (Math.max(y, g, x, T) <= _ * f.x + m * f.y || Math.min(y, g, x, T) >= _ * p.x + m * p.y)
        return !1;
      var E = v * (f.y - d.y), P = v * (d.x - f.x), b = E * s + P * u, w = E * h + P * u, A = E * s + P * l, R = E * h + P * l;
      return !(Math.max(b, w, A, R) <= E * f.x + P * f.y || Math.min(b, w, A, R) >= E * p.x + P * p.y);
    }, r.prototype.pad = function(t, e) {
      return t === void 0 && (t = 0), e === void 0 && (e = t), this.x -= t, this.y -= e, this.width += t * 2, this.height += e * 2, this;
    }, r.prototype.fit = function(t) {
      var e = Math.max(this.x, t.x), n = Math.min(this.x + this.width, t.x + t.width), i = Math.max(this.y, t.y), o = Math.min(this.y + this.height, t.y + t.height);
      return this.x = e, this.width = Math.max(n - e, 0), this.y = i, this.height = Math.max(o - i, 0), this;
    }, r.prototype.ceil = function(t, e) {
      t === void 0 && (t = 1), e === void 0 && (e = 1e-3);
      var n = Math.ceil((this.x + this.width - e) * t) / t, i = Math.ceil((this.y + this.height - e) * t) / t;
      return this.x = Math.floor((this.x + e) * t) / t, this.y = Math.floor((this.y + e) * t) / t, this.width = n - this.x, this.height = i - this.y, this;
    }, r.prototype.enlarge = function(t) {
      var e = Math.min(this.x, t.x), n = Math.max(this.x + this.width, t.x + t.width), i = Math.min(this.y, t.y), o = Math.max(this.y + this.height, t.y + t.height);
      return this.x = e, this.width = n - e, this.y = i, this.height = o - i, this;
    }, r.prototype.toString = function() {
      return "[@pixi/math:Rectangle x=" + this.x + " y=" + this.y + " width=" + this.width + " height=" + this.height + "]";
    }, r;
  }()
), my = (
  /** @class */
  function() {
    function r(t, e, n) {
      t === void 0 && (t = 0), e === void 0 && (e = 0), n === void 0 && (n = 0), this.x = t, this.y = e, this.radius = n, this.type = Nt.CIRC;
    }
    return r.prototype.clone = function() {
      return new r(this.x, this.y, this.radius);
    }, r.prototype.contains = function(t, e) {
      if (this.radius <= 0)
        return !1;
      var n = this.radius * this.radius, i = this.x - t, o = this.y - e;
      return i *= i, o *= o, i + o <= n;
    }, r.prototype.getBounds = function() {
      return new ut(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
    }, r.prototype.toString = function() {
      return "[@pixi/math:Circle x=" + this.x + " y=" + this.y + " radius=" + this.radius + "]";
    }, r;
  }()
), yy = (
  /** @class */
  function() {
    function r(t, e, n, i) {
      t === void 0 && (t = 0), e === void 0 && (e = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.x = t, this.y = e, this.width = n, this.height = i, this.type = Nt.ELIP;
    }
    return r.prototype.clone = function() {
      return new r(this.x, this.y, this.width, this.height);
    }, r.prototype.contains = function(t, e) {
      if (this.width <= 0 || this.height <= 0)
        return !1;
      var n = (t - this.x) / this.width, i = (e - this.y) / this.height;
      return n *= n, i *= i, n + i <= 1;
    }, r.prototype.getBounds = function() {
      return new ut(this.x - this.width, this.y - this.height, this.width, this.height);
    }, r.prototype.toString = function() {
      return "[@pixi/math:Ellipse x=" + this.x + " y=" + this.y + " width=" + this.width + " height=" + this.height + "]";
    }, r;
  }()
), ci = (
  /** @class */
  function() {
    function r() {
      for (var t = arguments, e = [], n = 0; n < arguments.length; n++)
        e[n] = t[n];
      var i = Array.isArray(e[0]) ? e[0] : e;
      if (typeof i[0] != "number") {
        for (var o = [], a = 0, s = i.length; a < s; a++)
          o.push(i[a].x, i[a].y);
        i = o;
      }
      this.points = i, this.type = Nt.POLY, this.closeStroke = !0;
    }
    return r.prototype.clone = function() {
      var t = this.points.slice(), e = new r(t);
      return e.closeStroke = this.closeStroke, e;
    }, r.prototype.contains = function(t, e) {
      for (var n = !1, i = this.points.length / 2, o = 0, a = i - 1; o < i; a = o++) {
        var s = this.points[o * 2], h = this.points[o * 2 + 1], u = this.points[a * 2], l = this.points[a * 2 + 1], f = h > e != l > e && t < (u - s) * ((e - h) / (l - h)) + s;
        f && (n = !n);
      }
      return n;
    }, r.prototype.toString = function() {
      return "[@pixi/math:Polygon" + ("closeStroke=" + this.closeStroke) + ("points=" + this.points.reduce(function(t, e) {
        return t + ", " + e;
      }, "") + "]");
    }, r;
  }()
), gy = (
  /** @class */
  function() {
    function r(t, e, n, i, o) {
      t === void 0 && (t = 0), e === void 0 && (e = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), o === void 0 && (o = 20), this.x = t, this.y = e, this.width = n, this.height = i, this.radius = o, this.type = Nt.RREC;
    }
    return r.prototype.clone = function() {
      return new r(this.x, this.y, this.width, this.height, this.radius);
    }, r.prototype.contains = function(t, e) {
      if (this.width <= 0 || this.height <= 0)
        return !1;
      if (t >= this.x && t <= this.x + this.width && e >= this.y && e <= this.y + this.height) {
        var n = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
        if (e >= this.y + n && e <= this.y + this.height - n || t >= this.x + n && t <= this.x + this.width - n)
          return !0;
        var i = t - (this.x + n), o = e - (this.y + n), a = n * n;
        if (i * i + o * o <= a || (i = t - (this.x + this.width - n), i * i + o * o <= a) || (o = e - (this.y + this.height - n), i * i + o * o <= a) || (i = t - (this.x + n), i * i + o * o <= a))
          return !0;
      }
      return !1;
    }, r.prototype.toString = function() {
      return "[@pixi/math:RoundedRectangle x=" + this.x + " y=" + this.y + ("width=" + this.width + " height=" + this.height + " radius=" + this.radius + "]");
    }, r;
  }()
), Cr = (
  /** @class */
  function() {
    function r(t, e, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = 0), this._x = n, this._y = i, this.cb = t, this.scope = e;
    }
    return r.prototype.clone = function(t, e) {
      return t === void 0 && (t = this.cb), e === void 0 && (e = this.scope), new r(t, e, this._x, this._y);
    }, r.prototype.set = function(t, e) {
      return t === void 0 && (t = 0), e === void 0 && (e = t), (this._x !== t || this._y !== e) && (this._x = t, this._y = e, this.cb.call(this.scope)), this;
    }, r.prototype.copyFrom = function(t) {
      return (this._x !== t.x || this._y !== t.y) && (this._x = t.x, this._y = t.y, this.cb.call(this.scope)), this;
    }, r.prototype.copyTo = function(t) {
      return t.set(this._x, this._y), t;
    }, r.prototype.equals = function(t) {
      return t.x === this._x && t.y === this._y;
    }, r.prototype.toString = function() {
      return "[@pixi/math:ObservablePoint x=0 y=0 scope=" + this.scope + "]";
    }, Object.defineProperty(r.prototype, "x", {
      /** Position of the observable point on the x axis. */
      get: function() {
        return this._x;
      },
      set: function(t) {
        this._x !== t && (this._x = t, this.cb.call(this.scope));
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "y", {
      /** Position of the observable point on the y axis. */
      get: function() {
        return this._y;
      },
      set: function(t) {
        this._y !== t && (this._y = t, this.cb.call(this.scope));
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }()
), Dt = (
  /** @class */
  function() {
    function r(t, e, n, i, o, a) {
      t === void 0 && (t = 1), e === void 0 && (e = 0), n === void 0 && (n = 0), i === void 0 && (i = 1), o === void 0 && (o = 0), a === void 0 && (a = 0), this.array = null, this.a = t, this.b = e, this.c = n, this.d = i, this.tx = o, this.ty = a;
    }
    return r.prototype.fromArray = function(t) {
      this.a = t[0], this.b = t[1], this.c = t[3], this.d = t[4], this.tx = t[2], this.ty = t[5];
    }, r.prototype.set = function(t, e, n, i, o, a) {
      return this.a = t, this.b = e, this.c = n, this.d = i, this.tx = o, this.ty = a, this;
    }, r.prototype.toArray = function(t, e) {
      this.array || (this.array = new Float32Array(9));
      var n = e || this.array;
      return t ? (n[0] = this.a, n[1] = this.b, n[2] = 0, n[3] = this.c, n[4] = this.d, n[5] = 0, n[6] = this.tx, n[7] = this.ty, n[8] = 1) : (n[0] = this.a, n[1] = this.c, n[2] = this.tx, n[3] = this.b, n[4] = this.d, n[5] = this.ty, n[6] = 0, n[7] = 0, n[8] = 1), n;
    }, r.prototype.apply = function(t, e) {
      e = e || new Et();
      var n = t.x, i = t.y;
      return e.x = this.a * n + this.c * i + this.tx, e.y = this.b * n + this.d * i + this.ty, e;
    }, r.prototype.applyInverse = function(t, e) {
      e = e || new Et();
      var n = 1 / (this.a * this.d + this.c * -this.b), i = t.x, o = t.y;
      return e.x = this.d * n * i + -this.c * n * o + (this.ty * this.c - this.tx * this.d) * n, e.y = this.a * n * o + -this.b * n * i + (-this.ty * this.a + this.tx * this.b) * n, e;
    }, r.prototype.translate = function(t, e) {
      return this.tx += t, this.ty += e, this;
    }, r.prototype.scale = function(t, e) {
      return this.a *= t, this.d *= e, this.c *= t, this.b *= e, this.tx *= t, this.ty *= e, this;
    }, r.prototype.rotate = function(t) {
      var e = Math.cos(t), n = Math.sin(t), i = this.a, o = this.c, a = this.tx;
      return this.a = i * e - this.b * n, this.b = i * n + this.b * e, this.c = o * e - this.d * n, this.d = o * n + this.d * e, this.tx = a * e - this.ty * n, this.ty = a * n + this.ty * e, this;
    }, r.prototype.append = function(t) {
      var e = this.a, n = this.b, i = this.c, o = this.d;
      return this.a = t.a * e + t.b * i, this.b = t.a * n + t.b * o, this.c = t.c * e + t.d * i, this.d = t.c * n + t.d * o, this.tx = t.tx * e + t.ty * i + this.tx, this.ty = t.tx * n + t.ty * o + this.ty, this;
    }, r.prototype.setTransform = function(t, e, n, i, o, a, s, h, u) {
      return this.a = Math.cos(s + u) * o, this.b = Math.sin(s + u) * o, this.c = -Math.sin(s - h) * a, this.d = Math.cos(s - h) * a, this.tx = t - (n * this.a + i * this.c), this.ty = e - (n * this.b + i * this.d), this;
    }, r.prototype.prepend = function(t) {
      var e = this.tx;
      if (t.a !== 1 || t.b !== 0 || t.c !== 0 || t.d !== 1) {
        var n = this.a, i = this.c;
        this.a = n * t.a + this.b * t.c, this.b = n * t.b + this.b * t.d, this.c = i * t.a + this.d * t.c, this.d = i * t.b + this.d * t.d;
      }
      return this.tx = e * t.a + this.ty * t.c + t.tx, this.ty = e * t.b + this.ty * t.d + t.ty, this;
    }, r.prototype.decompose = function(t) {
      var e = this.a, n = this.b, i = this.c, o = this.d, a = t.pivot, s = -Math.atan2(-i, o), h = Math.atan2(n, e), u = Math.abs(s + h);
      return u < 1e-5 || Math.abs(Pi - u) < 1e-5 ? (t.rotation = h, t.skew.x = t.skew.y = 0) : (t.rotation = 0, t.skew.x = s, t.skew.y = h), t.scale.x = Math.sqrt(e * e + n * n), t.scale.y = Math.sqrt(i * i + o * o), t.position.x = this.tx + (a.x * e + a.y * i), t.position.y = this.ty + (a.x * n + a.y * o), t;
    }, r.prototype.invert = function() {
      var t = this.a, e = this.b, n = this.c, i = this.d, o = this.tx, a = t * i - e * n;
      return this.a = i / a, this.b = -e / a, this.c = -n / a, this.d = t / a, this.tx = (n * this.ty - i * o) / a, this.ty = -(t * this.ty - e * o) / a, this;
    }, r.prototype.identity = function() {
      return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0, this;
    }, r.prototype.clone = function() {
      var t = new r();
      return t.a = this.a, t.b = this.b, t.c = this.c, t.d = this.d, t.tx = this.tx, t.ty = this.ty, t;
    }, r.prototype.copyTo = function(t) {
      return t.a = this.a, t.b = this.b, t.c = this.c, t.d = this.d, t.tx = this.tx, t.ty = this.ty, t;
    }, r.prototype.copyFrom = function(t) {
      return this.a = t.a, this.b = t.b, this.c = t.c, this.d = t.d, this.tx = t.tx, this.ty = t.ty, this;
    }, r.prototype.toString = function() {
      return "[@pixi/math:Matrix a=" + this.a + " b=" + this.b + " c=" + this.c + " d=" + this.d + " tx=" + this.tx + " ty=" + this.ty + "]";
    }, Object.defineProperty(r, "IDENTITY", {
      /**
       * A default (identity) matrix
       * @readonly
       */
      get: function() {
        return new r();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r, "TEMP_MATRIX", {
      /**
       * A temp matrix
       * @readonly
       */
      get: function() {
        return new r();
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }()
), Ze = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1], Je = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1], Qe = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1], tr = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1], ea = [], cl = [], jn = Math.sign;
function by() {
  for (var r = 0; r < 16; r++) {
    var t = [];
    ea.push(t);
    for (var e = 0; e < 16; e++)
      for (var n = jn(Ze[r] * Ze[e] + Qe[r] * Je[e]), i = jn(Je[r] * Ze[e] + tr[r] * Je[e]), o = jn(Ze[r] * Qe[e] + Qe[r] * tr[e]), a = jn(Je[r] * Qe[e] + tr[r] * tr[e]), s = 0; s < 16; s++)
        if (Ze[s] === n && Je[s] === i && Qe[s] === o && tr[s] === a) {
          t.push(s);
          break;
        }
  }
  for (var r = 0; r < 16; r++) {
    var h = new Dt();
    h.set(Ze[r], Je[r], Qe[r], tr[r], 0, 0), cl.push(h);
  }
}
by();
var St = {
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  E: 0,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  SE: 1,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  S: 2,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  SW: 3,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  W: 4,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  NW: 5,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  N: 6,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  NE: 7,
  /**
   * Reflection about Y-axis.
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  MIRROR_VERTICAL: 8,
  /**
   * Reflection about the main diagonal.
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  MAIN_DIAGONAL: 10,
  /**
   * Reflection about X-axis.
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  MIRROR_HORIZONTAL: 12,
  /**
   * Reflection about reverse diagonal.
   * @memberof PIXI.groupD8
   * @constant {PIXI.GD8Symmetry}
   */
  REVERSE_DIAGONAL: 14,
  /**
   * @memberof PIXI.groupD8
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */
  uX: function(r) {
    return Ze[r];
  },
  /**
   * @memberof PIXI.groupD8
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */
  uY: function(r) {
    return Je[r];
  },
  /**
   * @memberof PIXI.groupD8
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */
  vX: function(r) {
    return Qe[r];
  },
  /**
   * @memberof PIXI.groupD8
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */
  vY: function(r) {
    return tr[r];
  },
  /**
   * @memberof PIXI.groupD8
   * @param {PIXI.GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {PIXI.GD8Symmetry} The opposite symmetry of `rotation`
   */
  inv: function(r) {
    return r & 8 ? r & 15 : -r & 7;
  },
  /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @memberof PIXI.groupD8
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {PIXI.GD8Symmetry} Composed operation
   */
  add: function(r, t) {
    return ea[r][t];
  },
  /**
   * Reverse of `add`.
   * @memberof PIXI.groupD8
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation
   * @returns {PIXI.GD8Symmetry} Result
   */
  sub: function(r, t) {
    return ea[r][St.inv(t)];
  },
  /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @memberof PIXI.groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */
  rotate180: function(r) {
    return r ^ 4;
  },
  /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @memberof PIXI.groupD8
   * @param {PIXI.GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */
  isVertical: function(r) {
    return (r & 3) === 2;
  },
  /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @memberof PIXI.groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {PIXI.GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */
  byDirection: function(r, t) {
    return Math.abs(r) * 2 <= Math.abs(t) ? t >= 0 ? St.S : St.N : Math.abs(t) * 2 <= Math.abs(r) ? r > 0 ? St.E : St.W : t > 0 ? r > 0 ? St.SE : St.SW : r > 0 ? St.NE : St.NW;
  },
  /**
   * Helps sprite to compensate texture packer rotation.
   * @memberof PIXI.groupD8
   * @param {PIXI.Matrix} matrix - sprite world matrix
   * @param {PIXI.GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */
  matrixAppendRotationInv: function(r, t, e, n) {
    e === void 0 && (e = 0), n === void 0 && (n = 0);
    var i = cl[St.inv(t)];
    i.tx = e, i.ty = n, r.append(i);
  }
}, dl = (
  /** @class */
  function() {
    function r() {
      this.worldTransform = new Dt(), this.localTransform = new Dt(), this.position = new Cr(this.onChange, this, 0, 0), this.scale = new Cr(this.onChange, this, 1, 1), this.pivot = new Cr(this.onChange, this, 0, 0), this.skew = new Cr(this.updateSkew, this, 0, 0), this._rotation = 0, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1, this._localID = 0, this._currentLocalID = 0, this._worldID = 0, this._parentID = 0;
    }
    return r.prototype.onChange = function() {
      this._localID++;
    }, r.prototype.updateSkew = function() {
      this._cx = Math.cos(this._rotation + this.skew.y), this._sx = Math.sin(this._rotation + this.skew.y), this._cy = -Math.sin(this._rotation - this.skew.x), this._sy = Math.cos(this._rotation - this.skew.x), this._localID++;
    }, r.prototype.toString = function() {
      return "[@pixi/math:Transform " + ("position=(" + this.position.x + ", " + this.position.y + ") ") + ("rotation=" + this.rotation + " ") + ("scale=(" + this.scale.x + ", " + this.scale.y + ") ") + ("skew=(" + this.skew.x + ", " + this.skew.y + ") ") + "]";
    }, r.prototype.updateLocalTransform = function() {
      var t = this.localTransform;
      this._localID !== this._currentLocalID && (t.a = this._cx * this.scale.x, t.b = this._sx * this.scale.x, t.c = this._cy * this.scale.y, t.d = this._sy * this.scale.y, t.tx = this.position.x - (this.pivot.x * t.a + this.pivot.y * t.c), t.ty = this.position.y - (this.pivot.x * t.b + this.pivot.y * t.d), this._currentLocalID = this._localID, this._parentID = -1);
    }, r.prototype.updateTransform = function(t) {
      var e = this.localTransform;
      if (this._localID !== this._currentLocalID && (e.a = this._cx * this.scale.x, e.b = this._sx * this.scale.x, e.c = this._cy * this.scale.y, e.d = this._sy * this.scale.y, e.tx = this.position.x - (this.pivot.x * e.a + this.pivot.y * e.c), e.ty = this.position.y - (this.pivot.x * e.b + this.pivot.y * e.d), this._currentLocalID = this._localID, this._parentID = -1), this._parentID !== t._worldID) {
        var n = t.worldTransform, i = this.worldTransform;
        i.a = e.a * n.a + e.b * n.c, i.b = e.a * n.b + e.b * n.d, i.c = e.c * n.a + e.d * n.c, i.d = e.c * n.b + e.d * n.d, i.tx = e.tx * n.a + e.ty * n.c + n.tx, i.ty = e.tx * n.b + e.ty * n.d + n.ty, this._parentID = t._worldID, this._worldID++;
      }
    }, r.prototype.setFromMatrix = function(t) {
      t.decompose(this), this._localID++;
    }, Object.defineProperty(r.prototype, "rotation", {
      /** The rotation of the object in radians. */
      get: function() {
        return this._rotation;
      },
      set: function(t) {
        this._rotation !== t && (this._rotation = t, this.updateSkew());
      },
      enumerable: !1,
      configurable: !0
    }), r.IDENTITY = new r(), r;
  }()
);
/*!
 * @pixi/display - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/display is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
G.SORTABLE_CHILDREN = !1;
var Oi = (
  /** @class */
  function() {
    function r() {
      this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.rect = null, this.updateID = -1;
    }
    return r.prototype.isEmpty = function() {
      return this.minX > this.maxX || this.minY > this.maxY;
    }, r.prototype.clear = function() {
      this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0;
    }, r.prototype.getRectangle = function(t) {
      return this.minX > this.maxX || this.minY > this.maxY ? ut.EMPTY : (t = t || new ut(0, 0, 1, 1), t.x = this.minX, t.y = this.minY, t.width = this.maxX - this.minX, t.height = this.maxY - this.minY, t);
    }, r.prototype.addPoint = function(t) {
      this.minX = Math.min(this.minX, t.x), this.maxX = Math.max(this.maxX, t.x), this.minY = Math.min(this.minY, t.y), this.maxY = Math.max(this.maxY, t.y);
    }, r.prototype.addPointMatrix = function(t, e) {
      var n = t.a, i = t.b, o = t.c, a = t.d, s = t.tx, h = t.ty, u = n * e.x + o * e.y + s, l = i * e.x + a * e.y + h;
      this.minX = Math.min(this.minX, u), this.maxX = Math.max(this.maxX, u), this.minY = Math.min(this.minY, l), this.maxY = Math.max(this.maxY, l);
    }, r.prototype.addQuad = function(t) {
      var e = this.minX, n = this.minY, i = this.maxX, o = this.maxY, a = t[0], s = t[1];
      e = a < e ? a : e, n = s < n ? s : n, i = a > i ? a : i, o = s > o ? s : o, a = t[2], s = t[3], e = a < e ? a : e, n = s < n ? s : n, i = a > i ? a : i, o = s > o ? s : o, a = t[4], s = t[5], e = a < e ? a : e, n = s < n ? s : n, i = a > i ? a : i, o = s > o ? s : o, a = t[6], s = t[7], e = a < e ? a : e, n = s < n ? s : n, i = a > i ? a : i, o = s > o ? s : o, this.minX = e, this.minY = n, this.maxX = i, this.maxY = o;
    }, r.prototype.addFrame = function(t, e, n, i, o) {
      this.addFrameMatrix(t.worldTransform, e, n, i, o);
    }, r.prototype.addFrameMatrix = function(t, e, n, i, o) {
      var a = t.a, s = t.b, h = t.c, u = t.d, l = t.tx, f = t.ty, c = this.minX, d = this.minY, p = this.maxX, v = this.maxY, _ = a * e + h * n + l, m = s * e + u * n + f;
      c = _ < c ? _ : c, d = m < d ? m : d, p = _ > p ? _ : p, v = m > v ? m : v, _ = a * i + h * n + l, m = s * i + u * n + f, c = _ < c ? _ : c, d = m < d ? m : d, p = _ > p ? _ : p, v = m > v ? m : v, _ = a * e + h * o + l, m = s * e + u * o + f, c = _ < c ? _ : c, d = m < d ? m : d, p = _ > p ? _ : p, v = m > v ? m : v, _ = a * i + h * o + l, m = s * i + u * o + f, c = _ < c ? _ : c, d = m < d ? m : d, p = _ > p ? _ : p, v = m > v ? m : v, this.minX = c, this.minY = d, this.maxX = p, this.maxY = v;
    }, r.prototype.addVertexData = function(t, e, n) {
      for (var i = this.minX, o = this.minY, a = this.maxX, s = this.maxY, h = e; h < n; h += 2) {
        var u = t[h], l = t[h + 1];
        i = u < i ? u : i, o = l < o ? l : o, a = u > a ? u : a, s = l > s ? l : s;
      }
      this.minX = i, this.minY = o, this.maxX = a, this.maxY = s;
    }, r.prototype.addVertices = function(t, e, n, i) {
      this.addVerticesMatrix(t.worldTransform, e, n, i);
    }, r.prototype.addVerticesMatrix = function(t, e, n, i, o, a) {
      o === void 0 && (o = 0), a === void 0 && (a = o);
      for (var s = t.a, h = t.b, u = t.c, l = t.d, f = t.tx, c = t.ty, d = this.minX, p = this.minY, v = this.maxX, _ = this.maxY, m = n; m < i; m += 2) {
        var y = e[m], g = e[m + 1], x = s * y + u * g + f, T = l * g + h * y + c;
        d = Math.min(d, x - o), v = Math.max(v, x + o), p = Math.min(p, T - a), _ = Math.max(_, T + a);
      }
      this.minX = d, this.minY = p, this.maxX = v, this.maxY = _;
    }, r.prototype.addBounds = function(t) {
      var e = this.minX, n = this.minY, i = this.maxX, o = this.maxY;
      this.minX = t.minX < e ? t.minX : e, this.minY = t.minY < n ? t.minY : n, this.maxX = t.maxX > i ? t.maxX : i, this.maxY = t.maxY > o ? t.maxY : o;
    }, r.prototype.addBoundsMask = function(t, e) {
      var n = t.minX > e.minX ? t.minX : e.minX, i = t.minY > e.minY ? t.minY : e.minY, o = t.maxX < e.maxX ? t.maxX : e.maxX, a = t.maxY < e.maxY ? t.maxY : e.maxY;
      if (n <= o && i <= a) {
        var s = this.minX, h = this.minY, u = this.maxX, l = this.maxY;
        this.minX = n < s ? n : s, this.minY = i < h ? i : h, this.maxX = o > u ? o : u, this.maxY = a > l ? a : l;
      }
    }, r.prototype.addBoundsMatrix = function(t, e) {
      this.addFrameMatrix(e, t.minX, t.minY, t.maxX, t.maxY);
    }, r.prototype.addBoundsArea = function(t, e) {
      var n = t.minX > e.x ? t.minX : e.x, i = t.minY > e.y ? t.minY : e.y, o = t.maxX < e.x + e.width ? t.maxX : e.x + e.width, a = t.maxY < e.y + e.height ? t.maxY : e.y + e.height;
      if (n <= o && i <= a) {
        var s = this.minX, h = this.minY, u = this.maxX, l = this.maxY;
        this.minX = n < s ? n : s, this.minY = i < h ? i : h, this.maxX = o > u ? o : u, this.maxY = a > l ? a : l;
      }
    }, r.prototype.pad = function(t, e) {
      t === void 0 && (t = 0), e === void 0 && (e = t), this.isEmpty() || (this.minX -= t, this.maxX += t, this.minY -= e, this.maxY += e);
    }, r.prototype.addFramePad = function(t, e, n, i, o, a) {
      t -= o, e -= a, n += o, i += a, this.minX = this.minX < t ? this.minX : t, this.maxX = this.maxX > n ? this.maxX : n, this.minY = this.minY < e ? this.minY : e, this.maxY = this.maxY > i ? this.maxY : i;
    }, r;
  }()
);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ra = function(r, t) {
  return ra = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, ra(r, t);
};
function Ja(r, t) {
  ra(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var Rt = (
  /** @class */
  function(r) {
    Ja(t, r);
    function t() {
      var e = r.call(this) || this;
      return e.tempDisplayObjectParent = null, e.transform = new dl(), e.alpha = 1, e.visible = !0, e.renderable = !0, e.cullable = !1, e.cullArea = null, e.parent = null, e.worldAlpha = 1, e._lastSortedIndex = 0, e._zIndex = 0, e.filterArea = null, e.filters = null, e._enabledFilters = null, e._bounds = new Oi(), e._localBounds = null, e._boundsID = 0, e._boundsRect = null, e._localBoundsRect = null, e._mask = null, e._maskRefCount = 0, e._destroyed = !1, e.isSprite = !1, e.isMask = !1, e;
    }
    return t.mixin = function(e) {
      for (var n = Object.keys(e), i = 0; i < n.length; ++i) {
        var o = n[i];
        Object.defineProperty(t.prototype, o, Object.getOwnPropertyDescriptor(e, o));
      }
    }, Object.defineProperty(t.prototype, "destroyed", {
      /**
       * Fired when this DisplayObject is added to a Container.
       * @instance
       * @event added
       * @param {PIXI.Container} container - The container added to.
       */
      /**
       * Fired when this DisplayObject is removed from a Container.
       * @instance
       * @event removed
       * @param {PIXI.Container} container - The container removed from.
       */
      /**
       * Fired when this DisplayObject is destroyed. This event is emitted once
       * destroy is finished.
       * @instance
       * @event destroyed
       */
      /** Readonly flag for destroyed display objects. */
      get: function() {
        return this._destroyed;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._recursivePostUpdateTransform = function() {
      this.parent ? (this.parent._recursivePostUpdateTransform(), this.transform.updateTransform(this.parent.transform)) : this.transform.updateTransform(this._tempDisplayObjectParent.transform);
    }, t.prototype.updateTransform = function() {
      this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
    }, t.prototype.getBounds = function(e, n) {
      return e || (this.parent ? (this._recursivePostUpdateTransform(), this.updateTransform()) : (this.parent = this._tempDisplayObjectParent, this.updateTransform(), this.parent = null)), this._bounds.updateID !== this._boundsID && (this.calculateBounds(), this._bounds.updateID = this._boundsID), n || (this._boundsRect || (this._boundsRect = new ut()), n = this._boundsRect), this._bounds.getRectangle(n);
    }, t.prototype.getLocalBounds = function(e) {
      e || (this._localBoundsRect || (this._localBoundsRect = new ut()), e = this._localBoundsRect), this._localBounds || (this._localBounds = new Oi());
      var n = this.transform, i = this.parent;
      this.parent = null, this.transform = this._tempDisplayObjectParent.transform;
      var o = this._bounds, a = this._boundsID;
      this._bounds = this._localBounds;
      var s = this.getBounds(!1, e);
      return this.parent = i, this.transform = n, this._bounds = o, this._bounds.updateID += this._boundsID - a, s;
    }, t.prototype.toGlobal = function(e, n, i) {
      return i === void 0 && (i = !1), i || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.apply(e, n);
    }, t.prototype.toLocal = function(e, n, i, o) {
      return n && (e = n.toGlobal(e, i, o)), o || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.applyInverse(e, i);
    }, t.prototype.setParent = function(e) {
      if (!e || !e.addChild)
        throw new Error("setParent: Argument must be a Container");
      return e.addChild(this), e;
    }, t.prototype.setTransform = function(e, n, i, o, a, s, h, u, l) {
      return e === void 0 && (e = 0), n === void 0 && (n = 0), i === void 0 && (i = 1), o === void 0 && (o = 1), a === void 0 && (a = 0), s === void 0 && (s = 0), h === void 0 && (h = 0), u === void 0 && (u = 0), l === void 0 && (l = 0), this.position.x = e, this.position.y = n, this.scale.x = i || 1, this.scale.y = o || 1, this.rotation = a, this.skew.x = s, this.skew.y = h, this.pivot.x = u, this.pivot.y = l, this;
    }, t.prototype.destroy = function(e) {
      this.parent && this.parent.removeChild(this), this._destroyed = !0, this.transform = null, this.parent = null, this._bounds = null, this.mask = null, this.cullArea = null, this.filters = null, this.filterArea = null, this.hitArea = null, this.interactive = !1, this.interactiveChildren = !1, this.emit("destroyed"), this.removeAllListeners();
    }, Object.defineProperty(t.prototype, "_tempDisplayObjectParent", {
      /**
       * @protected
       * @member {PIXI.Container}
       */
      get: function() {
        return this.tempDisplayObjectParent === null && (this.tempDisplayObjectParent = new pl()), this.tempDisplayObjectParent;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.enableTempParent = function() {
      var e = this.parent;
      return this.parent = this._tempDisplayObjectParent, e;
    }, t.prototype.disableTempParent = function(e) {
      this.parent = e;
    }, Object.defineProperty(t.prototype, "x", {
      /**
       * The position of the displayObject on the x axis relative to the local coordinates of the parent.
       * An alias to position.x
       */
      get: function() {
        return this.position.x;
      },
      set: function(e) {
        this.transform.position.x = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "y", {
      /**
       * The position of the displayObject on the y axis relative to the local coordinates of the parent.
       * An alias to position.y
       */
      get: function() {
        return this.position.y;
      },
      set: function(e) {
        this.transform.position.y = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "worldTransform", {
      /**
       * Current transform of the object based on world (parent) factors.
       * @readonly
       */
      get: function() {
        return this.transform.worldTransform;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "localTransform", {
      /**
       * Current transform of the object based on local factors: position, scale, other stuff.
       * @readonly
       */
      get: function() {
        return this.transform.localTransform;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "position", {
      /**
       * The coordinate of the object relative to the local coordinates of the parent.
       * @since 4.0.0
       */
      get: function() {
        return this.transform.position;
      },
      set: function(e) {
        this.transform.position.copyFrom(e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "scale", {
      /**
       * The scale factors of this object along the local coordinate axes.
       *
       * The default scale is (1, 1).
       * @since 4.0.0
       */
      get: function() {
        return this.transform.scale;
      },
      set: function(e) {
        this.transform.scale.copyFrom(e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "pivot", {
      /**
       * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
       * is the projection of `pivot` in the parent's local space.
       *
       * By default, the pivot is the origin (0, 0).
       * @since 4.0.0
       */
      get: function() {
        return this.transform.pivot;
      },
      set: function(e) {
        this.transform.pivot.copyFrom(e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "skew", {
      /**
       * The skew factor for the object in radians.
       * @since 4.0.0
       */
      get: function() {
        return this.transform.skew;
      },
      set: function(e) {
        this.transform.skew.copyFrom(e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "rotation", {
      /**
       * The rotation of the object in radians.
       * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
       */
      get: function() {
        return this.transform.rotation;
      },
      set: function(e) {
        this.transform.rotation = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "angle", {
      /**
       * The angle of the object in degrees.
       * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
       */
      get: function() {
        return this.transform.rotation * vy;
      },
      set: function(e) {
        this.transform.rotation = e * _y;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "zIndex", {
      /**
       * The zIndex of the displayObject.
       *
       * If a container has the sortableChildren property set to true, children will be automatically
       * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
       * and thus rendered on top of other display objects within the same container.
       * @see PIXI.Container#sortableChildren
       */
      get: function() {
        return this._zIndex;
      },
      set: function(e) {
        this._zIndex = e, this.parent && (this.parent.sortDirty = !0);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "worldVisible", {
      /**
       * Indicates if the object is globally visible.
       * @readonly
       */
      get: function() {
        var e = this;
        do {
          if (!e.visible)
            return !1;
          e = e.parent;
        } while (e);
        return !0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "mask", {
      /**
       * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
       * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
       * {@link PIXI.Graphics} or a {@link PIXI.Sprite} object. This allows for much faster masking in canvas as it
       * utilities shape clipping. Furthermore, a mask of an object must be in the subtree of its parent.
       * Otherwise, `getLocalBounds` may calculate incorrect bounds, which makes the container's width and height wrong.
       * To remove a mask, set this property to `null`.
       *
       * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
       * @example
       * const graphics = new PIXI.Graphics();
       * graphics.beginFill(0xFF3300);
       * graphics.drawRect(50, 250, 100, 100);
       * graphics.endFill();
       *
       * const sprite = new PIXI.Sprite(texture);
       * sprite.mask = graphics;
       * @todo At the moment, PIXI.CanvasRenderer doesn't support PIXI.Sprite as mask.
       */
      get: function() {
        return this._mask;
      },
      set: function(e) {
        if (this._mask !== e) {
          if (this._mask) {
            var n = this._mask.isMaskData ? this._mask.maskObject : this._mask;
            n && (n._maskRefCount--, n._maskRefCount === 0 && (n.renderable = !0, n.isMask = !1));
          }
          if (this._mask = e, this._mask) {
            var n = this._mask.isMaskData ? this._mask.maskObject : this._mask;
            n && (n._maskRefCount === 0 && (n.renderable = !1, n.isMask = !0), n._maskRefCount++);
          }
        }
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Sn)
), pl = (
  /** @class */
  function(r) {
    Ja(t, r);
    function t() {
      var e = r !== null && r.apply(this, arguments) || this;
      return e.sortDirty = null, e;
    }
    return t;
  }(Rt)
);
Rt.prototype.displayObjectUpdateTransform = Rt.prototype.updateTransform;
function xy(r, t) {
  return r.zIndex === t.zIndex ? r._lastSortedIndex - t._lastSortedIndex : r.zIndex - t.zIndex;
}
var Te = (
  /** @class */
  function(r) {
    Ja(t, r);
    function t() {
      var e = r.call(this) || this;
      return e.children = [], e.sortableChildren = G.SORTABLE_CHILDREN, e.sortDirty = !1, e;
    }
    return t.prototype.onChildrenChange = function(e) {
    }, t.prototype.addChild = function() {
      for (var e = arguments, n = [], i = 0; i < arguments.length; i++)
        n[i] = e[i];
      if (n.length > 1)
        for (var o = 0; o < n.length; o++)
          this.addChild(n[o]);
      else {
        var a = n[0];
        a.parent && a.parent.removeChild(a), a.parent = this, this.sortDirty = !0, a.transform._parentID = -1, this.children.push(a), this._boundsID++, this.onChildrenChange(this.children.length - 1), this.emit("childAdded", a, this, this.children.length - 1), a.emit("added", this);
      }
      return n[0];
    }, t.prototype.addChildAt = function(e, n) {
      if (n < 0 || n > this.children.length)
        throw new Error(e + "addChildAt: The index " + n + " supplied is out of bounds " + this.children.length);
      return e.parent && e.parent.removeChild(e), e.parent = this, this.sortDirty = !0, e.transform._parentID = -1, this.children.splice(n, 0, e), this._boundsID++, this.onChildrenChange(n), e.emit("added", this), this.emit("childAdded", e, this, n), e;
    }, t.prototype.swapChildren = function(e, n) {
      if (e !== n) {
        var i = this.getChildIndex(e), o = this.getChildIndex(n);
        this.children[i] = n, this.children[o] = e, this.onChildrenChange(i < o ? i : o);
      }
    }, t.prototype.getChildIndex = function(e) {
      var n = this.children.indexOf(e);
      if (n === -1)
        throw new Error("The supplied DisplayObject must be a child of the caller");
      return n;
    }, t.prototype.setChildIndex = function(e, n) {
      if (n < 0 || n >= this.children.length)
        throw new Error("The index " + n + " supplied is out of bounds " + this.children.length);
      var i = this.getChildIndex(e);
      Nr(this.children, i, 1), this.children.splice(n, 0, e), this.onChildrenChange(n);
    }, t.prototype.getChildAt = function(e) {
      if (e < 0 || e >= this.children.length)
        throw new Error("getChildAt: Index (" + e + ") does not exist.");
      return this.children[e];
    }, t.prototype.removeChild = function() {
      for (var e = arguments, n = [], i = 0; i < arguments.length; i++)
        n[i] = e[i];
      if (n.length > 1)
        for (var o = 0; o < n.length; o++)
          this.removeChild(n[o]);
      else {
        var a = n[0], s = this.children.indexOf(a);
        if (s === -1)
          return null;
        a.parent = null, a.transform._parentID = -1, Nr(this.children, s, 1), this._boundsID++, this.onChildrenChange(s), a.emit("removed", this), this.emit("childRemoved", a, this, s);
      }
      return n[0];
    }, t.prototype.removeChildAt = function(e) {
      var n = this.getChildAt(e);
      return n.parent = null, n.transform._parentID = -1, Nr(this.children, e, 1), this._boundsID++, this.onChildrenChange(e), n.emit("removed", this), this.emit("childRemoved", n, this, e), n;
    }, t.prototype.removeChildren = function(e, n) {
      e === void 0 && (e = 0), n === void 0 && (n = this.children.length);
      var i = e, o = n, a = o - i, s;
      if (a > 0 && a <= o) {
        s = this.children.splice(i, a);
        for (var h = 0; h < s.length; ++h)
          s[h].parent = null, s[h].transform && (s[h].transform._parentID = -1);
        this._boundsID++, this.onChildrenChange(e);
        for (var h = 0; h < s.length; ++h)
          s[h].emit("removed", this), this.emit("childRemoved", s[h], this, h);
        return s;
      } else if (a === 0 && this.children.length === 0)
        return [];
      throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    }, t.prototype.sortChildren = function() {
      for (var e = !1, n = 0, i = this.children.length; n < i; ++n) {
        var o = this.children[n];
        o._lastSortedIndex = n, !e && o.zIndex !== 0 && (e = !0);
      }
      e && this.children.length > 1 && this.children.sort(xy), this.sortDirty = !1;
    }, t.prototype.updateTransform = function() {
      this.sortableChildren && this.sortDirty && this.sortChildren(), this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
      for (var e = 0, n = this.children.length; e < n; ++e) {
        var i = this.children[e];
        i.visible && i.updateTransform();
      }
    }, t.prototype.calculateBounds = function() {
      this._bounds.clear(), this._calculateBounds();
      for (var e = 0; e < this.children.length; e++) {
        var n = this.children[e];
        if (!(!n.visible || !n.renderable))
          if (n.calculateBounds(), n._mask) {
            var i = n._mask.isMaskData ? n._mask.maskObject : n._mask;
            i ? (i.calculateBounds(), this._bounds.addBoundsMask(n._bounds, i._bounds)) : this._bounds.addBounds(n._bounds);
          } else
            n.filterArea ? this._bounds.addBoundsArea(n._bounds, n.filterArea) : this._bounds.addBounds(n._bounds);
      }
      this._bounds.updateID = this._boundsID;
    }, t.prototype.getLocalBounds = function(e, n) {
      n === void 0 && (n = !1);
      var i = r.prototype.getLocalBounds.call(this, e);
      if (!n)
        for (var o = 0, a = this.children.length; o < a; ++o) {
          var s = this.children[o];
          s.visible && s.updateTransform();
        }
      return i;
    }, t.prototype._calculateBounds = function() {
    }, t.prototype._renderWithCulling = function(e) {
      var n = e.renderTexture.sourceFrame;
      if (n.width > 0 && n.height > 0) {
        var i, o;
        if (this.cullArea ? (i = this.cullArea, o = this.worldTransform) : this._render !== t.prototype._render && (i = this.getBounds(!0)), i && n.intersects(i, o))
          this._render(e);
        else if (this.cullArea)
          return;
        for (var a = 0, s = this.children.length; a < s; ++a) {
          var h = this.children[a], u = h.cullable;
          h.cullable = u || !this.cullArea, h.render(e), h.cullable = u;
        }
      }
    }, t.prototype.render = function(e) {
      if (!(!this.visible || this.worldAlpha <= 0 || !this.renderable))
        if (this._mask || this.filters && this.filters.length)
          this.renderAdvanced(e);
        else if (this.cullable)
          this._renderWithCulling(e);
        else {
          this._render(e);
          for (var n = 0, i = this.children.length; n < i; ++n)
            this.children[n].render(e);
        }
    }, t.prototype.renderAdvanced = function(e) {
      var n = this.filters, i = this._mask;
      if (n) {
        this._enabledFilters || (this._enabledFilters = []), this._enabledFilters.length = 0;
        for (var o = 0; o < n.length; o++)
          n[o].enabled && this._enabledFilters.push(n[o]);
      }
      var a = n && this._enabledFilters && this._enabledFilters.length || i && (!i.isMaskData || i.enabled && (i.autoDetect || i.type !== It.NONE));
      if (a && e.batch.flush(), n && this._enabledFilters && this._enabledFilters.length && e.filter.push(this, this._enabledFilters), i && e.mask.push(this, this._mask), this.cullable)
        this._renderWithCulling(e);
      else {
        this._render(e);
        for (var o = 0, s = this.children.length; o < s; ++o)
          this.children[o].render(e);
      }
      a && e.batch.flush(), i && e.mask.pop(this), n && this._enabledFilters && this._enabledFilters.length && e.filter.pop();
    }, t.prototype._render = function(e) {
    }, t.prototype.destroy = function(e) {
      r.prototype.destroy.call(this), this.sortDirty = !1;
      var n = typeof e == "boolean" ? e : e && e.children, i = this.removeChildren(0, this.children.length);
      if (n)
        for (var o = 0; o < i.length; ++o)
          i[o].destroy(e);
    }, Object.defineProperty(t.prototype, "width", {
      /** The width of the Container, setting this will actually modify the scale to achieve the value set. */
      get: function() {
        return this.scale.x * this.getLocalBounds().width;
      },
      set: function(e) {
        var n = this.getLocalBounds().width;
        n !== 0 ? this.scale.x = e / n : this.scale.x = 1, this._width = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "height", {
      /** The height of the Container, setting this will actually modify the scale to achieve the value set. */
      get: function() {
        return this.scale.y * this.getLocalBounds().height;
      },
      set: function(e) {
        var n = this.getLocalBounds().height;
        n !== 0 ? this.scale.y = e / n : this.scale.y = 1, this._height = e;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Rt)
);
Te.prototype.containerUpdateTransform = Te.prototype.updateTransform;
/*!
 * @pixi/extensions - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/extensions is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ln = function() {
  return ln = Object.assign || function(t) {
    for (var e = arguments, n, i = 1, o = arguments.length; i < o; i++) {
      n = e[i];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, ln.apply(this, arguments);
}, mt;
(function(r) {
  r.Application = "application", r.RendererPlugin = "renderer-webgl-plugin", r.CanvasRendererPlugin = "renderer-canvas-plugin", r.Loader = "loader", r.LoadParser = "load-parser", r.ResolveParser = "resolve-parser", r.CacheParser = "cache-parser", r.DetectionParser = "detection-parser";
})(mt || (mt = {}));
var bh = function(r) {
  if (typeof r == "function" || typeof r == "object" && r.extension) {
    if (!r.extension)
      throw new Error("Extension class must have an extension object");
    var t = typeof r.extension != "object" ? { type: r.extension } : r.extension;
    r = ln(ln({}, t), { ref: r });
  }
  if (typeof r == "object")
    r = ln({}, r);
  else
    throw new Error("Invalid extension type");
  return typeof r.type == "string" && (r.type = [r.type]), r;
}, Me = {
  /** @ignore */
  _addHandlers: null,
  /** @ignore */
  _removeHandlers: null,
  /** @ignore */
  _queue: {},
  /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed.
   * @returns {PIXI.extensions} For chaining.
   */
  remove: function() {
    for (var r = arguments, t = this, e = [], n = 0; n < arguments.length; n++)
      e[n] = r[n];
    return e.map(bh).forEach(function(i) {
      i.type.forEach(function(o) {
        var a, s;
        return (s = (a = t._removeHandlers)[o]) === null || s === void 0 ? void 0 : s.call(a, i);
      });
    }), this;
  },
  /**
   * Register new extensions with PixiJS.
   * @param extensions - The spread of extensions to add to PixiJS.
   * @returns {PIXI.extensions} For chaining.
   */
  add: function() {
    for (var r = arguments, t = this, e = [], n = 0; n < arguments.length; n++)
      e[n] = r[n];
    return e.map(bh).forEach(function(i) {
      i.type.forEach(function(o) {
        var a = t._addHandlers, s = t._queue;
        a[o] ? a[o](i) : (s[o] = s[o] || [], s[o].push(i));
      });
    }), this;
  },
  /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function for handling when extensions are added/registered passes {@link PIXI.ExtensionFormat}.
   * @param onRemove  - Function for handling when extensions are removed/unregistered passes {@link PIXI.ExtensionFormat}.
   * @returns {PIXI.extensions} For chaining.
   */
  handle: function(r, t, e) {
    var n = this._addHandlers = this._addHandlers || {}, i = this._removeHandlers = this._removeHandlers || {};
    if (n[r] || i[r])
      throw new Error("Extension type " + r + " already has a handler");
    n[r] = t, i[r] = e;
    var o = this._queue;
    return o[r] && (o[r].forEach(function(a) {
      return t(a);
    }), delete o[r]), this;
  },
  /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns {PIXI.extensions} For chaining.
   */
  handleByMap: function(r, t) {
    return this.handle(r, function(e) {
      t[e.name] = e.ref;
    }, function(e) {
      delete t[e.name];
    });
  },
  /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @returns {PIXI.extensions} For chaining.
   */
  handleByList: function(r, t) {
    return this.handle(r, function(e) {
      var n, i;
      t.includes(e.ref) || (t.push(e.ref), r === mt.Loader && ((i = (n = e.ref).add) === null || i === void 0 || i.call(n)));
    }, function(e) {
      var n = t.indexOf(e.ref);
      n !== -1 && t.splice(n, 1);
    });
  }
};
/*!
 * @pixi/runner - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/runner is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var kt = (
  /** @class */
  function() {
    function r(t) {
      this.items = [], this._name = t, this._aliasCount = 0;
    }
    return r.prototype.emit = function(t, e, n, i, o, a, s, h) {
      if (arguments.length > 8)
        throw new Error("max arguments reached");
      var u = this, l = u.name, f = u.items;
      this._aliasCount++;
      for (var c = 0, d = f.length; c < d; c++)
        f[c][l](t, e, n, i, o, a, s, h);
      return f === this.items && this._aliasCount--, this;
    }, r.prototype.ensureNonAliasedItems = function() {
      this._aliasCount > 0 && this.items.length > 1 && (this._aliasCount = 0, this.items = this.items.slice(0));
    }, r.prototype.add = function(t) {
      return t[this._name] && (this.ensureNonAliasedItems(), this.remove(t), this.items.push(t)), this;
    }, r.prototype.remove = function(t) {
      var e = this.items.indexOf(t);
      return e !== -1 && (this.ensureNonAliasedItems(), this.items.splice(e, 1)), this;
    }, r.prototype.contains = function(t) {
      return this.items.indexOf(t) !== -1;
    }, r.prototype.removeAll = function() {
      return this.ensureNonAliasedItems(), this.items.length = 0, this;
    }, r.prototype.destroy = function() {
      this.removeAll(), this.items = null, this._name = null;
    }, Object.defineProperty(r.prototype, "empty", {
      /**
       * `true` if there are no this Runner contains no listeners
       * @readonly
       */
      get: function() {
        return this.items.length === 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "name", {
      /**
       * The name of the runner.
       * @readonly
       */
      get: function() {
        return this._name;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }()
);
Object.defineProperties(kt.prototype, {
  /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method dispatch
   * @see PIXI.Runner#emit
   */
  dispatch: { value: kt.prototype.emit },
  /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method run
   * @see PIXI.Runner#emit
   */
  run: { value: kt.prototype.emit }
});
/*!
 * @pixi/ticker - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/ticker is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
G.TARGET_FPMS = 0.06;
var Ce;
(function(r) {
  r[r.INTERACTION = 50] = "INTERACTION", r[r.HIGH = 25] = "HIGH", r[r.NORMAL = 0] = "NORMAL", r[r.LOW = -25] = "LOW", r[r.UTILITY = -50] = "UTILITY";
})(Ce || (Ce = {}));
var fo = (
  /** @class */
  function() {
    function r(t, e, n, i) {
      e === void 0 && (e = null), n === void 0 && (n = 0), i === void 0 && (i = !1), this.next = null, this.previous = null, this._destroyed = !1, this.fn = t, this.context = e, this.priority = n, this.once = i;
    }
    return r.prototype.match = function(t, e) {
      return e === void 0 && (e = null), this.fn === t && this.context === e;
    }, r.prototype.emit = function(t) {
      this.fn && (this.context ? this.fn.call(this.context, t) : this.fn(t));
      var e = this.next;
      return this.once && this.destroy(!0), this._destroyed && (this.next = null), e;
    }, r.prototype.connect = function(t) {
      this.previous = t, t.next && (t.next.previous = this), this.next = t.next, t.next = this;
    }, r.prototype.destroy = function(t) {
      t === void 0 && (t = !1), this._destroyed = !0, this.fn = null, this.context = null, this.previous && (this.previous.next = this.next), this.next && (this.next.previous = this.previous);
      var e = this.next;
      return this.next = t ? null : e, this.previous = null, e;
    }, r;
  }()
), Ht = (
  /** @class */
  function() {
    function r() {
      var t = this;
      this.autoStart = !1, this.deltaTime = 1, this.lastTime = -1, this.speed = 1, this.started = !1, this._requestId = null, this._maxElapsedMS = 100, this._minElapsedMS = 0, this._protected = !1, this._lastFrame = -1, this._head = new fo(null, null, 1 / 0), this.deltaMS = 1 / G.TARGET_FPMS, this.elapsedMS = 1 / G.TARGET_FPMS, this._tick = function(e) {
        t._requestId = null, t.started && (t.update(e), t.started && t._requestId === null && t._head.next && (t._requestId = requestAnimationFrame(t._tick)));
      };
    }
    return r.prototype._requestIfNeeded = function() {
      this._requestId === null && this._head.next && (this.lastTime = performance.now(), this._lastFrame = this.lastTime, this._requestId = requestAnimationFrame(this._tick));
    }, r.prototype._cancelIfNeeded = function() {
      this._requestId !== null && (cancelAnimationFrame(this._requestId), this._requestId = null);
    }, r.prototype._startIfPossible = function() {
      this.started ? this._requestIfNeeded() : this.autoStart && this.start();
    }, r.prototype.add = function(t, e, n) {
      return n === void 0 && (n = Ce.NORMAL), this._addListener(new fo(t, e, n));
    }, r.prototype.addOnce = function(t, e, n) {
      return n === void 0 && (n = Ce.NORMAL), this._addListener(new fo(t, e, n, !0));
    }, r.prototype._addListener = function(t) {
      var e = this._head.next, n = this._head;
      if (!e)
        t.connect(n);
      else {
        for (; e; ) {
          if (t.priority > e.priority) {
            t.connect(n);
            break;
          }
          n = e, e = e.next;
        }
        t.previous || t.connect(n);
      }
      return this._startIfPossible(), this;
    }, r.prototype.remove = function(t, e) {
      for (var n = this._head.next; n; )
        n.match(t, e) ? n = n.destroy() : n = n.next;
      return this._head.next || this._cancelIfNeeded(), this;
    }, Object.defineProperty(r.prototype, "count", {
      /**
       * The number of listeners on this ticker, calculated by walking through linked list
       * @readonly
       * @member {number}
       */
      get: function() {
        if (!this._head)
          return 0;
        for (var t = 0, e = this._head; e = e.next; )
          t++;
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.start = function() {
      this.started || (this.started = !0, this._requestIfNeeded());
    }, r.prototype.stop = function() {
      this.started && (this.started = !1, this._cancelIfNeeded());
    }, r.prototype.destroy = function() {
      if (!this._protected) {
        this.stop();
        for (var t = this._head.next; t; )
          t = t.destroy(!0);
        this._head.destroy(), this._head = null;
      }
    }, r.prototype.update = function(t) {
      t === void 0 && (t = performance.now());
      var e;
      if (t > this.lastTime) {
        if (e = this.elapsedMS = t - this.lastTime, e > this._maxElapsedMS && (e = this._maxElapsedMS), e *= this.speed, this._minElapsedMS) {
          var n = t - this._lastFrame | 0;
          if (n < this._minElapsedMS)
            return;
          this._lastFrame = t - n % this._minElapsedMS;
        }
        this.deltaMS = e, this.deltaTime = this.deltaMS * G.TARGET_FPMS;
        for (var i = this._head, o = i.next; o; )
          o = o.emit(this.deltaTime);
        i.next || this._cancelIfNeeded();
      } else
        this.deltaTime = this.deltaMS = this.elapsedMS = 0;
      this.lastTime = t;
    }, Object.defineProperty(r.prototype, "FPS", {
      /**
       * The frames per second at which this ticker is running.
       * The default is approximately 60 in most modern browsers.
       * **Note:** This does not factor in the value of
       * {@link PIXI.Ticker#speed}, which is specific
       * to scaling {@link PIXI.Ticker#deltaTime}.
       * @member {number}
       * @readonly
       */
      get: function() {
        return 1e3 / this.elapsedMS;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "minFPS", {
      /**
       * Manages the maximum amount of milliseconds allowed to
       * elapse between invoking {@link PIXI.Ticker#update}.
       * This value is used to cap {@link PIXI.Ticker#deltaTime},
       * but does not effect the measured value of {@link PIXI.Ticker#FPS}.
       * When setting this property it is clamped to a value between
       * `0` and `PIXI.settings.TARGET_FPMS * 1000`.
       * @member {number}
       * @default 10
       */
      get: function() {
        return 1e3 / this._maxElapsedMS;
      },
      set: function(t) {
        var e = Math.min(this.maxFPS, t), n = Math.min(Math.max(0, e) / 1e3, G.TARGET_FPMS);
        this._maxElapsedMS = 1 / n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "maxFPS", {
      /**
       * Manages the minimum amount of milliseconds required to
       * elapse between invoking {@link PIXI.Ticker#update}.
       * This will effect the measured value of {@link PIXI.Ticker#FPS}.
       * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
       * Otherwise it will be at least `minFPS`
       * @member {number}
       * @default 0
       */
      get: function() {
        return this._minElapsedMS ? Math.round(1e3 / this._minElapsedMS) : 0;
      },
      set: function(t) {
        if (t === 0)
          this._minElapsedMS = 0;
        else {
          var e = Math.max(this.minFPS, t);
          this._minElapsedMS = 1 / (e / 1e3);
        }
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r, "shared", {
      /**
       * The shared ticker instance used by {@link PIXI.AnimatedSprite} and by
       * {@link PIXI.VideoResource} to update animation frames / video textures.
       *
       * It may also be used by {@link PIXI.Application} if created with the `sharedTicker` option property set to true.
       *
       * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
       * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
       * @example
       * let ticker = PIXI.Ticker.shared;
       * // Set this to prevent starting this ticker when listeners are added.
       * // By default this is true only for the PIXI.Ticker.shared instance.
       * ticker.autoStart = false;
       * // FYI, call this to ensure the ticker is stopped. It should be stopped
       * // if you have not attempted to render anything yet.
       * ticker.stop();
       * // Call this when you are ready for a running shared ticker.
       * ticker.start();
       * @example
       * // You may use the shared ticker to render...
       * let renderer = PIXI.autoDetectRenderer();
       * let stage = new PIXI.Container();
       * document.body.appendChild(renderer.view);
       * ticker.add(function (time) {
       *     renderer.render(stage);
       * });
       * @example
       * // Or you can just update it manually.
       * ticker.autoStart = false;
       * ticker.stop();
       * function animate(time) {
       *     ticker.update(time);
       *     renderer.render(stage);
       *     requestAnimationFrame(animate);
       * }
       * animate(performance.now());
       * @member {PIXI.Ticker}
       * @static
       */
      get: function() {
        if (!r._shared) {
          var t = r._shared = new r();
          t.autoStart = !0, t._protected = !0;
        }
        return r._shared;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r, "system", {
      /**
       * The system ticker instance used by {@link PIXI.InteractionManager} and by
       * {@link PIXI.BasePrepare} for core timing functionality that shouldn't usually need to be paused,
       * unlike the `shared` ticker which drives visual animations and rendering which may want to be paused.
       *
       * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
       * @member {PIXI.Ticker}
       * @static
       */
      get: function() {
        if (!r._system) {
          var t = r._system = new r();
          t.autoStart = !0, t._protected = !0;
        }
        return r._system;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }()
), Ty = (
  /** @class */
  function() {
    function r() {
    }
    return r.init = function(t) {
      var e = this;
      t = Object.assign({
        autoStart: !0,
        sharedTicker: !1
      }, t), Object.defineProperty(this, "ticker", {
        set: function(n) {
          this._ticker && this._ticker.remove(this.render, this), this._ticker = n, n && n.add(this.render, this, Ce.LOW);
        },
        get: function() {
          return this._ticker;
        }
      }), this.stop = function() {
        e._ticker.stop();
      }, this.start = function() {
        e._ticker.start();
      }, this._ticker = null, this.ticker = t.sharedTicker ? Ht.shared : new Ht(), t.autoStart && this.start();
    }, r.destroy = function() {
      if (this._ticker) {
        var t = this._ticker;
        this.ticker = null, t.destroy();
      }
    }, r.extension = mt.Application, r;
  }()
);
/*!
 * @pixi/core - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/core is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
G.PREFER_ENV = ge.any ? Ie.WEBGL : Ie.WEBGL2;
G.STRICT_TEXTURE_CACHE = !1;
var na = [];
function vl(r, t) {
  if (!r)
    return null;
  var e = "";
  if (typeof r == "string") {
    var n = /\.(\w{3,4})(?:$|\?|#)/i.exec(r);
    n && (e = n[1].toLowerCase());
  }
  for (var i = na.length - 1; i >= 0; --i) {
    var o = na[i];
    if (o.test && o.test(r, e))
      return new o(r, t);
  }
  throw new Error("Unrecognized source type to auto-detect Resource");
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ia = function(r, t) {
  return ia = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, ia(r, t);
};
function xt(r, t) {
  ia(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var oa = function() {
  return oa = Object.assign || function(t) {
    for (var e = arguments, n, i = 1, o = arguments.length; i < o; i++) {
      n = e[i];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, oa.apply(this, arguments);
};
function Ey(r, t) {
  var e = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && t.indexOf(n) < 0 && (e[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (e[n[i]] = r[n[i]]);
  return e;
}
var gn = (
  /** @class */
  function() {
    function r(t, e) {
      t === void 0 && (t = 0), e === void 0 && (e = 0), this._width = t, this._height = e, this.destroyed = !1, this.internal = !1, this.onResize = new kt("setRealSize"), this.onUpdate = new kt("update"), this.onError = new kt("onError");
    }
    return r.prototype.bind = function(t) {
      this.onResize.add(t), this.onUpdate.add(t), this.onError.add(t), (this._width || this._height) && this.onResize.emit(this._width, this._height);
    }, r.prototype.unbind = function(t) {
      this.onResize.remove(t), this.onUpdate.remove(t), this.onError.remove(t);
    }, r.prototype.resize = function(t, e) {
      (t !== this._width || e !== this._height) && (this._width = t, this._height = e, this.onResize.emit(t, e));
    }, Object.defineProperty(r.prototype, "valid", {
      /**
       * Has been validated
       * @readonly
       */
      get: function() {
        return !!this._width && !!this._height;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.update = function() {
      this.destroyed || this.onUpdate.emit();
    }, r.prototype.load = function() {
      return Promise.resolve(this);
    }, Object.defineProperty(r.prototype, "width", {
      /**
       * The width of the resource.
       * @readonly
       */
      get: function() {
        return this._width;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "height", {
      /**
       * The height of the resource.
       * @readonly
       */
      get: function() {
        return this._height;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.style = function(t, e, n) {
      return !1;
    }, r.prototype.dispose = function() {
    }, r.prototype.destroy = function() {
      this.destroyed || (this.destroyed = !0, this.dispose(), this.onError.removeAll(), this.onError = null, this.onResize.removeAll(), this.onResize = null, this.onUpdate.removeAll(), this.onUpdate = null);
    }, r.test = function(t, e) {
      return !1;
    }, r;
  }()
), Pn = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n) {
      var i = this, o = n || {}, a = o.width, s = o.height;
      if (!a || !s)
        throw new Error("BufferResource width or height invalid");
      return i = r.call(this, a, s) || this, i.data = e, i;
    }
    return t.prototype.upload = function(e, n, i) {
      var o = e.gl;
      o.pixelStorei(o.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.alphaMode === pe.UNPACK);
      var a = n.realWidth, s = n.realHeight;
      return i.width === a && i.height === s ? o.texSubImage2D(n.target, 0, 0, 0, a, s, n.format, i.type, this.data) : (i.width = a, i.height = s, o.texImage2D(n.target, 0, i.internalFormat, a, s, 0, n.format, i.type, this.data)), !0;
    }, t.prototype.dispose = function() {
      this.data = null;
    }, t.test = function(e) {
      return e instanceof Float32Array || e instanceof Uint8Array || e instanceof Uint32Array;
    }, t;
  }(gn)
), wy = {
  scaleMode: ye.NEAREST,
  format: L.RGBA,
  alphaMode: pe.NPM
}, ht = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n) {
      e === void 0 && (e = null), n === void 0 && (n = null);
      var i = r.call(this) || this;
      n = n || {};
      var o = n.alphaMode, a = n.mipmap, s = n.anisotropicLevel, h = n.scaleMode, u = n.width, l = n.height, f = n.wrapMode, c = n.format, d = n.type, p = n.target, v = n.resolution, _ = n.resourceOptions;
      return e && !(e instanceof gn) && (e = vl(e, _), e.internal = !0), i.resolution = v || G.RESOLUTION, i.width = Math.round((u || 0) * i.resolution) / i.resolution, i.height = Math.round((l || 0) * i.resolution) / i.resolution, i._mipmap = a !== void 0 ? a : G.MIPMAP_TEXTURES, i.anisotropicLevel = s !== void 0 ? s : G.ANISOTROPIC_LEVEL, i._wrapMode = f || G.WRAP_MODE, i._scaleMode = h !== void 0 ? h : G.SCALE_MODE, i.format = c || L.RGBA, i.type = d || X.UNSIGNED_BYTE, i.target = p || or.TEXTURE_2D, i.alphaMode = o !== void 0 ? o : pe.UNPACK, i.uid = lr(), i.touched = 0, i.isPowerOfTwo = !1, i._refreshPOT(), i._glTextures = {}, i.dirtyId = 0, i.dirtyStyleId = 0, i.cacheId = null, i.valid = u > 0 && l > 0, i.textureCacheIds = [], i.destroyed = !1, i.resource = null, i._batchEnabled = 0, i._batchLocation = 0, i.parentTextureArray = null, i.setResource(e), i;
    }
    return Object.defineProperty(t.prototype, "realWidth", {
      /**
       * Pixel width of the source of this texture
       * @readonly
       */
      get: function() {
        return Math.round(this.width * this.resolution);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "realHeight", {
      /**
       * Pixel height of the source of this texture
       * @readonly
       */
      get: function() {
        return Math.round(this.height * this.resolution);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "mipmap", {
      /**
       * Mipmap mode of the texture, affects downscaled images
       * @default PIXI.settings.MIPMAP_TEXTURES
       */
      get: function() {
        return this._mipmap;
      },
      set: function(e) {
        this._mipmap !== e && (this._mipmap = e, this.dirtyStyleId++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "scaleMode", {
      /**
       * The scale mode to apply when scaling this texture
       * @default PIXI.settings.SCALE_MODE
       */
      get: function() {
        return this._scaleMode;
      },
      set: function(e) {
        this._scaleMode !== e && (this._scaleMode = e, this.dirtyStyleId++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "wrapMode", {
      /**
       * How the texture wraps
       * @default PIXI.settings.WRAP_MODE
       */
      get: function() {
        return this._wrapMode;
      },
      set: function(e) {
        this._wrapMode !== e && (this._wrapMode = e, this.dirtyStyleId++);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setStyle = function(e, n) {
      var i;
      return e !== void 0 && e !== this.scaleMode && (this.scaleMode = e, i = !0), n !== void 0 && n !== this.mipmap && (this.mipmap = n, i = !0), i && this.dirtyStyleId++, this;
    }, t.prototype.setSize = function(e, n, i) {
      return i = i || this.resolution, this.setRealSize(e * i, n * i, i);
    }, t.prototype.setRealSize = function(e, n, i) {
      return this.resolution = i || this.resolution, this.width = Math.round(e) / this.resolution, this.height = Math.round(n) / this.resolution, this._refreshPOT(), this.update(), this;
    }, t.prototype._refreshPOT = function() {
      this.isPowerOfTwo = vh(this.realWidth) && vh(this.realHeight);
    }, t.prototype.setResolution = function(e) {
      var n = this.resolution;
      return n === e ? this : (this.resolution = e, this.valid && (this.width = Math.round(this.width * n) / e, this.height = Math.round(this.height * n) / e, this.emit("update", this)), this._refreshPOT(), this);
    }, t.prototype.setResource = function(e) {
      if (this.resource === e)
        return this;
      if (this.resource)
        throw new Error("Resource can be set only once");
      return e.bind(this), this.resource = e, this;
    }, t.prototype.update = function() {
      this.valid ? (this.dirtyId++, this.dirtyStyleId++, this.emit("update", this)) : this.width > 0 && this.height > 0 && (this.valid = !0, this.emit("loaded", this), this.emit("update", this));
    }, t.prototype.onError = function(e) {
      this.emit("error", this, e);
    }, t.prototype.destroy = function() {
      this.resource && (this.resource.unbind(this), this.resource.internal && this.resource.destroy(), this.resource = null), this.cacheId && (delete ze[this.cacheId], delete Ae[this.cacheId], this.cacheId = null), this.dispose(), t.removeFromCache(this), this.textureCacheIds = null, this.destroyed = !0;
    }, t.prototype.dispose = function() {
      this.emit("dispose", this);
    }, t.prototype.castToBaseTexture = function() {
      return this;
    }, t.from = function(e, n, i) {
      i === void 0 && (i = G.STRICT_TEXTURE_CACHE);
      var o = typeof e == "string", a = null;
      if (o)
        a = e;
      else {
        if (!e._pixiId) {
          var s = n && n.pixiIdPrefix || "pixiid";
          e._pixiId = s + "_" + lr();
        }
        a = e._pixiId;
      }
      var h = ze[a];
      if (o && i && !h)
        throw new Error('The cacheId "' + a + '" does not exist in BaseTextureCache.');
      return h || (h = new t(e, n), h.cacheId = a, t.addToCache(h, a)), h;
    }, t.fromBuffer = function(e, n, i, o) {
      e = e || new Float32Array(n * i * 4);
      var a = new Pn(e, { width: n, height: i }), s = e instanceof Float32Array ? X.FLOAT : X.UNSIGNED_BYTE;
      return new t(a, Object.assign({}, wy, o || { width: n, height: i, type: s }));
    }, t.addToCache = function(e, n) {
      n && (e.textureCacheIds.indexOf(n) === -1 && e.textureCacheIds.push(n), ze[n] && console.warn("BaseTexture added to the cache with an id [" + n + "] that already had an entry"), ze[n] = e);
    }, t.removeFromCache = function(e) {
      if (typeof e == "string") {
        var n = ze[e];
        if (n) {
          var i = n.textureCacheIds.indexOf(e);
          return i > -1 && n.textureCacheIds.splice(i, 1), delete ze[e], n;
        }
      } else if (e && e.textureCacheIds) {
        for (var o = 0; o < e.textureCacheIds.length; ++o)
          delete ze[e.textureCacheIds[o]];
        return e.textureCacheIds.length = 0, e;
      }
      return null;
    }, t._globalBatch = 0, t;
  }(Sn)
), _l = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n) {
      var i = this, o = n || {}, a = o.width, s = o.height;
      i = r.call(this, a, s) || this, i.items = [], i.itemDirtyIds = [];
      for (var h = 0; h < e; h++) {
        var u = new ht();
        i.items.push(u), i.itemDirtyIds.push(-2);
      }
      return i.length = e, i._load = null, i.baseTexture = null, i;
    }
    return t.prototype.initFromArray = function(e, n) {
      for (var i = 0; i < this.length; i++)
        e[i] && (e[i].castToBaseTexture ? this.addBaseTextureAt(e[i].castToBaseTexture(), i) : e[i] instanceof gn ? this.addResourceAt(e[i], i) : this.addResourceAt(vl(e[i], n), i));
    }, t.prototype.dispose = function() {
      for (var e = 0, n = this.length; e < n; e++)
        this.items[e].destroy();
      this.items = null, this.itemDirtyIds = null, this._load = null;
    }, t.prototype.addResourceAt = function(e, n) {
      if (!this.items[n])
        throw new Error("Index " + n + " is out of bounds");
      return e.valid && !this.valid && this.resize(e.width, e.height), this.items[n].setResource(e), this;
    }, t.prototype.bind = function(e) {
      if (this.baseTexture !== null)
        throw new Error("Only one base texture per TextureArray is allowed");
      r.prototype.bind.call(this, e);
      for (var n = 0; n < this.length; n++)
        this.items[n].parentTextureArray = e, this.items[n].on("update", e.update, e);
    }, t.prototype.unbind = function(e) {
      r.prototype.unbind.call(this, e);
      for (var n = 0; n < this.length; n++)
        this.items[n].parentTextureArray = null, this.items[n].off("update", e.update, e);
    }, t.prototype.load = function() {
      var e = this;
      if (this._load)
        return this._load;
      var n = this.items.map(function(o) {
        return o.resource;
      }).filter(function(o) {
        return o;
      }), i = n.map(function(o) {
        return o.load();
      });
      return this._load = Promise.all(i).then(function() {
        var o = e.items[0], a = o.realWidth, s = o.realHeight;
        return e.resize(a, s), Promise.resolve(e);
      }), this._load;
    }, t;
  }(gn)
), Sy = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n) {
      var i = this, o = n || {}, a = o.width, s = o.height, h, u;
      return Array.isArray(e) ? (h = e, u = e.length) : u = e, i = r.call(this, u, { width: a, height: s }) || this, h && i.initFromArray(h, n), i;
    }
    return t.prototype.addBaseTextureAt = function(e, n) {
      if (e.resource)
        this.addResourceAt(e.resource, n);
      else
        throw new Error("ArrayResource does not support RenderTexture");
      return this;
    }, t.prototype.bind = function(e) {
      r.prototype.bind.call(this, e), e.target = or.TEXTURE_2D_ARRAY;
    }, t.prototype.upload = function(e, n, i) {
      var o = this, a = o.length, s = o.itemDirtyIds, h = o.items, u = e.gl;
      i.dirtyId < 0 && u.texImage3D(u.TEXTURE_2D_ARRAY, 0, i.internalFormat, this._width, this._height, a, 0, n.format, i.type, null);
      for (var l = 0; l < a; l++) {
        var f = h[l];
        s[l] < f.dirtyId && (s[l] = f.dirtyId, f.valid && u.texSubImage3D(
          u.TEXTURE_2D_ARRAY,
          0,
          0,
          // xoffset
          0,
          // yoffset
          l,
          // zoffset
          f.resource.width,
          f.resource.height,
          1,
          n.format,
          i.type,
          f.resource.source
        ));
      }
      return !0;
    }, t;
  }(_l)
), Ge = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e) {
      var n = this, i = e, o = i.naturalWidth || i.videoWidth || i.width, a = i.naturalHeight || i.videoHeight || i.height;
      return n = r.call(this, o, a) || this, n.source = e, n.noSubImage = !1, n;
    }
    return t.crossOrigin = function(e, n, i) {
      i === void 0 && n.indexOf("data:") !== 0 ? e.crossOrigin = py(n) : i !== !1 && (e.crossOrigin = typeof i == "string" ? i : "anonymous");
    }, t.prototype.upload = function(e, n, i, o) {
      var a = e.gl, s = n.realWidth, h = n.realHeight;
      if (o = o || this.source, o instanceof HTMLImageElement) {
        if (!o.complete || o.naturalWidth === 0)
          return !1;
      } else if (o instanceof HTMLVideoElement && o.readyState <= 1)
        return !1;
      return a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.alphaMode === pe.UNPACK), !this.noSubImage && n.target === a.TEXTURE_2D && i.width === s && i.height === h ? a.texSubImage2D(a.TEXTURE_2D, 0, 0, 0, n.format, i.type, o) : (i.width = s, i.height = h, a.texImage2D(n.target, 0, i.internalFormat, n.format, i.type, o)), !0;
    }, t.prototype.update = function() {
      if (!this.destroyed) {
        var e = this.source, n = e.naturalWidth || e.videoWidth || e.width, i = e.naturalHeight || e.videoHeight || e.height;
        this.resize(n, i), r.prototype.update.call(this);
      }
    }, t.prototype.dispose = function() {
      this.source = null;
    }, t;
  }(gn)
), Ay = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e) {
      return r.call(this, e) || this;
    }
    return t.test = function(e) {
      var n = globalThis.OffscreenCanvas;
      return n && e instanceof n ? !0 : globalThis.HTMLCanvasElement && e instanceof HTMLCanvasElement;
    }, t;
  }(Ge)
), Py = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n) {
      var i = this, o = n || {}, a = o.width, s = o.height, h = o.autoLoad, u = o.linkBaseTexture;
      if (e && e.length !== t.SIDES)
        throw new Error("Invalid length. Got " + e.length + ", expected 6");
      i = r.call(this, 6, { width: a, height: s }) || this;
      for (var l = 0; l < t.SIDES; l++)
        i.items[l].target = or.TEXTURE_CUBE_MAP_POSITIVE_X + l;
      return i.linkBaseTexture = u !== !1, e && i.initFromArray(e, n), h !== !1 && i.load(), i;
    }
    return t.prototype.bind = function(e) {
      r.prototype.bind.call(this, e), e.target = or.TEXTURE_CUBE_MAP;
    }, t.prototype.addBaseTextureAt = function(e, n, i) {
      if (!this.items[n])
        throw new Error("Index " + n + " is out of bounds");
      if (!this.linkBaseTexture || e.parentTextureArray || Object.keys(e._glTextures).length > 0)
        if (e.resource)
          this.addResourceAt(e.resource, n);
        else
          throw new Error("CubeResource does not support copying of renderTexture.");
      else
        e.target = or.TEXTURE_CUBE_MAP_POSITIVE_X + n, e.parentTextureArray = this.baseTexture, this.items[n] = e;
      return e.valid && !this.valid && this.resize(e.realWidth, e.realHeight), this.items[n] = e, this;
    }, t.prototype.upload = function(e, n, i) {
      for (var o = this.itemDirtyIds, a = 0; a < t.SIDES; a++) {
        var s = this.items[a];
        (o[a] < s.dirtyId || i.dirtyId < n.dirtyId) && (s.valid && s.resource ? (s.resource.upload(e, s, i), o[a] = s.dirtyId) : o[a] < -1 && (e.gl.texImage2D(s.target, 0, i.internalFormat, n.realWidth, n.realHeight, 0, n.format, i.type, null), o[a] = -1));
      }
      return !0;
    }, t.test = function(e) {
      return Array.isArray(e) && e.length === t.SIDES;
    }, t.SIDES = 6, t;
  }(_l)
), ml = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n) {
      var i = this;
      if (n = n || {}, !(e instanceof HTMLImageElement)) {
        var o = new Image();
        Ge.crossOrigin(o, e, n.crossorigin), o.src = e, e = o;
      }
      return i = r.call(this, e) || this, !e.complete && i._width && i._height && (i._width = 0, i._height = 0), i.url = e.src, i._process = null, i.preserveBitmap = !1, i.createBitmap = (n.createBitmap !== void 0 ? n.createBitmap : G.CREATE_IMAGE_BITMAP) && !!globalThis.createImageBitmap, i.alphaMode = typeof n.alphaMode == "number" ? n.alphaMode : null, i.bitmap = null, i._load = null, n.autoLoad !== !1 && i.load(), i;
    }
    return t.prototype.load = function(e) {
      var n = this;
      return this._load ? this._load : (e !== void 0 && (this.createBitmap = e), this._load = new Promise(function(i, o) {
        var a = n.source;
        n.url = a.src;
        var s = function() {
          n.destroyed || (a.onload = null, a.onerror = null, n.resize(a.width, a.height), n._load = null, n.createBitmap ? i(n.process()) : i(n));
        };
        a.complete && a.src ? s() : (a.onload = s, a.onerror = function(h) {
          o(h), n.onError.emit(h);
        });
      }), this._load);
    }, t.prototype.process = function() {
      var e = this, n = this.source;
      if (this._process !== null)
        return this._process;
      if (this.bitmap !== null || !globalThis.createImageBitmap)
        return Promise.resolve(this);
      var i = globalThis.createImageBitmap, o = !n.crossOrigin || n.crossOrigin === "anonymous";
      return this._process = fetch(n.src, {
        mode: o ? "cors" : "no-cors"
      }).then(function(a) {
        return a.blob();
      }).then(function(a) {
        return i(a, 0, 0, n.width, n.height, {
          premultiplyAlpha: e.alphaMode === null || e.alphaMode === pe.UNPACK ? "premultiply" : "none"
        });
      }).then(function(a) {
        return e.destroyed ? Promise.reject() : (e.bitmap = a, e.update(), e._process = null, Promise.resolve(e));
      }), this._process;
    }, t.prototype.upload = function(e, n, i) {
      if (typeof this.alphaMode == "number" && (n.alphaMode = this.alphaMode), !this.createBitmap)
        return r.prototype.upload.call(this, e, n, i);
      if (!this.bitmap && (this.process(), !this.bitmap))
        return !1;
      if (r.prototype.upload.call(this, e, n, i, this.bitmap), !this.preserveBitmap) {
        var o = !0, a = n._glTextures;
        for (var s in a) {
          var h = a[s];
          if (h !== i && h.dirtyId !== n.dirtyId) {
            o = !1;
            break;
          }
        }
        o && (this.bitmap.close && this.bitmap.close(), this.bitmap = null);
      }
      return !0;
    }, t.prototype.dispose = function() {
      this.source.onload = null, this.source.onerror = null, r.prototype.dispose.call(this), this.bitmap && (this.bitmap.close(), this.bitmap = null), this._process = null, this._load = null;
    }, t.test = function(e) {
      return typeof e == "string" || e instanceof HTMLImageElement;
    }, t;
  }(Ge)
), Oy = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n) {
      var i = this;
      return n = n || {}, i = r.call(this, G.ADAPTER.createCanvas()) || this, i._width = 0, i._height = 0, i.svg = e, i.scale = n.scale || 1, i._overrideWidth = n.width, i._overrideHeight = n.height, i._resolve = null, i._crossorigin = n.crossorigin, i._load = null, n.autoLoad !== !1 && i.load(), i;
    }
    return t.prototype.load = function() {
      var e = this;
      return this._load ? this._load : (this._load = new Promise(function(n) {
        if (e._resolve = function() {
          e.resize(e.source.width, e.source.height), n(e);
        }, t.SVG_XML.test(e.svg.trim())) {
          if (!btoa)
            throw new Error("Your browser doesn't support base64 conversions.");
          e.svg = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(e.svg)));
        }
        e._loadSvg();
      }), this._load);
    }, t.prototype._loadSvg = function() {
      var e = this, n = new Image();
      Ge.crossOrigin(n, this.svg, this._crossorigin), n.src = this.svg, n.onerror = function(i) {
        e._resolve && (n.onerror = null, e.onError.emit(i));
      }, n.onload = function() {
        if (e._resolve) {
          var i = n.width, o = n.height;
          if (!i || !o)
            throw new Error("The SVG image must have width and height defined (in pixels), canvas API needs them.");
          var a = i * e.scale, s = o * e.scale;
          (e._overrideWidth || e._overrideHeight) && (a = e._overrideWidth || e._overrideHeight / o * i, s = e._overrideHeight || e._overrideWidth / i * o), a = Math.round(a), s = Math.round(s);
          var h = e.source;
          h.width = a, h.height = s, h._pixiId = "canvas_" + lr(), h.getContext("2d").drawImage(n, 0, 0, i, o, 0, 0, a, s), e._resolve(), e._resolve = null;
        }
      };
    }, t.getSize = function(e) {
      var n = t.SVG_SIZE.exec(e), i = {};
      return n && (i[n[1]] = Math.round(parseFloat(n[3])), i[n[5]] = Math.round(parseFloat(n[7]))), i;
    }, t.prototype.dispose = function() {
      r.prototype.dispose.call(this), this._resolve = null, this._crossorigin = null;
    }, t.test = function(e, n) {
      return n === "svg" || typeof e == "string" && e.startsWith("data:image/svg+xml") || typeof e == "string" && t.SVG_XML.test(e);
    }, t.SVG_XML = /^(<\?xml[^?]+\?>)?\s*(<!--[^(-->)]*-->)?\s*\<svg/m, t.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i, t;
  }(Ge)
), Ry = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n) {
      var i = this;
      if (n = n || {}, !(e instanceof HTMLVideoElement)) {
        var o = document.createElement("video");
        o.setAttribute("preload", "auto"), o.setAttribute("webkit-playsinline", ""), o.setAttribute("playsinline", ""), typeof e == "string" && (e = [e]);
        var a = e[0].src || e[0];
        Ge.crossOrigin(o, a, n.crossorigin);
        for (var s = 0; s < e.length; ++s) {
          var h = document.createElement("source"), u = e[s], l = u.src, f = u.mime;
          l = l || e[s];
          var c = l.split("?").shift().toLowerCase(), d = c.slice(c.lastIndexOf(".") + 1);
          f = f || t.MIME_TYPES[d] || "video/" + d, h.src = l, h.type = f, o.appendChild(h);
        }
        e = o;
      }
      return i = r.call(this, e) || this, i.noSubImage = !0, i._autoUpdate = !0, i._isConnectedToTicker = !1, i._updateFPS = n.updateFPS || 0, i._msToNextUpdate = 0, i.autoPlay = n.autoPlay !== !1, i._load = null, i._resolve = null, i._onCanPlay = i._onCanPlay.bind(i), i._onError = i._onError.bind(i), n.autoLoad !== !1 && i.load(), i;
    }
    return t.prototype.update = function(e) {
      if (!this.destroyed) {
        var n = Ht.shared.elapsedMS * this.source.playbackRate;
        this._msToNextUpdate = Math.floor(this._msToNextUpdate - n), (!this._updateFPS || this._msToNextUpdate <= 0) && (r.prototype.update.call(this), this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0);
      }
    }, t.prototype.load = function() {
      var e = this;
      if (this._load)
        return this._load;
      var n = this.source;
      return (n.readyState === n.HAVE_ENOUGH_DATA || n.readyState === n.HAVE_FUTURE_DATA) && n.width && n.height && (n.complete = !0), n.addEventListener("play", this._onPlayStart.bind(this)), n.addEventListener("pause", this._onPlayStop.bind(this)), this._isSourceReady() ? this._onCanPlay() : (n.addEventListener("canplay", this._onCanPlay), n.addEventListener("canplaythrough", this._onCanPlay), n.addEventListener("error", this._onError, !0)), this._load = new Promise(function(i) {
        e.valid ? i(e) : (e._resolve = i, n.load());
      }), this._load;
    }, t.prototype._onError = function(e) {
      this.source.removeEventListener("error", this._onError, !0), this.onError.emit(e);
    }, t.prototype._isSourcePlaying = function() {
      var e = this.source;
      return !e.paused && !e.ended && this._isSourceReady();
    }, t.prototype._isSourceReady = function() {
      var e = this.source;
      return e.readyState > 2;
    }, t.prototype._onPlayStart = function() {
      this.valid || this._onCanPlay(), this.autoUpdate && !this._isConnectedToTicker && (Ht.shared.add(this.update, this), this._isConnectedToTicker = !0);
    }, t.prototype._onPlayStop = function() {
      this._isConnectedToTicker && (Ht.shared.remove(this.update, this), this._isConnectedToTicker = !1);
    }, t.prototype._onCanPlay = function() {
      var e = this.source;
      e.removeEventListener("canplay", this._onCanPlay), e.removeEventListener("canplaythrough", this._onCanPlay);
      var n = this.valid;
      this.resize(e.videoWidth, e.videoHeight), !n && this._resolve && (this._resolve(this), this._resolve = null), this._isSourcePlaying() ? this._onPlayStart() : this.autoPlay && e.play();
    }, t.prototype.dispose = function() {
      this._isConnectedToTicker && (Ht.shared.remove(this.update, this), this._isConnectedToTicker = !1);
      var e = this.source;
      e && (e.removeEventListener("error", this._onError, !0), e.pause(), e.src = "", e.load()), r.prototype.dispose.call(this);
    }, Object.defineProperty(t.prototype, "autoUpdate", {
      /** Should the base texture automatically update itself, set to true by default. */
      get: function() {
        return this._autoUpdate;
      },
      set: function(e) {
        e !== this._autoUpdate && (this._autoUpdate = e, !this._autoUpdate && this._isConnectedToTicker ? (Ht.shared.remove(this.update, this), this._isConnectedToTicker = !1) : this._autoUpdate && !this._isConnectedToTicker && this._isSourcePlaying() && (Ht.shared.add(this.update, this), this._isConnectedToTicker = !0));
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "updateFPS", {
      /**
       * How many times a second to update the texture from the video. Leave at 0 to update at every render.
       * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
       */
      get: function() {
        return this._updateFPS;
      },
      set: function(e) {
        e !== this._updateFPS && (this._updateFPS = e);
      },
      enumerable: !1,
      configurable: !0
    }), t.test = function(e, n) {
      return globalThis.HTMLVideoElement && e instanceof HTMLVideoElement || t.TYPES.indexOf(n) > -1;
    }, t.TYPES = ["mp4", "m4v", "webm", "ogg", "ogv", "h264", "avi", "mov"], t.MIME_TYPES = {
      ogv: "video/ogg",
      mov: "video/quicktime",
      m4v: "video/mp4"
    }, t;
  }(Ge)
), Iy = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e) {
      return r.call(this, e) || this;
    }
    return t.test = function(e) {
      return !!globalThis.createImageBitmap && typeof ImageBitmap < "u" && e instanceof ImageBitmap;
    }, t;
  }(Ge)
);
na.push(ml, Iy, Ay, Ry, Oy, Pn, Py, Sy);
var Cy = (
  /** @class */
  function(r) {
    xt(t, r);
    function t() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return t.prototype.upload = function(e, n, i) {
      var o = e.gl;
      o.pixelStorei(o.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.alphaMode === pe.UNPACK);
      var a = n.realWidth, s = n.realHeight;
      return i.width === a && i.height === s ? o.texSubImage2D(n.target, 0, 0, 0, a, s, n.format, i.type, this.data) : (i.width = a, i.height = s, o.texImage2D(n.target, 0, i.internalFormat, a, s, 0, n.format, i.type, this.data)), !0;
    }, t;
  }(Pn)
), aa = (
  /** @class */
  function() {
    function r(t, e) {
      this.width = Math.round(t || 100), this.height = Math.round(e || 100), this.stencil = !1, this.depth = !1, this.dirtyId = 0, this.dirtyFormat = 0, this.dirtySize = 0, this.depthTexture = null, this.colorTextures = [], this.glFramebuffers = {}, this.disposeRunner = new kt("disposeFramebuffer"), this.multisample = wt.NONE;
    }
    return Object.defineProperty(r.prototype, "colorTexture", {
      /**
       * Reference to the colorTexture.
       * @readonly
       */
      get: function() {
        return this.colorTextures[0];
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.addColorTexture = function(t, e) {
      return t === void 0 && (t = 0), this.colorTextures[t] = e || new ht(null, {
        scaleMode: ye.NEAREST,
        resolution: 1,
        mipmap: de.OFF,
        width: this.width,
        height: this.height
      }), this.dirtyId++, this.dirtyFormat++, this;
    }, r.prototype.addDepthTexture = function(t) {
      return this.depthTexture = t || new ht(new Cy(null, { width: this.width, height: this.height }), {
        scaleMode: ye.NEAREST,
        resolution: 1,
        width: this.width,
        height: this.height,
        mipmap: de.OFF,
        format: L.DEPTH_COMPONENT,
        type: X.UNSIGNED_SHORT
      }), this.dirtyId++, this.dirtyFormat++, this;
    }, r.prototype.enableDepth = function() {
      return this.depth = !0, this.dirtyId++, this.dirtyFormat++, this;
    }, r.prototype.enableStencil = function() {
      return this.stencil = !0, this.dirtyId++, this.dirtyFormat++, this;
    }, r.prototype.resize = function(t, e) {
      if (t = Math.round(t), e = Math.round(e), !(t === this.width && e === this.height)) {
        this.width = t, this.height = e, this.dirtyId++, this.dirtySize++;
        for (var n = 0; n < this.colorTextures.length; n++) {
          var i = this.colorTextures[n], o = i.resolution;
          i.setSize(t / o, e / o);
        }
        if (this.depthTexture) {
          var o = this.depthTexture.resolution;
          this.depthTexture.setSize(t / o, e / o);
        }
      }
    }, r.prototype.dispose = function() {
      this.disposeRunner.emit(this, !1);
    }, r.prototype.destroyDepthTexture = function() {
      this.depthTexture && (this.depthTexture.destroy(), this.depthTexture = null, ++this.dirtyId, ++this.dirtyFormat);
    }, r;
  }()
), yl = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e) {
      e === void 0 && (e = {});
      var n = this;
      if (typeof e == "number") {
        var i = arguments[0], o = arguments[1], a = arguments[2], s = arguments[3];
        e = { width: i, height: o, scaleMode: a, resolution: s };
      }
      return e.width = e.width || 100, e.height = e.height || 100, e.multisample = e.multisample !== void 0 ? e.multisample : wt.NONE, n = r.call(this, null, e) || this, n.mipmap = de.OFF, n.valid = !0, n.clearColor = [0, 0, 0, 0], n.framebuffer = new aa(n.realWidth, n.realHeight).addColorTexture(0, n), n.framebuffer.multisample = e.multisample, n.maskStack = [], n.filterStack = [{}], n;
    }
    return t.prototype.resize = function(e, n) {
      this.framebuffer.resize(e * this.resolution, n * this.resolution), this.setRealSize(this.framebuffer.width, this.framebuffer.height);
    }, t.prototype.dispose = function() {
      this.framebuffer.dispose(), r.prototype.dispose.call(this);
    }, t.prototype.destroy = function() {
      r.prototype.destroy.call(this), this.framebuffer.destroyDepthTexture(), this.framebuffer = null;
    }, t;
  }(ht)
), gl = (
  /** @class */
  function() {
    function r() {
      this.x0 = 0, this.y0 = 0, this.x1 = 1, this.y1 = 0, this.x2 = 1, this.y2 = 1, this.x3 = 0, this.y3 = 1, this.uvsFloat32 = new Float32Array(8);
    }
    return r.prototype.set = function(t, e, n) {
      var i = e.width, o = e.height;
      if (n) {
        var a = t.width / 2 / i, s = t.height / 2 / o, h = t.x / i + a, u = t.y / o + s;
        n = St.add(n, St.NW), this.x0 = h + a * St.uX(n), this.y0 = u + s * St.uY(n), n = St.add(n, 2), this.x1 = h + a * St.uX(n), this.y1 = u + s * St.uY(n), n = St.add(n, 2), this.x2 = h + a * St.uX(n), this.y2 = u + s * St.uY(n), n = St.add(n, 2), this.x3 = h + a * St.uX(n), this.y3 = u + s * St.uY(n);
      } else
        this.x0 = t.x / i, this.y0 = t.y / o, this.x1 = (t.x + t.width) / i, this.y1 = t.y / o, this.x2 = (t.x + t.width) / i, this.y2 = (t.y + t.height) / o, this.x3 = t.x / i, this.y3 = (t.y + t.height) / o;
      this.uvsFloat32[0] = this.x0, this.uvsFloat32[1] = this.y0, this.uvsFloat32[2] = this.x1, this.uvsFloat32[3] = this.y1, this.uvsFloat32[4] = this.x2, this.uvsFloat32[5] = this.y2, this.uvsFloat32[6] = this.x3, this.uvsFloat32[7] = this.y3;
    }, r.prototype.toString = function() {
      return "[@pixi/core:TextureUvs " + ("x0=" + this.x0 + " y0=" + this.y0 + " ") + ("x1=" + this.x1 + " y1=" + this.y1 + " x2=" + this.x2 + " ") + ("y2=" + this.y2 + " x3=" + this.x3 + " y3=" + this.y3) + "]";
    }, r;
  }()
), xh = new gl();
function Yn(r) {
  r.destroy = function() {
  }, r.on = function() {
  }, r.once = function() {
  }, r.emit = function() {
  };
}
var J = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n, i, o, a, s) {
      var h = r.call(this) || this;
      if (h.noFrame = !1, n || (h.noFrame = !0, n = new ut(0, 0, 1, 1)), e instanceof t && (e = e.baseTexture), h.baseTexture = e, h._frame = n, h.trim = o, h.valid = !1, h._uvs = xh, h.uvMatrix = null, h.orig = i || n, h._rotate = Number(a || 0), a === !0)
        h._rotate = 2;
      else if (h._rotate % 2 !== 0)
        throw new Error("attempt to use diamond-shaped UVs. If you are sure, set rotation manually");
      return h.defaultAnchor = s ? new Et(s.x, s.y) : new Et(0, 0), h._updateID = 0, h.textureCacheIds = [], e.valid ? h.noFrame ? e.valid && h.onBaseTextureUpdated(e) : h.frame = n : e.once("loaded", h.onBaseTextureUpdated, h), h.noFrame && e.on("update", h.onBaseTextureUpdated, h), h;
    }
    return t.prototype.update = function() {
      this.baseTexture.resource && this.baseTexture.resource.update();
    }, t.prototype.onBaseTextureUpdated = function(e) {
      if (this.noFrame) {
        if (!this.baseTexture.valid)
          return;
        this._frame.width = e.width, this._frame.height = e.height, this.valid = !0, this.updateUvs();
      } else
        this.frame = this._frame;
      this.emit("update", this);
    }, t.prototype.destroy = function(e) {
      if (this.baseTexture) {
        if (e) {
          var n = this.baseTexture.resource;
          n && n.url && Ae[n.url] && t.removeFromCache(n.url), this.baseTexture.destroy();
        }
        this.baseTexture.off("loaded", this.onBaseTextureUpdated, this), this.baseTexture.off("update", this.onBaseTextureUpdated, this), this.baseTexture = null;
      }
      this._frame = null, this._uvs = null, this.trim = null, this.orig = null, this.valid = !1, t.removeFromCache(this), this.textureCacheIds = null;
    }, t.prototype.clone = function() {
      var e = this._frame.clone(), n = this._frame === this.orig ? e : this.orig.clone(), i = new t(this.baseTexture, !this.noFrame && e, n, this.trim && this.trim.clone(), this.rotate, this.defaultAnchor);
      return this.noFrame && (i._frame = e), i;
    }, t.prototype.updateUvs = function() {
      this._uvs === xh && (this._uvs = new gl()), this._uvs.set(this._frame, this.baseTexture, this.rotate), this._updateID++;
    }, t.from = function(e, n, i) {
      n === void 0 && (n = {}), i === void 0 && (i = G.STRICT_TEXTURE_CACHE);
      var o = typeof e == "string", a = null;
      if (o)
        a = e;
      else if (e instanceof ht) {
        if (!e.cacheId) {
          var s = n && n.pixiIdPrefix || "pixiid";
          e.cacheId = s + "-" + lr(), ht.addToCache(e, e.cacheId);
        }
        a = e.cacheId;
      } else {
        if (!e._pixiId) {
          var s = n && n.pixiIdPrefix || "pixiid";
          e._pixiId = s + "_" + lr();
        }
        a = e._pixiId;
      }
      var h = Ae[a];
      if (o && i && !h)
        throw new Error('The cacheId "' + a + '" does not exist in TextureCache.');
      return !h && !(e instanceof ht) ? (n.resolution || (n.resolution = Ai(e)), h = new t(new ht(e, n)), h.baseTexture.cacheId = a, ht.addToCache(h.baseTexture, a), t.addToCache(h, a)) : !h && e instanceof ht && (h = new t(e), t.addToCache(h, a)), h;
    }, t.fromURL = function(e, n) {
      var i = Object.assign({ autoLoad: !1 }, n == null ? void 0 : n.resourceOptions), o = t.from(e, Object.assign({ resourceOptions: i }, n), !1), a = o.baseTexture.resource;
      return o.baseTexture.valid ? Promise.resolve(o) : a.load().then(function() {
        return Promise.resolve(o);
      });
    }, t.fromBuffer = function(e, n, i, o) {
      return new t(ht.fromBuffer(e, n, i, o));
    }, t.fromLoader = function(e, n, i, o) {
      var a = new ht(e, Object.assign({
        scaleMode: G.SCALE_MODE,
        resolution: Ai(n)
      }, o)), s = a.resource;
      s instanceof ml && (s.url = n);
      var h = new t(a);
      return i || (i = n), ht.addToCache(h.baseTexture, i), t.addToCache(h, i), i !== n && (ht.addToCache(h.baseTexture, n), t.addToCache(h, n)), h.baseTexture.valid ? Promise.resolve(h) : new Promise(function(u) {
        h.baseTexture.once("loaded", function() {
          return u(h);
        });
      });
    }, t.addToCache = function(e, n) {
      n && (e.textureCacheIds.indexOf(n) === -1 && e.textureCacheIds.push(n), Ae[n] && console.warn("Texture added to the cache with an id [" + n + "] that already had an entry"), Ae[n] = e);
    }, t.removeFromCache = function(e) {
      if (typeof e == "string") {
        var n = Ae[e];
        if (n) {
          var i = n.textureCacheIds.indexOf(e);
          return i > -1 && n.textureCacheIds.splice(i, 1), delete Ae[e], n;
        }
      } else if (e && e.textureCacheIds) {
        for (var o = 0; o < e.textureCacheIds.length; ++o)
          Ae[e.textureCacheIds[o]] === e && delete Ae[e.textureCacheIds[o]];
        return e.textureCacheIds.length = 0, e;
      }
      return null;
    }, Object.defineProperty(t.prototype, "resolution", {
      /**
       * Returns resolution of baseTexture
       * @readonly
       */
      get: function() {
        return this.baseTexture.resolution;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "frame", {
      /**
       * The frame specifies the region of the base texture that this texture uses.
       * Please call `updateUvs()` after you change coordinates of `frame` manually.
       */
      get: function() {
        return this._frame;
      },
      set: function(e) {
        this._frame = e, this.noFrame = !1;
        var n = e.x, i = e.y, o = e.width, a = e.height, s = n + o > this.baseTexture.width, h = i + a > this.baseTexture.height;
        if (s || h) {
          var u = s && h ? "and" : "or", l = "X: " + n + " + " + o + " = " + (n + o) + " > " + this.baseTexture.width, f = "Y: " + i + " + " + a + " = " + (i + a) + " > " + this.baseTexture.height;
          throw new Error("Texture Error: frame does not fit inside the base Texture dimensions: " + (l + " " + u + " " + f));
        }
        this.valid = o && a && this.baseTexture.valid, !this.trim && !this.rotate && (this.orig = e), this.valid && this.updateUvs();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "rotate", {
      /**
       * Indicates whether the texture is rotated inside the atlas
       * set to 2 to compensate for texture packer rotation
       * set to 6 to compensate for spine packer rotation
       * can be used to rotate or mirror sprites
       * See {@link PIXI.groupD8} for explanation
       */
      get: function() {
        return this._rotate;
      },
      set: function(e) {
        this._rotate = e, this.valid && this.updateUvs();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "width", {
      /** The width of the Texture in pixels. */
      get: function() {
        return this.orig.width;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "height", {
      /** The height of the Texture in pixels. */
      get: function() {
        return this.orig.height;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.castToBaseTexture = function() {
      return this.baseTexture;
    }, Object.defineProperty(t, "EMPTY", {
      /** An empty texture, used often to not have to create multiple empty textures. Can not be destroyed. */
      get: function() {
        return t._EMPTY || (t._EMPTY = new t(new ht()), Yn(t._EMPTY), Yn(t._EMPTY.baseTexture)), t._EMPTY;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "WHITE", {
      /** A white texture of 16x16 size, used for graphics and other things Can not be destroyed. */
      get: function() {
        if (!t._WHITE) {
          var e = G.ADAPTER.createCanvas(16, 16), n = e.getContext("2d");
          e.width = 16, e.height = 16, n.fillStyle = "white", n.fillRect(0, 0, 16, 16), t._WHITE = new t(ht.from(e)), Yn(t._WHITE), Yn(t._WHITE.baseTexture);
        }
        return t._WHITE;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Sn)
), fr = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n) {
      var i = r.call(this, e, n) || this;
      return i.valid = !0, i.filterFrame = null, i.filterPoolKey = null, i.updateUvs(), i;
    }
    return Object.defineProperty(t.prototype, "framebuffer", {
      /**
       * Shortcut to `this.baseTexture.framebuffer`, saves baseTexture cast.
       * @readonly
       */
      get: function() {
        return this.baseTexture.framebuffer;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "multisample", {
      /**
       * Shortcut to `this.framebuffer.multisample`.
       * @default PIXI.MSAA_QUALITY.NONE
       */
      get: function() {
        return this.framebuffer.multisample;
      },
      set: function(e) {
        this.framebuffer.multisample = e;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.resize = function(e, n, i) {
      i === void 0 && (i = !0);
      var o = this.baseTexture.resolution, a = Math.round(e * o) / o, s = Math.round(n * o) / o;
      this.valid = a > 0 && s > 0, this._frame.width = this.orig.width = a, this._frame.height = this.orig.height = s, i && this.baseTexture.resize(a, s), this.updateUvs();
    }, t.prototype.setResolution = function(e) {
      var n = this.baseTexture;
      n.resolution !== e && (n.setResolution(e), this.resize(n.width, n.height, !1));
    }, t.create = function(e) {
      for (var n = arguments, i = [], o = 1; o < arguments.length; o++)
        i[o - 1] = n[o];
      return typeof e == "number" && (ce("6.0.0", "Arguments (width, height, scaleMode, resolution) have been deprecated."), e = {
        width: e,
        height: i[0],
        scaleMode: i[1],
        resolution: i[2]
      }), new t(new yl(e));
    }, t;
  }(J)
), My = (
  /** @class */
  function() {
    function r(t) {
      this.texturePool = {}, this.textureOptions = t || {}, this.enableFullScreen = !1, this._pixelsWidth = 0, this._pixelsHeight = 0;
    }
    return r.prototype.createTexture = function(t, e, n) {
      n === void 0 && (n = wt.NONE);
      var i = new yl(Object.assign({
        width: t,
        height: e,
        resolution: 1,
        multisample: n
      }, this.textureOptions));
      return new fr(i);
    }, r.prototype.getOptimalTexture = function(t, e, n, i) {
      n === void 0 && (n = 1), i === void 0 && (i = wt.NONE);
      var o;
      t = Math.ceil(t * n - 1e-6), e = Math.ceil(e * n - 1e-6), !this.enableFullScreen || t !== this._pixelsWidth || e !== this._pixelsHeight ? (t = Si(t), e = Si(e), o = ((t & 65535) << 16 | e & 65535) >>> 0, i > 1 && (o += i * 4294967296)) : o = i > 1 ? -i : -1, this.texturePool[o] || (this.texturePool[o] = []);
      var a = this.texturePool[o].pop();
      return a || (a = this.createTexture(t, e, i)), a.filterPoolKey = o, a.setResolution(n), a;
    }, r.prototype.getFilterTexture = function(t, e, n) {
      var i = this.getOptimalTexture(t.width, t.height, e || t.resolution, n || wt.NONE);
      return i.filterFrame = t.filterFrame, i;
    }, r.prototype.returnTexture = function(t) {
      var e = t.filterPoolKey;
      t.filterFrame = null, this.texturePool[e].push(t);
    }, r.prototype.returnFilterTexture = function(t) {
      this.returnTexture(t);
    }, r.prototype.clear = function(t) {
      if (t = t !== !1, t)
        for (var e in this.texturePool) {
          var n = this.texturePool[e];
          if (n)
            for (var i = 0; i < n.length; i++)
              n[i].destroy(!0);
        }
      this.texturePool = {};
    }, r.prototype.setScreenSize = function(t) {
      if (!(t.width === this._pixelsWidth && t.height === this._pixelsHeight)) {
        this.enableFullScreen = t.width > 0 && t.height > 0;
        for (var e in this.texturePool)
          if (Number(e) < 0) {
            var n = this.texturePool[e];
            if (n)
              for (var i = 0; i < n.length; i++)
                n[i].destroy(!0);
            this.texturePool[e] = [];
          }
        this._pixelsWidth = t.width, this._pixelsHeight = t.height;
      }
    }, r.SCREEN_KEY = -1, r;
  }()
), Th = (
  /** @class */
  function() {
    function r(t, e, n, i, o, a, s) {
      e === void 0 && (e = 0), n === void 0 && (n = !1), i === void 0 && (i = X.FLOAT), this.buffer = t, this.size = e, this.normalized = n, this.type = i, this.stride = o, this.start = a, this.instance = s;
    }
    return r.prototype.destroy = function() {
      this.buffer = null;
    }, r.from = function(t, e, n, i, o) {
      return new r(t, e, n, i, o);
    }, r;
  }()
), Dy = 0, Mt = (
  /** @class */
  function() {
    function r(t, e, n) {
      e === void 0 && (e = !0), n === void 0 && (n = !1), this.data = t || new Float32Array(1), this._glBuffers = {}, this._updateID = 0, this.index = n, this.static = e, this.id = Dy++, this.disposeRunner = new kt("disposeBuffer");
    }
    return r.prototype.update = function(t) {
      t instanceof Array && (t = new Float32Array(t)), this.data = t || this.data, this._updateID++;
    }, r.prototype.dispose = function() {
      this.disposeRunner.emit(this, !1);
    }, r.prototype.destroy = function() {
      this.dispose(), this.data = null;
    }, Object.defineProperty(r.prototype, "index", {
      get: function() {
        return this.type === xe.ELEMENT_ARRAY_BUFFER;
      },
      /**
       * Flags whether this is an index buffer.
       *
       * Index buffers are of type `ELEMENT_ARRAY_BUFFER`. Note that setting this property to false will make
       * the buffer of type `ARRAY_BUFFER`.
       *
       * For backwards compatibility.
       */
      set: function(t) {
        this.type = t ? xe.ELEMENT_ARRAY_BUFFER : xe.ARRAY_BUFFER;
      },
      enumerable: !1,
      configurable: !0
    }), r.from = function(t) {
      return t instanceof Array && (t = new Float32Array(t)), new r(t);
    }, r;
  }()
), Fy = {
  Float32Array,
  Uint32Array,
  Int32Array,
  Uint8Array
};
function By(r, t) {
  for (var e = 0, n = 0, i = {}, o = 0; o < r.length; o++)
    n += t[o], e += r[o].length;
  for (var a = new ArrayBuffer(e * 4), s = null, h = 0, o = 0; o < r.length; o++) {
    var u = t[o], l = r[o], f = fl(l);
    i[f] || (i[f] = new Fy[f](a)), s = i[f];
    for (var c = 0; c < l.length; c++) {
      var d = (c / u | 0) * n + h, p = c % u;
      s[d + p] = l[c];
    }
    h += u;
  }
  return new Float32Array(a);
}
var Eh = { 5126: 4, 5123: 2, 5121: 1 }, Ny = 0, Ly = {
  Float32Array,
  Uint32Array,
  Int32Array,
  Uint8Array,
  Uint16Array
}, On = (
  /** @class */
  function() {
    function r(t, e) {
      t === void 0 && (t = []), e === void 0 && (e = {}), this.buffers = t, this.indexBuffer = null, this.attributes = e, this.glVertexArrayObjects = {}, this.id = Ny++, this.instanced = !1, this.instanceCount = 1, this.disposeRunner = new kt("disposeGeometry"), this.refCount = 0;
    }
    return r.prototype.addAttribute = function(t, e, n, i, o, a, s, h) {
      if (n === void 0 && (n = 0), i === void 0 && (i = !1), h === void 0 && (h = !1), !e)
        throw new Error("You must pass a buffer when creating an attribute");
      e instanceof Mt || (e instanceof Array && (e = new Float32Array(e)), e = new Mt(e));
      var u = t.split("|");
      if (u.length > 1) {
        for (var l = 0; l < u.length; l++)
          this.addAttribute(u[l], e, n, i, o);
        return this;
      }
      var f = this.buffers.indexOf(e);
      return f === -1 && (this.buffers.push(e), f = this.buffers.length - 1), this.attributes[t] = new Th(f, n, i, o, a, s, h), this.instanced = this.instanced || h, this;
    }, r.prototype.getAttribute = function(t) {
      return this.attributes[t];
    }, r.prototype.getBuffer = function(t) {
      return this.buffers[this.getAttribute(t).buffer];
    }, r.prototype.addIndex = function(t) {
      return t instanceof Mt || (t instanceof Array && (t = new Uint16Array(t)), t = new Mt(t)), t.type = xe.ELEMENT_ARRAY_BUFFER, this.indexBuffer = t, this.buffers.indexOf(t) === -1 && this.buffers.push(t), this;
    }, r.prototype.getIndex = function() {
      return this.indexBuffer;
    }, r.prototype.interleave = function() {
      if (this.buffers.length === 1 || this.buffers.length === 2 && this.indexBuffer)
        return this;
      var t = [], e = [], n = new Mt(), i;
      for (i in this.attributes) {
        var o = this.attributes[i], a = this.buffers[o.buffer];
        t.push(a.data), e.push(o.size * Eh[o.type] / 4), o.buffer = 0;
      }
      for (n.data = By(t, e), i = 0; i < this.buffers.length; i++)
        this.buffers[i] !== this.indexBuffer && this.buffers[i].destroy();
      return this.buffers = [n], this.indexBuffer && this.buffers.push(this.indexBuffer), this;
    }, r.prototype.getSize = function() {
      for (var t in this.attributes) {
        var e = this.attributes[t], n = this.buffers[e.buffer];
        return n.data.length / (e.stride / 4 || e.size);
      }
      return 0;
    }, r.prototype.dispose = function() {
      this.disposeRunner.emit(this, !1);
    }, r.prototype.destroy = function() {
      this.dispose(), this.buffers = null, this.indexBuffer = null, this.attributes = null;
    }, r.prototype.clone = function() {
      for (var t = new r(), e = 0; e < this.buffers.length; e++)
        t.buffers[e] = new Mt(this.buffers[e].data.slice(0));
      for (var e in this.attributes) {
        var n = this.attributes[e];
        t.attributes[e] = new Th(n.buffer, n.size, n.normalized, n.type, n.stride, n.start, n.instance);
      }
      return this.indexBuffer && (t.indexBuffer = t.buffers[this.buffers.indexOf(this.indexBuffer)], t.indexBuffer.type = xe.ELEMENT_ARRAY_BUFFER), t;
    }, r.merge = function(t) {
      for (var e = new r(), n = [], i = [], o = [], a, s = 0; s < t.length; s++) {
        a = t[s];
        for (var h = 0; h < a.buffers.length; h++)
          i[h] = i[h] || 0, i[h] += a.buffers[h].data.length, o[h] = 0;
      }
      for (var s = 0; s < a.buffers.length; s++)
        n[s] = new Ly[fl(a.buffers[s].data)](i[s]), e.buffers[s] = new Mt(n[s]);
      for (var s = 0; s < t.length; s++) {
        a = t[s];
        for (var h = 0; h < a.buffers.length; h++)
          n[h].set(a.buffers[h].data, o[h]), o[h] += a.buffers[h].data.length;
      }
      if (e.attributes = a.attributes, a.indexBuffer) {
        e.indexBuffer = e.buffers[a.buffers.indexOf(a.indexBuffer)], e.indexBuffer.type = xe.ELEMENT_ARRAY_BUFFER;
        for (var u = 0, l = 0, f = 0, c = 0, s = 0; s < a.buffers.length; s++)
          if (a.buffers[s] !== a.indexBuffer) {
            c = s;
            break;
          }
        for (var s in a.attributes) {
          var d = a.attributes[s];
          (d.buffer | 0) === c && (l += d.size * Eh[d.type] / 4);
        }
        for (var s = 0; s < t.length; s++) {
          for (var p = t[s].indexBuffer.data, h = 0; h < p.length; h++)
            e.indexBuffer.data[h + f] += u;
          u += t[s].buffers[c].data.length / l, f += p.length;
        }
      }
      return e;
    }, r;
  }()
), Uy = (
  /** @class */
  function(r) {
    xt(t, r);
    function t() {
      var e = r.call(this) || this;
      return e.addAttribute("aVertexPosition", new Float32Array([
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1
      ])).addIndex([0, 1, 3, 2]), e;
    }
    return t;
  }(On)
), bl = (
  /** @class */
  function(r) {
    xt(t, r);
    function t() {
      var e = r.call(this) || this;
      return e.vertices = new Float32Array([
        -1,
        -1,
        1,
        -1,
        1,
        1,
        -1,
        1
      ]), e.uvs = new Float32Array([
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1
      ]), e.vertexBuffer = new Mt(e.vertices), e.uvBuffer = new Mt(e.uvs), e.addAttribute("aVertexPosition", e.vertexBuffer).addAttribute("aTextureCoord", e.uvBuffer).addIndex([0, 1, 2, 0, 2, 3]), e;
    }
    return t.prototype.map = function(e, n) {
      var i = 0, o = 0;
      return this.uvs[0] = i, this.uvs[1] = o, this.uvs[2] = i + n.width / e.width, this.uvs[3] = o, this.uvs[4] = i + n.width / e.width, this.uvs[5] = o + n.height / e.height, this.uvs[6] = i, this.uvs[7] = o + n.height / e.height, i = n.x, o = n.y, this.vertices[0] = i, this.vertices[1] = o, this.vertices[2] = i + n.width, this.vertices[3] = o, this.vertices[4] = i + n.width, this.vertices[5] = o + n.height, this.vertices[6] = i, this.vertices[7] = o + n.height, this.invalidate(), this;
    }, t.prototype.invalidate = function() {
      return this.vertexBuffer._updateID++, this.uvBuffer._updateID++, this;
    }, t;
  }(On)
), Gy = 0, hr = (
  /** @class */
  function() {
    function r(t, e, n) {
      this.group = !0, this.syncUniforms = {}, this.dirtyId = 0, this.id = Gy++, this.static = !!e, this.ubo = !!n, t instanceof Mt ? (this.buffer = t, this.buffer.type = xe.UNIFORM_BUFFER, this.autoManage = !1, this.ubo = !0) : (this.uniforms = t, this.ubo && (this.buffer = new Mt(new Float32Array(1)), this.buffer.type = xe.UNIFORM_BUFFER, this.autoManage = !0));
    }
    return r.prototype.update = function() {
      this.dirtyId++, !this.autoManage && this.buffer && this.buffer.update();
    }, r.prototype.add = function(t, e, n) {
      if (!this.ubo)
        this.uniforms[t] = new r(e, n);
      else
        throw new Error("[UniformGroup] uniform groups in ubo mode cannot be modified, or have uniform groups nested in them");
    }, r.from = function(t, e, n) {
      return new r(t, e, n);
    }, r.uboFrom = function(t, e) {
      return new r(t, e ?? !0, !0);
    }, r;
  }()
), ky = (
  /** @class */
  function() {
    function r() {
      this.renderTexture = null, this.target = null, this.legacy = !1, this.resolution = 1, this.multisample = wt.NONE, this.sourceFrame = new ut(), this.destinationFrame = new ut(), this.bindingSourceFrame = new ut(), this.bindingDestinationFrame = new ut(), this.filters = [], this.transform = null;
    }
    return r.prototype.clear = function() {
      this.target = null, this.filters = null, this.renderTexture = null;
    }, r;
  }()
), Vn = [new Et(), new Et(), new Et(), new Et()], co = new Dt(), Hy = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this.defaultFilterStack = [{}], this.texturePool = new My(), this.texturePool.setScreenSize(t.view), this.statePool = [], this.quad = new Uy(), this.quadUv = new bl(), this.tempRect = new ut(), this.activeState = {}, this.globalUniforms = new hr({
        outputFrame: new ut(),
        inputSize: new Float32Array(4),
        inputPixel: new Float32Array(4),
        inputClamp: new Float32Array(4),
        resolution: 1,
        // legacy variables
        filterArea: new Float32Array(4),
        filterClamp: new Float32Array(4)
      }, !0), this.forceClear = !1, this.useMaxPadding = !1;
    }
    return r.prototype.push = function(t, e) {
      for (var n, i, o = this.renderer, a = this.defaultFilterStack, s = this.statePool.pop() || new ky(), h = this.renderer.renderTexture, u = e[0].resolution, l = e[0].multisample, f = e[0].padding, c = e[0].autoFit, d = (n = e[0].legacy) !== null && n !== void 0 ? n : !0, p = 1; p < e.length; p++) {
        var v = e[p];
        u = Math.min(u, v.resolution), l = Math.min(l, v.multisample), f = this.useMaxPadding ? Math.max(f, v.padding) : f + v.padding, c = c && v.autoFit, d = d || ((i = v.legacy) !== null && i !== void 0 ? i : !0);
      }
      a.length === 1 && (this.defaultFilterStack[0].renderTexture = h.current), a.push(s), s.resolution = u, s.multisample = l, s.legacy = d, s.target = t, s.sourceFrame.copyFrom(t.filterArea || t.getBounds(!0)), s.sourceFrame.pad(f);
      var _ = this.tempRect.copyFrom(h.sourceFrame);
      o.projection.transform && this.transformAABB(co.copyFrom(o.projection.transform).invert(), _), c ? (s.sourceFrame.fit(_), (s.sourceFrame.width <= 0 || s.sourceFrame.height <= 0) && (s.sourceFrame.width = 0, s.sourceFrame.height = 0)) : s.sourceFrame.intersects(_) || (s.sourceFrame.width = 0, s.sourceFrame.height = 0), this.roundFrame(s.sourceFrame, h.current ? h.current.resolution : o.resolution, h.sourceFrame, h.destinationFrame, o.projection.transform), s.renderTexture = this.getOptimalFilterTexture(s.sourceFrame.width, s.sourceFrame.height, u, l), s.filters = e, s.destinationFrame.width = s.renderTexture.width, s.destinationFrame.height = s.renderTexture.height;
      var m = this.tempRect;
      m.x = 0, m.y = 0, m.width = s.sourceFrame.width, m.height = s.sourceFrame.height, s.renderTexture.filterFrame = s.sourceFrame, s.bindingSourceFrame.copyFrom(h.sourceFrame), s.bindingDestinationFrame.copyFrom(h.destinationFrame), s.transform = o.projection.transform, o.projection.transform = null, h.bind(s.renderTexture, s.sourceFrame, m), o.framebuffer.clear(0, 0, 0, 0);
    }, r.prototype.pop = function() {
      var t = this.defaultFilterStack, e = t.pop(), n = e.filters;
      this.activeState = e;
      var i = this.globalUniforms.uniforms;
      i.outputFrame = e.sourceFrame, i.resolution = e.resolution;
      var o = i.inputSize, a = i.inputPixel, s = i.inputClamp;
      if (o[0] = e.destinationFrame.width, o[1] = e.destinationFrame.height, o[2] = 1 / o[0], o[3] = 1 / o[1], a[0] = Math.round(o[0] * e.resolution), a[1] = Math.round(o[1] * e.resolution), a[2] = 1 / a[0], a[3] = 1 / a[1], s[0] = 0.5 * a[2], s[1] = 0.5 * a[3], s[2] = e.sourceFrame.width * o[2] - 0.5 * a[2], s[3] = e.sourceFrame.height * o[3] - 0.5 * a[3], e.legacy) {
        var h = i.filterArea;
        h[0] = e.destinationFrame.width, h[1] = e.destinationFrame.height, h[2] = e.sourceFrame.x, h[3] = e.sourceFrame.y, i.filterClamp = i.inputClamp;
      }
      this.globalUniforms.update();
      var u = t[t.length - 1];
      if (this.renderer.framebuffer.blit(), n.length === 1)
        n[0].apply(this, e.renderTexture, u.renderTexture, ue.BLEND, e), this.returnFilterTexture(e.renderTexture);
      else {
        var l = e.renderTexture, f = this.getOptimalFilterTexture(l.width, l.height, e.resolution);
        f.filterFrame = l.filterFrame;
        var c = 0;
        for (c = 0; c < n.length - 1; ++c) {
          c === 1 && e.multisample > 1 && (f = this.getOptimalFilterTexture(l.width, l.height, e.resolution), f.filterFrame = l.filterFrame), n[c].apply(this, l, f, ue.CLEAR, e);
          var d = l;
          l = f, f = d;
        }
        n[c].apply(this, l, u.renderTexture, ue.BLEND, e), c > 1 && e.multisample > 1 && this.returnFilterTexture(e.renderTexture), this.returnFilterTexture(l), this.returnFilterTexture(f);
      }
      e.clear(), this.statePool.push(e);
    }, r.prototype.bindAndClear = function(t, e) {
      e === void 0 && (e = ue.CLEAR);
      var n = this.renderer, i = n.renderTexture, o = n.state;
      if (t === this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? this.renderer.projection.transform = this.activeState.transform : this.renderer.projection.transform = null, t && t.filterFrame) {
        var a = this.tempRect;
        a.x = 0, a.y = 0, a.width = t.filterFrame.width, a.height = t.filterFrame.height, i.bind(t, t.filterFrame, a);
      } else
        t !== this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? i.bind(t) : this.renderer.renderTexture.bind(t, this.activeState.bindingSourceFrame, this.activeState.bindingDestinationFrame);
      var s = o.stateId & 1 || this.forceClear;
      (e === ue.CLEAR || e === ue.BLIT && s) && this.renderer.framebuffer.clear(0, 0, 0, 0);
    }, r.prototype.applyFilter = function(t, e, n, i) {
      var o = this.renderer;
      o.state.set(t.state), this.bindAndClear(n, i), t.uniforms.uSampler = e, t.uniforms.filterGlobals = this.globalUniforms, o.shader.bind(t), t.legacy = !!t.program.attributeData.aTextureCoord, t.legacy ? (this.quadUv.map(e._frame, e.filterFrame), o.geometry.bind(this.quadUv), o.geometry.draw(le.TRIANGLES)) : (o.geometry.bind(this.quad), o.geometry.draw(le.TRIANGLE_STRIP));
    }, r.prototype.calculateSpriteMatrix = function(t, e) {
      var n = this.activeState, i = n.sourceFrame, o = n.destinationFrame, a = e._texture.orig, s = t.set(o.width, 0, 0, o.height, i.x, i.y), h = e.worldTransform.copyTo(Dt.TEMP_MATRIX);
      return h.invert(), s.prepend(h), s.scale(1 / a.width, 1 / a.height), s.translate(e.anchor.x, e.anchor.y), s;
    }, r.prototype.destroy = function() {
      this.renderer = null, this.texturePool.clear(!1);
    }, r.prototype.getOptimalFilterTexture = function(t, e, n, i) {
      return n === void 0 && (n = 1), i === void 0 && (i = wt.NONE), this.texturePool.getOptimalTexture(t, e, n, i);
    }, r.prototype.getFilterTexture = function(t, e, n) {
      if (typeof t == "number") {
        var i = t;
        t = e, e = i;
      }
      t = t || this.activeState.renderTexture;
      var o = this.texturePool.getOptimalTexture(t.width, t.height, e || t.resolution, n || wt.NONE);
      return o.filterFrame = t.filterFrame, o;
    }, r.prototype.returnFilterTexture = function(t) {
      this.texturePool.returnTexture(t);
    }, r.prototype.emptyPool = function() {
      this.texturePool.clear(!0);
    }, r.prototype.resize = function() {
      this.texturePool.setScreenSize(this.renderer.view);
    }, r.prototype.transformAABB = function(t, e) {
      var n = Vn[0], i = Vn[1], o = Vn[2], a = Vn[3];
      n.set(e.left, e.top), i.set(e.left, e.bottom), o.set(e.right, e.top), a.set(e.right, e.bottom), t.apply(n, n), t.apply(i, i), t.apply(o, o), t.apply(a, a);
      var s = Math.min(n.x, i.x, o.x, a.x), h = Math.min(n.y, i.y, o.y, a.y), u = Math.max(n.x, i.x, o.x, a.x), l = Math.max(n.y, i.y, o.y, a.y);
      e.x = s, e.y = h, e.width = u - s, e.height = l - h;
    }, r.prototype.roundFrame = function(t, e, n, i, o) {
      if (!(t.width <= 0 || t.height <= 0 || n.width <= 0 || n.height <= 0)) {
        if (o) {
          var a = o.a, s = o.b, h = o.c, u = o.d;
          if ((Math.abs(s) > 1e-4 || Math.abs(h) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(u) > 1e-4))
            return;
        }
        o = o ? co.copyFrom(o) : co.identity(), o.translate(-n.x, -n.y).scale(i.width / n.width, i.height / n.height).translate(i.x, i.y), this.transformAABB(o, t), t.ceil(e), this.transformAABB(o.invert(), t);
      }
    }, r;
  }()
), Gi = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t;
    }
    return r.prototype.flush = function() {
    }, r.prototype.destroy = function() {
      this.renderer = null;
    }, r.prototype.start = function() {
    }, r.prototype.stop = function() {
      this.flush();
    }, r.prototype.render = function(t) {
    }, r;
  }()
), Xy = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this.emptyRenderer = new Gi(t), this.currentRenderer = this.emptyRenderer;
    }
    return r.prototype.setObjectRenderer = function(t) {
      this.currentRenderer !== t && (this.currentRenderer.stop(), this.currentRenderer = t, this.currentRenderer.start());
    }, r.prototype.flush = function() {
      this.setObjectRenderer(this.emptyRenderer);
    }, r.prototype.reset = function() {
      this.setObjectRenderer(this.emptyRenderer);
    }, r.prototype.copyBoundTextures = function(t, e) {
      for (var n = this.renderer.texture.boundTextures, i = e - 1; i >= 0; --i)
        t[i] = n[i] || null, t[i] && (t[i]._batchLocation = i);
    }, r.prototype.boundArray = function(t, e, n, i) {
      for (var o = t.elements, a = t.ids, s = t.count, h = 0, u = 0; u < s; u++) {
        var l = o[u], f = l._batchLocation;
        if (f >= 0 && f < i && e[f] === l) {
          a[u] = f;
          continue;
        }
        for (; h < i; ) {
          var c = e[h];
          if (c && c._batchEnabled === n && c._batchLocation === h) {
            h++;
            continue;
          }
          a[u] = h, l._batchLocation = h, e[h] = l;
          break;
        }
      }
    }, r.prototype.destroy = function() {
      this.renderer = null;
    }, r;
  }()
), wh = 0, jy = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this.webGLVersion = 1, this.extensions = {}, this.supports = {
        uint32Indices: !1
      }, this.handleContextLost = this.handleContextLost.bind(this), this.handleContextRestored = this.handleContextRestored.bind(this), t.view.addEventListener("webglcontextlost", this.handleContextLost, !1), t.view.addEventListener("webglcontextrestored", this.handleContextRestored, !1);
    }
    return Object.defineProperty(r.prototype, "isLost", {
      /**
       * `true` if the context is lost
       * @readonly
       */
      get: function() {
        return !this.gl || this.gl.isContextLost();
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.contextChange = function(t) {
      this.gl = t, this.renderer.gl = t, this.renderer.CONTEXT_UID = wh++;
    }, r.prototype.initFromContext = function(t) {
      this.gl = t, this.validateContext(t), this.renderer.gl = t, this.renderer.CONTEXT_UID = wh++, this.renderer.runners.contextChange.emit(t);
    }, r.prototype.initFromOptions = function(t) {
      var e = this.createContext(this.renderer.view, t);
      this.initFromContext(e);
    }, r.prototype.createContext = function(t, e) {
      var n;
      if (G.PREFER_ENV >= Ie.WEBGL2 && (n = t.getContext("webgl2", e)), n)
        this.webGLVersion = 2;
      else if (this.webGLVersion = 1, n = t.getContext("webgl", e) || t.getContext("experimental-webgl", e), !n)
        throw new Error("This browser does not support WebGL. Try using the canvas renderer");
      return this.gl = n, this.getExtensions(), this.gl;
    }, r.prototype.getExtensions = function() {
      var t = this.gl, e = {
        loseContext: t.getExtension("WEBGL_lose_context"),
        anisotropicFiltering: t.getExtension("EXT_texture_filter_anisotropic"),
        floatTextureLinear: t.getExtension("OES_texture_float_linear"),
        s3tc: t.getExtension("WEBGL_compressed_texture_s3tc"),
        s3tc_sRGB: t.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
        etc: t.getExtension("WEBGL_compressed_texture_etc"),
        etc1: t.getExtension("WEBGL_compressed_texture_etc1"),
        pvrtc: t.getExtension("WEBGL_compressed_texture_pvrtc") || t.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
        atc: t.getExtension("WEBGL_compressed_texture_atc"),
        astc: t.getExtension("WEBGL_compressed_texture_astc")
      };
      this.webGLVersion === 1 ? Object.assign(this.extensions, e, {
        drawBuffers: t.getExtension("WEBGL_draw_buffers"),
        depthTexture: t.getExtension("WEBGL_depth_texture"),
        vertexArrayObject: t.getExtension("OES_vertex_array_object") || t.getExtension("MOZ_OES_vertex_array_object") || t.getExtension("WEBKIT_OES_vertex_array_object"),
        uint32ElementIndex: t.getExtension("OES_element_index_uint"),
        // Floats and half-floats
        floatTexture: t.getExtension("OES_texture_float"),
        floatTextureLinear: t.getExtension("OES_texture_float_linear"),
        textureHalfFloat: t.getExtension("OES_texture_half_float"),
        textureHalfFloatLinear: t.getExtension("OES_texture_half_float_linear")
      }) : this.webGLVersion === 2 && Object.assign(this.extensions, e, {
        // Floats and half-floats
        colorBufferFloat: t.getExtension("EXT_color_buffer_float")
      });
    }, r.prototype.handleContextLost = function(t) {
      var e = this;
      t.preventDefault(), setTimeout(function() {
        e.gl.isContextLost() && e.extensions.loseContext && e.extensions.loseContext.restoreContext();
      }, 0);
    }, r.prototype.handleContextRestored = function() {
      this.renderer.runners.contextChange.emit(this.gl);
    }, r.prototype.destroy = function() {
      var t = this.renderer.view;
      this.renderer = null, t.removeEventListener("webglcontextlost", this.handleContextLost), t.removeEventListener("webglcontextrestored", this.handleContextRestored), this.gl.useProgram(null), this.extensions.loseContext && this.extensions.loseContext.loseContext();
    }, r.prototype.postrender = function() {
      this.renderer.renderingToScreen && this.gl.flush();
    }, r.prototype.validateContext = function(t) {
      var e = t.getContextAttributes(), n = "WebGL2RenderingContext" in globalThis && t instanceof globalThis.WebGL2RenderingContext;
      n && (this.webGLVersion = 2), e && !e.stencil && console.warn("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
      var i = n || !!t.getExtension("OES_element_index_uint");
      this.supports.uint32Indices = i, i || console.warn("Provided WebGL context does not support 32 index buffer, complex graphics may not render correctly");
    }, r;
  }()
), Yy = (
  /** @class */
  function() {
    function r(t) {
      this.framebuffer = t, this.stencil = null, this.dirtyId = -1, this.dirtyFormat = -1, this.dirtySize = -1, this.multisample = wt.NONE, this.msaaBuffer = null, this.blitFramebuffer = null, this.mipLevel = 0;
    }
    return r;
  }()
), Vy = new ut(), zy = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this.managedFramebuffers = [], this.unknownFramebuffer = new aa(10, 10), this.msaaSamples = null;
    }
    return r.prototype.contextChange = function() {
      this.disposeAll(!0);
      var t = this.gl = this.renderer.gl;
      if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.current = this.unknownFramebuffer, this.viewport = new ut(), this.hasMRT = !0, this.writeDepthTexture = !0, this.renderer.context.webGLVersion === 1) {
        var e = this.renderer.context.extensions.drawBuffers, n = this.renderer.context.extensions.depthTexture;
        G.PREFER_ENV === Ie.WEBGL_LEGACY && (e = null, n = null), e ? t.drawBuffers = function(i) {
          return e.drawBuffersWEBGL(i);
        } : (this.hasMRT = !1, t.drawBuffers = function() {
        }), n || (this.writeDepthTexture = !1);
      } else
        this.msaaSamples = t.getInternalformatParameter(t.RENDERBUFFER, t.RGBA8, t.SAMPLES);
    }, r.prototype.bind = function(t, e, n) {
      n === void 0 && (n = 0);
      var i = this.gl;
      if (t) {
        var o = t.glFramebuffers[this.CONTEXT_UID] || this.initFramebuffer(t);
        this.current !== t && (this.current = t, i.bindFramebuffer(i.FRAMEBUFFER, o.framebuffer)), o.mipLevel !== n && (t.dirtyId++, t.dirtyFormat++, o.mipLevel = n), o.dirtyId !== t.dirtyId && (o.dirtyId = t.dirtyId, o.dirtyFormat !== t.dirtyFormat ? (o.dirtyFormat = t.dirtyFormat, o.dirtySize = t.dirtySize, this.updateFramebuffer(t, n)) : o.dirtySize !== t.dirtySize && (o.dirtySize = t.dirtySize, this.resizeFramebuffer(t)));
        for (var a = 0; a < t.colorTextures.length; a++) {
          var s = t.colorTextures[a];
          this.renderer.texture.unbind(s.parentTextureArray || s);
        }
        if (t.depthTexture && this.renderer.texture.unbind(t.depthTexture), e) {
          var h = e.width >> n, u = e.height >> n, l = h / e.width;
          this.setViewport(e.x * l, e.y * l, h, u);
        } else {
          var h = t.width >> n, u = t.height >> n;
          this.setViewport(0, 0, h, u);
        }
      } else
        this.current && (this.current = null, i.bindFramebuffer(i.FRAMEBUFFER, null)), e ? this.setViewport(e.x, e.y, e.width, e.height) : this.setViewport(0, 0, this.renderer.width, this.renderer.height);
    }, r.prototype.setViewport = function(t, e, n, i) {
      var o = this.viewport;
      t = Math.round(t), e = Math.round(e), n = Math.round(n), i = Math.round(i), (o.width !== n || o.height !== i || o.x !== t || o.y !== e) && (o.x = t, o.y = e, o.width = n, o.height = i, this.gl.viewport(t, e, n, i));
    }, Object.defineProperty(r.prototype, "size", {
      /**
       * Get the size of the current width and height. Returns object with `width` and `height` values.
       * @readonly
       */
      get: function() {
        return this.current ? { x: 0, y: 0, width: this.current.width, height: this.current.height } : { x: 0, y: 0, width: this.renderer.width, height: this.renderer.height };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.clear = function(t, e, n, i, o) {
      o === void 0 && (o = mi.COLOR | mi.DEPTH);
      var a = this.gl;
      a.clearColor(t, e, n, i), a.clear(o);
    }, r.prototype.initFramebuffer = function(t) {
      var e = this.gl, n = new Yy(e.createFramebuffer());
      return n.multisample = this.detectSamples(t.multisample), t.glFramebuffers[this.CONTEXT_UID] = n, this.managedFramebuffers.push(t), t.disposeRunner.add(this), n;
    }, r.prototype.resizeFramebuffer = function(t) {
      var e = this.gl, n = t.glFramebuffers[this.CONTEXT_UID];
      n.msaaBuffer && (e.bindRenderbuffer(e.RENDERBUFFER, n.msaaBuffer), e.renderbufferStorageMultisample(e.RENDERBUFFER, n.multisample, e.RGBA8, t.width, t.height)), n.stencil && (e.bindRenderbuffer(e.RENDERBUFFER, n.stencil), n.msaaBuffer ? e.renderbufferStorageMultisample(e.RENDERBUFFER, n.multisample, e.DEPTH24_STENCIL8, t.width, t.height) : e.renderbufferStorage(e.RENDERBUFFER, e.DEPTH_STENCIL, t.width, t.height));
      var i = t.colorTextures, o = i.length;
      e.drawBuffers || (o = Math.min(o, 1));
      for (var a = 0; a < o; a++) {
        var s = i[a], h = s.parentTextureArray || s;
        this.renderer.texture.bind(h, 0);
      }
      t.depthTexture && this.writeDepthTexture && this.renderer.texture.bind(t.depthTexture, 0);
    }, r.prototype.updateFramebuffer = function(t, e) {
      var n = this.gl, i = t.glFramebuffers[this.CONTEXT_UID], o = t.colorTextures, a = o.length;
      n.drawBuffers || (a = Math.min(a, 1)), i.multisample > 1 && this.canMultisampleFramebuffer(t) ? (i.msaaBuffer = i.msaaBuffer || n.createRenderbuffer(), n.bindRenderbuffer(n.RENDERBUFFER, i.msaaBuffer), n.renderbufferStorageMultisample(n.RENDERBUFFER, i.multisample, n.RGBA8, t.width, t.height), n.framebufferRenderbuffer(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.RENDERBUFFER, i.msaaBuffer)) : i.msaaBuffer && (n.deleteRenderbuffer(i.msaaBuffer), i.msaaBuffer = null, i.blitFramebuffer && (i.blitFramebuffer.dispose(), i.blitFramebuffer = null));
      for (var s = [], h = 0; h < a; h++) {
        var u = o[h], l = u.parentTextureArray || u;
        this.renderer.texture.bind(l, 0), !(h === 0 && i.msaaBuffer) && (n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0 + h, u.target, l._glTextures[this.CONTEXT_UID].texture, e), s.push(n.COLOR_ATTACHMENT0 + h));
      }
      if (s.length > 1 && n.drawBuffers(s), t.depthTexture) {
        var f = this.writeDepthTexture;
        if (f) {
          var c = t.depthTexture;
          this.renderer.texture.bind(c, 0), n.framebufferTexture2D(n.FRAMEBUFFER, n.DEPTH_ATTACHMENT, n.TEXTURE_2D, c._glTextures[this.CONTEXT_UID].texture, e);
        }
      }
      (t.stencil || t.depth) && !(t.depthTexture && this.writeDepthTexture) ? (i.stencil = i.stencil || n.createRenderbuffer(), n.bindRenderbuffer(n.RENDERBUFFER, i.stencil), i.msaaBuffer ? n.renderbufferStorageMultisample(n.RENDERBUFFER, i.multisample, n.DEPTH24_STENCIL8, t.width, t.height) : n.renderbufferStorage(n.RENDERBUFFER, n.DEPTH_STENCIL, t.width, t.height), n.framebufferRenderbuffer(n.FRAMEBUFFER, n.DEPTH_STENCIL_ATTACHMENT, n.RENDERBUFFER, i.stencil)) : i.stencil && (n.deleteRenderbuffer(i.stencil), i.stencil = null);
    }, r.prototype.canMultisampleFramebuffer = function(t) {
      return this.renderer.context.webGLVersion !== 1 && t.colorTextures.length <= 1 && !t.depthTexture;
    }, r.prototype.detectSamples = function(t) {
      var e = this.msaaSamples, n = wt.NONE;
      if (t <= 1 || e === null)
        return n;
      for (var i = 0; i < e.length; i++)
        if (e[i] <= t) {
          n = e[i];
          break;
        }
      return n === 1 && (n = wt.NONE), n;
    }, r.prototype.blit = function(t, e, n) {
      var i = this, o = i.current, a = i.renderer, s = i.gl, h = i.CONTEXT_UID;
      if (a.context.webGLVersion === 2 && o) {
        var u = o.glFramebuffers[h];
        if (u) {
          if (!t) {
            if (!u.msaaBuffer)
              return;
            var l = o.colorTextures[0];
            if (!l)
              return;
            u.blitFramebuffer || (u.blitFramebuffer = new aa(o.width, o.height), u.blitFramebuffer.addColorTexture(0, l)), t = u.blitFramebuffer, t.colorTextures[0] !== l && (t.colorTextures[0] = l, t.dirtyId++, t.dirtyFormat++), (t.width !== o.width || t.height !== o.height) && (t.width = o.width, t.height = o.height, t.dirtyId++, t.dirtySize++);
          }
          e || (e = Vy, e.width = o.width, e.height = o.height), n || (n = e);
          var f = e.width === n.width && e.height === n.height;
          this.bind(t), s.bindFramebuffer(s.READ_FRAMEBUFFER, u.framebuffer), s.blitFramebuffer(e.left, e.top, e.right, e.bottom, n.left, n.top, n.right, n.bottom, s.COLOR_BUFFER_BIT, f ? s.NEAREST : s.LINEAR);
        }
      }
    }, r.prototype.disposeFramebuffer = function(t, e) {
      var n = t.glFramebuffers[this.CONTEXT_UID], i = this.gl;
      if (n) {
        delete t.glFramebuffers[this.CONTEXT_UID];
        var o = this.managedFramebuffers.indexOf(t);
        o >= 0 && this.managedFramebuffers.splice(o, 1), t.disposeRunner.remove(this), e || (i.deleteFramebuffer(n.framebuffer), n.msaaBuffer && i.deleteRenderbuffer(n.msaaBuffer), n.stencil && i.deleteRenderbuffer(n.stencil)), n.blitFramebuffer && n.blitFramebuffer.dispose();
      }
    }, r.prototype.disposeAll = function(t) {
      var e = this.managedFramebuffers;
      this.managedFramebuffers = [];
      for (var n = 0; n < e.length; n++)
        this.disposeFramebuffer(e[n], t);
    }, r.prototype.forceStencil = function() {
      var t = this.current;
      if (t) {
        var e = t.glFramebuffers[this.CONTEXT_UID];
        if (!(!e || e.stencil)) {
          t.stencil = !0;
          var n = t.width, i = t.height, o = this.gl, a = o.createRenderbuffer();
          o.bindRenderbuffer(o.RENDERBUFFER, a), e.msaaBuffer ? o.renderbufferStorageMultisample(o.RENDERBUFFER, e.multisample, o.DEPTH24_STENCIL8, n, i) : o.renderbufferStorage(o.RENDERBUFFER, o.DEPTH_STENCIL, n, i), e.stencil = a, o.framebufferRenderbuffer(o.FRAMEBUFFER, o.DEPTH_STENCIL_ATTACHMENT, o.RENDERBUFFER, a);
        }
      }
    }, r.prototype.reset = function() {
      this.current = this.unknownFramebuffer, this.viewport = new ut();
    }, r.prototype.destroy = function() {
      this.renderer = null;
    }, r;
  }()
), po = { 5126: 4, 5123: 2, 5121: 1 }, Wy = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this._activeGeometry = null, this._activeVao = null, this.hasVao = !0, this.hasInstance = !0, this.canUseUInt32ElementIndex = !1, this.managedGeometries = {};
    }
    return r.prototype.contextChange = function() {
      this.disposeAll(!0);
      var t = this.gl = this.renderer.gl, e = this.renderer.context;
      if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, e.webGLVersion !== 2) {
        var n = this.renderer.context.extensions.vertexArrayObject;
        G.PREFER_ENV === Ie.WEBGL_LEGACY && (n = null), n ? (t.createVertexArray = function() {
          return n.createVertexArrayOES();
        }, t.bindVertexArray = function(o) {
          return n.bindVertexArrayOES(o);
        }, t.deleteVertexArray = function(o) {
          return n.deleteVertexArrayOES(o);
        }) : (this.hasVao = !1, t.createVertexArray = function() {
          return null;
        }, t.bindVertexArray = function() {
          return null;
        }, t.deleteVertexArray = function() {
          return null;
        });
      }
      if (e.webGLVersion !== 2) {
        var i = t.getExtension("ANGLE_instanced_arrays");
        i ? (t.vertexAttribDivisor = function(o, a) {
          return i.vertexAttribDivisorANGLE(o, a);
        }, t.drawElementsInstanced = function(o, a, s, h, u) {
          return i.drawElementsInstancedANGLE(o, a, s, h, u);
        }, t.drawArraysInstanced = function(o, a, s, h) {
          return i.drawArraysInstancedANGLE(o, a, s, h);
        }) : this.hasInstance = !1;
      }
      this.canUseUInt32ElementIndex = e.webGLVersion === 2 || !!e.extensions.uint32ElementIndex;
    }, r.prototype.bind = function(t, e) {
      e = e || this.renderer.shader.shader;
      var n = this.gl, i = t.glVertexArrayObjects[this.CONTEXT_UID], o = !1;
      i || (this.managedGeometries[t.id] = t, t.disposeRunner.add(this), t.glVertexArrayObjects[this.CONTEXT_UID] = i = {}, o = !0);
      var a = i[e.program.id] || this.initGeometryVao(t, e, o);
      this._activeGeometry = t, this._activeVao !== a && (this._activeVao = a, this.hasVao ? n.bindVertexArray(a) : this.activateVao(t, e.program)), this.updateBuffers();
    }, r.prototype.reset = function() {
      this.unbind();
    }, r.prototype.updateBuffers = function() {
      for (var t = this._activeGeometry, e = this.renderer.buffer, n = 0; n < t.buffers.length; n++) {
        var i = t.buffers[n];
        e.update(i);
      }
    }, r.prototype.checkCompatibility = function(t, e) {
      var n = t.attributes, i = e.attributeData;
      for (var o in i)
        if (!n[o])
          throw new Error('shader and geometry incompatible, geometry missing the "' + o + '" attribute');
    }, r.prototype.getSignature = function(t, e) {
      var n = t.attributes, i = e.attributeData, o = ["g", t.id];
      for (var a in n)
        i[a] && o.push(a, i[a].location);
      return o.join("-");
    }, r.prototype.initGeometryVao = function(t, e, n) {
      n === void 0 && (n = !0);
      var i = this.gl, o = this.CONTEXT_UID, a = this.renderer.buffer, s = e.program;
      s.glPrograms[o] || this.renderer.shader.generateProgram(e), this.checkCompatibility(t, s);
      var h = this.getSignature(t, s), u = t.glVertexArrayObjects[this.CONTEXT_UID], l = u[h];
      if (l)
        return u[s.id] = l, l;
      var f = t.buffers, c = t.attributes, d = {}, p = {};
      for (var v in f)
        d[v] = 0, p[v] = 0;
      for (var v in c)
        !c[v].size && s.attributeData[v] ? c[v].size = s.attributeData[v].size : c[v].size || console.warn("PIXI Geometry attribute '" + v + "' size cannot be determined (likely the bound shader does not have the attribute)"), d[c[v].buffer] += c[v].size * po[c[v].type];
      for (var v in c) {
        var _ = c[v], m = _.size;
        _.stride === void 0 && (d[_.buffer] === m * po[_.type] ? _.stride = 0 : _.stride = d[_.buffer]), _.start === void 0 && (_.start = p[_.buffer], p[_.buffer] += m * po[_.type]);
      }
      l = i.createVertexArray(), i.bindVertexArray(l);
      for (var y = 0; y < f.length; y++) {
        var g = f[y];
        a.bind(g), n && g._glBuffers[o].refCount++;
      }
      return this.activateVao(t, s), this._activeVao = l, u[s.id] = l, u[h] = l, l;
    }, r.prototype.disposeGeometry = function(t, e) {
      var n;
      if (this.managedGeometries[t.id]) {
        delete this.managedGeometries[t.id];
        var i = t.glVertexArrayObjects[this.CONTEXT_UID], o = this.gl, a = t.buffers, s = (n = this.renderer) === null || n === void 0 ? void 0 : n.buffer;
        if (t.disposeRunner.remove(this), !!i) {
          if (s)
            for (var h = 0; h < a.length; h++) {
              var u = a[h]._glBuffers[this.CONTEXT_UID];
              u && (u.refCount--, u.refCount === 0 && !e && s.dispose(a[h], e));
            }
          if (!e) {
            for (var l in i)
              if (l[0] === "g") {
                var f = i[l];
                this._activeVao === f && this.unbind(), o.deleteVertexArray(f);
              }
          }
          delete t.glVertexArrayObjects[this.CONTEXT_UID];
        }
      }
    }, r.prototype.disposeAll = function(t) {
      for (var e = Object.keys(this.managedGeometries), n = 0; n < e.length; n++)
        this.disposeGeometry(this.managedGeometries[e[n]], t);
    }, r.prototype.activateVao = function(t, e) {
      var n = this.gl, i = this.CONTEXT_UID, o = this.renderer.buffer, a = t.buffers, s = t.attributes;
      t.indexBuffer && o.bind(t.indexBuffer);
      var h = null;
      for (var u in s) {
        var l = s[u], f = a[l.buffer], c = f._glBuffers[i];
        if (e.attributeData[u]) {
          h !== c && (o.bind(f), h = c);
          var d = e.attributeData[u].location;
          if (n.enableVertexAttribArray(d), n.vertexAttribPointer(d, l.size, l.type || n.FLOAT, l.normalized, l.stride, l.start), l.instance)
            if (this.hasInstance)
              n.vertexAttribDivisor(d, 1);
            else
              throw new Error("geometry error, GPU Instancing is not supported on this device");
        }
      }
    }, r.prototype.draw = function(t, e, n, i) {
      var o = this.gl, a = this._activeGeometry;
      if (a.indexBuffer) {
        var s = a.indexBuffer.data.BYTES_PER_ELEMENT, h = s === 2 ? o.UNSIGNED_SHORT : o.UNSIGNED_INT;
        s === 2 || s === 4 && this.canUseUInt32ElementIndex ? a.instanced ? o.drawElementsInstanced(t, e || a.indexBuffer.data.length, h, (n || 0) * s, i || 1) : o.drawElements(t, e || a.indexBuffer.data.length, h, (n || 0) * s) : console.warn("unsupported index buffer type: uint32");
      } else
        a.instanced ? o.drawArraysInstanced(t, n, e || a.getSize(), i || 1) : o.drawArrays(t, n, e || a.getSize());
      return this;
    }, r.prototype.unbind = function() {
      this.gl.bindVertexArray(null), this._activeVao = null, this._activeGeometry = null;
    }, r.prototype.destroy = function() {
      this.renderer = null;
    }, r;
  }()
), $y = (
  /** @class */
  function() {
    function r(t) {
      t === void 0 && (t = null), this.type = It.NONE, this.autoDetect = !0, this.maskObject = t || null, this.pooled = !1, this.isMaskData = !0, this.resolution = null, this.multisample = G.FILTER_MULTISAMPLE, this.enabled = !0, this.colorMask = 15, this._filters = null, this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null, this._scissorRectLocal = null, this._colorMask = 15, this._target = null;
    }
    return Object.defineProperty(r.prototype, "filter", {
      /**
       * The sprite mask filter.
       * If set to `null`, the default sprite mask filter is used.
       * @default null
       */
      get: function() {
        return this._filters ? this._filters[0] : null;
      },
      set: function(t) {
        t ? this._filters ? this._filters[0] = t : this._filters = [t] : this._filters = null;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.reset = function() {
      this.pooled && (this.maskObject = null, this.type = It.NONE, this.autoDetect = !0), this._target = null, this._scissorRectLocal = null;
    }, r.prototype.copyCountersOrReset = function(t) {
      t ? (this._stencilCounter = t._stencilCounter, this._scissorCounter = t._scissorCounter, this._scissorRect = t._scissorRect) : (this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null);
    }, r;
  }()
);
function Sh(r, t, e) {
  var n = r.createShader(t);
  return r.shaderSource(n, e), r.compileShader(n), n;
}
function Ah(r, t) {
  var e = r.getShaderSource(t).split(`
`).map(function(u, l) {
    return l + ": " + u;
  }), n = r.getShaderInfoLog(t), i = n.split(`
`), o = {}, a = i.map(function(u) {
    return parseFloat(u.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"));
  }).filter(function(u) {
    return u && !o[u] ? (o[u] = !0, !0) : !1;
  }), s = [""];
  a.forEach(function(u) {
    e[u - 1] = "%c" + e[u - 1] + "%c", s.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
  });
  var h = e.join(`
`);
  s[0] = h, console.error(n), console.groupCollapsed("click to view full shader code"), console.warn.apply(console, s), console.groupEnd();
}
function qy(r, t, e, n) {
  r.getProgramParameter(t, r.LINK_STATUS) || (r.getShaderParameter(e, r.COMPILE_STATUS) || Ah(r, e), r.getShaderParameter(n, r.COMPILE_STATUS) || Ah(r, n), console.error("PixiJS Error: Could not initialize shader."), r.getProgramInfoLog(t) !== "" && console.warn("PixiJS Warning: gl.getProgramInfoLog()", r.getProgramInfoLog(t)));
}
function vo(r) {
  for (var t = new Array(r), e = 0; e < t.length; e++)
    t[e] = !1;
  return t;
}
function xl(r, t) {
  switch (r) {
    case "float":
      return 0;
    case "vec2":
      return new Float32Array(2 * t);
    case "vec3":
      return new Float32Array(3 * t);
    case "vec4":
      return new Float32Array(4 * t);
    case "int":
    case "uint":
    case "sampler2D":
    case "sampler2DArray":
      return 0;
    case "ivec2":
      return new Int32Array(2 * t);
    case "ivec3":
      return new Int32Array(3 * t);
    case "ivec4":
      return new Int32Array(4 * t);
    case "uvec2":
      return new Uint32Array(2 * t);
    case "uvec3":
      return new Uint32Array(3 * t);
    case "uvec4":
      return new Uint32Array(4 * t);
    case "bool":
      return !1;
    case "bvec2":
      return vo(2 * t);
    case "bvec3":
      return vo(3 * t);
    case "bvec4":
      return vo(4 * t);
    case "mat2":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
var Tl = {}, Kr = Tl;
function Ky() {
  if (Kr === Tl || Kr && Kr.isContextLost()) {
    var r = G.ADAPTER.createCanvas(), t = void 0;
    G.PREFER_ENV >= Ie.WEBGL2 && (t = r.getContext("webgl2", {})), t || (t = r.getContext("webgl", {}) || r.getContext("experimental-webgl", {}), t ? t.getExtension("WEBGL_draw_buffers") : t = null), Kr = t;
  }
  return Kr;
}
var zn;
function Zy() {
  if (!zn) {
    zn = qt.MEDIUM;
    var r = Ky();
    if (r && r.getShaderPrecisionFormat) {
      var t = r.getShaderPrecisionFormat(r.FRAGMENT_SHADER, r.HIGH_FLOAT);
      zn = t.precision ? qt.HIGH : qt.MEDIUM;
    }
  }
  return zn;
}
function Ph(r, t, e) {
  if (r.substring(0, 9) !== "precision") {
    var n = t;
    return t === qt.HIGH && e !== qt.HIGH && (n = qt.MEDIUM), "precision " + n + ` float;
` + r;
  } else if (e !== qt.HIGH && r.substring(0, 15) === "precision highp")
    return r.replace("precision highp", "precision mediump");
  return r;
}
var Jy = {
  float: 1,
  vec2: 2,
  vec3: 3,
  vec4: 4,
  int: 1,
  ivec2: 2,
  ivec3: 3,
  ivec4: 4,
  uint: 1,
  uvec2: 2,
  uvec3: 3,
  uvec4: 4,
  bool: 1,
  bvec2: 2,
  bvec3: 3,
  bvec4: 4,
  mat2: 4,
  mat3: 9,
  mat4: 16,
  sampler2D: 1
};
function El(r) {
  return Jy[r];
}
var Wn = null, Oh = {
  FLOAT: "float",
  FLOAT_VEC2: "vec2",
  FLOAT_VEC3: "vec3",
  FLOAT_VEC4: "vec4",
  INT: "int",
  INT_VEC2: "ivec2",
  INT_VEC3: "ivec3",
  INT_VEC4: "ivec4",
  UNSIGNED_INT: "uint",
  UNSIGNED_INT_VEC2: "uvec2",
  UNSIGNED_INT_VEC3: "uvec3",
  UNSIGNED_INT_VEC4: "uvec4",
  BOOL: "bool",
  BOOL_VEC2: "bvec2",
  BOOL_VEC3: "bvec3",
  BOOL_VEC4: "bvec4",
  FLOAT_MAT2: "mat2",
  FLOAT_MAT3: "mat3",
  FLOAT_MAT4: "mat4",
  SAMPLER_2D: "sampler2D",
  INT_SAMPLER_2D: "sampler2D",
  UNSIGNED_INT_SAMPLER_2D: "sampler2D",
  SAMPLER_CUBE: "samplerCube",
  INT_SAMPLER_CUBE: "samplerCube",
  UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
  SAMPLER_2D_ARRAY: "sampler2DArray",
  INT_SAMPLER_2D_ARRAY: "sampler2DArray",
  UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray"
};
function wl(r, t) {
  if (!Wn) {
    var e = Object.keys(Oh);
    Wn = {};
    for (var n = 0; n < e.length; ++n) {
      var i = e[n];
      Wn[r[i]] = Oh[i];
    }
  }
  return Wn[t];
}
var Lr = [
  // a float cache layer
  {
    test: function(r) {
      return r.type === "float" && r.size === 1 && !r.isArray;
    },
    code: function(r) {
      return `
            if(uv["` + r + '"] !== ud["' + r + `"].value)
            {
                ud["` + r + '"].value = uv["' + r + `"]
                gl.uniform1f(ud["` + r + '"].location, uv["' + r + `"])
            }
            `;
    }
  },
  // handling samplers
  {
    test: function(r, t) {
      return (r.type === "sampler2D" || r.type === "samplerCube" || r.type === "sampler2DArray") && r.size === 1 && !r.isArray && (t == null || t.castToBaseTexture !== void 0);
    },
    code: function(r) {
      return `t = syncData.textureCount++;

            renderer.texture.bind(uv["` + r + `"], t);

            if(ud["` + r + `"].value !== t)
            {
                ud["` + r + `"].value = t;
                gl.uniform1i(ud["` + r + `"].location, t);
; // eslint-disable-line max-len
            }`;
    }
  },
  // uploading pixi matrix object to mat3
  {
    test: function(r, t) {
      return r.type === "mat3" && r.size === 1 && !r.isArray && t.a !== void 0;
    },
    code: function(r) {
      return `
            gl.uniformMatrix3fv(ud["` + r + '"].location, false, uv["' + r + `"].toArray(true));
            `;
    },
    codeUbo: function(r) {
      return `
                var ` + r + "_matrix = uv." + r + `.toArray(true);

                data[offset] = ` + r + `_matrix[0];
                data[offset+1] = ` + r + `_matrix[1];
                data[offset+2] = ` + r + `_matrix[2];
        
                data[offset + 4] = ` + r + `_matrix[3];
                data[offset + 5] = ` + r + `_matrix[4];
                data[offset + 6] = ` + r + `_matrix[5];
        
                data[offset + 8] = ` + r + `_matrix[6];
                data[offset + 9] = ` + r + `_matrix[7];
                data[offset + 10] = ` + r + `_matrix[8];
            `;
    }
  },
  // uploading a pixi point as a vec2 with caching layer
  {
    test: function(r, t) {
      return r.type === "vec2" && r.size === 1 && !r.isArray && t.x !== void 0;
    },
    code: function(r) {
      return `
                cv = ud["` + r + `"].value;
                v = uv["` + r + `"];

                if(cv[0] !== v.x || cv[1] !== v.y)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    gl.uniform2f(ud["` + r + `"].location, v.x, v.y);
                }`;
    },
    codeUbo: function(r) {
      return `
                v = uv.` + r + `;

                data[offset] = v.x;
                data[offset+1] = v.y;
            `;
    }
  },
  // caching layer for a vec2
  {
    test: function(r) {
      return r.type === "vec2" && r.size === 1 && !r.isArray;
    },
    code: function(r) {
      return `
                cv = ud["` + r + `"].value;
                v = uv["` + r + `"];

                if(cv[0] !== v[0] || cv[1] !== v[1])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    gl.uniform2f(ud["` + r + `"].location, v[0], v[1]);
                }
            `;
    }
  },
  // upload a pixi rectangle as a vec4 with caching layer
  {
    test: function(r, t) {
      return r.type === "vec4" && r.size === 1 && !r.isArray && t.width !== void 0;
    },
    code: function(r) {
      return `
                cv = ud["` + r + `"].value;
                v = uv["` + r + `"];

                if(cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    cv[2] = v.width;
                    cv[3] = v.height;
                    gl.uniform4f(ud["` + r + `"].location, v.x, v.y, v.width, v.height)
                }`;
    },
    codeUbo: function(r) {
      return `
                    v = uv.` + r + `;

                    data[offset] = v.x;
                    data[offset+1] = v.y;
                    data[offset+2] = v.width;
                    data[offset+3] = v.height;
                `;
    }
  },
  // a caching layer for vec4 uploading
  {
    test: function(r) {
      return r.type === "vec4" && r.size === 1 && !r.isArray;
    },
    code: function(r) {
      return `
                cv = ud["` + r + `"].value;
                v = uv["` + r + `"];

                if(cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    cv[2] = v[2];
                    cv[3] = v[3];

                    gl.uniform4f(ud["` + r + `"].location, v[0], v[1], v[2], v[3])
                }`;
    }
  }
], Qy = {
  float: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1f(location, v);
    }`,
  vec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2f(location, v[0], v[1])
    }`,
  vec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3f(location, v[0], v[1], v[2])
    }`,
  vec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4f(location, v[0], v[1], v[2], v[3]);
    }`,
  int: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
  ivec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
  ivec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
  ivec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
  uint: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1ui(location, v);
    }`,
  uvec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2ui(location, v[0], v[1]);
    }`,
  uvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3ui(location, v[0], v[1], v[2]);
    }`,
  uvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
    }`,
  bool: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1i(location, v);
    }`,
  bvec2: `
    if (cv[0] != v[0] || cv[1] != v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
  bvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
  bvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
  mat2: "gl.uniformMatrix2fv(location, false, v)",
  mat3: "gl.uniformMatrix3fv(location, false, v)",
  mat4: "gl.uniformMatrix4fv(location, false, v)",
  sampler2D: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
  samplerCube: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
  sampler2DArray: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`
}, tg = {
  float: "gl.uniform1fv(location, v)",
  vec2: "gl.uniform2fv(location, v)",
  vec3: "gl.uniform3fv(location, v)",
  vec4: "gl.uniform4fv(location, v)",
  mat4: "gl.uniformMatrix4fv(location, false, v)",
  mat3: "gl.uniformMatrix3fv(location, false, v)",
  mat2: "gl.uniformMatrix2fv(location, false, v)",
  int: "gl.uniform1iv(location, v)",
  ivec2: "gl.uniform2iv(location, v)",
  ivec3: "gl.uniform3iv(location, v)",
  ivec4: "gl.uniform4iv(location, v)",
  uint: "gl.uniform1uiv(location, v)",
  uvec2: "gl.uniform2uiv(location, v)",
  uvec3: "gl.uniform3uiv(location, v)",
  uvec4: "gl.uniform4uiv(location, v)",
  bool: "gl.uniform1iv(location, v)",
  bvec2: "gl.uniform2iv(location, v)",
  bvec3: "gl.uniform3iv(location, v)",
  bvec4: "gl.uniform4iv(location, v)",
  sampler2D: "gl.uniform1iv(location, v)",
  samplerCube: "gl.uniform1iv(location, v)",
  sampler2DArray: "gl.uniform1iv(location, v)"
};
function eg(r, t) {
  var e, n = [`
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
    `];
  for (var i in r.uniforms) {
    var o = t[i];
    if (!o) {
      !((e = r.uniforms[i]) === null || e === void 0) && e.group && (r.uniforms[i].ubo ? n.push(`
                        renderer.shader.syncUniformBufferGroup(uv.` + i + ", '" + i + `');
                    `) : n.push(`
                        renderer.shader.syncUniformGroup(uv.` + i + `, syncData);
                    `));
      continue;
    }
    for (var a = r.uniforms[i], s = !1, h = 0; h < Lr.length; h++)
      if (Lr[h].test(o, a)) {
        n.push(Lr[h].code(i, a)), s = !0;
        break;
      }
    if (!s) {
      var u = o.size === 1 && !o.isArray ? Qy : tg, l = u[o.type].replace("location", 'ud["' + i + '"].location');
      n.push(`
            cu = ud["` + i + `"];
            cv = cu.value;
            v = uv["` + i + `"];
            ` + l + ";");
    }
  }
  return new Function("ud", "uv", "renderer", "syncData", n.join(`
`));
}
var rg = [
  "precision mediump float;",
  "void main(void){",
  "float test = 0.1;",
  "%forloop%",
  "gl_FragColor = vec4(0.0);",
  "}"
].join(`
`);
function ng(r) {
  for (var t = "", e = 0; e < r; ++e)
    e > 0 && (t += `
else `), e < r - 1 && (t += "if(test == " + e + ".0){}");
  return t;
}
function ig(r, t) {
  if (r === 0)
    throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
  for (var e = t.createShader(t.FRAGMENT_SHADER); ; ) {
    var n = rg.replace(/%forloop%/gi, ng(r));
    if (t.shaderSource(e, n), t.compileShader(e), !t.getShaderParameter(e, t.COMPILE_STATUS))
      r = r / 2 | 0;
    else
      break;
  }
  return r;
}
var Zr;
function og() {
  if (typeof Zr == "boolean")
    return Zr;
  try {
    var r = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
    Zr = r({ a: "b" }, "a", "b") === !0;
  } catch {
    Zr = !1;
  }
  return Zr;
}
var ag = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor *= texture2D(uSampler, vTextureCoord);
}`, sg = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void){
   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
   vTextureCoord = aTextureCoord;
}
`, hg = 0, $n = {}, Rn = (
  /** @class */
  function() {
    function r(t, e, n) {
      n === void 0 && (n = "pixi-shader"), this.id = hg++, this.vertexSrc = t || r.defaultVertexSrc, this.fragmentSrc = e || r.defaultFragmentSrc, this.vertexSrc = this.vertexSrc.trim(), this.fragmentSrc = this.fragmentSrc.trim(), this.vertexSrc.substring(0, 8) !== "#version" && (n = n.replace(/\s+/g, "-"), $n[n] ? ($n[n]++, n += "-" + $n[n]) : $n[n] = 1, this.vertexSrc = "#define SHADER_NAME " + n + `
` + this.vertexSrc, this.fragmentSrc = "#define SHADER_NAME " + n + `
` + this.fragmentSrc, this.vertexSrc = Ph(this.vertexSrc, G.PRECISION_VERTEX, qt.HIGH), this.fragmentSrc = Ph(this.fragmentSrc, G.PRECISION_FRAGMENT, Zy())), this.glPrograms = {}, this.syncUniforms = null;
    }
    return Object.defineProperty(r, "defaultVertexSrc", {
      /**
       * The default vertex shader source.
       * @constant
       */
      get: function() {
        return sg;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r, "defaultFragmentSrc", {
      /**
       * The default fragment shader source.
       * @constant
       */
      get: function() {
        return ag;
      },
      enumerable: !1,
      configurable: !0
    }), r.from = function(t, e, n) {
      var i = t + e, o = yh[i];
      return o || (yh[i] = o = new r(t, e, n)), o;
    }, r;
  }()
), Ue = (
  /** @class */
  function() {
    function r(t, e) {
      this.uniformBindCount = 0, this.program = t, e ? e instanceof hr ? this.uniformGroup = e : this.uniformGroup = new hr(e) : this.uniformGroup = new hr({}), this.disposeRunner = new kt("disposeShader");
    }
    return r.prototype.checkUniformExists = function(t, e) {
      if (e.uniforms[t])
        return !0;
      for (var n in e.uniforms) {
        var i = e.uniforms[n];
        if (i.group && this.checkUniformExists(t, i))
          return !0;
      }
      return !1;
    }, r.prototype.destroy = function() {
      this.uniformGroup = null, this.disposeRunner.emit(this), this.disposeRunner.destroy();
    }, Object.defineProperty(r.prototype, "uniforms", {
      /**
       * Shader uniform values, shortcut for `uniformGroup.uniforms`.
       * @readonly
       */
      get: function() {
        return this.uniformGroup.uniforms;
      },
      enumerable: !1,
      configurable: !0
    }), r.from = function(t, e, n) {
      var i = Rn.from(t, e);
      return new r(i, n);
    }, r;
  }()
), _o = 0, mo = 1, yo = 2, go = 3, bo = 4, xo = 5, dr = (
  /** @class */
  function() {
    function r() {
      this.data = 0, this.blendMode = Y.NORMAL, this.polygonOffset = 0, this.blend = !0, this.depthMask = !0;
    }
    return Object.defineProperty(r.prototype, "blend", {
      /**
       * Activates blending of the computed fragment color values.
       * @default true
       */
      get: function() {
        return !!(this.data & 1 << _o);
      },
      set: function(t) {
        !!(this.data & 1 << _o) !== t && (this.data ^= 1 << _o);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "offsets", {
      /**
       * Activates adding an offset to depth values of polygon's fragments
       * @default false
       */
      get: function() {
        return !!(this.data & 1 << mo);
      },
      set: function(t) {
        !!(this.data & 1 << mo) !== t && (this.data ^= 1 << mo);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "culling", {
      /**
       * Activates culling of polygons.
       * @default false
       */
      get: function() {
        return !!(this.data & 1 << yo);
      },
      set: function(t) {
        !!(this.data & 1 << yo) !== t && (this.data ^= 1 << yo);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "depthTest", {
      /**
       * Activates depth comparisons and updates to the depth buffer.
       * @default false
       */
      get: function() {
        return !!(this.data & 1 << go);
      },
      set: function(t) {
        !!(this.data & 1 << go) !== t && (this.data ^= 1 << go);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "depthMask", {
      /**
       * Enables or disables writing to the depth buffer.
       * @default true
       */
      get: function() {
        return !!(this.data & 1 << xo);
      },
      set: function(t) {
        !!(this.data & 1 << xo) !== t && (this.data ^= 1 << xo);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "clockwiseFrontFace", {
      /**
       * Specifies whether or not front or back-facing polygons can be culled.
       * @default false
       */
      get: function() {
        return !!(this.data & 1 << bo);
      },
      set: function(t) {
        !!(this.data & 1 << bo) !== t && (this.data ^= 1 << bo);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "blendMode", {
      /**
       * The blend mode to be applied when this state is set. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
       * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
       * @default PIXI.BLEND_MODES.NORMAL
       */
      get: function() {
        return this._blendMode;
      },
      set: function(t) {
        this.blend = t !== Y.NONE, this._blendMode = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "polygonOffset", {
      /**
       * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
       * @default 0
       */
      get: function() {
        return this._polygonOffset;
      },
      set: function(t) {
        this.offsets = !!t, this._polygonOffset = t;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.toString = function() {
      return "[@pixi/core:State " + ("blendMode=" + this.blendMode + " ") + ("clockwiseFrontFace=" + this.clockwiseFrontFace + " ") + ("culling=" + this.culling + " ") + ("depthMask=" + this.depthMask + " ") + ("polygonOffset=" + this.polygonOffset) + "]";
    }, r.for2d = function() {
      var t = new r();
      return t.depthTest = !1, t.blend = !0, t;
    }, r;
  }()
), ug = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor = texture2D(uSampler, vTextureCoord);
}
`, lg = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`, Ve = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n, i) {
      var o = this, a = Rn.from(e || t.defaultVertexSrc, n || t.defaultFragmentSrc);
      return o = r.call(this, a, i) || this, o.padding = 0, o.resolution = G.FILTER_RESOLUTION, o.multisample = G.FILTER_MULTISAMPLE, o.enabled = !0, o.autoFit = !0, o.state = new dr(), o;
    }
    return t.prototype.apply = function(e, n, i, o, a) {
      e.applyFilter(this, n, i, o);
    }, Object.defineProperty(t.prototype, "blendMode", {
      /**
       * Sets the blend mode of the filter.
       * @default PIXI.BLEND_MODES.NORMAL
       */
      get: function() {
        return this.state.blendMode;
      },
      set: function(e) {
        this.state.blendMode = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "resolution", {
      /**
       * The resolution of the filter. Setting this to be lower will lower the quality but
       * increase the performance of the filter.
       */
      get: function() {
        return this._resolution;
      },
      set: function(e) {
        this._resolution = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "defaultVertexSrc", {
      /**
       * The default vertex shader source
       * @constant
       */
      get: function() {
        return lg;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "defaultFragmentSrc", {
      /**
       * The default fragment shader source
       * @constant
       */
      get: function() {
        return ug;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Ue)
), fg = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 otherMatrix;

varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;
}
`, cg = `varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform sampler2D mask;
uniform float alpha;
uniform float npmAlpha;
uniform vec4 maskClamp;

void main(void)
{
    float clip = step(3.5,
        step(maskClamp.x, vMaskCoord.x) +
        step(maskClamp.y, vMaskCoord.y) +
        step(vMaskCoord.x, maskClamp.z) +
        step(vMaskCoord.y, maskClamp.w));

    vec4 original = texture2D(uSampler, vTextureCoord);
    vec4 masky = texture2D(mask, vMaskCoord);
    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);

    original *= (alphaMul * masky.r * alpha * clip);

    gl_FragColor = original;
}
`, Rh = new Dt(), Qa = (
  /** @class */
  function() {
    function r(t, e) {
      this._texture = t, this.mapCoord = new Dt(), this.uClampFrame = new Float32Array(4), this.uClampOffset = new Float32Array(2), this._textureID = -1, this._updateID = 0, this.clampOffset = 0, this.clampMargin = typeof e > "u" ? 0.5 : e, this.isSimple = !1;
    }
    return Object.defineProperty(r.prototype, "texture", {
      /** Texture property. */
      get: function() {
        return this._texture;
      },
      set: function(t) {
        this._texture = t, this._textureID = -1;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.multiplyUvs = function(t, e) {
      e === void 0 && (e = t);
      for (var n = this.mapCoord, i = 0; i < t.length; i += 2) {
        var o = t[i], a = t[i + 1];
        e[i] = o * n.a + a * n.c + n.tx, e[i + 1] = o * n.b + a * n.d + n.ty;
      }
      return e;
    }, r.prototype.update = function(t) {
      var e = this._texture;
      if (!e || !e.valid || !t && this._textureID === e._updateID)
        return !1;
      this._textureID = e._updateID, this._updateID++;
      var n = e._uvs;
      this.mapCoord.set(n.x1 - n.x0, n.y1 - n.y0, n.x3 - n.x0, n.y3 - n.y0, n.x0, n.y0);
      var i = e.orig, o = e.trim;
      o && (Rh.set(i.width / o.width, 0, 0, i.height / o.height, -o.x / o.width, -o.y / o.height), this.mapCoord.append(Rh));
      var a = e.baseTexture, s = this.uClampFrame, h = this.clampMargin / a.resolution, u = this.clampOffset;
      return s[0] = (e._frame.x + h + u) / a.width, s[1] = (e._frame.y + h + u) / a.height, s[2] = (e._frame.x + e._frame.width - h + u) / a.width, s[3] = (e._frame.y + e._frame.height - h + u) / a.height, this.uClampOffset[0] = u / a.realWidth, this.uClampOffset[1] = u / a.realHeight, this.isSimple = e._frame.width === a.width && e._frame.height === a.height && e.rotate === 0, !0;
    }, r;
  }()
), dg = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n, i) {
      var o = this, a = null;
      return typeof e != "string" && n === void 0 && i === void 0 && (a = e, e = void 0, n = void 0, i = void 0), o = r.call(this, e || fg, n || cg, i) || this, o.maskSprite = a, o.maskMatrix = new Dt(), o;
    }
    return Object.defineProperty(t.prototype, "maskSprite", {
      /**
       * Sprite mask
       * @type {PIXI.DisplayObject}
       */
      get: function() {
        return this._maskSprite;
      },
      set: function(e) {
        this._maskSprite = e, this._maskSprite && (this._maskSprite.renderable = !1);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.apply = function(e, n, i, o) {
      var a = this._maskSprite, s = a._texture;
      s.valid && (s.uvMatrix || (s.uvMatrix = new Qa(s, 0)), s.uvMatrix.update(), this.uniforms.npmAlpha = s.baseTexture.alphaMode ? 0 : 1, this.uniforms.mask = s, this.uniforms.otherMatrix = e.calculateSpriteMatrix(this.maskMatrix, a).prepend(s.uvMatrix.mapCoord), this.uniforms.alpha = a.worldAlpha, this.uniforms.maskClamp = s.uvMatrix.uClampFrame, e.applyFilter(this, n, i, o));
    }, t;
  }(Ve)
), pg = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this.enableScissor = !0, this.alphaMaskPool = [], this.maskDataPool = [], this.maskStack = [], this.alphaMaskIndex = 0;
    }
    return r.prototype.setMaskStack = function(t) {
      this.maskStack = t, this.renderer.scissor.setMaskStack(t), this.renderer.stencil.setMaskStack(t);
    }, r.prototype.push = function(t, e) {
      var n = e;
      if (!n.isMaskData) {
        var i = this.maskDataPool.pop() || new $y();
        i.pooled = !0, i.maskObject = e, n = i;
      }
      var o = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null;
      if (n.copyCountersOrReset(o), n._colorMask = o ? o._colorMask : 15, n.autoDetect && this.detect(n), n._target = t, n.type !== It.SPRITE && this.maskStack.push(n), n.enabled)
        switch (n.type) {
          case It.SCISSOR:
            this.renderer.scissor.push(n);
            break;
          case It.STENCIL:
            this.renderer.stencil.push(n);
            break;
          case It.SPRITE:
            n.copyCountersOrReset(null), this.pushSpriteMask(n);
            break;
          case It.COLOR:
            this.pushColorMask(n);
            break;
        }
      n.type === It.SPRITE && this.maskStack.push(n);
    }, r.prototype.pop = function(t) {
      var e = this.maskStack.pop();
      if (!(!e || e._target !== t)) {
        if (e.enabled)
          switch (e.type) {
            case It.SCISSOR:
              this.renderer.scissor.pop(e);
              break;
            case It.STENCIL:
              this.renderer.stencil.pop(e.maskObject);
              break;
            case It.SPRITE:
              this.popSpriteMask(e);
              break;
            case It.COLOR:
              this.popColorMask(e);
              break;
          }
        if (e.reset(), e.pooled && this.maskDataPool.push(e), this.maskStack.length !== 0) {
          var n = this.maskStack[this.maskStack.length - 1];
          n.type === It.SPRITE && n._filters && (n._filters[0].maskSprite = n.maskObject);
        }
      }
    }, r.prototype.detect = function(t) {
      var e = t.maskObject;
      e ? e.isSprite ? t.type = It.SPRITE : this.enableScissor && this.renderer.scissor.testScissor(t) ? t.type = It.SCISSOR : t.type = It.STENCIL : t.type = It.COLOR;
    }, r.prototype.pushSpriteMask = function(t) {
      var e, n, i = t.maskObject, o = t._target, a = t._filters;
      a || (a = this.alphaMaskPool[this.alphaMaskIndex], a || (a = this.alphaMaskPool[this.alphaMaskIndex] = [new dg()]));
      var s = this.renderer, h = s.renderTexture, u, l;
      if (h.current) {
        var f = h.current;
        u = t.resolution || f.resolution, l = (e = t.multisample) !== null && e !== void 0 ? e : f.multisample;
      } else
        u = t.resolution || s.resolution, l = (n = t.multisample) !== null && n !== void 0 ? n : s.multisample;
      a[0].resolution = u, a[0].multisample = l, a[0].maskSprite = i;
      var c = o.filterArea;
      o.filterArea = i.getBounds(!0), s.filter.push(o, a), o.filterArea = c, t._filters || this.alphaMaskIndex++;
    }, r.prototype.popSpriteMask = function(t) {
      this.renderer.filter.pop(), t._filters ? t._filters[0].maskSprite = null : (this.alphaMaskIndex--, this.alphaMaskPool[this.alphaMaskIndex][0].maskSprite = null);
    }, r.prototype.pushColorMask = function(t) {
      var e = t._colorMask, n = t._colorMask = e & t.colorMask;
      n !== e && this.renderer.gl.colorMask((n & 1) !== 0, (n & 2) !== 0, (n & 4) !== 0, (n & 8) !== 0);
    }, r.prototype.popColorMask = function(t) {
      var e = t._colorMask, n = this.maskStack.length > 0 ? this.maskStack[this.maskStack.length - 1]._colorMask : 15;
      n !== e && this.renderer.gl.colorMask((n & 1) !== 0, (n & 2) !== 0, (n & 4) !== 0, (n & 8) !== 0);
    }, r.prototype.destroy = function() {
      this.renderer = null;
    }, r;
  }()
), Sl = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this.maskStack = [], this.glConst = 0;
    }
    return r.prototype.getStackLength = function() {
      return this.maskStack.length;
    }, r.prototype.setMaskStack = function(t) {
      var e = this.renderer.gl, n = this.getStackLength();
      this.maskStack = t;
      var i = this.getStackLength();
      i !== n && (i === 0 ? e.disable(this.glConst) : (e.enable(this.glConst), this._useCurrent()));
    }, r.prototype._useCurrent = function() {
    }, r.prototype.destroy = function() {
      this.renderer = null, this.maskStack = null;
    }, r;
  }()
), Ih = new Dt(), Ch = [], vg = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e) {
      var n = r.call(this, e) || this;
      return n.glConst = G.ADAPTER.getWebGLRenderingContext().SCISSOR_TEST, n;
    }
    return t.prototype.getStackLength = function() {
      var e = this.maskStack[this.maskStack.length - 1];
      return e ? e._scissorCounter : 0;
    }, t.prototype.calcScissorRect = function(e) {
      var n;
      if (!e._scissorRectLocal) {
        var i = e._scissorRect, o = e.maskObject, a = this.renderer, s = a.renderTexture, h = o.getBounds(!0, (n = Ch.pop()) !== null && n !== void 0 ? n : new ut());
        this.roundFrameToPixels(h, s.current ? s.current.resolution : a.resolution, s.sourceFrame, s.destinationFrame, a.projection.transform), i && h.fit(i), e._scissorRectLocal = h;
      }
    }, t.isMatrixRotated = function(e) {
      if (!e)
        return !1;
      var n = e.a, i = e.b, o = e.c, a = e.d;
      return (Math.abs(i) > 1e-4 || Math.abs(o) > 1e-4) && (Math.abs(n) > 1e-4 || Math.abs(a) > 1e-4);
    }, t.prototype.testScissor = function(e) {
      var n = e.maskObject;
      if (!n.isFastRect || !n.isFastRect() || t.isMatrixRotated(n.worldTransform) || t.isMatrixRotated(this.renderer.projection.transform))
        return !1;
      this.calcScissorRect(e);
      var i = e._scissorRectLocal;
      return i.width > 0 && i.height > 0;
    }, t.prototype.roundFrameToPixels = function(e, n, i, o, a) {
      t.isMatrixRotated(a) || (a = a ? Ih.copyFrom(a) : Ih.identity(), a.translate(-i.x, -i.y).scale(o.width / i.width, o.height / i.height).translate(o.x, o.y), this.renderer.filter.transformAABB(a, e), e.fit(o), e.x = Math.round(e.x * n), e.y = Math.round(e.y * n), e.width = Math.round(e.width * n), e.height = Math.round(e.height * n));
    }, t.prototype.push = function(e) {
      e._scissorRectLocal || this.calcScissorRect(e);
      var n = this.renderer.gl;
      e._scissorRect || n.enable(n.SCISSOR_TEST), e._scissorCounter++, e._scissorRect = e._scissorRectLocal, this._useCurrent();
    }, t.prototype.pop = function(e) {
      var n = this.renderer.gl;
      e && Ch.push(e._scissorRectLocal), this.getStackLength() > 0 ? this._useCurrent() : n.disable(n.SCISSOR_TEST);
    }, t.prototype._useCurrent = function() {
      var e = this.maskStack[this.maskStack.length - 1]._scissorRect, n;
      this.renderer.renderTexture.current ? n = e.y : n = this.renderer.height - e.height - e.y, this.renderer.gl.scissor(e.x, n, e.width, e.height);
    }, t;
  }(Sl)
), _g = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e) {
      var n = r.call(this, e) || this;
      return n.glConst = G.ADAPTER.getWebGLRenderingContext().STENCIL_TEST, n;
    }
    return t.prototype.getStackLength = function() {
      var e = this.maskStack[this.maskStack.length - 1];
      return e ? e._stencilCounter : 0;
    }, t.prototype.push = function(e) {
      var n = e.maskObject, i = this.renderer.gl, o = e._stencilCounter;
      o === 0 && (this.renderer.framebuffer.forceStencil(), i.clearStencil(0), i.clear(i.STENCIL_BUFFER_BIT), i.enable(i.STENCIL_TEST)), e._stencilCounter++;
      var a = e._colorMask;
      a !== 0 && (e._colorMask = 0, i.colorMask(!1, !1, !1, !1)), i.stencilFunc(i.EQUAL, o, 4294967295), i.stencilOp(i.KEEP, i.KEEP, i.INCR), n.renderable = !0, n.render(this.renderer), this.renderer.batch.flush(), n.renderable = !1, a !== 0 && (e._colorMask = a, i.colorMask((a & 1) !== 0, (a & 2) !== 0, (a & 4) !== 0, (a & 8) !== 0)), this._useCurrent();
    }, t.prototype.pop = function(e) {
      var n = this.renderer.gl;
      if (this.getStackLength() === 0)
        n.disable(n.STENCIL_TEST);
      else {
        var i = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null, o = i ? i._colorMask : 15;
        o !== 0 && (i._colorMask = 0, n.colorMask(!1, !1, !1, !1)), n.stencilOp(n.KEEP, n.KEEP, n.DECR), e.renderable = !0, e.render(this.renderer), this.renderer.batch.flush(), e.renderable = !1, o !== 0 && (i._colorMask = o, n.colorMask((o & 1) !== 0, (o & 2) !== 0, (o & 4) !== 0, (o & 8) !== 0)), this._useCurrent();
      }
    }, t.prototype._useCurrent = function() {
      var e = this.renderer.gl;
      e.stencilFunc(e.EQUAL, this.getStackLength(), 4294967295), e.stencilOp(e.KEEP, e.KEEP, e.KEEP);
    }, t;
  }(Sl)
), mg = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this.destinationFrame = null, this.sourceFrame = null, this.defaultFrame = null, this.projectionMatrix = new Dt(), this.transform = null;
    }
    return r.prototype.update = function(t, e, n, i) {
      this.destinationFrame = t || this.destinationFrame || this.defaultFrame, this.sourceFrame = e || this.sourceFrame || t, this.calculateProjection(this.destinationFrame, this.sourceFrame, n, i), this.transform && this.projectionMatrix.append(this.transform);
      var o = this.renderer;
      o.globalUniforms.uniforms.projectionMatrix = this.projectionMatrix, o.globalUniforms.update(), o.shader.shader && o.shader.syncUniformGroup(o.shader.shader.uniforms.globals);
    }, r.prototype.calculateProjection = function(t, e, n, i) {
      var o = this.projectionMatrix, a = i ? -1 : 1;
      o.identity(), o.a = 1 / e.width * 2, o.d = a * (1 / e.height * 2), o.tx = -1 - e.x * o.a, o.ty = -a - e.y * o.d;
    }, r.prototype.setTransform = function(t) {
    }, r.prototype.destroy = function() {
      this.renderer = null;
    }, r;
  }()
), We = new ut(), Jr = new ut(), yg = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this.clearColor = t._backgroundColorRgba, this.defaultMaskStack = [], this.current = null, this.sourceFrame = new ut(), this.destinationFrame = new ut(), this.viewportFrame = new ut();
    }
    return r.prototype.bind = function(t, e, n) {
      t === void 0 && (t = null);
      var i = this.renderer;
      this.current = t;
      var o, a, s;
      t ? (o = t.baseTexture, s = o.resolution, e || (We.width = t.frame.width, We.height = t.frame.height, e = We), n || (Jr.x = t.frame.x, Jr.y = t.frame.y, Jr.width = e.width, Jr.height = e.height, n = Jr), a = o.framebuffer) : (s = i.resolution, e || (We.width = i.screen.width, We.height = i.screen.height, e = We), n || (n = We, n.width = e.width, n.height = e.height));
      var h = this.viewportFrame;
      h.x = n.x * s, h.y = n.y * s, h.width = n.width * s, h.height = n.height * s, t || (h.y = i.view.height - (h.y + h.height)), h.ceil(), this.renderer.framebuffer.bind(a, h), this.renderer.projection.update(n, e, s, !a), t ? this.renderer.mask.setMaskStack(o.maskStack) : this.renderer.mask.setMaskStack(this.defaultMaskStack), this.sourceFrame.copyFrom(e), this.destinationFrame.copyFrom(n);
    }, r.prototype.clear = function(t, e) {
      this.current ? t = t || this.current.baseTexture.clearColor : t = t || this.clearColor;
      var n = this.destinationFrame, i = this.current ? this.current.baseTexture : this.renderer.screen, o = n.width !== i.width || n.height !== i.height;
      if (o) {
        var a = this.viewportFrame, s = a.x, h = a.y, u = a.width, l = a.height;
        s = Math.round(s), h = Math.round(h), u = Math.round(u), l = Math.round(l), this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST), this.renderer.gl.scissor(s, h, u, l);
      }
      this.renderer.framebuffer.clear(t[0], t[1], t[2], t[3], e), o && this.renderer.scissor.pop();
    }, r.prototype.resize = function() {
      this.bind(null);
    }, r.prototype.reset = function() {
      this.bind(null);
    }, r.prototype.destroy = function() {
      this.renderer = null;
    }, r;
  }()
);
function gg(r, t, e, n, i) {
  e.buffer.update(i);
}
var bg = {
  float: `
        data[offset] = v;
    `,
  vec2: `
        data[offset] = v[0];
        data[offset+1] = v[1];
    `,
  vec3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

    `,
  vec4: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];
        data[offset+3] = v[3];
    `,
  mat2: `
        data[offset] = v[0];
        data[offset+1] = v[1];

        data[offset+4] = v[2];
        data[offset+5] = v[3];
    `,
  mat3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];

        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];
    `,
  mat4: `
        for(var i = 0; i < 16; i++)
        {
            data[offset + i] = v[i];
        }
    `
}, Al = {
  float: 4,
  vec2: 8,
  vec3: 12,
  vec4: 16,
  int: 4,
  ivec2: 8,
  ivec3: 12,
  ivec4: 16,
  uint: 4,
  uvec2: 8,
  uvec3: 12,
  uvec4: 16,
  bool: 4,
  bvec2: 8,
  bvec3: 12,
  bvec4: 16,
  mat2: 16 * 2,
  mat3: 16 * 3,
  mat4: 16 * 4
};
function xg(r) {
  for (var t = r.map(function(h) {
    return {
      data: h,
      offset: 0,
      dataLen: 0,
      dirty: 0
    };
  }), e = 0, n = 0, i = 0, o = 0; o < t.length; o++) {
    var a = t[o];
    if (e = Al[a.data.type], a.data.size > 1 && (e = Math.max(e, 16) * a.data.size), a.dataLen = e, n % e !== 0 && n < 16) {
      var s = n % e % 16;
      n += s, i += s;
    }
    n + e > 16 ? (i = Math.ceil(i / 16) * 16, a.offset = i, i += e, n = e) : (a.offset = i, n += e, i += e);
  }
  return i = Math.ceil(i / 16) * 16, { uboElements: t, size: i };
}
function Tg(r, t) {
  var e = [];
  for (var n in r)
    t[n] && e.push(t[n]);
  return e.sort(function(i, o) {
    return i.index - o.index;
  }), e;
}
function Eg(r, t) {
  if (!r.autoManage)
    return { size: 0, syncFunc: gg };
  for (var e = Tg(r.uniforms, t), n = xg(e), i = n.uboElements, o = n.size, a = [`
    var v = null;
    var v2 = null;
    var cv = null;
    var t = 0;
    var gl = renderer.gl
    var index = 0;
    var data = buffer.data;
    `], s = 0; s < i.length; s++) {
    for (var h = i[s], u = r.uniforms[h.data.name], l = h.data.name, f = !1, c = 0; c < Lr.length; c++) {
      var d = Lr[c];
      if (d.codeUbo && d.test(h.data, u)) {
        a.push("offset = " + h.offset / 4 + ";", Lr[c].codeUbo(h.data.name, u)), f = !0;
        break;
      }
    }
    if (!f)
      if (h.data.size > 1) {
        var p = El(h.data.type), v = Math.max(Al[h.data.type] / 16, 1), _ = p / v, m = (4 - _ % 4) % 4;
        a.push(`
                cv = ud.` + l + `.value;
                v = uv.` + l + `;
                offset = ` + h.offset / 4 + `;

                t = 0;

                for(var i=0; i < ` + h.data.size * v + `; i++)
                {
                    for(var j = 0; j < ` + _ + `; j++)
                    {
                        data[offset++] = v[t++];
                    }
                    offset += ` + m + `;
                }

                `);
      } else {
        var y = bg[h.data.type];
        a.push(`
                cv = ud.` + l + `.value;
                v = uv.` + l + `;
                offset = ` + h.offset / 4 + `;
                ` + y + `;
                `);
      }
  }
  return a.push(`
       renderer.buffer.update(buffer);
    `), {
    size: o,
    // eslint-disable-next-line no-new-func
    syncFunc: new Function("ud", "uv", "renderer", "syncData", "buffer", a.join(`
`))
  };
}
var wg = (
  /** @class */
  function() {
    function r(t, e) {
      this.program = t, this.uniformData = e, this.uniformGroups = {}, this.uniformDirtyGroups = {}, this.uniformBufferBindings = {};
    }
    return r.prototype.destroy = function() {
      this.uniformData = null, this.uniformGroups = null, this.uniformDirtyGroups = null, this.uniformBufferBindings = null, this.program = null;
    }, r;
  }()
);
function Sg(r, t) {
  for (var e = {}, n = t.getProgramParameter(r, t.ACTIVE_ATTRIBUTES), i = 0; i < n; i++) {
    var o = t.getActiveAttrib(r, i);
    if (o.name.indexOf("gl_") !== 0) {
      var a = wl(t, o.type), s = {
        type: a,
        name: o.name,
        size: El(a),
        location: t.getAttribLocation(r, o.name)
      };
      e[o.name] = s;
    }
  }
  return e;
}
function Ag(r, t) {
  for (var e = {}, n = t.getProgramParameter(r, t.ACTIVE_UNIFORMS), i = 0; i < n; i++) {
    var o = t.getActiveUniform(r, i), a = o.name.replace(/\[.*?\]$/, ""), s = !!o.name.match(/\[.*?\]$/), h = wl(t, o.type);
    e[a] = {
      name: a,
      index: i,
      type: h,
      size: o.size,
      isArray: s,
      value: xl(h, o.size)
    };
  }
  return e;
}
function Pg(r, t) {
  var e = Sh(r, r.VERTEX_SHADER, t.vertexSrc), n = Sh(r, r.FRAGMENT_SHADER, t.fragmentSrc), i = r.createProgram();
  if (r.attachShader(i, e), r.attachShader(i, n), r.linkProgram(i), r.getProgramParameter(i, r.LINK_STATUS) || qy(r, i, e, n), t.attributeData = Sg(i, r), t.uniformData = Ag(i, r), !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(t.vertexSrc)) {
    var o = Object.keys(t.attributeData);
    o.sort(function(l, f) {
      return l > f ? 1 : -1;
    });
    for (var a = 0; a < o.length; a++)
      t.attributeData[o[a]].location = a, r.bindAttribLocation(i, a, o[a]);
    r.linkProgram(i);
  }
  r.deleteShader(e), r.deleteShader(n);
  var s = {};
  for (var a in t.uniformData) {
    var h = t.uniformData[a];
    s[a] = {
      location: r.getUniformLocation(i, a),
      value: xl(h.type, h.size)
    };
  }
  var u = new wg(i, s);
  return u;
}
var Og = 0, qn = { textureCount: 0, uboCount: 0 }, Rg = (
  /** @class */
  function() {
    function r(t) {
      this.destroyed = !1, this.renderer = t, this.systemCheck(), this.gl = null, this.shader = null, this.program = null, this.cache = {}, this._uboCache = {}, this.id = Og++;
    }
    return r.prototype.systemCheck = function() {
      if (!og())
        throw new Error("Current environment does not allow unsafe-eval, please use @pixi/unsafe-eval module to enable support.");
    }, r.prototype.contextChange = function(t) {
      this.gl = t, this.reset();
    }, r.prototype.bind = function(t, e) {
      t.disposeRunner.add(this), t.uniforms.globals = this.renderer.globalUniforms;
      var n = t.program, i = n.glPrograms[this.renderer.CONTEXT_UID] || this.generateProgram(t);
      return this.shader = t, this.program !== n && (this.program = n, this.gl.useProgram(i.program)), e || (qn.textureCount = 0, qn.uboCount = 0, this.syncUniformGroup(t.uniformGroup, qn)), i;
    }, r.prototype.setUniforms = function(t) {
      var e = this.shader.program, n = e.glPrograms[this.renderer.CONTEXT_UID];
      e.syncUniforms(n.uniformData, t, this.renderer);
    }, r.prototype.syncUniformGroup = function(t, e) {
      var n = this.getGlProgram();
      (!t.static || t.dirtyId !== n.uniformDirtyGroups[t.id]) && (n.uniformDirtyGroups[t.id] = t.dirtyId, this.syncUniforms(t, n, e));
    }, r.prototype.syncUniforms = function(t, e, n) {
      var i = t.syncUniforms[this.shader.program.id] || this.createSyncGroups(t);
      i(e.uniformData, t.uniforms, this.renderer, n);
    }, r.prototype.createSyncGroups = function(t) {
      var e = this.getSignature(t, this.shader.program.uniformData, "u");
      return this.cache[e] || (this.cache[e] = eg(t, this.shader.program.uniformData)), t.syncUniforms[this.shader.program.id] = this.cache[e], t.syncUniforms[this.shader.program.id];
    }, r.prototype.syncUniformBufferGroup = function(t, e) {
      var n = this.getGlProgram();
      if (!t.static || t.dirtyId !== 0 || !n.uniformGroups[t.id]) {
        t.dirtyId = 0;
        var i = n.uniformGroups[t.id] || this.createSyncBufferGroup(t, n, e);
        t.buffer.update(), i(n.uniformData, t.uniforms, this.renderer, qn, t.buffer);
      }
      this.renderer.buffer.bindBufferBase(t.buffer, n.uniformBufferBindings[e]);
    }, r.prototype.createSyncBufferGroup = function(t, e, n) {
      var i = this.renderer.gl;
      this.renderer.buffer.bind(t.buffer);
      var o = this.gl.getUniformBlockIndex(e.program, n);
      e.uniformBufferBindings[n] = this.shader.uniformBindCount, i.uniformBlockBinding(e.program, o, this.shader.uniformBindCount), this.shader.uniformBindCount++;
      var a = this.getSignature(t, this.shader.program.uniformData, "ubo"), s = this._uboCache[a];
      if (s || (s = this._uboCache[a] = Eg(t, this.shader.program.uniformData)), t.autoManage) {
        var h = new Float32Array(s.size / 4);
        t.buffer.update(h);
      }
      return e.uniformGroups[t.id] = s.syncFunc, e.uniformGroups[t.id];
    }, r.prototype.getSignature = function(t, e, n) {
      var i = t.uniforms, o = [n + "-"];
      for (var a in i)
        o.push(a), e[a] && o.push(e[a].type);
      return o.join("-");
    }, r.prototype.getGlProgram = function() {
      return this.shader ? this.shader.program.glPrograms[this.renderer.CONTEXT_UID] : null;
    }, r.prototype.generateProgram = function(t) {
      var e = this.gl, n = t.program, i = Pg(e, n);
      return n.glPrograms[this.renderer.CONTEXT_UID] = i, i;
    }, r.prototype.reset = function() {
      this.program = null, this.shader = null;
    }, r.prototype.disposeShader = function(t) {
      this.shader === t && (this.shader = null);
    }, r.prototype.destroy = function() {
      this.renderer = null, this.destroyed = !0;
    }, r;
  }()
);
function Ig(r, t) {
  return t === void 0 && (t = []), t[Y.NORMAL] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.ADD] = [r.ONE, r.ONE], t[Y.MULTIPLY] = [r.DST_COLOR, r.ONE_MINUS_SRC_ALPHA, r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.SCREEN] = [r.ONE, r.ONE_MINUS_SRC_COLOR, r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.OVERLAY] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.DARKEN] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.LIGHTEN] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.COLOR_DODGE] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.COLOR_BURN] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.HARD_LIGHT] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.SOFT_LIGHT] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.DIFFERENCE] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.EXCLUSION] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.HUE] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.SATURATION] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.COLOR] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.LUMINOSITY] = [r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.NONE] = [0, 0], t[Y.NORMAL_NPM] = [r.SRC_ALPHA, r.ONE_MINUS_SRC_ALPHA, r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.ADD_NPM] = [r.SRC_ALPHA, r.ONE, r.ONE, r.ONE], t[Y.SCREEN_NPM] = [r.SRC_ALPHA, r.ONE_MINUS_SRC_COLOR, r.ONE, r.ONE_MINUS_SRC_ALPHA], t[Y.SRC_IN] = [r.DST_ALPHA, r.ZERO], t[Y.SRC_OUT] = [r.ONE_MINUS_DST_ALPHA, r.ZERO], t[Y.SRC_ATOP] = [r.DST_ALPHA, r.ONE_MINUS_SRC_ALPHA], t[Y.DST_OVER] = [r.ONE_MINUS_DST_ALPHA, r.ONE], t[Y.DST_IN] = [r.ZERO, r.SRC_ALPHA], t[Y.DST_OUT] = [r.ZERO, r.ONE_MINUS_SRC_ALPHA], t[Y.DST_ATOP] = [r.ONE_MINUS_DST_ALPHA, r.SRC_ALPHA], t[Y.XOR] = [r.ONE_MINUS_DST_ALPHA, r.ONE_MINUS_SRC_ALPHA], t[Y.SUBTRACT] = [r.ONE, r.ONE, r.ONE, r.ONE, r.FUNC_REVERSE_SUBTRACT, r.FUNC_ADD], t;
}
var Cg = 0, Mg = 1, Dg = 2, Fg = 3, Bg = 4, Ng = 5, Lg = (
  /** @class */
  function() {
    function r() {
      this.gl = null, this.stateId = 0, this.polygonOffset = 0, this.blendMode = Y.NONE, this._blendEq = !1, this.map = [], this.map[Cg] = this.setBlend, this.map[Mg] = this.setOffset, this.map[Dg] = this.setCullFace, this.map[Fg] = this.setDepthTest, this.map[Bg] = this.setFrontFace, this.map[Ng] = this.setDepthMask, this.checks = [], this.defaultState = new dr(), this.defaultState.blend = !0;
    }
    return r.prototype.contextChange = function(t) {
      this.gl = t, this.blendModes = Ig(t), this.set(this.defaultState), this.reset();
    }, r.prototype.set = function(t) {
      if (t = t || this.defaultState, this.stateId !== t.data) {
        for (var e = this.stateId ^ t.data, n = 0; e; )
          e & 1 && this.map[n].call(this, !!(t.data & 1 << n)), e = e >> 1, n++;
        this.stateId = t.data;
      }
      for (var n = 0; n < this.checks.length; n++)
        this.checks[n](this, t);
    }, r.prototype.forceState = function(t) {
      t = t || this.defaultState;
      for (var e = 0; e < this.map.length; e++)
        this.map[e].call(this, !!(t.data & 1 << e));
      for (var e = 0; e < this.checks.length; e++)
        this.checks[e](this, t);
      this.stateId = t.data;
    }, r.prototype.setBlend = function(t) {
      this.updateCheck(r.checkBlendMode, t), this.gl[t ? "enable" : "disable"](this.gl.BLEND);
    }, r.prototype.setOffset = function(t) {
      this.updateCheck(r.checkPolygonOffset, t), this.gl[t ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
    }, r.prototype.setDepthTest = function(t) {
      this.gl[t ? "enable" : "disable"](this.gl.DEPTH_TEST);
    }, r.prototype.setDepthMask = function(t) {
      this.gl.depthMask(t);
    }, r.prototype.setCullFace = function(t) {
      this.gl[t ? "enable" : "disable"](this.gl.CULL_FACE);
    }, r.prototype.setFrontFace = function(t) {
      this.gl.frontFace(this.gl[t ? "CW" : "CCW"]);
    }, r.prototype.setBlendMode = function(t) {
      if (t !== this.blendMode) {
        this.blendMode = t;
        var e = this.blendModes[t], n = this.gl;
        e.length === 2 ? n.blendFunc(e[0], e[1]) : n.blendFuncSeparate(e[0], e[1], e[2], e[3]), e.length === 6 ? (this._blendEq = !0, n.blendEquationSeparate(e[4], e[5])) : this._blendEq && (this._blendEq = !1, n.blendEquationSeparate(n.FUNC_ADD, n.FUNC_ADD));
      }
    }, r.prototype.setPolygonOffset = function(t, e) {
      this.gl.polygonOffset(t, e);
    }, r.prototype.reset = function() {
      this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !1), this.forceState(this.defaultState), this._blendEq = !0, this.blendMode = -1, this.setBlendMode(0);
    }, r.prototype.updateCheck = function(t, e) {
      var n = this.checks.indexOf(t);
      e && n === -1 ? this.checks.push(t) : !e && n !== -1 && this.checks.splice(n, 1);
    }, r.checkBlendMode = function(t, e) {
      t.setBlendMode(e.blendMode);
    }, r.checkPolygonOffset = function(t, e) {
      t.setPolygonOffset(1, e.polygonOffset);
    }, r.prototype.destroy = function() {
      this.gl = null;
    }, r;
  }()
), Ug = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this.count = 0, this.checkCount = 0, this.maxIdle = G.GC_MAX_IDLE, this.checkCountMax = G.GC_MAX_CHECK_COUNT, this.mode = G.GC_MODE;
    }
    return r.prototype.postrender = function() {
      this.renderer.renderingToScreen && (this.count++, this.mode !== gi.MANUAL && (this.checkCount++, this.checkCount > this.checkCountMax && (this.checkCount = 0, this.run())));
    }, r.prototype.run = function() {
      for (var t = this.renderer.texture, e = t.managedTextures, n = !1, i = 0; i < e.length; i++) {
        var o = e[i];
        !o.framebuffer && this.count - o.touched > this.maxIdle && (t.destroyTexture(o, !0), e[i] = null, n = !0);
      }
      if (n) {
        for (var a = 0, i = 0; i < e.length; i++)
          e[i] !== null && (e[a++] = e[i]);
        e.length = a;
      }
    }, r.prototype.unload = function(t) {
      var e = this.renderer.texture, n = t._texture;
      n && !n.framebuffer && e.destroyTexture(n);
      for (var i = t.children.length - 1; i >= 0; i--)
        this.unload(t.children[i]);
    }, r.prototype.destroy = function() {
      this.renderer = null;
    }, r;
  }()
);
function Gg(r) {
  var t, e, n, i, o, a, s, h, u, l, f, c, d, p, v, _, m, y, g, x, T, E, P;
  return "WebGL2RenderingContext" in globalThis && r instanceof globalThis.WebGL2RenderingContext ? P = (t = {}, t[X.UNSIGNED_BYTE] = (e = {}, e[L.RGBA] = r.RGBA8, e[L.RGB] = r.RGB8, e[L.RG] = r.RG8, e[L.RED] = r.R8, e[L.RGBA_INTEGER] = r.RGBA8UI, e[L.RGB_INTEGER] = r.RGB8UI, e[L.RG_INTEGER] = r.RG8UI, e[L.RED_INTEGER] = r.R8UI, e[L.ALPHA] = r.ALPHA, e[L.LUMINANCE] = r.LUMINANCE, e[L.LUMINANCE_ALPHA] = r.LUMINANCE_ALPHA, e), t[X.BYTE] = (n = {}, n[L.RGBA] = r.RGBA8_SNORM, n[L.RGB] = r.RGB8_SNORM, n[L.RG] = r.RG8_SNORM, n[L.RED] = r.R8_SNORM, n[L.RGBA_INTEGER] = r.RGBA8I, n[L.RGB_INTEGER] = r.RGB8I, n[L.RG_INTEGER] = r.RG8I, n[L.RED_INTEGER] = r.R8I, n), t[X.UNSIGNED_SHORT] = (i = {}, i[L.RGBA_INTEGER] = r.RGBA16UI, i[L.RGB_INTEGER] = r.RGB16UI, i[L.RG_INTEGER] = r.RG16UI, i[L.RED_INTEGER] = r.R16UI, i[L.DEPTH_COMPONENT] = r.DEPTH_COMPONENT16, i), t[X.SHORT] = (o = {}, o[L.RGBA_INTEGER] = r.RGBA16I, o[L.RGB_INTEGER] = r.RGB16I, o[L.RG_INTEGER] = r.RG16I, o[L.RED_INTEGER] = r.R16I, o), t[X.UNSIGNED_INT] = (a = {}, a[L.RGBA_INTEGER] = r.RGBA32UI, a[L.RGB_INTEGER] = r.RGB32UI, a[L.RG_INTEGER] = r.RG32UI, a[L.RED_INTEGER] = r.R32UI, a[L.DEPTH_COMPONENT] = r.DEPTH_COMPONENT24, a), t[X.INT] = (s = {}, s[L.RGBA_INTEGER] = r.RGBA32I, s[L.RGB_INTEGER] = r.RGB32I, s[L.RG_INTEGER] = r.RG32I, s[L.RED_INTEGER] = r.R32I, s), t[X.FLOAT] = (h = {}, h[L.RGBA] = r.RGBA32F, h[L.RGB] = r.RGB32F, h[L.RG] = r.RG32F, h[L.RED] = r.R32F, h[L.DEPTH_COMPONENT] = r.DEPTH_COMPONENT32F, h), t[X.HALF_FLOAT] = (u = {}, u[L.RGBA] = r.RGBA16F, u[L.RGB] = r.RGB16F, u[L.RG] = r.RG16F, u[L.RED] = r.R16F, u), t[X.UNSIGNED_SHORT_5_6_5] = (l = {}, l[L.RGB] = r.RGB565, l), t[X.UNSIGNED_SHORT_4_4_4_4] = (f = {}, f[L.RGBA] = r.RGBA4, f), t[X.UNSIGNED_SHORT_5_5_5_1] = (c = {}, c[L.RGBA] = r.RGB5_A1, c), t[X.UNSIGNED_INT_2_10_10_10_REV] = (d = {}, d[L.RGBA] = r.RGB10_A2, d[L.RGBA_INTEGER] = r.RGB10_A2UI, d), t[X.UNSIGNED_INT_10F_11F_11F_REV] = (p = {}, p[L.RGB] = r.R11F_G11F_B10F, p), t[X.UNSIGNED_INT_5_9_9_9_REV] = (v = {}, v[L.RGB] = r.RGB9_E5, v), t[X.UNSIGNED_INT_24_8] = (_ = {}, _[L.DEPTH_STENCIL] = r.DEPTH24_STENCIL8, _), t[X.FLOAT_32_UNSIGNED_INT_24_8_REV] = (m = {}, m[L.DEPTH_STENCIL] = r.DEPTH32F_STENCIL8, m), t) : P = (y = {}, y[X.UNSIGNED_BYTE] = (g = {}, g[L.RGBA] = r.RGBA, g[L.RGB] = r.RGB, g[L.ALPHA] = r.ALPHA, g[L.LUMINANCE] = r.LUMINANCE, g[L.LUMINANCE_ALPHA] = r.LUMINANCE_ALPHA, g), y[X.UNSIGNED_SHORT_5_6_5] = (x = {}, x[L.RGB] = r.RGB, x), y[X.UNSIGNED_SHORT_4_4_4_4] = (T = {}, T[L.RGBA] = r.RGBA, T), y[X.UNSIGNED_SHORT_5_5_5_1] = (E = {}, E[L.RGBA] = r.RGBA, E), y), P;
}
var To = (
  /** @class */
  function() {
    function r(t) {
      this.texture = t, this.width = -1, this.height = -1, this.dirtyId = -1, this.dirtyStyleId = -1, this.mipmap = !1, this.wrapMode = 33071, this.type = X.UNSIGNED_BYTE, this.internalFormat = L.RGBA, this.samplerType = 0;
    }
    return r;
  }()
), kg = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this.boundTextures = [], this.currentLocation = -1, this.managedTextures = [], this._unknownBoundTextures = !1, this.unknownTexture = new ht(), this.hasIntegerTextures = !1;
    }
    return r.prototype.contextChange = function() {
      var t = this.gl = this.renderer.gl;
      this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.webGLVersion = this.renderer.context.webGLVersion, this.internalFormats = Gg(t);
      var e = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);
      this.boundTextures.length = e;
      for (var n = 0; n < e; n++)
        this.boundTextures[n] = null;
      this.emptyTextures = {};
      var i = new To(t.createTexture());
      t.bindTexture(t.TEXTURE_2D, i.texture), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, 1, 1, 0, t.RGBA, t.UNSIGNED_BYTE, new Uint8Array(4)), this.emptyTextures[t.TEXTURE_2D] = i, this.emptyTextures[t.TEXTURE_CUBE_MAP] = new To(t.createTexture()), t.bindTexture(t.TEXTURE_CUBE_MAP, this.emptyTextures[t.TEXTURE_CUBE_MAP].texture);
      for (var n = 0; n < 6; n++)
        t.texImage2D(t.TEXTURE_CUBE_MAP_POSITIVE_X + n, 0, t.RGBA, 1, 1, 0, t.RGBA, t.UNSIGNED_BYTE, null);
      t.texParameteri(t.TEXTURE_CUBE_MAP, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_CUBE_MAP, t.TEXTURE_MIN_FILTER, t.LINEAR);
      for (var n = 0; n < this.boundTextures.length; n++)
        this.bind(null, n);
    }, r.prototype.bind = function(t, e) {
      e === void 0 && (e = 0);
      var n = this.gl;
      if (t = t == null ? void 0 : t.castToBaseTexture(), t && t.valid && !t.parentTextureArray) {
        t.touched = this.renderer.textureGC.count;
        var i = t._glTextures[this.CONTEXT_UID] || this.initTexture(t);
        this.boundTextures[e] !== t && (this.currentLocation !== e && (this.currentLocation = e, n.activeTexture(n.TEXTURE0 + e)), n.bindTexture(t.target, i.texture)), i.dirtyId !== t.dirtyId ? (this.currentLocation !== e && (this.currentLocation = e, n.activeTexture(n.TEXTURE0 + e)), this.updateTexture(t)) : i.dirtyStyleId !== t.dirtyStyleId && this.updateTextureStyle(t), this.boundTextures[e] = t;
      } else
        this.currentLocation !== e && (this.currentLocation = e, n.activeTexture(n.TEXTURE0 + e)), n.bindTexture(n.TEXTURE_2D, this.emptyTextures[n.TEXTURE_2D].texture), this.boundTextures[e] = null;
    }, r.prototype.reset = function() {
      this._unknownBoundTextures = !0, this.hasIntegerTextures = !1, this.currentLocation = -1;
      for (var t = 0; t < this.boundTextures.length; t++)
        this.boundTextures[t] = this.unknownTexture;
    }, r.prototype.unbind = function(t) {
      var e = this, n = e.gl, i = e.boundTextures;
      if (this._unknownBoundTextures) {
        this._unknownBoundTextures = !1;
        for (var o = 0; o < i.length; o++)
          i[o] === this.unknownTexture && this.bind(null, o);
      }
      for (var o = 0; o < i.length; o++)
        i[o] === t && (this.currentLocation !== o && (n.activeTexture(n.TEXTURE0 + o), this.currentLocation = o), n.bindTexture(t.target, this.emptyTextures[t.target].texture), i[o] = null);
    }, r.prototype.ensureSamplerType = function(t) {
      var e = this, n = e.boundTextures, i = e.hasIntegerTextures, o = e.CONTEXT_UID;
      if (i)
        for (var a = t - 1; a >= 0; --a) {
          var s = n[a];
          if (s) {
            var h = s._glTextures[o];
            h.samplerType !== yi.FLOAT && this.renderer.texture.unbind(s);
          }
        }
    }, r.prototype.initTexture = function(t) {
      var e = new To(this.gl.createTexture());
      return e.dirtyId = -1, t._glTextures[this.CONTEXT_UID] = e, this.managedTextures.push(t), t.on("dispose", this.destroyTexture, this), e;
    }, r.prototype.initTextureType = function(t, e) {
      var n, i;
      e.internalFormat = (i = (n = this.internalFormats[t.type]) === null || n === void 0 ? void 0 : n[t.format]) !== null && i !== void 0 ? i : t.format, this.webGLVersion === 2 && t.type === X.HALF_FLOAT ? e.type = this.gl.HALF_FLOAT : e.type = t.type;
    }, r.prototype.updateTexture = function(t) {
      var e = t._glTextures[this.CONTEXT_UID];
      if (e) {
        var n = this.renderer;
        if (this.initTextureType(t, e), t.resource && t.resource.upload(n, t, e))
          e.samplerType !== yi.FLOAT && (this.hasIntegerTextures = !0);
        else {
          var i = t.realWidth, o = t.realHeight, a = n.gl;
          (e.width !== i || e.height !== o || e.dirtyId < 0) && (e.width = i, e.height = o, a.texImage2D(t.target, 0, e.internalFormat, i, o, 0, t.format, e.type, null));
        }
        t.dirtyStyleId !== e.dirtyStyleId && this.updateTextureStyle(t), e.dirtyId = t.dirtyId;
      }
    }, r.prototype.destroyTexture = function(t, e) {
      var n = this.gl;
      if (t = t.castToBaseTexture(), t._glTextures[this.CONTEXT_UID] && (this.unbind(t), n.deleteTexture(t._glTextures[this.CONTEXT_UID].texture), t.off("dispose", this.destroyTexture, this), delete t._glTextures[this.CONTEXT_UID], !e)) {
        var i = this.managedTextures.indexOf(t);
        i !== -1 && Nr(this.managedTextures, i, 1);
      }
    }, r.prototype.updateTextureStyle = function(t) {
      var e = t._glTextures[this.CONTEXT_UID];
      e && ((t.mipmap === de.POW2 || this.webGLVersion !== 2) && !t.isPowerOfTwo ? e.mipmap = !1 : e.mipmap = t.mipmap >= 1, this.webGLVersion !== 2 && !t.isPowerOfTwo ? e.wrapMode = be.CLAMP : e.wrapMode = t.wrapMode, t.resource && t.resource.style(this.renderer, t, e) || this.setStyle(t, e), e.dirtyStyleId = t.dirtyStyleId);
    }, r.prototype.setStyle = function(t, e) {
      var n = this.gl;
      if (e.mipmap && t.mipmap !== de.ON_MANUAL && n.generateMipmap(t.target), n.texParameteri(t.target, n.TEXTURE_WRAP_S, e.wrapMode), n.texParameteri(t.target, n.TEXTURE_WRAP_T, e.wrapMode), e.mipmap) {
        n.texParameteri(t.target, n.TEXTURE_MIN_FILTER, t.scaleMode === ye.LINEAR ? n.LINEAR_MIPMAP_LINEAR : n.NEAREST_MIPMAP_NEAREST);
        var i = this.renderer.context.extensions.anisotropicFiltering;
        if (i && t.anisotropicLevel > 0 && t.scaleMode === ye.LINEAR) {
          var o = Math.min(t.anisotropicLevel, n.getParameter(i.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
          n.texParameterf(t.target, i.TEXTURE_MAX_ANISOTROPY_EXT, o);
        }
      } else
        n.texParameteri(t.target, n.TEXTURE_MIN_FILTER, t.scaleMode === ye.LINEAR ? n.LINEAR : n.NEAREST);
      n.texParameteri(t.target, n.TEXTURE_MAG_FILTER, t.scaleMode === ye.LINEAR ? n.LINEAR : n.NEAREST);
    }, r.prototype.destroy = function() {
      this.renderer = null;
    }, r;
  }()
), Eo = new Dt(), Hg = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e, n) {
      e === void 0 && (e = vn.UNKNOWN);
      var i = r.call(this) || this;
      return n = Object.assign({}, G.RENDER_OPTIONS, n), i.options = n, i.type = e, i.screen = new ut(0, 0, n.width, n.height), i.view = n.view || G.ADAPTER.createCanvas(), i.resolution = n.resolution || G.RESOLUTION, i.useContextAlpha = n.useContextAlpha, i.autoDensity = !!n.autoDensity, i.preserveDrawingBuffer = n.preserveDrawingBuffer, i.clearBeforeRender = n.clearBeforeRender, i._backgroundColor = 0, i._backgroundColorRgba = [0, 0, 0, 1], i._backgroundColorString = "#000000", i.backgroundColor = n.backgroundColor || i._backgroundColor, i.backgroundAlpha = n.backgroundAlpha, n.transparent !== void 0 && (ce("6.0.0", "Option transparent is deprecated, please use backgroundAlpha instead."), i.useContextAlpha = n.transparent, i.backgroundAlpha = n.transparent ? 0 : 1), i._lastObjectRendered = null, i.plugins = {}, i;
    }
    return t.prototype.initPlugins = function(e) {
      for (var n in e)
        this.plugins[n] = new e[n](this);
    }, Object.defineProperty(t.prototype, "width", {
      /**
       * Same as view.width, actual number of pixels in the canvas by horizontal.
       * @member {number}
       * @readonly
       * @default 800
       */
      get: function() {
        return this.view.width;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "height", {
      /**
       * Same as view.height, actual number of pixels in the canvas by vertical.
       * @member {number}
       * @readonly
       * @default 600
       */
      get: function() {
        return this.view.height;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.resize = function(e, n) {
      this.view.width = Math.round(e * this.resolution), this.view.height = Math.round(n * this.resolution);
      var i = this.view.width / this.resolution, o = this.view.height / this.resolution;
      this.screen.width = i, this.screen.height = o, this.autoDensity && (this.view.style.width = i + "px", this.view.style.height = o + "px"), this.emit("resize", i, o);
    }, t.prototype.generateTexture = function(e, n, i, o) {
      n === void 0 && (n = {}), typeof n == "number" && (ce("6.1.0", "generateTexture options (scaleMode, resolution, region) are now object options."), n = { scaleMode: n, resolution: i, region: o });
      var a = n.region, s = Ey(n, ["region"]);
      o = a || e.getLocalBounds(null, !0), o.width === 0 && (o.width = 1), o.height === 0 && (o.height = 1);
      var h = fr.create(oa({ width: o.width, height: o.height }, s));
      return Eo.tx = -o.x, Eo.ty = -o.y, this.render(e, {
        renderTexture: h,
        clear: !1,
        transform: Eo,
        skipUpdateTransform: !!e.parent
      }), h;
    }, t.prototype.destroy = function(e) {
      for (var n in this.plugins)
        this.plugins[n].destroy(), this.plugins[n] = null;
      e && this.view.parentNode && this.view.parentNode.removeChild(this.view);
      var i = this;
      i.plugins = null, i.type = vn.UNKNOWN, i.view = null, i.screen = null, i._tempDisplayObjectParent = null, i.options = null, this._backgroundColorRgba = null, this._backgroundColorString = null, this._lastObjectRendered = null;
    }, Object.defineProperty(t.prototype, "backgroundColor", {
      /**
       * The background color to fill if not transparent
       * @member {number}
       */
      get: function() {
        return this._backgroundColor;
      },
      set: function(e) {
        this._backgroundColor = e, this._backgroundColorString = sl(e), jr(e, this._backgroundColorRgba);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "backgroundAlpha", {
      /**
       * The background color alpha. Setting this to 0 will make the canvas transparent.
       * @member {number}
       */
      get: function() {
        return this._backgroundColorRgba[3];
      },
      set: function(e) {
        this._backgroundColorRgba[3] = e;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Sn)
), Xg = (
  /** @class */
  function() {
    function r(t) {
      this.buffer = t || null, this.updateID = -1, this.byteLength = -1, this.refCount = 0;
    }
    return r;
  }()
), jg = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t, this.managedBuffers = {}, this.boundBufferBases = {};
    }
    return r.prototype.destroy = function() {
      this.renderer = null;
    }, r.prototype.contextChange = function() {
      this.disposeAll(!0), this.gl = this.renderer.gl, this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    }, r.prototype.bind = function(t) {
      var e = this, n = e.gl, i = e.CONTEXT_UID, o = t._glBuffers[i] || this.createGLBuffer(t);
      n.bindBuffer(t.type, o.buffer);
    }, r.prototype.bindBufferBase = function(t, e) {
      var n = this, i = n.gl, o = n.CONTEXT_UID;
      if (this.boundBufferBases[e] !== t) {
        var a = t._glBuffers[o] || this.createGLBuffer(t);
        this.boundBufferBases[e] = t, i.bindBufferBase(i.UNIFORM_BUFFER, e, a.buffer);
      }
    }, r.prototype.bindBufferRange = function(t, e, n) {
      var i = this, o = i.gl, a = i.CONTEXT_UID;
      n = n || 0;
      var s = t._glBuffers[a] || this.createGLBuffer(t);
      o.bindBufferRange(o.UNIFORM_BUFFER, e || 0, s.buffer, n * 256, 256);
    }, r.prototype.update = function(t) {
      var e = this, n = e.gl, i = e.CONTEXT_UID, o = t._glBuffers[i];
      if (t._updateID !== o.updateID)
        if (o.updateID = t._updateID, n.bindBuffer(t.type, o.buffer), o.byteLength >= t.data.byteLength)
          n.bufferSubData(t.type, 0, t.data);
        else {
          var a = t.static ? n.STATIC_DRAW : n.DYNAMIC_DRAW;
          o.byteLength = t.data.byteLength, n.bufferData(t.type, t.data, a);
        }
    }, r.prototype.dispose = function(t, e) {
      if (this.managedBuffers[t.id]) {
        delete this.managedBuffers[t.id];
        var n = t._glBuffers[this.CONTEXT_UID], i = this.gl;
        t.disposeRunner.remove(this), n && (e || i.deleteBuffer(n.buffer), delete t._glBuffers[this.CONTEXT_UID]);
      }
    }, r.prototype.disposeAll = function(t) {
      for (var e = Object.keys(this.managedBuffers), n = 0; n < e.length; n++)
        this.dispose(this.managedBuffers[e[n]], t);
    }, r.prototype.createGLBuffer = function(t) {
      var e = this, n = e.CONTEXT_UID, i = e.gl;
      return t._glBuffers[n] = new Xg(i.createBuffer()), this.managedBuffers[t.id] = t, t.disposeRunner.add(this), t._glBuffers[n];
    }, r;
  }()
), Pl = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e) {
      var n = r.call(this, vn.WEBGL, e) || this;
      return e = n.options, n.gl = null, n.CONTEXT_UID = 0, n.runners = {
        destroy: new kt("destroy"),
        contextChange: new kt("contextChange"),
        reset: new kt("reset"),
        update: new kt("update"),
        postrender: new kt("postrender"),
        prerender: new kt("prerender"),
        resize: new kt("resize")
      }, n.runners.contextChange.add(n), n.globalUniforms = new hr({
        projectionMatrix: new Dt()
      }, !0), n.addSystem(pg, "mask").addSystem(jy, "context").addSystem(Lg, "state").addSystem(Rg, "shader").addSystem(kg, "texture").addSystem(jg, "buffer").addSystem(Wy, "geometry").addSystem(zy, "framebuffer").addSystem(vg, "scissor").addSystem(_g, "stencil").addSystem(mg, "projection").addSystem(Ug, "textureGC").addSystem(Hy, "filter").addSystem(yg, "renderTexture").addSystem(Xy, "batch"), n.initPlugins(t.__plugins), n.multisample = void 0, e.context ? n.context.initFromContext(e.context) : n.context.initFromOptions({
        alpha: !!n.useContextAlpha,
        antialias: e.antialias,
        premultipliedAlpha: n.useContextAlpha && n.useContextAlpha !== "notMultiplied",
        stencil: !0,
        preserveDrawingBuffer: e.preserveDrawingBuffer,
        powerPreference: n.options.powerPreference
      }), n.renderingToScreen = !0, bv(n.context.webGLVersion === 2 ? "WebGL 2" : "WebGL 1"), n.resize(n.options.width, n.options.height), n;
    }
    return t.create = function(e) {
      if (xv())
        return new t(e);
      throw new Error('WebGL unsupported in this browser, use "pixi.js-legacy" for fallback canvas2d support.');
    }, t.prototype.contextChange = function() {
      var e = this.gl, n;
      if (this.context.webGLVersion === 1) {
        var i = e.getParameter(e.FRAMEBUFFER_BINDING);
        e.bindFramebuffer(e.FRAMEBUFFER, null), n = e.getParameter(e.SAMPLES), e.bindFramebuffer(e.FRAMEBUFFER, i);
      } else {
        var i = e.getParameter(e.DRAW_FRAMEBUFFER_BINDING);
        e.bindFramebuffer(e.DRAW_FRAMEBUFFER, null), n = e.getParameter(e.SAMPLES), e.bindFramebuffer(e.DRAW_FRAMEBUFFER, i);
      }
      n >= wt.HIGH ? this.multisample = wt.HIGH : n >= wt.MEDIUM ? this.multisample = wt.MEDIUM : n >= wt.LOW ? this.multisample = wt.LOW : this.multisample = wt.NONE;
    }, t.prototype.addSystem = function(e, n) {
      var i = new e(this);
      if (this[n])
        throw new Error('Whoops! The name "' + n + '" is already in use');
      this[n] = i;
      for (var o in this.runners)
        this.runners[o].add(i);
      return this;
    }, t.prototype.render = function(e, n) {
      var i, o, a, s;
      if (n && (n instanceof fr ? (ce("6.0.0", "Renderer#render arguments changed, use options instead."), i = n, o = arguments[2], a = arguments[3], s = arguments[4]) : (i = n.renderTexture, o = n.clear, a = n.transform, s = n.skipUpdateTransform)), this.renderingToScreen = !i, this.runners.prerender.emit(), this.emit("prerender"), this.projection.transform = a, !this.context.isLost) {
        if (i || (this._lastObjectRendered = e), !s) {
          var h = e.enableTempParent();
          e.updateTransform(), e.disableTempParent(h);
        }
        this.renderTexture.bind(i), this.batch.currentRenderer.start(), (o !== void 0 ? o : this.clearBeforeRender) && this.renderTexture.clear(), e.render(this), this.batch.currentRenderer.flush(), i && i.baseTexture.update(), this.runners.postrender.emit(), this.projection.transform = null, this.emit("postrender");
      }
    }, t.prototype.generateTexture = function(e, n, i, o) {
      n === void 0 && (n = {});
      var a = r.prototype.generateTexture.call(this, e, n, i, o);
      return this.framebuffer.blit(), a;
    }, t.prototype.resize = function(e, n) {
      r.prototype.resize.call(this, e, n), this.runners.resize.emit(this.screen.height, this.screen.width);
    }, t.prototype.reset = function() {
      return this.runners.reset.emit(), this;
    }, t.prototype.clear = function() {
      this.renderTexture.bind(), this.renderTexture.clear();
    }, t.prototype.destroy = function(e) {
      this.runners.destroy.emit();
      for (var n in this.runners)
        this.runners[n].destroy();
      r.prototype.destroy.call(this, e), this.gl = null;
    }, Object.defineProperty(t.prototype, "extract", {
      /**
       * Please use `plugins.extract` instead.
       * @member {PIXI.Extract} extract
       * @deprecated since 6.0.0
       * @readonly
       */
      get: function() {
        return ce("6.0.0", "Renderer#extract has been deprecated, please use Renderer#plugins.extract instead."), this.plugins.extract;
      },
      enumerable: !1,
      configurable: !0
    }), t.registerPlugin = function(e, n) {
      ce("6.5.0", "Renderer.registerPlugin() has been deprecated, please use extensions.add() instead."), Me.add({
        name: e,
        type: mt.RendererPlugin,
        ref: n
      });
    }, t.__plugins = {}, t;
  }(Hg)
);
Me.handleByMap(mt.RendererPlugin, Pl.__plugins);
function Ol(r) {
  return Pl.create(r);
}
var Yg = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, Vg = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`, zg = Yg, Rl = Vg, sa = (
  /** @class */
  function() {
    function r() {
      this.texArray = null, this.blend = 0, this.type = le.TRIANGLES, this.start = 0, this.size = 0, this.data = null;
    }
    return r;
  }()
), ha = (
  /** @class */
  function() {
    function r() {
      this.elements = [], this.ids = [], this.count = 0;
    }
    return r.prototype.clear = function() {
      for (var t = 0; t < this.count; t++)
        this.elements[t] = null;
      this.count = 0;
    }, r;
  }()
), ua = (
  /** @class */
  function() {
    function r(t) {
      typeof t == "number" ? this.rawBinaryData = new ArrayBuffer(t) : t instanceof Uint8Array ? this.rawBinaryData = t.buffer : this.rawBinaryData = t, this.uint32View = new Uint32Array(this.rawBinaryData), this.float32View = new Float32Array(this.rawBinaryData);
    }
    return Object.defineProperty(r.prototype, "int8View", {
      /** View on the raw binary data as a `Int8Array`. */
      get: function() {
        return this._int8View || (this._int8View = new Int8Array(this.rawBinaryData)), this._int8View;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "uint8View", {
      /** View on the raw binary data as a `Uint8Array`. */
      get: function() {
        return this._uint8View || (this._uint8View = new Uint8Array(this.rawBinaryData)), this._uint8View;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "int16View", {
      /**  View on the raw binary data as a `Int16Array`. */
      get: function() {
        return this._int16View || (this._int16View = new Int16Array(this.rawBinaryData)), this._int16View;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "uint16View", {
      /** View on the raw binary data as a `Uint16Array`. */
      get: function() {
        return this._uint16View || (this._uint16View = new Uint16Array(this.rawBinaryData)), this._uint16View;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "int32View", {
      /** View on the raw binary data as a `Int32Array`. */
      get: function() {
        return this._int32View || (this._int32View = new Int32Array(this.rawBinaryData)), this._int32View;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.view = function(t) {
      return this[t + "View"];
    }, r.prototype.destroy = function() {
      this.rawBinaryData = null, this._int8View = null, this._uint8View = null, this._int16View = null, this._uint16View = null, this._int32View = null, this.uint32View = null, this.float32View = null;
    }, r.sizeOf = function(t) {
      switch (t) {
        case "int8":
        case "uint8":
          return 1;
        case "int16":
        case "uint16":
          return 2;
        case "int32":
        case "uint32":
        case "float32":
          return 4;
        default:
          throw new Error(t + " isn't a valid view type");
      }
    }, r;
  }()
), Wg = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e) {
      var n = r.call(this, e) || this;
      return n.shaderGenerator = null, n.geometryClass = null, n.vertexSize = null, n.state = dr.for2d(), n.size = G.SPRITE_BATCH_SIZE * 4, n._vertexCount = 0, n._indexCount = 0, n._bufferedElements = [], n._bufferedTextures = [], n._bufferSize = 0, n._shader = null, n._packedGeometries = [], n._packedGeometryPoolSize = 2, n._flushId = 0, n._aBuffers = {}, n._iBuffers = {}, n.MAX_TEXTURES = 1, n.renderer.on("prerender", n.onPrerender, n), e.runners.contextChange.add(n), n._dcIndex = 0, n._aIndex = 0, n._iIndex = 0, n._attributeBuffer = null, n._indexBuffer = null, n._tempBoundTextures = [], n;
    }
    return t.prototype.contextChange = function() {
      var e = this.renderer.gl;
      G.PREFER_ENV === Ie.WEBGL_LEGACY ? this.MAX_TEXTURES = 1 : (this.MAX_TEXTURES = Math.min(e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS), G.SPRITE_MAX_TEXTURES), this.MAX_TEXTURES = ig(this.MAX_TEXTURES, e)), this._shader = this.shaderGenerator.generateShader(this.MAX_TEXTURES);
      for (var n = 0; n < this._packedGeometryPoolSize; n++)
        this._packedGeometries[n] = new this.geometryClass();
      this.initFlushBuffers();
    }, t.prototype.initFlushBuffers = function() {
      for (var e = t._drawCallPool, n = t._textureArrayPool, i = this.size / 4, o = Math.floor(i / this.MAX_TEXTURES) + 1; e.length < i; )
        e.push(new sa());
      for (; n.length < o; )
        n.push(new ha());
      for (var a = 0; a < this.MAX_TEXTURES; a++)
        this._tempBoundTextures[a] = null;
    }, t.prototype.onPrerender = function() {
      this._flushId = 0;
    }, t.prototype.render = function(e) {
      e._texture.valid && (this._vertexCount + e.vertexData.length / 2 > this.size && this.flush(), this._vertexCount += e.vertexData.length / 2, this._indexCount += e.indices.length, this._bufferedTextures[this._bufferSize] = e._texture.baseTexture, this._bufferedElements[this._bufferSize++] = e);
    }, t.prototype.buildTexturesAndDrawCalls = function() {
      var e = this, n = e._bufferedTextures, i = e.MAX_TEXTURES, o = t._textureArrayPool, a = this.renderer.batch, s = this._tempBoundTextures, h = this.renderer.textureGC.count, u = ++ht._globalBatch, l = 0, f = o[0], c = 0;
      a.copyBoundTextures(s, i);
      for (var d = 0; d < this._bufferSize; ++d) {
        var p = n[d];
        n[d] = null, p._batchEnabled !== u && (f.count >= i && (a.boundArray(f, s, u, i), this.buildDrawCalls(f, c, d), c = d, f = o[++l], ++u), p._batchEnabled = u, p.touched = h, f.elements[f.count++] = p);
      }
      f.count > 0 && (a.boundArray(f, s, u, i), this.buildDrawCalls(f, c, this._bufferSize), ++l, ++u);
      for (var d = 0; d < s.length; d++)
        s[d] = null;
      ht._globalBatch = u;
    }, t.prototype.buildDrawCalls = function(e, n, i) {
      var o = this, a = o._bufferedElements, s = o._attributeBuffer, h = o._indexBuffer, u = o.vertexSize, l = t._drawCallPool, f = this._dcIndex, c = this._aIndex, d = this._iIndex, p = l[f];
      p.start = this._iIndex, p.texArray = e;
      for (var v = n; v < i; ++v) {
        var _ = a[v], m = _._texture.baseTexture, y = hl[m.alphaMode ? 1 : 0][_.blendMode];
        a[v] = null, n < v && p.blend !== y && (p.size = d - p.start, n = v, p = l[++f], p.texArray = e, p.start = d), this.packInterleavedGeometry(_, s, h, c, d), c += _.vertexData.length / 2 * u, d += _.indices.length, p.blend = y;
      }
      n < i && (p.size = d - p.start, ++f), this._dcIndex = f, this._aIndex = c, this._iIndex = d;
    }, t.prototype.bindAndClearTexArray = function(e) {
      for (var n = this.renderer.texture, i = 0; i < e.count; i++)
        n.bind(e.elements[i], e.ids[i]), e.elements[i] = null;
      e.count = 0;
    }, t.prototype.updateGeometry = function() {
      var e = this, n = e._packedGeometries, i = e._attributeBuffer, o = e._indexBuffer;
      G.CAN_UPLOAD_SAME_BUFFER ? (n[this._flushId]._buffer.update(i.rawBinaryData), n[this._flushId]._indexBuffer.update(o), this.renderer.geometry.updateBuffers()) : (this._packedGeometryPoolSize <= this._flushId && (this._packedGeometryPoolSize++, n[this._flushId] = new this.geometryClass()), n[this._flushId]._buffer.update(i.rawBinaryData), n[this._flushId]._indexBuffer.update(o), this.renderer.geometry.bind(n[this._flushId]), this.renderer.geometry.updateBuffers(), this._flushId++);
    }, t.prototype.drawBatches = function() {
      for (var e = this._dcIndex, n = this.renderer, i = n.gl, o = n.state, a = t._drawCallPool, s = null, h = 0; h < e; h++) {
        var u = a[h], l = u.texArray, f = u.type, c = u.size, d = u.start, p = u.blend;
        s !== l && (s = l, this.bindAndClearTexArray(l)), this.state.blendMode = p, o.set(this.state), i.drawElements(f, c, i.UNSIGNED_SHORT, d * 2);
      }
    }, t.prototype.flush = function() {
      this._vertexCount !== 0 && (this._attributeBuffer = this.getAttributeBuffer(this._vertexCount), this._indexBuffer = this.getIndexBuffer(this._indexCount), this._aIndex = 0, this._iIndex = 0, this._dcIndex = 0, this.buildTexturesAndDrawCalls(), this.updateGeometry(), this.drawBatches(), this._bufferSize = 0, this._vertexCount = 0, this._indexCount = 0);
    }, t.prototype.start = function() {
      this.renderer.state.set(this.state), this.renderer.texture.ensureSamplerType(this.MAX_TEXTURES), this.renderer.shader.bind(this._shader), G.CAN_UPLOAD_SAME_BUFFER && this.renderer.geometry.bind(this._packedGeometries[this._flushId]);
    }, t.prototype.stop = function() {
      this.flush();
    }, t.prototype.destroy = function() {
      for (var e = 0; e < this._packedGeometryPoolSize; e++)
        this._packedGeometries[e] && this._packedGeometries[e].destroy();
      this.renderer.off("prerender", this.onPrerender, this), this._aBuffers = null, this._iBuffers = null, this._packedGeometries = null, this._attributeBuffer = null, this._indexBuffer = null, this._shader && (this._shader.destroy(), this._shader = null), r.prototype.destroy.call(this);
    }, t.prototype.getAttributeBuffer = function(e) {
      var n = Si(Math.ceil(e / 8)), i = _h(n), o = n * 8;
      this._aBuffers.length <= i && (this._iBuffers.length = i + 1);
      var a = this._aBuffers[o];
      return a || (this._aBuffers[o] = a = new ua(o * this.vertexSize * 4)), a;
    }, t.prototype.getIndexBuffer = function(e) {
      var n = Si(Math.ceil(e / 12)), i = _h(n), o = n * 12;
      this._iBuffers.length <= i && (this._iBuffers.length = i + 1);
      var a = this._iBuffers[i];
      return a || (this._iBuffers[i] = a = new Uint16Array(o)), a;
    }, t.prototype.packInterleavedGeometry = function(e, n, i, o, a) {
      for (var s = n.uint32View, h = n.float32View, u = o / this.vertexSize, l = e.uvs, f = e.indices, c = e.vertexData, d = e._texture.baseTexture._batchLocation, p = Math.min(e.worldAlpha, 1), v = p < 1 && e._texture.baseTexture.alphaMode ? Za(e._tintRGB, p) : e._tintRGB + (p * 255 << 24), _ = 0; _ < c.length; _ += 2)
        h[o++] = c[_], h[o++] = c[_ + 1], h[o++] = l[_], h[o++] = l[_ + 1], s[o++] = v, h[o++] = d;
      for (var _ = 0; _ < f.length; _++)
        i[a++] = u + f[_];
    }, t._drawCallPool = [], t._textureArrayPool = [], t;
  }(Gi)
), $g = (
  /** @class */
  function() {
    function r(t, e) {
      if (this.vertexSrc = t, this.fragTemplate = e, this.programCache = {}, this.defaultGroupCache = {}, e.indexOf("%count%") < 0)
        throw new Error('Fragment template must contain "%count%".');
      if (e.indexOf("%forloop%") < 0)
        throw new Error('Fragment template must contain "%forloop%".');
    }
    return r.prototype.generateShader = function(t) {
      if (!this.programCache[t]) {
        for (var e = new Int32Array(t), n = 0; n < t; n++)
          e[n] = n;
        this.defaultGroupCache[t] = hr.from({ uSamplers: e }, !0);
        var i = this.fragTemplate;
        i = i.replace(/%count%/gi, "" + t), i = i.replace(/%forloop%/gi, this.generateSampleSrc(t)), this.programCache[t] = new Rn(this.vertexSrc, i);
      }
      var o = {
        tint: new Float32Array([1, 1, 1, 1]),
        translationMatrix: new Dt(),
        default: this.defaultGroupCache[t]
      };
      return new Ue(this.programCache[t], o);
    }, r.prototype.generateSampleSrc = function(t) {
      var e = "";
      e += `
`, e += `
`;
      for (var n = 0; n < t; n++)
        n > 0 && (e += `
else `), n < t - 1 && (e += "if(vTextureId < " + n + ".5)"), e += `
{`, e += `
	color = texture2D(uSamplers[` + n + "], vTextureCoord);", e += `
}`;
      return e += `
`, e += `
`, e;
    }, r;
  }()
), Il = (
  /** @class */
  function(r) {
    xt(t, r);
    function t(e) {
      e === void 0 && (e = !1);
      var n = r.call(this) || this;
      return n._buffer = new Mt(null, e, !1), n._indexBuffer = new Mt(null, e, !0), n.addAttribute("aVertexPosition", n._buffer, 2, !1, X.FLOAT).addAttribute("aTextureCoord", n._buffer, 2, !1, X.FLOAT).addAttribute("aColor", n._buffer, 4, !0, X.UNSIGNED_BYTE).addAttribute("aTextureId", n._buffer, 1, !0, X.FLOAT).addIndex(n._indexBuffer), n;
    }
    return t;
  }(On)
), Mh = `precision highp float;
attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;
attribute float aTextureId;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform vec4 tint;

varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;

void main(void){
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vTextureId = aTextureId;
    vColor = aColor * tint;
}
`, Dh = `varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;
uniform sampler2D uSamplers[%count%];

void main(void){
    vec4 color;
    %forloop%
    gl_FragColor = color * vColor;
}
`, qg = (
  /** @class */
  function() {
    function r() {
    }
    return r.create = function(t) {
      var e = Object.assign({
        vertex: Mh,
        fragment: Dh,
        geometryClass: Il,
        vertexSize: 6
      }, t), n = e.vertex, i = e.fragment, o = e.vertexSize, a = e.geometryClass;
      return (
        /** @class */
        function(s) {
          xt(h, s);
          function h(u) {
            var l = s.call(this, u) || this;
            return l.shaderGenerator = new $g(n, i), l.geometryClass = a, l.vertexSize = o, l;
          }
          return h;
        }(Wg)
      );
    }, Object.defineProperty(r, "defaultVertexSrc", {
      /**
       * The default vertex shader source
       * @readonly
       */
      get: function() {
        return Mh;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r, "defaultFragmentTemplate", {
      /**
       * The default fragment shader source
       * @readonly
       */
      get: function() {
        return Dh;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }()
), Cl = qg.create();
Object.assign(Cl, {
  extension: {
    name: "batch",
    type: mt.RendererPlugin
  }
});
/*!
 * @pixi/accessibility - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/accessibility is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var Kg = {
  /**
   *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
   *   shadow div with attributes set
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */
  accessible: !1,
  /**
   * Sets the title attribute of the shadow div
   * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
   * @member {?string}
   * @memberof PIXI.DisplayObject#
   */
  accessibleTitle: null,
  /**
   * Sets the aria-label attribute of the shadow div
   * @member {string}
   * @memberof PIXI.DisplayObject#
   */
  accessibleHint: null,
  /**
   * @member {number}
   * @memberof PIXI.DisplayObject#
   * @private
   * @todo Needs docs.
   */
  tabIndex: 0,
  /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */
  _accessibleActive: !1,
  /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */
  _accessibleDiv: null,
  /**
   * Specify the type of div the accessible layer is. Screen readers treat the element differently
   * depending on this type. Defaults to button.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'button'
   */
  accessibleType: "button",
  /**
   * Specify the pointer-events the accessible div will use
   * Defaults to auto.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'auto'
   */
  accessiblePointerEvents: "auto",
  /**
   * Setting to false will prevent any children inside this container to
   * be accessible. Defaults to true.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @default true
   */
  accessibleChildren: !0,
  renderId: -1
};
Rt.mixin(Kg);
var Zg = 9, Kn = 100, Jg = 0, Qg = 0, Fh = 2, Bh = 1, t0 = -1e3, e0 = -1e3, r0 = 2, n0 = (
  /** @class */
  function() {
    function r(t) {
      this.debug = !1, this._isActive = !1, this._isMobileAccessibility = !1, this.pool = [], this.renderId = 0, this.children = [], this.androidUpdateCount = 0, this.androidUpdateFrequency = 500, this._hookDiv = null, (ge.tablet || ge.phone) && this.createTouchHook();
      var e = document.createElement("div");
      e.style.width = Kn + "px", e.style.height = Kn + "px", e.style.position = "absolute", e.style.top = Jg + "px", e.style.left = Qg + "px", e.style.zIndex = Fh.toString(), this.div = e, this.renderer = t, this._onKeyDown = this._onKeyDown.bind(this), this._onMouseMove = this._onMouseMove.bind(this), globalThis.addEventListener("keydown", this._onKeyDown, !1);
    }
    return Object.defineProperty(r.prototype, "isActive", {
      /**
       * Value of `true` if accessibility is currently active and accessibility layers are showing.
       * @member {boolean}
       * @readonly
       */
      get: function() {
        return this._isActive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "isMobileAccessibility", {
      /**
       * Value of `true` if accessibility is enabled for touch devices.
       * @member {boolean}
       * @readonly
       */
      get: function() {
        return this._isMobileAccessibility;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.createTouchHook = function() {
      var t = this, e = document.createElement("button");
      e.style.width = Bh + "px", e.style.height = Bh + "px", e.style.position = "absolute", e.style.top = t0 + "px", e.style.left = e0 + "px", e.style.zIndex = r0.toString(), e.style.backgroundColor = "#FF0000", e.title = "select to enable accessibility for this content", e.addEventListener("focus", function() {
        t._isMobileAccessibility = !0, t.activate(), t.destroyTouchHook();
      }), document.body.appendChild(e), this._hookDiv = e;
    }, r.prototype.destroyTouchHook = function() {
      this._hookDiv && (document.body.removeChild(this._hookDiv), this._hookDiv = null);
    }, r.prototype.activate = function() {
      var t;
      this._isActive || (this._isActive = !0, globalThis.document.addEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown, !1), this.renderer.on("postrender", this.update, this), (t = this.renderer.view.parentNode) === null || t === void 0 || t.appendChild(this.div));
    }, r.prototype.deactivate = function() {
      var t;
      !this._isActive || this._isMobileAccessibility || (this._isActive = !1, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.addEventListener("keydown", this._onKeyDown, !1), this.renderer.off("postrender", this.update), (t = this.div.parentNode) === null || t === void 0 || t.removeChild(this.div));
    }, r.prototype.updateAccessibleObjects = function(t) {
      if (!(!t.visible || !t.accessibleChildren)) {
        t.accessible && t.interactive && (t._accessibleActive || this.addChild(t), t.renderId = this.renderId);
        var e = t.children;
        if (e)
          for (var n = 0; n < e.length; n++)
            this.updateAccessibleObjects(e[n]);
      }
    }, r.prototype.update = function() {
      var t = performance.now();
      if (!(ge.android.device && t < this.androidUpdateCount) && (this.androidUpdateCount = t + this.androidUpdateFrequency, !!this.renderer.renderingToScreen)) {
        this.renderer._lastObjectRendered && this.updateAccessibleObjects(this.renderer._lastObjectRendered);
        var e = this.renderer.view.getBoundingClientRect(), n = e.left, i = e.top, o = e.width, a = e.height, s = this.renderer, h = s.width, u = s.height, l = s.resolution, f = o / h * l, c = a / u * l, d = this.div;
        d.style.left = n + "px", d.style.top = i + "px", d.style.width = h + "px", d.style.height = u + "px";
        for (var p = 0; p < this.children.length; p++) {
          var v = this.children[p];
          if (v.renderId !== this.renderId)
            v._accessibleActive = !1, Nr(this.children, p, 1), this.div.removeChild(v._accessibleDiv), this.pool.push(v._accessibleDiv), v._accessibleDiv = null, p--;
          else {
            d = v._accessibleDiv;
            var _ = v.hitArea, m = v.worldTransform;
            v.hitArea ? (d.style.left = (m.tx + _.x * m.a) * f + "px", d.style.top = (m.ty + _.y * m.d) * c + "px", d.style.width = _.width * m.a * f + "px", d.style.height = _.height * m.d * c + "px") : (_ = v.getBounds(), this.capHitArea(_), d.style.left = _.x * f + "px", d.style.top = _.y * c + "px", d.style.width = _.width * f + "px", d.style.height = _.height * c + "px", d.title !== v.accessibleTitle && v.accessibleTitle !== null && (d.title = v.accessibleTitle), d.getAttribute("aria-label") !== v.accessibleHint && v.accessibleHint !== null && d.setAttribute("aria-label", v.accessibleHint)), (v.accessibleTitle !== d.title || v.tabIndex !== d.tabIndex) && (d.title = v.accessibleTitle, d.tabIndex = v.tabIndex, this.debug && this.updateDebugHTML(d));
          }
        }
        this.renderId++;
      }
    }, r.prototype.updateDebugHTML = function(t) {
      t.innerHTML = "type: " + t.type + "</br> title : " + t.title + "</br> tabIndex: " + t.tabIndex;
    }, r.prototype.capHitArea = function(t) {
      t.x < 0 && (t.width += t.x, t.x = 0), t.y < 0 && (t.height += t.y, t.y = 0);
      var e = this.renderer, n = e.width, i = e.height;
      t.x + t.width > n && (t.width = n - t.x), t.y + t.height > i && (t.height = i - t.y);
    }, r.prototype.addChild = function(t) {
      var e = this.pool.pop();
      e || (e = document.createElement("button"), e.style.width = Kn + "px", e.style.height = Kn + "px", e.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent", e.style.position = "absolute", e.style.zIndex = Fh.toString(), e.style.borderStyle = "none", navigator.userAgent.toLowerCase().indexOf("chrome") > -1 ? e.setAttribute("aria-live", "off") : e.setAttribute("aria-live", "polite"), navigator.userAgent.match(/rv:.*Gecko\//) ? e.setAttribute("aria-relevant", "additions") : e.setAttribute("aria-relevant", "text"), e.addEventListener("click", this._onClick.bind(this)), e.addEventListener("focus", this._onFocus.bind(this)), e.addEventListener("focusout", this._onFocusOut.bind(this))), e.style.pointerEvents = t.accessiblePointerEvents, e.type = t.accessibleType, t.accessibleTitle && t.accessibleTitle !== null ? e.title = t.accessibleTitle : (!t.accessibleHint || t.accessibleHint === null) && (e.title = "displayObject " + t.tabIndex), t.accessibleHint && t.accessibleHint !== null && e.setAttribute("aria-label", t.accessibleHint), this.debug && this.updateDebugHTML(e), t._accessibleActive = !0, t._accessibleDiv = e, e.displayObject = t, this.children.push(t), this.div.appendChild(t._accessibleDiv), t._accessibleDiv.tabIndex = t.tabIndex;
    }, r.prototype._onClick = function(t) {
      var e = this.renderer.plugins.interaction, n = t.target.displayObject, i = e.eventData;
      e.dispatchEvent(n, "click", i), e.dispatchEvent(n, "pointertap", i), e.dispatchEvent(n, "tap", i);
    }, r.prototype._onFocus = function(t) {
      t.target.getAttribute("aria-live") || t.target.setAttribute("aria-live", "assertive");
      var e = this.renderer.plugins.interaction, n = t.target.displayObject, i = e.eventData;
      e.dispatchEvent(n, "mouseover", i);
    }, r.prototype._onFocusOut = function(t) {
      t.target.getAttribute("aria-live") || t.target.setAttribute("aria-live", "polite");
      var e = this.renderer.plugins.interaction, n = t.target.displayObject, i = e.eventData;
      e.dispatchEvent(n, "mouseout", i);
    }, r.prototype._onKeyDown = function(t) {
      t.keyCode === Zg && this.activate();
    }, r.prototype._onMouseMove = function(t) {
      t.movementX === 0 && t.movementY === 0 || this.deactivate();
    }, r.prototype.destroy = function() {
      this.destroyTouchHook(), this.div = null, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown), this.pool = null, this.children = null, this.renderer = null;
    }, r.extension = {
      name: "accessibility",
      type: [
        mt.RendererPlugin,
        mt.CanvasRendererPlugin
      ]
    }, r;
  }()
);
/*!
 * @pixi/interaction - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/interaction is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var Nh = (
  /** @class */
  function() {
    function r() {
      this.pressure = 0, this.rotationAngle = 0, this.twist = 0, this.tangentialPressure = 0, this.global = new Et(), this.target = null, this.originalEvent = null, this.identifier = null, this.isPrimary = !1, this.button = 0, this.buttons = 0, this.width = 0, this.height = 0, this.tiltX = 0, this.tiltY = 0, this.pointerType = null, this.pressure = 0, this.rotationAngle = 0, this.twist = 0, this.tangentialPressure = 0;
    }
    return Object.defineProperty(r.prototype, "pointerId", {
      /**
       * The unique identifier of the pointer. It will be the same as `identifier`.
       * @readonly
       * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerId
       */
      get: function() {
        return this.identifier;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.getLocalPosition = function(t, e, n) {
      return t.worldTransform.applyInverse(n || this.global, e);
    }, r.prototype.copyEvent = function(t) {
      "isPrimary" in t && t.isPrimary && (this.isPrimary = !0), this.button = "button" in t && t.button;
      var e = "buttons" in t && t.buttons;
      this.buttons = Number.isInteger(e) ? e : "which" in t && t.which, this.width = "width" in t && t.width, this.height = "height" in t && t.height, this.tiltX = "tiltX" in t && t.tiltX, this.tiltY = "tiltY" in t && t.tiltY, this.pointerType = "pointerType" in t && t.pointerType, this.pressure = "pressure" in t && t.pressure, this.rotationAngle = "rotationAngle" in t && t.rotationAngle, this.twist = "twist" in t && t.twist || 0, this.tangentialPressure = "tangentialPressure" in t && t.tangentialPressure || 0;
    }, r.prototype.reset = function() {
      this.isPrimary = !1;
    }, r;
  }()
);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var la = function(r, t) {
  return la = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, la(r, t);
};
function i0(r, t) {
  la(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var o0 = (
  /** @class */
  function() {
    function r() {
      this.stopped = !1, this.stopsPropagatingAt = null, this.stopPropagationHint = !1, this.target = null, this.currentTarget = null, this.type = null, this.data = null;
    }
    return r.prototype.stopPropagation = function() {
      this.stopped = !0, this.stopPropagationHint = !0, this.stopsPropagatingAt = this.currentTarget;
    }, r.prototype.reset = function() {
      this.stopped = !1, this.stopsPropagatingAt = null, this.stopPropagationHint = !1, this.currentTarget = null, this.target = null;
    }, r;
  }()
), wo = (
  /** @class */
  function() {
    function r(t) {
      this._pointerId = t, this._flags = r.FLAGS.NONE;
    }
    return r.prototype._doSet = function(t, e) {
      e ? this._flags = this._flags | t : this._flags = this._flags & ~t;
    }, Object.defineProperty(r.prototype, "pointerId", {
      /**
       * Unique pointer id of the event
       * @readonly
       * @private
       * @member {number}
       */
      get: function() {
        return this._pointerId;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "flags", {
      /**
       * State of the tracking data, expressed as bit flags
       * @private
       * @member {number}
       */
      get: function() {
        return this._flags;
      },
      set: function(t) {
        this._flags = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "none", {
      /**
       * Is the tracked event inactive (not over or down)?
       * @private
       * @member {number}
       */
      get: function() {
        return this._flags === r.FLAGS.NONE;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "over", {
      /**
       * Is the tracked event over the DisplayObject?
       * @private
       * @member {boolean}
       */
      get: function() {
        return (this._flags & r.FLAGS.OVER) !== 0;
      },
      set: function(t) {
        this._doSet(r.FLAGS.OVER, t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "rightDown", {
      /**
       * Did the right mouse button come down in the DisplayObject?
       * @private
       * @member {boolean}
       */
      get: function() {
        return (this._flags & r.FLAGS.RIGHT_DOWN) !== 0;
      },
      set: function(t) {
        this._doSet(r.FLAGS.RIGHT_DOWN, t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "leftDown", {
      /**
       * Did the left mouse button come down in the DisplayObject?
       * @private
       * @member {boolean}
       */
      get: function() {
        return (this._flags & r.FLAGS.LEFT_DOWN) !== 0;
      },
      set: function(t) {
        this._doSet(r.FLAGS.LEFT_DOWN, t);
      },
      enumerable: !1,
      configurable: !0
    }), r.FLAGS = Object.freeze({
      NONE: 0,
      OVER: 1,
      LEFT_DOWN: 2,
      RIGHT_DOWN: 4
    }), r;
  }()
), a0 = (
  /** @class */
  function() {
    function r() {
      this._tempPoint = new Et();
    }
    return r.prototype.recursiveFindHit = function(t, e, n, i, o) {
      var a;
      if (!e || !e.visible)
        return !1;
      var s = t.data.global;
      o = e.interactive || o;
      var h = !1, u = o, l = !0;
      if (e.hitArea)
        i && (e.worldTransform.applyInverse(s, this._tempPoint), e.hitArea.contains(this._tempPoint.x, this._tempPoint.y) ? h = !0 : (i = !1, l = !1)), u = !1;
      else if (e._mask && i) {
        var f = e._mask.isMaskData ? e._mask.maskObject : e._mask;
        f && !(!((a = f.containsPoint) === null || a === void 0) && a.call(f, s)) && (i = !1);
      }
      if (l && e.interactiveChildren && e.children)
        for (var c = e.children, d = c.length - 1; d >= 0; d--) {
          var p = c[d], v = this.recursiveFindHit(t, p, n, i, u);
          if (v) {
            if (!p.parent)
              continue;
            u = !1, v && (t.target && (i = !1), h = !0);
          }
        }
      return o && (i && !t.target && !e.hitArea && e.containsPoint && e.containsPoint(s) && (h = !0), e.interactive && (h && !t.target && (t.target = e), n && n(t, e, !!h))), h;
    }, r.prototype.findHit = function(t, e, n, i) {
      this.recursiveFindHit(t, e, n, i, !1);
    }, r;
  }()
), s0 = {
  interactive: !1,
  interactiveChildren: !0,
  hitArea: null,
  /**
   * If enabled, the mouse cursor use the pointer behavior when hovered over the displayObject if it is interactive
   * Setting this changes the 'cursor' property to `'pointer'`.
   * @example
   * const sprite = new PIXI.Sprite(texture);
   * sprite.interactive = true;
   * sprite.buttonMode = true;
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */
  get buttonMode() {
    return this.cursor === "pointer";
  },
  set buttonMode(r) {
    r ? this.cursor = "pointer" : this.cursor === "pointer" && (this.cursor = null);
  },
  /**
   * This defines what cursor mode is used when the mouse cursor
   * is hovered over the displayObject.
   * @example
   * const sprite = new PIXI.Sprite(texture);
   * sprite.interactive = true;
   * sprite.cursor = 'wait';
   * @see https://developer.mozilla.org/en/docs/Web/CSS/cursor
   * @member {string}
   * @memberof PIXI.DisplayObject#
   */
  cursor: null,
  /**
   * Internal set of all active pointers, by identifier
   * @member {Map<number, InteractionTrackingData>}
   * @memberof PIXI.DisplayObject#
   * @private
   */
  get trackedPointers() {
    return this._trackedPointers === void 0 && (this._trackedPointers = {}), this._trackedPointers;
  },
  /**
   * Map of all tracked pointers, by identifier. Use trackedPointers to access.
   * @private
   * @type {Map<number, InteractionTrackingData>}
   */
  _trackedPointers: void 0
};
Rt.mixin(s0);
var Zn = 1, Jn = {
  target: null,
  data: {
    global: null
  }
}, h0 = (
  /** @class */
  function(r) {
    i0(t, r);
    function t(e, n) {
      var i = r.call(this) || this;
      return n = n || {}, i.renderer = e, i.autoPreventDefault = n.autoPreventDefault !== void 0 ? n.autoPreventDefault : !0, i.interactionFrequency = n.interactionFrequency || 10, i.mouse = new Nh(), i.mouse.identifier = Zn, i.mouse.global.set(-999999), i.activeInteractionData = {}, i.activeInteractionData[Zn] = i.mouse, i.interactionDataPool = [], i.eventData = new o0(), i.interactionDOMElement = null, i.moveWhenInside = !1, i.eventsAdded = !1, i.tickerAdded = !1, i.mouseOverRenderer = !("PointerEvent" in globalThis), i.supportsTouchEvents = "ontouchstart" in globalThis, i.supportsPointerEvents = !!globalThis.PointerEvent, i.onPointerUp = i.onPointerUp.bind(i), i.processPointerUp = i.processPointerUp.bind(i), i.onPointerCancel = i.onPointerCancel.bind(i), i.processPointerCancel = i.processPointerCancel.bind(i), i.onPointerDown = i.onPointerDown.bind(i), i.processPointerDown = i.processPointerDown.bind(i), i.onPointerMove = i.onPointerMove.bind(i), i.processPointerMove = i.processPointerMove.bind(i), i.onPointerOut = i.onPointerOut.bind(i), i.processPointerOverOut = i.processPointerOverOut.bind(i), i.onPointerOver = i.onPointerOver.bind(i), i.cursorStyles = {
        default: "inherit",
        pointer: "pointer"
      }, i.currentCursorMode = null, i.cursor = null, i.resolution = 1, i.delayedEvents = [], i.search = new a0(), i._tempDisplayObject = new pl(), i._eventListenerOptions = { capture: !0, passive: !1 }, i._useSystemTicker = n.useSystemTicker !== void 0 ? n.useSystemTicker : !0, i.setTargetElement(i.renderer.view, i.renderer.resolution), i;
    }
    return Object.defineProperty(t.prototype, "useSystemTicker", {
      /**
       * Should the InteractionManager automatically add {@link tickerUpdate} to {@link PIXI.Ticker.system}.
       * @default true
       */
      get: function() {
        return this._useSystemTicker;
      },
      set: function(e) {
        this._useSystemTicker = e, e ? this.addTickerListener() : this.removeTickerListener();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastObjectRendered", {
      /**
       * Last rendered object or temp object.
       * @readonly
       * @protected
       */
      get: function() {
        return this.renderer._lastObjectRendered || this._tempDisplayObject;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.hitTest = function(e, n) {
      return Jn.target = null, Jn.data.global = e, n || (n = this.lastObjectRendered), this.processInteractive(Jn, n, null, !0), Jn.target;
    }, t.prototype.setTargetElement = function(e, n) {
      n === void 0 && (n = 1), this.removeTickerListener(), this.removeEvents(), this.interactionDOMElement = e, this.resolution = n, this.addEvents(), this.addTickerListener();
    }, t.prototype.addTickerListener = function() {
      this.tickerAdded || !this.interactionDOMElement || !this._useSystemTicker || (Ht.system.add(this.tickerUpdate, this, Ce.INTERACTION), this.tickerAdded = !0);
    }, t.prototype.removeTickerListener = function() {
      this.tickerAdded && (Ht.system.remove(this.tickerUpdate, this), this.tickerAdded = !1);
    }, t.prototype.addEvents = function() {
      if (!(this.eventsAdded || !this.interactionDOMElement)) {
        var e = this.interactionDOMElement.style;
        globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "none", e.msTouchAction = "none") : this.supportsPointerEvents && (e.touchAction = "none"), this.supportsPointerEvents ? (globalThis.document.addEventListener("pointermove", this.onPointerMove, this._eventListenerOptions), this.interactionDOMElement.addEventListener("pointerdown", this.onPointerDown, this._eventListenerOptions), this.interactionDOMElement.addEventListener("pointerleave", this.onPointerOut, this._eventListenerOptions), this.interactionDOMElement.addEventListener("pointerover", this.onPointerOver, this._eventListenerOptions), globalThis.addEventListener("pointercancel", this.onPointerCancel, this._eventListenerOptions), globalThis.addEventListener("pointerup", this.onPointerUp, this._eventListenerOptions)) : (globalThis.document.addEventListener("mousemove", this.onPointerMove, this._eventListenerOptions), this.interactionDOMElement.addEventListener("mousedown", this.onPointerDown, this._eventListenerOptions), this.interactionDOMElement.addEventListener("mouseout", this.onPointerOut, this._eventListenerOptions), this.interactionDOMElement.addEventListener("mouseover", this.onPointerOver, this._eventListenerOptions), globalThis.addEventListener("mouseup", this.onPointerUp, this._eventListenerOptions)), this.supportsTouchEvents && (this.interactionDOMElement.addEventListener("touchstart", this.onPointerDown, this._eventListenerOptions), this.interactionDOMElement.addEventListener("touchcancel", this.onPointerCancel, this._eventListenerOptions), this.interactionDOMElement.addEventListener("touchend", this.onPointerUp, this._eventListenerOptions), this.interactionDOMElement.addEventListener("touchmove", this.onPointerMove, this._eventListenerOptions)), this.eventsAdded = !0;
      }
    }, t.prototype.removeEvents = function() {
      if (!(!this.eventsAdded || !this.interactionDOMElement)) {
        var e = this.interactionDOMElement.style;
        globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "", e.msTouchAction = "") : this.supportsPointerEvents && (e.touchAction = ""), this.supportsPointerEvents ? (globalThis.document.removeEventListener("pointermove", this.onPointerMove, this._eventListenerOptions), this.interactionDOMElement.removeEventListener("pointerdown", this.onPointerDown, this._eventListenerOptions), this.interactionDOMElement.removeEventListener("pointerleave", this.onPointerOut, this._eventListenerOptions), this.interactionDOMElement.removeEventListener("pointerover", this.onPointerOver, this._eventListenerOptions), globalThis.removeEventListener("pointercancel", this.onPointerCancel, this._eventListenerOptions), globalThis.removeEventListener("pointerup", this.onPointerUp, this._eventListenerOptions)) : (globalThis.document.removeEventListener("mousemove", this.onPointerMove, this._eventListenerOptions), this.interactionDOMElement.removeEventListener("mousedown", this.onPointerDown, this._eventListenerOptions), this.interactionDOMElement.removeEventListener("mouseout", this.onPointerOut, this._eventListenerOptions), this.interactionDOMElement.removeEventListener("mouseover", this.onPointerOver, this._eventListenerOptions), globalThis.removeEventListener("mouseup", this.onPointerUp, this._eventListenerOptions)), this.supportsTouchEvents && (this.interactionDOMElement.removeEventListener("touchstart", this.onPointerDown, this._eventListenerOptions), this.interactionDOMElement.removeEventListener("touchcancel", this.onPointerCancel, this._eventListenerOptions), this.interactionDOMElement.removeEventListener("touchend", this.onPointerUp, this._eventListenerOptions), this.interactionDOMElement.removeEventListener("touchmove", this.onPointerMove, this._eventListenerOptions)), this.interactionDOMElement = null, this.eventsAdded = !1;
      }
    }, t.prototype.tickerUpdate = function(e) {
      this._deltaTime += e, !(this._deltaTime < this.interactionFrequency) && (this._deltaTime = 0, this.update());
    }, t.prototype.update = function() {
      if (this.interactionDOMElement) {
        if (this._didMove) {
          this._didMove = !1;
          return;
        }
        this.cursor = null;
        for (var e in this.activeInteractionData)
          if (this.activeInteractionData.hasOwnProperty(e)) {
            var n = this.activeInteractionData[e];
            if (n.originalEvent && n.pointerType !== "touch") {
              var i = this.configureInteractionEventForDOMEvent(this.eventData, n.originalEvent, n);
              this.processInteractive(i, this.lastObjectRendered, this.processPointerOverOut, !0);
            }
          }
        this.setCursorMode(this.cursor);
      }
    }, t.prototype.setCursorMode = function(e) {
      e = e || "default";
      var n = !0;
      if (globalThis.OffscreenCanvas && this.interactionDOMElement instanceof OffscreenCanvas && (n = !1), this.currentCursorMode !== e) {
        this.currentCursorMode = e;
        var i = this.cursorStyles[e];
        if (i)
          switch (typeof i) {
            case "string":
              n && (this.interactionDOMElement.style.cursor = i);
              break;
            case "function":
              i(e);
              break;
            case "object":
              n && Object.assign(this.interactionDOMElement.style, i);
              break;
          }
        else
          n && typeof e == "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, e) && (this.interactionDOMElement.style.cursor = e);
      }
    }, t.prototype.dispatchEvent = function(e, n, i) {
      (!i.stopPropagationHint || e === i.stopsPropagatingAt) && (i.currentTarget = e, i.type = n, e.emit(n, i), e[n] && e[n](i));
    }, t.prototype.delayDispatchEvent = function(e, n, i) {
      this.delayedEvents.push({ displayObject: e, eventString: n, eventData: i });
    }, t.prototype.mapPositionToPoint = function(e, n, i) {
      var o;
      this.interactionDOMElement.parentElement ? o = this.interactionDOMElement.getBoundingClientRect() : o = {
        x: 0,
        y: 0,
        width: this.interactionDOMElement.width,
        height: this.interactionDOMElement.height,
        left: 0,
        top: 0
      };
      var a = 1 / this.resolution;
      e.x = (n - o.left) * (this.interactionDOMElement.width / o.width) * a, e.y = (i - o.top) * (this.interactionDOMElement.height / o.height) * a;
    }, t.prototype.processInteractive = function(e, n, i, o) {
      var a = this.search.findHit(e, n, i, o), s = this.delayedEvents;
      if (!s.length)
        return a;
      e.stopPropagationHint = !1;
      var h = s.length;
      this.delayedEvents = [];
      for (var u = 0; u < h; u++) {
        var l = s[u], f = l.displayObject, c = l.eventString, d = l.eventData;
        d.stopsPropagatingAt === f && (d.stopPropagationHint = !0), this.dispatchEvent(f, c, d);
      }
      return a;
    }, t.prototype.onPointerDown = function(e) {
      if (!(this.supportsTouchEvents && e.pointerType === "touch")) {
        var n = this.normalizeToPointerData(e);
        if (this.autoPreventDefault && n[0].isNormalized) {
          var i = e.cancelable || !("cancelable" in e);
          i && e.preventDefault();
        }
        for (var o = n.length, a = 0; a < o; a++) {
          var s = n[a], h = this.getInteractionDataForPointerId(s), u = this.configureInteractionEventForDOMEvent(this.eventData, s, h);
          if (u.data.originalEvent = e, this.processInteractive(u, this.lastObjectRendered, this.processPointerDown, !0), this.emit("pointerdown", u), s.pointerType === "touch")
            this.emit("touchstart", u);
          else if (s.pointerType === "mouse" || s.pointerType === "pen") {
            var l = s.button === 2;
            this.emit(l ? "rightdown" : "mousedown", this.eventData);
          }
        }
      }
    }, t.prototype.processPointerDown = function(e, n, i) {
      var o = e.data, a = e.data.identifier;
      if (i) {
        if (n.trackedPointers[a] || (n.trackedPointers[a] = new wo(a)), this.dispatchEvent(n, "pointerdown", e), o.pointerType === "touch")
          this.dispatchEvent(n, "touchstart", e);
        else if (o.pointerType === "mouse" || o.pointerType === "pen") {
          var s = o.button === 2;
          s ? n.trackedPointers[a].rightDown = !0 : n.trackedPointers[a].leftDown = !0, this.dispatchEvent(n, s ? "rightdown" : "mousedown", e);
        }
      }
    }, t.prototype.onPointerComplete = function(e, n, i) {
      var o = this.normalizeToPointerData(e), a = o.length, s = e.target;
      e.composedPath && e.composedPath().length > 0 && (s = e.composedPath()[0]);
      for (var h = s !== this.interactionDOMElement ? "outside" : "", u = 0; u < a; u++) {
        var l = o[u], f = this.getInteractionDataForPointerId(l), c = this.configureInteractionEventForDOMEvent(this.eventData, l, f);
        if (c.data.originalEvent = e, this.processInteractive(c, this.lastObjectRendered, i, n || !h), this.emit(n ? "pointercancel" : "pointerup" + h, c), l.pointerType === "mouse" || l.pointerType === "pen") {
          var d = l.button === 2;
          this.emit(d ? "rightup" + h : "mouseup" + h, c);
        } else
          l.pointerType === "touch" && (this.emit(n ? "touchcancel" : "touchend" + h, c), this.releaseInteractionDataForPointerId(l.pointerId));
      }
    }, t.prototype.onPointerCancel = function(e) {
      this.supportsTouchEvents && e.pointerType === "touch" || this.onPointerComplete(e, !0, this.processPointerCancel);
    }, t.prototype.processPointerCancel = function(e, n) {
      var i = e.data, o = e.data.identifier;
      n.trackedPointers[o] !== void 0 && (delete n.trackedPointers[o], this.dispatchEvent(n, "pointercancel", e), i.pointerType === "touch" && this.dispatchEvent(n, "touchcancel", e));
    }, t.prototype.onPointerUp = function(e) {
      this.supportsTouchEvents && e.pointerType === "touch" || this.onPointerComplete(e, !1, this.processPointerUp);
    }, t.prototype.processPointerUp = function(e, n, i) {
      var o = e.data, a = e.data.identifier, s = n.trackedPointers[a], h = o.pointerType === "touch", u = o.pointerType === "mouse" || o.pointerType === "pen", l = !1;
      if (u) {
        var f = o.button === 2, c = wo.FLAGS, d = f ? c.RIGHT_DOWN : c.LEFT_DOWN, p = s !== void 0 && s.flags & d;
        i ? (this.dispatchEvent(n, f ? "rightup" : "mouseup", e), p && (this.dispatchEvent(n, f ? "rightclick" : "click", e), l = !0)) : p && this.dispatchEvent(n, f ? "rightupoutside" : "mouseupoutside", e), s && (f ? s.rightDown = !1 : s.leftDown = !1);
      }
      i ? (this.dispatchEvent(n, "pointerup", e), h && this.dispatchEvent(n, "touchend", e), s && ((!u || l) && this.dispatchEvent(n, "pointertap", e), h && (this.dispatchEvent(n, "tap", e), s.over = !1))) : s && (this.dispatchEvent(n, "pointerupoutside", e), h && this.dispatchEvent(n, "touchendoutside", e)), s && s.none && delete n.trackedPointers[a];
    }, t.prototype.onPointerMove = function(e) {
      if (!(this.supportsTouchEvents && e.pointerType === "touch")) {
        var n = this.normalizeToPointerData(e);
        (n[0].pointerType === "mouse" || n[0].pointerType === "pen") && (this._didMove = !0, this.cursor = null);
        for (var i = n.length, o = 0; o < i; o++) {
          var a = n[o], s = this.getInteractionDataForPointerId(a), h = this.configureInteractionEventForDOMEvent(this.eventData, a, s);
          h.data.originalEvent = e, this.processInteractive(h, this.lastObjectRendered, this.processPointerMove, !0), this.emit("pointermove", h), a.pointerType === "touch" && this.emit("touchmove", h), (a.pointerType === "mouse" || a.pointerType === "pen") && this.emit("mousemove", h);
        }
        n[0].pointerType === "mouse" && this.setCursorMode(this.cursor);
      }
    }, t.prototype.processPointerMove = function(e, n, i) {
      var o = e.data, a = o.pointerType === "touch", s = o.pointerType === "mouse" || o.pointerType === "pen";
      s && this.processPointerOverOut(e, n, i), (!this.moveWhenInside || i) && (this.dispatchEvent(n, "pointermove", e), a && this.dispatchEvent(n, "touchmove", e), s && this.dispatchEvent(n, "mousemove", e));
    }, t.prototype.onPointerOut = function(e) {
      if (!(this.supportsTouchEvents && e.pointerType === "touch")) {
        var n = this.normalizeToPointerData(e), i = n[0];
        i.pointerType === "mouse" && (this.mouseOverRenderer = !1, this.setCursorMode(null));
        var o = this.getInteractionDataForPointerId(i), a = this.configureInteractionEventForDOMEvent(this.eventData, i, o);
        a.data.originalEvent = i, this.processInteractive(a, this.lastObjectRendered, this.processPointerOverOut, !1), this.emit("pointerout", a), i.pointerType === "mouse" || i.pointerType === "pen" ? this.emit("mouseout", a) : this.releaseInteractionDataForPointerId(o.identifier);
      }
    }, t.prototype.processPointerOverOut = function(e, n, i) {
      var o = e.data, a = e.data.identifier, s = o.pointerType === "mouse" || o.pointerType === "pen", h = n.trackedPointers[a];
      i && !h && (h = n.trackedPointers[a] = new wo(a)), h !== void 0 && (i && this.mouseOverRenderer ? (h.over || (h.over = !0, this.delayDispatchEvent(n, "pointerover", e), s && this.delayDispatchEvent(n, "mouseover", e)), s && this.cursor === null && (this.cursor = n.cursor)) : h.over && (h.over = !1, this.dispatchEvent(n, "pointerout", this.eventData), s && this.dispatchEvent(n, "mouseout", e), h.none && delete n.trackedPointers[a]));
    }, t.prototype.onPointerOver = function(e) {
      if (!(this.supportsTouchEvents && e.pointerType === "touch")) {
        var n = this.normalizeToPointerData(e), i = n[0], o = this.getInteractionDataForPointerId(i), a = this.configureInteractionEventForDOMEvent(this.eventData, i, o);
        a.data.originalEvent = i, i.pointerType === "mouse" && (this.mouseOverRenderer = !0), this.emit("pointerover", a), (i.pointerType === "mouse" || i.pointerType === "pen") && this.emit("mouseover", a);
      }
    }, t.prototype.getInteractionDataForPointerId = function(e) {
      var n = e.pointerId, i;
      return n === Zn || e.pointerType === "mouse" ? i = this.mouse : this.activeInteractionData[n] ? i = this.activeInteractionData[n] : (i = this.interactionDataPool.pop() || new Nh(), i.identifier = n, this.activeInteractionData[n] = i), i.copyEvent(e), i;
    }, t.prototype.releaseInteractionDataForPointerId = function(e) {
      var n = this.activeInteractionData[e];
      n && (delete this.activeInteractionData[e], n.reset(), this.interactionDataPool.push(n));
    }, t.prototype.configureInteractionEventForDOMEvent = function(e, n, i) {
      return e.data = i, this.mapPositionToPoint(i.global, n.clientX, n.clientY), n.pointerType === "touch" && (n.globalX = i.global.x, n.globalY = i.global.y), i.originalEvent = n, e.reset(), e;
    }, t.prototype.normalizeToPointerData = function(e) {
      var n = [];
      if (this.supportsTouchEvents && e instanceof TouchEvent)
        for (var i = 0, o = e.changedTouches.length; i < o; i++) {
          var a = e.changedTouches[i];
          typeof a.button > "u" && (a.button = e.touches.length ? 1 : 0), typeof a.buttons > "u" && (a.buttons = e.touches.length ? 1 : 0), typeof a.isPrimary > "u" && (a.isPrimary = e.touches.length === 1 && e.type === "touchstart"), typeof a.width > "u" && (a.width = a.radiusX || 1), typeof a.height > "u" && (a.height = a.radiusY || 1), typeof a.tiltX > "u" && (a.tiltX = 0), typeof a.tiltY > "u" && (a.tiltY = 0), typeof a.pointerType > "u" && (a.pointerType = "touch"), typeof a.pointerId > "u" && (a.pointerId = a.identifier || 0), typeof a.pressure > "u" && (a.pressure = a.force || 0.5), typeof a.twist > "u" && (a.twist = 0), typeof a.tangentialPressure > "u" && (a.tangentialPressure = 0), typeof a.layerX > "u" && (a.layerX = a.offsetX = a.clientX), typeof a.layerY > "u" && (a.layerY = a.offsetY = a.clientY), a.isNormalized = !0, n.push(a);
        }
      else if (!globalThis.MouseEvent || e instanceof MouseEvent && (!this.supportsPointerEvents || !(e instanceof globalThis.PointerEvent))) {
        var s = e;
        typeof s.isPrimary > "u" && (s.isPrimary = !0), typeof s.width > "u" && (s.width = 1), typeof s.height > "u" && (s.height = 1), typeof s.tiltX > "u" && (s.tiltX = 0), typeof s.tiltY > "u" && (s.tiltY = 0), typeof s.pointerType > "u" && (s.pointerType = "mouse"), typeof s.pointerId > "u" && (s.pointerId = Zn), typeof s.pressure > "u" && (s.pressure = 0.5), typeof s.twist > "u" && (s.twist = 0), typeof s.tangentialPressure > "u" && (s.tangentialPressure = 0), s.isNormalized = !0, n.push(s);
      } else
        n.push(e);
      return n;
    }, t.prototype.destroy = function() {
      this.removeEvents(), this.removeTickerListener(), this.removeAllListeners(), this.renderer = null, this.mouse = null, this.eventData = null, this.interactionDOMElement = null, this.onPointerDown = null, this.processPointerDown = null, this.onPointerUp = null, this.processPointerUp = null, this.onPointerCancel = null, this.processPointerCancel = null, this.onPointerMove = null, this.processPointerMove = null, this.onPointerOut = null, this.processPointerOverOut = null, this.onPointerOver = null, this.search = null;
    }, t.extension = {
      name: "interaction",
      type: [
        mt.RendererPlugin,
        mt.CanvasRendererPlugin
      ]
    }, t;
  }(Sn)
);
/*!
 * @pixi/extract - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/extract is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var u0 = new ut(), l0 = 4, f0 = (
  /** @class */
  function() {
    function r(t) {
      this.renderer = t;
    }
    return r.prototype.image = function(t, e, n) {
      var i = new Image();
      return i.src = this.base64(t, e, n), i;
    }, r.prototype.base64 = function(t, e, n) {
      return this.canvas(t).toDataURL(e, n);
    }, r.prototype.canvas = function(t, e) {
      var n = this._rawPixels(t, e), i = n.pixels, o = n.width, a = n.height, s = n.flipY, h = new gh(o, a, 1), u = h.context.getImageData(0, 0, o, a);
      if (r.arrayPostDivide(i, u.data), h.context.putImageData(u, 0, 0), s) {
        var l = new gh(h.width, h.height, 1);
        l.context.scale(1, -1), l.context.drawImage(h.canvas, 0, -a), h.destroy(), h = l;
      }
      return h.canvas;
    }, r.prototype.pixels = function(t, e) {
      var n = this._rawPixels(t, e).pixels;
      return r.arrayPostDivide(n, n), n;
    }, r.prototype._rawPixels = function(t, e) {
      var n = this.renderer, i, o = !1, a, s = !1;
      if (t)
        if (t instanceof fr)
          a = t;
        else {
          var h = n.context.webGLVersion >= 2 ? n.multisample : wt.NONE;
          if (a = this.renderer.generateTexture(t, { multisample: h }), h !== wt.NONE) {
            var u = fr.create({
              width: a.width,
              height: a.height
            });
            n.framebuffer.bind(a.framebuffer), n.framebuffer.blit(u.framebuffer), n.framebuffer.bind(null), a.destroy(!0), a = u;
          }
          s = !0;
        }
      a ? (i = a.baseTexture.resolution, e = e ?? a.frame, o = !1, n.renderTexture.bind(a)) : (i = n.resolution, e || (e = u0, e.width = n.width, e.height = n.height), o = !0, n.renderTexture.bind(null));
      var l = Math.round(e.width * i), f = Math.round(e.height * i), c = new Uint8Array(l0 * l * f), d = n.gl;
      return d.readPixels(Math.round(e.x * i), Math.round(e.y * i), l, f, d.RGBA, d.UNSIGNED_BYTE, c), s && a.destroy(!0), { pixels: c, width: l, height: f, flipY: o };
    }, r.prototype.destroy = function() {
      this.renderer = null;
    }, r.arrayPostDivide = function(t, e) {
      for (var n = 0; n < t.length; n += 4) {
        var i = e[n + 3] = t[n + 3];
        i !== 0 ? (e[n] = Math.round(Math.min(t[n] * 255 / i, 255)), e[n + 1] = Math.round(Math.min(t[n + 1] * 255 / i, 255)), e[n + 2] = Math.round(Math.min(t[n + 2] * 255 / i, 255))) : (e[n] = t[n], e[n + 1] = t[n + 1], e[n + 2] = t[n + 2]);
      }
    }, r.extension = {
      name: "extract",
      type: mt.RendererPlugin
    }, r;
  }()
);
/*!
 * @pixi/loaders - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/loaders is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var Qn = (
  /** @class */
  function() {
    function r(t, e, n) {
      e === void 0 && (e = !1), this._fn = t, this._once = e, this._thisArg = n, this._next = this._prev = this._owner = null;
    }
    return r.prototype.detach = function() {
      return this._owner === null ? !1 : (this._owner.detach(this), !0);
    }, r;
  }()
);
function Lh(r, t) {
  return r._head ? (r._tail._next = t, t._prev = r._tail, r._tail = t) : (r._head = t, r._tail = t), t._owner = r, t;
}
var Oe = (
  /** @class */
  function() {
    function r() {
      this._head = this._tail = void 0;
    }
    return r.prototype.handlers = function(t) {
      t === void 0 && (t = !1);
      var e = this._head;
      if (t)
        return !!e;
      for (var n = []; e; )
        n.push(e), e = e._next;
      return n;
    }, r.prototype.has = function(t) {
      if (!(t instanceof Qn))
        throw new Error("MiniSignal#has(): First arg must be a SignalBinding object.");
      return t._owner === this;
    }, r.prototype.dispatch = function() {
      for (var t = arguments, e = [], n = 0; n < arguments.length; n++)
        e[n] = t[n];
      var i = this._head;
      if (!i)
        return !1;
      for (; i; )
        i._once && this.detach(i), i._fn.apply(i._thisArg, e), i = i._next;
      return !0;
    }, r.prototype.add = function(t, e) {
      if (e === void 0 && (e = null), typeof t != "function")
        throw new Error("MiniSignal#add(): First arg must be a Function.");
      return Lh(this, new Qn(t, !1, e));
    }, r.prototype.once = function(t, e) {
      if (e === void 0 && (e = null), typeof t != "function")
        throw new Error("MiniSignal#once(): First arg must be a Function.");
      return Lh(this, new Qn(t, !0, e));
    }, r.prototype.detach = function(t) {
      if (!(t instanceof Qn))
        throw new Error("MiniSignal#detach(): First arg must be a SignalBinding object.");
      return t._owner !== this ? this : (t._prev && (t._prev._next = t._next), t._next && (t._next._prev = t._prev), t === this._head ? (this._head = t._next, t._next === null && (this._tail = null)) : t === this._tail && (this._tail = t._prev, this._tail._next = null), t._owner = null, this);
    }, r.prototype.detachAll = function() {
      var t = this._head;
      if (!t)
        return this;
      for (this._head = this._tail = null; t; )
        t._owner = null, t = t._next;
      return this;
    }, r;
  }()
);
function Ml(r, t) {
  t = t || {};
  for (var e = {
    // eslint-disable-next-line max-len
    key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
    q: {
      name: "queryKey",
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
    },
    parser: {
      // eslint-disable-next-line max-len
      strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      // eslint-disable-next-line max-len
      loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
    }
  }, n = e.parser[t.strictMode ? "strict" : "loose"].exec(r), i = {}, o = 14; o--; )
    i[e.key[o]] = n[o] || "";
  return i[e.q.name] = {}, i[e.key[12]].replace(e.q.parser, function(a, s, h) {
    s && (i[e.q.name][s] = h);
  }), i;
}
var So, ti = null, c0 = 0, Uh = 200, d0 = 204, p0 = 1223, v0 = 2;
function Gh() {
}
function kh(r, t, e) {
  t && t.indexOf(".") === 0 && (t = t.substring(1)), t && (r[t] = e);
}
function Ao(r) {
  return r.toString().replace("object ", "");
}
var Ot = (
  /** @class */
  function() {
    function r(t, e, n) {
      if (this._dequeue = Gh, this._onLoadBinding = null, this._elementTimer = 0, this._boundComplete = null, this._boundOnError = null, this._boundOnProgress = null, this._boundOnTimeout = null, this._boundXhrOnError = null, this._boundXhrOnTimeout = null, this._boundXhrOnAbort = null, this._boundXhrOnLoad = null, typeof t != "string" || typeof e != "string")
        throw new Error("Both name and url are required for constructing a resource.");
      n = n || {}, this._flags = 0, this._setFlag(r.STATUS_FLAGS.DATA_URL, e.indexOf("data:") === 0), this.name = t, this.url = e, this.extension = this._getExtension(), this.data = null, this.crossOrigin = n.crossOrigin === !0 ? "anonymous" : n.crossOrigin, this.timeout = n.timeout || 0, this.loadType = n.loadType || this._determineLoadType(), this.xhrType = n.xhrType, this.metadata = n.metadata || {}, this.error = null, this.xhr = null, this.children = [], this.type = r.TYPE.UNKNOWN, this.progressChunk = 0, this._dequeue = Gh, this._onLoadBinding = null, this._elementTimer = 0, this._boundComplete = this.complete.bind(this), this._boundOnError = this._onError.bind(this), this._boundOnProgress = this._onProgress.bind(this), this._boundOnTimeout = this._onTimeout.bind(this), this._boundXhrOnError = this._xhrOnError.bind(this), this._boundXhrOnTimeout = this._xhrOnTimeout.bind(this), this._boundXhrOnAbort = this._xhrOnAbort.bind(this), this._boundXhrOnLoad = this._xhrOnLoad.bind(this), this.onStart = new Oe(), this.onProgress = new Oe(), this.onComplete = new Oe(), this.onAfterMiddleware = new Oe();
    }
    return r.setExtensionLoadType = function(t, e) {
      kh(r._loadTypeMap, t, e);
    }, r.setExtensionXhrType = function(t, e) {
      kh(r._xhrTypeMap, t, e);
    }, Object.defineProperty(r.prototype, "isDataUrl", {
      /**
       * When the resource starts to load.
       * @memberof PIXI.LoaderResource
       * @callback OnStartSignal
       * @param {PIXI.Resource} resource - The resource that the event happened on.
       */
      /**
       * When the resource reports loading progress.
       * @memberof PIXI.LoaderResource
       * @callback OnProgressSignal
       * @param {PIXI.Resource} resource - The resource that the event happened on.
       * @param {number} percentage - The progress of the load in the range [0, 1].
       */
      /**
       * When the resource finishes loading.
       * @memberof PIXI.LoaderResource
       * @callback OnCompleteSignal
       * @param {PIXI.Resource} resource - The resource that the event happened on.
       */
      /**
       * @memberof PIXI.LoaderResource
       * @typedef {object} IMetadata
       * @property {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [loadElement=null] - The
       *      element to use for loading, instead of creating one.
       * @property {boolean} [skipSource=false] - Skips adding source(s) to the load element. This
       *      is useful if you want to pass in a `loadElement` that you already added load sources to.
       * @property {string|string[]} [mimeType] - The mime type to use for the source element
       *      of a video/audio elment. If the urls are an array, you can pass this as an array as well
       *      where each index is the mime type to use for the corresponding url index.
       */
      /**
       * Stores whether or not this url is a data url.
       * @readonly
       * @member {boolean}
       */
      get: function() {
        return this._hasFlag(r.STATUS_FLAGS.DATA_URL);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "isComplete", {
      /**
       * Describes if this resource has finished loading. Is true when the resource has completely
       * loaded.
       * @readonly
       * @member {boolean}
       */
      get: function() {
        return this._hasFlag(r.STATUS_FLAGS.COMPLETE);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "isLoading", {
      /**
       * Describes if this resource is currently loading. Is true when the resource starts loading,
       * and is false again when complete.
       * @readonly
       * @member {boolean}
       */
      get: function() {
        return this._hasFlag(r.STATUS_FLAGS.LOADING);
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.complete = function() {
      this._clearEvents(), this._finish();
    }, r.prototype.abort = function(t) {
      if (!this.error) {
        if (this.error = new Error(t), this._clearEvents(), this.xhr)
          this.xhr.abort();
        else if (this.xdr)
          this.xdr.abort();
        else if (this.data)
          if (this.data.src)
            this.data.src = r.EMPTY_GIF;
          else
            for (; this.data.firstChild; )
              this.data.removeChild(this.data.firstChild);
        this._finish();
      }
    }, r.prototype.load = function(t) {
      var e = this;
      if (!this.isLoading) {
        if (this.isComplete) {
          t && setTimeout(function() {
            return t(e);
          }, 1);
          return;
        } else
          t && this.onComplete.once(t);
        switch (this._setFlag(r.STATUS_FLAGS.LOADING, !0), this.onStart.dispatch(this), (this.crossOrigin === !1 || typeof this.crossOrigin != "string") && (this.crossOrigin = this._determineCrossOrigin(this.url)), this.loadType) {
          case r.LOAD_TYPE.IMAGE:
            this.type = r.TYPE.IMAGE, this._loadElement("image");
            break;
          case r.LOAD_TYPE.AUDIO:
            this.type = r.TYPE.AUDIO, this._loadSourceElement("audio");
            break;
          case r.LOAD_TYPE.VIDEO:
            this.type = r.TYPE.VIDEO, this._loadSourceElement("video");
            break;
          case r.LOAD_TYPE.XHR:
          default:
            typeof So > "u" && (So = !!(globalThis.XDomainRequest && !("withCredentials" in new XMLHttpRequest()))), So && this.crossOrigin ? this._loadXdr() : this._loadXhr();
            break;
        }
      }
    }, r.prototype._hasFlag = function(t) {
      return (this._flags & t) !== 0;
    }, r.prototype._setFlag = function(t, e) {
      this._flags = e ? this._flags | t : this._flags & ~t;
    }, r.prototype._clearEvents = function() {
      clearTimeout(this._elementTimer), this.data && this.data.removeEventListener && (this.data.removeEventListener("error", this._boundOnError, !1), this.data.removeEventListener("load", this._boundComplete, !1), this.data.removeEventListener("progress", this._boundOnProgress, !1), this.data.removeEventListener("canplaythrough", this._boundComplete, !1)), this.xhr && (this.xhr.removeEventListener ? (this.xhr.removeEventListener("error", this._boundXhrOnError, !1), this.xhr.removeEventListener("timeout", this._boundXhrOnTimeout, !1), this.xhr.removeEventListener("abort", this._boundXhrOnAbort, !1), this.xhr.removeEventListener("progress", this._boundOnProgress, !1), this.xhr.removeEventListener("load", this._boundXhrOnLoad, !1)) : (this.xhr.onerror = null, this.xhr.ontimeout = null, this.xhr.onprogress = null, this.xhr.onload = null));
    }, r.prototype._finish = function() {
      if (this.isComplete)
        throw new Error("Complete called again for an already completed resource.");
      this._setFlag(r.STATUS_FLAGS.COMPLETE, !0), this._setFlag(r.STATUS_FLAGS.LOADING, !1), this.onComplete.dispatch(this);
    }, r.prototype._loadElement = function(t) {
      this.metadata.loadElement ? this.data = this.metadata.loadElement : t === "image" && typeof globalThis.Image < "u" ? this.data = new Image() : this.data = document.createElement(t), this.crossOrigin && (this.data.crossOrigin = this.crossOrigin), this.metadata.skipSource || (this.data.src = this.url), this.data.addEventListener("error", this._boundOnError, !1), this.data.addEventListener("load", this._boundComplete, !1), this.data.addEventListener("progress", this._boundOnProgress, !1), this.timeout && (this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout));
    }, r.prototype._loadSourceElement = function(t) {
      if (this.metadata.loadElement ? this.data = this.metadata.loadElement : t === "audio" && typeof globalThis.Audio < "u" ? this.data = new Audio() : this.data = document.createElement(t), this.data === null) {
        this.abort("Unsupported element: " + t);
        return;
      }
      if (this.crossOrigin && (this.data.crossOrigin = this.crossOrigin), !this.metadata.skipSource)
        if (navigator.isCocoonJS)
          this.data.src = Array.isArray(this.url) ? this.url[0] : this.url;
        else if (Array.isArray(this.url))
          for (var e = this.metadata.mimeType, n = 0; n < this.url.length; ++n)
            this.data.appendChild(this._createSource(t, this.url[n], Array.isArray(e) ? e[n] : e));
        else {
          var e = this.metadata.mimeType;
          this.data.appendChild(this._createSource(t, this.url, Array.isArray(e) ? e[0] : e));
        }
      this.data.addEventListener("error", this._boundOnError, !1), this.data.addEventListener("load", this._boundComplete, !1), this.data.addEventListener("progress", this._boundOnProgress, !1), this.data.addEventListener("canplaythrough", this._boundComplete, !1), this.data.load(), this.timeout && (this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout));
    }, r.prototype._loadXhr = function() {
      typeof this.xhrType != "string" && (this.xhrType = this._determineXhrType());
      var t = this.xhr = new XMLHttpRequest();
      this.crossOrigin === "use-credentials" && (t.withCredentials = !0), t.open("GET", this.url, !0), t.timeout = this.timeout, this.xhrType === r.XHR_RESPONSE_TYPE.JSON || this.xhrType === r.XHR_RESPONSE_TYPE.DOCUMENT ? t.responseType = r.XHR_RESPONSE_TYPE.TEXT : t.responseType = this.xhrType, t.addEventListener("error", this._boundXhrOnError, !1), t.addEventListener("timeout", this._boundXhrOnTimeout, !1), t.addEventListener("abort", this._boundXhrOnAbort, !1), t.addEventListener("progress", this._boundOnProgress, !1), t.addEventListener("load", this._boundXhrOnLoad, !1), t.send();
    }, r.prototype._loadXdr = function() {
      typeof this.xhrType != "string" && (this.xhrType = this._determineXhrType());
      var t = this.xhr = new globalThis.XDomainRequest();
      t.timeout = this.timeout || 5e3, t.onerror = this._boundXhrOnError, t.ontimeout = this._boundXhrOnTimeout, t.onprogress = this._boundOnProgress, t.onload = this._boundXhrOnLoad, t.open("GET", this.url, !0), setTimeout(function() {
        return t.send();
      }, 1);
    }, r.prototype._createSource = function(t, e, n) {
      n || (n = t + "/" + this._getExtension(e));
      var i = document.createElement("source");
      return i.src = e, i.type = n, i;
    }, r.prototype._onError = function(t) {
      this.abort("Failed to load element using: " + t.target.nodeName);
    }, r.prototype._onProgress = function(t) {
      t && t.lengthComputable && this.onProgress.dispatch(this, t.loaded / t.total);
    }, r.prototype._onTimeout = function() {
      this.abort("Load timed out.");
    }, r.prototype._xhrOnError = function() {
      var t = this.xhr;
      this.abort(Ao(t) + " Request failed. Status: " + t.status + ', text: "' + t.statusText + '"');
    }, r.prototype._xhrOnTimeout = function() {
      var t = this.xhr;
      this.abort(Ao(t) + " Request timed out.");
    }, r.prototype._xhrOnAbort = function() {
      var t = this.xhr;
      this.abort(Ao(t) + " Request was aborted by the user.");
    }, r.prototype._xhrOnLoad = function() {
      var t = this.xhr, e = "", n = typeof t.status > "u" ? Uh : t.status;
      (t.responseType === "" || t.responseType === "text" || typeof t.responseType > "u") && (e = t.responseText), n === c0 && (e.length > 0 || t.responseType === r.XHR_RESPONSE_TYPE.BUFFER) ? n = Uh : n === p0 && (n = d0);
      var i = n / 100 | 0;
      if (i === v0)
        if (this.xhrType === r.XHR_RESPONSE_TYPE.TEXT)
          this.data = e, this.type = r.TYPE.TEXT;
        else if (this.xhrType === r.XHR_RESPONSE_TYPE.JSON)
          try {
            this.data = JSON.parse(e), this.type = r.TYPE.JSON;
          } catch (s) {
            this.abort("Error trying to parse loaded json: " + s);
            return;
          }
        else if (this.xhrType === r.XHR_RESPONSE_TYPE.DOCUMENT)
          try {
            if (globalThis.DOMParser) {
              var o = new DOMParser();
              this.data = o.parseFromString(e, "text/xml");
            } else {
              var a = document.createElement("div");
              a.innerHTML = e, this.data = a;
            }
            this.type = r.TYPE.XML;
          } catch (s) {
            this.abort("Error trying to parse loaded xml: " + s);
            return;
          }
        else
          this.data = t.response || e;
      else {
        this.abort("[" + t.status + "] " + t.statusText + ": " + t.responseURL);
        return;
      }
      this.complete();
    }, r.prototype._determineCrossOrigin = function(t, e) {
      if (t.indexOf("data:") === 0)
        return "";
      if (globalThis.origin !== globalThis.location.origin)
        return "anonymous";
      e = e || globalThis.location, ti || (ti = document.createElement("a")), ti.href = t;
      var n = Ml(ti.href, { strictMode: !0 }), i = !n.port && e.port === "" || n.port === e.port, o = n.protocol ? n.protocol + ":" : "";
      return n.host !== e.hostname || !i || o !== e.protocol ? "anonymous" : "";
    }, r.prototype._determineXhrType = function() {
      return r._xhrTypeMap[this.extension] || r.XHR_RESPONSE_TYPE.TEXT;
    }, r.prototype._determineLoadType = function() {
      return r._loadTypeMap[this.extension] || r.LOAD_TYPE.XHR;
    }, r.prototype._getExtension = function(t) {
      t === void 0 && (t = this.url);
      var e = "";
      if (this.isDataUrl) {
        var n = t.indexOf("/");
        e = t.substring(n + 1, t.indexOf(";", n));
      } else {
        var i = t.indexOf("?"), o = t.indexOf("#"), a = Math.min(i > -1 ? i : t.length, o > -1 ? o : t.length);
        t = t.substring(0, a), e = t.substring(t.lastIndexOf(".") + 1);
      }
      return e.toLowerCase();
    }, r.prototype._getMimeFromXhrType = function(t) {
      switch (t) {
        case r.XHR_RESPONSE_TYPE.BUFFER:
          return "application/octet-binary";
        case r.XHR_RESPONSE_TYPE.BLOB:
          return "application/blob";
        case r.XHR_RESPONSE_TYPE.DOCUMENT:
          return "application/xml";
        case r.XHR_RESPONSE_TYPE.JSON:
          return "application/json";
        case r.XHR_RESPONSE_TYPE.DEFAULT:
        case r.XHR_RESPONSE_TYPE.TEXT:
        default:
          return "text/plain";
      }
    }, r;
  }()
);
(function(r) {
  (function(t) {
    t[t.NONE = 0] = "NONE", t[t.DATA_URL = 1] = "DATA_URL", t[t.COMPLETE = 2] = "COMPLETE", t[t.LOADING = 4] = "LOADING";
  })(r.STATUS_FLAGS || (r.STATUS_FLAGS = {})), function(t) {
    t[t.UNKNOWN = 0] = "UNKNOWN", t[t.JSON = 1] = "JSON", t[t.XML = 2] = "XML", t[t.IMAGE = 3] = "IMAGE", t[t.AUDIO = 4] = "AUDIO", t[t.VIDEO = 5] = "VIDEO", t[t.TEXT = 6] = "TEXT";
  }(r.TYPE || (r.TYPE = {})), function(t) {
    t[t.XHR = 1] = "XHR", t[t.IMAGE = 2] = "IMAGE", t[t.AUDIO = 3] = "AUDIO", t[t.VIDEO = 4] = "VIDEO";
  }(r.LOAD_TYPE || (r.LOAD_TYPE = {})), function(t) {
    t.DEFAULT = "text", t.BUFFER = "arraybuffer", t.BLOB = "blob", t.DOCUMENT = "document", t.JSON = "json", t.TEXT = "text";
  }(r.XHR_RESPONSE_TYPE || (r.XHR_RESPONSE_TYPE = {})), r._loadTypeMap = {
    // images
    gif: r.LOAD_TYPE.IMAGE,
    png: r.LOAD_TYPE.IMAGE,
    bmp: r.LOAD_TYPE.IMAGE,
    jpg: r.LOAD_TYPE.IMAGE,
    jpeg: r.LOAD_TYPE.IMAGE,
    tif: r.LOAD_TYPE.IMAGE,
    tiff: r.LOAD_TYPE.IMAGE,
    webp: r.LOAD_TYPE.IMAGE,
    tga: r.LOAD_TYPE.IMAGE,
    avif: r.LOAD_TYPE.IMAGE,
    svg: r.LOAD_TYPE.IMAGE,
    "svg+xml": r.LOAD_TYPE.IMAGE,
    // audio
    mp3: r.LOAD_TYPE.AUDIO,
    ogg: r.LOAD_TYPE.AUDIO,
    wav: r.LOAD_TYPE.AUDIO,
    // videos
    mp4: r.LOAD_TYPE.VIDEO,
    webm: r.LOAD_TYPE.VIDEO
  }, r._xhrTypeMap = {
    // xml
    xhtml: r.XHR_RESPONSE_TYPE.DOCUMENT,
    html: r.XHR_RESPONSE_TYPE.DOCUMENT,
    htm: r.XHR_RESPONSE_TYPE.DOCUMENT,
    xml: r.XHR_RESPONSE_TYPE.DOCUMENT,
    tmx: r.XHR_RESPONSE_TYPE.DOCUMENT,
    svg: r.XHR_RESPONSE_TYPE.DOCUMENT,
    // This was added to handle Tiled Tileset XML, but .tsx is also a TypeScript React Component.
    // Since it is way less likely for people to be loading TypeScript files instead of Tiled files,
    // this should probably be fine.
    tsx: r.XHR_RESPONSE_TYPE.DOCUMENT,
    // images
    gif: r.XHR_RESPONSE_TYPE.BLOB,
    png: r.XHR_RESPONSE_TYPE.BLOB,
    bmp: r.XHR_RESPONSE_TYPE.BLOB,
    jpg: r.XHR_RESPONSE_TYPE.BLOB,
    jpeg: r.XHR_RESPONSE_TYPE.BLOB,
    tif: r.XHR_RESPONSE_TYPE.BLOB,
    tiff: r.XHR_RESPONSE_TYPE.BLOB,
    webp: r.XHR_RESPONSE_TYPE.BLOB,
    tga: r.XHR_RESPONSE_TYPE.BLOB,
    avif: r.XHR_RESPONSE_TYPE.BLOB,
    // json
    json: r.XHR_RESPONSE_TYPE.JSON,
    // text
    text: r.XHR_RESPONSE_TYPE.TEXT,
    txt: r.XHR_RESPONSE_TYPE.TEXT,
    // fonts
    ttf: r.XHR_RESPONSE_TYPE.BUFFER,
    otf: r.XHR_RESPONSE_TYPE.BUFFER
  }, r.EMPTY_GIF = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
})(Ot || (Ot = {}));
function $e() {
}
function _0(r) {
  return function() {
    for (var e = arguments, n = [], i = 0; i < arguments.length; i++)
      n[i] = e[i];
    if (r === null)
      throw new Error("Callback was already called.");
    var o = r;
    r = null, o.apply(this, n);
  };
}
var m0 = (
  /** @class */
  function() {
    function r(t, e) {
      this.data = t, this.callback = e;
    }
    return r;
  }()
), Po = (
  /** @class */
  function() {
    function r(t, e) {
      var n = this;
      if (e === void 0 && (e = 1), this.workers = 0, this.saturated = $e, this.unsaturated = $e, this.empty = $e, this.drain = $e, this.error = $e, this.started = !1, this.paused = !1, this._tasks = [], this._insert = function(i, o, a) {
        if (a && typeof a != "function")
          throw new Error("task callback must be a function");
        if (n.started = !0, i == null && n.idle()) {
          setTimeout(function() {
            return n.drain();
          }, 1);
          return;
        }
        var s = new m0(i, typeof a == "function" ? a : $e);
        o ? n._tasks.unshift(s) : n._tasks.push(s), setTimeout(n.process, 1);
      }, this.process = function() {
        for (; !n.paused && n.workers < n.concurrency && n._tasks.length; ) {
          var i = n._tasks.shift();
          n._tasks.length === 0 && n.empty(), n.workers += 1, n.workers === n.concurrency && n.saturated(), n._worker(i.data, _0(n._next(i)));
        }
      }, this._worker = t, e === 0)
        throw new Error("Concurrency must not be zero");
      this.concurrency = e, this.buffer = e / 4;
    }
    return r.prototype._next = function(t) {
      var e = this;
      return function() {
        for (var n = arguments, i = [], o = 0; o < arguments.length; o++)
          i[o] = n[o];
        e.workers -= 1, t.callback.apply(t, i), i[0] != null && e.error(i[0], t.data), e.workers <= e.concurrency - e.buffer && e.unsaturated(), e.idle() && e.drain(), e.process();
      };
    }, r.prototype.push = function(t, e) {
      this._insert(t, !1, e);
    }, r.prototype.kill = function() {
      this.workers = 0, this.drain = $e, this.started = !1, this._tasks = [];
    }, r.prototype.unshift = function(t, e) {
      this._insert(t, !0, e);
    }, r.prototype.length = function() {
      return this._tasks.length;
    }, r.prototype.running = function() {
      return this.workers;
    }, r.prototype.idle = function() {
      return this._tasks.length + this.workers === 0;
    }, r.prototype.pause = function() {
      this.paused !== !0 && (this.paused = !0);
    }, r.prototype.resume = function() {
      if (this.paused !== !1) {
        this.paused = !1;
        for (var t = 1; t <= this.concurrency; t++)
          this.process();
      }
    }, r.eachSeries = function(t, e, n, i) {
      var o = 0, a = t.length;
      function s(h) {
        if (h || o === a) {
          n && n(h);
          return;
        }
        i ? setTimeout(function() {
          e(t[o++], s);
        }, 1) : e(t[o++], s);
      }
      s();
    }, r.queue = function(t, e) {
      return new r(t, e);
    }, r;
  }()
), Oo = 100, y0 = /(#[\w-]+)?$/, Ri = (
  /** @class */
  function() {
    function r(t, e) {
      var n = this;
      t === void 0 && (t = ""), e === void 0 && (e = 10), this.progress = 0, this.loading = !1, this.defaultQueryString = "", this._beforeMiddleware = [], this._afterMiddleware = [], this._resourcesParsing = [], this._boundLoadResource = function(h, u) {
        return n._loadResource(h, u);
      }, this.resources = {}, this.baseUrl = t, this._beforeMiddleware = [], this._afterMiddleware = [], this._resourcesParsing = [], this._boundLoadResource = function(h, u) {
        return n._loadResource(h, u);
      }, this._queue = Po.queue(this._boundLoadResource, e), this._queue.pause(), this.resources = {}, this.onProgress = new Oe(), this.onError = new Oe(), this.onLoad = new Oe(), this.onStart = new Oe(), this.onComplete = new Oe();
      for (var i = 0; i < r._plugins.length; ++i) {
        var o = r._plugins[i], a = o.pre, s = o.use;
        a && this.pre(a), s && this.use(s);
      }
      this._protected = !1;
    }
    return r.prototype._add = function(t, e, n, i) {
      if (this.loading && (!n || !n.parentResource))
        throw new Error("Cannot add resources while the loader is running.");
      if (this.resources[t])
        throw new Error('Resource named "' + t + '" already exists.');
      if (e = this._prepareUrl(e), this.resources[t] = new Ot(t, e, n), typeof i == "function" && this.resources[t].onAfterMiddleware.once(i), this.loading) {
        for (var o = n.parentResource, a = [], s = 0; s < o.children.length; ++s)
          o.children[s].isComplete || a.push(o.children[s]);
        var h = o.progressChunk * (a.length + 1), u = h / (a.length + 2);
        o.children.push(this.resources[t]), o.progressChunk = u;
        for (var s = 0; s < a.length; ++s)
          a[s].progressChunk = u;
        this.resources[t].progressChunk = u;
      }
      return this._queue.push(this.resources[t]), this;
    }, r.prototype.pre = function(t) {
      return this._beforeMiddleware.push(t), this;
    }, r.prototype.use = function(t) {
      return this._afterMiddleware.push(t), this;
    }, r.prototype.reset = function() {
      this.progress = 0, this.loading = !1, this._queue.kill(), this._queue.pause();
      for (var t in this.resources) {
        var e = this.resources[t];
        e._onLoadBinding && e._onLoadBinding.detach(), e.isLoading && e.abort("loader reset");
      }
      return this.resources = {}, this;
    }, r.prototype.load = function(t) {
      if (ce("6.5.0", "@pixi/loaders is being replaced with @pixi/assets in the next major release."), typeof t == "function" && this.onComplete.once(t), this.loading)
        return this;
      if (this._queue.idle())
        this._onStart(), this._onComplete();
      else {
        for (var e = this._queue._tasks.length, n = Oo / e, i = 0; i < this._queue._tasks.length; ++i)
          this._queue._tasks[i].data.progressChunk = n;
        this._onStart(), this._queue.resume();
      }
      return this;
    }, Object.defineProperty(r.prototype, "concurrency", {
      /**
       * The number of resources to load concurrently.
       * @default 10
       */
      get: function() {
        return this._queue.concurrency;
      },
      set: function(t) {
        this._queue.concurrency = t;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._prepareUrl = function(t) {
      var e = Ml(t, { strictMode: !0 }), n;
      if (e.protocol || !e.path || t.indexOf("//") === 0 ? n = t : this.baseUrl.length && this.baseUrl.lastIndexOf("/") !== this.baseUrl.length - 1 && t.charAt(0) !== "/" ? n = this.baseUrl + "/" + t : n = this.baseUrl + t, this.defaultQueryString) {
        var i = y0.exec(n)[0];
        n = n.slice(0, n.length - i.length), n.indexOf("?") !== -1 ? n += "&" + this.defaultQueryString : n += "?" + this.defaultQueryString, n += i;
      }
      return n;
    }, r.prototype._loadResource = function(t, e) {
      var n = this;
      t._dequeue = e, Po.eachSeries(this._beforeMiddleware, function(i, o) {
        i.call(n, t, function() {
          o(t.isComplete ? {} : null);
        });
      }, function() {
        t.isComplete ? n._onLoad(t) : (t._onLoadBinding = t.onComplete.once(n._onLoad, n), t.load());
      }, !0);
    }, r.prototype._onStart = function() {
      this.progress = 0, this.loading = !0, this.onStart.dispatch(this);
    }, r.prototype._onComplete = function() {
      this.progress = Oo, this.loading = !1, this.onComplete.dispatch(this, this.resources);
    }, r.prototype._onLoad = function(t) {
      var e = this;
      t._onLoadBinding = null, this._resourcesParsing.push(t), t._dequeue(), Po.eachSeries(this._afterMiddleware, function(n, i) {
        n.call(e, t, i);
      }, function() {
        t.onAfterMiddleware.dispatch(t), e.progress = Math.min(Oo, e.progress + t.progressChunk), e.onProgress.dispatch(e, t), t.error ? e.onError.dispatch(t.error, e, t) : e.onLoad.dispatch(e, t), e._resourcesParsing.splice(e._resourcesParsing.indexOf(t), 1), e._queue.idle() && e._resourcesParsing.length === 0 && e._onComplete();
      }, !0);
    }, r.prototype.destroy = function() {
      this._protected || this.reset();
    }, Object.defineProperty(r, "shared", {
      /** A premade instance of the loader that can be used to load resources. */
      get: function() {
        var t = r._shared;
        return t || (t = new r(), t._protected = !0, r._shared = t), t;
      },
      enumerable: !1,
      configurable: !0
    }), r.registerPlugin = function(t) {
      return ce("6.5.0", "Loader.registerPlugin() is deprecated, use extensions.add() instead."), Me.add({
        type: mt.Loader,
        ref: t
      }), r;
    }, r._plugins = [], r;
  }()
);
Me.handleByList(mt.Loader, Ri._plugins);
Ri.prototype.add = function(t, e, n, i) {
  if (Array.isArray(t)) {
    for (var o = 0; o < t.length; ++o)
      this.add(t[o]);
    return this;
  }
  if (typeof t == "object" && (n = t, i = e || n.callback || n.onComplete, e = n.url, t = n.name || n.key || n.url), typeof e != "string" && (i = n, n = e, e = t), typeof e != "string")
    throw new Error("No url passed to add resource to loader.");
  return typeof n == "function" && (i = n, n = null), this._add(t, e, n, i);
};
var g0 = (
  /** @class */
  function() {
    function r() {
    }
    return r.init = function(t) {
      t = Object.assign({
        sharedLoader: !1
      }, t), this.loader = t.sharedLoader ? Ri.shared : new Ri();
    }, r.destroy = function() {
      this.loader && (this.loader.destroy(), this.loader = null);
    }, r.extension = mt.Application, r;
  }()
), b0 = (
  /** @class */
  function() {
    function r() {
    }
    return r.add = function() {
      Ot.setExtensionLoadType("svg", Ot.LOAD_TYPE.XHR), Ot.setExtensionXhrType("svg", Ot.XHR_RESPONSE_TYPE.TEXT);
    }, r.use = function(t, e) {
      if (t.data && (t.type === Ot.TYPE.IMAGE || t.extension === "svg")) {
        var n = t.data, i = t.url, o = t.name, a = t.metadata;
        J.fromLoader(n, i, o, a).then(function(s) {
          t.texture = s, e();
        }).catch(e);
      } else
        e();
    }, r.extension = mt.Loader, r;
  }()
), x0 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function T0(r) {
  for (var t = "", e = 0; e < r.length; ) {
    for (var n = [0, 0, 0], i = [0, 0, 0, 0], o = 0; o < n.length; ++o)
      e < r.length ? n[o] = r.charCodeAt(e++) & 255 : n[o] = 0;
    i[0] = n[0] >> 2, i[1] = (n[0] & 3) << 4 | n[1] >> 4, i[2] = (n[1] & 15) << 2 | n[2] >> 6, i[3] = n[2] & 63;
    var a = e - (r.length - 1);
    switch (a) {
      case 2:
        i[3] = 64, i[2] = 64;
        break;
      case 1:
        i[3] = 64;
        break;
    }
    for (var o = 0; o < i.length; ++o)
      t += x0.charAt(i[o]);
  }
  return t;
}
function E0(r, t) {
  if (!r.data) {
    t();
    return;
  }
  if (r.xhr && r.xhrType === Ot.XHR_RESPONSE_TYPE.BLOB) {
    if (!self.Blob || typeof r.data == "string") {
      var e = r.xhr.getResponseHeader("content-type");
      if (e && e.indexOf("image") === 0) {
        r.data = new Image(), r.data.src = "data:" + e + ";base64," + T0(r.xhr.responseText), r.type = Ot.TYPE.IMAGE, r.data.onload = function() {
          r.data.onload = null, t();
        };
        return;
      }
    } else if (r.data.type.indexOf("image") === 0) {
      var n = globalThis.URL || globalThis.webkitURL, i = n.createObjectURL(r.data);
      r.blob = r.data, r.data = new Image(), r.data.src = i, r.type = Ot.TYPE.IMAGE, r.data.onload = function() {
        n.revokeObjectURL(i), r.data.onload = null, t();
      };
      return;
    }
  }
  t();
}
var w0 = (
  /** @class */
  function() {
    function r() {
    }
    return r.extension = mt.Loader, r.use = E0, r;
  }()
);
Me.add(b0, w0);
/*!
 * @pixi/compressed-textures - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/compressed-textures is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var vt, rt;
(function(r) {
  r[r.COMPRESSED_RGB_S3TC_DXT1_EXT = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT", r[r.COMPRESSED_RGBA_S3TC_DXT1_EXT = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT", r[r.COMPRESSED_RGBA_S3TC_DXT3_EXT = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT", r[r.COMPRESSED_RGBA_S3TC_DXT5_EXT = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT", r[r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT", r[r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT", r[r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT", r[r.COMPRESSED_SRGB_S3TC_DXT1_EXT = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT", r[r.COMPRESSED_R11_EAC = 37488] = "COMPRESSED_R11_EAC", r[r.COMPRESSED_SIGNED_R11_EAC = 37489] = "COMPRESSED_SIGNED_R11_EAC", r[r.COMPRESSED_RG11_EAC = 37490] = "COMPRESSED_RG11_EAC", r[r.COMPRESSED_SIGNED_RG11_EAC = 37491] = "COMPRESSED_SIGNED_RG11_EAC", r[r.COMPRESSED_RGB8_ETC2 = 37492] = "COMPRESSED_RGB8_ETC2", r[r.COMPRESSED_RGBA8_ETC2_EAC = 37496] = "COMPRESSED_RGBA8_ETC2_EAC", r[r.COMPRESSED_SRGB8_ETC2 = 37493] = "COMPRESSED_SRGB8_ETC2", r[r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = 37497] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC", r[r.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37494] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2", r[r.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37495] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2", r[r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG", r[r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG", r[r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG", r[r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG", r[r.COMPRESSED_RGB_ETC1_WEBGL = 36196] = "COMPRESSED_RGB_ETC1_WEBGL", r[r.COMPRESSED_RGB_ATC_WEBGL = 35986] = "COMPRESSED_RGB_ATC_WEBGL", r[r.COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 35986] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL", r[r.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL", r[r.COMPRESSED_RGBA_ASTC_4x4_KHR = 37808] = "COMPRESSED_RGBA_ASTC_4x4_KHR";
})(rt || (rt = {}));
var Ii = (vt = {}, // WEBGL_compressed_texture_s3tc
vt[rt.COMPRESSED_RGB_S3TC_DXT1_EXT] = 0.5, vt[rt.COMPRESSED_RGBA_S3TC_DXT1_EXT] = 0.5, vt[rt.COMPRESSED_RGBA_S3TC_DXT3_EXT] = 1, vt[rt.COMPRESSED_RGBA_S3TC_DXT5_EXT] = 1, // WEBGL_compressed_texture_s3tc
vt[rt.COMPRESSED_SRGB_S3TC_DXT1_EXT] = 0.5, vt[rt.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT] = 0.5, vt[rt.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT] = 1, vt[rt.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT] = 1, // WEBGL_compressed_texture_etc
vt[rt.COMPRESSED_R11_EAC] = 0.5, vt[rt.COMPRESSED_SIGNED_R11_EAC] = 0.5, vt[rt.COMPRESSED_RG11_EAC] = 1, vt[rt.COMPRESSED_SIGNED_RG11_EAC] = 1, vt[rt.COMPRESSED_RGB8_ETC2] = 0.5, vt[rt.COMPRESSED_RGBA8_ETC2_EAC] = 1, vt[rt.COMPRESSED_SRGB8_ETC2] = 0.5, vt[rt.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC] = 1, vt[rt.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2] = 0.5, vt[rt.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2] = 0.5, // WEBGL_compressed_texture_pvrtc
vt[rt.COMPRESSED_RGB_PVRTC_4BPPV1_IMG] = 0.5, vt[rt.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG] = 0.5, vt[rt.COMPRESSED_RGB_PVRTC_2BPPV1_IMG] = 0.25, vt[rt.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG] = 0.25, // WEBGL_compressed_texture_etc1
vt[rt.COMPRESSED_RGB_ETC1_WEBGL] = 0.5, // @see https://www.khronos.org/registry/OpenGL/extensions/AMD/AMD_compressed_ATC_texture.txt
// WEBGL_compressed_texture_atc
vt[rt.COMPRESSED_RGB_ATC_WEBGL] = 0.5, vt[rt.COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL] = 1, vt[rt.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL] = 1, // @see https://registry.khronos.org/OpenGL/extensions/KHR/KHR_texture_compression_astc_hdr.txt
// WEBGL_compressed_texture_astc
/* eslint-disable-next-line camelcase */
vt[rt.COMPRESSED_RGBA_ASTC_4x4_KHR] = 1, vt);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var fa = function(r, t) {
  return fa = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, fa(r, t);
};
function Dl(r, t) {
  fa(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
function S0(r, t, e, n) {
  function i(o) {
    return o instanceof e ? o : new e(function(a) {
      a(o);
    });
  }
  return new (e || (e = Promise))(function(o, a) {
    function s(l) {
      try {
        u(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function h(l) {
      try {
        u(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(s, h);
    }
    u((n = n.apply(r, t || [])).next());
  });
}
function A0(r, t) {
  var e = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(l) {
      return h([u, l]);
    };
  }
  function h(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; e; )
      try {
        if (n = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done)
          return o;
        switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
          case 0:
          case 1:
            o = u;
            break;
          case 4:
            return e.label++, { value: u[1], done: !1 };
          case 5:
            e.label++, i = u[1], u = [0];
            continue;
          case 7:
            u = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (o = e.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              e = 0;
              continue;
            }
            if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
              e.label = u[1];
              break;
            }
            if (u[0] === 6 && e.label < o[1]) {
              e.label = o[1], o = u;
              break;
            }
            if (o && e.label < o[2]) {
              e.label = o[2], e.ops.push(u);
              break;
            }
            o[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        u = t.call(r, e);
      } catch (l) {
        u = [6, l], i = 0;
      } finally {
        n = o = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
var P0 = (
  /** @class */
  function(r) {
    Dl(t, r);
    function t(e, n) {
      n === void 0 && (n = { width: 1, height: 1, autoLoad: !0 });
      var i = this, o, a;
      return typeof e == "string" ? (o = e, a = new Uint8Array()) : (o = null, a = e), i = r.call(this, a, n) || this, i.origin = o, i.buffer = a ? new ua(a) : null, i.origin && n.autoLoad !== !1 && i.load(), a && a.length && (i.loaded = !0, i.onBlobLoaded(i.buffer.rawBinaryData)), i;
    }
    return t.prototype.onBlobLoaded = function(e) {
    }, t.prototype.load = function() {
      return S0(this, void 0, Promise, function() {
        var e, n, i;
        return A0(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, fetch(this.origin)];
            case 1:
              return e = o.sent(), [4, e.blob()];
            case 2:
              return n = o.sent(), [4, n.arrayBuffer()];
            case 3:
              return i = o.sent(), this.data = new Uint32Array(i), this.buffer = new ua(i), this.loaded = !0, this.onBlobLoaded(i), this.update(), [2, this];
          }
        });
      });
    }, t;
  }(Pn)
), ca = (
  /** @class */
  function(r) {
    Dl(t, r);
    function t(e, n) {
      var i = r.call(this, e, n) || this;
      return i.format = n.format, i.levels = n.levels || 1, i._width = n.width, i._height = n.height, i._extension = t._formatToExtension(i.format), (n.levelBuffers || i.buffer) && (i._levelBuffers = n.levelBuffers || t._createLevelBuffers(
        e instanceof Uint8Array ? e : i.buffer.uint8View,
        i.format,
        i.levels,
        4,
        4,
        // PVRTC has 8x4 blocks in 2bpp mode
        i.width,
        i.height
      )), i;
    }
    return t.prototype.upload = function(e, n, i) {
      var o = e.gl, a = e.context.extensions[this._extension];
      if (!a)
        throw new Error(this._extension + " textures are not supported on the current machine");
      if (!this._levelBuffers)
        return !1;
      for (var s = 0, h = this.levels; s < h; s++) {
        var u = this._levelBuffers[s], l = u.levelID, f = u.levelWidth, c = u.levelHeight, d = u.levelBuffer;
        o.compressedTexImage2D(o.TEXTURE_2D, l, this.format, f, c, 0, d);
      }
      return !0;
    }, t.prototype.onBlobLoaded = function() {
      this._levelBuffers = t._createLevelBuffers(
        this.buffer.uint8View,
        this.format,
        this.levels,
        4,
        4,
        // PVRTC has 8x4 blocks in 2bpp mode
        this.width,
        this.height
      );
    }, t._formatToExtension = function(e) {
      if (e >= 33776 && e <= 33779)
        return "s3tc";
      if (e >= 37488 && e <= 37497)
        return "etc";
      if (e >= 35840 && e <= 35843)
        return "pvrtc";
      if (e >= 36196)
        return "etc1";
      if (e >= 35986 && e <= 34798)
        return "atc";
      throw new Error("Invalid (compressed) texture format given!");
    }, t._createLevelBuffers = function(e, n, i, o, a, s, h) {
      for (var u = new Array(i), l = e.byteOffset, f = s, c = h, d = f + o - 1 & ~(o - 1), p = c + a - 1 & ~(a - 1), v = d * p * Ii[n], _ = 0; _ < i; _++)
        u[_] = {
          levelID: _,
          levelWidth: i > 1 ? f : d,
          levelHeight: i > 1 ? c : p,
          levelBuffer: new Uint8Array(e.buffer, l, v)
        }, l += v, f = f >> 1 || 1, c = c >> 1 || 1, d = f + o - 1 & ~(o - 1), p = c + a - 1 & ~(a - 1), v = d * p * Ii[n];
      return u;
    }, t;
  }(P0)
), O0 = (
  /** @class */
  function() {
    function r() {
    }
    return r.use = function(t, e) {
      var n = t.data, i = this;
      if (t.type === Ot.TYPE.JSON && n && n.cacheID && n.textures) {
        for (var o = n.textures, a = void 0, s = void 0, h = 0, u = o.length; h < u; h++) {
          var l = o[h], f = l.src, c = l.format;
          if (c || (s = f), r.textureFormats[c]) {
            a = f;
            break;
          }
        }
        if (a = a || s, !a) {
          e(new Error("Cannot load compressed-textures in " + t.url + ", make sure you provide a fallback"));
          return;
        }
        if (a === t.url) {
          e(new Error("URL of compressed texture cannot be the same as the manifest's URL"));
          return;
        }
        var d = {
          crossOrigin: t.crossOrigin,
          metadata: t.metadata.imageMetadata,
          parentResource: t
        }, p = Rr.resolve(t.url.replace(i.baseUrl, ""), a), v = n.cacheID;
        i.add(v, p, d, function(_) {
          if (_.error) {
            e(_.error);
            return;
          }
          var m = _.texture, y = m === void 0 ? null : m, g = _.textures, x = g === void 0 ? {} : g;
          Object.assign(t, { texture: y, textures: x }), e();
        });
      } else
        e();
    }, Object.defineProperty(r, "textureExtensions", {
      /**  Map of available texture extensions. */
      get: function() {
        if (!r._textureExtensions) {
          var t = G.ADAPTER.createCanvas(), e = t.getContext("webgl");
          if (!e)
            return console.warn("WebGL not available for compressed textures. Silently failing."), {};
          var n = {
            s3tc: e.getExtension("WEBGL_compressed_texture_s3tc"),
            s3tc_sRGB: e.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
            etc: e.getExtension("WEBGL_compressed_texture_etc"),
            etc1: e.getExtension("WEBGL_compressed_texture_etc1"),
            pvrtc: e.getExtension("WEBGL_compressed_texture_pvrtc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
            atc: e.getExtension("WEBGL_compressed_texture_atc"),
            astc: e.getExtension("WEBGL_compressed_texture_astc")
          };
          r._textureExtensions = n;
        }
        return r._textureExtensions;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r, "textureFormats", {
      /** Map of available texture formats. */
      get: function() {
        if (!r._textureFormats) {
          var t = r.textureExtensions;
          r._textureFormats = {};
          for (var e in t) {
            var n = t[e];
            n && Object.assign(r._textureFormats, Object.getPrototypeOf(n));
          }
        }
        return r._textureFormats;
      },
      enumerable: !1,
      configurable: !0
    }), r.extension = mt.Loader, r;
  }()
);
function Fl(r, t, e) {
  var n = {
    textures: {},
    texture: null
  };
  if (!t)
    return n;
  var i = t.map(function(o) {
    return new J(new ht(o, Object.assign({
      mipmap: de.OFF,
      alphaMode: pe.NO_PREMULTIPLIED_ALPHA
    }, e)));
  });
  return i.forEach(function(o, a) {
    var s = o.baseTexture, h = r + "-" + (a + 1);
    ht.addToCache(s, h), J.addToCache(o, h), a === 0 && (ht.addToCache(s, r), J.addToCache(o, r), n.texture = o), n.textures[h] = o;
  }), n;
}
var Qr, ie, Ro = 4, ei = 124, R0 = 32, Hh = 20, I0 = 542327876, ri = {
  SIZE: 1,
  FLAGS: 2,
  HEIGHT: 3,
  WIDTH: 4,
  MIPMAP_COUNT: 7,
  PIXEL_FORMAT: 19
}, C0 = {
  SIZE: 0,
  FLAGS: 1,
  FOURCC: 2,
  RGB_BITCOUNT: 3,
  R_BIT_MASK: 4,
  G_BIT_MASK: 5,
  B_BIT_MASK: 6,
  A_BIT_MASK: 7
}, ni = {
  DXGI_FORMAT: 0,
  RESOURCE_DIMENSION: 1,
  MISC_FLAG: 2,
  ARRAY_SIZE: 3,
  MISC_FLAGS2: 4
}, se;
(function(r) {
  r[r.DXGI_FORMAT_UNKNOWN = 0] = "DXGI_FORMAT_UNKNOWN", r[r.DXGI_FORMAT_R32G32B32A32_TYPELESS = 1] = "DXGI_FORMAT_R32G32B32A32_TYPELESS", r[r.DXGI_FORMAT_R32G32B32A32_FLOAT = 2] = "DXGI_FORMAT_R32G32B32A32_FLOAT", r[r.DXGI_FORMAT_R32G32B32A32_UINT = 3] = "DXGI_FORMAT_R32G32B32A32_UINT", r[r.DXGI_FORMAT_R32G32B32A32_SINT = 4] = "DXGI_FORMAT_R32G32B32A32_SINT", r[r.DXGI_FORMAT_R32G32B32_TYPELESS = 5] = "DXGI_FORMAT_R32G32B32_TYPELESS", r[r.DXGI_FORMAT_R32G32B32_FLOAT = 6] = "DXGI_FORMAT_R32G32B32_FLOAT", r[r.DXGI_FORMAT_R32G32B32_UINT = 7] = "DXGI_FORMAT_R32G32B32_UINT", r[r.DXGI_FORMAT_R32G32B32_SINT = 8] = "DXGI_FORMAT_R32G32B32_SINT", r[r.DXGI_FORMAT_R16G16B16A16_TYPELESS = 9] = "DXGI_FORMAT_R16G16B16A16_TYPELESS", r[r.DXGI_FORMAT_R16G16B16A16_FLOAT = 10] = "DXGI_FORMAT_R16G16B16A16_FLOAT", r[r.DXGI_FORMAT_R16G16B16A16_UNORM = 11] = "DXGI_FORMAT_R16G16B16A16_UNORM", r[r.DXGI_FORMAT_R16G16B16A16_UINT = 12] = "DXGI_FORMAT_R16G16B16A16_UINT", r[r.DXGI_FORMAT_R16G16B16A16_SNORM = 13] = "DXGI_FORMAT_R16G16B16A16_SNORM", r[r.DXGI_FORMAT_R16G16B16A16_SINT = 14] = "DXGI_FORMAT_R16G16B16A16_SINT", r[r.DXGI_FORMAT_R32G32_TYPELESS = 15] = "DXGI_FORMAT_R32G32_TYPELESS", r[r.DXGI_FORMAT_R32G32_FLOAT = 16] = "DXGI_FORMAT_R32G32_FLOAT", r[r.DXGI_FORMAT_R32G32_UINT = 17] = "DXGI_FORMAT_R32G32_UINT", r[r.DXGI_FORMAT_R32G32_SINT = 18] = "DXGI_FORMAT_R32G32_SINT", r[r.DXGI_FORMAT_R32G8X24_TYPELESS = 19] = "DXGI_FORMAT_R32G8X24_TYPELESS", r[r.DXGI_FORMAT_D32_FLOAT_S8X24_UINT = 20] = "DXGI_FORMAT_D32_FLOAT_S8X24_UINT", r[r.DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS = 21] = "DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS", r[r.DXGI_FORMAT_X32_TYPELESS_G8X24_UINT = 22] = "DXGI_FORMAT_X32_TYPELESS_G8X24_UINT", r[r.DXGI_FORMAT_R10G10B10A2_TYPELESS = 23] = "DXGI_FORMAT_R10G10B10A2_TYPELESS", r[r.DXGI_FORMAT_R10G10B10A2_UNORM = 24] = "DXGI_FORMAT_R10G10B10A2_UNORM", r[r.DXGI_FORMAT_R10G10B10A2_UINT = 25] = "DXGI_FORMAT_R10G10B10A2_UINT", r[r.DXGI_FORMAT_R11G11B10_FLOAT = 26] = "DXGI_FORMAT_R11G11B10_FLOAT", r[r.DXGI_FORMAT_R8G8B8A8_TYPELESS = 27] = "DXGI_FORMAT_R8G8B8A8_TYPELESS", r[r.DXGI_FORMAT_R8G8B8A8_UNORM = 28] = "DXGI_FORMAT_R8G8B8A8_UNORM", r[r.DXGI_FORMAT_R8G8B8A8_UNORM_SRGB = 29] = "DXGI_FORMAT_R8G8B8A8_UNORM_SRGB", r[r.DXGI_FORMAT_R8G8B8A8_UINT = 30] = "DXGI_FORMAT_R8G8B8A8_UINT", r[r.DXGI_FORMAT_R8G8B8A8_SNORM = 31] = "DXGI_FORMAT_R8G8B8A8_SNORM", r[r.DXGI_FORMAT_R8G8B8A8_SINT = 32] = "DXGI_FORMAT_R8G8B8A8_SINT", r[r.DXGI_FORMAT_R16G16_TYPELESS = 33] = "DXGI_FORMAT_R16G16_TYPELESS", r[r.DXGI_FORMAT_R16G16_FLOAT = 34] = "DXGI_FORMAT_R16G16_FLOAT", r[r.DXGI_FORMAT_R16G16_UNORM = 35] = "DXGI_FORMAT_R16G16_UNORM", r[r.DXGI_FORMAT_R16G16_UINT = 36] = "DXGI_FORMAT_R16G16_UINT", r[r.DXGI_FORMAT_R16G16_SNORM = 37] = "DXGI_FORMAT_R16G16_SNORM", r[r.DXGI_FORMAT_R16G16_SINT = 38] = "DXGI_FORMAT_R16G16_SINT", r[r.DXGI_FORMAT_R32_TYPELESS = 39] = "DXGI_FORMAT_R32_TYPELESS", r[r.DXGI_FORMAT_D32_FLOAT = 40] = "DXGI_FORMAT_D32_FLOAT", r[r.DXGI_FORMAT_R32_FLOAT = 41] = "DXGI_FORMAT_R32_FLOAT", r[r.DXGI_FORMAT_R32_UINT = 42] = "DXGI_FORMAT_R32_UINT", r[r.DXGI_FORMAT_R32_SINT = 43] = "DXGI_FORMAT_R32_SINT", r[r.DXGI_FORMAT_R24G8_TYPELESS = 44] = "DXGI_FORMAT_R24G8_TYPELESS", r[r.DXGI_FORMAT_D24_UNORM_S8_UINT = 45] = "DXGI_FORMAT_D24_UNORM_S8_UINT", r[r.DXGI_FORMAT_R24_UNORM_X8_TYPELESS = 46] = "DXGI_FORMAT_R24_UNORM_X8_TYPELESS", r[r.DXGI_FORMAT_X24_TYPELESS_G8_UINT = 47] = "DXGI_FORMAT_X24_TYPELESS_G8_UINT", r[r.DXGI_FORMAT_R8G8_TYPELESS = 48] = "DXGI_FORMAT_R8G8_TYPELESS", r[r.DXGI_FORMAT_R8G8_UNORM = 49] = "DXGI_FORMAT_R8G8_UNORM", r[r.DXGI_FORMAT_R8G8_UINT = 50] = "DXGI_FORMAT_R8G8_UINT", r[r.DXGI_FORMAT_R8G8_SNORM = 51] = "DXGI_FORMAT_R8G8_SNORM", r[r.DXGI_FORMAT_R8G8_SINT = 52] = "DXGI_FORMAT_R8G8_SINT", r[r.DXGI_FORMAT_R16_TYPELESS = 53] = "DXGI_FORMAT_R16_TYPELESS", r[r.DXGI_FORMAT_R16_FLOAT = 54] = "DXGI_FORMAT_R16_FLOAT", r[r.DXGI_FORMAT_D16_UNORM = 55] = "DXGI_FORMAT_D16_UNORM", r[r.DXGI_FORMAT_R16_UNORM = 56] = "DXGI_FORMAT_R16_UNORM", r[r.DXGI_FORMAT_R16_UINT = 57] = "DXGI_FORMAT_R16_UINT", r[r.DXGI_FORMAT_R16_SNORM = 58] = "DXGI_FORMAT_R16_SNORM", r[r.DXGI_FORMAT_R16_SINT = 59] = "DXGI_FORMAT_R16_SINT", r[r.DXGI_FORMAT_R8_TYPELESS = 60] = "DXGI_FORMAT_R8_TYPELESS", r[r.DXGI_FORMAT_R8_UNORM = 61] = "DXGI_FORMAT_R8_UNORM", r[r.DXGI_FORMAT_R8_UINT = 62] = "DXGI_FORMAT_R8_UINT", r[r.DXGI_FORMAT_R8_SNORM = 63] = "DXGI_FORMAT_R8_SNORM", r[r.DXGI_FORMAT_R8_SINT = 64] = "DXGI_FORMAT_R8_SINT", r[r.DXGI_FORMAT_A8_UNORM = 65] = "DXGI_FORMAT_A8_UNORM", r[r.DXGI_FORMAT_R1_UNORM = 66] = "DXGI_FORMAT_R1_UNORM", r[r.DXGI_FORMAT_R9G9B9E5_SHAREDEXP = 67] = "DXGI_FORMAT_R9G9B9E5_SHAREDEXP", r[r.DXGI_FORMAT_R8G8_B8G8_UNORM = 68] = "DXGI_FORMAT_R8G8_B8G8_UNORM", r[r.DXGI_FORMAT_G8R8_G8B8_UNORM = 69] = "DXGI_FORMAT_G8R8_G8B8_UNORM", r[r.DXGI_FORMAT_BC1_TYPELESS = 70] = "DXGI_FORMAT_BC1_TYPELESS", r[r.DXGI_FORMAT_BC1_UNORM = 71] = "DXGI_FORMAT_BC1_UNORM", r[r.DXGI_FORMAT_BC1_UNORM_SRGB = 72] = "DXGI_FORMAT_BC1_UNORM_SRGB", r[r.DXGI_FORMAT_BC2_TYPELESS = 73] = "DXGI_FORMAT_BC2_TYPELESS", r[r.DXGI_FORMAT_BC2_UNORM = 74] = "DXGI_FORMAT_BC2_UNORM", r[r.DXGI_FORMAT_BC2_UNORM_SRGB = 75] = "DXGI_FORMAT_BC2_UNORM_SRGB", r[r.DXGI_FORMAT_BC3_TYPELESS = 76] = "DXGI_FORMAT_BC3_TYPELESS", r[r.DXGI_FORMAT_BC3_UNORM = 77] = "DXGI_FORMAT_BC3_UNORM", r[r.DXGI_FORMAT_BC3_UNORM_SRGB = 78] = "DXGI_FORMAT_BC3_UNORM_SRGB", r[r.DXGI_FORMAT_BC4_TYPELESS = 79] = "DXGI_FORMAT_BC4_TYPELESS", r[r.DXGI_FORMAT_BC4_UNORM = 80] = "DXGI_FORMAT_BC4_UNORM", r[r.DXGI_FORMAT_BC4_SNORM = 81] = "DXGI_FORMAT_BC4_SNORM", r[r.DXGI_FORMAT_BC5_TYPELESS = 82] = "DXGI_FORMAT_BC5_TYPELESS", r[r.DXGI_FORMAT_BC5_UNORM = 83] = "DXGI_FORMAT_BC5_UNORM", r[r.DXGI_FORMAT_BC5_SNORM = 84] = "DXGI_FORMAT_BC5_SNORM", r[r.DXGI_FORMAT_B5G6R5_UNORM = 85] = "DXGI_FORMAT_B5G6R5_UNORM", r[r.DXGI_FORMAT_B5G5R5A1_UNORM = 86] = "DXGI_FORMAT_B5G5R5A1_UNORM", r[r.DXGI_FORMAT_B8G8R8A8_UNORM = 87] = "DXGI_FORMAT_B8G8R8A8_UNORM", r[r.DXGI_FORMAT_B8G8R8X8_UNORM = 88] = "DXGI_FORMAT_B8G8R8X8_UNORM", r[r.DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM = 89] = "DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM", r[r.DXGI_FORMAT_B8G8R8A8_TYPELESS = 90] = "DXGI_FORMAT_B8G8R8A8_TYPELESS", r[r.DXGI_FORMAT_B8G8R8A8_UNORM_SRGB = 91] = "DXGI_FORMAT_B8G8R8A8_UNORM_SRGB", r[r.DXGI_FORMAT_B8G8R8X8_TYPELESS = 92] = "DXGI_FORMAT_B8G8R8X8_TYPELESS", r[r.DXGI_FORMAT_B8G8R8X8_UNORM_SRGB = 93] = "DXGI_FORMAT_B8G8R8X8_UNORM_SRGB", r[r.DXGI_FORMAT_BC6H_TYPELESS = 94] = "DXGI_FORMAT_BC6H_TYPELESS", r[r.DXGI_FORMAT_BC6H_UF16 = 95] = "DXGI_FORMAT_BC6H_UF16", r[r.DXGI_FORMAT_BC6H_SF16 = 96] = "DXGI_FORMAT_BC6H_SF16", r[r.DXGI_FORMAT_BC7_TYPELESS = 97] = "DXGI_FORMAT_BC7_TYPELESS", r[r.DXGI_FORMAT_BC7_UNORM = 98] = "DXGI_FORMAT_BC7_UNORM", r[r.DXGI_FORMAT_BC7_UNORM_SRGB = 99] = "DXGI_FORMAT_BC7_UNORM_SRGB", r[r.DXGI_FORMAT_AYUV = 100] = "DXGI_FORMAT_AYUV", r[r.DXGI_FORMAT_Y410 = 101] = "DXGI_FORMAT_Y410", r[r.DXGI_FORMAT_Y416 = 102] = "DXGI_FORMAT_Y416", r[r.DXGI_FORMAT_NV12 = 103] = "DXGI_FORMAT_NV12", r[r.DXGI_FORMAT_P010 = 104] = "DXGI_FORMAT_P010", r[r.DXGI_FORMAT_P016 = 105] = "DXGI_FORMAT_P016", r[r.DXGI_FORMAT_420_OPAQUE = 106] = "DXGI_FORMAT_420_OPAQUE", r[r.DXGI_FORMAT_YUY2 = 107] = "DXGI_FORMAT_YUY2", r[r.DXGI_FORMAT_Y210 = 108] = "DXGI_FORMAT_Y210", r[r.DXGI_FORMAT_Y216 = 109] = "DXGI_FORMAT_Y216", r[r.DXGI_FORMAT_NV11 = 110] = "DXGI_FORMAT_NV11", r[r.DXGI_FORMAT_AI44 = 111] = "DXGI_FORMAT_AI44", r[r.DXGI_FORMAT_IA44 = 112] = "DXGI_FORMAT_IA44", r[r.DXGI_FORMAT_P8 = 113] = "DXGI_FORMAT_P8", r[r.DXGI_FORMAT_A8P8 = 114] = "DXGI_FORMAT_A8P8", r[r.DXGI_FORMAT_B4G4R4A4_UNORM = 115] = "DXGI_FORMAT_B4G4R4A4_UNORM", r[r.DXGI_FORMAT_P208 = 116] = "DXGI_FORMAT_P208", r[r.DXGI_FORMAT_V208 = 117] = "DXGI_FORMAT_V208", r[r.DXGI_FORMAT_V408 = 118] = "DXGI_FORMAT_V408", r[r.DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE = 119] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE", r[r.DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE = 120] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE", r[r.DXGI_FORMAT_FORCE_UINT = 121] = "DXGI_FORMAT_FORCE_UINT";
})(se || (se = {}));
var da;
(function(r) {
  r[r.DDS_DIMENSION_TEXTURE1D = 2] = "DDS_DIMENSION_TEXTURE1D", r[r.DDS_DIMENSION_TEXTURE2D = 3] = "DDS_DIMENSION_TEXTURE2D", r[r.DDS_DIMENSION_TEXTURE3D = 6] = "DDS_DIMENSION_TEXTURE3D";
})(da || (da = {}));
var M0 = 1, D0 = 2, F0 = 4, B0 = 64, N0 = 512, L0 = 131072, U0 = 827611204, G0 = 861165636, k0 = 894720068, H0 = 808540228, X0 = 4, j0 = (Qr = {}, Qr[U0] = rt.COMPRESSED_RGBA_S3TC_DXT1_EXT, Qr[G0] = rt.COMPRESSED_RGBA_S3TC_DXT3_EXT, Qr[k0] = rt.COMPRESSED_RGBA_S3TC_DXT5_EXT, Qr), Y0 = (ie = {}, // WEBGL_compressed_texture_s3tc
ie[se.DXGI_FORMAT_BC1_TYPELESS] = rt.COMPRESSED_RGBA_S3TC_DXT1_EXT, ie[se.DXGI_FORMAT_BC1_UNORM] = rt.COMPRESSED_RGBA_S3TC_DXT1_EXT, ie[se.DXGI_FORMAT_BC2_TYPELESS] = rt.COMPRESSED_RGBA_S3TC_DXT3_EXT, ie[se.DXGI_FORMAT_BC2_UNORM] = rt.COMPRESSED_RGBA_S3TC_DXT3_EXT, ie[se.DXGI_FORMAT_BC3_TYPELESS] = rt.COMPRESSED_RGBA_S3TC_DXT5_EXT, ie[se.DXGI_FORMAT_BC3_UNORM] = rt.COMPRESSED_RGBA_S3TC_DXT5_EXT, // WEBGL_compressed_texture_s3tc_srgb
ie[se.DXGI_FORMAT_BC1_UNORM_SRGB] = rt.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT, ie[se.DXGI_FORMAT_BC2_UNORM_SRGB] = rt.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT, ie[se.DXGI_FORMAT_BC3_UNORM_SRGB] = rt.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT, ie);
function V0(r) {
  var t = new Uint32Array(r), e = t[0];
  if (e !== I0)
    throw new Error("Invalid DDS file magic word");
  var n = new Uint32Array(r, 0, ei / Uint32Array.BYTES_PER_ELEMENT), i = n[ri.HEIGHT], o = n[ri.WIDTH], a = n[ri.MIPMAP_COUNT], s = new Uint32Array(r, ri.PIXEL_FORMAT * Uint32Array.BYTES_PER_ELEMENT, R0 / Uint32Array.BYTES_PER_ELEMENT), h = s[M0];
  if (h & F0) {
    var u = s[C0.FOURCC];
    if (u !== H0) {
      var l = j0[u], f = Ro + ei, c = new Uint8Array(r, f), d = new ca(c, {
        format: l,
        width: o,
        height: i,
        levels: a
        // CompressedTextureResource will separate the levelBuffers for us!
      });
      return [d];
    }
    var p = Ro + ei, v = new Uint32Array(t.buffer, p, Hh / Uint32Array.BYTES_PER_ELEMENT), _ = v[ni.DXGI_FORMAT], m = v[ni.RESOURCE_DIMENSION], y = v[ni.MISC_FLAG], g = v[ni.ARRAY_SIZE], x = Y0[_];
    if (x === void 0)
      throw new Error("DDSParser cannot parse texture data with DXGI format " + _);
    if (y === X0)
      throw new Error("DDSParser does not support cubemap textures");
    if (m === da.DDS_DIMENSION_TEXTURE3D)
      throw new Error("DDSParser does not supported 3D texture data");
    var T = new Array(), E = Ro + ei + Hh;
    if (g === 1)
      T.push(new Uint8Array(r, E));
    else {
      for (var P = Ii[x], b = 0, w = o, A = i, R = 0; R < a; R++) {
        var C = Math.max(1, w + 3 & -4), M = Math.max(1, A + 3 & -4), H = C * M * P;
        b += H, w = w >>> 1, A = A >>> 1;
      }
      for (var U = E, R = 0; R < g; R++)
        T.push(new Uint8Array(r, U, b)), U += b;
    }
    return T.map(function(B) {
      return new ca(B, {
        format: x,
        width: o,
        height: i,
        levels: a
      });
    });
  }
  throw h & B0 ? new Error("DDSParser does not support uncompressed texture data.") : h & N0 ? new Error("DDSParser does not supported YUV uncompressed texture data.") : h & L0 ? new Error("DDSParser does not support single-channel (lumninance) texture data!") : h & D0 ? new Error("DDSParser does not support single-channel (alpha) texture data!") : new Error("DDSParser failed to load a texture file due to an unknown reason!");
}
var De, Se, tn, Xh = [171, 75, 84, 88, 32, 49, 49, 187, 13, 10, 26, 10], z0 = 67305985, oe = {
  FILE_IDENTIFIER: 0,
  ENDIANNESS: 12,
  GL_TYPE: 16,
  GL_TYPE_SIZE: 20,
  GL_FORMAT: 24,
  GL_INTERNAL_FORMAT: 28,
  GL_BASE_INTERNAL_FORMAT: 32,
  PIXEL_WIDTH: 36,
  PIXEL_HEIGHT: 40,
  PIXEL_DEPTH: 44,
  NUMBER_OF_ARRAY_ELEMENTS: 48,
  NUMBER_OF_FACES: 52,
  NUMBER_OF_MIPMAP_LEVELS: 56,
  BYTES_OF_KEY_VALUE_DATA: 60
}, pa = 64, jh = (De = {}, De[X.UNSIGNED_BYTE] = 1, De[X.UNSIGNED_SHORT] = 2, De[X.INT] = 4, De[X.UNSIGNED_INT] = 4, De[X.FLOAT] = 4, De[X.HALF_FLOAT] = 8, De), W0 = (Se = {}, Se[L.RGBA] = 4, Se[L.RGB] = 3, Se[L.RG] = 2, Se[L.RED] = 1, Se[L.LUMINANCE] = 1, Se[L.LUMINANCE_ALPHA] = 2, Se[L.ALPHA] = 1, Se), $0 = (tn = {}, tn[X.UNSIGNED_SHORT_4_4_4_4] = 2, tn[X.UNSIGNED_SHORT_5_5_5_1] = 2, tn[X.UNSIGNED_SHORT_5_6_5] = 2, tn);
function q0(r, t, e) {
  e === void 0 && (e = !1);
  var n = new DataView(t);
  if (!K0(r, n))
    return null;
  var i = n.getUint32(oe.ENDIANNESS, !0) === z0, o = n.getUint32(oe.GL_TYPE, i), a = n.getUint32(oe.GL_FORMAT, i), s = n.getUint32(oe.GL_INTERNAL_FORMAT, i), h = n.getUint32(oe.PIXEL_WIDTH, i), u = n.getUint32(oe.PIXEL_HEIGHT, i) || 1, l = n.getUint32(oe.PIXEL_DEPTH, i) || 1, f = n.getUint32(oe.NUMBER_OF_ARRAY_ELEMENTS, i) || 1, c = n.getUint32(oe.NUMBER_OF_FACES, i), d = n.getUint32(oe.NUMBER_OF_MIPMAP_LEVELS, i), p = n.getUint32(oe.BYTES_OF_KEY_VALUE_DATA, i);
  if (u === 0 || l !== 1)
    throw new Error("Only 2D textures are supported");
  if (c !== 1)
    throw new Error("CubeTextures are not supported by KTXLoader yet!");
  if (f !== 1)
    throw new Error("WebGL does not support array textures");
  var v = 4, _ = 4, m = h + 3 & -4, y = u + 3 & -4, g = new Array(f), x = h * u;
  o === 0 && (x = m * y);
  var T;
  if (o !== 0 ? jh[o] ? T = jh[o] * W0[a] : T = $0[o] : T = Ii[s], T === void 0)
    throw new Error("Unable to resolve the pixel format stored in the *.ktx file!");
  for (var E = e ? J0(n, p, i) : null, P = x * T, b = P, w = h, A = u, R = m, C = y, M = pa + p, H = 0; H < d; H++) {
    for (var U = n.getUint32(M, i), B = M + 4, $ = 0; $ < f; $++) {
      var q = g[$];
      q || (q = g[$] = new Array(d)), q[H] = {
        levelID: H,
        // don't align mipWidth when texture not compressed! (glType not zero)
        levelWidth: d > 1 || o !== 0 ? w : R,
        levelHeight: d > 1 || o !== 0 ? A : C,
        levelBuffer: new Uint8Array(t, B, b)
      }, B += b;
    }
    M += U + 4, M = M % 4 !== 0 ? M + 4 - M % 4 : M, w = w >> 1 || 1, A = A >> 1 || 1, R = w + v - 1 & ~(v - 1), C = A + _ - 1 & ~(_ - 1), b = R * C * T;
  }
  return o !== 0 ? {
    uncompressed: g.map(function(Q) {
      var N = Q[0].levelBuffer, F = !1;
      return o === X.FLOAT ? N = new Float32Array(Q[0].levelBuffer.buffer, Q[0].levelBuffer.byteOffset, Q[0].levelBuffer.byteLength / 4) : o === X.UNSIGNED_INT ? (F = !0, N = new Uint32Array(Q[0].levelBuffer.buffer, Q[0].levelBuffer.byteOffset, Q[0].levelBuffer.byteLength / 4)) : o === X.INT && (F = !0, N = new Int32Array(Q[0].levelBuffer.buffer, Q[0].levelBuffer.byteOffset, Q[0].levelBuffer.byteLength / 4)), {
        resource: new Pn(N, {
          width: Q[0].levelWidth,
          height: Q[0].levelHeight
        }),
        type: o,
        format: F ? Z0(a) : a
      };
    }),
    kvData: E
  } : {
    compressed: g.map(function(Q) {
      return new ca(null, {
        format: s,
        width: h,
        height: u,
        levels: d,
        levelBuffers: Q
      });
    }),
    kvData: E
  };
}
function K0(r, t) {
  for (var e = 0; e < Xh.length; e++)
    if (t.getUint8(e) !== Xh[e])
      return console.error(r + " is not a valid *.ktx file!"), !1;
  return !0;
}
function Z0(r) {
  switch (r) {
    case L.RGBA:
      return L.RGBA_INTEGER;
    case L.RGB:
      return L.RGB_INTEGER;
    case L.RG:
      return L.RG_INTEGER;
    case L.RED:
      return L.RED_INTEGER;
    default:
      return r;
  }
}
function J0(r, t, e) {
  for (var n = /* @__PURE__ */ new Map(), i = 0; i < t; ) {
    var o = r.getUint32(pa + i, e), a = pa + i + 4, s = 3 - (o + 3) % 4;
    if (o === 0 || o > t - i) {
      console.error("KTXLoader: keyAndValueByteSize out of bounds");
      break;
    }
    for (var h = 0; h < o && r.getUint8(a + h) !== 0; h++)
      ;
    if (h === -1) {
      console.error("KTXLoader: Failed to find null byte terminating kvData key");
      break;
    }
    var u = new TextDecoder().decode(new Uint8Array(r.buffer, a, h)), l = new DataView(r.buffer, a + h + 1, o - h - 1);
    n.set(u, l), i += 4 + o + s;
  }
  return n;
}
Ot.setExtensionXhrType("dds", Ot.XHR_RESPONSE_TYPE.BUFFER);
var Q0 = (
  /** @class */
  function() {
    function r() {
    }
    return r.use = function(t, e) {
      if (t.extension === "dds" && t.data)
        try {
          Object.assign(t, Fl(t.name || t.url, V0(t.data), t.metadata));
        } catch (n) {
          e(n);
          return;
        }
      e();
    }, r.extension = mt.Loader, r;
  }()
);
Ot.setExtensionXhrType("ktx", Ot.XHR_RESPONSE_TYPE.BUFFER);
var tb = (
  /** @class */
  function() {
    function r() {
    }
    return r.use = function(t, e) {
      if (t.extension === "ktx" && t.data)
        try {
          var n = t.name || t.url, i = q0(n, t.data, this.loadKeyValueData), o = i.compressed, a = i.uncompressed, s = i.kvData;
          if (o) {
            var h = Fl(n, o, t.metadata);
            if (s && h.textures)
              for (var u in h.textures)
                h.textures[u].baseTexture.ktxKeyValueData = s;
            Object.assign(t, h);
          } else if (a) {
            var l = {};
            a.forEach(function(f, c) {
              var d = new J(new ht(f.resource, {
                mipmap: de.OFF,
                alphaMode: pe.NO_PREMULTIPLIED_ALPHA,
                type: f.type,
                format: f.format
              })), p = n + "-" + (c + 1);
              s && (d.baseTexture.ktxKeyValueData = s), ht.addToCache(d.baseTexture, p), J.addToCache(d, p), c === 0 && (l[n] = d, ht.addToCache(d.baseTexture, n), J.addToCache(d, n)), l[p] = d;
            }), Object.assign(t, { textures: l });
          }
        } catch (f) {
          e(f);
          return;
        }
      e();
    }, r.extension = mt.Loader, r.loadKeyValueData = !1, r;
  }()
);
/*!
 * @pixi/particle-container - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/particle-container is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var va = function(r, t) {
  return va = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, va(r, t);
};
function Bl(r, t) {
  va(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
(function(r) {
  Bl(t, r);
  function t(e, n, i, o) {
    e === void 0 && (e = 1500), i === void 0 && (i = 16384), o === void 0 && (o = !1);
    var a = r.call(this) || this, s = 16384;
    return i > s && (i = s), a._properties = [!1, !0, !1, !1, !1], a._maxSize = e, a._batchSize = i, a._buffers = null, a._bufferUpdateIDs = [], a._updateID = 0, a.interactiveChildren = !1, a.blendMode = Y.NORMAL, a.autoResize = o, a.roundPixels = !0, a.baseTexture = null, a.setProperties(n), a._tint = 0, a.tintRgb = new Float32Array(4), a.tint = 16777215, a;
  }
  return t.prototype.setProperties = function(e) {
    e && (this._properties[0] = "vertices" in e || "scale" in e ? !!e.vertices || !!e.scale : this._properties[0], this._properties[1] = "position" in e ? !!e.position : this._properties[1], this._properties[2] = "rotation" in e ? !!e.rotation : this._properties[2], this._properties[3] = "uvs" in e ? !!e.uvs : this._properties[3], this._properties[4] = "tint" in e || "alpha" in e ? !!e.tint || !!e.alpha : this._properties[4]);
  }, t.prototype.updateTransform = function() {
    this.displayObjectUpdateTransform();
  }, Object.defineProperty(t.prototype, "tint", {
    /**
     * The tint applied to the container. This is a hex value.
     * A value of 0xFFFFFF will remove any tint effect.
     * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
     * @default 0xFFFFFF
     */
    get: function() {
      return this._tint;
    },
    set: function(e) {
      this._tint = e, jr(e, this.tintRgb);
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.render = function(e) {
    var n = this;
    !this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable || (this.baseTexture || (this.baseTexture = this.children[0]._texture.baseTexture, this.baseTexture.valid || this.baseTexture.once("update", function() {
      return n.onChildrenChange(0);
    })), e.batch.setObjectRenderer(e.plugins.particle), e.plugins.particle.render(this));
  }, t.prototype.onChildrenChange = function(e) {
    for (var n = Math.floor(e / this._batchSize); this._bufferUpdateIDs.length < n; )
      this._bufferUpdateIDs.push(0);
    this._bufferUpdateIDs[n] = ++this._updateID;
  }, t.prototype.dispose = function() {
    if (this._buffers) {
      for (var e = 0; e < this._buffers.length; ++e)
        this._buffers[e].destroy();
      this._buffers = null;
    }
  }, t.prototype.destroy = function(e) {
    r.prototype.destroy.call(this, e), this.dispose(), this._properties = null, this._buffers = null, this._bufferUpdateIDs = null;
  }, t;
})(Te);
var Yh = (
  /** @class */
  function() {
    function r(t, e, n) {
      this.geometry = new On(), this.indexBuffer = null, this.size = n, this.dynamicProperties = [], this.staticProperties = [];
      for (var i = 0; i < t.length; ++i) {
        var o = t[i];
        o = {
          attributeName: o.attributeName,
          size: o.size,
          uploadFunction: o.uploadFunction,
          type: o.type || X.FLOAT,
          offset: o.offset
        }, e[i] ? this.dynamicProperties.push(o) : this.staticProperties.push(o);
      }
      this.staticStride = 0, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.dynamicStride = 0, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this._updateID = 0, this.initBuffers();
    }
    return r.prototype.initBuffers = function() {
      var t = this.geometry, e = 0;
      this.indexBuffer = new Mt(fy(this.size), !0, !0), t.addIndex(this.indexBuffer), this.dynamicStride = 0;
      for (var n = 0; n < this.dynamicProperties.length; ++n) {
        var i = this.dynamicProperties[n];
        i.offset = e, e += i.size, this.dynamicStride += i.size;
      }
      var o = new ArrayBuffer(this.size * this.dynamicStride * 4 * 4);
      this.dynamicData = new Float32Array(o), this.dynamicDataUint32 = new Uint32Array(o), this.dynamicBuffer = new Mt(this.dynamicData, !1, !1);
      var a = 0;
      this.staticStride = 0;
      for (var n = 0; n < this.staticProperties.length; ++n) {
        var i = this.staticProperties[n];
        i.offset = a, a += i.size, this.staticStride += i.size;
      }
      var s = new ArrayBuffer(this.size * this.staticStride * 4 * 4);
      this.staticData = new Float32Array(s), this.staticDataUint32 = new Uint32Array(s), this.staticBuffer = new Mt(this.staticData, !0, !1);
      for (var n = 0; n < this.dynamicProperties.length; ++n) {
        var i = this.dynamicProperties[n];
        t.addAttribute(i.attributeName, this.dynamicBuffer, 0, i.type === X.UNSIGNED_BYTE, i.type, this.dynamicStride * 4, i.offset * 4);
      }
      for (var n = 0; n < this.staticProperties.length; ++n) {
        var i = this.staticProperties[n];
        t.addAttribute(i.attributeName, this.staticBuffer, 0, i.type === X.UNSIGNED_BYTE, i.type, this.staticStride * 4, i.offset * 4);
      }
    }, r.prototype.uploadDynamic = function(t, e, n) {
      for (var i = 0; i < this.dynamicProperties.length; i++) {
        var o = this.dynamicProperties[i];
        o.uploadFunction(t, e, n, o.type === X.UNSIGNED_BYTE ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, o.offset);
      }
      this.dynamicBuffer._updateID++;
    }, r.prototype.uploadStatic = function(t, e, n) {
      for (var i = 0; i < this.staticProperties.length; i++) {
        var o = this.staticProperties[i];
        o.uploadFunction(t, e, n, o.type === X.UNSIGNED_BYTE ? this.staticDataUint32 : this.staticData, this.staticStride, o.offset);
      }
      this.staticBuffer._updateID++;
    }, r.prototype.destroy = function() {
      this.indexBuffer = null, this.dynamicProperties = null, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this.staticProperties = null, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.geometry.destroy();
    }, r;
  }()
), eb = `varying vec2 vTextureCoord;
varying vec4 vColor;

uniform sampler2D uSampler;

void main(void){
    vec4 color = texture2D(uSampler, vTextureCoord) * vColor;
    gl_FragColor = color;
}`, rb = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;

attribute vec2 aPositionCoord;
attribute float aRotation;

uniform mat3 translationMatrix;
uniform vec4 uColor;

varying vec2 vTextureCoord;
varying vec4 vColor;

void main(void){
    float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);
    float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);

    vec2 v = vec2(x, y);
    v = v + aPositionCoord;

    gl_Position = vec4((translationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vColor = aColor * uColor;
}
`, nb = (
  /** @class */
  function(r) {
    Bl(t, r);
    function t(e) {
      var n = r.call(this, e) || this;
      return n.shader = null, n.properties = null, n.tempMatrix = new Dt(), n.properties = [
        // verticesData
        {
          attributeName: "aVertexPosition",
          size: 2,
          uploadFunction: n.uploadVertices,
          offset: 0
        },
        // positionData
        {
          attributeName: "aPositionCoord",
          size: 2,
          uploadFunction: n.uploadPosition,
          offset: 0
        },
        // rotationData
        {
          attributeName: "aRotation",
          size: 1,
          uploadFunction: n.uploadRotation,
          offset: 0
        },
        // uvsData
        {
          attributeName: "aTextureCoord",
          size: 2,
          uploadFunction: n.uploadUvs,
          offset: 0
        },
        // tintData
        {
          attributeName: "aColor",
          size: 1,
          type: X.UNSIGNED_BYTE,
          uploadFunction: n.uploadTint,
          offset: 0
        }
      ], n.shader = Ue.from(rb, eb, {}), n.state = dr.for2d(), n;
    }
    return t.prototype.render = function(e) {
      var n = e.children, i = e._maxSize, o = e._batchSize, a = this.renderer, s = n.length;
      if (s !== 0) {
        s > i && !e.autoResize && (s = i);
        var h = e._buffers;
        h || (h = e._buffers = this.generateBuffers(e));
        var u = n[0]._texture.baseTexture, l = u.alphaMode > 0;
        this.state.blendMode = ul(e.blendMode, l), a.state.set(this.state);
        var f = a.gl, c = e.worldTransform.copyTo(this.tempMatrix);
        c.prepend(a.globalUniforms.uniforms.projectionMatrix), this.shader.uniforms.translationMatrix = c.toArray(!0), this.shader.uniforms.uColor = ly(e.tintRgb, e.worldAlpha, this.shader.uniforms.uColor, l), this.shader.uniforms.uSampler = u, this.renderer.shader.bind(this.shader);
        for (var d = !1, p = 0, v = 0; p < s; p += o, v += 1) {
          var _ = s - p;
          _ > o && (_ = o), v >= h.length && h.push(this._generateOneMoreBuffer(e));
          var m = h[v];
          m.uploadDynamic(n, p, _);
          var y = e._bufferUpdateIDs[v] || 0;
          d = d || m._updateID < y, d && (m._updateID = e._updateID, m.uploadStatic(n, p, _)), a.geometry.bind(m.geometry), f.drawElements(f.TRIANGLES, _ * 6, f.UNSIGNED_SHORT, 0);
        }
      }
    }, t.prototype.generateBuffers = function(e) {
      for (var n = [], i = e._maxSize, o = e._batchSize, a = e._properties, s = 0; s < i; s += o)
        n.push(new Yh(this.properties, a, o));
      return n;
    }, t.prototype._generateOneMoreBuffer = function(e) {
      var n = e._batchSize, i = e._properties;
      return new Yh(this.properties, i, n);
    }, t.prototype.uploadVertices = function(e, n, i, o, a, s) {
      for (var h = 0, u = 0, l = 0, f = 0, c = 0; c < i; ++c) {
        var d = e[n + c], p = d._texture, v = d.scale.x, _ = d.scale.y, m = p.trim, y = p.orig;
        m ? (u = m.x - d.anchor.x * y.width, h = u + m.width, f = m.y - d.anchor.y * y.height, l = f + m.height) : (h = y.width * (1 - d.anchor.x), u = y.width * -d.anchor.x, l = y.height * (1 - d.anchor.y), f = y.height * -d.anchor.y), o[s] = u * v, o[s + 1] = f * _, o[s + a] = h * v, o[s + a + 1] = f * _, o[s + a * 2] = h * v, o[s + a * 2 + 1] = l * _, o[s + a * 3] = u * v, o[s + a * 3 + 1] = l * _, s += a * 4;
      }
    }, t.prototype.uploadPosition = function(e, n, i, o, a, s) {
      for (var h = 0; h < i; h++) {
        var u = e[n + h].position;
        o[s] = u.x, o[s + 1] = u.y, o[s + a] = u.x, o[s + a + 1] = u.y, o[s + a * 2] = u.x, o[s + a * 2 + 1] = u.y, o[s + a * 3] = u.x, o[s + a * 3 + 1] = u.y, s += a * 4;
      }
    }, t.prototype.uploadRotation = function(e, n, i, o, a, s) {
      for (var h = 0; h < i; h++) {
        var u = e[n + h].rotation;
        o[s] = u, o[s + a] = u, o[s + a * 2] = u, o[s + a * 3] = u, s += a * 4;
      }
    }, t.prototype.uploadUvs = function(e, n, i, o, a, s) {
      for (var h = 0; h < i; ++h) {
        var u = e[n + h]._texture._uvs;
        u ? (o[s] = u.x0, o[s + 1] = u.y0, o[s + a] = u.x1, o[s + a + 1] = u.y1, o[s + a * 2] = u.x2, o[s + a * 2 + 1] = u.y2, o[s + a * 3] = u.x3, o[s + a * 3 + 1] = u.y3, s += a * 4) : (o[s] = 0, o[s + 1] = 0, o[s + a] = 0, o[s + a + 1] = 0, o[s + a * 2] = 0, o[s + a * 2 + 1] = 0, o[s + a * 3] = 0, o[s + a * 3 + 1] = 0, s += a * 4);
      }
    }, t.prototype.uploadTint = function(e, n, i, o, a, s) {
      for (var h = 0; h < i; ++h) {
        var u = e[n + h], l = u._texture.baseTexture.alphaMode > 0, f = u.alpha, c = f < 1 && l ? Za(u._tintRGB, f) : u._tintRGB + (f * 255 << 24);
        o[s] = c, o[s + a] = c, o[s + a * 2] = c, o[s + a * 3] = c, s += a * 4;
      }
    }, t.prototype.destroy = function() {
      r.prototype.destroy.call(this), this.shader && (this.shader.destroy(), this.shader = null), this.tempMatrix = null;
    }, t.extension = {
      name: "particle",
      type: mt.RendererPlugin
    }, t;
  }(Gi)
);
/*!
 * @pixi/graphics - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/graphics is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var Re;
(function(r) {
  r.MITER = "miter", r.BEVEL = "bevel", r.ROUND = "round";
})(Re || (Re = {}));
var Le;
(function(r) {
  r.BUTT = "butt", r.ROUND = "round", r.SQUARE = "square";
})(Le || (Le = {}));
var bn = {
  adaptive: !0,
  maxLength: 10,
  minSegments: 8,
  maxSegments: 2048,
  epsilon: 1e-4,
  _segmentsCount: function(r, t) {
    if (t === void 0 && (t = 20), !this.adaptive || !r || isNaN(r))
      return t;
    var e = Math.ceil(r / this.maxLength);
    return e < this.minSegments ? e = this.minSegments : e > this.maxSegments && (e = this.maxSegments), e;
  }
}, Nl = (
  /** @class */
  function() {
    function r() {
      this.color = 16777215, this.alpha = 1, this.texture = J.WHITE, this.matrix = null, this.visible = !1, this.reset();
    }
    return r.prototype.clone = function() {
      var t = new r();
      return t.color = this.color, t.alpha = this.alpha, t.texture = this.texture, t.matrix = this.matrix, t.visible = this.visible, t;
    }, r.prototype.reset = function() {
      this.color = 16777215, this.alpha = 1, this.texture = J.WHITE, this.matrix = null, this.visible = !1;
    }, r.prototype.destroy = function() {
      this.texture = null, this.matrix = null;
    }, r;
  }()
);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _a = function(r, t) {
  return _a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, _a(r, t);
};
function ts(r, t) {
  _a(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
function Vh(r, t) {
  var e, n;
  t === void 0 && (t = !1);
  var i = r.length;
  if (!(i < 6)) {
    for (var o = 0, a = 0, s = r[i - 2], h = r[i - 1]; a < i; a += 2) {
      var u = r[a], l = r[a + 1];
      o += (u - s) * (l + h), s = u, h = l;
    }
    if (!t && o > 0 || t && o <= 0)
      for (var f = i / 2, a = f + f % 2; a < i; a += 2) {
        var c = i - a - 2, d = i - a - 1, p = a, v = a + 1;
        e = [r[p], r[c]], r[c] = e[0], r[p] = e[1], n = [r[v], r[d]], r[d] = n[0], r[v] = n[1];
      }
  }
}
var Ll = {
  build: function(r) {
    r.points = r.shape.points.slice();
  },
  triangulate: function(r, t) {
    var e = r.points, n = r.holes, i = t.points, o = t.indices;
    if (e.length >= 6) {
      Vh(e, !1);
      for (var a = [], s = 0; s < n.length; s++) {
        var h = n[s];
        Vh(h.points, !0), a.push(e.length / 2), e = e.concat(h.points);
      }
      var u = Yu(e, a, 2);
      if (!u)
        return;
      for (var l = i.length / 2, s = 0; s < u.length; s += 3)
        o.push(u[s] + l), o.push(u[s + 1] + l), o.push(u[s + 2] + l);
      for (var s = 0; s < e.length; s++)
        i.push(e[s]);
    }
  }
}, Ci = {
  build: function(r) {
    var t = r.points, e, n, i, o, a, s;
    if (r.type === Nt.CIRC) {
      var h = r.shape;
      e = h.x, n = h.y, a = s = h.radius, i = o = 0;
    } else if (r.type === Nt.ELIP) {
      var u = r.shape;
      e = u.x, n = u.y, a = u.width, s = u.height, i = o = 0;
    } else {
      var l = r.shape, f = l.width / 2, c = l.height / 2;
      e = l.x + f, n = l.y + c, a = s = Math.max(0, Math.min(l.radius, Math.min(f, c))), i = f - a, o = c - s;
    }
    if (!(a >= 0 && s >= 0 && i >= 0 && o >= 0)) {
      t.length = 0;
      return;
    }
    var d = Math.ceil(2.3 * Math.sqrt(a + s)), p = d * 8 + (i ? 4 : 0) + (o ? 4 : 0);
    if (t.length = p, p !== 0) {
      if (d === 0) {
        t.length = 8, t[0] = t[6] = e + i, t[1] = t[3] = n + o, t[2] = t[4] = e - i, t[5] = t[7] = n - o;
        return;
      }
      var v = 0, _ = d * 4 + (i ? 2 : 0) + 2, m = _, y = p;
      {
        var g = i + a, x = o, T = e + g, E = e - g, P = n + x;
        if (t[v++] = T, t[v++] = P, t[--_] = P, t[--_] = E, o) {
          var b = n - x;
          t[m++] = E, t[m++] = b, t[--y] = b, t[--y] = T;
        }
      }
      for (var w = 1; w < d; w++) {
        var A = Math.PI / 2 * (w / d), g = i + Math.cos(A) * a, x = o + Math.sin(A) * s, T = e + g, E = e - g, P = n + x, b = n - x;
        t[v++] = T, t[v++] = P, t[--_] = P, t[--_] = E, t[m++] = E, t[m++] = b, t[--y] = b, t[--y] = T;
      }
      {
        var g = i, x = o + s, T = e + g, E = e - g, P = n + x, b = n - x;
        t[v++] = T, t[v++] = P, t[--y] = b, t[--y] = T, i && (t[v++] = E, t[v++] = P, t[--y] = b, t[--y] = E);
      }
    }
  },
  triangulate: function(r, t) {
    var e = r.points, n = t.points, i = t.indices;
    if (e.length !== 0) {
      var o = n.length / 2, a = o, s, h;
      if (r.type !== Nt.RREC) {
        var u = r.shape;
        s = u.x, h = u.y;
      } else {
        var l = r.shape;
        s = l.x + l.width / 2, h = l.y + l.height / 2;
      }
      var f = r.matrix;
      n.push(r.matrix ? f.a * s + f.c * h + f.tx : s, r.matrix ? f.b * s + f.d * h + f.ty : h), o++, n.push(e[0], e[1]);
      for (var c = 2; c < e.length; c += 2)
        n.push(e[c], e[c + 1]), i.push(o++, a, o);
      i.push(a + 1, a, o);
    }
  }
}, ib = {
  build: function(r) {
    var t = r.shape, e = t.x, n = t.y, i = t.width, o = t.height, a = r.points;
    a.length = 0, a.push(e, n, e + i, n, e + i, n + o, e, n + o);
  },
  triangulate: function(r, t) {
    var e = r.points, n = t.points, i = n.length / 2;
    n.push(e[0], e[1], e[2], e[3], e[6], e[7], e[4], e[5]), t.indices.push(i, i + 1, i + 2, i + 1, i + 2, i + 3);
  }
};
function xr(r, t, e) {
  var n = t - r;
  return r + n * e;
}
function ii(r, t, e, n, i, o, a) {
  a === void 0 && (a = []);
  for (var s = 20, h = a, u = 0, l = 0, f = 0, c = 0, d = 0, p = 0, v = 0, _ = 0; v <= s; ++v)
    _ = v / s, u = xr(r, e, _), l = xr(t, n, _), f = xr(e, i, _), c = xr(n, o, _), d = xr(u, f, _), p = xr(l, c, _), !(v === 0 && h[h.length - 2] === d && h[h.length - 1] === p) && h.push(d, p);
  return h;
}
var ob = {
  build: function(r) {
    if (cr.nextRoundedRectBehavior) {
      Ci.build(r);
      return;
    }
    var t = r.shape, e = r.points, n = t.x, i = t.y, o = t.width, a = t.height, s = Math.max(0, Math.min(t.radius, Math.min(o, a) / 2));
    e.length = 0, s ? (ii(n, i + s, n, i, n + s, i, e), ii(n + o - s, i, n + o, i, n + o, i + s, e), ii(n + o, i + a - s, n + o, i + a, n + o - s, i + a, e), ii(n + s, i + a, n, i + a, n, i + a - s, e)) : e.push(n, i, n + o, i, n + o, i + a, n, i + a);
  },
  triangulate: function(r, t) {
    if (cr.nextRoundedRectBehavior) {
      Ci.triangulate(r, t);
      return;
    }
    for (var e = r.points, n = t.points, i = t.indices, o = n.length / 2, a = Yu(e, null, 2), s = 0, h = a.length; s < h; s += 3)
      i.push(a[s] + o), i.push(a[s + 1] + o), i.push(a[s + 2] + o);
    for (var s = 0, h = e.length; s < h; s++)
      n.push(e[s], e[++s]);
  }
};
function zh(r, t, e, n, i, o, a, s) {
  var h = r - e * i, u = t - n * i, l = r + e * o, f = t + n * o, c, d;
  a ? (c = n, d = -e) : (c = -n, d = e);
  var p = h + c, v = u + d, _ = l + c, m = f + d;
  return s.push(p, v), s.push(_, m), 2;
}
function qe(r, t, e, n, i, o, a, s) {
  var h = e - r, u = n - t, l = Math.atan2(h, u), f = Math.atan2(i - r, o - t);
  s && l < f ? l += Math.PI * 2 : !s && l > f && (f += Math.PI * 2);
  var c = l, d = f - l, p = Math.abs(d), v = Math.sqrt(h * h + u * u), _ = (15 * p * Math.sqrt(v) / Math.PI >> 0) + 1, m = d / _;
  if (c += m, s) {
    a.push(r, t), a.push(e, n);
    for (var y = 1, g = c; y < _; y++, g += m)
      a.push(r, t), a.push(r + Math.sin(g) * v, t + Math.cos(g) * v);
    a.push(r, t), a.push(i, o);
  } else {
    a.push(e, n), a.push(r, t);
    for (var y = 1, g = c; y < _; y++, g += m)
      a.push(r + Math.sin(g) * v, t + Math.cos(g) * v), a.push(r, t);
    a.push(i, o), a.push(r, t);
  }
  return _ * 2;
}
function ab(r, t) {
  var e = r.shape, n = r.points || e.points.slice(), i = t.closePointEps;
  if (n.length !== 0) {
    var o = r.lineStyle, a = new Et(n[0], n[1]), s = new Et(n[n.length - 2], n[n.length - 1]), h = e.type !== Nt.POLY || e.closeStroke, u = Math.abs(a.x - s.x) < i && Math.abs(a.y - s.y) < i;
    if (h) {
      n = n.slice(), u && (n.pop(), n.pop(), s.set(n[n.length - 2], n[n.length - 1]));
      var l = (a.x + s.x) * 0.5, f = (s.y + a.y) * 0.5;
      n.unshift(l, f), n.push(l, f);
    }
    var c = t.points, d = n.length / 2, p = n.length, v = c.length / 2, _ = o.width / 2, m = _ * _, y = o.miterLimit * o.miterLimit, g = n[0], x = n[1], T = n[2], E = n[3], P = 0, b = 0, w = -(x - E), A = g - T, R = 0, C = 0, M = Math.sqrt(w * w + A * A);
    w /= M, A /= M, w *= _, A *= _;
    var H = o.alignment, U = (1 - H) * 2, B = H * 2;
    h || (o.cap === Le.ROUND ? p += qe(g - w * (U - B) * 0.5, x - A * (U - B) * 0.5, g - w * U, x - A * U, g + w * B, x + A * B, c, !0) + 2 : o.cap === Le.SQUARE && (p += zh(g, x, w, A, U, B, !0, c))), c.push(g - w * U, x - A * U), c.push(g + w * B, x + A * B);
    for (var $ = 1; $ < d - 1; ++$) {
      g = n[($ - 1) * 2], x = n[($ - 1) * 2 + 1], T = n[$ * 2], E = n[$ * 2 + 1], P = n[($ + 1) * 2], b = n[($ + 1) * 2 + 1], w = -(x - E), A = g - T, M = Math.sqrt(w * w + A * A), w /= M, A /= M, w *= _, A *= _, R = -(E - b), C = T - P, M = Math.sqrt(R * R + C * C), R /= M, C /= M, R *= _, C *= _;
      var q = T - g, Q = x - E, N = T - P, F = b - E, k = q * N + Q * F, tt = Q * N - F * q, et = tt < 0;
      if (Math.abs(tt) < 1e-3 * Math.abs(k)) {
        c.push(T - w * U, E - A * U), c.push(T + w * B, E + A * B), k >= 0 && (o.join === Re.ROUND ? p += qe(T, E, T - w * U, E - A * U, T - R * U, E - C * U, c, !1) + 4 : p += 2, c.push(T - R * B, E - C * B), c.push(T + R * U, E + C * U));
        continue;
      }
      var pt = (-w + g) * (-A + E) - (-w + T) * (-A + x), j = (-R + P) * (-C + E) - (-R + T) * (-C + b), st = (q * j - N * pt) / tt, _t = (F * pt - Q * j) / tt, Tt = (st - T) * (st - T) + (_t - E) * (_t - E), W = T + (st - T) * U, it = E + (_t - E) * U, at = T - (st - T) * B, lt = E - (_t - E) * B, nt = Math.min(q * q + Q * Q, N * N + F * F), D = et ? U : B, O = nt + D * D * m, dt = Tt <= O;
      dt ? o.join === Re.BEVEL || Tt / m > y ? (et ? (c.push(W, it), c.push(T + w * B, E + A * B), c.push(W, it), c.push(T + R * B, E + C * B)) : (c.push(T - w * U, E - A * U), c.push(at, lt), c.push(T - R * U, E - C * U), c.push(at, lt)), p += 2) : o.join === Re.ROUND ? et ? (c.push(W, it), c.push(T + w * B, E + A * B), p += qe(T, E, T + w * B, E + A * B, T + R * B, E + C * B, c, !0) + 4, c.push(W, it), c.push(T + R * B, E + C * B)) : (c.push(T - w * U, E - A * U), c.push(at, lt), p += qe(T, E, T - w * U, E - A * U, T - R * U, E - C * U, c, !1) + 4, c.push(T - R * U, E - C * U), c.push(at, lt)) : (c.push(W, it), c.push(at, lt)) : (c.push(T - w * U, E - A * U), c.push(T + w * B, E + A * B), o.join === Re.ROUND ? et ? p += qe(T, E, T + w * B, E + A * B, T + R * B, E + C * B, c, !0) + 2 : p += qe(T, E, T - w * U, E - A * U, T - R * U, E - C * U, c, !1) + 2 : o.join === Re.MITER && Tt / m <= y && (et ? (c.push(at, lt), c.push(at, lt)) : (c.push(W, it), c.push(W, it)), p += 2), c.push(T - R * U, E - C * U), c.push(T + R * B, E + C * B), p += 2);
    }
    g = n[(d - 2) * 2], x = n[(d - 2) * 2 + 1], T = n[(d - 1) * 2], E = n[(d - 1) * 2 + 1], w = -(x - E), A = g - T, M = Math.sqrt(w * w + A * A), w /= M, A /= M, w *= _, A *= _, c.push(T - w * U, E - A * U), c.push(T + w * B, E + A * B), h || (o.cap === Le.ROUND ? p += qe(T - w * (U - B) * 0.5, E - A * (U - B) * 0.5, T - w * U, E - A * U, T + w * B, E + A * B, c, !1) + 2 : o.cap === Le.SQUARE && (p += zh(T, E, w, A, U, B, !1, c)));
    for (var ve = t.indices, vr = bn.epsilon * bn.epsilon, $ = v; $ < p + v - 2; ++$)
      g = c[$ * 2], x = c[$ * 2 + 1], T = c[($ + 1) * 2], E = c[($ + 1) * 2 + 1], P = c[($ + 2) * 2], b = c[($ + 2) * 2 + 1], !(Math.abs(g * (E - b) + T * (b - x) + P * (x - E)) < vr) && ve.push($, $ + 1, $ + 2);
  }
}
function sb(r, t) {
  var e = 0, n = r.shape, i = r.points || n.points, o = n.type !== Nt.POLY || n.closeStroke;
  if (i.length !== 0) {
    var a = t.points, s = t.indices, h = i.length / 2, u = a.length / 2, l = u;
    for (a.push(i[0], i[1]), e = 1; e < h; e++)
      a.push(i[e * 2], i[e * 2 + 1]), s.push(l, l + 1), l++;
    o && s.push(l, u);
  }
}
function Wh(r, t) {
  r.lineStyle.native ? sb(r, t) : ab(r, t);
}
var $h = (
  /** @class */
  function() {
    function r() {
    }
    return r.curveTo = function(t, e, n, i, o, a) {
      var s = a[a.length - 2], h = a[a.length - 1], u = h - e, l = s - t, f = i - e, c = n - t, d = Math.abs(u * c - l * f);
      if (d < 1e-8 || o === 0)
        return (a[a.length - 2] !== t || a[a.length - 1] !== e) && a.push(t, e), null;
      var p = u * u + l * l, v = f * f + c * c, _ = u * f + l * c, m = o * Math.sqrt(p) / d, y = o * Math.sqrt(v) / d, g = m * _ / p, x = y * _ / v, T = m * c + y * l, E = m * f + y * u, P = l * (y + g), b = u * (y + g), w = c * (m + x), A = f * (m + x), R = Math.atan2(b - E, P - T), C = Math.atan2(A - E, w - T);
      return {
        cx: T + t,
        cy: E + e,
        radius: o,
        startAngle: R,
        endAngle: C,
        anticlockwise: l * f > c * u
      };
    }, r.arc = function(t, e, n, i, o, a, s, h, u) {
      for (var l = s - a, f = bn._segmentsCount(Math.abs(l) * o, Math.ceil(Math.abs(l) / Pi) * 40), c = l / (f * 2), d = c * 2, p = Math.cos(c), v = Math.sin(c), _ = f - 1, m = _ % 1 / _, y = 0; y <= _; ++y) {
        var g = y + m * y, x = c + a + d * g, T = Math.cos(x), E = -Math.sin(x);
        u.push((p * T + v * E) * o + n, (p * -E + v * T) * o + i);
      }
    }, r;
  }()
), hb = (
  /** @class */
  function() {
    function r() {
    }
    return r.curveLength = function(t, e, n, i, o, a, s, h) {
      for (var u = 10, l = 0, f = 0, c = 0, d = 0, p = 0, v = 0, _ = 0, m = 0, y = 0, g = 0, x = 0, T = t, E = e, P = 1; P <= u; ++P)
        f = P / u, c = f * f, d = c * f, p = 1 - f, v = p * p, _ = v * p, m = _ * t + 3 * v * f * n + 3 * p * c * o + d * s, y = _ * e + 3 * v * f * i + 3 * p * c * a + d * h, g = T - m, x = E - y, T = m, E = y, l += Math.sqrt(g * g + x * x);
      return l;
    }, r.curveTo = function(t, e, n, i, o, a, s) {
      var h = s[s.length - 2], u = s[s.length - 1];
      s.length -= 2;
      var l = bn._segmentsCount(r.curveLength(h, u, t, e, n, i, o, a)), f = 0, c = 0, d = 0, p = 0, v = 0;
      s.push(h, u);
      for (var _ = 1, m = 0; _ <= l; ++_)
        m = _ / l, f = 1 - m, c = f * f, d = c * f, p = m * m, v = p * m, s.push(d * h + 3 * c * m * t + 3 * f * p * n + v * o, d * u + 3 * c * m * e + 3 * f * p * i + v * a);
    }, r;
  }()
), ub = (
  /** @class */
  function() {
    function r() {
    }
    return r.curveLength = function(t, e, n, i, o, a) {
      var s = t - 2 * n + o, h = e - 2 * i + a, u = 2 * n - 2 * t, l = 2 * i - 2 * e, f = 4 * (s * s + h * h), c = 4 * (s * u + h * l), d = u * u + l * l, p = 2 * Math.sqrt(f + c + d), v = Math.sqrt(f), _ = 2 * f * v, m = 2 * Math.sqrt(d), y = c / v;
      return (_ * p + v * c * (p - m) + (4 * d * f - c * c) * Math.log((2 * v + y + p) / (y + m))) / (4 * _);
    }, r.curveTo = function(t, e, n, i, o) {
      for (var a = o[o.length - 2], s = o[o.length - 1], h = bn._segmentsCount(r.curveLength(a, s, t, e, n, i)), u = 0, l = 0, f = 1; f <= h; ++f) {
        var c = f / h;
        u = a + (t - a) * c, l = s + (e - s) * c, o.push(u + (t + (n - t) * c - u) * c, l + (e + (i - e) * c - l) * c);
      }
    }, r;
  }()
), lb = (
  /** @class */
  function() {
    function r() {
      this.reset();
    }
    return r.prototype.begin = function(t, e, n) {
      this.reset(), this.style = t, this.start = e, this.attribStart = n;
    }, r.prototype.end = function(t, e) {
      this.attribSize = e - this.attribStart, this.size = t - this.start;
    }, r.prototype.reset = function() {
      this.style = null, this.size = 0, this.start = 0, this.attribStart = 0, this.attribSize = 0;
    }, r;
  }()
), Ke, Io = (Ke = {}, Ke[Nt.POLY] = Ll, Ke[Nt.CIRC] = Ci, Ke[Nt.ELIP] = Ci, Ke[Nt.RECT] = ib, Ke[Nt.RREC] = ob, Ke), qh = [], oi = [], Kh = (
  /** @class */
  function() {
    function r(t, e, n, i) {
      e === void 0 && (e = null), n === void 0 && (n = null), i === void 0 && (i = null), this.points = [], this.holes = [], this.shape = t, this.lineStyle = n, this.fillStyle = e, this.matrix = i, this.type = t.type;
    }
    return r.prototype.clone = function() {
      return new r(this.shape, this.fillStyle, this.lineStyle, this.matrix);
    }, r.prototype.destroy = function() {
      this.shape = null, this.holes.length = 0, this.holes = null, this.points.length = 0, this.points = null, this.lineStyle = null, this.fillStyle = null;
    }, r;
  }()
), Tr = new Et(), fb = (
  /** @class */
  function(r) {
    ts(t, r);
    function t() {
      var e = r.call(this) || this;
      return e.closePointEps = 1e-4, e.boundsPadding = 0, e.uvsFloat32 = null, e.indicesUint16 = null, e.batchable = !1, e.points = [], e.colors = [], e.uvs = [], e.indices = [], e.textureIds = [], e.graphicsData = [], e.drawCalls = [], e.batchDirty = -1, e.batches = [], e.dirty = 0, e.cacheDirty = -1, e.clearDirty = 0, e.shapeIndex = 0, e._bounds = new Oi(), e.boundsDirty = -1, e;
    }
    return Object.defineProperty(t.prototype, "bounds", {
      /**
       * Get the current bounds of the graphic geometry.
       * @readonly
       */
      get: function() {
        return this.updateBatches(), this.boundsDirty !== this.dirty && (this.boundsDirty = this.dirty, this.calculateBounds()), this._bounds;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.invalidate = function() {
      this.boundsDirty = -1, this.dirty++, this.batchDirty++, this.shapeIndex = 0, this.points.length = 0, this.colors.length = 0, this.uvs.length = 0, this.indices.length = 0, this.textureIds.length = 0;
      for (var e = 0; e < this.drawCalls.length; e++)
        this.drawCalls[e].texArray.clear(), oi.push(this.drawCalls[e]);
      this.drawCalls.length = 0;
      for (var e = 0; e < this.batches.length; e++) {
        var n = this.batches[e];
        n.reset(), qh.push(n);
      }
      this.batches.length = 0;
    }, t.prototype.clear = function() {
      return this.graphicsData.length > 0 && (this.invalidate(), this.clearDirty++, this.graphicsData.length = 0), this;
    }, t.prototype.drawShape = function(e, n, i, o) {
      n === void 0 && (n = null), i === void 0 && (i = null), o === void 0 && (o = null);
      var a = new Kh(e, n, i, o);
      return this.graphicsData.push(a), this.dirty++, this;
    }, t.prototype.drawHole = function(e, n) {
      if (n === void 0 && (n = null), !this.graphicsData.length)
        return null;
      var i = new Kh(e, null, null, n), o = this.graphicsData[this.graphicsData.length - 1];
      return i.lineStyle = o.lineStyle, o.holes.push(i), this.dirty++, this;
    }, t.prototype.destroy = function() {
      r.prototype.destroy.call(this);
      for (var e = 0; e < this.graphicsData.length; ++e)
        this.graphicsData[e].destroy();
      this.points.length = 0, this.points = null, this.colors.length = 0, this.colors = null, this.uvs.length = 0, this.uvs = null, this.indices.length = 0, this.indices = null, this.indexBuffer.destroy(), this.indexBuffer = null, this.graphicsData.length = 0, this.graphicsData = null, this.drawCalls.length = 0, this.drawCalls = null, this.batches.length = 0, this.batches = null, this._bounds = null;
    }, t.prototype.containsPoint = function(e) {
      for (var n = this.graphicsData, i = 0; i < n.length; ++i) {
        var o = n[i];
        if (o.fillStyle.visible && o.shape && (o.matrix ? o.matrix.applyInverse(e, Tr) : Tr.copyFrom(e), o.shape.contains(Tr.x, Tr.y))) {
          var a = !1;
          if (o.holes)
            for (var s = 0; s < o.holes.length; s++) {
              var h = o.holes[s];
              if (h.shape.contains(Tr.x, Tr.y)) {
                a = !0;
                break;
              }
            }
          if (!a)
            return !0;
        }
      }
      return !1;
    }, t.prototype.updateBatches = function() {
      if (!this.graphicsData.length) {
        this.batchable = !0;
        return;
      }
      if (this.validateBatching()) {
        this.cacheDirty = this.dirty;
        var e = this.uvs, n = this.graphicsData, i = null, o = null;
        this.batches.length > 0 && (i = this.batches[this.batches.length - 1], o = i.style);
        for (var a = this.shapeIndex; a < n.length; a++) {
          this.shapeIndex++;
          var s = n[a], h = s.fillStyle, u = s.lineStyle, l = Io[s.type];
          l.build(s), s.matrix && this.transformPoints(s.points, s.matrix), (h.visible || u.visible) && this.processHoles(s.holes);
          for (var f = 0; f < 2; f++) {
            var c = f === 0 ? h : u;
            if (c.visible) {
              var d = c.texture.baseTexture, p = this.indices.length, v = this.points.length / 2;
              d.wrapMode = be.REPEAT, f === 0 ? this.processFill(s) : this.processLine(s);
              var _ = this.points.length / 2 - v;
              _ !== 0 && (i && !this._compareStyles(o, c) && (i.end(p, v), i = null), i || (i = qh.pop() || new lb(), i.begin(c, p, v), this.batches.push(i), o = c), this.addUvs(this.points, e, c.texture, v, _, c.matrix));
            }
          }
        }
        var m = this.indices.length, y = this.points.length / 2;
        if (i && i.end(m, y), this.batches.length === 0) {
          this.batchable = !0;
          return;
        }
        var g = y > 65535;
        this.indicesUint16 && this.indices.length === this.indicesUint16.length && g === this.indicesUint16.BYTES_PER_ELEMENT > 2 ? this.indicesUint16.set(this.indices) : this.indicesUint16 = g ? new Uint32Array(this.indices) : new Uint16Array(this.indices), this.batchable = this.isBatchable(), this.batchable ? this.packBatches() : this.buildDrawCalls();
      }
    }, t.prototype._compareStyles = function(e, n) {
      return !(!e || !n || e.texture.baseTexture !== n.texture.baseTexture || e.color + e.alpha !== n.color + n.alpha || !!e.native != !!n.native);
    }, t.prototype.validateBatching = function() {
      if (this.dirty === this.cacheDirty || !this.graphicsData.length)
        return !1;
      for (var e = 0, n = this.graphicsData.length; e < n; e++) {
        var i = this.graphicsData[e], o = i.fillStyle, a = i.lineStyle;
        if (o && !o.texture.baseTexture.valid || a && !a.texture.baseTexture.valid)
          return !1;
      }
      return !0;
    }, t.prototype.packBatches = function() {
      this.batchDirty++, this.uvsFloat32 = new Float32Array(this.uvs);
      for (var e = this.batches, n = 0, i = e.length; n < i; n++)
        for (var o = e[n], a = 0; a < o.size; a++) {
          var s = o.start + a;
          this.indicesUint16[s] = this.indicesUint16[s] - o.attribStart;
        }
    }, t.prototype.isBatchable = function() {
      if (this.points.length > 65535 * 2)
        return !1;
      for (var e = this.batches, n = 0; n < e.length; n++)
        if (e[n].style.native)
          return !1;
      return this.points.length < t.BATCHABLE_SIZE * 2;
    }, t.prototype.buildDrawCalls = function() {
      for (var e = ++ht._globalBatch, n = 0; n < this.drawCalls.length; n++)
        this.drawCalls[n].texArray.clear(), oi.push(this.drawCalls[n]);
      this.drawCalls.length = 0;
      var i = this.colors, o = this.textureIds, a = oi.pop();
      a || (a = new sa(), a.texArray = new ha()), a.texArray.count = 0, a.start = 0, a.size = 0, a.type = le.TRIANGLES;
      var s = 0, h = null, u = 0, l = !1, f = le.TRIANGLES, c = 0;
      this.drawCalls.push(a);
      for (var n = 0; n < this.batches.length; n++) {
        var d = this.batches[n], p = 8, v = d.style, _ = v.texture.baseTexture;
        l !== !!v.native && (l = !!v.native, f = l ? le.LINES : le.TRIANGLES, h = null, s = p, e++), h !== _ && (h = _, _._batchEnabled !== e && (s === p && (e++, s = 0, a.size > 0 && (a = oi.pop(), a || (a = new sa(), a.texArray = new ha()), this.drawCalls.push(a)), a.start = c, a.size = 0, a.texArray.count = 0, a.type = f), _.touched = 1, _._batchEnabled = e, _._batchLocation = s, _.wrapMode = be.REPEAT, a.texArray.elements[a.texArray.count++] = _, s++)), a.size += d.size, c += d.size, u = _._batchLocation, this.addColors(i, v.color, v.alpha, d.attribSize, d.attribStart), this.addTextureIds(o, u, d.attribSize, d.attribStart);
      }
      ht._globalBatch = e, this.packAttributes();
    }, t.prototype.packAttributes = function() {
      for (var e = this.points, n = this.uvs, i = this.colors, o = this.textureIds, a = new ArrayBuffer(e.length * 3 * 4), s = new Float32Array(a), h = new Uint32Array(a), u = 0, l = 0; l < e.length / 2; l++)
        s[u++] = e[l * 2], s[u++] = e[l * 2 + 1], s[u++] = n[l * 2], s[u++] = n[l * 2 + 1], h[u++] = i[l], s[u++] = o[l];
      this._buffer.update(a), this._indexBuffer.update(this.indicesUint16);
    }, t.prototype.processFill = function(e) {
      if (e.holes.length)
        Ll.triangulate(e, this);
      else {
        var n = Io[e.type];
        n.triangulate(e, this);
      }
    }, t.prototype.processLine = function(e) {
      Wh(e, this);
      for (var n = 0; n < e.holes.length; n++)
        Wh(e.holes[n], this);
    }, t.prototype.processHoles = function(e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n], o = Io[i.type];
        o.build(i), i.matrix && this.transformPoints(i.points, i.matrix);
      }
    }, t.prototype.calculateBounds = function() {
      var e = this._bounds;
      e.clear(), e.addVertexData(this.points, 0, this.points.length), e.pad(this.boundsPadding, this.boundsPadding);
    }, t.prototype.transformPoints = function(e, n) {
      for (var i = 0; i < e.length / 2; i++) {
        var o = e[i * 2], a = e[i * 2 + 1];
        e[i * 2] = n.a * o + n.c * a + n.tx, e[i * 2 + 1] = n.b * o + n.d * a + n.ty;
      }
    }, t.prototype.addColors = function(e, n, i, o, a) {
      a === void 0 && (a = 0);
      var s = (n >> 16) + (n & 65280) + ((n & 255) << 16), h = Za(s, i);
      e.length = Math.max(e.length, a + o);
      for (var u = 0; u < o; u++)
        e[a + u] = h;
    }, t.prototype.addTextureIds = function(e, n, i, o) {
      o === void 0 && (o = 0), e.length = Math.max(e.length, o + i);
      for (var a = 0; a < i; a++)
        e[o + a] = n;
    }, t.prototype.addUvs = function(e, n, i, o, a, s) {
      s === void 0 && (s = null);
      for (var h = 0, u = n.length, l = i.frame; h < a; ) {
        var f = e[(o + h) * 2], c = e[(o + h) * 2 + 1];
        if (s) {
          var d = s.a * f + s.c * c + s.tx;
          c = s.b * f + s.d * c + s.ty, f = d;
        }
        h++, n.push(f / l.width, c / l.height);
      }
      var p = i.baseTexture;
      (l.width < p.width || l.height < p.height) && this.adjustUvs(n, i, u, a);
    }, t.prototype.adjustUvs = function(e, n, i, o) {
      for (var a = n.baseTexture, s = 1e-6, h = i + o * 2, u = n.frame, l = u.width / a.width, f = u.height / a.height, c = u.x / u.width, d = u.y / u.height, p = Math.floor(e[i] + s), v = Math.floor(e[i + 1] + s), _ = i + 2; _ < h; _ += 2)
        p = Math.min(p, Math.floor(e[_] + s)), v = Math.min(v, Math.floor(e[_ + 1] + s));
      c -= p, d -= v;
      for (var _ = i; _ < h; _ += 2)
        e[_] = (e[_] + c) * l, e[_ + 1] = (e[_ + 1] + d) * f;
    }, t.BATCHABLE_SIZE = 100, t;
  }(Il)
), cb = (
  /** @class */
  function(r) {
    ts(t, r);
    function t() {
      var e = r !== null && r.apply(this, arguments) || this;
      return e.width = 0, e.alignment = 0.5, e.native = !1, e.cap = Le.BUTT, e.join = Re.MITER, e.miterLimit = 10, e;
    }
    return t.prototype.clone = function() {
      var e = new t();
      return e.color = this.color, e.alpha = this.alpha, e.texture = this.texture, e.matrix = this.matrix, e.visible = this.visible, e.width = this.width, e.alignment = this.alignment, e.native = this.native, e.cap = this.cap, e.join = this.join, e.miterLimit = this.miterLimit, e;
    }, t.prototype.reset = function() {
      r.prototype.reset.call(this), this.color = 0, this.alignment = 0.5, this.width = 0, this.native = !1;
    }, t;
  }(Nl)
), db = new Float32Array(3), Co = {}, cr = (
  /** @class */
  function(r) {
    ts(t, r);
    function t(e) {
      e === void 0 && (e = null);
      var n = r.call(this) || this;
      return n.shader = null, n.pluginName = "batch", n.currentPath = null, n.batches = [], n.batchTint = -1, n.batchDirty = -1, n.vertexData = null, n._fillStyle = new Nl(), n._lineStyle = new cb(), n._matrix = null, n._holeMode = !1, n.state = dr.for2d(), n._geometry = e || new fb(), n._geometry.refCount++, n._transformID = -1, n.tint = 16777215, n.blendMode = Y.NORMAL, n;
    }
    return Object.defineProperty(t.prototype, "geometry", {
      /**
       * Includes vertex positions, face indices, normals, colors, UVs, and
       * custom attributes within buffers, reducing the cost of passing all
       * this data to the GPU. Can be shared between multiple Mesh or Graphics objects.
       * @readonly
       */
      get: function() {
        return this._geometry;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.clone = function() {
      return this.finishPoly(), new t(this._geometry);
    }, Object.defineProperty(t.prototype, "blendMode", {
      get: function() {
        return this.state.blendMode;
      },
      /**
       * The blend mode to be applied to the graphic shape. Apply a value of
       * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.  Note that, since each
       * primitive in the GraphicsGeometry list is rendered sequentially, modes
       * such as `PIXI.BLEND_MODES.ADD` and `PIXI.BLEND_MODES.MULTIPLY` will
       * be applied per-primitive.
       * @default PIXI.BLEND_MODES.NORMAL
       */
      set: function(e) {
        this.state.blendMode = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tint", {
      /**
       * The tint applied to each graphic shape. This is a hex value. A value of
       * 0xFFFFFF will remove any tint effect.
       * @default 0xFFFFFF
       */
      get: function() {
        return this._tint;
      },
      set: function(e) {
        this._tint = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "fill", {
      /**
       * The current fill style.
       * @readonly
       */
      get: function() {
        return this._fillStyle;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "line", {
      /**
       * The current line style.
       * @readonly
       */
      get: function() {
        return this._lineStyle;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.lineStyle = function(e, n, i, o, a) {
      return e === void 0 && (e = null), n === void 0 && (n = 0), i === void 0 && (i = 1), o === void 0 && (o = 0.5), a === void 0 && (a = !1), typeof e == "number" && (e = { width: e, color: n, alpha: i, alignment: o, native: a }), this.lineTextureStyle(e);
    }, t.prototype.lineTextureStyle = function(e) {
      e = Object.assign({
        width: 0,
        texture: J.WHITE,
        color: e && e.texture ? 16777215 : 0,
        alpha: 1,
        matrix: null,
        alignment: 0.5,
        native: !1,
        cap: Le.BUTT,
        join: Re.MITER,
        miterLimit: 10
      }, e), this.currentPath && this.startPoly();
      var n = e.width > 0 && e.alpha > 0;
      return n ? (e.matrix && (e.matrix = e.matrix.clone(), e.matrix.invert()), Object.assign(this._lineStyle, { visible: n }, e)) : this._lineStyle.reset(), this;
    }, t.prototype.startPoly = function() {
      if (this.currentPath) {
        var e = this.currentPath.points, n = this.currentPath.points.length;
        n > 2 && (this.drawShape(this.currentPath), this.currentPath = new ci(), this.currentPath.closeStroke = !1, this.currentPath.points.push(e[n - 2], e[n - 1]));
      } else
        this.currentPath = new ci(), this.currentPath.closeStroke = !1;
    }, t.prototype.finishPoly = function() {
      this.currentPath && (this.currentPath.points.length > 2 ? (this.drawShape(this.currentPath), this.currentPath = null) : this.currentPath.points.length = 0);
    }, t.prototype.moveTo = function(e, n) {
      return this.startPoly(), this.currentPath.points[0] = e, this.currentPath.points[1] = n, this;
    }, t.prototype.lineTo = function(e, n) {
      this.currentPath || this.moveTo(0, 0);
      var i = this.currentPath.points, o = i[i.length - 2], a = i[i.length - 1];
      return (o !== e || a !== n) && i.push(e, n), this;
    }, t.prototype._initCurve = function(e, n) {
      e === void 0 && (e = 0), n === void 0 && (n = 0), this.currentPath ? this.currentPath.points.length === 0 && (this.currentPath.points = [e, n]) : this.moveTo(e, n);
    }, t.prototype.quadraticCurveTo = function(e, n, i, o) {
      this._initCurve();
      var a = this.currentPath.points;
      return a.length === 0 && this.moveTo(0, 0), ub.curveTo(e, n, i, o, a), this;
    }, t.prototype.bezierCurveTo = function(e, n, i, o, a, s) {
      return this._initCurve(), hb.curveTo(e, n, i, o, a, s, this.currentPath.points), this;
    }, t.prototype.arcTo = function(e, n, i, o, a) {
      this._initCurve(e, n);
      var s = this.currentPath.points, h = $h.curveTo(e, n, i, o, a, s);
      if (h) {
        var u = h.cx, l = h.cy, f = h.radius, c = h.startAngle, d = h.endAngle, p = h.anticlockwise;
        this.arc(u, l, f, c, d, p);
      }
      return this;
    }, t.prototype.arc = function(e, n, i, o, a, s) {
      if (s === void 0 && (s = !1), o === a)
        return this;
      !s && a <= o ? a += Pi : s && o <= a && (o += Pi);
      var h = a - o;
      if (h === 0)
        return this;
      var u = e + Math.cos(o) * i, l = n + Math.sin(o) * i, f = this._geometry.closePointEps, c = this.currentPath ? this.currentPath.points : null;
      if (c) {
        var d = Math.abs(c[c.length - 2] - u), p = Math.abs(c[c.length - 1] - l);
        d < f && p < f || c.push(u, l);
      } else
        this.moveTo(u, l), c = this.currentPath.points;
      return $h.arc(u, l, e, n, i, o, a, s, c), this;
    }, t.prototype.beginFill = function(e, n) {
      return e === void 0 && (e = 0), n === void 0 && (n = 1), this.beginTextureFill({ texture: J.WHITE, color: e, alpha: n });
    }, t.prototype.beginTextureFill = function(e) {
      e = Object.assign({
        texture: J.WHITE,
        color: 16777215,
        alpha: 1,
        matrix: null
      }, e), this.currentPath && this.startPoly();
      var n = e.alpha > 0;
      return n ? (e.matrix && (e.matrix = e.matrix.clone(), e.matrix.invert()), Object.assign(this._fillStyle, { visible: n }, e)) : this._fillStyle.reset(), this;
    }, t.prototype.endFill = function() {
      return this.finishPoly(), this._fillStyle.reset(), this;
    }, t.prototype.drawRect = function(e, n, i, o) {
      return this.drawShape(new ut(e, n, i, o));
    }, t.prototype.drawRoundedRect = function(e, n, i, o, a) {
      return this.drawShape(new gy(e, n, i, o, a));
    }, t.prototype.drawCircle = function(e, n, i) {
      return this.drawShape(new my(e, n, i));
    }, t.prototype.drawEllipse = function(e, n, i, o) {
      return this.drawShape(new yy(e, n, i, o));
    }, t.prototype.drawPolygon = function() {
      for (var e = arguments, n = [], i = 0; i < arguments.length; i++)
        n[i] = e[i];
      var o, a = !0, s = n[0];
      s.points ? (a = s.closeStroke, o = s.points) : Array.isArray(n[0]) ? o = n[0] : o = n;
      var h = new ci(o);
      return h.closeStroke = a, this.drawShape(h), this;
    }, t.prototype.drawShape = function(e) {
      return this._holeMode ? this._geometry.drawHole(e, this._matrix) : this._geometry.drawShape(e, this._fillStyle.clone(), this._lineStyle.clone(), this._matrix), this;
    }, t.prototype.clear = function() {
      return this._geometry.clear(), this._lineStyle.reset(), this._fillStyle.reset(), this._boundsID++, this._matrix = null, this._holeMode = !1, this.currentPath = null, this;
    }, t.prototype.isFastRect = function() {
      var e = this._geometry.graphicsData;
      return e.length === 1 && e[0].shape.type === Nt.RECT && !e[0].matrix && !e[0].holes.length && !(e[0].lineStyle.visible && e[0].lineStyle.width);
    }, t.prototype._render = function(e) {
      this.finishPoly();
      var n = this._geometry;
      n.updateBatches(), n.batchable ? (this.batchDirty !== n.batchDirty && this._populateBatches(), this._renderBatched(e)) : (e.batch.flush(), this._renderDirect(e));
    }, t.prototype._populateBatches = function() {
      var e = this._geometry, n = this.blendMode, i = e.batches.length;
      this.batchTint = -1, this._transformID = -1, this.batchDirty = e.batchDirty, this.batches.length = i, this.vertexData = new Float32Array(e.points);
      for (var o = 0; o < i; o++) {
        var a = e.batches[o], s = a.style.color, h = new Float32Array(this.vertexData.buffer, a.attribStart * 4 * 2, a.attribSize * 2), u = new Float32Array(e.uvsFloat32.buffer, a.attribStart * 4 * 2, a.attribSize * 2), l = new Uint16Array(e.indicesUint16.buffer, a.start * 2, a.size), f = {
          vertexData: h,
          blendMode: n,
          indices: l,
          uvs: u,
          _batchRGB: jr(s),
          _tintRGB: s,
          _texture: a.style.texture,
          alpha: a.style.alpha,
          worldAlpha: 1
        };
        this.batches[o] = f;
      }
    }, t.prototype._renderBatched = function(e) {
      if (this.batches.length) {
        e.batch.setObjectRenderer(e.plugins[this.pluginName]), this.calculateVertices(), this.calculateTints();
        for (var n = 0, i = this.batches.length; n < i; n++) {
          var o = this.batches[n];
          o.worldAlpha = this.worldAlpha * o.alpha, e.plugins[this.pluginName].render(o);
        }
      }
    }, t.prototype._renderDirect = function(e) {
      var n = this._resolveDirectShader(e), i = this._geometry, o = this.tint, a = this.worldAlpha, s = n.uniforms, h = i.drawCalls;
      s.translationMatrix = this.transform.worldTransform, s.tint[0] = (o >> 16 & 255) / 255 * a, s.tint[1] = (o >> 8 & 255) / 255 * a, s.tint[2] = (o & 255) / 255 * a, s.tint[3] = a, e.shader.bind(n), e.geometry.bind(i, n), e.state.set(this.state);
      for (var u = 0, l = h.length; u < l; u++)
        this._renderDrawCallDirect(e, i.drawCalls[u]);
    }, t.prototype._renderDrawCallDirect = function(e, n) {
      for (var i = n.texArray, o = n.type, a = n.size, s = n.start, h = i.count, u = 0; u < h; u++)
        e.texture.bind(i.elements[u], u);
      e.geometry.draw(o, a, s);
    }, t.prototype._resolveDirectShader = function(e) {
      var n = this.shader, i = this.pluginName;
      if (!n) {
        if (!Co[i]) {
          for (var o = e.plugins[i].MAX_TEXTURES, a = new Int32Array(o), s = 0; s < o; s++)
            a[s] = s;
          var h = {
            tint: new Float32Array([1, 1, 1, 1]),
            translationMatrix: new Dt(),
            default: hr.from({ uSamplers: a }, !0)
          }, u = e.plugins[i]._shader.program;
          Co[i] = new Ue(u, h);
        }
        n = Co[i];
      }
      return n;
    }, t.prototype._calculateBounds = function() {
      this.finishPoly();
      var e = this._geometry;
      if (e.graphicsData.length) {
        var n = e.bounds, i = n.minX, o = n.minY, a = n.maxX, s = n.maxY;
        this._bounds.addFrame(this.transform, i, o, a, s);
      }
    }, t.prototype.containsPoint = function(e) {
      return this.worldTransform.applyInverse(e, t._TEMP_POINT), this._geometry.containsPoint(t._TEMP_POINT);
    }, t.prototype.calculateTints = function() {
      if (this.batchTint !== this.tint) {
        this.batchTint = this.tint;
        for (var e = jr(this.tint, db), n = 0; n < this.batches.length; n++) {
          var i = this.batches[n], o = i._batchRGB, a = e[0] * o[0] * 255, s = e[1] * o[1] * 255, h = e[2] * o[2] * 255, u = (a << 16) + (s << 8) + (h | 0);
          i._tintRGB = (u >> 16) + (u & 65280) + ((u & 255) << 16);
        }
      }
    }, t.prototype.calculateVertices = function() {
      var e = this.transform._worldID;
      if (this._transformID !== e) {
        this._transformID = e;
        for (var n = this.transform.worldTransform, i = n.a, o = n.b, a = n.c, s = n.d, h = n.tx, u = n.ty, l = this._geometry.points, f = this.vertexData, c = 0, d = 0; d < l.length; d += 2) {
          var p = l[d], v = l[d + 1];
          f[c++] = i * p + a * v + h, f[c++] = s * v + o * p + u;
        }
      }
    }, t.prototype.closePath = function() {
      var e = this.currentPath;
      return e && (e.closeStroke = !0, this.finishPoly()), this;
    }, t.prototype.setMatrix = function(e) {
      return this._matrix = e, this;
    }, t.prototype.beginHole = function() {
      return this.finishPoly(), this._holeMode = !0, this;
    }, t.prototype.endHole = function() {
      return this.finishPoly(), this._holeMode = !1, this;
    }, t.prototype.destroy = function(e) {
      this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose(), this._matrix = null, this.currentPath = null, this._lineStyle.destroy(), this._lineStyle = null, this._fillStyle.destroy(), this._fillStyle = null, this._geometry = null, this.shader = null, this.vertexData = null, this.batches.length = 0, this.batches = null, r.prototype.destroy.call(this, e);
    }, t.nextRoundedRectBehavior = !1, t._TEMP_POINT = new Et(), t;
  }(Te)
);
/*!
 * @pixi/sprite - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/sprite is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ma = function(r, t) {
  return ma = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, ma(r, t);
};
function pb(r, t) {
  ma(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var en = new Et(), vb = new Uint16Array([0, 1, 2, 0, 2, 3]), In = (
  /** @class */
  function(r) {
    pb(t, r);
    function t(e) {
      var n = r.call(this) || this;
      return n._anchor = new Cr(n._onAnchorUpdate, n, e ? e.defaultAnchor.x : 0, e ? e.defaultAnchor.y : 0), n._texture = null, n._width = 0, n._height = 0, n._tint = null, n._tintRGB = null, n.tint = 16777215, n.blendMode = Y.NORMAL, n._cachedTint = 16777215, n.uvs = null, n.texture = e || J.EMPTY, n.vertexData = new Float32Array(8), n.vertexTrimmedData = null, n._transformID = -1, n._textureID = -1, n._transformTrimmedID = -1, n._textureTrimmedID = -1, n.indices = vb, n.pluginName = "batch", n.isSprite = !0, n._roundPixels = G.ROUND_PIXELS, n;
    }
    return t.prototype._onTextureUpdate = function() {
      this._textureID = -1, this._textureTrimmedID = -1, this._cachedTint = 16777215, this._width && (this.scale.x = Ir(this.scale.x) * this._width / this._texture.orig.width), this._height && (this.scale.y = Ir(this.scale.y) * this._height / this._texture.orig.height);
    }, t.prototype._onAnchorUpdate = function() {
      this._transformID = -1, this._transformTrimmedID = -1;
    }, t.prototype.calculateVertices = function() {
      var e = this._texture;
      if (!(this._transformID === this.transform._worldID && this._textureID === e._updateID)) {
        this._textureID !== e._updateID && (this.uvs = this._texture._uvs.uvsFloat32), this._transformID = this.transform._worldID, this._textureID = e._updateID;
        var n = this.transform.worldTransform, i = n.a, o = n.b, a = n.c, s = n.d, h = n.tx, u = n.ty, l = this.vertexData, f = e.trim, c = e.orig, d = this._anchor, p = 0, v = 0, _ = 0, m = 0;
        if (f ? (v = f.x - d._x * c.width, p = v + f.width, m = f.y - d._y * c.height, _ = m + f.height) : (v = -d._x * c.width, p = v + c.width, m = -d._y * c.height, _ = m + c.height), l[0] = i * v + a * m + h, l[1] = s * m + o * v + u, l[2] = i * p + a * m + h, l[3] = s * m + o * p + u, l[4] = i * p + a * _ + h, l[5] = s * _ + o * p + u, l[6] = i * v + a * _ + h, l[7] = s * _ + o * v + u, this._roundPixels)
          for (var y = G.RESOLUTION, g = 0; g < l.length; ++g)
            l[g] = Math.round((l[g] * y | 0) / y);
      }
    }, t.prototype.calculateTrimmedVertices = function() {
      if (!this.vertexTrimmedData)
        this.vertexTrimmedData = new Float32Array(8);
      else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID)
        return;
      this._transformTrimmedID = this.transform._worldID, this._textureTrimmedID = this._texture._updateID;
      var e = this._texture, n = this.vertexTrimmedData, i = e.orig, o = this._anchor, a = this.transform.worldTransform, s = a.a, h = a.b, u = a.c, l = a.d, f = a.tx, c = a.ty, d = -o._x * i.width, p = d + i.width, v = -o._y * i.height, _ = v + i.height;
      n[0] = s * d + u * v + f, n[1] = l * v + h * d + c, n[2] = s * p + u * v + f, n[3] = l * v + h * p + c, n[4] = s * p + u * _ + f, n[5] = l * _ + h * p + c, n[6] = s * d + u * _ + f, n[7] = l * _ + h * d + c;
    }, t.prototype._render = function(e) {
      this.calculateVertices(), e.batch.setObjectRenderer(e.plugins[this.pluginName]), e.plugins[this.pluginName].render(this);
    }, t.prototype._calculateBounds = function() {
      var e = this._texture.trim, n = this._texture.orig;
      !e || e.width === n.width && e.height === n.height ? (this.calculateVertices(), this._bounds.addQuad(this.vertexData)) : (this.calculateTrimmedVertices(), this._bounds.addQuad(this.vertexTrimmedData));
    }, t.prototype.getLocalBounds = function(e) {
      return this.children.length === 0 ? (this._localBounds || (this._localBounds = new Oi()), this._localBounds.minX = this._texture.orig.width * -this._anchor._x, this._localBounds.minY = this._texture.orig.height * -this._anchor._y, this._localBounds.maxX = this._texture.orig.width * (1 - this._anchor._x), this._localBounds.maxY = this._texture.orig.height * (1 - this._anchor._y), e || (this._localBoundsRect || (this._localBoundsRect = new ut()), e = this._localBoundsRect), this._localBounds.getRectangle(e)) : r.prototype.getLocalBounds.call(this, e);
    }, t.prototype.containsPoint = function(e) {
      this.worldTransform.applyInverse(e, en);
      var n = this._texture.orig.width, i = this._texture.orig.height, o = -n * this.anchor.x, a = 0;
      return en.x >= o && en.x < o + n && (a = -i * this.anchor.y, en.y >= a && en.y < a + i);
    }, t.prototype.destroy = function(e) {
      r.prototype.destroy.call(this, e), this._texture.off("update", this._onTextureUpdate, this), this._anchor = null;
      var n = typeof e == "boolean" ? e : e && e.texture;
      if (n) {
        var i = typeof e == "boolean" ? e : e && e.baseTexture;
        this._texture.destroy(!!i);
      }
      this._texture = null;
    }, t.from = function(e, n) {
      var i = e instanceof J ? e : J.from(e, n);
      return new t(i);
    }, Object.defineProperty(t.prototype, "roundPixels", {
      get: function() {
        return this._roundPixels;
      },
      /**
       * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
       *
       * Advantages can include sharper image quality (like text) and faster rendering on canvas.
       * The main disadvantage is movement of objects may appear less smooth.
       *
       * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}.
       * @default false
       */
      set: function(e) {
        this._roundPixels !== e && (this._transformID = -1), this._roundPixels = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "width", {
      /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */
      get: function() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
      },
      set: function(e) {
        var n = Ir(this.scale.x) || 1;
        this.scale.x = n * e / this._texture.orig.width, this._width = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "height", {
      /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */
      get: function() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
      },
      set: function(e) {
        var n = Ir(this.scale.y) || 1;
        this.scale.y = n * e / this._texture.orig.height, this._height = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "anchor", {
      /**
       * The anchor sets the origin point of the sprite. The default value is taken from the {@link PIXI.Texture|Texture}
       * and passed to the constructor.
       *
       * The default is `(0,0)`, this means the sprite's origin is the top left.
       *
       * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
       *
       * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
       *
       * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
       * @example
       * const sprite = new PIXI.Sprite(texture);
       * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
       */
      get: function() {
        return this._anchor;
      },
      set: function(e) {
        this._anchor.copyFrom(e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tint", {
      /**
       * The tint applied to the sprite. This is a hex value.
       *
       * A value of 0xFFFFFF will remove any tint effect.
       * @default 0xFFFFFF
       */
      get: function() {
        return this._tint;
      },
      set: function(e) {
        this._tint = e, this._tintRGB = (e >> 16) + (e & 65280) + ((e & 255) << 16);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "texture", {
      /** The texture that the sprite is using. */
      get: function() {
        return this._texture;
      },
      set: function(e) {
        this._texture !== e && (this._texture && this._texture.off("update", this._onTextureUpdate, this), this._texture = e || J.EMPTY, this._cachedTint = 16777215, this._textureID = -1, this._textureTrimmedID = -1, e && (e.baseTexture.valid ? this._onTextureUpdate() : e.once("update", this._onTextureUpdate, this)));
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Te)
);
/*!
 * @pixi/text - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/text is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ya = function(r, t) {
  return ya = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, ya(r, t);
};
function _b(r, t) {
  ya(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var xn;
(function(r) {
  r[r.LINEAR_VERTICAL = 0] = "LINEAR_VERTICAL", r[r.LINEAR_HORIZONTAL = 1] = "LINEAR_HORIZONTAL";
})(xn || (xn = {}));
var Mo = {
  align: "left",
  breakWords: !1,
  dropShadow: !1,
  dropShadowAlpha: 1,
  dropShadowAngle: Math.PI / 6,
  dropShadowBlur: 0,
  dropShadowColor: "black",
  dropShadowDistance: 5,
  fill: "black",
  fillGradientType: xn.LINEAR_VERTICAL,
  fillGradientStops: [],
  fontFamily: "Arial",
  fontSize: 26,
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: "normal",
  letterSpacing: 0,
  lineHeight: 0,
  lineJoin: "miter",
  miterLimit: 10,
  padding: 0,
  stroke: "black",
  strokeThickness: 0,
  textBaseline: "alphabetic",
  trim: !1,
  whiteSpace: "pre",
  wordWrap: !1,
  wordWrapWidth: 100,
  leading: 0
}, mb = [
  "serif",
  "sans-serif",
  "monospace",
  "cursive",
  "fantasy",
  "system-ui"
], Vr = (
  /** @class */
  function() {
    function r(t) {
      this.styleID = 0, this.reset(), Fo(this, t, t);
    }
    return r.prototype.clone = function() {
      var t = {};
      return Fo(t, this, Mo), new r(t);
    }, r.prototype.reset = function() {
      Fo(this, Mo, Mo);
    }, Object.defineProperty(r.prototype, "align", {
      /**
       * Alignment for multiline text ('left', 'center' or 'right'), does not affect single line text
       *
       * @member {string}
       */
      get: function() {
        return this._align;
      },
      set: function(t) {
        this._align !== t && (this._align = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "breakWords", {
      /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */
      get: function() {
        return this._breakWords;
      },
      set: function(t) {
        this._breakWords !== t && (this._breakWords = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "dropShadow", {
      /** Set a drop shadow for the text. */
      get: function() {
        return this._dropShadow;
      },
      set: function(t) {
        this._dropShadow !== t && (this._dropShadow = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "dropShadowAlpha", {
      /** Set alpha for the drop shadow. */
      get: function() {
        return this._dropShadowAlpha;
      },
      set: function(t) {
        this._dropShadowAlpha !== t && (this._dropShadowAlpha = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "dropShadowAngle", {
      /** Set a angle of the drop shadow. */
      get: function() {
        return this._dropShadowAngle;
      },
      set: function(t) {
        this._dropShadowAngle !== t && (this._dropShadowAngle = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "dropShadowBlur", {
      /** Set a shadow blur radius. */
      get: function() {
        return this._dropShadowBlur;
      },
      set: function(t) {
        this._dropShadowBlur !== t && (this._dropShadowBlur = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "dropShadowColor", {
      /** A fill style to be used on the dropshadow e.g 'red', '#00FF00'. */
      get: function() {
        return this._dropShadowColor;
      },
      set: function(t) {
        var e = Do(t);
        this._dropShadowColor !== e && (this._dropShadowColor = e, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "dropShadowDistance", {
      /** Set a distance of the drop shadow. */
      get: function() {
        return this._dropShadowDistance;
      },
      set: function(t) {
        this._dropShadowDistance !== t && (this._dropShadowDistance = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "fill", {
      /**
       * A canvas fillstyle that will be used on the text e.g 'red', '#00FF00'.
       *
       * Can be an array to create a gradient eg ['#000000','#FFFFFF']
       * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
       *
       * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
       */
      get: function() {
        return this._fill;
      },
      set: function(t) {
        var e = Do(t);
        this._fill !== e && (this._fill = e, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "fillGradientType", {
      /**
       * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
       *
       * @see PIXI.TEXT_GRADIENT
       */
      get: function() {
        return this._fillGradientType;
      },
      set: function(t) {
        this._fillGradientType !== t && (this._fillGradientType = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "fillGradientStops", {
      /**
       * If fill is an array of colours to create a gradient, this array can set the stop points
       * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
       */
      get: function() {
        return this._fillGradientStops;
      },
      set: function(t) {
        yb(this._fillGradientStops, t) || (this._fillGradientStops = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "fontFamily", {
      /** The font family. */
      get: function() {
        return this._fontFamily;
      },
      set: function(t) {
        this.fontFamily !== t && (this._fontFamily = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "fontSize", {
      /**
       * The font size
       * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
       */
      get: function() {
        return this._fontSize;
      },
      set: function(t) {
        this._fontSize !== t && (this._fontSize = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "fontStyle", {
      /**
       * The font style
       * ('normal', 'italic' or 'oblique')
       *
       * @member {string}
       */
      get: function() {
        return this._fontStyle;
      },
      set: function(t) {
        this._fontStyle !== t && (this._fontStyle = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "fontVariant", {
      /**
       * The font variant
       * ('normal' or 'small-caps')
       *
       * @member {string}
       */
      get: function() {
        return this._fontVariant;
      },
      set: function(t) {
        this._fontVariant !== t && (this._fontVariant = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "fontWeight", {
      /**
       * The font weight
       * ('normal', 'bold', 'bolder', 'lighter' and '100', '200', '300', '400', '500', '600', '700', 800' or '900')
       *
       * @member {string}
       */
      get: function() {
        return this._fontWeight;
      },
      set: function(t) {
        this._fontWeight !== t && (this._fontWeight = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "letterSpacing", {
      /** The amount of spacing between letters, default is 0. */
      get: function() {
        return this._letterSpacing;
      },
      set: function(t) {
        this._letterSpacing !== t && (this._letterSpacing = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "lineHeight", {
      /** The line height, a number that represents the vertical space that a letter uses. */
      get: function() {
        return this._lineHeight;
      },
      set: function(t) {
        this._lineHeight !== t && (this._lineHeight = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "leading", {
      /** The space between lines. */
      get: function() {
        return this._leading;
      },
      set: function(t) {
        this._leading !== t && (this._leading = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "lineJoin", {
      /**
       * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
       * Default is 'miter' (creates a sharp corner).
       *
       * @member {string}
       */
      get: function() {
        return this._lineJoin;
      },
      set: function(t) {
        this._lineJoin !== t && (this._lineJoin = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "miterLimit", {
      /**
       * The miter limit to use when using the 'miter' lineJoin mode.
       *
       * This can reduce or increase the spikiness of rendered text.
       */
      get: function() {
        return this._miterLimit;
      },
      set: function(t) {
        this._miterLimit !== t && (this._miterLimit = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "padding", {
      /**
       * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
       * by adding padding to all sides of the text.
       */
      get: function() {
        return this._padding;
      },
      set: function(t) {
        this._padding !== t && (this._padding = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "stroke", {
      /**
       * A canvas fillstyle that will be used on the text stroke
       * e.g 'blue', '#FCFF00'
       */
      get: function() {
        return this._stroke;
      },
      set: function(t) {
        var e = Do(t);
        this._stroke !== e && (this._stroke = e, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "strokeThickness", {
      /**
       * A number that represents the thickness of the stroke.
       *
       * @default 0
       */
      get: function() {
        return this._strokeThickness;
      },
      set: function(t) {
        this._strokeThickness !== t && (this._strokeThickness = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "textBaseline", {
      /**
       * The baseline of the text that is rendered.
       *
       * @member {string}
       */
      get: function() {
        return this._textBaseline;
      },
      set: function(t) {
        this._textBaseline !== t && (this._textBaseline = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "trim", {
      /** Trim transparent borders. */
      get: function() {
        return this._trim;
      },
      set: function(t) {
        this._trim !== t && (this._trim = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "whiteSpace", {
      /**
       * How newlines and spaces should be handled.
       * Default is 'pre' (preserve, preserve).
       *
       *  value       | New lines     |   Spaces
       *  ---         | ---           |   ---
       * 'normal'     | Collapse      |   Collapse
       * 'pre'        | Preserve      |   Preserve
       * 'pre-line'   | Preserve      |   Collapse
       *
       * @member {string}
       */
      get: function() {
        return this._whiteSpace;
      },
      set: function(t) {
        this._whiteSpace !== t && (this._whiteSpace = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "wordWrap", {
      /** Indicates if word wrap should be used. */
      get: function() {
        return this._wordWrap;
      },
      set: function(t) {
        this._wordWrap !== t && (this._wordWrap = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "wordWrapWidth", {
      /** The width at which text will wrap, it needs wordWrap to be set to true. */
      get: function() {
        return this._wordWrapWidth;
      },
      set: function(t) {
        this._wordWrapWidth !== t && (this._wordWrapWidth = t, this.styleID++);
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.toFontString = function() {
      var t = typeof this.fontSize == "number" ? this.fontSize + "px" : this.fontSize, e = this.fontFamily;
      Array.isArray(this.fontFamily) || (e = this.fontFamily.split(","));
      for (var n = e.length - 1; n >= 0; n--) {
        var i = e[n].trim();
        !/([\"\'])[^\'\"]+\1/.test(i) && mb.indexOf(i) < 0 && (i = '"' + i + '"'), e[n] = i;
      }
      return this.fontStyle + " " + this.fontVariant + " " + this.fontWeight + " " + t + " " + e.join(",");
    }, r;
  }()
);
function Zh(r) {
  return typeof r == "number" ? sl(r) : (typeof r == "string" && r.indexOf("0x") === 0 && (r = r.replace("0x", "#")), r);
}
function Do(r) {
  if (Array.isArray(r)) {
    for (var t = 0; t < r.length; ++t)
      r[t] = Zh(r[t]);
    return r;
  } else
    return Zh(r);
}
function yb(r, t) {
  if (!Array.isArray(r) || !Array.isArray(t) || r.length !== t.length)
    return !1;
  for (var e = 0; e < r.length; ++e)
    if (r[e] !== t[e])
      return !1;
  return !0;
}
function Fo(r, t, e) {
  for (var n in e)
    Array.isArray(t[n]) ? r[n] = t[n].slice() : r[n] = t[n];
}
var ai = {
  // TextMetrics requires getImageData readback for measuring fonts.
  willReadFrequently: !0
}, Ee = (
  /** @class */
  function() {
    function r(t, e, n, i, o, a, s, h, u) {
      this.text = t, this.style = e, this.width = n, this.height = i, this.lines = o, this.lineWidths = a, this.lineHeight = s, this.maxLineWidth = h, this.fontProperties = u;
    }
    return r.measureText = function(t, e, n, i) {
      i === void 0 && (i = r._canvas), n = n ?? e.wordWrap;
      var o = e.toFontString(), a = r.measureFont(o);
      a.fontSize === 0 && (a.fontSize = e.fontSize, a.ascent = e.fontSize);
      var s = i.getContext("2d", ai);
      s.font = o;
      for (var h = n ? r.wordWrap(t, e, i) : t, u = h.split(/(?:\r\n|\r|\n)/), l = new Array(u.length), f = 0, c = 0; c < u.length; c++) {
        var d = s.measureText(u[c]).width + (u[c].length - 1) * e.letterSpacing;
        l[c] = d, f = Math.max(f, d);
      }
      var p = f + e.strokeThickness;
      e.dropShadow && (p += e.dropShadowDistance);
      var v = e.lineHeight || a.fontSize + e.strokeThickness, _ = Math.max(v, a.fontSize + e.strokeThickness) + (u.length - 1) * (v + e.leading);
      return e.dropShadow && (_ += e.dropShadowDistance), new r(t, e, p, _, u, l, v + e.leading, f, a);
    }, r.wordWrap = function(t, e, n) {
      n === void 0 && (n = r._canvas);
      for (var i = n.getContext("2d", ai), o = 0, a = "", s = "", h = /* @__PURE__ */ Object.create(null), u = e.letterSpacing, l = e.whiteSpace, f = r.collapseSpaces(l), c = r.collapseNewlines(l), d = !f, p = e.wordWrapWidth + u, v = r.tokenize(t), _ = 0; _ < v.length; _++) {
        var m = v[_];
        if (r.isNewline(m)) {
          if (!c) {
            s += r.addLine(a), d = !f, a = "", o = 0;
            continue;
          }
          m = " ";
        }
        if (f) {
          var y = r.isBreakingSpace(m), g = r.isBreakingSpace(a[a.length - 1]);
          if (y && g)
            continue;
        }
        var x = r.getFromCache(m, u, h, i);
        if (x > p)
          if (a !== "" && (s += r.addLine(a), a = "", o = 0), r.canBreakWords(m, e.breakWords))
            for (var T = r.wordWrapSplit(m), E = 0; E < T.length; E++) {
              for (var P = T[E], b = 1; T[E + b]; ) {
                var w = T[E + b], A = P[P.length - 1];
                if (!r.canBreakChars(A, w, m, E, e.breakWords))
                  P += w;
                else
                  break;
                b++;
              }
              E += P.length - 1;
              var R = r.getFromCache(P, u, h, i);
              R + o > p && (s += r.addLine(a), d = !1, a = "", o = 0), a += P, o += R;
            }
          else {
            a.length > 0 && (s += r.addLine(a), a = "", o = 0);
            var C = _ === v.length - 1;
            s += r.addLine(m, !C), d = !1, a = "", o = 0;
          }
        else
          x + o > p && (d = !1, s += r.addLine(a), a = "", o = 0), (a.length > 0 || !r.isBreakingSpace(m) || d) && (a += m, o += x);
      }
      return s += r.addLine(a, !1), s;
    }, r.addLine = function(t, e) {
      return e === void 0 && (e = !0), t = r.trimRight(t), t = e ? t + `
` : t, t;
    }, r.getFromCache = function(t, e, n, i) {
      var o = n[t];
      if (typeof o != "number") {
        var a = t.length * e;
        o = i.measureText(t).width + a, n[t] = o;
      }
      return o;
    }, r.collapseSpaces = function(t) {
      return t === "normal" || t === "pre-line";
    }, r.collapseNewlines = function(t) {
      return t === "normal";
    }, r.trimRight = function(t) {
      if (typeof t != "string")
        return "";
      for (var e = t.length - 1; e >= 0; e--) {
        var n = t[e];
        if (!r.isBreakingSpace(n))
          break;
        t = t.slice(0, -1);
      }
      return t;
    }, r.isNewline = function(t) {
      return typeof t != "string" ? !1 : r._newlines.indexOf(t.charCodeAt(0)) >= 0;
    }, r.isBreakingSpace = function(t, e) {
      return typeof t != "string" ? !1 : r._breakingSpaces.indexOf(t.charCodeAt(0)) >= 0;
    }, r.tokenize = function(t) {
      var e = [], n = "";
      if (typeof t != "string")
        return e;
      for (var i = 0; i < t.length; i++) {
        var o = t[i], a = t[i + 1];
        if (r.isBreakingSpace(o, a) || r.isNewline(o)) {
          n !== "" && (e.push(n), n = ""), e.push(o);
          continue;
        }
        n += o;
      }
      return n !== "" && e.push(n), e;
    }, r.canBreakWords = function(t, e) {
      return e;
    }, r.canBreakChars = function(t, e, n, i, o) {
      return !0;
    }, r.wordWrapSplit = function(t) {
      return t.split("");
    }, r.measureFont = function(t) {
      if (r._fonts[t])
        return r._fonts[t];
      var e = {
        ascent: 0,
        descent: 0,
        fontSize: 0
      }, n = r._canvas, i = r._context;
      i.font = t;
      var o = r.METRICS_STRING + r.BASELINE_SYMBOL, a = Math.ceil(i.measureText(o).width), s = Math.ceil(i.measureText(r.BASELINE_SYMBOL).width), h = Math.ceil(r.HEIGHT_MULTIPLIER * s);
      s = s * r.BASELINE_MULTIPLIER | 0, n.width = a, n.height = h, i.fillStyle = "#f00", i.fillRect(0, 0, a, h), i.font = t, i.textBaseline = "alphabetic", i.fillStyle = "#000", i.fillText(o, 0, s);
      var u = i.getImageData(0, 0, a, h).data, l = u.length, f = a * 4, c = 0, d = 0, p = !1;
      for (c = 0; c < s; ++c) {
        for (var v = 0; v < f; v += 4)
          if (u[d + v] !== 255) {
            p = !0;
            break;
          }
        if (!p)
          d += f;
        else
          break;
      }
      for (e.ascent = s - c, d = l - f, p = !1, c = h; c > s; --c) {
        for (var v = 0; v < f; v += 4)
          if (u[d + v] !== 255) {
            p = !0;
            break;
          }
        if (!p)
          d -= f;
        else
          break;
      }
      return e.descent = c - s, e.fontSize = e.ascent + e.descent, r._fonts[t] = e, e;
    }, r.clearMetrics = function(t) {
      t === void 0 && (t = ""), t ? delete r._fonts[t] : r._fonts = {};
    }, Object.defineProperty(r, "_canvas", {
      /**
       * Cached canvas element for measuring text
       * TODO: this should be private, but isn't because of backward compat, will fix later.
       * @ignore
       */
      get: function() {
        if (!r.__canvas) {
          var t = void 0;
          try {
            var e = new OffscreenCanvas(0, 0), n = e.getContext("2d", ai);
            if (n && n.measureText)
              return r.__canvas = e, e;
            t = G.ADAPTER.createCanvas();
          } catch {
            t = G.ADAPTER.createCanvas();
          }
          t.width = t.height = 10, r.__canvas = t;
        }
        return r.__canvas;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r, "_context", {
      /**
       * TODO: this should be private, but isn't because of backward compat, will fix later.
       * @ignore
       */
      get: function() {
        return r.__context || (r.__context = r._canvas.getContext("2d", ai)), r.__context;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }()
);
Ee._fonts = {};
Ee.METRICS_STRING = "|ÉqÅ";
Ee.BASELINE_SYMBOL = "M";
Ee.BASELINE_MULTIPLIER = 1.4;
Ee.HEIGHT_MULTIPLIER = 2;
Ee._newlines = [
  10,
  13
];
Ee._breakingSpaces = [
  9,
  32,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8200,
  8201,
  8202,
  8287,
  12288
];
var gb = {
  texture: !0,
  children: !1,
  baseTexture: !0
}, Ul = (
  /** @class */
  function(r) {
    _b(t, r);
    function t(e, n, i) {
      var o = this, a = !1;
      i || (i = G.ADAPTER.createCanvas(), a = !0), i.width = 3, i.height = 3;
      var s = J.from(i);
      return s.orig = new ut(), s.trim = new ut(), o = r.call(this, s) || this, o._ownCanvas = a, o.canvas = i, o.context = i.getContext("2d", {
        // required for trimming to work without warnings
        willReadFrequently: !0
      }), o._resolution = G.RESOLUTION, o._autoResolution = !0, o._text = null, o._style = null, o._styleListener = null, o._font = "", o.text = e, o.style = n, o.localStyleID = -1, o;
    }
    return t.prototype.updateText = function(e) {
      var n = this._style;
      if (this.localStyleID !== n.styleID && (this.dirty = !0, this.localStyleID = n.styleID), !(!this.dirty && e)) {
        this._font = this._style.toFontString();
        var i = this.context, o = Ee.measureText(this._text || " ", this._style, this._style.wordWrap, this.canvas), a = o.width, s = o.height, h = o.lines, u = o.lineHeight, l = o.lineWidths, f = o.maxLineWidth, c = o.fontProperties;
        this.canvas.width = Math.ceil(Math.ceil(Math.max(1, a) + n.padding * 2) * this._resolution), this.canvas.height = Math.ceil(Math.ceil(Math.max(1, s) + n.padding * 2) * this._resolution), i.scale(this._resolution, this._resolution), i.clearRect(0, 0, this.canvas.width, this.canvas.height), i.font = this._font, i.lineWidth = n.strokeThickness, i.textBaseline = n.textBaseline, i.lineJoin = n.lineJoin, i.miterLimit = n.miterLimit;
        for (var d, p, v = n.dropShadow ? 2 : 1, _ = 0; _ < v; ++_) {
          var m = n.dropShadow && _ === 0, y = m ? Math.ceil(Math.max(1, s) + n.padding * 2) : 0, g = y * this._resolution;
          if (m) {
            i.fillStyle = "black", i.strokeStyle = "black";
            var x = n.dropShadowColor, T = jr(typeof x == "number" ? x : Yr(x)), E = n.dropShadowBlur * this._resolution, P = n.dropShadowDistance * this._resolution;
            i.shadowColor = "rgba(" + T[0] * 255 + "," + T[1] * 255 + "," + T[2] * 255 + "," + n.dropShadowAlpha + ")", i.shadowBlur = E, i.shadowOffsetX = Math.cos(n.dropShadowAngle) * P, i.shadowOffsetY = Math.sin(n.dropShadowAngle) * P + g;
          } else
            i.fillStyle = this._generateFillStyle(n, h, o), i.strokeStyle = n.stroke, i.shadowColor = "black", i.shadowBlur = 0, i.shadowOffsetX = 0, i.shadowOffsetY = 0;
          var b = (u - c.fontSize) / 2;
          (!t.nextLineHeightBehavior || u - c.fontSize < 0) && (b = 0);
          for (var w = 0; w < h.length; w++)
            d = n.strokeThickness / 2, p = n.strokeThickness / 2 + w * u + c.ascent + b, n.align === "right" ? d += f - l[w] : n.align === "center" && (d += (f - l[w]) / 2), n.stroke && n.strokeThickness && this.drawLetterSpacing(h[w], d + n.padding, p + n.padding - y, !0), n.fill && this.drawLetterSpacing(h[w], d + n.padding, p + n.padding - y);
        }
        this.updateTexture();
      }
    }, t.prototype.drawLetterSpacing = function(e, n, i, o) {
      o === void 0 && (o = !1);
      var a = this._style, s = a.letterSpacing, h = t.experimentalLetterSpacing && ("letterSpacing" in CanvasRenderingContext2D.prototype || "textLetterSpacing" in CanvasRenderingContext2D.prototype);
      if (s === 0 || h) {
        h && (this.context.letterSpacing = s, this.context.textLetterSpacing = s), o ? this.context.strokeText(e, n, i) : this.context.fillText(e, n, i);
        return;
      }
      for (var u = n, l = Array.from ? Array.from(e) : e.split(""), f = this.context.measureText(e).width, c = 0, d = 0; d < l.length; ++d) {
        var p = l[d];
        o ? this.context.strokeText(p, u, i) : this.context.fillText(p, u, i);
        for (var v = "", _ = d + 1; _ < l.length; ++_)
          v += l[_];
        c = this.context.measureText(v).width, u += f - c + s, f = c;
      }
    }, t.prototype.updateTexture = function() {
      var e = this.canvas;
      if (this._style.trim) {
        var n = dy(e);
        n.data && (e.width = n.width, e.height = n.height, this.context.putImageData(n.data, 0, 0));
      }
      var i = this._texture, o = this._style, a = o.trim ? 0 : o.padding, s = i.baseTexture;
      i.trim.width = i._frame.width = e.width / this._resolution, i.trim.height = i._frame.height = e.height / this._resolution, i.trim.x = -a, i.trim.y = -a, i.orig.width = i._frame.width - a * 2, i.orig.height = i._frame.height - a * 2, this._onTextureUpdate(), s.setRealSize(e.width, e.height, this._resolution), i.updateUvs(), this.dirty = !1;
    }, t.prototype._render = function(e) {
      this._autoResolution && this._resolution !== e.resolution && (this._resolution = e.resolution, this.dirty = !0), this.updateText(!0), r.prototype._render.call(this, e);
    }, t.prototype.updateTransform = function() {
      this.updateText(!0), r.prototype.updateTransform.call(this);
    }, t.prototype.getBounds = function(e, n) {
      return this.updateText(!0), this._textureID === -1 && (e = !1), r.prototype.getBounds.call(this, e, n);
    }, t.prototype.getLocalBounds = function(e) {
      return this.updateText(!0), r.prototype.getLocalBounds.call(this, e);
    }, t.prototype._calculateBounds = function() {
      this.calculateVertices(), this._bounds.addQuad(this.vertexData);
    }, t.prototype._generateFillStyle = function(e, n, i) {
      var o = e.fill;
      if (Array.isArray(o)) {
        if (o.length === 1)
          return o[0];
      } else
        return o;
      var a, s = e.dropShadow ? e.dropShadowDistance : 0, h = e.padding || 0, u = this.canvas.width / this._resolution - s - h * 2, l = this.canvas.height / this._resolution - s - h * 2, f = o.slice(), c = e.fillGradientStops.slice();
      if (!c.length)
        for (var d = f.length + 1, p = 1; p < d; ++p)
          c.push(p / d);
      if (f.unshift(o[0]), c.unshift(0), f.push(o[o.length - 1]), c.push(1), e.fillGradientType === xn.LINEAR_VERTICAL) {
        a = this.context.createLinearGradient(u / 2, h, u / 2, l + h);
        for (var v = i.fontProperties.fontSize + e.strokeThickness, p = 0; p < n.length; p++) {
          var _ = i.lineHeight * (p - 1) + v, m = i.lineHeight * p, y = m;
          p > 0 && _ > m && (y = (m + _) / 2);
          var g = m + v, x = i.lineHeight * (p + 1), T = g;
          p + 1 < n.length && x < g && (T = (g + x) / 2);
          for (var E = (T - y) / l, P = 0; P < f.length; P++) {
            var b = 0;
            typeof c[P] == "number" ? b = c[P] : b = P / f.length;
            var w = Math.min(1, Math.max(0, y / l + b * E));
            w = Number(w.toFixed(5)), a.addColorStop(w, f[P]);
          }
        }
      } else {
        a = this.context.createLinearGradient(h, l / 2, u + h, l / 2);
        for (var A = f.length + 1, R = 1, p = 0; p < f.length; p++) {
          var C = void 0;
          typeof c[p] == "number" ? C = c[p] : C = R / A, a.addColorStop(C, f[p]), R++;
        }
      }
      return a;
    }, t.prototype.destroy = function(e) {
      typeof e == "boolean" && (e = { children: e }), e = Object.assign({}, gb, e), r.prototype.destroy.call(this, e), this._ownCanvas && (this.canvas.height = this.canvas.width = 0), this.context = null, this.canvas = null, this._style = null;
    }, Object.defineProperty(t.prototype, "width", {
      /** The width of the Text, setting this will actually modify the scale to achieve the value set. */
      get: function() {
        return this.updateText(!0), Math.abs(this.scale.x) * this._texture.orig.width;
      },
      set: function(e) {
        this.updateText(!0);
        var n = Ir(this.scale.x) || 1;
        this.scale.x = n * e / this._texture.orig.width, this._width = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "height", {
      /** The height of the Text, setting this will actually modify the scale to achieve the value set. */
      get: function() {
        return this.updateText(!0), Math.abs(this.scale.y) * this._texture.orig.height;
      },
      set: function(e) {
        this.updateText(!0);
        var n = Ir(this.scale.y) || 1;
        this.scale.y = n * e / this._texture.orig.height, this._height = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "style", {
      /**
       * Set the style of the text.
       *
       * Set up an event listener to listen for changes on the style object and mark the text as dirty.
       */
      get: function() {
        return this._style;
      },
      set: function(e) {
        e = e || {}, e instanceof Vr ? this._style = e : this._style = new Vr(e), this.localStyleID = -1, this.dirty = !0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "text", {
      /** Set the copy for the text object. To split a line you can use '\n'. */
      get: function() {
        return this._text;
      },
      set: function(e) {
        e = String(e ?? ""), this._text !== e && (this._text = e, this.dirty = !0);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "resolution", {
      /**
       * The resolution / device pixel ratio of the canvas.
       *
       * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
       * @default 1
       */
      get: function() {
        return this._resolution;
      },
      set: function(e) {
        this._autoResolution = !1, this._resolution !== e && (this._resolution = e, this.dirty = !0);
      },
      enumerable: !1,
      configurable: !0
    }), t.nextLineHeightBehavior = !1, t.experimentalLetterSpacing = !1, t;
  }(In)
);
/*!
 * @pixi/prepare - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/prepare is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
G.UPLOADS_PER_FRAME = 4;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ga = function(r, t) {
  return ga = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, ga(r, t);
};
function bb(r, t) {
  ga(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var xb = (
  /** @class */
  function() {
    function r(t) {
      this.maxItemsPerFrame = t, this.itemsLeft = 0;
    }
    return r.prototype.beginFrame = function() {
      this.itemsLeft = this.maxItemsPerFrame;
    }, r.prototype.allowedToUpload = function() {
      return this.itemsLeft-- > 0;
    }, r;
  }()
);
function Tb(r, t) {
  var e = !1;
  if (r && r._textures && r._textures.length) {
    for (var n = 0; n < r._textures.length; n++)
      if (r._textures[n] instanceof J) {
        var i = r._textures[n].baseTexture;
        t.indexOf(i) === -1 && (t.push(i), e = !0);
      }
  }
  return e;
}
function Eb(r, t) {
  if (r.baseTexture instanceof ht) {
    var e = r.baseTexture;
    return t.indexOf(e) === -1 && t.push(e), !0;
  }
  return !1;
}
function wb(r, t) {
  if (r._texture && r._texture instanceof J) {
    var e = r._texture.baseTexture;
    return t.indexOf(e) === -1 && t.push(e), !0;
  }
  return !1;
}
function Sb(r, t) {
  return t instanceof Ul ? (t.updateText(!0), !0) : !1;
}
function Ab(r, t) {
  if (t instanceof Vr) {
    var e = t.toFontString();
    return Ee.measureFont(e), !0;
  }
  return !1;
}
function Pb(r, t) {
  if (r instanceof Ul) {
    t.indexOf(r.style) === -1 && t.push(r.style), t.indexOf(r) === -1 && t.push(r);
    var e = r._texture.baseTexture;
    return t.indexOf(e) === -1 && t.push(e), !0;
  }
  return !1;
}
function Ob(r, t) {
  return r instanceof Vr ? (t.indexOf(r) === -1 && t.push(r), !0) : !1;
}
var Rb = (
  /** @class */
  function() {
    function r(t) {
      var e = this;
      this.limiter = new xb(G.UPLOADS_PER_FRAME), this.renderer = t, this.uploadHookHelper = null, this.queue = [], this.addHooks = [], this.uploadHooks = [], this.completes = [], this.ticking = !1, this.delayedTick = function() {
        e.queue && e.prepareItems();
      }, this.registerFindHook(Pb), this.registerFindHook(Ob), this.registerFindHook(Tb), this.registerFindHook(Eb), this.registerFindHook(wb), this.registerUploadHook(Sb), this.registerUploadHook(Ab);
    }
    return r.prototype.upload = function(t, e) {
      var n = this;
      return typeof t == "function" && (e = t, t = null), e && ce("6.5.0", "BasePrepare.upload callback is deprecated, use the return Promise instead."), new Promise(function(i) {
        t && n.add(t);
        var o = function() {
          e == null || e(), i();
        };
        n.queue.length ? (n.completes.push(o), n.ticking || (n.ticking = !0, Ht.system.addOnce(n.tick, n, Ce.UTILITY))) : o();
      });
    }, r.prototype.tick = function() {
      setTimeout(this.delayedTick, 0);
    }, r.prototype.prepareItems = function() {
      for (this.limiter.beginFrame(); this.queue.length && this.limiter.allowedToUpload(); ) {
        var t = this.queue[0], e = !1;
        if (t && !t._destroyed) {
          for (var n = 0, i = this.uploadHooks.length; n < i; n++)
            if (this.uploadHooks[n](this.uploadHookHelper, t)) {
              this.queue.shift(), e = !0;
              break;
            }
        }
        e || this.queue.shift();
      }
      if (this.queue.length)
        Ht.system.addOnce(this.tick, this, Ce.UTILITY);
      else {
        this.ticking = !1;
        var o = this.completes.slice(0);
        this.completes.length = 0;
        for (var n = 0, i = o.length; n < i; n++)
          o[n]();
      }
    }, r.prototype.registerFindHook = function(t) {
      return t && this.addHooks.push(t), this;
    }, r.prototype.registerUploadHook = function(t) {
      return t && this.uploadHooks.push(t), this;
    }, r.prototype.add = function(t) {
      for (var e = 0, n = this.addHooks.length; e < n && !this.addHooks[e](t, this.queue); e++)
        ;
      if (t instanceof Te)
        for (var e = t.children.length - 1; e >= 0; e--)
          this.add(t.children[e]);
      return this;
    }, r.prototype.destroy = function() {
      this.ticking && Ht.system.remove(this.tick, this), this.ticking = !1, this.addHooks = null, this.uploadHooks = null, this.renderer = null, this.completes = null, this.queue = null, this.limiter = null, this.uploadHookHelper = null;
    }, r;
  }()
);
function Gl(r, t) {
  return t instanceof ht ? (t._glTextures[r.CONTEXT_UID] || r.texture.bind(t), !0) : !1;
}
function Ib(r, t) {
  if (!(t instanceof cr))
    return !1;
  var e = t.geometry;
  t.finishPoly(), e.updateBatches();
  for (var n = e.batches, i = 0; i < n.length; i++) {
    var o = n[i].style.texture;
    o && Gl(r, o.baseTexture);
  }
  return e.batchable || r.geometry.bind(e, t._resolveDirectShader(r)), !0;
}
function Cb(r, t) {
  return r instanceof cr ? (t.push(r), !0) : !1;
}
var Mb = (
  /** @class */
  function(r) {
    bb(t, r);
    function t(e) {
      var n = r.call(this, e) || this;
      return n.uploadHookHelper = n.renderer, n.registerFindHook(Cb), n.registerUploadHook(Gl), n.registerUploadHook(Ib), n;
    }
    return t.extension = {
      name: "prepare",
      type: mt.RendererPlugin
    }, t;
  }(Rb)
);
/*!
 * @pixi/spritesheet - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/spritesheet is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var Db = (
  /** @class */
  function() {
    function r(t, e, n) {
      n === void 0 && (n = null), this.linkedSheets = [], this._texture = t instanceof J ? t : null, this.baseTexture = t instanceof ht ? t : this._texture.baseTexture, this.textures = {}, this.animations = {}, this.data = e;
      var i = this.baseTexture.resource;
      this.resolution = this._updateResolution(n || (i ? i.url : null)), this._frames = this.data.frames, this._frameKeys = Object.keys(this._frames), this._batchIndex = 0, this._callback = null;
    }
    return r.prototype._updateResolution = function(t) {
      t === void 0 && (t = null);
      var e = this.data.meta.scale, n = Ai(t, null);
      return n === null && (n = e !== void 0 ? parseFloat(e) : 1), n !== 1 && this.baseTexture.setResolution(n), n;
    }, r.prototype.parse = function(t) {
      var e = this;
      return t && ce("6.5.0", "Spritesheet.parse callback is deprecated, use the return Promise instead."), new Promise(function(n) {
        e._callback = function(i) {
          t == null || t(i), n(i);
        }, e._batchIndex = 0, e._frameKeys.length <= r.BATCH_SIZE ? (e._processFrames(0), e._processAnimations(), e._parseComplete()) : e._nextBatch();
      });
    }, r.prototype._processFrames = function(t) {
      for (var e = t, n = r.BATCH_SIZE; e - t < n && e < this._frameKeys.length; ) {
        var i = this._frameKeys[e], o = this._frames[i], a = o.frame;
        if (a) {
          var s = null, h = null, u = o.trimmed !== !1 && o.sourceSize ? o.sourceSize : o.frame, l = new ut(0, 0, Math.floor(u.w) / this.resolution, Math.floor(u.h) / this.resolution);
          o.rotated ? s = new ut(Math.floor(a.x) / this.resolution, Math.floor(a.y) / this.resolution, Math.floor(a.h) / this.resolution, Math.floor(a.w) / this.resolution) : s = new ut(Math.floor(a.x) / this.resolution, Math.floor(a.y) / this.resolution, Math.floor(a.w) / this.resolution, Math.floor(a.h) / this.resolution), o.trimmed !== !1 && o.spriteSourceSize && (h = new ut(Math.floor(o.spriteSourceSize.x) / this.resolution, Math.floor(o.spriteSourceSize.y) / this.resolution, Math.floor(a.w) / this.resolution, Math.floor(a.h) / this.resolution)), this.textures[i] = new J(this.baseTexture, s, l, h, o.rotated ? 2 : 0, o.anchor), J.addToCache(this.textures[i], i);
        }
        e++;
      }
    }, r.prototype._processAnimations = function() {
      var t = this.data.animations || {};
      for (var e in t) {
        this.animations[e] = [];
        for (var n = 0; n < t[e].length; n++) {
          var i = t[e][n];
          this.animations[e].push(this.textures[i]);
        }
      }
    }, r.prototype._parseComplete = function() {
      var t = this._callback;
      this._callback = null, this._batchIndex = 0, t.call(this, this.textures);
    }, r.prototype._nextBatch = function() {
      var t = this;
      this._processFrames(this._batchIndex * r.BATCH_SIZE), this._batchIndex++, setTimeout(function() {
        t._batchIndex * r.BATCH_SIZE < t._frameKeys.length ? t._nextBatch() : (t._processAnimations(), t._parseComplete());
      }, 0);
    }, r.prototype.destroy = function(t) {
      var e;
      t === void 0 && (t = !1);
      for (var n in this.textures)
        this.textures[n].destroy();
      this._frames = null, this._frameKeys = null, this.data = null, this.textures = null, t && ((e = this._texture) === null || e === void 0 || e.destroy(), this.baseTexture.destroy()), this._texture = null, this.baseTexture = null, this.linkedSheets = [];
    }, r.BATCH_SIZE = 1e3, r;
  }()
), Fb = (
  /** @class */
  function() {
    function r() {
    }
    return r.use = function(t, e) {
      var n, i, o = this, a = t.name + "_image";
      if (!t.data || t.type !== Ot.TYPE.JSON || !t.data.frames || o.resources[a]) {
        e();
        return;
      }
      var s = (i = (n = t.data) === null || n === void 0 ? void 0 : n.meta) === null || i === void 0 ? void 0 : i.related_multi_packs;
      if (Array.isArray(s))
        for (var h = function(p) {
          if (typeof p != "string")
            return "continue";
          var v = p.replace(".json", ""), _ = Rr.resolve(t.url.replace(o.baseUrl, ""), p);
          if (o.resources[v] || Object.values(o.resources).some(function(y) {
            return Rr.format(Rr.parse(y.url)) === _;
          }))
            return "continue";
          var m = {
            crossOrigin: t.crossOrigin,
            loadType: Ot.LOAD_TYPE.XHR,
            xhrType: Ot.XHR_RESPONSE_TYPE.JSON,
            parentResource: t,
            metadata: t.metadata
          };
          o.add(v, _, m);
        }, u = 0, l = s; u < l.length; u++) {
          var f = l[u];
          h(f);
        }
      var c = {
        crossOrigin: t.crossOrigin,
        metadata: t.metadata.imageMetadata,
        parentResource: t
      }, d = r.getResourcePath(t, o.baseUrl);
      o.add(a, d, c, function(v) {
        if (v.error) {
          e(v.error);
          return;
        }
        var _ = new Db(v.texture, t.data, t.url);
        _.parse().then(function() {
          t.spritesheet = _, t.textures = _.textures, e();
        });
      });
    }, r.getResourcePath = function(t, e) {
      return t.isDataUrl ? t.data.meta.image : Rr.resolve(t.url.replace(e, ""), t.data.meta.image);
    }, r.extension = mt.Loader, r;
  }()
);
/*!
 * @pixi/sprite-tiling - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/sprite-tiling is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var ba = function(r, t) {
  return ba = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, ba(r, t);
};
function kl(r, t) {
  ba(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var rn = new Et();
(function(r) {
  kl(t, r);
  function t(e, n, i) {
    n === void 0 && (n = 100), i === void 0 && (i = 100);
    var o = r.call(this, e) || this;
    return o.tileTransform = new dl(), o._width = n, o._height = i, o.uvMatrix = o.texture.uvMatrix || new Qa(e), o.pluginName = "tilingSprite", o.uvRespectAnchor = !1, o;
  }
  return Object.defineProperty(t.prototype, "clampMargin", {
    /**
     * Changes frame clamping in corresponding textureTransform, shortcut
     * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
     * @default 0.5
     * @member {number}
     */
    get: function() {
      return this.uvMatrix.clampMargin;
    },
    set: function(e) {
      this.uvMatrix.clampMargin = e, this.uvMatrix.update(!0);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "tileScale", {
    /** The scaling of the image that is being tiled. */
    get: function() {
      return this.tileTransform.scale;
    },
    set: function(e) {
      this.tileTransform.scale.copyFrom(e);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "tilePosition", {
    /** The offset of the image that is being tiled. */
    get: function() {
      return this.tileTransform.position;
    },
    set: function(e) {
      this.tileTransform.position.copyFrom(e);
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._onTextureUpdate = function() {
    this.uvMatrix && (this.uvMatrix.texture = this._texture), this._cachedTint = 16777215;
  }, t.prototype._render = function(e) {
    var n = this._texture;
    !n || !n.valid || (this.tileTransform.updateLocalTransform(), this.uvMatrix.update(), e.batch.setObjectRenderer(e.plugins[this.pluginName]), e.plugins[this.pluginName].render(this));
  }, t.prototype._calculateBounds = function() {
    var e = this._width * -this._anchor._x, n = this._height * -this._anchor._y, i = this._width * (1 - this._anchor._x), o = this._height * (1 - this._anchor._y);
    this._bounds.addFrame(this.transform, e, n, i, o);
  }, t.prototype.getLocalBounds = function(e) {
    return this.children.length === 0 ? (this._bounds.minX = this._width * -this._anchor._x, this._bounds.minY = this._height * -this._anchor._y, this._bounds.maxX = this._width * (1 - this._anchor._x), this._bounds.maxY = this._height * (1 - this._anchor._y), e || (this._localBoundsRect || (this._localBoundsRect = new ut()), e = this._localBoundsRect), this._bounds.getRectangle(e)) : r.prototype.getLocalBounds.call(this, e);
  }, t.prototype.containsPoint = function(e) {
    this.worldTransform.applyInverse(e, rn);
    var n = this._width, i = this._height, o = -n * this.anchor._x;
    if (rn.x >= o && rn.x < o + n) {
      var a = -i * this.anchor._y;
      if (rn.y >= a && rn.y < a + i)
        return !0;
    }
    return !1;
  }, t.prototype.destroy = function(e) {
    r.prototype.destroy.call(this, e), this.tileTransform = null, this.uvMatrix = null;
  }, t.from = function(e, n) {
    var i = e instanceof J ? e : J.from(e, n);
    return new t(i, n.width, n.height);
  }, Object.defineProperty(t.prototype, "width", {
    /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */
    get: function() {
      return this._width;
    },
    set: function(e) {
      this._width = e;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "height", {
    /** The height of the TilingSprite, setting this will actually modify the scale to achieve the value set. */
    get: function() {
      return this._height;
    },
    set: function(e) {
      this._height = e;
    },
    enumerable: !1,
    configurable: !0
  }), t;
})(In);
var Bb = `#version 100
#define SHADER_NAME Tiling-Sprite-Simple-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;

void main(void)
{
    vec4 texSample = texture2D(uSampler, vTextureCoord);
    gl_FragColor = texSample * uColor;
}
`, Jh = `#version 100
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`, Nb = `#version 100
#ifdef GL_EXT_shader_texture_lod
    #extension GL_EXT_shader_texture_lod : enable
#endif
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    #ifdef GL_EXT_shader_texture_lod
        vec4 texSample = unclamped == coord
            ? texture2D(uSampler, coord) 
            : texture2DLodEXT(uSampler, coord, 0);
    #else
        vec4 texSample = texture2D(uSampler, coord);
    #endif

    gl_FragColor = texSample * uColor;
}
`, Lb = `#version 300 es
#define SHADER_NAME Tiling-Sprite-300

precision lowp float;

in vec2 aVertexPosition;
in vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

out vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`, Ub = `#version 300 es
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

in vec2 vTextureCoord;

out vec4 fragmentColor;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    vec4 texSample = texture(uSampler, coord, unclamped == coord ? 0.0f : -32.0f);// lod-bias very negative to force lod 0

    fragmentColor = texSample * uColor;
}
`, si = new Dt(), Gb = (
  /** @class */
  function(r) {
    kl(t, r);
    function t(e) {
      var n = r.call(this, e) || this;
      return e.runners.contextChange.add(n), n.quad = new bl(), n.state = dr.for2d(), n;
    }
    return t.prototype.contextChange = function() {
      var e = this.renderer, n = { globals: e.globalUniforms };
      this.simpleShader = Ue.from(Jh, Bb, n), this.shader = e.context.webGLVersion > 1 ? Ue.from(Lb, Ub, n) : Ue.from(Jh, Nb, n);
    }, t.prototype.render = function(e) {
      var n = this.renderer, i = this.quad, o = i.vertices;
      o[0] = o[6] = e._width * -e.anchor.x, o[1] = o[3] = e._height * -e.anchor.y, o[2] = o[4] = e._width * (1 - e.anchor.x), o[5] = o[7] = e._height * (1 - e.anchor.y);
      var a = e.uvRespectAnchor ? e.anchor.x : 0, s = e.uvRespectAnchor ? e.anchor.y : 0;
      o = i.uvs, o[0] = o[6] = -a, o[1] = o[3] = -s, o[2] = o[4] = 1 - a, o[5] = o[7] = 1 - s, i.invalidate();
      var h = e._texture, u = h.baseTexture, l = u.alphaMode > 0, f = e.tileTransform.localTransform, c = e.uvMatrix, d = u.isPowerOfTwo && h.frame.width === u.width && h.frame.height === u.height;
      d && (u._glTextures[n.CONTEXT_UID] ? d = u.wrapMode !== be.CLAMP : u.wrapMode === be.CLAMP && (u.wrapMode = be.REPEAT));
      var p = d ? this.simpleShader : this.shader, v = h.width, _ = h.height, m = e._width, y = e._height;
      si.set(f.a * v / m, f.b * v / y, f.c * _ / m, f.d * _ / y, f.tx / m, f.ty / y), si.invert(), d ? si.prepend(c.mapCoord) : (p.uniforms.uMapCoord = c.mapCoord.toArray(!0), p.uniforms.uClampFrame = c.uClampFrame, p.uniforms.uClampOffset = c.uClampOffset), p.uniforms.uTransform = si.toArray(!0), p.uniforms.uColor = ll(e.tint, e.worldAlpha, p.uniforms.uColor, l), p.uniforms.translationMatrix = e.transform.worldTransform.toArray(!0), p.uniforms.uSampler = h, n.shader.bind(p), n.geometry.bind(i), this.state.blendMode = ul(e.blendMode, l), n.state.set(this.state), n.geometry.draw(this.renderer.gl.TRIANGLES, 6, 0);
    }, t.extension = {
      name: "tilingSprite",
      type: mt.RendererPlugin
    }, t;
  }(Gi)
);
/*!
 * @pixi/mesh - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/mesh is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var xa = function(r, t) {
  return xa = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, xa(r, t);
};
function es(r, t) {
  xa(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var kb = (
  /** @class */
  function() {
    function r(t, e) {
      this.uvBuffer = t, this.uvMatrix = e, this.data = null, this._bufferUpdateId = -1, this._textureUpdateId = -1, this._updateID = 0;
    }
    return r.prototype.update = function(t) {
      if (!(!t && this._bufferUpdateId === this.uvBuffer._updateID && this._textureUpdateId === this.uvMatrix._updateID)) {
        this._bufferUpdateId = this.uvBuffer._updateID, this._textureUpdateId = this.uvMatrix._updateID;
        var e = this.uvBuffer.data;
        (!this.data || this.data.length !== e.length) && (this.data = new Float32Array(e.length)), this.uvMatrix.multiplyUvs(e, this.data), this._updateID++;
      }
    }, r;
  }()
), Bo = new Et(), Qh = new ci(), Tn = (
  /** @class */
  function(r) {
    es(t, r);
    function t(e, n, i, o) {
      o === void 0 && (o = le.TRIANGLES);
      var a = r.call(this) || this;
      return a.geometry = e, a.shader = n, a.state = i || dr.for2d(), a.drawMode = o, a.start = 0, a.size = 0, a.uvs = null, a.indices = null, a.vertexData = new Float32Array(1), a.vertexDirty = -1, a._transformID = -1, a._roundPixels = G.ROUND_PIXELS, a.batchUvs = null, a;
    }
    return Object.defineProperty(t.prototype, "geometry", {
      /**
       * Includes vertex positions, face indices, normals, colors, UVs, and
       * custom attributes within buffers, reducing the cost of passing all
       * this data to the GPU. Can be shared between multiple Mesh objects.
       */
      get: function() {
        return this._geometry;
      },
      set: function(e) {
        this._geometry !== e && (this._geometry && (this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose()), this._geometry = e, this._geometry && this._geometry.refCount++, this.vertexDirty = -1);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "uvBuffer", {
      /**
       * To change mesh uv's, change its uvBuffer data and increment its _updateID.
       * @readonly
       */
      get: function() {
        return this.geometry.buffers[1];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "verticesBuffer", {
      /**
       * To change mesh vertices, change its uvBuffer data and increment its _updateID.
       * Incrementing _updateID is optional because most of Mesh objects do it anyway.
       * @readonly
       */
      get: function() {
        return this.geometry.buffers[0];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "material", {
      get: function() {
        return this.shader;
      },
      /** Alias for {@link PIXI.Mesh#shader}. */
      set: function(e) {
        this.shader = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "blendMode", {
      get: function() {
        return this.state.blendMode;
      },
      /**
       * The blend mode to be applied to the Mesh. Apply a value of
       * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
       * @default PIXI.BLEND_MODES.NORMAL;
       */
      set: function(e) {
        this.state.blendMode = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "roundPixels", {
      get: function() {
        return this._roundPixels;
      },
      /**
       * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
       * Advantages can include sharper image quality (like text) and faster rendering on canvas.
       * The main disadvantage is movement of objects may appear less smooth.
       * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
       * @default false
       */
      set: function(e) {
        this._roundPixels !== e && (this._transformID = -1), this._roundPixels = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tint", {
      /**
       * The multiply tint applied to the Mesh. This is a hex value. A value of
       * `0xFFFFFF` will remove any tint effect.
       *
       * Null for non-MeshMaterial shaders
       * @default 0xFFFFFF
       */
      get: function() {
        return "tint" in this.shader ? this.shader.tint : null;
      },
      set: function(e) {
        this.shader.tint = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "texture", {
      /** The texture that the Mesh uses. Null for non-MeshMaterial shaders */
      get: function() {
        return "texture" in this.shader ? this.shader.texture : null;
      },
      set: function(e) {
        this.shader.texture = e;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._render = function(e) {
      var n = this.geometry.buffers[0].data, i = this.shader;
      i.batchable && this.drawMode === le.TRIANGLES && n.length < t.BATCHABLE_SIZE * 2 ? this._renderToBatch(e) : this._renderDefault(e);
    }, t.prototype._renderDefault = function(e) {
      var n = this.shader;
      n.alpha = this.worldAlpha, n.update && n.update(), e.batch.flush(), n.uniforms.translationMatrix = this.transform.worldTransform.toArray(!0), e.shader.bind(n), e.state.set(this.state), e.geometry.bind(this.geometry, n), e.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
    }, t.prototype._renderToBatch = function(e) {
      var n = this.geometry, i = this.shader;
      i.uvMatrix && (i.uvMatrix.update(), this.calculateUvs()), this.calculateVertices(), this.indices = n.indexBuffer.data, this._tintRGB = i._tintRGB, this._texture = i.texture;
      var o = this.material.pluginName;
      e.batch.setObjectRenderer(e.plugins[o]), e.plugins[o].render(this);
    }, t.prototype.calculateVertices = function() {
      var e = this.geometry, n = e.buffers[0], i = n.data, o = n._updateID;
      if (!(o === this.vertexDirty && this._transformID === this.transform._worldID)) {
        this._transformID = this.transform._worldID, this.vertexData.length !== i.length && (this.vertexData = new Float32Array(i.length));
        for (var a = this.transform.worldTransform, s = a.a, h = a.b, u = a.c, l = a.d, f = a.tx, c = a.ty, d = this.vertexData, p = 0; p < d.length / 2; p++) {
          var v = i[p * 2], _ = i[p * 2 + 1];
          d[p * 2] = s * v + u * _ + f, d[p * 2 + 1] = h * v + l * _ + c;
        }
        if (this._roundPixels)
          for (var m = G.RESOLUTION, p = 0; p < d.length; ++p)
            d[p] = Math.round((d[p] * m | 0) / m);
        this.vertexDirty = o;
      }
    }, t.prototype.calculateUvs = function() {
      var e = this.geometry.buffers[1], n = this.shader;
      n.uvMatrix.isSimple ? this.uvs = e.data : (this.batchUvs || (this.batchUvs = new kb(e, n.uvMatrix)), this.batchUvs.update(), this.uvs = this.batchUvs.data);
    }, t.prototype._calculateBounds = function() {
      this.calculateVertices(), this._bounds.addVertexData(this.vertexData, 0, this.vertexData.length);
    }, t.prototype.containsPoint = function(e) {
      if (!this.getBounds().contains(e.x, e.y))
        return !1;
      this.worldTransform.applyInverse(e, Bo);
      for (var n = this.geometry.getBuffer("aVertexPosition").data, i = Qh.points, o = this.geometry.getIndex().data, a = o.length, s = this.drawMode === 4 ? 3 : 1, h = 0; h + 2 < a; h += s) {
        var u = o[h] * 2, l = o[h + 1] * 2, f = o[h + 2] * 2;
        if (i[0] = n[u], i[1] = n[u + 1], i[2] = n[l], i[3] = n[l + 1], i[4] = n[f], i[5] = n[f + 1], Qh.contains(Bo.x, Bo.y))
          return !0;
      }
      return !1;
    }, t.prototype.destroy = function(e) {
      r.prototype.destroy.call(this, e), this._cachedTexture && (this._cachedTexture.destroy(), this._cachedTexture = null), this.geometry = null, this.shader = null, this.state = null, this.uvs = null, this.indices = null, this.vertexData = null;
    }, t.BATCHABLE_SIZE = 100, t;
  }(Te)
), Hb = `varying vec2 vTextureCoord;
uniform vec4 uColor;

uniform sampler2D uSampler;

void main(void)
{
    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;
}
`, Xb = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTextureMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;
}
`, En = (
  /** @class */
  function(r) {
    es(t, r);
    function t(e, n) {
      var i = this, o = {
        uSampler: e,
        alpha: 1,
        uTextureMatrix: Dt.IDENTITY,
        uColor: new Float32Array([1, 1, 1, 1])
      };
      return n = Object.assign({
        tint: 16777215,
        alpha: 1,
        pluginName: "batch"
      }, n), n.uniforms && Object.assign(o, n.uniforms), i = r.call(this, n.program || Rn.from(Xb, Hb), o) || this, i._colorDirty = !1, i.uvMatrix = new Qa(e), i.batchable = n.program === void 0, i.pluginName = n.pluginName, i.tint = n.tint, i.alpha = n.alpha, i;
    }
    return Object.defineProperty(t.prototype, "texture", {
      /** Reference to the texture being rendered. */
      get: function() {
        return this.uniforms.uSampler;
      },
      set: function(e) {
        this.uniforms.uSampler !== e && (!this.uniforms.uSampler.baseTexture.alphaMode != !e.baseTexture.alphaMode && (this._colorDirty = !0), this.uniforms.uSampler = e, this.uvMatrix.texture = e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "alpha", {
      get: function() {
        return this._alpha;
      },
      /**
       * This gets automatically set by the object using this.
       * @default 1
       */
      set: function(e) {
        e !== this._alpha && (this._alpha = e, this._colorDirty = !0);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tint", {
      get: function() {
        return this._tint;
      },
      /**
       * Multiply tint for the material.
       * @default 0xFFFFFF
       */
      set: function(e) {
        e !== this._tint && (this._tint = e, this._tintRGB = (e >> 16) + (e & 65280) + ((e & 255) << 16), this._colorDirty = !0);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.update = function() {
      if (this._colorDirty) {
        this._colorDirty = !1;
        var e = this.texture.baseTexture;
        ll(this._tint, this._alpha, this.uniforms.uColor, e.alphaMode);
      }
      this.uvMatrix.update() && (this.uniforms.uTextureMatrix = this.uvMatrix.mapCoord);
    }, t;
  }(Ue)
), ki = (
  /** @class */
  function(r) {
    es(t, r);
    function t(e, n, i) {
      var o = r.call(this) || this, a = new Mt(e), s = new Mt(n, !0), h = new Mt(i, !0, !0);
      return o.addAttribute("aVertexPosition", a, 2, !1, X.FLOAT).addAttribute("aTextureCoord", s, 2, !1, X.FLOAT).addIndex(h), o._updateId = -1, o;
    }
    return Object.defineProperty(t.prototype, "vertexDirtyId", {
      /**
       * If the vertex position is updated.
       * @readonly
       * @private
       */
      get: function() {
        return this.buffers[0]._updateID;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(On)
);
/*!
 * @pixi/text-bitmap - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/text-bitmap is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Ta = function(r, t) {
  return Ta = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, Ta(r, t);
};
function jb(r, t) {
  Ta(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var Mi = (
  /** @class */
  function() {
    function r() {
      this.info = [], this.common = [], this.page = [], this.char = [], this.kerning = [], this.distanceField = [];
    }
    return r;
  }()
), Yb = (
  /** @class */
  function() {
    function r() {
    }
    return r.test = function(t) {
      return typeof t == "string" && t.indexOf("info face=") === 0;
    }, r.parse = function(t) {
      var e = t.match(/^[a-z]+\s+.+$/gm), n = {
        info: [],
        common: [],
        page: [],
        char: [],
        chars: [],
        kerning: [],
        kernings: [],
        distanceField: []
      };
      for (var i in e) {
        var o = e[i].match(/^[a-z]+/gm)[0], a = e[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm), s = {};
        for (var h in a) {
          var u = a[h].split("="), l = u[0], f = u[1].replace(/"/gm, ""), c = parseFloat(f), d = isNaN(c) ? f : c;
          s[l] = d;
        }
        n[o].push(s);
      }
      var p = new Mi();
      return n.info.forEach(function(v) {
        return p.info.push({
          face: v.face,
          size: parseInt(v.size, 10)
        });
      }), n.common.forEach(function(v) {
        return p.common.push({
          lineHeight: parseInt(v.lineHeight, 10)
        });
      }), n.page.forEach(function(v) {
        return p.page.push({
          id: parseInt(v.id, 10),
          file: v.file
        });
      }), n.char.forEach(function(v) {
        return p.char.push({
          id: parseInt(v.id, 10),
          page: parseInt(v.page, 10),
          x: parseInt(v.x, 10),
          y: parseInt(v.y, 10),
          width: parseInt(v.width, 10),
          height: parseInt(v.height, 10),
          xoffset: parseInt(v.xoffset, 10),
          yoffset: parseInt(v.yoffset, 10),
          xadvance: parseInt(v.xadvance, 10)
        });
      }), n.kerning.forEach(function(v) {
        return p.kerning.push({
          first: parseInt(v.first, 10),
          second: parseInt(v.second, 10),
          amount: parseInt(v.amount, 10)
        });
      }), n.distanceField.forEach(function(v) {
        return p.distanceField.push({
          distanceRange: parseInt(v.distanceRange, 10),
          fieldType: v.fieldType
        });
      }), p;
    }, r;
  }()
), Ea = (
  /** @class */
  function() {
    function r() {
    }
    return r.test = function(t) {
      return t instanceof XMLDocument && t.getElementsByTagName("page").length && t.getElementsByTagName("info")[0].getAttribute("face") !== null;
    }, r.parse = function(t) {
      for (var e = new Mi(), n = t.getElementsByTagName("info"), i = t.getElementsByTagName("common"), o = t.getElementsByTagName("page"), a = t.getElementsByTagName("char"), s = t.getElementsByTagName("kerning"), h = t.getElementsByTagName("distanceField"), u = 0; u < n.length; u++)
        e.info.push({
          face: n[u].getAttribute("face"),
          size: parseInt(n[u].getAttribute("size"), 10)
        });
      for (var u = 0; u < i.length; u++)
        e.common.push({
          lineHeight: parseInt(i[u].getAttribute("lineHeight"), 10)
        });
      for (var u = 0; u < o.length; u++)
        e.page.push({
          id: parseInt(o[u].getAttribute("id"), 10) || 0,
          file: o[u].getAttribute("file")
        });
      for (var u = 0; u < a.length; u++) {
        var l = a[u];
        e.char.push({
          id: parseInt(l.getAttribute("id"), 10),
          page: parseInt(l.getAttribute("page"), 10) || 0,
          x: parseInt(l.getAttribute("x"), 10),
          y: parseInt(l.getAttribute("y"), 10),
          width: parseInt(l.getAttribute("width"), 10),
          height: parseInt(l.getAttribute("height"), 10),
          xoffset: parseInt(l.getAttribute("xoffset"), 10),
          yoffset: parseInt(l.getAttribute("yoffset"), 10),
          xadvance: parseInt(l.getAttribute("xadvance"), 10)
        });
      }
      for (var u = 0; u < s.length; u++)
        e.kerning.push({
          first: parseInt(s[u].getAttribute("first"), 10),
          second: parseInt(s[u].getAttribute("second"), 10),
          amount: parseInt(s[u].getAttribute("amount"), 10)
        });
      for (var u = 0; u < h.length; u++)
        e.distanceField.push({
          fieldType: h[u].getAttribute("fieldType"),
          distanceRange: parseInt(h[u].getAttribute("distanceRange"), 10)
        });
      return e;
    }, r;
  }()
), Vb = (
  /** @class */
  function() {
    function r() {
    }
    return r.test = function(t) {
      if (typeof t == "string" && t.indexOf("<font>") > -1) {
        var e = new globalThis.DOMParser().parseFromString(t, "text/xml");
        return Ea.test(e);
      }
      return !1;
    }, r.parse = function(t) {
      var e = new globalThis.DOMParser().parseFromString(t, "text/xml");
      return Ea.parse(e);
    }, r;
  }()
), No = [
  Yb,
  Ea,
  Vb
];
function Hl(r) {
  for (var t = 0; t < No.length; t++)
    if (No[t].test(r))
      return No[t];
  return null;
}
function zb(r, t, e, n, i, o) {
  var a = e.fill;
  if (Array.isArray(a)) {
    if (a.length === 1)
      return a[0];
  } else
    return a;
  var s, h = e.dropShadow ? e.dropShadowDistance : 0, u = e.padding || 0, l = r.width / n - h - u * 2, f = r.height / n - h - u * 2, c = a.slice(), d = e.fillGradientStops.slice();
  if (!d.length)
    for (var p = c.length + 1, v = 1; v < p; ++v)
      d.push(v / p);
  if (c.unshift(a[0]), d.unshift(0), c.push(a[a.length - 1]), d.push(1), e.fillGradientType === xn.LINEAR_VERTICAL) {
    s = t.createLinearGradient(l / 2, u, l / 2, f + u);
    for (var _ = 0, m = o.fontProperties.fontSize + e.strokeThickness, y = m / f, v = 0; v < i.length; v++)
      for (var g = o.lineHeight * v, x = 0; x < c.length; x++) {
        var T = 0;
        typeof d[x] == "number" ? T = d[x] : T = x / c.length;
        var E = g / f + T * y, P = Math.max(_, E);
        P = Math.min(P, 1), s.addColorStop(P, c[x]), _ = P;
      }
  } else {
    s = t.createLinearGradient(u, f / 2, l + u, f / 2);
    for (var b = c.length + 1, w = 1, v = 0; v < c.length; v++) {
      var A = void 0;
      typeof d[v] == "number" ? A = d[v] : A = w / b, s.addColorStop(A, c[v]), w++;
    }
  }
  return s;
}
function Wb(r, t, e, n, i, o, a) {
  var s = e.text, h = e.fontProperties;
  t.translate(n, i), t.scale(o, o);
  var u = a.strokeThickness / 2, l = -(a.strokeThickness / 2);
  if (t.font = a.toFontString(), t.lineWidth = a.strokeThickness, t.textBaseline = a.textBaseline, t.lineJoin = a.lineJoin, t.miterLimit = a.miterLimit, t.fillStyle = zb(r, t, a, o, [s], e), t.strokeStyle = a.stroke, a.dropShadow) {
    var f = a.dropShadowColor, c = jr(typeof f == "number" ? f : Yr(f)), d = a.dropShadowBlur * o, p = a.dropShadowDistance * o;
    t.shadowColor = "rgba(" + c[0] * 255 + "," + c[1] * 255 + "," + c[2] * 255 + "," + a.dropShadowAlpha + ")", t.shadowBlur = d, t.shadowOffsetX = Math.cos(a.dropShadowAngle) * p, t.shadowOffsetY = Math.sin(a.dropShadowAngle) * p;
  } else
    t.shadowColor = "black", t.shadowBlur = 0, t.shadowOffsetX = 0, t.shadowOffsetY = 0;
  a.stroke && a.strokeThickness && t.strokeText(s, u, l + e.lineHeight - h.descent), a.fill && t.fillText(s, u, l + e.lineHeight - h.descent), t.setTransform(1, 0, 0, 1, 0, 0), t.fillStyle = "rgba(0, 0, 0, 0)";
}
function Xl(r) {
  return Array.from ? Array.from(r) : r.split("");
}
function $b(r) {
  typeof r == "string" && (r = [r]);
  for (var t = [], e = 0, n = r.length; e < n; e++) {
    var i = r[e];
    if (Array.isArray(i)) {
      if (i.length !== 2)
        throw new Error("[BitmapFont]: Invalid character range length, expecting 2 got " + i.length + ".");
      var o = i[0].charCodeAt(0), a = i[1].charCodeAt(0);
      if (a < o)
        throw new Error("[BitmapFont]: Invalid character range.");
      for (var s = o, h = a; s <= h; s++)
        t.push(String.fromCharCode(s));
    } else
      t.push.apply(t, Xl(i));
  }
  if (t.length === 0)
    throw new Error("[BitmapFont]: Empty set when resolving characters.");
  return t;
}
function di(r) {
  return r.codePointAt ? r.codePointAt(0) : r.charCodeAt(0);
}
var Fe = (
  /** @class */
  function() {
    function r(t, e, n) {
      var i, o, a = t.info[0], s = t.common[0], h = t.page[0], u = t.distanceField[0], l = Ai(h.file), f = {};
      this._ownsTextures = n, this.font = a.face, this.size = a.size, this.lineHeight = s.lineHeight / l, this.chars = {}, this.pageTextures = f;
      for (var c = 0; c < t.page.length; c++) {
        var d = t.page[c], p = d.id, v = d.file;
        f[p] = e instanceof Array ? e[c] : e[v], u != null && u.fieldType && u.fieldType !== "none" && (f[p].baseTexture.alphaMode = pe.NO_PREMULTIPLIED_ALPHA, f[p].baseTexture.mipmap = de.OFF);
      }
      for (var c = 0; c < t.char.length; c++) {
        var _ = t.char[c], p = _.id, m = _.page, y = t.char[c], g = y.x, x = y.y, T = y.width, E = y.height, P = y.xoffset, b = y.yoffset, w = y.xadvance;
        g /= l, x /= l, T /= l, E /= l, P /= l, b /= l, w /= l;
        var A = new ut(g + f[m].frame.x / l, x + f[m].frame.y / l, T, E);
        this.chars[p] = {
          xOffset: P,
          yOffset: b,
          xAdvance: w,
          kerning: {},
          texture: new J(f[m].baseTexture, A),
          page: m
        };
      }
      for (var c = 0; c < t.kerning.length; c++) {
        var R = t.kerning[c], C = R.first, M = R.second, H = R.amount;
        C /= l, M /= l, H /= l, this.chars[M] && (this.chars[M].kerning[C] = H);
      }
      this.distanceFieldRange = u == null ? void 0 : u.distanceRange, this.distanceFieldType = (o = (i = u == null ? void 0 : u.fieldType) === null || i === void 0 ? void 0 : i.toLowerCase()) !== null && o !== void 0 ? o : "none";
    }
    return r.prototype.destroy = function() {
      for (var t in this.chars)
        this.chars[t].texture.destroy(), this.chars[t].texture = null;
      for (var t in this.pageTextures)
        this._ownsTextures && this.pageTextures[t].destroy(!0), this.pageTextures[t] = null;
      this.chars = null, this.pageTextures = null;
    }, r.install = function(t, e, n) {
      var i;
      if (t instanceof Mi)
        i = t;
      else {
        var o = Hl(t);
        if (!o)
          throw new Error("Unrecognized data format for font.");
        i = o.parse(t);
      }
      e instanceof J && (e = [e]);
      var a = new r(i, e, n);
      return r.available[a.font] = a, a;
    }, r.uninstall = function(t) {
      var e = r.available[t];
      if (!e)
        throw new Error("No font found named '" + t + "'");
      e.destroy(), delete r.available[t];
    }, r.from = function(t, e, n) {
      if (!t)
        throw new Error("[BitmapFont] Property `name` is required.");
      var i = Object.assign({}, r.defaultOptions, n), o = i.chars, a = i.padding, s = i.resolution, h = i.textureWidth, u = i.textureHeight, l = $b(o), f = e instanceof Vr ? e : new Vr(e), c = h, d = new Mi();
      d.info[0] = {
        face: f.fontFamily,
        size: f.fontSize
      }, d.common[0] = {
        lineHeight: f.fontSize
      };
      for (var p = 0, v = 0, _, m, y, g = 0, x = [], T = 0; T < l.length; T++) {
        _ || (_ = G.ADAPTER.createCanvas(), _.width = h, _.height = u, m = _.getContext("2d"), y = new ht(_, { resolution: s }), x.push(new J(y)), d.page.push({
          id: x.length - 1,
          file: ""
        }));
        var E = l[T], P = Ee.measureText(E, f, !1, _), b = P.width, w = Math.ceil(P.height), A = Math.ceil((f.fontStyle === "italic" ? 2 : 1) * b);
        if (v >= u - w * s) {
          if (v === 0)
            throw new Error("[BitmapFont] textureHeight " + u + "px is too small " + ("(fontFamily: '" + f.fontFamily + "', fontSize: " + f.fontSize + "px, char: '" + E + "')"));
          --T, _ = null, m = null, y = null, v = 0, p = 0, g = 0;
          continue;
        }
        if (g = Math.max(w + P.fontProperties.descent, g), A * s + p >= c) {
          if (p === 0)
            throw new Error("[BitmapFont] textureWidth " + h + "px is too small " + ("(fontFamily: '" + f.fontFamily + "', fontSize: " + f.fontSize + "px, char: '" + E + "')"));
          --T, v += g * s, v = Math.ceil(v), p = 0, g = 0;
          continue;
        }
        Wb(_, m, P, p, v, s, f);
        var R = di(P.text);
        d.char.push({
          id: R,
          page: x.length - 1,
          x: p / s,
          y: v / s,
          width: A,
          height: w,
          xoffset: 0,
          yoffset: 0,
          xadvance: Math.ceil(b - (f.dropShadow ? f.dropShadowDistance : 0) - (f.stroke ? f.strokeThickness : 0))
        }), p += (A + 2 * a) * s, p = Math.ceil(p);
      }
      if (!(n != null && n.skipKerning))
        for (var T = 0, C = l.length; T < C; T++)
          for (var M = l[T], H = 0; H < C; H++) {
            var U = l[H], B = m.measureText(M).width, $ = m.measureText(U).width, q = m.measureText(M + U).width, Q = q - (B + $);
            Q && d.kerning.push({
              first: di(M),
              second: di(U),
              amount: Q
            });
          }
      var N = new r(d, x, !0);
      return r.available[t] !== void 0 && r.uninstall(t), r.available[t] = N, N;
    }, r.ALPHA = [["a", "z"], ["A", "Z"], " "], r.NUMERIC = [["0", "9"]], r.ALPHANUMERIC = [["a", "z"], ["A", "Z"], ["0", "9"], " "], r.ASCII = [[" ", "~"]], r.defaultOptions = {
      resolution: 1,
      textureWidth: 512,
      textureHeight: 512,
      padding: 4,
      chars: r.ALPHANUMERIC
    }, r.available = {}, r;
  }()
), qb = `// Pixi texture info\r
varying vec2 vTextureCoord;\r
uniform sampler2D uSampler;\r
\r
// Tint\r
uniform vec4 uColor;\r
\r
// on 2D applications fwidth is screenScale / glyphAtlasScale * distanceFieldRange\r
uniform float uFWidth;\r
\r
void main(void) {\r
\r
  // To stack MSDF and SDF we need a non-pre-multiplied-alpha texture.\r
  vec4 texColor = texture2D(uSampler, vTextureCoord);\r
\r
  // MSDF\r
  float median = texColor.r + texColor.g + texColor.b -\r
                  min(texColor.r, min(texColor.g, texColor.b)) -\r
                  max(texColor.r, max(texColor.g, texColor.b));\r
  // SDF\r
  median = min(median, texColor.a);\r
\r
  float screenPxDistance = uFWidth * (median - 0.5);\r
  float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);\r
  if (median < 0.01) {\r
    alpha = 0.0;\r
  } else if (median > 0.99) {\r
    alpha = 1.0;\r
  }\r
\r
  // NPM Textures, NPM outputs\r
  gl_FragColor = vec4(uColor.rgb, uColor.a * alpha);\r
\r
}\r
`, Kb = `// Mesh material default fragment\r
attribute vec2 aVertexPosition;\r
attribute vec2 aTextureCoord;\r
\r
uniform mat3 projectionMatrix;\r
uniform mat3 translationMatrix;\r
uniform mat3 uTextureMatrix;\r
\r
varying vec2 vTextureCoord;\r
\r
void main(void)\r
{\r
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\r
\r
    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\r
}\r
`, tu = [], eu = [], ru = [];
(function(r) {
  jb(t, r);
  function t(e, n) {
    n === void 0 && (n = {});
    var i = r.call(this) || this;
    i._tint = 16777215;
    var o = Object.assign({}, t.styleDefaults, n), a = o.align, s = o.tint, h = o.maxWidth, u = o.letterSpacing, l = o.fontName, f = o.fontSize;
    if (!Fe.available[l])
      throw new Error('Missing BitmapFont "' + l + '"');
    return i._activePagesMeshData = [], i._textWidth = 0, i._textHeight = 0, i._align = a, i._tint = s, i._font = void 0, i._fontName = l, i._fontSize = f, i.text = e, i._maxWidth = h, i._maxLineHeight = 0, i._letterSpacing = u, i._anchor = new Cr(function() {
      i.dirty = !0;
    }, i, 0, 0), i._roundPixels = G.ROUND_PIXELS, i.dirty = !0, i._resolution = G.RESOLUTION, i._autoResolution = !0, i._textureCache = {}, i;
  }
  return t.prototype.updateText = function() {
    for (var e, n = Fe.available[this._fontName], i = this.fontSize, o = i / n.size, a = new Et(), s = [], h = [], u = [], l = this._text.replace(/(?:\r\n|\r)/g, `
`) || " ", f = Xl(l), c = this._maxWidth * n.size / i, d = n.distanceFieldType === "none" ? tu : eu, p = null, v = 0, _ = 0, m = 0, y = -1, g = 0, x = 0, T = 0, E = 0, P = 0; P < f.length; P++) {
      var b = f[P], w = di(b);
      if (/(?:\s)/.test(b) && (y = P, g = v, E++), b === "\r" || b === `
`) {
        h.push(v), u.push(-1), _ = Math.max(_, v), ++m, ++x, a.x = 0, a.y += n.lineHeight, p = null, E = 0;
        continue;
      }
      var A = n.chars[w];
      if (A) {
        p && A.kerning[p] && (a.x += A.kerning[p]);
        var R = ru.pop() || {
          texture: J.EMPTY,
          line: 0,
          charCode: 0,
          prevSpaces: 0,
          position: new Et()
        };
        R.texture = A.texture, R.line = m, R.charCode = w, R.position.x = a.x + A.xOffset + this._letterSpacing / 2, R.position.y = a.y + A.yOffset, R.prevSpaces = E, s.push(R), v = R.position.x + Math.max(A.xAdvance - A.xOffset, A.texture.orig.width), a.x += A.xAdvance + this._letterSpacing, T = Math.max(T, A.yOffset + A.texture.height), p = w, y !== -1 && c > 0 && a.x > c && (++x, Nr(s, 1 + y - x, 1 + P - y), P = y, y = -1, h.push(g), u.push(s.length > 0 ? s[s.length - 1].prevSpaces : 0), _ = Math.max(_, g), m++, a.x = 0, a.y += n.lineHeight, p = null, E = 0);
      }
    }
    var C = f[f.length - 1];
    C !== "\r" && C !== `
` && (/(?:\s)/.test(C) && (v = g), h.push(v), _ = Math.max(_, v), u.push(-1));
    for (var M = [], P = 0; P <= m; P++) {
      var H = 0;
      this._align === "right" ? H = _ - h[P] : this._align === "center" ? H = (_ - h[P]) / 2 : this._align === "justify" && (H = u[P] < 0 ? 0 : (_ - h[P]) / u[P]), M.push(H);
    }
    var U = s.length, B = {}, $ = [], q = this._activePagesMeshData;
    d.push.apply(d, q);
    for (var P = 0; P < U; P++) {
      var Q = s[P].texture, N = Q.baseTexture.uid;
      if (!B[N]) {
        var F = d.pop();
        if (!F) {
          var k = new ki(), tt = void 0, et = void 0;
          n.distanceFieldType === "none" ? (tt = new En(J.EMPTY), et = Y.NORMAL) : (tt = new En(J.EMPTY, { program: Rn.from(Kb, qb), uniforms: { uFWidth: 0 } }), et = Y.NORMAL_NPM);
          var pt = new Tn(k, tt);
          pt.blendMode = et, F = {
            index: 0,
            indexCount: 0,
            vertexCount: 0,
            uvsCount: 0,
            total: 0,
            mesh: pt,
            vertices: null,
            uvs: null,
            indices: null
          };
        }
        F.index = 0, F.indexCount = 0, F.vertexCount = 0, F.uvsCount = 0, F.total = 0;
        var j = this._textureCache;
        j[N] = j[N] || new J(Q.baseTexture), F.mesh.texture = j[N], F.mesh.tint = this._tint, $.push(F), B[N] = F;
      }
      B[N].total++;
    }
    for (var P = 0; P < q.length; P++)
      $.indexOf(q[P]) === -1 && this.removeChild(q[P].mesh);
    for (var P = 0; P < $.length; P++)
      $[P].mesh.parent !== this && this.addChild($[P].mesh);
    this._activePagesMeshData = $;
    for (var P in B) {
      var F = B[P], st = F.total;
      if (!(((e = F.indices) === null || e === void 0 ? void 0 : e.length) > 6 * st) || F.vertices.length < Tn.BATCHABLE_SIZE * 2)
        F.vertices = new Float32Array(4 * 2 * st), F.uvs = new Float32Array(4 * 2 * st), F.indices = new Uint16Array(6 * st);
      else
        for (var _t = F.total, Tt = F.vertices, W = _t * 4 * 2; W < Tt.length; W++)
          Tt[W] = 0;
      F.mesh.size = 6 * st;
    }
    for (var P = 0; P < U; P++) {
      var b = s[P], it = b.position.x + M[b.line] * (this._align === "justify" ? b.prevSpaces : 1);
      this._roundPixels && (it = Math.round(it));
      var at = it * o, lt = b.position.y * o, Q = b.texture, nt = B[Q.baseTexture.uid], D = Q.frame, O = Q._uvs, dt = nt.index++;
      nt.indices[dt * 6 + 0] = 0 + dt * 4, nt.indices[dt * 6 + 1] = 1 + dt * 4, nt.indices[dt * 6 + 2] = 2 + dt * 4, nt.indices[dt * 6 + 3] = 0 + dt * 4, nt.indices[dt * 6 + 4] = 2 + dt * 4, nt.indices[dt * 6 + 5] = 3 + dt * 4, nt.vertices[dt * 8 + 0] = at, nt.vertices[dt * 8 + 1] = lt, nt.vertices[dt * 8 + 2] = at + D.width * o, nt.vertices[dt * 8 + 3] = lt, nt.vertices[dt * 8 + 4] = at + D.width * o, nt.vertices[dt * 8 + 5] = lt + D.height * o, nt.vertices[dt * 8 + 6] = at, nt.vertices[dt * 8 + 7] = lt + D.height * o, nt.uvs[dt * 8 + 0] = O.x0, nt.uvs[dt * 8 + 1] = O.y0, nt.uvs[dt * 8 + 2] = O.x1, nt.uvs[dt * 8 + 3] = O.y1, nt.uvs[dt * 8 + 4] = O.x2, nt.uvs[dt * 8 + 5] = O.y2, nt.uvs[dt * 8 + 6] = O.x3, nt.uvs[dt * 8 + 7] = O.y3;
    }
    this._textWidth = _ * o, this._textHeight = (a.y + n.lineHeight) * o;
    for (var P in B) {
      var F = B[P];
      if (this.anchor.x !== 0 || this.anchor.y !== 0)
        for (var ve = 0, vr = this._textWidth * this.anchor.x, Cn = this._textHeight * this.anchor.y, us = 0; us < F.total; us++)
          F.vertices[ve++] -= vr, F.vertices[ve++] -= Cn, F.vertices[ve++] -= vr, F.vertices[ve++] -= Cn, F.vertices[ve++] -= vr, F.vertices[ve++] -= Cn, F.vertices[ve++] -= vr, F.vertices[ve++] -= Cn;
      this._maxLineHeight = T * o;
      var ls = F.mesh.geometry.getBuffer("aVertexPosition"), fs = F.mesh.geometry.getBuffer("aTextureCoord"), cs = F.mesh.geometry.getIndex();
      ls.data = F.vertices, fs.data = F.uvs, cs.data = F.indices, ls.update(), fs.update(), cs.update();
    }
    for (var P = 0; P < s.length; P++)
      ru.push(s[P]);
    this._font = n, this.dirty = !1;
  }, t.prototype.updateTransform = function() {
    this.validate(), this.containerUpdateTransform();
  }, t.prototype._render = function(e) {
    this._autoResolution && this._resolution !== e.resolution && (this._resolution = e.resolution, this.dirty = !0);
    var n = Fe.available[this._fontName], i = n.distanceFieldRange, o = n.distanceFieldType, a = n.size;
    if (o !== "none")
      for (var s = this.worldTransform, h = s.a, u = s.b, l = s.c, f = s.d, c = Math.sqrt(h * h + u * u), d = Math.sqrt(l * l + f * f), p = (Math.abs(c) + Math.abs(d)) / 2, v = this.fontSize / a, _ = 0, m = this._activePagesMeshData; _ < m.length; _++) {
        var y = m[_];
        y.mesh.shader.uniforms.uFWidth = p * i * v * this._resolution;
      }
    r.prototype._render.call(this, e);
  }, t.prototype.getLocalBounds = function() {
    return this.validate(), r.prototype.getLocalBounds.call(this);
  }, t.prototype.validate = function() {
    var e = Fe.available[this._fontName];
    if (!e)
      throw new Error('Missing BitmapFont "' + this._fontName + '"');
    this._font !== e && (this.dirty = !0), this.dirty && this.updateText();
  }, Object.defineProperty(t.prototype, "tint", {
    /**
     * The tint of the BitmapText object.
     * @default 0xffffff
     */
    get: function() {
      return this._tint;
    },
    set: function(e) {
      if (this._tint !== e) {
        this._tint = e;
        for (var n = 0; n < this._activePagesMeshData.length; n++)
          this._activePagesMeshData[n].mesh.tint = e;
      }
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "align", {
    /**
     * The alignment of the BitmapText object.
     * @member {string}
     * @default 'left'
     */
    get: function() {
      return this._align;
    },
    set: function(e) {
      this._align !== e && (this._align = e, this.dirty = !0);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "fontName", {
    /** The name of the BitmapFont. */
    get: function() {
      return this._fontName;
    },
    set: function(e) {
      if (!Fe.available[e])
        throw new Error('Missing BitmapFont "' + e + '"');
      this._fontName !== e && (this._fontName = e, this.dirty = !0);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "fontSize", {
    /** The size of the font to display. */
    get: function() {
      var e;
      return (e = this._fontSize) !== null && e !== void 0 ? e : Fe.available[this._fontName].size;
    },
    set: function(e) {
      this._fontSize !== e && (this._fontSize = e, this.dirty = !0);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "anchor", {
    /**
     * The anchor sets the origin point of the text.
     *
     * The default is `(0,0)`, this means the text's origin is the top left.
     *
     * Setting the anchor to `(0.5,0.5)` means the text's origin is centered.
     *
     * Setting the anchor to `(1,1)` would mean the text's origin point will be the bottom right corner.
     */
    get: function() {
      return this._anchor;
    },
    set: function(e) {
      typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "text", {
    /** The text of the BitmapText object. */
    get: function() {
      return this._text;
    },
    set: function(e) {
      e = String(e ?? ""), this._text !== e && (this._text = e, this.dirty = !0);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "maxWidth", {
    /**
     * The max width of this bitmap text in pixels. If the text provided is longer than the
     * value provided, line breaks will be automatically inserted in the last whitespace.
     * Disable by setting the value to 0.
     */
    get: function() {
      return this._maxWidth;
    },
    set: function(e) {
      this._maxWidth !== e && (this._maxWidth = e, this.dirty = !0);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "maxLineHeight", {
    /**
     * The max line height. This is useful when trying to use the total height of the Text,
     * i.e. when trying to vertically align.
     * @readonly
     */
    get: function() {
      return this.validate(), this._maxLineHeight;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "textWidth", {
    /**
     * The width of the overall text, different from fontSize,
     * which is defined in the style object.
     * @readonly
     */
    get: function() {
      return this.validate(), this._textWidth;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "letterSpacing", {
    /** Additional space between characters. */
    get: function() {
      return this._letterSpacing;
    },
    set: function(e) {
      this._letterSpacing !== e && (this._letterSpacing = e, this.dirty = !0);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "roundPixels", {
    /**
     * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
     * Advantages can include sharper image quality (like text) and faster rendering on canvas.
     * The main disadvantage is movement of objects may appear less smooth.
     * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
     * @default PIXI.settings.ROUND_PIXELS
     */
    get: function() {
      return this._roundPixels;
    },
    set: function(e) {
      e !== this._roundPixels && (this._roundPixels = e, this.dirty = !0);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "textHeight", {
    /**
     * The height of the overall text, different from fontSize,
     * which is defined in the style object.
     * @readonly
     */
    get: function() {
      return this.validate(), this._textHeight;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "resolution", {
    /**
     * The resolution / device pixel ratio of the canvas.
     *
     * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
     * @default 1
     */
    get: function() {
      return this._resolution;
    },
    set: function(e) {
      this._autoResolution = !1, this._resolution !== e && (this._resolution = e, this.dirty = !0);
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.destroy = function(e) {
    var n = this._textureCache, i = Fe.available[this._fontName], o = i.distanceFieldType === "none" ? tu : eu;
    o.push.apply(o, this._activePagesMeshData);
    for (var a = 0, s = this._activePagesMeshData; a < s.length; a++) {
      var h = s[a];
      this.removeChild(h.mesh);
    }
    this._activePagesMeshData = [], o.filter(function(f) {
      return n[f.mesh.texture.baseTexture.uid];
    }).forEach(function(f) {
      f.mesh.texture = J.EMPTY;
    });
    for (var u in n) {
      var l = n[u];
      l.destroy(), delete n[u];
    }
    this._font = null, this._textureCache = null, r.prototype.destroy.call(this, e);
  }, t.styleDefaults = {
    align: "left",
    tint: 16777215,
    maxWidth: 0,
    letterSpacing: 0
  }, t;
})(Te);
var Zb = (
  /** @class */
  function() {
    function r() {
    }
    return r.add = function() {
      Ot.setExtensionXhrType("fnt", Ot.XHR_RESPONSE_TYPE.TEXT);
    }, r.use = function(t, e) {
      var n = Hl(t.data);
      if (!n) {
        e();
        return;
      }
      for (var i = r.getBaseUrl(this, t), o = n.parse(t.data), a = {}, s = function(v) {
        a[v.metadata.pageFile] = v.texture, Object.keys(a).length === o.page.length && (t.bitmapFont = Fe.install(o, a, !0), e());
      }, h = 0; h < o.page.length; ++h) {
        var u = o.page[h].file, l = i + u, f = !1;
        for (var c in this.resources) {
          var d = this.resources[c];
          if (d.url === l) {
            d.metadata.pageFile = u, d.texture ? s(d) : d.onAfterMiddleware.add(s), f = !0;
            break;
          }
        }
        if (!f) {
          var p = {
            crossOrigin: t.crossOrigin,
            loadType: Ot.LOAD_TYPE.IMAGE,
            metadata: Object.assign({ pageFile: u }, t.metadata.imageMetadata),
            parentResource: t
          };
          this.add(l, p, s);
        }
      }
    }, r.getBaseUrl = function(t, e) {
      var n = e.isDataUrl ? "" : r.dirname(e.url);
      return e.isDataUrl && (n === "." && (n = ""), t.baseUrl && n && t.baseUrl.charAt(t.baseUrl.length - 1) === "/" && (n += "/")), n = n.replace(t.baseUrl, ""), n && n.charAt(n.length - 1) !== "/" && (n += "/"), n;
    }, r.dirname = function(t) {
      var e = t.replace(/\\/g, "/").replace(/\/$/, "").replace(/\/[^\/]*$/, "");
      return e === t ? "." : e === "" ? "/" : e;
    }, r.extension = mt.Loader, r;
  }()
);
/*!
 * @pixi/filter-alpha - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/filter-alpha is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var wa = function(r, t) {
  return wa = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, wa(r, t);
};
function Jb(r, t) {
  wa(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var Qb = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform float uAlpha;

void main(void)
{
   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;
}
`;
(function(r) {
  Jb(t, r);
  function t(e) {
    e === void 0 && (e = 1);
    var n = r.call(this, zg, Qb, { uAlpha: 1 }) || this;
    return n.alpha = e, n;
  }
  return Object.defineProperty(t.prototype, "alpha", {
    /**
     * Coefficient for alpha multiplication
     * @default 1
     */
    get: function() {
      return this.uniforms.uAlpha;
    },
    set: function(e) {
      this.uniforms.uAlpha = e;
    },
    enumerable: !1,
    configurable: !0
  }), t;
})(Ve);
/*!
 * @pixi/filter-blur - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/filter-blur is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Sa = function(r, t) {
  return Sa = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, Sa(r, t);
};
function jl(r, t) {
  Sa(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var tx = `
    attribute vec2 aVertexPosition;

    uniform mat3 projectionMatrix;

    uniform float strength;

    varying vec2 vBlurTexCoords[%size%];

    uniform vec4 inputSize;
    uniform vec4 outputFrame;

    vec4 filterVertexPosition( void )
    {
        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
    }

    vec2 filterTextureCoord( void )
    {
        return aVertexPosition * (outputFrame.zw * inputSize.zw);
    }

    void main(void)
    {
        gl_Position = filterVertexPosition();

        vec2 textureCoord = filterTextureCoord();
        %blur%
    }`;
function ex(r, t) {
  var e = Math.ceil(r / 2), n = tx, i = "", o;
  t ? o = "vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * strength, 0.0);" : o = "vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * strength);";
  for (var a = 0; a < r; a++) {
    var s = o.replace("%index%", a.toString());
    s = s.replace("%sampleIndex%", a - (e - 1) + ".0"), i += s, i += `
`;
  }
  return n = n.replace("%blur%", i), n = n.replace("%size%", r.toString()), n;
}
var rx = {
  5: [0.153388, 0.221461, 0.250301],
  7: [0.071303, 0.131514, 0.189879, 0.214607],
  9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
  11: [93e-4, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
  13: [2406e-6, 9255e-6, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
  15: [489e-6, 2403e-6, 9246e-6, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448]
}, nx = [
  "varying vec2 vBlurTexCoords[%size%];",
  "uniform sampler2D uSampler;",
  "void main(void)",
  "{",
  "    gl_FragColor = vec4(0.0);",
  "    %blur%",
  "}"
].join(`
`);
function ix(r) {
  for (var t = rx[r], e = t.length, n = nx, i = "", o = "gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;", a, s = 0; s < r; s++) {
    var h = o.replace("%index%", s.toString());
    a = s, s >= e && (a = r - s - 1), h = h.replace("%value%", t[a].toString()), i += h, i += `
`;
  }
  return n = n.replace("%blur%", i), n = n.replace("%size%", r.toString()), n;
}
var nu = (
  /** @class */
  function(r) {
    jl(t, r);
    function t(e, n, i, o, a) {
      n === void 0 && (n = 8), i === void 0 && (i = 4), o === void 0 && (o = G.FILTER_RESOLUTION), a === void 0 && (a = 5);
      var s = this, h = ex(a, e), u = ix(a);
      return s = r.call(
        this,
        // vertex shader
        h,
        // fragment shader
        u
      ) || this, s.horizontal = e, s.resolution = o, s._quality = 0, s.quality = i, s.blur = n, s;
    }
    return t.prototype.apply = function(e, n, i, o) {
      if (i ? this.horizontal ? this.uniforms.strength = 1 / i.width * (i.width / n.width) : this.uniforms.strength = 1 / i.height * (i.height / n.height) : this.horizontal ? this.uniforms.strength = 1 / e.renderer.width * (e.renderer.width / n.width) : this.uniforms.strength = 1 / e.renderer.height * (e.renderer.height / n.height), this.uniforms.strength *= this.strength, this.uniforms.strength /= this.passes, this.passes === 1)
        e.applyFilter(this, n, i, o);
      else {
        var a = e.getFilterTexture(), s = e.renderer, h = n, u = a;
        this.state.blend = !1, e.applyFilter(this, h, u, ue.CLEAR);
        for (var l = 1; l < this.passes - 1; l++) {
          e.bindAndClear(h, ue.BLIT), this.uniforms.uSampler = u;
          var f = u;
          u = h, h = f, s.shader.bind(this), s.geometry.draw(5);
        }
        this.state.blend = !0, e.applyFilter(this, u, i, o), e.returnFilterTexture(a);
      }
    }, Object.defineProperty(t.prototype, "blur", {
      /**
       * Sets the strength of both the blur.
       * @default 16
       */
      get: function() {
        return this.strength;
      },
      set: function(e) {
        this.padding = 1 + Math.abs(e) * 2, this.strength = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "quality", {
      /**
       * Sets the quality of the blur by modifying the number of passes. More passes means higher
       * quality bluring but the lower the performance.
       * @default 4
       */
      get: function() {
        return this._quality;
      },
      set: function(e) {
        this._quality = e, this.passes = e;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Ve)
);
(function(r) {
  jl(t, r);
  function t(e, n, i, o) {
    e === void 0 && (e = 8), n === void 0 && (n = 4), i === void 0 && (i = G.FILTER_RESOLUTION), o === void 0 && (o = 5);
    var a = r.call(this) || this;
    return a.blurXFilter = new nu(!0, e, n, i, o), a.blurYFilter = new nu(!1, e, n, i, o), a.resolution = i, a.quality = n, a.blur = e, a.repeatEdgePixels = !1, a;
  }
  return t.prototype.apply = function(e, n, i, o) {
    var a = Math.abs(this.blurXFilter.strength), s = Math.abs(this.blurYFilter.strength);
    if (a && s) {
      var h = e.getFilterTexture();
      this.blurXFilter.apply(e, n, h, ue.CLEAR), this.blurYFilter.apply(e, h, i, o), e.returnFilterTexture(h);
    } else
      s ? this.blurYFilter.apply(e, n, i, o) : this.blurXFilter.apply(e, n, i, o);
  }, t.prototype.updatePadding = function() {
    this._repeatEdgePixels ? this.padding = 0 : this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
  }, Object.defineProperty(t.prototype, "blur", {
    /**
     * Sets the strength of both the blurX and blurY properties simultaneously
     * @default 2
     */
    get: function() {
      return this.blurXFilter.blur;
    },
    set: function(e) {
      this.blurXFilter.blur = this.blurYFilter.blur = e, this.updatePadding();
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "quality", {
    /**
     * Sets the number of passes for blur. More passes means higher quality bluring.
     * @default 1
     */
    get: function() {
      return this.blurXFilter.quality;
    },
    set: function(e) {
      this.blurXFilter.quality = this.blurYFilter.quality = e;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "blurX", {
    /**
     * Sets the strength of the blurX property
     * @default 2
     */
    get: function() {
      return this.blurXFilter.blur;
    },
    set: function(e) {
      this.blurXFilter.blur = e, this.updatePadding();
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "blurY", {
    /**
     * Sets the strength of the blurY property
     * @default 2
     */
    get: function() {
      return this.blurYFilter.blur;
    },
    set: function(e) {
      this.blurYFilter.blur = e, this.updatePadding();
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "blendMode", {
    /**
     * Sets the blendmode of the filter
     * @default PIXI.BLEND_MODES.NORMAL
     */
    get: function() {
      return this.blurYFilter.blendMode;
    },
    set: function(e) {
      this.blurYFilter.blendMode = e;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "repeatEdgePixels", {
    /**
     * If set to true the edge of the target will be clamped
     * @default false
     */
    get: function() {
      return this._repeatEdgePixels;
    },
    set: function(e) {
      this._repeatEdgePixels = e, this.updatePadding();
    },
    enumerable: !1,
    configurable: !0
  }), t;
})(Ve);
/*!
 * @pixi/filter-color-matrix - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/filter-color-matrix is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Aa = function(r, t) {
  return Aa = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, Aa(r, t);
};
function ox(r, t) {
  Aa(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var ax = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float m[20];
uniform float uAlpha;

void main(void)
{
    vec4 c = texture2D(uSampler, vTextureCoord);

    if (uAlpha == 0.0) {
        gl_FragColor = c;
        return;
    }

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (c.a > 0.0) {
      c.rgb /= c.a;
    }

    vec4 result;

    result.r = (m[0] * c.r);
        result.r += (m[1] * c.g);
        result.r += (m[2] * c.b);
        result.r += (m[3] * c.a);
        result.r += m[4];

    result.g = (m[5] * c.r);
        result.g += (m[6] * c.g);
        result.g += (m[7] * c.b);
        result.g += (m[8] * c.a);
        result.g += m[9];

    result.b = (m[10] * c.r);
       result.b += (m[11] * c.g);
       result.b += (m[12] * c.b);
       result.b += (m[13] * c.a);
       result.b += m[14];

    result.a = (m[15] * c.r);
       result.a += (m[16] * c.g);
       result.a += (m[17] * c.b);
       result.a += (m[18] * c.a);
       result.a += m[19];

    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);

    // Premultiply alpha again.
    rgb *= result.a;

    gl_FragColor = vec4(rgb, result.a);
}
`, iu = (
  /** @class */
  function(r) {
    ox(t, r);
    function t() {
      var e = this, n = {
        m: new Float32Array([
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ]),
        uAlpha: 1
      };
      return e = r.call(this, Rl, ax, n) || this, e.alpha = 1, e;
    }
    return t.prototype._loadMatrix = function(e, n) {
      n === void 0 && (n = !1);
      var i = e;
      n && (this._multiply(i, this.uniforms.m, e), i = this._colorMatrix(i)), this.uniforms.m = i;
    }, t.prototype._multiply = function(e, n, i) {
      return e[0] = n[0] * i[0] + n[1] * i[5] + n[2] * i[10] + n[3] * i[15], e[1] = n[0] * i[1] + n[1] * i[6] + n[2] * i[11] + n[3] * i[16], e[2] = n[0] * i[2] + n[1] * i[7] + n[2] * i[12] + n[3] * i[17], e[3] = n[0] * i[3] + n[1] * i[8] + n[2] * i[13] + n[3] * i[18], e[4] = n[0] * i[4] + n[1] * i[9] + n[2] * i[14] + n[3] * i[19] + n[4], e[5] = n[5] * i[0] + n[6] * i[5] + n[7] * i[10] + n[8] * i[15], e[6] = n[5] * i[1] + n[6] * i[6] + n[7] * i[11] + n[8] * i[16], e[7] = n[5] * i[2] + n[6] * i[7] + n[7] * i[12] + n[8] * i[17], e[8] = n[5] * i[3] + n[6] * i[8] + n[7] * i[13] + n[8] * i[18], e[9] = n[5] * i[4] + n[6] * i[9] + n[7] * i[14] + n[8] * i[19] + n[9], e[10] = n[10] * i[0] + n[11] * i[5] + n[12] * i[10] + n[13] * i[15], e[11] = n[10] * i[1] + n[11] * i[6] + n[12] * i[11] + n[13] * i[16], e[12] = n[10] * i[2] + n[11] * i[7] + n[12] * i[12] + n[13] * i[17], e[13] = n[10] * i[3] + n[11] * i[8] + n[12] * i[13] + n[13] * i[18], e[14] = n[10] * i[4] + n[11] * i[9] + n[12] * i[14] + n[13] * i[19] + n[14], e[15] = n[15] * i[0] + n[16] * i[5] + n[17] * i[10] + n[18] * i[15], e[16] = n[15] * i[1] + n[16] * i[6] + n[17] * i[11] + n[18] * i[16], e[17] = n[15] * i[2] + n[16] * i[7] + n[17] * i[12] + n[18] * i[17], e[18] = n[15] * i[3] + n[16] * i[8] + n[17] * i[13] + n[18] * i[18], e[19] = n[15] * i[4] + n[16] * i[9] + n[17] * i[14] + n[18] * i[19] + n[19], e;
    }, t.prototype._colorMatrix = function(e) {
      var n = new Float32Array(e);
      return n[4] /= 255, n[9] /= 255, n[14] /= 255, n[19] /= 255, n;
    }, t.prototype.brightness = function(e, n) {
      var i = [
        e,
        0,
        0,
        0,
        0,
        0,
        e,
        0,
        0,
        0,
        0,
        0,
        e,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(i, n);
    }, t.prototype.tint = function(e, n) {
      var i = e >> 16 & 255, o = e >> 8 & 255, a = e & 255, s = [
        i / 255,
        0,
        0,
        0,
        0,
        0,
        o / 255,
        0,
        0,
        0,
        0,
        0,
        a / 255,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(s, n);
    }, t.prototype.greyscale = function(e, n) {
      var i = [
        e,
        e,
        e,
        0,
        0,
        e,
        e,
        e,
        0,
        0,
        e,
        e,
        e,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(i, n);
    }, t.prototype.blackAndWhite = function(e) {
      var n = [
        0.3,
        0.6,
        0.1,
        0,
        0,
        0.3,
        0.6,
        0.1,
        0,
        0,
        0.3,
        0.6,
        0.1,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(n, e);
    }, t.prototype.hue = function(e, n) {
      e = (e || 0) / 180 * Math.PI;
      var i = Math.cos(e), o = Math.sin(e), a = Math.sqrt, s = 1 / 3, h = a(s), u = i + (1 - i) * s, l = s * (1 - i) - h * o, f = s * (1 - i) + h * o, c = s * (1 - i) + h * o, d = i + s * (1 - i), p = s * (1 - i) - h * o, v = s * (1 - i) - h * o, _ = s * (1 - i) + h * o, m = i + s * (1 - i), y = [
        u,
        l,
        f,
        0,
        0,
        c,
        d,
        p,
        0,
        0,
        v,
        _,
        m,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(y, n);
    }, t.prototype.contrast = function(e, n) {
      var i = (e || 0) + 1, o = -0.5 * (i - 1), a = [
        i,
        0,
        0,
        0,
        o,
        0,
        i,
        0,
        0,
        o,
        0,
        0,
        i,
        0,
        o,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(a, n);
    }, t.prototype.saturate = function(e, n) {
      e === void 0 && (e = 0);
      var i = e * 2 / 3 + 1, o = (i - 1) * -0.5, a = [
        i,
        o,
        o,
        0,
        0,
        o,
        i,
        o,
        0,
        0,
        o,
        o,
        i,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(a, n);
    }, t.prototype.desaturate = function() {
      this.saturate(-1);
    }, t.prototype.negative = function(e) {
      var n = [
        -1,
        0,
        0,
        1,
        0,
        0,
        -1,
        0,
        1,
        0,
        0,
        0,
        -1,
        1,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(n, e);
    }, t.prototype.sepia = function(e) {
      var n = [
        0.393,
        0.7689999,
        0.18899999,
        0,
        0,
        0.349,
        0.6859999,
        0.16799999,
        0,
        0,
        0.272,
        0.5339999,
        0.13099999,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(n, e);
    }, t.prototype.technicolor = function(e) {
      var n = [
        1.9125277891456083,
        -0.8545344976951645,
        -0.09155508482755585,
        0,
        11.793603434377337,
        -0.3087833385928097,
        1.7658908555458428,
        -0.10601743074722245,
        0,
        -70.35205161461398,
        -0.231103377548616,
        -0.7501899197440212,
        1.847597816108189,
        0,
        30.950940869491138,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(n, e);
    }, t.prototype.polaroid = function(e) {
      var n = [
        1.438,
        -0.062,
        -0.062,
        0,
        0,
        -0.122,
        1.378,
        -0.122,
        0,
        0,
        -0.016,
        -0.016,
        1.483,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(n, e);
    }, t.prototype.toBGR = function(e) {
      var n = [
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(n, e);
    }, t.prototype.kodachrome = function(e) {
      var n = [
        1.1285582396593525,
        -0.3967382283601348,
        -0.03992559172921793,
        0,
        63.72958762196502,
        -0.16404339962244616,
        1.0835251566291304,
        -0.05498805115633132,
        0,
        24.732407896706203,
        -0.16786010706155763,
        -0.5603416277695248,
        1.6014850761964943,
        0,
        35.62982807460946,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(n, e);
    }, t.prototype.browni = function(e) {
      var n = [
        0.5997023498159715,
        0.34553243048391263,
        -0.2708298674538042,
        0,
        47.43192855600873,
        -0.037703249837783157,
        0.8609577587992641,
        0.15059552388459913,
        0,
        -36.96841498319127,
        0.24113635128153335,
        -0.07441037908422492,
        0.44972182064877153,
        0,
        -7.562075277591283,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(n, e);
    }, t.prototype.vintage = function(e) {
      var n = [
        0.6279345635605994,
        0.3202183420819367,
        -0.03965408211312453,
        0,
        9.651285835294123,
        0.02578397704808868,
        0.6441188644374771,
        0.03259127616149294,
        0,
        7.462829176470591,
        0.0466055556782719,
        -0.0851232987247891,
        0.5241648018700465,
        0,
        5.159190588235296,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(n, e);
    }, t.prototype.colorTone = function(e, n, i, o, a) {
      e = e || 0.2, n = n || 0.15, i = i || 16770432, o = o || 3375104;
      var s = (i >> 16 & 255) / 255, h = (i >> 8 & 255) / 255, u = (i & 255) / 255, l = (o >> 16 & 255) / 255, f = (o >> 8 & 255) / 255, c = (o & 255) / 255, d = [
        0.3,
        0.59,
        0.11,
        0,
        0,
        s,
        h,
        u,
        e,
        0,
        l,
        f,
        c,
        n,
        0,
        s - l,
        h - f,
        u - c,
        0,
        0
      ];
      this._loadMatrix(d, a);
    }, t.prototype.night = function(e, n) {
      e = e || 0.1;
      var i = [
        e * -2,
        -e,
        0,
        0,
        0,
        -e,
        0,
        e,
        0,
        0,
        0,
        e,
        e * 2,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(i, n);
    }, t.prototype.predator = function(e, n) {
      var i = [
        // row 1
        11.224130630493164 * e,
        -4.794486999511719 * e,
        -2.8746118545532227 * e,
        0 * e,
        0.40342438220977783 * e,
        // row 2
        -3.6330697536468506 * e,
        9.193157196044922 * e,
        -2.951810836791992 * e,
        0 * e,
        -1.316135048866272 * e,
        // row 3
        -3.2184197902679443 * e,
        -4.2375030517578125 * e,
        7.476448059082031 * e,
        0 * e,
        0.8044459223747253 * e,
        // row 4
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(i, n);
    }, t.prototype.lsd = function(e) {
      var n = [
        2,
        -0.4,
        0.5,
        0,
        0,
        -0.5,
        2,
        -0.4,
        0,
        0,
        -0.4,
        -0.5,
        3,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(n, e);
    }, t.prototype.reset = function() {
      var e = [
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ];
      this._loadMatrix(e, !1);
    }, Object.defineProperty(t.prototype, "matrix", {
      /**
       * The matrix of the color matrix filter
       * @member {number[]}
       * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
       */
      get: function() {
        return this.uniforms.m;
      },
      set: function(e) {
        this.uniforms.m = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "alpha", {
      /**
       * The opacity value to use when mixing the original and resultant colors.
       *
       * When the value is 0, the original color is used without modification.
       * When the value is 1, the result color is used.
       * When in the range (0, 1) the color is interpolated between the original and result by this amount.
       * @default 1
       */
      get: function() {
        return this.uniforms.uAlpha;
      },
      set: function(e) {
        this.uniforms.uAlpha = e;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Ve)
);
iu.prototype.grayscale = iu.prototype.greyscale;
/*!
 * @pixi/filter-displacement - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/filter-displacement is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Pa = function(r, t) {
  return Pa = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, Pa(r, t);
};
function sx(r, t) {
  Pa(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var hx = `varying vec2 vFilterCoord;
varying vec2 vTextureCoord;

uniform vec2 scale;
uniform mat2 rotation;
uniform sampler2D uSampler;
uniform sampler2D mapSampler;

uniform highp vec4 inputSize;
uniform vec4 inputClamp;

void main(void)
{
  vec4 map =  texture2D(mapSampler, vFilterCoord);

  map -= 0.5;
  map.xy = scale * inputSize.zw * (rotation * map.xy);

  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));
}
`, ux = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;
uniform mat3 filterMatrix;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
	gl_Position = filterVertexPosition();
	vTextureCoord = filterTextureCoord();
	vFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;
}
`;
(function(r) {
  sx(t, r);
  function t(e, n) {
    var i = this, o = new Dt();
    return e.renderable = !1, i = r.call(this, ux, hx, {
      mapSampler: e._texture,
      filterMatrix: o,
      scale: { x: 1, y: 1 },
      rotation: new Float32Array([1, 0, 0, 1])
    }) || this, i.maskSprite = e, i.maskMatrix = o, n == null && (n = 20), i.scale = new Et(n, n), i;
  }
  return t.prototype.apply = function(e, n, i, o) {
    this.uniforms.filterMatrix = e.calculateSpriteMatrix(this.maskMatrix, this.maskSprite), this.uniforms.scale.x = this.scale.x, this.uniforms.scale.y = this.scale.y;
    var a = this.maskSprite.worldTransform, s = Math.sqrt(a.a * a.a + a.b * a.b), h = Math.sqrt(a.c * a.c + a.d * a.d);
    s !== 0 && h !== 0 && (this.uniforms.rotation[0] = a.a / s, this.uniforms.rotation[1] = a.b / s, this.uniforms.rotation[2] = a.c / h, this.uniforms.rotation[3] = a.d / h), e.applyFilter(this, n, i, o);
  }, Object.defineProperty(t.prototype, "map", {
    /** The texture used for the displacement map. Must be power of 2 sized texture. */
    get: function() {
      return this.uniforms.mapSampler;
    },
    set: function(e) {
      this.uniforms.mapSampler = e;
    },
    enumerable: !1,
    configurable: !0
  }), t;
})(Ve);
/*!
 * @pixi/filter-fxaa - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/filter-fxaa is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Oa = function(r, t) {
  return Oa = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, Oa(r, t);
};
function lx(r, t) {
  Oa(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var fx = `
attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

void texcoords(vec2 fragCoord, vec2 inverseVP,
               out vec2 v_rgbNW, out vec2 v_rgbNE,
               out vec2 v_rgbSW, out vec2 v_rgbSE,
               out vec2 v_rgbM) {
    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;
    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;
    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;
    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;
    v_rgbM = vec2(fragCoord * inverseVP);
}

void main(void) {

   gl_Position = filterVertexPosition();

   vFragCoord = aVertexPosition * outputFrame.zw;

   texcoords(vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);
}
`, cx = `varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;
uniform sampler2D uSampler;
uniform highp vec4 inputSize;


/**
 Basic FXAA implementation based on the code on geeks3d.com with the
 modification that the texture2DLod stuff was removed since it's
 unsupported by WebGL.

 --

 From:
 https://github.com/mitsuhiko/webgl-meincraft

 Copyright (c) 2011 by Armin Ronacher.

 Some rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are
 met:

 * Redistributions of source code must retain the above copyright
 notice, this list of conditions and the following disclaimer.

 * Redistributions in binary form must reproduce the above
 copyright notice, this list of conditions and the following
 disclaimer in the documentation and/or other materials provided
 with the distribution.

 * The names of the contributors may not be used to endorse or
 promote products derived from this software without specific
 prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

#ifndef FXAA_REDUCE_MIN
#define FXAA_REDUCE_MIN   (1.0/ 128.0)
#endif
#ifndef FXAA_REDUCE_MUL
#define FXAA_REDUCE_MUL   (1.0 / 8.0)
#endif
#ifndef FXAA_SPAN_MAX
#define FXAA_SPAN_MAX     8.0
#endif

//optimized version for mobile, where dependent
//texture reads can be a bottleneck
vec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 inverseVP,
          vec2 v_rgbNW, vec2 v_rgbNE,
          vec2 v_rgbSW, vec2 v_rgbSE,
          vec2 v_rgbM) {
    vec4 color;
    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;
    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;
    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;
    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;
    vec4 texColor = texture2D(tex, v_rgbM);
    vec3 rgbM  = texColor.xyz;
    vec3 luma = vec3(0.299, 0.587, 0.114);
    float lumaNW = dot(rgbNW, luma);
    float lumaNE = dot(rgbNE, luma);
    float lumaSW = dot(rgbSW, luma);
    float lumaSE = dot(rgbSE, luma);
    float lumaM  = dot(rgbM,  luma);
    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));
    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));

    mediump vec2 dir;
    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));
    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));

    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *
                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);

    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);
    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),
              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),
                  dir * rcpDirMin)) * inverseVP;

    vec3 rgbA = 0.5 * (
                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +
                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);
    vec3 rgbB = rgbA * 0.5 + 0.25 * (
                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +
                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);

    float lumaB = dot(rgbB, luma);
    if ((lumaB < lumaMin) || (lumaB > lumaMax))
        color = vec4(rgbA, texColor.a);
    else
        color = vec4(rgbB, texColor.a);
    return color;
}

void main() {

      vec4 color;

      color = fxaa(uSampler, vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);

      gl_FragColor = color;
}
`;
(function(r) {
  lx(t, r);
  function t() {
    return r.call(this, fx, cx) || this;
  }
  return t;
})(Ve);
/*!
 * @pixi/filter-noise - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/filter-noise is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Ra = function(r, t) {
  return Ra = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, Ra(r, t);
};
function dx(r, t) {
  Ra(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var px = `precision highp float;

varying vec2 vTextureCoord;
varying vec4 vColor;

uniform float uNoise;
uniform float uSeed;
uniform sampler2D uSampler;

float rand(vec2 co)
{
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main()
{
    vec4 color = texture2D(uSampler, vTextureCoord);
    float randomValue = rand(gl_FragCoord.xy * uSeed);
    float diff = (randomValue - 0.5) * uNoise;

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (color.a > 0.0) {
        color.rgb /= color.a;
    }

    color.r += diff;
    color.g += diff;
    color.b += diff;

    // Premultiply alpha again.
    color.rgb *= color.a;

    gl_FragColor = color;
}
`;
(function(r) {
  dx(t, r);
  function t(e, n) {
    e === void 0 && (e = 0.5), n === void 0 && (n = Math.random());
    var i = r.call(this, Rl, px, {
      uNoise: 0,
      uSeed: 0
    }) || this;
    return i.noise = e, i.seed = n, i;
  }
  return Object.defineProperty(t.prototype, "noise", {
    /**
     * The amount of noise to apply, this value should be in the range (0, 1].
     * @default 0.5
     */
    get: function() {
      return this.uniforms.uNoise;
    },
    set: function(e) {
      this.uniforms.uNoise = e;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "seed", {
    /** A seed value to apply to the random noise generation. `Math.random()` is a good value to use. */
    get: function() {
      return this.uniforms.uSeed;
    },
    set: function(e) {
      this.uniforms.uSeed = e;
    },
    enumerable: !1,
    configurable: !0
  }), t;
})(Ve);
/*!
 * @pixi/mixin-cache-as-bitmap - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/mixin-cache-as-bitmap is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var Yl = new Dt();
Rt.prototype._cacheAsBitmap = !1;
Rt.prototype._cacheData = null;
Rt.prototype._cacheAsBitmapResolution = null;
Rt.prototype._cacheAsBitmapMultisample = wt.NONE;
var vx = (
  /** @class */
  function() {
    function r() {
      this.textureCacheId = null, this.originalRender = null, this.originalRenderCanvas = null, this.originalCalculateBounds = null, this.originalGetLocalBounds = null, this.originalUpdateTransform = null, this.originalDestroy = null, this.originalMask = null, this.originalFilterArea = null, this.originalContainsPoint = null, this.sprite = null;
    }
    return r;
  }()
);
Object.defineProperties(Rt.prototype, {
  /**
   * The resolution to use for cacheAsBitmap. By default this will use the renderer's resolution
   * but can be overriden for performance. Lower values will reduce memory usage at the expense
   * of render quality. A falsey value of `null` or `0` will default to the renderer's resolution.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new resolution.
   * @member {number} cacheAsBitmapResolution
   * @memberof PIXI.DisplayObject#
   * @default null
   */
  cacheAsBitmapResolution: {
    get: function() {
      return this._cacheAsBitmapResolution;
    },
    set: function(r) {
      r !== this._cacheAsBitmapResolution && (this._cacheAsBitmapResolution = r, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
    }
  },
  /**
   * The number of samples to use for cacheAsBitmap. If set to `null`, the renderer's
   * sample count is used.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new number of samples.
   * @member {number} cacheAsBitmapMultisample
   * @memberof PIXI.DisplayObject#
   * @default PIXI.MSAA_QUALITY.NONE
   */
  cacheAsBitmapMultisample: {
    get: function() {
      return this._cacheAsBitmapMultisample;
    },
    set: function(r) {
      r !== this._cacheAsBitmapMultisample && (this._cacheAsBitmapMultisample = r, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
    }
  },
  /**
   * Set this to true if you want this display object to be cached as a bitmap.
   * This basically takes a snap shot of the display object as it is at that moment. It can
   * provide a performance benefit for complex static displayObjects.
   * To remove simply set this property to `false`
   *
   * IMPORTANT GOTCHA - Make sure that all your textures are preloaded BEFORE setting this property to true
   * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */
  cacheAsBitmap: {
    get: function() {
      return this._cacheAsBitmap;
    },
    set: function(r) {
      if (this._cacheAsBitmap !== r) {
        this._cacheAsBitmap = r;
        var t;
        r ? (this._cacheData || (this._cacheData = new vx()), t = this._cacheData, t.originalRender = this.render, t.originalRenderCanvas = this.renderCanvas, t.originalUpdateTransform = this.updateTransform, t.originalCalculateBounds = this.calculateBounds, t.originalGetLocalBounds = this.getLocalBounds, t.originalDestroy = this.destroy, t.originalContainsPoint = this.containsPoint, t.originalMask = this._mask, t.originalFilterArea = this.filterArea, this.render = this._renderCached, this.renderCanvas = this._renderCachedCanvas, this.destroy = this._cacheAsBitmapDestroy) : (t = this._cacheData, t.sprite && this._destroyCachedDisplayObject(), this.render = t.originalRender, this.renderCanvas = t.originalRenderCanvas, this.calculateBounds = t.originalCalculateBounds, this.getLocalBounds = t.originalGetLocalBounds, this.destroy = t.originalDestroy, this.updateTransform = t.originalUpdateTransform, this.containsPoint = t.originalContainsPoint, this._mask = t.originalMask, this.filterArea = t.originalFilterArea);
      }
    }
  }
});
Rt.prototype._renderCached = function(t) {
  !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObject(t), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._render(t));
};
Rt.prototype._initCachedDisplayObject = function(t) {
  var e;
  if (!(this._cacheData && this._cacheData.sprite)) {
    var n = this.alpha;
    this.alpha = 1, t.batch.flush();
    var i = this.getLocalBounds(null, !0).clone();
    if (this.filters && this.filters.length) {
      var o = this.filters[0].padding;
      i.pad(o);
    }
    i.ceil(G.RESOLUTION);
    var a = t.renderTexture.current, s = t.renderTexture.sourceFrame.clone(), h = t.renderTexture.destinationFrame.clone(), u = t.projection.transform, l = fr.create({
      width: i.width,
      height: i.height,
      resolution: this.cacheAsBitmapResolution || t.resolution,
      multisample: (e = this.cacheAsBitmapMultisample) !== null && e !== void 0 ? e : t.multisample
    }), f = "cacheAsBitmap_" + lr();
    this._cacheData.textureCacheId = f, ht.addToCache(l.baseTexture, f), J.addToCache(l, f);
    var c = this.transform.localTransform.copyTo(Yl).invert().translate(-i.x, -i.y);
    this.render = this._cacheData.originalRender, t.render(this, { renderTexture: l, clear: !0, transform: c, skipUpdateTransform: !1 }), t.framebuffer.blit(), t.projection.transform = u, t.renderTexture.bind(a, s, h), this.render = this._renderCached, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = n;
    var d = new In(l);
    d.transform.worldTransform = this.transform.worldTransform, d.anchor.x = -(i.x / i.width), d.anchor.y = -(i.y / i.height), d.alpha = n, d._bounds = this._bounds, this._cacheData.sprite = d, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.enableTempParent(), this.updateTransform(), this.disableTempParent(null)), this.containsPoint = d.containsPoint.bind(d);
  }
};
Rt.prototype._renderCachedCanvas = function(t) {
  !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObjectCanvas(t), this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._renderCanvas(t));
};
Rt.prototype._initCachedDisplayObjectCanvas = function(t) {
  if (!(this._cacheData && this._cacheData.sprite)) {
    var e = this.getLocalBounds(null, !0), n = this.alpha;
    this.alpha = 1;
    var i = t.context, o = t._projTransform;
    e.ceil(G.RESOLUTION);
    var a = fr.create({ width: e.width, height: e.height }), s = "cacheAsBitmap_" + lr();
    this._cacheData.textureCacheId = s, ht.addToCache(a.baseTexture, s), J.addToCache(a, s);
    var h = Yl;
    this.transform.localTransform.copyTo(h), h.invert(), h.tx -= e.x, h.ty -= e.y, this.renderCanvas = this._cacheData.originalRenderCanvas, t.render(this, { renderTexture: a, clear: !0, transform: h, skipUpdateTransform: !1 }), t.context = i, t._projTransform = o, this.renderCanvas = this._renderCachedCanvas, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = n;
    var u = new In(a);
    u.transform.worldTransform = this.transform.worldTransform, u.anchor.x = -(e.x / e.width), u.anchor.y = -(e.y / e.height), u.alpha = n, u._bounds = this._bounds, this._cacheData.sprite = u, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.parent = t._tempDisplayObjectParent, this.updateTransform(), this.parent = null), this.containsPoint = u.containsPoint.bind(u);
  }
};
Rt.prototype._calculateCachedBounds = function() {
  this._bounds.clear(), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite._calculateBounds(), this._bounds.updateID = this._boundsID;
};
Rt.prototype._getCachedLocalBounds = function() {
  return this._cacheData.sprite.getLocalBounds(null);
};
Rt.prototype._destroyCachedDisplayObject = function() {
  this._cacheData.sprite._texture.destroy(!0), this._cacheData.sprite = null, ht.removeFromCache(this._cacheData.textureCacheId), J.removeFromCache(this._cacheData.textureCacheId), this._cacheData.textureCacheId = null;
};
Rt.prototype._cacheAsBitmapDestroy = function(t) {
  this.cacheAsBitmap = !1, this.destroy(t);
};
/*!
 * @pixi/mixin-get-child-by-name - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/mixin-get-child-by-name is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
Rt.prototype.name = null;
Te.prototype.getChildByName = function(t, e) {
  for (var n = 0, i = this.children.length; n < i; n++)
    if (this.children[n].name === t)
      return this.children[n];
  if (e)
    for (var n = 0, i = this.children.length; n < i; n++) {
      var o = this.children[n];
      if (o.getChildByName) {
        var a = o.getChildByName(t, !0);
        if (a)
          return a;
      }
    }
  return null;
};
/*!
 * @pixi/mixin-get-global-position - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/mixin-get-global-position is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
Rt.prototype.getGlobalPosition = function(t, e) {
  return t === void 0 && (t = new Et()), e === void 0 && (e = !1), this.parent ? this.parent.toGlobal(this.position, t, e) : (t.x = this.position.x, t.y = this.position.y), t;
};
/*!
 * @pixi/app - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/app is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var _x = (
  /** @class */
  function() {
    function r() {
    }
    return r.init = function(t) {
      var e = this;
      Object.defineProperty(
        this,
        "resizeTo",
        /**
         * The HTML element or window to automatically resize the
         * renderer's view element to match width and height.
         * @member {Window|HTMLElement}
         * @name resizeTo
         * @memberof PIXI.Application#
         */
        {
          set: function(n) {
            globalThis.removeEventListener("resize", this.queueResize), this._resizeTo = n, n && (globalThis.addEventListener("resize", this.queueResize), this.resize());
          },
          get: function() {
            return this._resizeTo;
          }
        }
      ), this.queueResize = function() {
        e._resizeTo && (e.cancelResize(), e._resizeId = requestAnimationFrame(function() {
          return e.resize();
        }));
      }, this.cancelResize = function() {
        e._resizeId && (cancelAnimationFrame(e._resizeId), e._resizeId = null);
      }, this.resize = function() {
        if (e._resizeTo) {
          e.cancelResize();
          var n, i;
          if (e._resizeTo === globalThis.window)
            n = globalThis.innerWidth, i = globalThis.innerHeight;
          else {
            var o = e._resizeTo, a = o.clientWidth, s = o.clientHeight;
            n = a, i = s;
          }
          e.renderer.resize(n, i);
        }
      }, this._resizeId = null, this._resizeTo = null, this.resizeTo = t.resizeTo || null;
    }, r.destroy = function() {
      globalThis.removeEventListener("resize", this.queueResize), this.cancelResize(), this.cancelResize = null, this.queueResize = null, this.resizeTo = null, this.resize = null;
    }, r.extension = mt.Application, r;
  }()
), mx = (
  /** @class */
  function() {
    function r(t) {
      var e = this;
      this.stage = new Te(), t = Object.assign({
        forceCanvas: !1
      }, t), this.renderer = Ol(t), r._plugins.forEach(function(n) {
        n.init.call(e, t);
      });
    }
    return r.registerPlugin = function(t) {
      ce("6.5.0", "Application.registerPlugin() is deprecated, use extensions.add()"), Me.add({
        type: mt.Application,
        ref: t
      });
    }, r.prototype.render = function() {
      this.renderer.render(this.stage);
    }, Object.defineProperty(r.prototype, "view", {
      /**
       * Reference to the renderer's canvas element.
       * @member {HTMLCanvasElement}
       * @readonly
       */
      get: function() {
        return this.renderer.view;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "screen", {
      /**
       * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
       * @member {PIXI.Rectangle}
       * @readonly
       */
      get: function() {
        return this.renderer.screen;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.destroy = function(t, e) {
      var n = this, i = r._plugins.slice(0);
      i.reverse(), i.forEach(function(o) {
        o.destroy.call(n);
      }), this.stage.destroy(e), this.stage = null, this.renderer.destroy(t), this.renderer = null;
    }, r._plugins = [], r;
  }()
);
Me.handleByList(mt.Application, mx._plugins);
Me.add(_x);
/*!
 * @pixi/mesh-extras - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/mesh-extras is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Ia = function(r, t) {
  return Ia = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, Ia(r, t);
};
function Wr(r, t) {
  Ia(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var yx = (
  /** @class */
  function(r) {
    Wr(t, r);
    function t(e, n, i, o) {
      e === void 0 && (e = 100), n === void 0 && (n = 100), i === void 0 && (i = 10), o === void 0 && (o = 10);
      var a = r.call(this) || this;
      return a.segWidth = i, a.segHeight = o, a.width = e, a.height = n, a.build(), a;
    }
    return t.prototype.build = function() {
      for (var e = this.segWidth * this.segHeight, n = [], i = [], o = [], a = this.segWidth - 1, s = this.segHeight - 1, h = this.width / a, u = this.height / s, l = 0; l < e; l++) {
        var f = l % this.segWidth, c = l / this.segWidth | 0;
        n.push(f * h, c * u), i.push(f / a, c / s);
      }
      for (var d = a * s, l = 0; l < d; l++) {
        var p = l % a, v = l / a | 0, _ = v * this.segWidth + p, m = v * this.segWidth + p + 1, y = (v + 1) * this.segWidth + p, g = (v + 1) * this.segWidth + p + 1;
        o.push(_, m, y, m, g, y);
      }
      this.buffers[0].data = new Float32Array(n), this.buffers[1].data = new Float32Array(i), this.indexBuffer.data = new Uint16Array(o), this.buffers[0].update(), this.buffers[1].update(), this.indexBuffer.update();
    }, t;
  }(ki)
), gx = (
  /** @class */
  function(r) {
    Wr(t, r);
    function t(e, n, i) {
      e === void 0 && (e = 200), i === void 0 && (i = 0);
      var o = r.call(this, new Float32Array(n.length * 4), new Float32Array(n.length * 4), new Uint16Array((n.length - 1) * 6)) || this;
      return o.points = n, o._width = e, o.textureScale = i, o.build(), o;
    }
    return Object.defineProperty(t.prototype, "width", {
      /**
       * The width (i.e., thickness) of the rope.
       * @readonly
       */
      get: function() {
        return this._width;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.build = function() {
      var e = this.points;
      if (e) {
        var n = this.getBuffer("aVertexPosition"), i = this.getBuffer("aTextureCoord"), o = this.getIndex();
        if (!(e.length < 1)) {
          n.data.length / 4 !== e.length && (n.data = new Float32Array(e.length * 4), i.data = new Float32Array(e.length * 4), o.data = new Uint16Array((e.length - 1) * 6));
          var a = i.data, s = o.data;
          a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 1;
          for (var h = 0, u = e[0], l = this._width * this.textureScale, f = e.length, c = 0; c < f; c++) {
            var d = c * 4;
            if (this.textureScale > 0) {
              var p = u.x - e[c].x, v = u.y - e[c].y, _ = Math.sqrt(p * p + v * v);
              u = e[c], h += _ / l;
            } else
              h = c / (f - 1);
            a[d] = h, a[d + 1] = 0, a[d + 2] = h, a[d + 3] = 1;
          }
          for (var m = 0, c = 0; c < f - 1; c++) {
            var d = c * 2;
            s[m++] = d, s[m++] = d + 1, s[m++] = d + 2, s[m++] = d + 2, s[m++] = d + 1, s[m++] = d + 3;
          }
          i.update(), o.update(), this.updateVertices();
        }
      }
    }, t.prototype.updateVertices = function() {
      var e = this.points;
      if (!(e.length < 1)) {
        for (var n = e[0], i, o = 0, a = 0, s = this.buffers[0].data, h = e.length, u = 0; u < h; u++) {
          var l = e[u], f = u * 4;
          u < e.length - 1 ? i = e[u + 1] : i = l, a = -(i.x - n.x), o = i.y - n.y;
          var c = Math.sqrt(o * o + a * a), d = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
          o /= c, a /= c, o *= d, a *= d, s[f] = l.x + o, s[f + 1] = l.y + a, s[f + 2] = l.x - o, s[f + 3] = l.y - a, n = l;
        }
        this.buffers[0].update();
      }
    }, t.prototype.update = function() {
      this.textureScale > 0 ? this.build() : this.updateVertices();
    }, t;
  }(ki)
);
(function(r) {
  Wr(t, r);
  function t(e, n, i) {
    i === void 0 && (i = 0);
    var o = this, a = new gx(e.height, n, i), s = new En(e);
    return i > 0 && (e.baseTexture.wrapMode = be.REPEAT), o = r.call(this, a, s) || this, o.autoUpdate = !0, o;
  }
  return t.prototype._render = function(e) {
    var n = this.geometry;
    (this.autoUpdate || n._width !== this.shader.texture.height) && (n._width = this.shader.texture.height, n.update()), r.prototype._render.call(this, e);
  }, t;
})(Tn);
var bx = (
  /** @class */
  function(r) {
    Wr(t, r);
    function t(e, n, i) {
      var o = this, a = new yx(e.width, e.height, n, i), s = new En(J.WHITE);
      return o = r.call(this, a, s) || this, o.texture = e, o.autoResize = !0, o;
    }
    return t.prototype.textureUpdated = function() {
      this._textureID = this.shader.texture._updateID;
      var e = this.geometry, n = this.shader.texture, i = n.width, o = n.height;
      this.autoResize && (e.width !== i || e.height !== o) && (e.width = this.shader.texture.width, e.height = this.shader.texture.height, e.build());
    }, Object.defineProperty(t.prototype, "texture", {
      get: function() {
        return this.shader.texture;
      },
      set: function(e) {
        this.shader.texture !== e && (this.shader.texture = e, this._textureID = -1, e.baseTexture.valid ? this.textureUpdated() : e.once("update", this.textureUpdated, this));
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype._render = function(e) {
      this._textureID !== this.shader.texture._updateID && this.textureUpdated(), r.prototype._render.call(this, e);
    }, t.prototype.destroy = function(e) {
      this.shader.texture.off("update", this.textureUpdated, this), r.prototype.destroy.call(this, e);
    }, t;
  }(Tn)
);
(function(r) {
  Wr(t, r);
  function t(e, n, i, o, a) {
    e === void 0 && (e = J.EMPTY);
    var s = this, h = new ki(n, i, o);
    h.getBuffer("aVertexPosition").static = !1;
    var u = new En(e);
    return s = r.call(this, h, u, null, a) || this, s.autoUpdate = !0, s;
  }
  return Object.defineProperty(t.prototype, "vertices", {
    /**
     * Collection of vertices data.
     * @type {Float32Array}
     */
    get: function() {
      return this.geometry.getBuffer("aVertexPosition").data;
    },
    set: function(e) {
      this.geometry.getBuffer("aVertexPosition").data = e;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._render = function(e) {
    this.autoUpdate && this.geometry.getBuffer("aVertexPosition").update(), r.prototype._render.call(this, e);
  }, t;
})(Tn);
var hi = 10;
(function(r) {
  Wr(t, r);
  function t(e, n, i, o, a) {
    n === void 0 && (n = hi), i === void 0 && (i = hi), o === void 0 && (o = hi), a === void 0 && (a = hi);
    var s = r.call(this, J.WHITE, 4, 4) || this;
    return s._origWidth = e.orig.width, s._origHeight = e.orig.height, s._width = s._origWidth, s._height = s._origHeight, s._leftWidth = n, s._rightWidth = o, s._topHeight = i, s._bottomHeight = a, s.texture = e, s;
  }
  return t.prototype.textureUpdated = function() {
    this._textureID = this.shader.texture._updateID, this._refresh();
  }, Object.defineProperty(t.prototype, "vertices", {
    get: function() {
      return this.geometry.getBuffer("aVertexPosition").data;
    },
    set: function(e) {
      this.geometry.getBuffer("aVertexPosition").data = e;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.updateHorizontalVertices = function() {
    var e = this.vertices, n = this._getMinScale();
    e[9] = e[11] = e[13] = e[15] = this._topHeight * n, e[17] = e[19] = e[21] = e[23] = this._height - this._bottomHeight * n, e[25] = e[27] = e[29] = e[31] = this._height;
  }, t.prototype.updateVerticalVertices = function() {
    var e = this.vertices, n = this._getMinScale();
    e[2] = e[10] = e[18] = e[26] = this._leftWidth * n, e[4] = e[12] = e[20] = e[28] = this._width - this._rightWidth * n, e[6] = e[14] = e[22] = e[30] = this._width;
  }, t.prototype._getMinScale = function() {
    var e = this._leftWidth + this._rightWidth, n = this._width > e ? 1 : this._width / e, i = this._topHeight + this._bottomHeight, o = this._height > i ? 1 : this._height / i, a = Math.min(n, o);
    return a;
  }, Object.defineProperty(t.prototype, "width", {
    /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
    get: function() {
      return this._width;
    },
    set: function(e) {
      this._width = e, this._refresh();
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "height", {
    /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
    get: function() {
      return this._height;
    },
    set: function(e) {
      this._height = e, this._refresh();
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "leftWidth", {
    /** The width of the left column. */
    get: function() {
      return this._leftWidth;
    },
    set: function(e) {
      this._leftWidth = e, this._refresh();
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "rightWidth", {
    /** The width of the right column. */
    get: function() {
      return this._rightWidth;
    },
    set: function(e) {
      this._rightWidth = e, this._refresh();
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "topHeight", {
    /** The height of the top row. */
    get: function() {
      return this._topHeight;
    },
    set: function(e) {
      this._topHeight = e, this._refresh();
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "bottomHeight", {
    /** The height of the bottom row. */
    get: function() {
      return this._bottomHeight;
    },
    set: function(e) {
      this._bottomHeight = e, this._refresh();
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._refresh = function() {
    var e = this.texture, n = this.geometry.buffers[1].data;
    this._origWidth = e.orig.width, this._origHeight = e.orig.height;
    var i = 1 / this._origWidth, o = 1 / this._origHeight;
    n[0] = n[8] = n[16] = n[24] = 0, n[1] = n[3] = n[5] = n[7] = 0, n[6] = n[14] = n[22] = n[30] = 1, n[25] = n[27] = n[29] = n[31] = 1, n[2] = n[10] = n[18] = n[26] = i * this._leftWidth, n[4] = n[12] = n[20] = n[28] = 1 - i * this._rightWidth, n[9] = n[11] = n[13] = n[15] = o * this._topHeight, n[17] = n[19] = n[21] = n[23] = 1 - o * this._bottomHeight, this.updateHorizontalVertices(), this.updateVerticalVertices(), this.geometry.buffers[0].update(), this.geometry.buffers[1].update();
  }, t;
})(bx);
/*!
 * @pixi/sprite-animated - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * @pixi/sprite-animated is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Ca = function(r, t) {
  return Ca = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var i in n)
      n.hasOwnProperty(i) && (e[i] = n[i]);
  }, Ca(r, t);
};
function xx(r, t) {
  Ca(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
(function(r) {
  xx(t, r);
  function t(e, n) {
    n === void 0 && (n = !0);
    var i = r.call(this, e[0] instanceof J ? e[0] : e[0].texture) || this;
    return i._textures = null, i._durations = null, i._autoUpdate = n, i._isConnectedToTicker = !1, i.animationSpeed = 1, i.loop = !0, i.updateAnchor = !1, i.onComplete = null, i.onFrameChange = null, i.onLoop = null, i._currentTime = 0, i._playing = !1, i._previousFrame = null, i.textures = e, i;
  }
  return t.prototype.stop = function() {
    this._playing && (this._playing = !1, this._autoUpdate && this._isConnectedToTicker && (Ht.shared.remove(this.update, this), this._isConnectedToTicker = !1));
  }, t.prototype.play = function() {
    this._playing || (this._playing = !0, this._autoUpdate && !this._isConnectedToTicker && (Ht.shared.add(this.update, this, Ce.HIGH), this._isConnectedToTicker = !0));
  }, t.prototype.gotoAndStop = function(e) {
    this.stop();
    var n = this.currentFrame;
    this._currentTime = e, n !== this.currentFrame && this.updateTexture();
  }, t.prototype.gotoAndPlay = function(e) {
    var n = this.currentFrame;
    this._currentTime = e, n !== this.currentFrame && this.updateTexture(), this.play();
  }, t.prototype.update = function(e) {
    if (this._playing) {
      var n = this.animationSpeed * e, i = this.currentFrame;
      if (this._durations !== null) {
        var o = this._currentTime % 1 * this._durations[this.currentFrame];
        for (o += n / 60 * 1e3; o < 0; )
          this._currentTime--, o += this._durations[this.currentFrame];
        var a = Math.sign(this.animationSpeed * e);
        for (this._currentTime = Math.floor(this._currentTime); o >= this._durations[this.currentFrame]; )
          o -= this._durations[this.currentFrame] * a, this._currentTime += a;
        this._currentTime += o / this._durations[this.currentFrame];
      } else
        this._currentTime += n;
      this._currentTime < 0 && !this.loop ? (this.gotoAndStop(0), this.onComplete && this.onComplete()) : this._currentTime >= this._textures.length && !this.loop ? (this.gotoAndStop(this._textures.length - 1), this.onComplete && this.onComplete()) : i !== this.currentFrame && (this.loop && this.onLoop && (this.animationSpeed > 0 && this.currentFrame < i ? this.onLoop() : this.animationSpeed < 0 && this.currentFrame > i && this.onLoop()), this.updateTexture());
    }
  }, t.prototype.updateTexture = function() {
    var e = this.currentFrame;
    this._previousFrame !== e && (this._previousFrame = e, this._texture = this._textures[e], this._textureID = -1, this._textureTrimmedID = -1, this._cachedTint = 16777215, this.uvs = this._texture._uvs.uvsFloat32, this.updateAnchor && this._anchor.copyFrom(this._texture.defaultAnchor), this.onFrameChange && this.onFrameChange(this.currentFrame));
  }, t.prototype.destroy = function(e) {
    this.stop(), r.prototype.destroy.call(this, e), this.onComplete = null, this.onFrameChange = null, this.onLoop = null;
  }, t.fromFrames = function(e) {
    for (var n = [], i = 0; i < e.length; ++i)
      n.push(J.from(e[i]));
    return new t(n);
  }, t.fromImages = function(e) {
    for (var n = [], i = 0; i < e.length; ++i)
      n.push(J.from(e[i]));
    return new t(n);
  }, Object.defineProperty(t.prototype, "totalFrames", {
    /**
     * The total number of frames in the AnimatedSprite. This is the same as number of textures
     * assigned to the AnimatedSprite.
     * @readonly
     * @default 0
     */
    get: function() {
      return this._textures.length;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "textures", {
    /** The array of textures used for this AnimatedSprite. */
    get: function() {
      return this._textures;
    },
    set: function(e) {
      if (e[0] instanceof J)
        this._textures = e, this._durations = null;
      else {
        this._textures = [], this._durations = [];
        for (var n = 0; n < e.length; n++)
          this._textures.push(e[n].texture), this._durations.push(e[n].time);
      }
      this._previousFrame = null, this.gotoAndStop(0), this.updateTexture();
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "currentFrame", {
    /**
     * The AnimatedSprites current frame index.
     * @readonly
     */
    get: function() {
      var e = Math.floor(this._currentTime) % this._textures.length;
      return e < 0 && (e += this._textures.length), e;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "playing", {
    /**
     * Indicates if the AnimatedSprite is currently playing.
     * @readonly
     */
    get: function() {
      return this._playing;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "autoUpdate", {
    /** Whether to use PIXI.Ticker.shared to auto update animation time. */
    get: function() {
      return this._autoUpdate;
    },
    set: function(e) {
      e !== this._autoUpdate && (this._autoUpdate = e, !this._autoUpdate && this._isConnectedToTicker ? (Ht.shared.remove(this.update, this), this._isConnectedToTicker = !1) : this._autoUpdate && !this._isConnectedToTicker && this._playing && (Ht.shared.add(this.update, this), this._isConnectedToTicker = !0));
    },
    enumerable: !1,
    configurable: !0
  }), t;
})(In);
/*!
 * pixi.js - v6.5.10
 * Compiled Thu, 06 Jul 2023 15:25:11 UTC
 *
 * pixi.js is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
Me.add(
  // Install renderer plugins
  n0,
  f0,
  h0,
  nb,
  Mb,
  Cl,
  Gb,
  // Install loader plugins
  Zb,
  O0,
  Q0,
  tb,
  Fb,
  // Install application plugins
  Ty,
  g0
);
const Di = 1733608, Vl = 0.25, Tx = (r, t) => {
  const { x: e, y: n, w: i, h: o } = r.geometry, a = t != null && t.fill ? Yr(t.fill) : Di, s = (t == null ? void 0 : t.fillOpacity) === void 0 ? Vl : t.fillOpacity, h = new cr();
  return h.beginFill(16777215, s), h.drawRect(e, n, i, o), h.endFill(), h.tint = a, h;
}, Ex = (r, t) => {
  const e = r.geometry.points.reduce((a, s) => [...a, ...s], []), n = t != null && t.fill ? Yr(t.fill) : Di, i = (t == null ? void 0 : t.fillOpacity) === void 0 ? Vl : t.fillOpacity, o = new cr();
  return o.beginFill(n, i), o.drawPolygon(e), o.endFill(), o;
}, wx = (r, t, e) => () => {
  const n = r.viewport.viewportToImageRectangle(r.viewport.getBounds(!0)), i = r.viewport.getContainerSize().x, a = r.viewport.getZoom(!0) * i / r.world.getContentFactor(), s = Math.PI * r.viewport.getRotation() / 180, h = -n.x * a, u = -n.y * a;
  let l, f;
  s > 0 && s <= Math.PI / 2 ? (l = n.height * a, f = 0) : s > Math.PI / 2 && s <= Math.PI ? (l = n.width * a, f = n.height * a) : s > Math.PI && s <= Math.PI * 1.5 ? (l = 0, f = n.width * a) : (l = 0, f = 0), t.position.x = l + h * Math.cos(s) - u * Math.sin(s), t.position.y = f + h * Math.sin(s) + u * Math.cos(s), t.scale.set(a, a), t.rotation = s, e.render(t);
}, Sx = (r, t) => {
  const e = new cr(), n = Ol({
    width: t.width,
    height: t.height,
    backgroundAlpha: 0,
    view: t
  }), i = /* @__PURE__ */ new Map();
  let o;
  const a = (f) => {
    const { selector: c } = f.target, d = typeof o == "function" ? o(f) : o;
    let p;
    c.type === $t.RECTANGLE ? p = Tx(c, d) : c.type === $t.POLYGON ? p = Ex(c, d) : console.warn(`Unsupported shape type: ${c.type}`), p && (e.addChild(p), i.set(f.id, { g: p, annotation: f }));
  }, s = (f) => {
    const c = i.get(f.id);
    c && (i.delete(f.id), c.g.destroy());
  }, h = (f, c) => {
    const d = i.get(f.id);
    d && (i.delete(f.id), d.g.destroy(), a(c));
  }, u = (f, c) => {
    n.resize(f, c), n.render(e);
  }, l = (f) => {
    if (typeof f == "function")
      i.forEach(({ g: c, annotation: d }, p) => {
        const { fill: v } = f(d);
        c.tint = v ? Yr(v) : Di;
      });
    else {
      const c = f != null && f.fill ? Yr(f.fill) : Di;
      i.forEach(({ g: d }, p) => d.tint = c);
    }
    o = f, n.render(e);
  };
  return {
    addAnnotation: a,
    redraw: wx(r, e, n),
    removeAnnotation: s,
    resize: u,
    setStyle: l,
    updateAnnotation: h
  };
};
function Ax(r, t, e) {
  let n, { state: i } = t, { viewer: o } = t, { style: a = void 0 } = t;
  const { store: s, hover: h, viewport: u } = i;
  wu(r, h, (y) => e(7, n = y));
  const l = Bi();
  let f, c = !1;
  const d = (y) => {
    const g = new vi.Point(y.x, y.y), { x, y: T } = o.viewport.pointFromPixel(g);
    return o.viewport.viewportToImageCoordinates(x, T);
  }, p = (y) => (g) => {
    const { x, y: T } = d(new vi.Point(g.offsetX, g.offsetY)), E = s.getAt(x, T);
    E ? (y.classList.add("hover"), n !== E.id && h.set(E.id)) : (y.classList.remove("hover"), n && h.set(null));
  }, v = (y) => {
    const g = y.originalEvent;
    if (!c) {
      const { x, y: T } = d(y.position), E = s.getAt(x, T);
      E ? l("click", { originalEvent: g, annotation: E }) : l("click", { originalEvent: g });
    }
    c = !1;
  }, _ = () => c = !0;
  let m;
  return Fi(() => {
    const { offsetWidth: y, offsetHeight: g } = o.canvas, x = document.createElement("canvas");
    x.width = y, x.height = g, x.className = "a9s-gl-canvas", o.element.querySelector(".openseadragon-canvas").appendChild(x), e(4, f = Sx(o, x));
    const T = p(x);
    x.addEventListener("pointermove", T), new ResizeObserver((b) => {
      const { width: w, height: A } = b[0].contentRect;
      x.width = w, x.height = A, f.resize(w, A);
    }).observe(x);
    const P = () => {
      const b = o.viewport.getBounds();
      m = o.viewport.viewportToImageRectangle(b);
      const { x: w, y: A, width: R, height: C } = m, M = s.getIntersecting(w, A, R, C);
      u.set(M.map((H) => H.id));
    };
    return o.addHandler("canvas-drag", _), o.addHandler("canvas-release", v), o.addHandler("update-viewport", f.redraw), o.addHandler("animation-finish", P), () => {
      x.removeEventListener("pointermove", T), o.removeHandler("canvas-drag", _), o.removeHandler("canvas-release", v), o.removeHandler("update-viewport", f.redraw), o.removeHandler("animation-finish", P), x.parentNode.removeChild(x);
    };
  }), s.observe((y) => {
    const { created: g, updated: x, deleted: T } = y.changes;
    if (g.forEach((E) => f.addAnnotation(E)), x.forEach(({ oldValue: E, newValue: P }) => f.updateAnnotation(E, P)), T.forEach((E) => f.removeAnnotation(E)), m) {
      const { x: E, y: P, width: b, height: w } = m, A = s.getIntersecting(E, P, b, w);
      u.set(A.map((R) => R.id));
    } else
      u.set(s.all().map((E) => E.id));
    f.redraw();
  }), r.$$set = (y) => {
    "state" in y && e(1, i = y.state), "viewer" in y && e(2, o = y.viewer), "style" in y && e(3, a = y.style);
  }, r.$$.update = () => {
    r.$$.dirty & /*stage, style*/
    24 && (f == null || f.setStyle(a));
  }, [h, i, o, a, f];
}
class Px extends ne {
  constructor(t) {
    super(), re(this, t, Ax, null, te, { state: 1, viewer: 2, style: 3 });
  }
}
const Ox = (r) => ({
  transform: r & /*layerTransform*/
  2,
  scale: r & /*scale*/
  1
}), ou = (r) => ({
  transform: (
    /*layerTransform*/
    r[1]
  ),
  scale: (
    /*scale*/
    r[0]
  )
});
function Rx(r) {
  let t;
  const e = (
    /*#slots*/
    r[4].default
  ), n = Su(
    e,
    r,
    /*$$scope*/
    r[3],
    ou
  );
  return {
    c() {
      n && n.c();
    },
    m(i, o) {
      n && n.m(i, o), t = !0;
    },
    p(i, [o]) {
      n && n.p && (!t || o & /*$$scope, layerTransform, scale*/
      11) && Ou(
        n,
        e,
        i,
        /*$$scope*/
        i[3],
        t ? Pu(
          e,
          /*$$scope*/
          i[3],
          o,
          Ox
        ) : Ru(
          /*$$scope*/
          i[3]
        ),
        ou
      );
    },
    i(i) {
      t || (ct(n, i), t = !0);
    },
    o(i) {
      bt(n, i), t = !1;
    },
    d(i) {
      n && n.d(i);
    }
  };
}
function Ix(r, t, e) {
  let { $$slots: n = {}, $$scope: i } = t, { viewer: o } = t, a = 1, s;
  const h = () => {
    const u = o.viewport.getContainerSize().x, l = o.viewport.getZoom(!0), f = o.viewport.getFlip(), c = o.viewport.pixelFromPoint(new vi.Point(0, 0), !0);
    f && (c.x = u - c.x);
    const d = l * u / o.world.getContentFactor(), p = f ? -d : d, v = o.viewport.getRotation();
    e(1, s = `translate(${c.x}, ${c.y}) scale(${p}, ${d}) rotate(${v})`), e(0, a = l * u / o.world.getContentFactor());
  };
  return Fi(() => (o.addHandler("update-viewport", h), () => {
    o.removeHandler("update-viewport", h);
  })), r.$$set = (u) => {
    "viewer" in u && e(2, o = u.viewer), "$$scope" in u && e(3, i = u.$$scope);
  }, [a, s, o, i, n];
}
class zl extends ne {
  constructor(t) {
    super(), re(this, t, Ix, Rx, te, { viewer: 2 });
  }
}
const { Boolean: Cx } = Iu;
function au(r, t, e) {
  const n = r.slice();
  return n[19] = t[e], n;
}
function Mx(r) {
  let t, e, n;
  var i = (
    /*tool*/
    r[0]
  );
  function o(a) {
    return {
      props: {
        transform: { elementToImage: (
          /*toolTransform*/
          a[4]
        ) },
        viewportScale: (
          /*scale*/
          a[18]
        )
      }
    };
  }
  return i && (t = _i(i, o(r)), t.$on(
    "create",
    /*onSelectionCreated*/
    r[8]
  )), {
    c() {
      t && ee(t.$$.fragment), e = He();
    },
    m(a, s) {
      t && Zt(t, a, s), Z(a, e, s), n = !0;
    },
    p(a, s) {
      const h = {};
      if (s & /*scale*/
      262144 && (h.viewportScale = /*scale*/
      a[18]), s & /*tool*/
      1 && i !== (i = /*tool*/
      a[0])) {
        if (t) {
          Xe();
          const u = t;
          bt(u.$$.fragment, 1, 0, () => {
            Jt(u, 1);
          }), je();
        }
        i ? (t = _i(i, o(a)), t.$on(
          "create",
          /*onSelectionCreated*/
          a[8]
        ), ee(t.$$.fragment), ct(t.$$.fragment, 1), Zt(t, e.parentNode, e)) : t = null;
      } else
        i && t.$set(h);
    },
    i(a) {
      n || (t && ct(t.$$.fragment, a), n = !0);
    },
    o(a) {
      t && bt(t.$$.fragment, a), n = !1;
    },
    d(a) {
      a && K(e), t && Jt(t, a);
    }
  };
}
function Dx(r) {
  let t, e, n = (
    /*editableAnnotations*/
    r[2]
  ), i = [];
  for (let a = 0; a < n.length; a += 1)
    i[a] = su(au(r, n, a));
  const o = (a) => bt(i[a], 1, 1, () => {
    i[a] = null;
  });
  return {
    c() {
      for (let a = 0; a < i.length; a += 1)
        i[a].c();
      t = He();
    },
    m(a, s) {
      for (let h = 0; h < i.length; h += 1)
        i[h] && i[h].m(a, s);
      Z(a, t, s), e = !0;
    },
    p(a, s) {
      if (s & /*getEditor, editableAnnotations, cast, toolTransform, scale, onGrab, onChangeSelected, onRelease*/
      262900) {
        n = /*editableAnnotations*/
        a[2];
        let h;
        for (h = 0; h < n.length; h += 1) {
          const u = au(a, n, h);
          i[h] ? (i[h].p(u, s), ct(i[h], 1)) : (i[h] = su(u), i[h].c(), ct(i[h], 1), i[h].m(t.parentNode, t));
        }
        for (Xe(), h = n.length; h < i.length; h += 1)
          o(h);
        je();
      }
    },
    i(a) {
      if (!e) {
        for (let s = 0; s < n.length; s += 1)
          ct(i[s]);
        e = !0;
      }
    },
    o(a) {
      i = i.filter(Cx);
      for (let s = 0; s < i.length; s += 1)
        bt(i[s]);
      e = !1;
    },
    d(a) {
      Ba(i, a), a && K(t);
    }
  };
}
function su(r) {
  let t, e, n;
  var i = Es(
    /*editable*/
    r[19].target.selector
  );
  function o(a) {
    return {
      props: {
        shape: (
          /*cast*/
          a[9](
            /*editable*/
            a[19].target.selector
          )
        ),
        transform: { elementToImage: (
          /*toolTransform*/
          a[4]
        ) },
        viewportScale: (
          /*scale*/
          a[18]
        )
      }
    };
  }
  return i && (t = _i(i, o(r)), t.$on(
    "grab",
    /*onGrab*/
    r[5]
  ), t.$on("change", function() {
    Gt(
      /*onChangeSelected*/
      r[7](
        /*editable*/
        r[19]
      )
    ) && r[7](
      /*editable*/
      r[19]
    ).apply(this, arguments);
  }), t.$on(
    "release",
    /*onRelease*/
    r[6]
  )), {
    c() {
      t && ee(t.$$.fragment), e = He();
    },
    m(a, s) {
      t && Zt(t, a, s), Z(a, e, s), n = !0;
    },
    p(a, s) {
      r = a;
      const h = {};
      if (s & /*editableAnnotations*/
      4 && (h.shape = /*cast*/
      r[9](
        /*editable*/
        r[19].target.selector
      )), s & /*scale*/
      262144 && (h.viewportScale = /*scale*/
      r[18]), s & /*editableAnnotations*/
      4 && i !== (i = Es(
        /*editable*/
        r[19].target.selector
      ))) {
        if (t) {
          Xe();
          const u = t;
          bt(u.$$.fragment, 1, 0, () => {
            Jt(u, 1);
          }), je();
        }
        i ? (t = _i(i, o(r)), t.$on(
          "grab",
          /*onGrab*/
          r[5]
        ), t.$on("change", function() {
          Gt(
            /*onChangeSelected*/
            r[7](
              /*editable*/
              r[19]
            )
          ) && r[7](
            /*editable*/
            r[19]
          ).apply(this, arguments);
        }), t.$on(
          "release",
          /*onRelease*/
          r[6]
        ), ee(t.$$.fragment), ct(t.$$.fragment, 1), Zt(t, e.parentNode, e)) : t = null;
      } else
        i && t.$set(h);
    },
    i(a) {
      n || (t && ct(t.$$.fragment, a), n = !0);
    },
    o(a) {
      t && bt(t.$$.fragment, a), n = !1;
    },
    d(a) {
      a && K(e), t && Jt(t, a);
    }
  };
}
function Fx(r) {
  let t, e, n, i, o, a, s;
  const h = [Dx, Mx], u = [];
  function l(f, c) {
    return c & /*tool*/
    1 && (n = null), /*editableAnnotations*/
    f[2] ? 0 : (n == null && (n = !!/*tool*/
    f[0]), n ? 1 : -1);
  }
  return ~(i = l(r, -1)) && (o = u[i] = h[i](r)), {
    c() {
      t = ft("svg"), e = ft("g"), o && o.c(), S(e, "transform", a = /*transform*/
      r[17]), S(e, "class", "svelte-190cqdf"), S(t, "class", "a9s-annotationlayer a9s-osd-drawinglayer svelte-190cqdf"), vs(
        t,
        "drawing",
        /*tool*/
        r[0]
      );
    },
    m(f, c) {
      Z(f, t, c), ir(t, e), ~i && u[i].m(e, null), s = !0;
    },
    p(f, c) {
      let d = i;
      i = l(f, c), i === d ? ~i && u[i].p(f, c) : (o && (Xe(), bt(u[d], 1, 1, () => {
        u[d] = null;
      }), je()), ~i ? (o = u[i], o ? o.p(f, c) : (o = u[i] = h[i](f), o.c()), ct(o, 1), o.m(e, null)) : o = null), (!s || c & /*transform*/
      131072 && a !== (a = /*transform*/
      f[17])) && S(e, "transform", a), (!s || c & /*tool*/
      1) && vs(
        t,
        "drawing",
        /*tool*/
        f[0]
      );
    },
    i(f) {
      s || (ct(o), s = !0);
    },
    o(f) {
      bt(o), s = !1;
    },
    d(f) {
      f && K(t), ~i && u[i].d();
    }
  };
}
function Bx(r) {
  let t, e;
  return t = new zl({
    props: {
      viewer: (
        /*viewer*/
        r[1]
      ),
      $$slots: {
        default: [
          Fx,
          ({ transform: n, scale: i }) => ({ 17: n, 18: i }),
          ({ transform: n, scale: i }) => (n ? 131072 : 0) | (i ? 262144 : 0)
        ]
      },
      $$scope: { ctx: r }
    }
  }), {
    c() {
      ee(t.$$.fragment);
    },
    m(n, i) {
      Zt(t, n, i), e = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*viewer*/
      2 && (o.viewer = /*viewer*/
      n[1]), i & /*$$scope, tool, transform, editableAnnotations, scale*/
      4587525 && (o.$$scope = { dirty: i, ctx: n }), t.$set(o);
    },
    i(n) {
      e || (ct(t.$$.fragment, n), e = !0);
    },
    o(n) {
      bt(t.$$.fragment, n), e = !1;
    },
    d(n) {
      Jt(t, n);
    }
  };
}
function Nx(r, t, e) {
  let n, { state: i } = t, { viewer: o } = t, { user: a } = t, { tool: s = null } = t, { keepEnabled: h = !1 } = t;
  const { store: u, selection: l } = i;
  wu(r, l, (x) => e(13, n = x));
  let f = null, c = null;
  const d = (x) => {
    u.unobserve(f);
    const T = x.filter(({ editable: E }) => E).map(({ id: E }) => E);
    T.length > 0 ? (e(2, c = T.map((E) => u.getAnnotation(E))), f = (E) => {
      const { updated: P } = E.changes;
      e(2, c = P.map((b) => b.newValue));
    }, u.observe(f, { annotations: T })) : e(2, c = null);
  }, p = (x, T) => {
    const { x: E, y: P } = o.viewport.viewerElementToImageCoordinates(new vi.Point(x, T));
    return [E, P];
  }, v = () => o.setMouseNavEnabled(!1), _ = () => o.setMouseNavEnabled(!0), m = (x) => (T) => {
    var w;
    const { target: E } = x, P = 10 * 60 * 1e3, b = ((w = E.creator) == null ? void 0 : w.id) !== a.id || !E.created || (/* @__PURE__ */ new Date()).getTime() - E.created.getTime() > P;
    u.updateTarget({
      ...E,
      selector: T.detail,
      created: b ? E.created : /* @__PURE__ */ new Date(),
      updated: b ? /* @__PURE__ */ new Date() : null,
      updatedBy: b ? a : null
    });
  }, y = (x) => {
    const T = Mu(), E = {
      id: T,
      bodies: [],
      target: {
        annotation: T,
        selector: x.detail,
        creator: a,
        created: /* @__PURE__ */ new Date()
      }
    };
    u.addAnnotation(E), l.setSelected(E.id), o.setMouseNavEnabled(!0), h || e(0, s = null);
  }, g = (x) => x;
  return r.$$set = (x) => {
    "state" in x && e(10, i = x.state), "viewer" in x && e(1, o = x.viewer), "user" in x && e(11, a = x.user), "tool" in x && e(0, s = x.tool), "keepEnabled" in x && e(12, h = x.keepEnabled);
  }, r.$$.update = () => {
    r.$$.dirty & /*tool, viewer*/
    3 && (s ? o.setMouseNavEnabled(!1) : o.setMouseNavEnabled(!0)), r.$$.dirty & /*tool*/
    1 && s && l.clear(), r.$$.dirty & /*$selection, keepEnabled, tool, viewer*/
    12291 && n.selected.length === 0 && h && s && o.setMouseNavEnabled(!1), r.$$.dirty & /*$selection*/
    8192 && d(n.selected);
  }, [
    s,
    o,
    c,
    l,
    p,
    v,
    _,
    m,
    y,
    g,
    i,
    a,
    h,
    n
  ];
}
class Lx extends ne {
  constructor(t) {
    super(), re(this, t, Nx, Bx, te, {
      state: 10,
      viewer: 1,
      user: 11,
      tool: 0,
      keepEnabled: 12
    });
  }
}
function Ux(r) {
  let t, e, n, i, o, a, s, h = (
    /*user*/
    r[2].appearance.label + ""
  ), u, l, f, c;
  return {
    c() {
      t = ft("g"), e = ft("rect"), s = ft("text"), u = Na(h), S(e, "class", "a9s-presence-label-bg svelte-1rehw2p"), S(
        e,
        "x",
        /*x*/
        r[0]
      ), S(e, "y", n = /*y*/
      r[1] - 18 / /*scale*/
      r[3]), S(e, "height", i = 18 / /*scale*/
      r[3]), S(e, "fill", o = /*user*/
      r[2].appearance.color), S(e, "stroke", a = /*user*/
      r[2].appearance.color), S(s, "font-size", l = 12 / /*scale*/
      r[3]), S(s, "x", f = /*x*/
      r[0] + Math.round(5 / /*scale*/
      r[3])), S(s, "y", c = /*y*/
      r[1] - 5 / /*scale*/
      r[3]), S(s, "class", "svelte-1rehw2p"), S(t, "class", "a9s-presence-label");
    },
    m(d, p) {
      Z(d, t, p), ir(t, e), ir(t, s), ir(s, u), r[6](t);
    },
    p(d, [p]) {
      p & /*x*/
      1 && S(
        e,
        "x",
        /*x*/
        d[0]
      ), p & /*y, scale*/
      10 && n !== (n = /*y*/
      d[1] - 18 / /*scale*/
      d[3]) && S(e, "y", n), p & /*scale*/
      8 && i !== (i = 18 / /*scale*/
      d[3]) && S(e, "height", i), p & /*user*/
      4 && o !== (o = /*user*/
      d[2].appearance.color) && S(e, "fill", o), p & /*user*/
      4 && a !== (a = /*user*/
      d[2].appearance.color) && S(e, "stroke", a), p & /*user*/
      4 && h !== (h = /*user*/
      d[2].appearance.label + "") && hf(u, h), p & /*scale*/
      8 && l !== (l = 12 / /*scale*/
      d[3]) && S(s, "font-size", l), p & /*x, scale*/
      9 && f !== (f = /*x*/
      d[0] + Math.round(5 / /*scale*/
      d[3])) && S(s, "x", f), p & /*y, scale*/
      10 && c !== (c = /*y*/
      d[1] - 5 / /*scale*/
      d[3]) && S(s, "y", c);
    },
    i: Kt,
    o: Kt,
    d(d) {
      d && K(t), r[6](null);
    }
  };
}
function Gx(r, t, e) {
  let { x: n } = t, { y: i } = t, { user: o } = t, { scale: a } = t, { hAlign: s = null } = t, h;
  const u = (f) => {
    const c = h.querySelector("text"), d = h.querySelector("rect"), p = c.getBBox().width + 10 / f;
    s === "CENTER" && h.setAttribute("style", `transform: translateX(-${p / 2}px)`), d.setAttribute("width", `${p}`);
  };
  function l(f) {
    dn[f ? "unshift" : "push"](() => {
      h = f, e(4, h);
    });
  }
  return r.$$set = (f) => {
    "x" in f && e(0, n = f.x), "y" in f && e(1, i = f.y), "user" in f && e(2, o = f.user), "scale" in f && e(3, a = f.scale), "hAlign" in f && e(5, s = f.hAlign);
  }, r.$$.update = () => {
    r.$$.dirty & /*g, scale*/
    24 && h && u(a);
  }, [n, i, o, a, h, s, l];
}
class Wl extends ne {
  constructor(t) {
    super(), re(this, t, Gx, Ux, te, { x: 0, y: 1, user: 2, scale: 3, hAlign: 5 });
  }
}
function kx(r) {
  let t, e, n, i, o, a;
  return e = new Wl({
    props: {
      scale: (
        /*scale*/
        r[1]
      ),
      user: (
        /*user*/
        r[0]
      ),
      x: (
        /*origin*/
        r[3][0]
      ),
      y: (
        /*origin*/
        r[3][1]
      ),
      hAlign: "CENTER"
    }
  }), {
    c() {
      t = ft("g"), ee(e.$$.fragment), n = ft("polygon"), S(n, "class", "a9s-presence-shape a9s-presence-polygon svelte-fgq4n0"), S(n, "stroke", i = /*user*/
      r[0].appearance.color), S(n, "fill", "transparent"), S(n, "points", o = /*geom*/
      r[2].points.map(hu).join(" ")), S(t, "class", "a9s-presence-overlay");
    },
    m(s, h) {
      Z(s, t, h), Zt(e, t, null), ir(t, n), a = !0;
    },
    p(s, [h]) {
      const u = {};
      h & /*scale*/
      2 && (u.scale = /*scale*/
      s[1]), h & /*user*/
      1 && (u.user = /*user*/
      s[0]), h & /*origin*/
      8 && (u.x = /*origin*/
      s[3][0]), h & /*origin*/
      8 && (u.y = /*origin*/
      s[3][1]), e.$set(u), (!a || h & /*user*/
      1 && i !== (i = /*user*/
      s[0].appearance.color)) && S(n, "stroke", i), (!a || h & /*geom*/
      4 && o !== (o = /*geom*/
      s[2].points.map(hu).join(" "))) && S(n, "points", o);
    },
    i(s) {
      a || (ct(e.$$.fragment, s), a = !0);
    },
    o(s) {
      bt(e.$$.fragment, s), a = !1;
    },
    d(s) {
      s && K(t), Jt(e);
    }
  };
}
const hu = (r) => r.join(",");
function Hx(r, t, e) {
  let n, i, { annotation: o } = t, { user: a } = t, { scale: s } = t;
  const h = (u) => {
    let [l, ...f] = u.points;
    return f.forEach(([c, d]) => {
      d < l[1] && (l = [c, d]);
    }), l;
  };
  return r.$$set = (u) => {
    "annotation" in u && e(4, o = u.annotation), "user" in u && e(0, a = u.user), "scale" in u && e(1, s = u.scale);
  }, r.$$.update = () => {
    r.$$.dirty & /*annotation*/
    16 && e(2, n = o.target.selector.geometry), r.$$.dirty & /*geom*/
    4 && e(3, i = h(n));
  }, [a, s, n, i, o];
}
class Xx extends ne {
  constructor(t) {
    super(), re(this, t, Hx, kx, te, { annotation: 4, user: 0, scale: 1 });
  }
}
function jx(r) {
  let t, e, n, i, o, a, s, h, u;
  return e = new Wl({
    props: {
      scale: (
        /*scale*/
        r[1]
      ),
      user: (
        /*user*/
        r[0]
      ),
      x: (
        /*geom*/
        r[2].x
      ),
      y: (
        /*geom*/
        r[2].y
      )
    }
  }), {
    c() {
      t = ft("g"), ee(e.$$.fragment), n = ft("rect"), S(n, "class", "a9s-presence-shape a9s-presence-rectangle svelte-gze948"), S(n, "stroke", i = /*user*/
      r[0].appearance.color), S(n, "fill", "transparent"), S(n, "x", o = /*geom*/
      r[2].x), S(n, "y", a = /*geom*/
      r[2].y), S(n, "width", s = /*geom*/
      r[2].w), S(n, "height", h = /*geom*/
      r[2].h), S(t, "class", "a9s-presence-overlay");
    },
    m(l, f) {
      Z(l, t, f), Zt(e, t, null), ir(t, n), u = !0;
    },
    p(l, [f]) {
      const c = {};
      f & /*scale*/
      2 && (c.scale = /*scale*/
      l[1]), f & /*user*/
      1 && (c.user = /*user*/
      l[0]), f & /*geom*/
      4 && (c.x = /*geom*/
      l[2].x), f & /*geom*/
      4 && (c.y = /*geom*/
      l[2].y), e.$set(c), (!u || f & /*user*/
      1 && i !== (i = /*user*/
      l[0].appearance.color)) && S(n, "stroke", i), (!u || f & /*geom*/
      4 && o !== (o = /*geom*/
      l[2].x)) && S(n, "x", o), (!u || f & /*geom*/
      4 && a !== (a = /*geom*/
      l[2].y)) && S(n, "y", a), (!u || f & /*geom*/
      4 && s !== (s = /*geom*/
      l[2].w)) && S(n, "width", s), (!u || f & /*geom*/
      4 && h !== (h = /*geom*/
      l[2].h)) && S(n, "height", h);
    },
    i(l) {
      u || (ct(e.$$.fragment, l), u = !0);
    },
    o(l) {
      bt(e.$$.fragment, l), u = !1;
    },
    d(l) {
      l && K(t), Jt(e);
    }
  };
}
function Yx(r, t, e) {
  let n, { annotation: i } = t, { user: o } = t, { scale: a } = t;
  return r.$$set = (s) => {
    "annotation" in s && e(3, i = s.annotation), "user" in s && e(0, o = s.user), "scale" in s && e(1, a = s.scale);
  }, r.$$.update = () => {
    r.$$.dirty & /*annotation*/
    8 && e(2, n = i.target.selector.geometry);
  }, [o, a, n, i];
}
class Vx extends ne {
  constructor(t) {
    super(), re(this, t, Yx, jx, te, { annotation: 3, user: 0, scale: 1 });
  }
}
const { Boolean: zx } = Iu;
function uu(r, t, e) {
  const n = r.slice();
  return n[8] = t[e], n;
}
function lu(r) {
  let t, e;
  return t = new zl({
    props: {
      viewer: (
        /*viewer*/
        r[0]
      ),
      $$slots: {
        default: [
          qx,
          ({ transform: n, scale: i }) => ({ 6: n, 7: i }),
          ({ transform: n, scale: i }) => (n ? 64 : 0) | (i ? 128 : 0)
        ]
      },
      $$scope: { ctx: r }
    }
  }), {
    c() {
      ee(t.$$.fragment);
    },
    m(n, i) {
      Zt(t, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i & /*viewer*/
      1 && (o.viewer = /*viewer*/
      n[0]), i & /*$$scope, transform, trackedAnnotations, scale*/
      2244 && (o.$$scope = { dirty: i, ctx: n }), t.$set(o);
    },
    i(n) {
      e || (ct(t.$$.fragment, n), e = !0);
    },
    o(n) {
      bt(t.$$.fragment, n), e = !1;
    },
    d(n) {
      Jt(t, n);
    }
  };
}
function fu(r) {
  let t, e, n = (
    /*trackedAnnotations*/
    r[2]
  ), i = [];
  for (let a = 0; a < n.length; a += 1)
    i[a] = cu(uu(r, n, a));
  const o = (a) => bt(i[a], 1, 1, () => {
    i[a] = null;
  });
  return {
    c() {
      for (let a = 0; a < i.length; a += 1)
        i[a].c();
      t = He();
    },
    m(a, s) {
      for (let h = 0; h < i.length; h += 1)
        i[h] && i[h].m(a, s);
      Z(a, t, s), e = !0;
    },
    p(a, s) {
      if (s & /*trackedAnnotations, scale, ShapeType*/
      132) {
        n = /*trackedAnnotations*/
        a[2];
        let h;
        for (h = 0; h < n.length; h += 1) {
          const u = uu(a, n, h);
          i[h] ? (i[h].p(u, s), ct(i[h], 1)) : (i[h] = cu(u), i[h].c(), ct(i[h], 1), i[h].m(t.parentNode, t));
        }
        for (Xe(), h = n.length; h < i.length; h += 1)
          o(h);
        je();
      }
    },
    i(a) {
      if (!e) {
        for (let s = 0; s < n.length; s += 1)
          ct(i[s]);
        e = !0;
      }
    },
    o(a) {
      i = i.filter(zx);
      for (let s = 0; s < i.length; s += 1)
        bt(i[s]);
      e = !1;
    },
    d(a) {
      Ba(i, a), a && K(t);
    }
  };
}
function Wx(r) {
  let t, e;
  return t = new Xx({
    props: {
      annotation: (
        /*tracked*/
        r[8].annotation
      ),
      user: (
        /*tracked*/
        r[8].selectedBy
      ),
      scale: (
        /*scale*/
        r[7]
      )
    }
  }), {
    c() {
      ee(t.$$.fragment);
    },
    m(n, i) {
      Zt(t, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i & /*trackedAnnotations*/
      4 && (o.annotation = /*tracked*/
      n[8].annotation), i & /*trackedAnnotations*/
      4 && (o.user = /*tracked*/
      n[8].selectedBy), i & /*scale*/
      128 && (o.scale = /*scale*/
      n[7]), t.$set(o);
    },
    i(n) {
      e || (ct(t.$$.fragment, n), e = !0);
    },
    o(n) {
      bt(t.$$.fragment, n), e = !1;
    },
    d(n) {
      Jt(t, n);
    }
  };
}
function $x(r) {
  let t, e;
  return t = new Vx({
    props: {
      annotation: (
        /*tracked*/
        r[8].annotation
      ),
      user: (
        /*tracked*/
        r[8].selectedBy
      ),
      scale: (
        /*scale*/
        r[7]
      )
    }
  }), {
    c() {
      ee(t.$$.fragment);
    },
    m(n, i) {
      Zt(t, n, i), e = !0;
    },
    p(n, i) {
      const o = {};
      i & /*trackedAnnotations*/
      4 && (o.annotation = /*tracked*/
      n[8].annotation), i & /*trackedAnnotations*/
      4 && (o.user = /*tracked*/
      n[8].selectedBy), i & /*scale*/
      128 && (o.scale = /*scale*/
      n[7]), t.$set(o);
    },
    i(n) {
      e || (ct(t.$$.fragment, n), e = !0);
    },
    o(n) {
      bt(t.$$.fragment, n), e = !1;
    },
    d(n) {
      Jt(t, n);
    }
  };
}
function cu(r) {
  let t, e, n, i;
  const o = [$x, Wx], a = [];
  function s(h, u) {
    return (
      /*tracked*/
      h[8].annotation.target.selector.type === $t.RECTANGLE ? 0 : (
        /*tracked*/
        h[8].annotation.target.selector.type === $t.POLYGON ? 1 : -1
      )
    );
  }
  return ~(t = s(r)) && (e = a[t] = o[t](r)), {
    c() {
      e && e.c(), n = He();
    },
    m(h, u) {
      ~t && a[t].m(h, u), Z(h, n, u), i = !0;
    },
    p(h, u) {
      let l = t;
      t = s(h), t === l ? ~t && a[t].p(h, u) : (e && (Xe(), bt(a[l], 1, 1, () => {
        a[l] = null;
      }), je()), ~t ? (e = a[t], e ? e.p(h, u) : (e = a[t] = o[t](h), e.c()), ct(e, 1), e.m(n.parentNode, n)) : e = null);
    },
    i(h) {
      i || (ct(e), i = !0);
    },
    o(h) {
      bt(e), i = !1;
    },
    d(h) {
      ~t && a[t].d(h), h && K(n);
    }
  };
}
function qx(r) {
  let t, e, n, i, o = (
    /*trackedAnnotations*/
    r[2].length > 0 && fu(r)
  );
  return {
    c() {
      t = ft("svg"), e = ft("g"), o && o.c(), S(e, "transform", n = /*transform*/
      r[6]), S(t, "class", "a9s-osd-presencelayer svelte-1krwc4m");
    },
    m(a, s) {
      Z(a, t, s), ir(t, e), o && o.m(e, null), i = !0;
    },
    p(a, s) {
      /*trackedAnnotations*/
      a[2].length > 0 ? o ? (o.p(a, s), s & /*trackedAnnotations*/
      4 && ct(o, 1)) : (o = fu(a), o.c(), ct(o, 1), o.m(e, null)) : o && (Xe(), bt(o, 1, 1, () => {
        o = null;
      }), je()), (!i || s & /*transform*/
      64 && n !== (n = /*transform*/
      a[6])) && S(e, "transform", n);
    },
    i(a) {
      i || (ct(o), i = !0);
    },
    o(a) {
      bt(o), i = !1;
    },
    d(a) {
      a && K(t), o && o.d();
    }
  };
}
function Kx(r) {
  let t = !!/*provider*/
  r[1], e, n, i = t && lu(r);
  return {
    c() {
      i && i.c(), e = He();
    },
    m(o, a) {
      i && i.m(o, a), Z(o, e, a), n = !0;
    },
    p(o, [a]) {
      a & /*provider*/
      2 && (t = !!/*provider*/
      o[1]), t ? i ? (i.p(o, a), a & /*provider*/
      2 && ct(i, 1)) : (i = lu(o), i.c(), ct(i, 1), i.m(e.parentNode, e)) : i && (Xe(), bt(i, 1, 1, () => {
        i = null;
      }), je());
    },
    i(o) {
      n || (ct(i), n = !0);
    },
    o(o) {
      bt(i), n = !1;
    },
    d(o) {
      i && i.d(o), o && K(e);
    }
  };
}
function Zx(r, t, e) {
  let { store: n } = t, { viewer: i } = t, { provider: o = null } = t, a = [], s = null;
  const h = (u, l) => {
    e(2, a = [
      ...a.filter(({ selectedBy: f }) => f.presenceKey !== u.presenceKey),
      ...(l || []).map((f) => ({
        // Warning - could be undefined!
        annotation: n.getAnnotation(f),
        selectedBy: u
      }))
    ].filter(({ annotation: f }) => (f || console.warn("Selection event on unknown annotation"), !!f))), s && n.unobserve(s), s = (f) => {
      const { deleted: c, updated: d } = f.changes, p = new Set(c.map((_) => _.id)), v = a.filter(({ annotation: _ }) => !p.has(_.id)).map((_) => {
        const m = d.find((y) => y.oldValue.id === _.annotation.id);
        return m ? {
          selectedBy: _.selectedBy,
          annotation: m.newValue
        } : _;
      });
      e(2, a = v);
    }, n.observe(s, {
      annotations: a.map((f) => f.annotation.id)
    });
  };
  return lf(() => {
    s && n.unobserve(s);
  }), r.$$set = (u) => {
    "store" in u && e(3, n = u.store), "viewer" in u && e(0, i = u.viewer), "provider" in u && e(1, o = u.provider);
  }, r.$$.update = () => {
    r.$$.dirty & /*provider*/
    2 && o && o.on("selectionChange", h);
  }, [i, o, a, n];
}
class Jx extends ne {
  constructor(t) {
    super(), re(this, t, Zx, Kx, te, { store: 3, viewer: 0, provider: 1 });
  }
}
const Qx = (r, t, e) => {
  const n = () => {
    const { selected: i } = t;
    if (i) {
      const o = i.filter((a) => a.editable);
      o.length > 0 && e.bulkDeleteAnnotation(o.map((a) => a.id));
    }
  };
  r.addEventListener("keydown", (i) => {
    i.key === "Delete" && n();
  });
}, t1 = (r) => {
  r.addHandler("open", (t) => {
    const e = r.world.getItemCount();
    r.world.getItemAt(e - 1).addOnceHandler("fully-loaded-change", (i) => {
      const { fullyLoaded: o } = i;
      if (o) {
        const a = r.canvas.querySelector("canvas");
        Sc(a, r.element);
      }
    });
  });
}, $l = (r, t, e) => (n, i = {}) => {
  const o = typeof n == "string" ? n : n.id, a = t.getAnnotation(o);
  if (!a)
    return;
  const s = r.container.getBoundingClientRect(), { padding: h } = i;
  let [u, l, f, c] = h ? Array.isArray(h) ? h : [h, h, h, h] : [0, 0, 0, 0];
  u = u / s.height, l = l / s.width, f = f / s.height, c = c / s.width;
  const { minX: d, minY: p, maxX: v, maxY: _ } = a.target.selector.geometry.bounds, m = v - d, y = _ - p, g = d - c * m, x = p - u * y, T = m + (l + c) * m, E = y + (u + f) * y, P = r.viewport.imageToViewportRectangle(g, x, T, E);
  r.viewport[e](P, i.immediately);
}, e1 = (r, t) => $l(r, t, "fitBounds"), r1 = (r, t) => $l(r, t, "fitBoundsWithConstraints");
const rT = (r, t = {}) => {
  const e = Ac(t), n = Ec(e), { hover: i, selection: o, store: a } = n, s = Df(
    a,
    o,
    i,
    void 0,
    e.adapter,
    e.autoSave
  );
  let h = e.style, u = e.readOnly ? null : kf();
  Qx(r.element, o, a);
  const l = new Px({
    target: r.element,
    props: { state: n, viewer: r, style: h }
  }), f = new Jx({
    target: r.element.querySelector(".openseadragon-canvas"),
    props: { store: a, viewer: r, provider: null }
  }), c = new Lx({
    target: r.element.querySelector(".openseadragon-canvas"),
    props: { state: n, viewer: r, user: u }
  });
  l.$on("click", (b) => {
    const { originalEvent: w, annotation: A } = b.detail;
    A ? o.clickSelect(A.id, w) : o.isEmpty() || o.clear();
  }), r.element.addEventListener("pointerdown", (b) => {
    if (i.current) {
      const w = a.getAnnotation(i.current);
      s.emit("clickAnnotation", w, b);
    }
  }), t1(r);
  const d = Bf(a, e.adapter), p = (b) => {
    h = b, l.$set({ style: b });
  }, v = () => {
    l.$destroy(), f.$destroy(), c.$destroy();
  }, _ = e1(r, a), m = r1(r, a), y = () => u, g = (b) => {
    b ? o.setSelected(b) : o.clear();
  }, x = (b) => f.$set({ provider: b }), T = (b) => {
    u = b, c.$set({ user: b });
  }, E = (b, w = !1) => {
    const A = dc(b);
    c.$set({ tool: A, keepEnabled: w });
  }, P = () => {
    c.$set({ tool: null });
  };
  return {
    ...d,
    get style() {
      return h;
    },
    set style(b) {
      p(b);
    },
    destroy: v,
    fitBounds: _,
    fitBoundsWithConstraints: m,
    getUser: y,
    listTools: cc,
    on: s.on,
    off: s.off,
    setPresenceProvider: x,
    setSelected: g,
    setUser: T,
    startDrawing: E,
    state: n,
    stopDrawing: P,
    viewer: r
  };
};
function Ma() {
}
function n1(r, t) {
  for (const e in t)
    r[e] = t[e];
  return r;
}
function ql(r) {
  return r();
}
function du() {
  return /* @__PURE__ */ Object.create(null);
}
function pr(r) {
  r.forEach(ql);
}
function Vt(r) {
  return typeof r == "function";
}
function rs(r, t) {
  return r != r ? t == t : r !== t || r && typeof r == "object" || typeof r == "function";
}
function i1(r) {
  return Object.keys(r).length === 0;
}
function o1(r, t, e, n) {
  if (r) {
    const i = Kl(r, t, e, n);
    return r[0](i);
  }
}
function Kl(r, t, e, n) {
  return r[1] && n ? n1(e.ctx.slice(), r[1](n(t))) : e.ctx;
}
function a1(r, t, e, n) {
  if (r[2] && n) {
    const i = r[2](n(e));
    if (t.dirty === void 0)
      return i;
    if (typeof i == "object") {
      const o = [], a = Math.max(t.dirty.length, i.length);
      for (let s = 0; s < a; s += 1)
        o[s] = t.dirty[s] | i[s];
      return o;
    }
    return t.dirty | i;
  }
  return t.dirty;
}
function s1(r, t, e, n, i, o) {
  if (i) {
    const a = Kl(t, e, n, o);
    r.p(a, i);
  }
}
function h1(r) {
  if (r.ctx.length > 32) {
    const t = [], e = r.ctx.length / 32;
    for (let n = 0; n < e; n++)
      t[n] = -1;
    return t;
  }
  return -1;
}
function gt(r, t, e) {
  r.insertBefore(t, e || null);
}
function yt(r) {
  r.parentNode && r.parentNode.removeChild(r);
}
function u1(r, t) {
  for (let e = 0; e < r.length; e += 1)
    r[e] && r[e].d(t);
}
function Wt(r) {
  return document.createElementNS("http://www.w3.org/2000/svg", r);
}
function Zl(r) {
  return document.createTextNode(r);
}
function he() {
  return Zl(" ");
}
function l1() {
  return Zl("");
}
function zt(r, t, e, n) {
  return r.addEventListener(t, e, n), () => r.removeEventListener(t, e, n);
}
function I(r, t, e) {
  e == null ? r.removeAttribute(t) : r.getAttribute(t) !== e && r.setAttribute(t, e);
}
function f1(r) {
  return Array.from(r.childNodes);
}
function c1(r, t, { bubbles: e = !1, cancelable: n = !1 } = {}) {
  const i = document.createEvent("CustomEvent");
  return i.initCustomEvent(r, e, n, t), i;
}
let wn;
function fn(r) {
  wn = r;
}
function d1() {
  if (!wn)
    throw new Error("Function called outside component initialization");
  return wn;
}
function p1() {
  const r = d1();
  return (t, e, { cancelable: n = !1 } = {}) => {
    const i = r.$$.callbacks[t];
    if (i) {
      const o = c1(t, e, { cancelable: n });
      return i.slice().forEach((a) => {
        a.call(r, o);
      }), !o.defaultPrevented;
    }
    return !0;
  };
}
function Ur(r, t) {
  const e = r.$$.callbacks[t.type];
  e && e.slice().forEach((n) => n.call(this, t));
}
const Pr = [], pu = [];
let Gr = [];
const vu = [], v1 = /* @__PURE__ */ Promise.resolve();
let Da = !1;
function _1() {
  Da || (Da = !0, v1.then(Jl));
}
function Fa(r) {
  Gr.push(r);
}
const Lo = /* @__PURE__ */ new Set();
let Er = 0;
function Jl() {
  if (Er !== 0)
    return;
  const r = wn;
  do {
    try {
      for (; Er < Pr.length; ) {
        const t = Pr[Er];
        Er++, fn(t), m1(t.$$);
      }
    } catch (t) {
      throw Pr.length = 0, Er = 0, t;
    }
    for (fn(null), Pr.length = 0, Er = 0; pu.length; )
      pu.pop()();
    for (let t = 0; t < Gr.length; t += 1) {
      const e = Gr[t];
      Lo.has(e) || (Lo.add(e), e());
    }
    Gr.length = 0;
  } while (Pr.length);
  for (; vu.length; )
    vu.pop()();
  Da = !1, Lo.clear(), fn(r);
}
function m1(r) {
  if (r.fragment !== null) {
    r.update(), pr(r.before_update);
    const t = r.dirty;
    r.dirty = [-1], r.fragment && r.fragment.p(r.ctx, t), r.after_update.forEach(Fa);
  }
}
function y1(r) {
  const t = [], e = [];
  Gr.forEach((n) => r.indexOf(n) === -1 ? t.push(n) : e.push(n)), e.forEach((n) => n()), Gr = t;
}
const pi = /* @__PURE__ */ new Set();
let g1;
function Hi(r, t) {
  r && r.i && (pi.delete(r), r.i(t));
}
function ns(r, t, e, n) {
  if (r && r.o) {
    if (pi.has(r))
      return;
    pi.add(r), g1.c.push(() => {
      pi.delete(r), n && (e && r.d(1), n());
    }), r.o(t);
  } else
    n && n();
}
function Ql(r) {
  r && r.c();
}
function is(r, t, e, n) {
  const { fragment: i, after_update: o } = r.$$;
  i && i.m(t, e), n || Fa(() => {
    const a = r.$$.on_mount.map(ql).filter(Vt);
    r.$$.on_destroy ? r.$$.on_destroy.push(...a) : pr(a), r.$$.on_mount = [];
  }), o.forEach(Fa);
}
function os(r, t) {
  const e = r.$$;
  e.fragment !== null && (y1(e.after_update), pr(e.on_destroy), e.fragment && e.fragment.d(t), e.on_destroy = e.fragment = null, e.ctx = []);
}
function b1(r, t) {
  r.$$.dirty[0] === -1 && (Pr.push(r), _1(), r.$$.dirty.fill(0)), r.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function as(r, t, e, n, i, o, a, s = [-1]) {
  const h = wn;
  fn(r);
  const u = r.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: o,
    update: Ma,
    not_equal: i,
    bound: du(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(t.context || (h ? h.$$.context : [])),
    // everything else
    callbacks: du(),
    dirty: s,
    skip_bound: !1,
    root: t.target || h.$$.root
  };
  a && a(u.root);
  let l = !1;
  if (u.ctx = e ? e(r, t.props || {}, (f, c, ...d) => {
    const p = d.length ? d[0] : c;
    return u.ctx && i(u.ctx[f], u.ctx[f] = p) && (!u.skip_bound && u.bound[f] && u.bound[f](p), l && b1(r, f)), c;
  }) : [], u.update(), l = !0, pr(u.before_update), u.fragment = n ? n(u.ctx) : !1, t.target) {
    if (t.hydrate) {
      const f = f1(t.target);
      u.fragment && u.fragment.l(f), f.forEach(yt);
    } else
      u.fragment && u.fragment.c();
    t.intro && Hi(r.$$.fragment), is(r, t.target, t.anchor, t.customElement), Jl();
  }
  fn(h);
}
class ss {
  $destroy() {
    os(this, 1), this.$destroy = Ma;
  }
  $on(t, e) {
    if (!Vt(e))
      return Ma;
    const n = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
    return n.push(e), () => {
      const i = n.indexOf(e);
      i !== -1 && n.splice(i, 1);
    };
  }
  $set(t) {
    this.$$set && !i1(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
  }
}
var Qt = /* @__PURE__ */ ((r) => (r.ELLIPSE = "ELLIPSE", r.POLYGON = "POLYGON", r.RECTANGLE = "RECTANGLE", r))(Qt || {});
const hs = (r, t) => t, tf = (r) => {
  let t = 1 / 0, e = 1 / 0, n = -1 / 0, i = -1 / 0;
  return r.forEach(([o, a]) => {
    t = Math.min(t, o), e = Math.min(e, a), n = Math.max(n, o), i = Math.max(i, a);
  }), { minX: t, minY: e, maxX: n, maxY: i };
}, x1 = {
  area: (r) => Math.PI * r.geometry.rx * r.geometry.ry,
  intersects: (r, t, e) => {
    const { cx: n, cy: i, rx: o, ry: a } = r.geometry, s = 0, h = Math.cos(s), u = Math.sin(s), l = t - n, f = e - i, c = h * l + u * f, d = u * l - h * f;
    return c * c / (o * o) + d * d / (a * a) <= 1;
  }
};
hs(Qt.ELLIPSE, x1);
const T1 = {
  area: (r) => {
    const { points: t } = r.geometry;
    let e = 0, n = t.length - 1;
    for (let i = 0; i < t.length; i++)
      e += (t[n][0] + t[i][0]) * (t[n][1] - t[i][1]), n = i;
    return Math.abs(0.5 * e);
  },
  intersects: (r, t, e) => {
    const { points: n } = r.geometry;
    let i = !1;
    for (let o = 0, a = n.length - 1; o < n.length; a = o++) {
      const s = n[o][0], h = n[o][1], u = n[a][0], l = n[a][1];
      h > e != l > e && t < (u - s) * (e - h) / (l - h) + s && (i = !i);
    }
    return i;
  }
};
hs(Qt.POLYGON, T1);
const E1 = {
  area: (r) => r.geometry.w * r.geometry.h,
  intersects: (r, t, e) => t >= r.geometry.x && t <= r.geometry.x + r.geometry.w && e >= r.geometry.y && e <= r.geometry.y + r.geometry.h
};
hs(Qt.RECTANGLE, E1);
const w1 = (r, t = !1) => {
  const e = typeof r == "string" ? r : r.value, n = /^(xywh)=(pixel|percent)?:?(.+?),(.+?),(.+?),(.+)*/g, i = [...e.matchAll(n)][0], [o, a, s, h, u, l, f] = i;
  if (a !== "xywh")
    throw new Error("Unsupported MediaFragment: " + e);
  if (s && s !== "pixel")
    throw new Error(`Unsupported MediaFragment unit: ${s}`);
  const [c, d, p, v] = [h, u, l, f].map(parseFloat);
  return {
    type: Qt.RECTANGLE,
    geometry: {
      x: c,
      y: d,
      w: p,
      h: v,
      bounds: {
        minX: c,
        minY: t ? d - v : d,
        maxX: c + p,
        maxY: t ? d : d + v
      }
    }
  };
}, S1 = (r) => {
  const { x: t, y: e, w: n, h: i } = r;
  return {
    type: "FragmentSelector",
    conformsTo: "http://www.w3.org/TR/media-frags/",
    value: `xywh=pixel:${t},${e},${n},${i}`
  };
}, ef = "http://www.w3.org/2000/svg", _u = (r) => {
  const t = (n) => {
    Array.from(n.attributes).forEach((i) => {
      i.name.startsWith("on") && n.removeAttribute(i.name);
    });
  }, e = r.getElementsByTagName("script");
  return Array.from(e).reverse().forEach((n) => n.parentNode.removeChild(n)), Array.from(r.querySelectorAll("*")).forEach(t), r;
}, A1 = (r) => {
  const t = new XMLSerializer().serializeToString(r.documentElement).replace("<svg>", `<svg xmlns="${ef}">`);
  return new DOMParser().parseFromString(t, "image/svg+xml").documentElement;
}, P1 = (r) => {
  const t = new DOMParser().parseFromString(r, "image/svg+xml"), e = t.lookupPrefix(ef), n = t.lookupNamespaceURI(null);
  return e || n ? _u(t).firstChild : _u(A1(t)).firstChild;
}, O1 = (r) => {
  const [t, e, n] = r.match(/(<polygon points=["|'])([^("|')]*)/) || [];
  if (!n)
    return;
  const i = n.split(" ").map((o) => o.split(",").map(parseFloat));
  return {
    type: Qt.POLYGON,
    geometry: {
      points: i,
      bounds: tf(i)
    }
  };
}, R1 = (r) => {
  const t = P1(r), e = parseFloat(t.getAttribute("cx")), n = parseFloat(t.getAttribute("cy")), i = parseFloat(t.getAttribute("rx")), o = parseFloat(t.getAttribute("ry")), a = {
    minX: e - i,
    minY: n - o,
    maxX: e + i,
    maxY: n + o
  };
  return {
    type: Qt.ELLIPSE,
    geometry: {
      cx: e,
      cy: n,
      rx: i,
      ry: o,
      bounds: a
    }
  };
}, I1 = (r) => {
  const t = typeof r == "string" ? r : r.value;
  if (t.includes("<polygon points="))
    return O1(t);
  if (t.includes("<ellipse "))
    return R1(t);
}, C1 = (r) => {
  let t;
  if (r.type === Qt.POLYGON) {
    const e = r.geometry, { points: n } = e;
    t = `<svg><polygon points="${n.map((i) => i.join(",")).join(" ")}" /></svg>`;
  } else if (r.type === Qt.ELLIPSE) {
    const e = r.geometry;
    t = `<svg><ellipse cx="${e.cx}" cy="${e.cy}" rx="${e.rx}" ry="${e.ry}" /></svg>`;
  }
  if (t)
    return { type: "SvgSelector", value: t };
  throw `Unsupported shape type: ${r.type}`;
};
let ui;
const M1 = new Uint8Array(16);
function D1() {
  if (!ui && (ui = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !ui))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ui(M1);
}
const Ut = [];
for (let r = 0; r < 256; ++r)
  Ut.push((r + 256).toString(16).slice(1));
function F1(r, t = 0) {
  return Ut[r[t + 0]] + Ut[r[t + 1]] + Ut[r[t + 2]] + Ut[r[t + 3]] + "-" + Ut[r[t + 4]] + Ut[r[t + 5]] + "-" + Ut[r[t + 6]] + Ut[r[t + 7]] + "-" + Ut[r[t + 8]] + Ut[r[t + 9]] + "-" + Ut[r[t + 10]] + Ut[r[t + 11]] + Ut[r[t + 12]] + Ut[r[t + 13]] + Ut[r[t + 14]] + Ut[r[t + 15]];
}
const B1 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), mu = {
  randomUUID: B1
};
function N1(r, t, e) {
  if (mu.randomUUID && !t && !r)
    return mu.randomUUID();
  r = r || {};
  const n = r.random || (r.rng || D1)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, t) {
    e = e || 0;
    for (let i = 0; i < 16; ++i)
      t[e + i] = n[i];
    return t;
  }
  return F1(n);
}
let L1 = (r = 21) => crypto.getRandomValues(new Uint8Array(r)).reduce((t, e) => (e &= 63, e < 36 ? t += e.toString(36) : e < 62 ? t += (e - 26).toString(36).toUpperCase() : e > 62 ? t += "-" : t += "_", t), "");
const U1 = (r) => {
  const t = JSON.stringify(r);
  let e = 0;
  for (let n = 0, i = t.length; n < i; n++) {
    let o = t.charCodeAt(n);
    e = (e << 5) - e + o, e |= 0;
  }
  return `${e}`;
}, G1 = (r, t) => (Array.isArray(r) ? r : [r]).map((e) => {
  const { id: n, type: i, purpose: o, value: a, created: s, creator: h, ...u } = e;
  return {
    id: n || U1(e),
    annotation: t,
    type: i,
    purpose: o,
    value: a,
    created: s,
    creator: h ? typeof h == "object" ? { ...h } : h : void 0,
    ...u
  };
}), k1 = (r) => r.map((t) => {
  const e = { ...t };
  return delete e.annotation, delete e.id, e;
});
L1();
const H1 = (r, t = !1) => ({ parse: (e) => X1(e, t), serialize: (e) => j1(e, r) }), X1 = (r, t = !1) => {
  const e = r.id || N1(), n = G1(r.body, e), i = Array.isArray(r.target) ? r.target[0] : r.target, o = Array.isArray(i.selector) ? i.selector[0] : i.selector, a = o.type === "FragmentSelector" ? w1(o, t) : o.type === "SvgSelector" ? I1(o) : void 0;
  return a ? {
    parsed: {
      id: e,
      bodies: n,
      target: {
        annotation: e,
        selector: a
      }
    }
  } : {
    error: Error(`Unknown selector type: ${a.type}`)
  };
}, j1 = (r, t) => {
  const e = r.target.selector, n = e.type == Qt.RECTANGLE ? S1(e.geometry) : C1(e);
  return {
    "@context": "http://www.w3.org/ns/anno.jsonld",
    id: r.id,
    type: "Annotation",
    body: k1(r.bodies),
    target: {
      source: t,
      selector: n
    }
  };
};
function yu(r, t, e) {
  const n = r.slice();
  return n[11] = t[e], n[13] = e, n;
}
function gu(r) {
  let t, e, n, i, o;
  return {
    c() {
      t = Wt("rect"), I(t, "class", "a9s-corner-handle"), I(t, "x", e = /*point*/
      r[11][0] - /*handleSize*/
      r[3] / 2), I(t, "y", n = /*point*/
      r[11][1] - /*handleSize*/
      r[3] / 2), I(
        t,
        "height",
        /*handleSize*/
        r[3]
      ), I(
        t,
        "width",
        /*handleSize*/
        r[3]
      );
    },
    m(a, s) {
      gt(a, t, s), i || (o = zt(t, "pointerdown", function() {
        Vt(
          /*grab*/
          r[10](z(
            /*idx*/
            r[13]
          ))
        ) && r[10](z(
          /*idx*/
          r[13]
        )).apply(this, arguments);
      }), i = !0);
    },
    p(a, s) {
      r = a, s & /*geom, handleSize*/
      24 && e !== (e = /*point*/
      r[11][0] - /*handleSize*/
      r[3] / 2) && I(t, "x", e), s & /*geom, handleSize*/
      24 && n !== (n = /*point*/
      r[11][1] - /*handleSize*/
      r[3] / 2) && I(t, "y", n), s & /*handleSize*/
      8 && I(
        t,
        "height",
        /*handleSize*/
        r[3]
      ), s & /*handleSize*/
      8 && I(
        t,
        "width",
        /*handleSize*/
        r[3]
      );
    },
    d(a) {
      a && yt(t), i = !1, o();
    }
  };
}
function Y1(r) {
  let t, e, n, i, o, a, s, h, u, l, f = (
    /*geom*/
    r[4].points
  ), c = [];
  for (let d = 0; d < f.length; d += 1)
    c[d] = gu(yu(r, f, d));
  return {
    c() {
      t = Wt("polygon"), i = he(), o = Wt("polygon"), s = he();
      for (let d = 0; d < c.length; d += 1)
        c[d].c();
      h = l1(), I(t, "class", "a9s-outer"), I(t, "style", e = /*computedStyle*/
      r[1] ? "display:none;" : void 0), I(t, "points", n = /*geom*/
      r[4].points.map(bu).join(" ")), I(o, "class", "a9s-inner a9s-shape-handle"), I(
        o,
        "style",
        /*computedStyle*/
        r[1]
      ), I(o, "points", a = /*geom*/
      r[4].points.map(xu).join(" "));
    },
    m(d, p) {
      gt(d, t, p), gt(d, i, p), gt(d, o, p), gt(d, s, p);
      for (let v = 0; v < c.length; v += 1)
        c[v] && c[v].m(d, p);
      gt(d, h, p), u || (l = [
        zt(t, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.SHAPE)
          ) && r[10](z.SHAPE).apply(this, arguments);
        }),
        zt(o, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.SHAPE)
          ) && r[10](z.SHAPE).apply(this, arguments);
        })
      ], u = !0);
    },
    p(d, p) {
      if (r = d, p & /*computedStyle*/
      2 && e !== (e = /*computedStyle*/
      r[1] ? "display:none;" : void 0) && I(t, "style", e), p & /*geom*/
      16 && n !== (n = /*geom*/
      r[4].points.map(bu).join(" ")) && I(t, "points", n), p & /*computedStyle*/
      2 && I(
        o,
        "style",
        /*computedStyle*/
        r[1]
      ), p & /*geom*/
      16 && a !== (a = /*geom*/
      r[4].points.map(xu).join(" ")) && I(o, "points", a), p & /*geom, handleSize, grab, Handle*/
      1048) {
        f = /*geom*/
        r[4].points;
        let v;
        for (v = 0; v < f.length; v += 1) {
          const _ = yu(r, f, v);
          c[v] ? c[v].p(_, p) : (c[v] = gu(_), c[v].c(), c[v].m(h.parentNode, h));
        }
        for (; v < c.length; v += 1)
          c[v].d(1);
        c.length = f.length;
      }
    },
    d(d) {
      d && yt(t), d && yt(i), d && yt(o), d && yt(s), u1(c, d), d && yt(h), u = !1, pr(l);
    }
  };
}
function V1(r) {
  let t, e;
  return t = new rf({
    props: {
      shape: (
        /*shape*/
        r[0]
      ),
      transform: (
        /*transform*/
        r[2]
      ),
      editor: (
        /*editor*/
        r[5]
      ),
      $$slots: {
        default: [
          Y1,
          ({ grab: n }) => ({ 10: n }),
          ({ grab: n }) => n ? 1024 : 0
        ]
      },
      $$scope: { ctx: r }
    }
  }), t.$on(
    "change",
    /*change_handler*/
    r[7]
  ), t.$on(
    "grab",
    /*grab_handler*/
    r[8]
  ), t.$on(
    "release",
    /*release_handler*/
    r[9]
  ), {
    c() {
      Ql(t.$$.fragment);
    },
    m(n, i) {
      is(t, n, i), e = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*shape*/
      1 && (o.shape = /*shape*/
      n[0]), i & /*transform*/
      4 && (o.transform = /*transform*/
      n[2]), i & /*$$scope, geom, handleSize, grab, computedStyle*/
      17434 && (o.$$scope = { dirty: i, ctx: n }), t.$set(o);
    },
    i(n) {
      e || (Hi(t.$$.fragment, n), e = !0);
    },
    o(n) {
      ns(t.$$.fragment, n), e = !1;
    },
    d(n) {
      os(t, n);
    }
  };
}
const bu = (r) => r.join(","), xu = (r) => r.join(",");
function z1(r, t, e) {
  let n, i, { shape: o } = t, { computedStyle: a = void 0 } = t, { transform: s } = t, { viewportScale: h = 1 } = t;
  const u = (d, p, v) => {
    let _;
    p === z.SHAPE ? _ = d.geometry.points.map(([y, g]) => [y + v[0], g + v[1]]) : _ = d.geometry.points.map(([y, g], x) => p === z(x) ? [y + v[0], g + v[1]] : [y, g]);
    const m = tf(_);
    return { ...d, geometry: { points: _, bounds: m } };
  };
  function l(d) {
    Ur.call(this, r, d);
  }
  function f(d) {
    Ur.call(this, r, d);
  }
  function c(d) {
    Ur.call(this, r, d);
  }
  return r.$$set = (d) => {
    "shape" in d && e(0, o = d.shape), "computedStyle" in d && e(1, a = d.computedStyle), "transform" in d && e(2, s = d.transform), "viewportScale" in d && e(6, h = d.viewportScale);
  }, r.$$.update = () => {
    r.$$.dirty & /*shape*/
    1 && e(4, n = o.geometry), r.$$.dirty & /*viewportScale*/
    64 && e(3, i = 10 / h);
  }, [
    o,
    a,
    s,
    i,
    n,
    u,
    h,
    l,
    f,
    c
  ];
}
class W1 extends ss {
  constructor(t) {
    super(), as(this, t, z1, V1, rs, {
      shape: 0,
      computedStyle: 1,
      transform: 2,
      viewportScale: 6
    });
  }
}
function $1(r) {
  let t, e, n, i, o, a, s, h, u, l, f, c, d, p, v, _, m, y, g, x, T, E, P, b, w, A, R, C, M, H, U, B, $, q, Q, N, F, k, tt, et, pt, j, st, _t, Tt, W, it, at, lt, nt;
  return {
    c() {
      t = Wt("rect"), s = he(), h = Wt("rect"), d = he(), p = Wt("rect"), y = he(), g = Wt("rect"), P = he(), b = Wt("rect"), C = he(), M = Wt("rect"), $ = he(), q = Wt("rect"), F = he(), k = Wt("rect"), pt = he(), j = Wt("rect"), Tt = he(), W = Wt("rect"), I(t, "class", "a9s-outer"), I(t, "style", e = /*computedStyle*/
      r[1] ? "display:none;" : void 0), I(t, "x", n = /*geom*/
      r[4].x), I(t, "y", i = /*geom*/
      r[4].y), I(t, "width", o = /*geom*/
      r[4].w), I(t, "height", a = /*geom*/
      r[4].h), I(h, "class", "a9s-inner a9s-shape-handle"), I(
        h,
        "style",
        /*computedStyle*/
        r[1]
      ), I(h, "x", u = /*geom*/
      r[4].x), I(h, "y", l = /*geom*/
      r[4].y), I(h, "width", f = /*geom*/
      r[4].w), I(h, "height", c = /*geom*/
      r[4].h), I(p, "class", "a9s-edge-handle a9s-edge-handle-top"), I(p, "x", v = /*geom*/
      r[4].x), I(p, "y", _ = /*geom*/
      r[4].y), I(p, "height", 1), I(p, "width", m = /*geom*/
      r[4].w), I(g, "class", "a9s-edge-handle a9s-edge-handle-right"), I(g, "x", x = /*geom*/
      r[4].x + /*geom*/
      r[4].w), I(g, "y", T = /*geom*/
      r[4].y), I(g, "height", E = /*geom*/
      r[4].h), I(g, "width", 1), I(b, "class", "a9s-edge-handle a9s-edge-handle-bottom"), I(b, "x", w = /*geom*/
      r[4].x), I(b, "y", A = /*geom*/
      r[4].y + /*geom*/
      r[4].h), I(b, "height", 1), I(b, "width", R = /*geom*/
      r[4].w), I(M, "class", "a9s-edge-handle a9s-edge-handle-left"), I(M, "x", H = /*geom*/
      r[4].x), I(M, "y", U = /*geom*/
      r[4].y), I(M, "height", B = /*geom*/
      r[4].h), I(M, "width", 1), I(q, "class", "a9s-corner-handle a9s-corner-handle-topleft"), I(q, "x", Q = /*geom*/
      r[4].x - /*handleSize*/
      r[3] / 2), I(q, "y", N = /*geom*/
      r[4].y - /*handleSize*/
      r[3] / 2), I(
        q,
        "height",
        /*handleSize*/
        r[3]
      ), I(
        q,
        "width",
        /*handleSize*/
        r[3]
      ), I(k, "class", "a9s-corner-handle a9s-corner-handle-topright"), I(k, "x", tt = /*geom*/
      r[4].x + /*geom*/
      r[4].w - /*handleSize*/
      r[3] / 2), I(k, "y", et = /*geom*/
      r[4].y - /*handleSize*/
      r[3] / 2), I(
        k,
        "height",
        /*handleSize*/
        r[3]
      ), I(
        k,
        "width",
        /*handleSize*/
        r[3]
      ), I(j, "class", "a9s-corner-handle a9s-corner-handle-bottomright"), I(j, "x", st = /*geom*/
      r[4].x + /*geom*/
      r[4].w - /*handleSize*/
      r[3] / 2), I(j, "y", _t = /*geom*/
      r[4].y + /*geom*/
      r[4].h - /*handleSize*/
      r[3] / 2), I(
        j,
        "height",
        /*handleSize*/
        r[3]
      ), I(
        j,
        "width",
        /*handleSize*/
        r[3]
      ), I(W, "class", "a9s-corner-handle a9s-corner-handle-bottomleft"), I(W, "x", it = /*geom*/
      r[4].x - /*handleSize*/
      r[3] / 2), I(W, "y", at = /*geom*/
      r[4].y + /*geom*/
      r[4].h - /*handleSize*/
      r[3] / 2), I(
        W,
        "height",
        /*handleSize*/
        r[3]
      ), I(
        W,
        "width",
        /*handleSize*/
        r[3]
      );
    },
    m(D, O) {
      gt(D, t, O), gt(D, s, O), gt(D, h, O), gt(D, d, O), gt(D, p, O), gt(D, y, O), gt(D, g, O), gt(D, P, O), gt(D, b, O), gt(D, C, O), gt(D, M, O), gt(D, $, O), gt(D, q, O), gt(D, F, O), gt(D, k, O), gt(D, pt, O), gt(D, j, O), gt(D, Tt, O), gt(D, W, O), lt || (nt = [
        zt(t, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.SHAPE)
          ) && r[10](z.SHAPE).apply(this, arguments);
        }),
        zt(h, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.SHAPE)
          ) && r[10](z.SHAPE).apply(this, arguments);
        }),
        zt(p, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.TOP)
          ) && r[10](z.TOP).apply(this, arguments);
        }),
        zt(g, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.RIGHT)
          ) && r[10](z.RIGHT).apply(this, arguments);
        }),
        zt(b, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.BOTTOM)
          ) && r[10](z.BOTTOM).apply(this, arguments);
        }),
        zt(M, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.LEFT)
          ) && r[10](z.LEFT).apply(this, arguments);
        }),
        zt(q, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.TOP_LEFT)
          ) && r[10](z.TOP_LEFT).apply(this, arguments);
        }),
        zt(k, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.TOP_RIGHT)
          ) && r[10](z.TOP_RIGHT).apply(this, arguments);
        }),
        zt(j, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.BOTTOM_RIGHT)
          ) && r[10](z.BOTTOM_RIGHT).apply(this, arguments);
        }),
        zt(W, "pointerdown", function() {
          Vt(
            /*grab*/
            r[10](z.BOTTOM_LEFT)
          ) && r[10](z.BOTTOM_LEFT).apply(this, arguments);
        })
      ], lt = !0);
    },
    p(D, O) {
      r = D, O & /*computedStyle*/
      2 && e !== (e = /*computedStyle*/
      r[1] ? "display:none;" : void 0) && I(t, "style", e), O & /*geom*/
      16 && n !== (n = /*geom*/
      r[4].x) && I(t, "x", n), O & /*geom*/
      16 && i !== (i = /*geom*/
      r[4].y) && I(t, "y", i), O & /*geom*/
      16 && o !== (o = /*geom*/
      r[4].w) && I(t, "width", o), O & /*geom*/
      16 && a !== (a = /*geom*/
      r[4].h) && I(t, "height", a), O & /*computedStyle*/
      2 && I(
        h,
        "style",
        /*computedStyle*/
        r[1]
      ), O & /*geom*/
      16 && u !== (u = /*geom*/
      r[4].x) && I(h, "x", u), O & /*geom*/
      16 && l !== (l = /*geom*/
      r[4].y) && I(h, "y", l), O & /*geom*/
      16 && f !== (f = /*geom*/
      r[4].w) && I(h, "width", f), O & /*geom*/
      16 && c !== (c = /*geom*/
      r[4].h) && I(h, "height", c), O & /*geom*/
      16 && v !== (v = /*geom*/
      r[4].x) && I(p, "x", v), O & /*geom*/
      16 && _ !== (_ = /*geom*/
      r[4].y) && I(p, "y", _), O & /*geom*/
      16 && m !== (m = /*geom*/
      r[4].w) && I(p, "width", m), O & /*geom*/
      16 && x !== (x = /*geom*/
      r[4].x + /*geom*/
      r[4].w) && I(g, "x", x), O & /*geom*/
      16 && T !== (T = /*geom*/
      r[4].y) && I(g, "y", T), O & /*geom*/
      16 && E !== (E = /*geom*/
      r[4].h) && I(g, "height", E), O & /*geom*/
      16 && w !== (w = /*geom*/
      r[4].x) && I(b, "x", w), O & /*geom*/
      16 && A !== (A = /*geom*/
      r[4].y + /*geom*/
      r[4].h) && I(b, "y", A), O & /*geom*/
      16 && R !== (R = /*geom*/
      r[4].w) && I(b, "width", R), O & /*geom*/
      16 && H !== (H = /*geom*/
      r[4].x) && I(M, "x", H), O & /*geom*/
      16 && U !== (U = /*geom*/
      r[4].y) && I(M, "y", U), O & /*geom*/
      16 && B !== (B = /*geom*/
      r[4].h) && I(M, "height", B), O & /*geom, handleSize*/
      24 && Q !== (Q = /*geom*/
      r[4].x - /*handleSize*/
      r[3] / 2) && I(q, "x", Q), O & /*geom, handleSize*/
      24 && N !== (N = /*geom*/
      r[4].y - /*handleSize*/
      r[3] / 2) && I(q, "y", N), O & /*handleSize*/
      8 && I(
        q,
        "height",
        /*handleSize*/
        r[3]
      ), O & /*handleSize*/
      8 && I(
        q,
        "width",
        /*handleSize*/
        r[3]
      ), O & /*geom, handleSize*/
      24 && tt !== (tt = /*geom*/
      r[4].x + /*geom*/
      r[4].w - /*handleSize*/
      r[3] / 2) && I(k, "x", tt), O & /*geom, handleSize*/
      24 && et !== (et = /*geom*/
      r[4].y - /*handleSize*/
      r[3] / 2) && I(k, "y", et), O & /*handleSize*/
      8 && I(
        k,
        "height",
        /*handleSize*/
        r[3]
      ), O & /*handleSize*/
      8 && I(
        k,
        "width",
        /*handleSize*/
        r[3]
      ), O & /*geom, handleSize*/
      24 && st !== (st = /*geom*/
      r[4].x + /*geom*/
      r[4].w - /*handleSize*/
      r[3] / 2) && I(j, "x", st), O & /*geom, handleSize*/
      24 && _t !== (_t = /*geom*/
      r[4].y + /*geom*/
      r[4].h - /*handleSize*/
      r[3] / 2) && I(j, "y", _t), O & /*handleSize*/
      8 && I(
        j,
        "height",
        /*handleSize*/
        r[3]
      ), O & /*handleSize*/
      8 && I(
        j,
        "width",
        /*handleSize*/
        r[3]
      ), O & /*geom, handleSize*/
      24 && it !== (it = /*geom*/
      r[4].x - /*handleSize*/
      r[3] / 2) && I(W, "x", it), O & /*geom, handleSize*/
      24 && at !== (at = /*geom*/
      r[4].y + /*geom*/
      r[4].h - /*handleSize*/
      r[3] / 2) && I(W, "y", at), O & /*handleSize*/
      8 && I(
        W,
        "height",
        /*handleSize*/
        r[3]
      ), O & /*handleSize*/
      8 && I(
        W,
        "width",
        /*handleSize*/
        r[3]
      );
    },
    d(D) {
      D && yt(t), D && yt(s), D && yt(h), D && yt(d), D && yt(p), D && yt(y), D && yt(g), D && yt(P), D && yt(b), D && yt(C), D && yt(M), D && yt($), D && yt(q), D && yt(F), D && yt(k), D && yt(pt), D && yt(j), D && yt(Tt), D && yt(W), lt = !1, pr(nt);
    }
  };
}
function q1(r) {
  let t, e;
  return t = new rf({
    props: {
      shape: (
        /*shape*/
        r[0]
      ),
      transform: (
        /*transform*/
        r[2]
      ),
      editor: (
        /*editor*/
        r[5]
      ),
      $$slots: {
        default: [
          $1,
          ({ grab: n }) => ({ 10: n }),
          ({ grab: n }) => n ? 1024 : 0
        ]
      },
      $$scope: { ctx: r }
    }
  }), t.$on(
    "grab",
    /*grab_handler*/
    r[7]
  ), t.$on(
    "change",
    /*change_handler*/
    r[8]
  ), t.$on(
    "release",
    /*release_handler*/
    r[9]
  ), {
    c() {
      Ql(t.$$.fragment);
    },
    m(n, i) {
      is(t, n, i), e = !0;
    },
    p(n, [i]) {
      const o = {};
      i & /*shape*/
      1 && (o.shape = /*shape*/
      n[0]), i & /*transform*/
      4 && (o.transform = /*transform*/
      n[2]), i & /*$$scope, geom, handleSize, grab, computedStyle*/
      3098 && (o.$$scope = { dirty: i, ctx: n }), t.$set(o);
    },
    i(n) {
      e || (Hi(t.$$.fragment, n), e = !0);
    },
    o(n) {
      ns(t.$$.fragment, n), e = !1;
    },
    d(n) {
      os(t, n);
    }
  };
}
function K1(r, t, e) {
  let n, i, { shape: o } = t, { computedStyle: a = void 0 } = t, { transform: s } = t, { viewportScale: h = 1 } = t;
  const u = (d, p, v) => {
    const _ = d.geometry.bounds;
    let [m, y] = [_.minX, _.minY], [g, x] = [_.maxX, _.maxY];
    const [T, E] = v;
    if (p === z.SHAPE)
      m += T, g += T, y += E, x += E;
    else {
      switch (p) {
        case z.TOP:
        case z.TOP_LEFT:
        case z.TOP_RIGHT: {
          y += E;
          break;
        }
        case z.BOTTOM:
        case z.BOTTOM_LEFT:
        case z.BOTTOM_RIGHT: {
          x += E;
          break;
        }
      }
      switch (p) {
        case z.LEFT:
        case z.TOP_LEFT:
        case z.BOTTOM_LEFT: {
          m += T;
          break;
        }
        case z.RIGHT:
        case z.TOP_RIGHT:
        case z.BOTTOM_RIGHT: {
          g += T;
          break;
        }
      }
    }
    const P = Math.min(m, g), b = Math.min(y, x), w = Math.abs(g - m), A = Math.abs(x - y);
    return {
      ...d,
      geometry: {
        x: P,
        y: b,
        w,
        h: A,
        bounds: {
          minX: P,
          minY: b,
          maxX: P + w,
          maxY: b + A
        }
      }
    };
  };
  function l(d) {
    Ur.call(this, r, d);
  }
  function f(d) {
    Ur.call(this, r, d);
  }
  function c(d) {
    Ur.call(this, r, d);
  }
  return r.$$set = (d) => {
    "shape" in d && e(0, o = d.shape), "computedStyle" in d && e(1, a = d.computedStyle), "transform" in d && e(2, s = d.transform), "viewportScale" in d && e(6, h = d.viewportScale);
  }, r.$$.update = () => {
    r.$$.dirty & /*shape*/
    1 && e(4, n = o.geometry), r.$$.dirty & /*viewportScale*/
    64 && e(3, i = 10 / h);
  }, [
    o,
    a,
    s,
    i,
    n,
    u,
    h,
    l,
    f,
    c
  ];
}
class Z1 extends ss {
  constructor(t) {
    super(), as(this, t, K1, q1, rs, {
      shape: 0,
      computedStyle: 1,
      transform: 2,
      viewportScale: 6
    });
  }
}
Qt.RECTANGLE, Qt.POLYGON;
const z = (r) => `HANDLE-${r}`;
z.SHAPE = "SHAPE";
z.TOP = "TOP";
z.RIGHT = "RIGHT";
z.BOTTOM = "BOTTOM";
z.LEFT = "LEFT";
z.TOP_LEFT = "TOP_LEFT";
z.TOP_RIGHT = "TOP_RIGHT";
z.BOTTOM_RIGHT = "BOTTOM_RIGHT";
z.BOTTOM_LEFT = "BOTTOM_LEFT";
const J1 = (r) => ({}), Tu = (r) => ({ grab: (
  /*onGrab*/
  r[0]
) });
function Q1(r) {
  let t, e, n, i;
  const o = (
    /*#slots*/
    r[7].default
  ), a = o1(
    o,
    r,
    /*$$scope*/
    r[6],
    Tu
  );
  return {
    c() {
      t = Wt("g"), a && a.c(), I(t, "class", "a9s-annotation selected");
    },
    m(s, h) {
      gt(s, t, h), a && a.m(t, null), e = !0, n || (i = [
        zt(
          t,
          "pointerup",
          /*onRelease*/
          r[2]
        ),
        zt(
          t,
          "pointermove",
          /*onPointerMove*/
          r[1]
        )
      ], n = !0);
    },
    p(s, [h]) {
      a && a.p && (!e || h & /*$$scope*/
      64) && s1(
        a,
        o,
        s,
        /*$$scope*/
        s[6],
        e ? a1(
          o,
          /*$$scope*/
          s[6],
          h,
          J1
        ) : h1(
          /*$$scope*/
          s[6]
        ),
        Tu
      );
    },
    i(s) {
      e || (Hi(a, s), e = !0);
    },
    o(s) {
      ns(a, s), e = !1;
    },
    d(s) {
      s && yt(t), a && a.d(s), n = !1, pr(i);
    }
  };
}
function tT(r, t, e) {
  let { $$slots: n = {}, $$scope: i } = t;
  const o = p1();
  let { shape: a } = t, { editor: s } = t, { transform: h } = t, u = null, l, f = null;
  const c = (v) => (_) => {
    u = v, l = h.elementToImage(_.offsetX, _.offsetY), f = a, _.target.setPointerCapture(_.pointerId), o("grab");
  }, d = (v) => {
    if (u) {
      const [_, m] = h.elementToImage(v.offsetX, v.offsetY), y = [_ - l[0], m - l[1]];
      e(3, a = s(f, u, y)), o("change", a);
    }
  }, p = (v) => {
    v.target.releasePointerCapture(v.pointerId), u = null, f = a, o("release");
  };
  return r.$$set = (v) => {
    "shape" in v && e(3, a = v.shape), "editor" in v && e(4, s = v.editor), "transform" in v && e(5, h = v.transform), "$$scope" in v && e(6, i = v.$$scope);
  }, [c, d, p, a, s, h, i, n];
}
class rf extends ss {
  constructor(t) {
    super(), as(this, t, tT, Q1, rs, { shape: 3, editor: 4, transform: 5 });
  }
}
const nT = Xf, iT = Ga, oT = Ef, aT = Qt, sT = H1;
export {
  iT as PointerSelectAction,
  aT as ShapeType,
  sT as W3CImageFormat,
  oT as createBody,
  rT as createOSDAnnotator,
  nT as defaultColorProvider
};
//# sourceMappingURL=annotorious-openseadragon.es.js.map
